/* eslint-disable */
/*
 * 自动生成，请勿手改。来源：tools/map-pipeline（map.config.json）。
 * 地图：美洲战火（1840）（key=americas1840, mapID=25）
 */
import Country from "../../enums/Country";
import WDBoardMap from "../../components/map/components/WDBoardMap";
import capturableLandTexture from "../../assets/textures/capturable-land.jpeg";
import seaTexture from "../../assets/textures/sea-texture.png";
import type { MapVariant } from "./types";

const provincesMapData = {
  "REGION_1": {
    "abbr": "QUE",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 84,
        "y": 90,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 239,
    "height": 175,
    "x": 599,
    "y": 235,
    "playable": true,
    "path": "M 0.00 168.00 L 4.00 175.00 L 28.00 175.00 L 32.00 172.00 L 33.00 169.00 L 36.00 166.00 L 42.00 163.00 L 46.00 163.00 L 47.00 162.00 L 55.00 162.00 L 56.00 161.00 L 64.00 161.00 L 65.00 160.00 L 69.00 160.00 L 72.00 158.00 L 93.00 158.00 L 96.00 160.00 L 105.00 149.00 L 110.00 132.00 L 123.00 123.00 L 142.00 124.00 L 153.00 136.00 L 209.00 136.00 L 223.00 118.00 L 238.00 117.00 L 239.00 111.00 L 237.00 109.00 L 237.00 105.00 L 236.00 104.00 L 236.00 100.00 L 225.00 94.00 L 211.00 91.00 L 206.00 83.00 L 191.00 82.00 L 181.00 73.00 L 173.00 71.00 L 168.00 61.00 L 147.00 42.00 L 147.00 37.00 L 137.00 29.00 L 133.00 28.00 L 133.00 32.00 L 131.00 35.00 L 130.00 40.00 L 126.00 44.00 L 120.00 47.00 L 105.00 46.00 L 95.00 37.00 L 88.00 34.00 L 86.00 32.00 L 86.00 21.00 L 76.00 10.00 L 75.00 6.00 L 57.00 6.00 L 53.00 1.00 L 27.00 0.00 L 26.00 8.00 L 31.00 15.00 L 31.00 26.00 L 24.00 33.00 L 24.00 35.00 L 27.00 36.00 L 35.00 46.00 L 36.00 53.00 L 39.00 61.00 L 39.00 71.00 L 20.00 90.00 L 15.00 92.00 L 16.00 101.00 L 21.00 110.00 L 21.00 123.00 L 15.00 128.00 L 14.00 131.00 L 12.00 133.00 L 5.00 134.00 L 5.00 137.00 L 4.00 138.00 L 4.00 145.00 L 3.00 146.00 L 3.00 153.00 L 2.00 154.00 L 2.00 157.00 L 0.00 160.00 Z",
    "province": "REGION_1",
    "rootTerritory": "REGION_1",
    "viewBox": "0 0 239 175",
    "unitSlots": [
      {
        "name": "main",
        "x": 134,
        "y": 112,
        "territory": "REGION_1",
        "arrowReceiver": {
          "x": 134,
          "y": 142
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 134,
        "y": 112,
        "territory": "REGION_1",
        "arrowReceiver": {
          "x": 134,
          "y": 142
        }
      }
    },
    "texture": {
      "texture": "#A8ABCE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_2": {
    "abbr": "NEW",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 20,
        "y": 9,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 45,
    "height": 37,
    "x": 840,
    "y": 369,
    "playable": true,
    "path": "M 8.00 0.00 L 6.00 3.00 L 8.00 19.00 L 0.00 29.00 L 0.00 35.00 L 11.00 35.00 L 12.00 34.00 L 14.00 35.00 L 19.00 35.00 L 22.00 33.00 L 33.00 33.00 L 40.00 37.00 L 44.00 37.00 L 45.00 34.00 L 40.00 29.00 L 41.00 20.00 L 34.00 19.00 L 33.00 18.00 L 23.00 18.00 L 15.00 14.00 L 13.00 12.00 L 11.00 12.00 L 10.00 11.00 L 10.00 0.00 Z",
    "province": "REGION_2",
    "rootTerritory": "REGION_2",
    "viewBox": "0 0 45 37",
    "unitSlots": [
      {
        "name": "main",
        "x": 30,
        "y": 46,
        "territory": "REGION_2",
        "arrowReceiver": {
          "x": 30,
          "y": 76
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 30,
        "y": 46,
        "territory": "REGION_2",
        "arrowReceiver": {
          "x": 30,
          "y": 76
        }
      }
    },
    "texture": {
      "texture": "#A8ABCE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_3": {
    "abbr": "MON",
    "type": "Coast",
    "centerPos": {
      "x": 56,
      "y": 44
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 47,
        "y": 61,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 138,
    "height": 97,
    "x": 630,
    "y": 357,
    "playable": true,
    "path": "M 123.00 12.00 L 113.00 1.00 L 90.00 0.00 L 78.00 8.00 L 74.00 23.00 L 64.00 36.00 L 62.00 35.00 L 39.00 35.00 L 36.00 37.00 L 9.00 40.00 L 1.00 44.00 L 0.00 50.00 L 10.00 50.00 L 21.00 62.00 L 21.00 75.00 L 12.00 92.00 L 12.00 97.00 L 14.00 97.00 L 27.00 90.00 L 31.00 90.00 L 33.00 88.00 L 57.00 88.00 L 58.00 87.00 L 71.00 86.00 L 86.00 57.00 L 88.00 55.00 L 91.00 55.00 L 98.00 46.00 L 113.00 48.00 L 118.00 45.00 L 133.00 46.00 L 137.00 43.00 L 138.00 40.00 L 134.00 37.00 L 130.00 37.00 L 122.00 41.00 L 104.00 41.00 L 102.00 39.00 L 102.00 30.00 L 115.00 14.00 L 123.00 14.00 Z",
    "province": "REGION_3",
    "rootTerritory": "REGION_3",
    "viewBox": "0 0 138 97",
    "unitSlots": [
      {
        "name": "main",
        "x": 70,
        "y": 42,
        "territory": "REGION_3",
        "arrowReceiver": {
          "x": 70,
          "y": 72
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 70,
        "y": 42,
        "territory": "REGION_3",
        "arrowReceiver": {
          "x": 70,
          "y": 72
        }
      }
    },
    "texture": {
      "texture": "#A8ABCE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_4": {
    "abbr": "HAL",
    "type": "Coast",
    "centerPos": {
      "x": 15,
      "y": 13
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 32,
        "y": 10,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 90,
    "height": 61,
    "x": 720,
    "y": 401,
    "playable": true,
    "path": "M 0.00 9.00 L 0.00 11.00 L 3.00 12.00 L 20.00 13.00 L 24.00 17.00 L 26.00 33.00 L 35.00 40.00 L 51.00 39.00 L 55.00 42.00 L 55.00 51.00 L 51.00 58.00 L 51.00 61.00 L 53.00 61.00 L 55.00 59.00 L 60.00 50.00 L 76.00 42.00 L 84.00 42.00 L 84.00 40.00 L 90.00 34.00 L 90.00 32.00 L 83.00 32.00 L 76.00 36.00 L 59.00 36.00 L 50.00 25.00 L 42.00 21.00 L 43.00 1.00 L 26.00 0.00 L 21.00 3.00 L 6.00 1.00 Z",
    "province": "REGION_4",
    "rootTerritory": "REGION_4",
    "viewBox": "0 0 90 61",
    "unitSlots": [
      {
        "name": "main",
        "x": 54,
        "y": 26,
        "territory": "REGION_4",
        "arrowReceiver": {
          "x": 54,
          "y": 56
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 54,
        "y": 26,
        "territory": "REGION_4",
        "arrowReceiver": {
          "x": 54,
          "y": 56
        }
      }
    },
    "texture": {
      "texture": "#A8ABCE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_8": {
    "abbr": "SAS",
    "type": "Coast",
    "centerPos": {
      "x": 70,
      "y": 96
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 87,
        "y": 89,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 179,
    "height": 202,
    "x": 1073,
    "y": 1172,
    "playable": true,
    "path": "M 28.00 0.00 L 25.00 5.00 L 24.00 16.00 L 11.00 42.00 L 0.00 52.00 L 0.00 54.00 L 8.00 60.00 L 8.00 77.00 L 5.00 82.00 L 5.00 87.00 L 19.00 95.00 L 19.00 102.00 L 15.00 109.00 L 15.00 114.00 L 22.00 122.00 L 27.00 125.00 L 26.00 139.00 L 24.00 141.00 L 24.00 158.00 L 23.00 159.00 L 23.00 170.00 L 22.00 171.00 L 22.00 183.00 L 27.00 185.00 L 35.00 180.00 L 46.00 180.00 L 51.00 183.00 L 64.00 182.00 L 72.00 186.00 L 76.00 191.00 L 79.00 190.00 L 84.00 193.00 L 98.00 195.00 L 99.00 196.00 L 99.00 202.00 L 101.00 202.00 L 113.00 167.00 L 132.00 153.00 L 144.00 129.00 L 150.00 121.00 L 158.00 104.00 L 172.00 91.00 L 178.00 79.00 L 179.00 62.00 L 177.00 59.00 L 176.00 51.00 L 172.00 44.00 L 153.00 43.00 L 137.00 26.00 L 136.00 20.00 L 135.00 19.00 L 120.00 18.00 L 115.00 21.00 L 79.00 19.00 L 74.00 22.00 L 59.00 23.00 L 58.00 22.00 L 58.00 14.00 L 53.00 7.00 L 50.00 7.00 L 45.00 5.00 L 40.00 5.00 L 31.00 0.00 Z",
    "province": "REGION_8",
    "rootTerritory": "REGION_8",
    "viewBox": "0 0 179 202",
    "unitSlots": [
      {
        "name": "main",
        "x": 96,
        "y": 61,
        "territory": "REGION_8",
        "arrowReceiver": {
          "x": 96,
          "y": 91
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 96,
        "y": 61,
        "territory": "REGION_8",
        "arrowReceiver": {
          "x": 96,
          "y": 91
        }
      }
    },
    "texture": {
      "texture": "#B0CEB1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_10": {
    "abbr": "MAT",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 133,
        "y": 71,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 213,
    "height": 221,
    "x": 809,
    "y": 1301,
    "playable": true,
    "path": "M 42.00 1.00 L 34.00 8.00 L 30.00 14.00 L 13.00 20.00 L 6.00 25.00 L 0.00 35.00 L 0.00 53.00 L 12.00 65.00 L 31.00 69.00 L 58.00 83.00 L 66.00 83.00 L 70.00 85.00 L 72.00 88.00 L 71.00 89.00 L 69.00 111.00 L 72.00 117.00 L 75.00 120.00 L 97.00 120.00 L 100.00 123.00 L 99.00 135.00 L 109.00 144.00 L 109.00 146.00 L 108.00 147.00 L 107.00 162.00 L 96.00 179.00 L 97.00 198.00 L 100.00 202.00 L 120.00 203.00 L 123.00 208.00 L 123.00 219.00 L 126.00 221.00 L 129.00 221.00 L 145.00 204.00 L 159.00 200.00 L 160.00 195.00 L 175.00 178.00 L 184.00 159.00 L 186.00 157.00 L 197.00 157.00 L 196.00 152.00 L 189.00 143.00 L 170.00 134.00 L 166.00 127.00 L 201.00 85.00 L 210.00 67.00 L 213.00 14.00 L 132.00 11.00 L 123.00 0.00 L 120.00 0.00 L 114.00 10.00 L 54.00 10.00 L 44.00 1.00 Z",
    "province": "REGION_10",
    "rootTerritory": "REGION_10",
    "viewBox": "0 0 213 221",
    "unitSlots": [
      {
        "name": "main",
        "x": 106,
        "y": 46,
        "territory": "REGION_10",
        "arrowReceiver": {
          "x": 106,
          "y": 76
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 106,
        "y": 46,
        "territory": "REGION_10",
        "arrowReceiver": {
          "x": 106,
          "y": 76
        }
      }
    },
    "texture": {
      "texture": "#B0CEB1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_12": {
    "abbr": "SAP",
    "type": "Coast",
    "centerPos": {
      "x": 45,
      "y": 37
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 62,
        "y": 30,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 121,
    "height": 72,
    "x": 967,
    "y": 1456,
    "playable": true,
    "path": "M 121.00 35.00 L 118.00 30.00 L 97.00 31.00 L 93.00 33.00 L 91.00 31.00 L 90.00 19.00 L 83.00 12.00 L 84.00 4.00 L 81.00 0.00 L 62.00 1.00 L 57.00 4.00 L 50.00 1.00 L 26.00 1.00 L 16.00 21.00 L 1.00 38.00 L 0.00 45.00 L 19.00 45.00 L 24.00 48.00 L 44.00 50.00 L 46.00 54.00 L 48.00 64.00 L 55.00 72.00 L 57.00 72.00 L 78.00 56.00 L 93.00 52.00 L 109.00 37.00 L 121.00 38.00 Z",
    "province": "REGION_12",
    "rootTerritory": "REGION_12",
    "viewBox": "0 0 121 72",
    "unitSlots": [
      {
        "name": "main",
        "x": 56,
        "y": 36,
        "territory": "REGION_12",
        "arrowReceiver": {
          "x": 56,
          "y": 66
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 56,
        "y": 36,
        "territory": "REGION_12",
        "arrowReceiver": {
          "x": 56,
          "y": 66
        }
      }
    },
    "texture": {
      "texture": "#B0CEB1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_13": {
    "abbr": "RGS",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 88,
        "y": 32,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 133,
    "height": 132,
    "x": 890,
    "y": 1500,
    "playable": true,
    "path": "M 123.00 5.00 L 103.00 3.00 L 98.00 0.00 L 74.00 0.00 L 62.00 4.00 L 47.00 20.00 L 47.00 23.00 L 51.00 23.00 L 56.00 25.00 L 56.00 36.00 L 52.00 43.00 L 52.00 46.00 L 55.00 51.00 L 55.00 62.00 L 49.00 74.00 L 26.00 90.00 L 14.00 96.00 L 8.00 96.00 L 0.00 107.00 L 0.00 109.00 L 6.00 116.00 L 18.00 116.00 L 20.00 117.00 L 33.00 132.00 L 36.00 132.00 L 48.00 118.00 L 59.00 113.00 L 66.00 104.00 L 74.00 103.00 L 93.00 85.00 L 101.00 80.00 L 105.00 76.00 L 109.00 61.00 L 125.00 32.00 L 127.00 30.00 L 133.00 28.00 L 133.00 26.00 L 126.00 18.00 Z",
    "province": "REGION_13",
    "rootTerritory": "REGION_13",
    "viewBox": "0 0 133 132",
    "unitSlots": [
      {
        "name": "main",
        "x": 57,
        "y": 86,
        "territory": "REGION_13",
        "arrowReceiver": {
          "x": 57,
          "y": 116
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 57,
        "y": 86,
        "territory": "REGION_13",
        "arrowReceiver": {
          "x": 57,
          "y": 116
        }
      }
    },
    "texture": {
      "texture": "#B0CEB1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_15": {
    "abbr": "ARO",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 157,
        "y": 57,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 418,
    "height": 137,
    "x": 362,
    "y": 0,
    "playable": true,
    "path": "M 0.00 120.00 L 3.00 120.00 L 8.00 125.00 L 12.00 125.00 L 15.00 127.00 L 20.00 127.00 L 29.00 136.00 L 38.00 137.00 L 40.00 135.00 L 39.00 125.00 L 30.00 120.00 L 29.00 110.00 L 35.00 101.00 L 40.00 100.00 L 54.00 92.00 L 74.00 92.00 L 82.00 99.00 L 98.00 102.00 L 113.00 110.00 L 136.00 109.00 L 137.00 114.00 L 141.00 118.00 L 149.00 122.00 L 157.00 122.00 L 164.00 118.00 L 175.00 117.00 L 183.00 112.00 L 190.00 112.00 L 191.00 113.00 L 221.00 112.00 L 231.00 119.00 L 239.00 119.00 L 240.00 114.00 L 244.00 109.00 L 244.00 106.00 L 238.00 106.00 L 235.00 104.00 L 216.00 104.00 L 208.00 96.00 L 209.00 80.00 L 211.00 72.00 L 226.00 73.00 L 253.00 59.00 L 284.00 55.00 L 324.00 42.00 L 346.00 42.00 L 355.00 47.00 L 383.00 44.00 L 415.00 61.00 L 418.00 61.00 L 418.00 58.00 L 403.00 42.00 L 388.00 22.00 L 383.00 11.00 L 375.00 0.00 L 68.00 0.00 L 60.00 16.00 L 52.00 26.00 L 45.00 41.00 L 37.00 51.00 L 26.00 74.00 L 14.00 89.00 L 0.00 117.00 Z",
    "province": "REGION_15",
    "rootTerritory": "REGION_15",
    "viewBox": "0 0 418 137",
    "unitSlots": [
      {
        "name": "main",
        "x": 231,
        "y": 49,
        "territory": "REGION_15",
        "arrowReceiver": {
          "x": 231,
          "y": 79
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 231,
        "y": 49,
        "territory": "REGION_15",
        "arrowReceiver": {
          "x": 231,
          "y": 79
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_16": {
    "abbr": "SON",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 22,
        "y": 43,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 45,
    "height": 104,
    "x": 131,
    "y": 595,
    "playable": true,
    "path": "M 32.00 0.00 L 27.00 1.00 L 27.00 5.00 L 24.00 9.00 L 0.00 33.00 L 2.00 67.00 L 15.00 81.00 L 15.00 94.00 L 25.00 104.00 L 28.00 104.00 L 31.00 101.00 L 30.00 81.00 L 36.00 74.00 L 39.00 59.00 L 44.00 51.00 L 45.00 9.00 L 44.00 7.00 L 38.00 7.00 Z",
    "province": "REGION_16",
    "rootTerritory": "REGION_16",
    "viewBox": "0 0 45 104",
    "unitSlots": [
      {
        "name": "main",
        "x": 26,
        "y": 46,
        "territory": "REGION_16",
        "arrowReceiver": {
          "x": 26,
          "y": 76
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 26,
        "y": 46,
        "territory": "REGION_16",
        "arrowReceiver": {
          "x": 26,
          "y": 76
        }
      }
    },
    "texture": {
      "texture": "#BED3B0",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_17": {
    "abbr": "CHH",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 39,
        "y": 65,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 154,
    "height": 180,
    "x": 160,
    "y": 605,
    "playable": true,
    "path": "M 15.00 0.00 L 14.00 39.00 L 9.00 47.00 L 6.00 62.00 L 0.00 69.00 L 1.00 91.00 L 3.00 91.00 L 5.00 89.00 L 13.00 89.00 L 20.00 95.00 L 21.00 102.00 L 27.00 108.00 L 30.00 108.00 L 33.00 103.00 L 40.00 103.00 L 44.00 105.00 L 53.00 105.00 L 60.00 107.00 L 84.00 109.00 L 85.00 110.00 L 85.00 128.00 L 84.00 131.00 L 87.00 133.00 L 102.00 132.00 L 110.00 139.00 L 112.00 139.00 L 115.00 144.00 L 117.00 145.00 L 120.00 152.00 L 120.00 168.00 L 126.00 173.00 L 127.00 178.00 L 130.00 177.00 L 133.00 178.00 L 134.00 180.00 L 139.00 180.00 L 141.00 152.00 L 154.00 133.00 L 154.00 130.00 L 132.00 119.00 L 130.00 99.00 L 107.00 62.00 L 101.00 61.00 L 88.00 71.00 L 81.00 71.00 L 72.00 66.00 L 74.00 43.00 L 70.00 36.00 L 70.00 21.00 L 59.00 20.00 L 54.00 17.00 L 42.00 17.00 L 34.00 13.00 L 19.00 10.00 L 17.00 0.00 Z",
    "province": "REGION_17",
    "rootTerritory": "REGION_17",
    "viewBox": "0 0 154 180",
    "unitSlots": [
      {
        "name": "main",
        "x": 63,
        "y": 86,
        "territory": "REGION_17",
        "arrowReceiver": {
          "x": 63,
          "y": 116
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 63,
        "y": 86,
        "territory": "REGION_17",
        "arrowReceiver": {
          "x": 63,
          "y": 116
        }
      }
    },
    "texture": {
      "texture": "#BED3B0",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_18": {
    "abbr": "MAO",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 233,
        "y": 161,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 372,
    "height": 606,
    "x": 922,
    "y": 627,
    "playable": true,
    "path": "M 0.205 63.968 L 1.968 70.870 L 2.117 71.984 L 3.449 81.940 L 3.598 83.054 L 4.124 86.983 L 4.273 88.097 L 5.324 95.957 L 5.473 97.071 L 6.261 102.965 L 6.410 104.079 L 7.067 108.991 L 7.216 110.105 L 9.336 125.955 L 9.485 127.069 L 11.079 138.989 L 11.228 140.103 L 12.674 150.910 L 12.823 152.024 L 14.137 161.848 L 14.286 162.962 L 15.468 171.804 L 15.617 172.917 L 15.761 179.713 L 15.927 184.009 L 16.548 188.931 L 16.688 190.039 L 17.185 193.977 L 17.325 195.085 L 18.567 204.928 L 18.707 206.037 L 19.576 212.927 L 19.716 214.036 L 20.462 219.942 L 20.601 221.050 L 22.605 236.924 L 22.745 238.032 L 23.777 246.210 L 23.777 246.210 L 24.000 305.000 L 56.000 303.000 L 59.000 301.000 L 64.000 300.000 L 72.000 296.000 L 110.000 294.000 L 113.000 292.000 L 123.000 292.000 L 126.000 290.000 L 187.000 289.000 L 191.000 296.000 L 191.000 311.000 L 193.000 314.000 L 193.000 326.000 L 194.000 327.000 L 194.000 334.000 L 195.000 335.000 L 195.000 348.000 L 196.000 349.000 L 196.000 355.000 L 197.000 356.000 L 198.000 390.000 L 200.000 393.000 L 200.000 407.000 L 201.000 408.000 L 203.000 482.000 L 207.000 489.000 L 217.000 489.000 L 238.000 481.000 L 262.000 482.000 L 273.000 476.000 L 294.000 478.000 L 295.000 479.000 L 295.000 486.000 L 298.000 491.000 L 296.000 565.000 L 295.000 566.000 L 286.000 565.000 L 287.000 573.000 L 302.000 589.000 L 321.000 590.000 L 325.000 596.000 L 329.000 606.000 L 351.073 602.130 L 371.955 590.420 L 371.955 590.420 L 371.958 0.625 L 363.020 2.120 L 361.885 2.310 L 356.048 3.287 L 354.912 3.477 L 350.049 4.291 L 348.913 4.481 L 343.077 5.457 L 341.941 5.647 L 337.077 6.461 L 335.942 6.651 L 331.078 7.465 L 329.942 7.655 L 325.078 8.469 L 323.943 8.659 L 319.079 9.473 L 317.944 9.663 L 313.080 10.477 L 311.944 10.667 L 307.080 11.481 L 305.945 11.671 L 301.081 12.484 L 299.946 12.674 L 295.082 13.488 L 293.946 13.678 L 289.082 14.492 L 287.947 14.682 L 278.056 16.337 L 276.921 16.527 L 272.057 17.341 L 270.922 17.531 L 267.031 18.182 L 265.895 18.372 L 262.004 19.023 L 260.868 19.213 L 256.005 20.027 L 254.869 20.217 L 248.060 21.357 L 246.924 21.547 L 242.060 22.360 L 240.925 22.550 L 236.061 23.364 L 234.925 23.554 L 230.062 24.368 L 228.926 24.558 L 224.062 25.372 L 222.927 25.562 L 218.063 26.376 L 216.927 26.566 L 212.064 27.380 L 210.928 27.570 L 198.119 29.713 L 196.984 29.903 L 189.039 31.233 L 187.903 31.423 L 181.094 32.562 L 179.958 32.752 L 175.095 33.566 L 173.959 33.756 L 169.095 34.570 L 167.960 34.760 L 163.096 35.574 L 161.960 35.764 L 157.097 36.577 L 155.961 36.767 L 151.097 37.581 L 149.962 37.771 L 145.098 38.585 L 143.962 38.775 L 139.099 39.589 L 137.963 39.779 L 133.099 40.593 L 131.964 40.783 L 126.127 41.760 L 124.992 41.950 L 120.128 42.763 L 118.992 42.953 L 102.130 45.775 L 100.994 45.965 L 91.104 47.620 L 89.968 47.810 L 86.077 48.461 L 84.942 48.651 L 81.051 49.302 L 79.915 49.492 L 75.051 50.306 L 73.916 50.496 L 70.025 51.147 L 68.889 51.337 L 62.080 52.477 L 56.890 53.345 L 49.108 54.647 L 47.973 54.837 L 37.110 56.655 L 35.974 56.845 L 32.083 57.496 L 30.947 57.686 L 27.056 58.337 L 25.921 58.527 L 9.058 61.349 L 7.923 61.539 Z",
    "province": "REGION_18",
    "rootTerritory": "REGION_18",
    "viewBox": "0 0 372 606",
    "unitSlots": [
      {
        "name": "main",
        "x": 188,
        "y": 67,
        "territory": "REGION_18",
        "arrowReceiver": {
          "x": 188,
          "y": 97
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 188,
        "y": 67,
        "territory": "REGION_18",
        "arrowReceiver": {
          "x": 188,
          "y": 97
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_19": {
    "abbr": "GUA",
    "type": "Coast",
    "centerPos": {
      "x": 42,
      "y": 57
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 59,
        "y": 50,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 120,
    "height": 143,
    "x": 156,
    "y": 693,
    "playable": true,
    "path": "M 7.00 0.00 L 0.00 5.00 L 1.00 24.00 L 10.00 31.00 L 16.00 50.00 L 33.00 70.00 L 39.00 82.00 L 39.00 107.00 L 33.00 114.00 L 31.00 120.00 L 36.00 128.00 L 50.00 143.00 L 57.00 142.00 L 63.00 137.00 L 63.00 128.00 L 75.00 121.00 L 76.00 114.00 L 95.00 98.00 L 95.00 96.00 L 84.00 88.00 L 84.00 74.00 L 108.00 58.00 L 110.00 55.00 L 120.00 56.00 L 120.00 53.00 L 118.00 50.00 L 116.00 50.00 L 107.00 42.00 L 99.00 44.00 L 93.00 44.00 L 90.00 41.00 L 90.00 20.00 L 66.00 18.00 L 59.00 16.00 L 50.00 16.00 L 46.00 14.00 L 35.00 14.00 L 32.00 18.00 L 26.00 12.00 L 25.00 5.00 L 19.00 0.00 Z",
    "province": "REGION_19",
    "rootTerritory": "REGION_19",
    "viewBox": "0 0 120 143",
    "unitSlots": [
      {
        "name": "main",
        "x": 70,
        "y": 52,
        "territory": "REGION_19",
        "arrowReceiver": {
          "x": 70,
          "y": 82
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 70,
        "y": 52,
        "territory": "REGION_19",
        "arrowReceiver": {
          "x": 70,
          "y": 82
        }
      }
    },
    "texture": {
      "texture": "#BED3B0",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_21": {
    "abbr": "MEH",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 23,
        "y": 26,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 73,
    "height": 66,
    "x": 206,
    "y": 813,
    "playable": true,
    "path": "M 12.00 6.00 L 12.00 15.00 L 7.00 20.00 L 0.00 22.00 L 0.00 24.00 L 12.00 37.00 L 31.00 45.00 L 48.00 58.00 L 65.00 65.00 L 72.00 66.00 L 73.00 64.00 L 72.00 49.00 L 50.00 32.00 L 50.00 24.00 L 48.00 18.00 L 39.00 18.00 L 27.00 12.00 L 25.00 10.00 L 25.00 0.00 L 22.00 0.00 Z",
    "province": "REGION_21",
    "rootTerritory": "REGION_21",
    "viewBox": "0 0 73 66",
    "unitSlots": [
      {
        "name": "main",
        "x": 48,
        "y": 39,
        "territory": "REGION_21",
        "arrowReceiver": {
          "x": 48,
          "y": 69
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 48,
        "y": 39,
        "territory": "REGION_21",
        "arrowReceiver": {
          "x": 48,
          "y": 69
        }
      }
    },
    "texture": {
      "texture": "#BED3B0",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_22": {
    "abbr": "OAX",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 27,
        "y": 16,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 71,
    "height": 37,
    "x": 276,
    "y": 862,
    "playable": true,
    "path": "M 1.00 0.00 L 2.00 13.00 L 0.00 18.00 L 28.00 33.00 L 30.00 35.00 L 30.00 37.00 L 36.00 37.00 L 39.00 34.00 L 59.00 33.00 L 60.00 32.00 L 64.00 32.00 L 65.00 35.00 L 68.00 35.00 L 71.00 28.00 L 70.00 25.00 L 55.00 25.00 L 49.00 22.00 L 42.00 15.00 L 40.00 7.00 L 36.00 2.00 L 22.00 2.00 L 21.00 0.00 L 19.00 0.00 L 18.00 2.00 L 5.00 2.00 L 3.00 0.00 Z",
    "province": "REGION_22",
    "rootTerritory": "REGION_22",
    "viewBox": "0 0 71 37",
    "unitSlots": [
      {
        "name": "main",
        "x": 35,
        "y": 31,
        "territory": "REGION_22",
        "arrowReceiver": {
          "x": 35,
          "y": 61
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 35,
        "y": 31,
        "territory": "REGION_22",
        "arrowReceiver": {
          "x": 35,
          "y": 61
        }
      }
    },
    "texture": {
      "texture": "#BED3B0",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_23": {
    "abbr": "SAO",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 384,
        "y": 478,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 480,
    "height": 629,
    "x": 814,
    "y": 1217,
    "playable": true,
    "path": "M 479.955 0.420 L 467.292 7.521 L 464.917 8.853 L 459.073 12.130 L 464.000 20.000 L 463.000 78.000 L 462.000 79.000 L 462.000 101.000 L 463.000 102.000 L 463.000 112.000 L 464.000 113.000 L 464.000 129.000 L 460.000 132.000 L 459.000 171.000 L 437.000 183.000 L 426.000 184.000 L 421.000 187.000 L 407.000 188.000 L 408.000 217.000 L 409.000 218.000 L 409.000 227.000 L 410.000 228.000 L 408.000 318.000 L 397.000 326.000 L 371.000 328.000 L 352.000 338.000 L 316.000 343.000 L 316.000 373.000 L 312.000 380.000 L 313.000 413.000 L 308.000 419.000 L 303.000 421.000 L 300.000 421.000 L 287.000 426.000 L 284.000 426.000 L 280.000 428.000 L 242.000 431.000 L 238.000 435.000 L 195.000 436.000 L 192.000 438.000 L 183.000 438.000 L 179.000 440.000 L 176.000 445.000 L 175.000 481.000 L 171.000 488.000 L 170.000 516.000 L 166.000 523.000 L 162.000 523.000 L 161.000 524.000 L 153.000 524.000 L 152.000 525.000 L 143.000 525.000 L 142.000 526.000 L 138.000 526.000 L 131.000 530.000 L 103.000 531.000 L 99.000 534.000 L 86.000 532.000 L 83.000 534.000 L 53.000 535.000 L 50.000 538.000 L 37.000 537.000 L 36.000 538.000 L 13.000 539.000 L 13.000 543.000 L 9.000 550.000 L 8.000 567.000 L 4.985 571.998 L 0.890 600.023 L 22.000 600.000 L 23.000 601.000 L 23.000 629.000 L 33.000 629.000 L 34.000 628.000 L 53.000 628.000 L 54.000 627.000 L 63.000 627.000 L 66.000 625.000 L 85.000 625.000 L 88.000 623.000 L 97.000 623.000 L 98.000 622.000 L 131.000 621.000 L 132.000 620.000 L 146.000 619.000 L 149.000 615.000 L 157.000 615.000 L 160.000 617.000 L 167.000 617.000 L 168.000 616.000 L 176.000 616.000 L 179.000 614.000 L 190.000 614.000 L 191.000 613.000 L 202.000 613.000 L 205.000 611.000 L 216.000 611.000 L 219.000 609.000 L 257.000 607.000 L 258.000 606.000 L 261.000 606.000 L 265.000 604.000 L 268.000 604.000 L 272.000 602.000 L 275.000 602.000 L 276.000 601.000 L 278.000 601.000 L 282.000 599.000 L 285.000 599.000 L 289.000 597.000 L 292.000 597.000 L 293.000 596.000 L 319.000 597.000 L 320.000 596.000 L 323.000 596.000 L 324.000 595.000 L 326.000 595.000 L 330.000 593.000 L 333.000 593.000 L 340.000 590.000 L 343.000 590.000 L 350.000 587.000 L 353.000 587.000 L 354.000 586.000 L 360.000 585.000 L 367.000 582.000 L 370.000 582.000 L 377.000 579.000 L 380.000 579.000 L 387.000 576.000 L 390.000 576.000 L 391.000 575.000 L 401.000 575.000 L 402.000 574.000 L 411.000 574.000 L 426.000 566.000 L 450.000 562.000 L 468.000 552.000 L 480.000 552.000 Z",
    "province": "REGION_23",
    "rootTerritory": "REGION_23",
    "viewBox": "0 0 480 629",
    "unitSlots": [
      {
        "name": "main",
        "x": 247,
        "y": 546,
        "territory": "REGION_23",
        "arrowReceiver": {
          "x": 247,
          "y": 576
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 247,
        "y": 546,
        "territory": "REGION_23",
        "arrowReceiver": {
          "x": 247,
          "y": 576
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_24": {
    "abbr": "TKM",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 47,
        "y": 23,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 76,
    "height": 73,
    "x": 749,
    "y": 1517,
    "playable": true,
    "path": "M 74.00 0.00 L 68.00 1.00 L 60.00 9.00 L 38.00 9.00 L 25.00 33.00 L 23.00 35.00 L 6.00 38.00 L 0.00 46.00 L 0.00 53.00 L 11.00 61.00 L 21.00 60.00 L 31.00 73.00 L 33.00 73.00 L 33.00 61.00 L 35.00 57.00 L 66.00 23.00 L 74.00 6.00 L 76.00 5.00 Z",
    "province": "REGION_24",
    "rootTerritory": "REGION_24",
    "viewBox": "0 0 76 73",
    "unitSlots": [
      {
        "name": "main",
        "x": 35,
        "y": 42,
        "territory": "REGION_24",
        "arrowReceiver": {
          "x": 35,
          "y": 72
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 35,
        "y": 42,
        "territory": "REGION_24",
        "arrowReceiver": {
          "x": 35,
          "y": 72
        }
      }
    },
    "texture": {
      "texture": "#C6A8D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_25": {
    "abbr": "TUC",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 37,
        "y": 46,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 78,
    "height": 77,
    "x": 781,
    "y": 1521,
    "playable": true,
    "path": "M 45.00 0.00 L 41.00 0.00 L 33.00 17.00 L 2.00 51.00 L 0.00 55.00 L 0.00 71.00 L 2.00 73.00 L 31.00 77.00 L 48.00 65.00 L 55.00 65.00 L 58.00 63.00 L 67.00 64.00 L 78.00 55.00 L 77.00 49.00 L 67.00 45.00 L 53.00 29.00 L 54.00 12.00 Z",
    "province": "REGION_25",
    "rootTerritory": "REGION_25",
    "viewBox": "0 0 78 77",
    "unitSlots": [
      {
        "name": "main",
        "x": 42,
        "y": 53,
        "territory": "REGION_25",
        "arrowReceiver": {
          "x": 42,
          "y": 83
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 42,
        "y": 53,
        "territory": "REGION_25",
        "arrowReceiver": {
          "x": 42,
          "y": 83
        }
      }
    },
    "texture": {
      "texture": "#C6A8D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_26": {
    "abbr": "LAR",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 35,
        "y": 35,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 69,
    "height": 55,
    "x": 715,
    "y": 1569,
    "playable": true,
    "path": "M 69.00 23.00 L 57.00 7.00 L 47.00 8.00 L 38.00 1.00 L 34.00 0.00 L 34.00 15.00 L 32.00 19.00 L 26.00 22.00 L 0.00 51.00 L 0.00 53.00 L 26.00 55.00 L 36.00 51.00 L 44.00 50.00 L 49.00 42.00 L 67.00 25.00 L 69.00 25.00 Z",
    "province": "REGION_26",
    "rootTerritory": "REGION_26",
    "viewBox": "0 0 69 55",
    "unitSlots": [
      {
        "name": "main",
        "x": 31,
        "y": 39,
        "territory": "REGION_26",
        "arrowReceiver": {
          "x": 31,
          "y": 69
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 31,
        "y": 39,
        "territory": "REGION_26",
        "arrowReceiver": {
          "x": 31,
          "y": 69
        }
      }
    },
    "texture": {
      "texture": "#C6A8D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_27": {
    "abbr": "CRR",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 28,
        "y": 21,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 61,
    "height": 77,
    "x": 838,
    "y": 1575,
    "playable": true,
    "path": "M 61.00 21.00 L 51.00 21.00 L 48.00 18.00 L 27.00 8.00 L 21.00 0.00 L 17.00 1.00 L 9.00 8.00 L 9.00 10.00 L 14.00 10.00 L 17.00 15.00 L 18.00 32.00 L 5.00 45.00 L 6.00 53.00 L 0.00 61.00 L 1.00 73.00 L 6.00 77.00 L 9.00 77.00 L 10.00 66.00 L 27.00 33.00 L 29.00 31.00 L 48.00 29.00 L 51.00 33.00 L 54.00 33.00 L 60.00 25.00 Z",
    "province": "REGION_27",
    "rootTerritory": "REGION_27",
    "viewBox": "0 0 61 77",
    "unitSlots": [
      {
        "name": "main",
        "x": 39,
        "y": 15,
        "territory": "REGION_27",
        "arrowReceiver": {
          "x": 39,
          "y": 45
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 39,
        "y": 15,
        "territory": "REGION_27",
        "arrowReceiver": {
          "x": 39,
          "y": 45
        }
      }
    },
    "texture": {
      "texture": "#C6A8D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_28": {
    "abbr": "CHA",
    "type": "Land",
    "centerPos": {
      "x": 19,
      "y": 26
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 36,
        "y": 19,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 54,
    "height": 71,
    "x": 803,
    "y": 1583,
    "playable": true,
    "path": "M 51.00 1.00 L 34.00 0.00 L 31.00 2.00 L 24.00 2.00 L 8.00 13.00 L 8.00 15.00 L 13.00 15.00 L 18.00 17.00 L 18.00 26.00 L 0.00 61.00 L 0.00 64.00 L 6.00 71.00 L 8.00 71.00 L 25.00 62.00 L 33.00 62.00 L 35.00 64.00 L 37.00 64.00 L 36.00 55.00 L 42.00 47.00 L 41.00 39.00 L 54.00 26.00 L 53.00 5.00 Z",
    "province": "REGION_28",
    "rootTerritory": "REGION_28",
    "viewBox": "0 0 54 71",
    "unitSlots": [
      {
        "name": "main",
        "x": 20,
        "y": 53,
        "territory": "REGION_28",
        "arrowReceiver": {
          "x": 20,
          "y": 83
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 20,
        "y": 53,
        "territory": "REGION_28",
        "arrowReceiver": {
          "x": 20,
          "y": 83
        }
      }
    },
    "texture": {
      "texture": "#C6A8D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_29": {
    "abbr": "SVC",
    "type": "Land",
    "centerPos": {
      "x": 1,
      "y": 8
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 44,
        "y": 25,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 76,
    "height": 53,
    "x": 746,
    "y": 1593,
    "playable": true,
    "path": "M 0.00 27.00 L 0.00 29.00 L 10.00 29.00 L 11.00 30.00 L 12.00 47.00 L 14.00 48.00 L 52.00 49.00 L 56.00 53.00 L 58.00 53.00 L 76.00 18.00 L 76.00 5.00 L 34.00 0.00 L 17.00 16.00 L 11.00 25.00 Z",
    "province": "REGION_29",
    "rootTerritory": "REGION_29",
    "viewBox": "0 0 76 53",
    "unitSlots": [
      {
        "name": "main",
        "x": 27,
        "y": 27,
        "territory": "REGION_29",
        "arrowReceiver": {
          "x": 27,
          "y": 57
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 27,
        "y": 27,
        "territory": "REGION_29",
        "arrowReceiver": {
          "x": 27,
          "y": 57
        }
      }
    },
    "texture": {
      "texture": "#C6A8D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_30": {
    "abbr": "BUE",
    "type": "Coast",
    "centerPos": {
      "x": 4,
      "y": -10
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 21,
        "y": 31,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 41,
    "height": 62,
    "x": 810,
    "y": 1644,
    "playable": true,
    "path": "M 28.00 0.00 L 16.00 0.00 L 0.00 8.00 L 0.00 11.00 L 4.00 15.00 L 2.00 51.00 L 6.00 55.00 L 7.00 55.00 L 13.00 62.00 L 14.00 61.00 L 16.00 61.00 L 19.00 58.00 L 28.00 54.00 L 40.00 40.00 L 39.00 30.00 L 41.00 28.00 L 41.00 25.00 L 36.00 20.00 L 37.00 7.00 Z",
    "province": "REGION_30",
    "rootTerritory": "REGION_30",
    "viewBox": "0 0 41 62",
    "unitSlots": [
      {
        "name": "main",
        "x": 24,
        "y": 14,
        "territory": "REGION_30",
        "arrowReceiver": {
          "x": 24,
          "y": 44
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 24,
        "y": 14,
        "territory": "REGION_30",
        "arrowReceiver": {
          "x": 24,
          "y": 44
        }
      }
    },
    "texture": {
      "texture": "#C6A8D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_40": {
    "abbr": "MAB",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 68,
        "y": 33,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 92,
    "height": 55,
    "x": 715,
    "y": 438,
    "playable": true,
    "path": "M 90.231 4.715 L 79.000 4.000 L 62.000 13.000 L 61.000 12.000 L 60.444 0.384 L 60.444 0.384 L 41.000 2.000 L 42.000 17.000 L 32.000 25.000 L 24.000 24.000 L 0.000 45.000 L 3.013 54.222 L 30.003 53.795 L 37.995 53.669 L 57.994 53.353 L 58.997 53.337 L 91.113 52.829 L 90.806 41.091 L 90.666 34.975 Z",
    "province": "REGION_40",
    "rootTerritory": "REGION_40",
    "viewBox": "0 0 92 55",
    "unitSlots": [
      {
        "name": "main",
        "x": 52,
        "y": 41,
        "territory": "REGION_40",
        "arrowReceiver": {
          "x": 52,
          "y": 71
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 52,
        "y": 41,
        "territory": "REGION_40",
        "arrowReceiver": {
          "x": 52,
          "y": 71
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_42": {
    "abbr": "GUL",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 92,
        "y": 37,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 157,
    "height": 72,
    "x": 651,
    "y": 490,
    "playable": true,
    "path": "M 155.113 0.829 L 120.999 1.368 L 119.998 1.384 L 109.000 1.558 L 107.997 1.574 L 97.002 1.748 L 96.005 1.763 L 67.013 2.222 L 67.000 10.000 L 64.000 14.000 L 50.000 19.000 L 41.000 26.000 L 29.000 28.000 L 28.000 36.000 L 23.000 46.000 L 14.000 54.000 L 12.000 54.000 L 9.000 62.000 L 1.000 67.000 L 0.000 71.000 L 1.000 72.000 L 119.998 70.551 L 126.566 60.478 L 136.619 44.759 L 141.530 37.082 L 149.185 25.114 L 156.194 14.156 Z",
    "province": "REGION_42",
    "rootTerritory": "REGION_42",
    "viewBox": "0 0 157 72",
    "unitSlots": [
      {
        "name": "main",
        "x": 69,
        "y": 59,
        "territory": "REGION_42",
        "arrowReceiver": {
          "x": 69,
          "y": 89
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 69,
        "y": 59,
        "territory": "REGION_42",
        "arrowReceiver": {
          "x": 69,
          "y": 89
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_44": {
    "abbr": "ANC",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 119,
        "y": 42,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 198,
    "height": 122,
    "x": 573,
    "y": 560,
    "playable": true,
    "path": "M 197.998 0.551 L 81.000 1.000 L 78.000 0.000 L 78.000 5.000 L 80.000 6.000 L 80.000 28.000 L 69.000 50.000 L 67.000 52.000 L 36.000 67.000 L 1.000 98.000 L 0.000 103.000 L 2.000 108.000 L 4.019 119.831 L 51.314 121.228 L 51.314 121.228 L 52.000 106.000 L 53.000 105.000 L 53.000 92.000 L 55.000 84.000 L 151.188 81.083 L 165.954 67.348 L 172.406 53.176 L 181.574 34.295 L 186.856 23.417 L 191.732 13.375 L 197.998 0.551 Z",
    "province": "REGION_44",
    "rootTerritory": "REGION_44",
    "viewBox": "0 0 198 122",
    "unitSlots": [
      {
        "name": "main",
        "x": 87,
        "y": 80,
        "territory": "REGION_44",
        "arrowReceiver": {
          "x": 87,
          "y": 110
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 87,
        "y": 80,
        "territory": "REGION_44",
        "arrowReceiver": {
          "x": 87,
          "y": 110
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_47": {
    "abbr": "APB",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 40,
        "y": 30,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 117,
    "height": 61,
    "x": 427,
    "y": 669,
    "playable": true,
    "path": "M 3.00 20.00 L 2.00 36.00 L 0.00 39.00 L 0.00 51.00 L 3.00 57.00 L 115.00 61.00 L 117.00 33.00 L 102.00 20.00 L 98.00 12.00 L 95.00 12.00 L 90.00 15.00 L 78.00 15.00 L 73.00 8.00 L 48.00 4.00 L 45.00 3.00 L 42.00 0.00 L 24.00 1.00 L 21.00 3.00 L 15.00 16.00 Z",
    "province": "REGION_47",
    "rootTerritory": "REGION_47",
    "viewBox": "0 0 117 61",
    "unitSlots": [
      {
        "name": "main",
        "x": 64,
        "y": 33,
        "territory": "REGION_47",
        "arrowReceiver": {
          "x": 64,
          "y": 63
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 64,
        "y": 33,
        "territory": "REGION_47",
        "arrowReceiver": {
          "x": 64,
          "y": 63
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_48": {
    "abbr": "GOM",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 83,
        "y": 75,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 244,
    "height": 139,
    "x": 298,
    "y": 680,
    "playable": true,
    "path": "M 2.000 75.000 L 0.000 105.000 L 5.000 104.000 L 10.000 105.000 L 12.000 120.000 L 18.072 126.737 L 42.984 129.168 L 44.069 129.274 L 53.978 130.240 L 59.119 130.742 L 75.964 132.385 L 79.123 132.694 L 113.851 136.082 L 113.851 136.082 L 145.000 129.000 L 148.000 126.000 L 163.000 126.000 L 175.920 133.964 L 175.920 133.964 L 225.039 138.033 L 237.000 125.000 L 239.000 80.000 L 240.000 79.000 L 240.000 62.000 L 241.000 61.000 L 241.000 52.000 L 244.000 51.000 L 244.000 49.000 L 134.000 45.000 L 130.000 38.000 L 130.000 30.000 L 132.000 27.000 L 133.000 9.000 L 124.000 9.000 L 117.000 5.000 L 99.000 4.000 L 90.000 0.000 L 87.000 0.000 L 86.000 1.000 L 75.000 2.000 L 58.000 14.000 L 41.000 18.000 L 31.000 34.000 L 29.000 55.000 L 28.000 56.000 L 15.000 56.000 Z",
    "province": "REGION_48",
    "rootTerritory": "REGION_48",
    "viewBox": "0 0 244 139",
    "unitSlots": [
      {
        "name": "main",
        "x": 119,
        "y": 93,
        "territory": "REGION_48",
        "arrowReceiver": {
          "x": 119,
          "y": 123
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 119,
        "y": 93,
        "territory": "REGION_48",
        "arrowReceiver": {
          "x": 119,
          "y": 123
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_51": {
    "abbr": "BDL",
    "type": "Coast",
    "centerPos": {
      "x": 11,
      "y": 16
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 28,
        "y": 9,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 57,
    "height": 55,
    "x": 831,
    "y": 798,
    "playable": true,
    "path": "M 5.00 0.00 L 5.00 2.00 L 3.00 5.00 L 3.00 24.00 L 1.00 27.00 L 1.00 30.00 L 2.00 31.00 L 1.00 45.00 L 0.00 46.00 L 1.00 55.00 L 50.00 54.00 L 52.00 52.00 L 52.00 20.00 L 57.00 17.00 L 57.00 4.00 L 55.00 1.00 L 31.00 1.00 L 30.00 0.00 Z",
    "province": "REGION_51",
    "rootTerritory": "REGION_51",
    "viewBox": "0 0 57 55",
    "unitSlots": [
      {
        "name": "main",
        "x": 25,
        "y": 36,
        "territory": "REGION_51",
        "arrowReceiver": {
          "x": 25,
          "y": 66
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 25,
        "y": 36,
        "territory": "REGION_51",
        "arrowReceiver": {
          "x": 25,
          "y": 66
        }
      }
    },
    "texture": {
      "texture": "#E19EAA",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_52": {
    "abbr": "PUE",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 47,
        "y": 40,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 81,
    "height": 73,
    "x": 865,
    "y": 807,
    "playable": true,
    "path": "M 21.00 0.00 L 22.00 6.00 L 17.00 9.00 L 17.00 41.00 L 13.00 44.00 L 0.00 45.00 L 3.00 71.00 L 8.00 72.00 L 11.00 70.00 L 25.00 70.00 L 30.00 73.00 L 35.00 70.00 L 41.00 70.00 L 42.00 69.00 L 52.00 69.00 L 53.00 68.00 L 75.00 68.00 L 76.00 67.00 L 80.00 67.00 L 81.00 66.00 L 81.00 62.00 L 80.00 61.00 L 80.00 56.00 L 79.00 55.00 L 79.00 48.00 L 78.00 47.00 L 78.00 39.00 L 77.00 38.00 L 77.00 32.00 L 76.00 31.00 L 75.00 13.00 L 74.00 12.00 L 73.00 0.00 Z",
    "province": "REGION_52",
    "rootTerritory": "REGION_52",
    "viewBox": "0 0 81 73",
    "unitSlots": [
      {
        "name": "main",
        "x": 40,
        "y": 42,
        "territory": "REGION_52",
        "arrowReceiver": {
          "x": 40,
          "y": 72
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 40,
        "y": 42,
        "territory": "REGION_52",
        "arrowReceiver": {
          "x": 40,
          "y": 72
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_53": {
    "abbr": "SOY",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 23,
        "y": 15,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 63,
    "height": 31,
    "x": 464,
    "y": 813,
    "playable": true,
    "path": "M 0.543 27.893 L 0.543 27.893 L 32.000 28.988 L 33.038 29.024 L 62.476 30.048 L 62.476 30.048 L 63.000 18.000 L 59.000 14.000 L 59.039 5.033 L 9.920 0.964 L 9.000 17.000 Z",
    "province": "REGION_53",
    "rootTerritory": "REGION_53",
    "viewBox": "0 0 63 31",
    "unitSlots": [
      {
        "name": "main",
        "x": 41,
        "y": 18,
        "territory": "REGION_53",
        "arrowReceiver": {
          "x": 41,
          "y": 48
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 41,
        "y": 18,
        "territory": "REGION_53",
        "arrowReceiver": {
          "x": 41,
          "y": 48
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_55": {
    "abbr": "WCA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 94,
        "y": 69,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 165,
    "height": 102,
    "x": 463,
    "y": 840,
    "playable": true,
    "path": "M 1.543 0.893 L 0.000 22.000 L 28.000 23.000 L 33.000 27.000 L 37.000 35.000 L 37.000 46.000 L 35.000 49.000 L 36.000 63.000 L 44.000 63.000 L 52.000 67.000 L 63.000 80.000 L 63.000 84.000 L 66.000 87.000 L 66.000 100.000 L 71.000 100.000 L 72.000 101.000 L 101.000 101.000 L 102.000 102.000 L 127.998 101.888 L 128.995 101.861 L 164.648 101.162 L 164.000 71.002 L 138.000 70.000 L 137.000 69.000 L 135.000 38.000 L 68.000 36.000 L 65.000 34.000 L 63.476 3.048 L 35.995 2.092 L 34.957 2.056 L 1.543 0.893 Z",
    "province": "REGION_55",
    "rootTerritory": "REGION_55",
    "viewBox": "0 0 165 102",
    "unitSlots": [
      {
        "name": "main",
        "x": 108,
        "y": 63,
        "territory": "REGION_55",
        "arrowReceiver": {
          "x": 108,
          "y": 93
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 108,
        "y": 63,
        "territory": "REGION_55",
        "arrowReceiver": {
          "x": 108,
          "y": 93
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_59": {
    "abbr": "GUC",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 147,
        "y": 78,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 233,
    "height": 208,
    "x": 897,
    "y": 915,
    "playable": true,
    "path": "M 49.00 16.00 L 49.00 33.00 L 48.00 34.00 L 48.00 42.00 L 46.00 44.00 L 46.00 47.00 L 48.00 49.00 L 47.00 70.00 L 31.00 88.00 L 25.00 88.00 L 14.00 95.00 L 2.00 95.00 L 0.00 97.00 L 0.00 99.00 L 4.00 104.00 L 12.00 110.00 L 14.00 113.00 L 24.00 114.00 L 60.00 150.00 L 107.00 148.00 L 108.00 149.00 L 121.00 149.00 L 125.00 151.00 L 146.00 170.00 L 146.00 174.00 L 152.00 178.00 L 156.00 200.00 L 165.00 208.00 L 202.00 207.00 L 215.00 200.00 L 233.00 201.00 L 233.00 198.00 L 229.00 191.00 L 226.00 103.00 L 224.00 100.00 L 223.00 66.00 L 222.00 65.00 L 222.00 54.00 L 221.00 53.00 L 220.00 37.00 L 219.00 36.00 L 219.00 24.00 L 217.00 21.00 L 217.00 6.00 L 214.00 0.00 L 149.00 1.00 L 146.00 3.00 L 136.00 3.00 L 133.00 5.00 L 96.00 7.00 L 78.00 14.00 Z",
    "province": "REGION_59",
    "rootTerritory": "REGION_59",
    "viewBox": "0 0 233 208",
    "unitSlots": [
      {
        "name": "main",
        "x": 112,
        "y": 89,
        "territory": "REGION_59",
        "arrowReceiver": {
          "x": 112,
          "y": 119
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 112,
        "y": 89,
        "territory": "REGION_59",
        "arrowReceiver": {
          "x": 112,
          "y": 119
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_61": {
    "abbr": "GOV",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 86,
        "y": 21,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 107,
    "height": 54,
    "x": 682,
    "y": 940,
    "playable": true,
    "path": "M 0.493 4.139 L 0.493 4.139 L 0.493 4.139 L 0.000 43.000 L 6.000 42.000 L 21.000 31.000 L 37.000 33.000 L 40.000 40.000 L 42.000 41.000 L 47.000 41.000 L 54.000 34.000 L 61.000 34.000 L 62.000 35.000 L 70.000 35.000 L 81.000 43.000 L 88.000 43.000 L 97.000 54.000 L 106.000 54.000 L 105.000 48.000 L 107.000 46.000 L 107.000 29.000 L 106.000 28.000 L 106.000 8.000 L 104.000 5.000 L 104.000 1.000 L 6.000 0.000 Z",
    "province": "REGION_61",
    "rootTerritory": "REGION_61",
    "viewBox": "0 0 107 54",
    "unitSlots": [
      {
        "name": "main",
        "x": 49,
        "y": 7,
        "territory": "REGION_61",
        "arrowReceiver": {
          "x": 49,
          "y": 37
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 49,
        "y": 7,
        "territory": "REGION_61",
        "arrowReceiver": {
          "x": 49,
          "y": 37
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_68": {
    "abbr": "SPO",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 192,
        "y": 181,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 367,
    "height": 676,
    "x": 0,
    "y": 1152,
    "playable": true,
    "path": "M 0.00 18.00 L 0.00 648.00 L 9.00 649.00 L 10.00 650.00 L 15.00 650.00 L 16.00 651.00 L 21.00 651.00 L 22.00 652.00 L 38.00 653.00 L 43.00 655.00 L 58.00 656.00 L 59.00 657.00 L 64.00 657.00 L 65.00 658.00 L 75.00 659.00 L 76.00 660.00 L 81.00 660.00 L 82.00 661.00 L 87.00 661.00 L 88.00 662.00 L 97.00 662.00 L 98.00 663.00 L 102.00 663.00 L 103.00 664.00 L 109.00 664.00 L 114.00 666.00 L 120.00 666.00 L 121.00 667.00 L 127.00 667.00 L 128.00 668.00 L 148.00 670.00 L 149.00 671.00 L 154.00 671.00 L 155.00 672.00 L 160.00 672.00 L 161.00 673.00 L 192.00 676.00 L 191.00 668.00 L 190.00 667.00 L 190.00 662.00 L 189.00 661.00 L 189.00 656.00 L 188.00 655.00 L 188.00 651.00 L 187.00 650.00 L 187.00 647.00 L 185.00 642.00 L 185.00 638.00 L 184.00 637.00 L 184.00 630.00 L 182.00 625.00 L 182.00 620.00 L 181.00 619.00 L 181.00 615.00 L 180.00 614.00 L 180.00 610.00 L 179.00 609.00 L 179.00 602.00 L 178.00 601.00 L 178.00 597.00 L 177.00 596.00 L 177.00 593.00 L 175.00 588.00 L 175.00 584.00 L 174.00 583.00 L 172.00 569.00 L 170.00 568.00 L 163.00 568.00 L 162.00 567.00 L 157.00 567.00 L 156.00 566.00 L 150.00 566.00 L 149.00 565.00 L 140.00 564.00 L 135.00 556.00 L 138.00 497.00 L 139.00 496.00 L 156.00 495.00 L 159.00 493.00 L 165.00 493.00 L 163.00 443.00 L 160.00 438.00 L 162.00 422.00 L 159.00 417.00 L 161.00 355.00 L 162.00 354.00 L 201.00 355.00 L 202.00 356.00 L 213.00 356.00 L 214.00 357.00 L 224.00 357.00 L 225.00 358.00 L 237.00 358.00 L 246.00 363.00 L 277.00 362.00 L 280.00 364.00 L 313.00 365.00 L 314.00 366.00 L 324.00 366.00 L 327.00 368.00 L 343.00 368.00 L 344.00 369.00 L 352.00 369.00 L 353.00 370.00 L 363.00 371.00 L 364.00 329.00 L 365.00 328.00 L 365.00 303.00 L 366.00 302.00 L 366.00 279.00 L 367.00 278.00 L 367.00 61.00 L 330.00 61.00 L 329.00 60.00 L 329.00 18.00 L 330.00 17.00 L 327.00 15.00 L 318.00 16.00 L 317.00 15.00 L 299.00 14.00 L 298.00 13.00 L 284.00 13.00 L 283.00 12.00 L 279.00 12.00 L 278.00 11.00 L 248.00 10.00 L 247.00 9.00 L 231.00 8.00 L 230.00 7.00 L 207.00 6.00 L 206.00 5.00 L 191.00 4.00 L 190.00 3.00 L 173.00 3.00 L 172.00 2.00 L 161.00 2.00 L 160.00 1.00 L 155.00 1.00 L 154.00 0.00 L 148.00 0.00 L 145.00 13.00 L 141.00 17.00 Z",
    "province": "REGION_68",
    "rootTerritory": "REGION_68",
    "viewBox": "0 0 367 676",
    "unitSlots": [
      {
        "name": "main",
        "x": 187,
        "y": 66,
        "territory": "REGION_68",
        "arrowReceiver": {
          "x": 187,
          "y": 96
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 187,
        "y": 66,
        "territory": "REGION_68",
        "arrowReceiver": {
          "x": 187,
          "y": 96
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_69": {
    "abbr": "GOG",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 118,
        "y": 52,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 191,
    "height": 107,
    "x": 366,
    "y": 1173,
    "playable": true,
    "path": "M 0.762 40.010 L 1.348 74.949 L 1.400 77.991 L 2.205 99.017 L 27.997 100.073 L 29.035 100.115 L 48.004 100.891 L 49.042 100.934 L 68.012 101.710 L 69.049 101.753 L 98.003 102.938 L 99.040 102.980 L 123.002 103.961 L 124.039 104.004 L 148.000 104.984 L 149.038 105.027 L 174.037 106.050 L 175.000 89.000 L 171.000 82.000 L 171.000 69.000 L 185.000 60.000 L 191.000 58.000 L 191.000 54.000 L 180.000 46.000 L 180.000 18.000 L 189.000 10.000 L 190.000 3.000 L 180.000 3.000 L 179.000 2.000 L 125.001 1.950 L 123.984 1.932 L 76.998 1.115 L 75.980 1.097 L 70.246 0.997 L 69.000 38.000 L 67.000 40.000 L 54.000 40.000 L 53.000 41.000 L 10.000 41.000 L 9.000 40.000 Z",
    "province": "REGION_69",
    "rootTerritory": "REGION_69",
    "viewBox": "0 0 191 107",
    "unitSlots": [
      {
        "name": "main",
        "x": 97,
        "y": 54,
        "territory": "REGION_69",
        "arrowReceiver": {
          "x": 97,
          "y": 84
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 97,
        "y": 54,
        "territory": "REGION_69",
        "arrowReceiver": {
          "x": 97,
          "y": 84
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_70": {
    "abbr": "MEB",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 244,
        "y": 49,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 343,
    "height": 93,
    "x": 363,
    "y": 1441,
    "playable": true,
    "path": "M 3.403 0.454 L 0.067 82.081 L 31.991 83.319 L 33.019 83.349 L 67.989 84.369 L 69.017 84.399 L 141.985 86.528 L 143.013 86.557 L 174.986 87.490 L 176.014 87.520 L 202.992 88.307 L 204.020 88.337 L 239.988 89.387 L 241.017 89.417 L 279.984 90.553 L 281.012 90.583 L 313.984 91.545 L 315.012 91.575 L 331.991 92.071 L 333.000 83.000 L 342.000 67.000 L 341.000 48.000 L 342.000 47.000 L 343.000 27.000 L 331.000 11.000 L 323.000 5.000 L 313.000 5.000 L 309.000 9.000 L 266.000 9.000 L 265.000 8.000 L 205.000 8.000 L 204.000 7.000 L 81.000 6.000 L 80.000 5.000 L 44.000 5.000 L 43.000 4.000 L 18.000 3.000 L 17.000 2.000 L 9.000 2.000 L 3.403 0.454 Z",
    "province": "REGION_70",
    "rootTerritory": "REGION_70",
    "viewBox": "0 0 343 93",
    "unitSlots": [
      {
        "name": "main",
        "x": 170,
        "y": 26,
        "territory": "REGION_70",
        "arrowReceiver": {
          "x": 170,
          "y": 56
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 170,
        "y": 26,
        "territory": "REGION_70",
        "arrowReceiver": {
          "x": 170,
          "y": 56
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_71": {
    "abbr": "HUC",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 149,
        "y": 98,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 537,
    "height": 198,
    "x": 158,
    "y": 1505,
    "playable": true,
    "path": "M 6.000 140.000 L 16.000 140.000 L 17.000 142.000 L 59.000 142.000 L 62.000 147.000 L 62.000 158.000 L 55.000 165.000 L 55.000 169.000 L 60.000 174.000 L 64.000 176.000 L 71.000 176.000 L 72.000 177.000 L 86.000 177.000 L 87.000 178.000 L 123.000 180.000 L 134.000 186.000 L 189.000 185.000 L 202.000 190.000 L 247.000 191.000 L 248.000 192.000 L 261.000 192.000 L 262.000 193.000 L 306.000 191.000 L 315.000 196.000 L 466.000 198.000 L 485.000 175.000 L 488.000 175.000 L 488.000 173.000 L 493.000 164.000 L 492.000 154.000 L 505.000 137.000 L 512.000 107.000 L 515.000 102.000 L 515.000 89.000 L 534.000 52.000 L 536.991 28.071 L 469.996 26.116 L 468.971 26.086 L 445.988 25.416 L 444.963 25.386 L 425.978 24.832 L 424.952 24.802 L 367.997 23.141 L 366.972 23.111 L 330.999 22.061 L 329.974 22.031 L 221.031 18.853 L 217.982 18.764 L 205.067 18.081 L 205.067 18.081 L 171.000 14.000 L 168.000 12.000 L 158.000 12.000 L 157.000 11.000 L 124.000 10.000 L 121.000 8.000 L 90.000 9.000 L 81.000 4.000 L 69.000 4.000 L 68.000 3.000 L 46.000 2.000 L 45.000 1.000 L 2.000 0.000 L 0.000 66.000 L 3.000 71.000 L 1.000 87.000 L 4.000 92.000 Z",
    "province": "REGION_71",
    "rootTerritory": "REGION_71",
    "viewBox": "0 0 537 198",
    "unitSlots": [
      {
        "name": "main",
        "x": 268,
        "y": 25,
        "territory": "REGION_71",
        "arrowReceiver": {
          "x": 268,
          "y": 55
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 268,
        "y": 25,
        "territory": "REGION_71",
        "arrowReceiver": {
          "x": 268,
          "y": 55
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_72": {
    "abbr": "RDP",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 104,
        "y": 48,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 166,
    "height": 101,
    "x": 828,
    "y": 1657,
    "playable": true,
    "path": "M 166.000 0.000 L 130.000 0.000 L 119.000 5.000 L 89.000 5.000 L 80.000 11.000 L 60.000 12.000 L 55.000 15.000 L 45.000 15.000 L 44.000 14.000 L 27.000 14.000 L 26.000 15.000 L 24.000 13.000 L 22.000 13.000 L 20.000 15.000 L 21.000 25.000 L 9.000 39.000 L 2.216 45.271 L 2.216 45.271 L 2.216 45.271 L 1.435 68.948 L 1.202 76.007 L 1.004 82.000 L 0.903 85.063 L 0.408 100.047 L 11.000 100.000 L 12.000 99.000 L 24.000 99.000 L 25.000 98.000 L 38.000 99.000 L 41.000 96.000 L 71.000 95.000 L 74.000 93.000 L 87.000 95.000 L 91.000 92.000 L 119.000 91.000 L 126.000 87.000 L 154.000 84.000 L 157.000 78.000 L 158.000 50.000 L 162.000 43.000 L 163.000 7.000 L 166.000 3.000 Z",
    "province": "REGION_72",
    "rootTerritory": "REGION_72",
    "viewBox": "0 0 166 101",
    "unitSlots": [
      {
        "name": "main",
        "x": 76,
        "y": 76,
        "territory": "REGION_72",
        "arrowReceiver": {
          "x": 76,
          "y": 106
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 76,
        "y": 76,
        "territory": "REGION_72",
        "arrowReceiver": {
          "x": 76,
          "y": 106
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_75": {
    "abbr": "BLK",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 95,
        "y": 58,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 130,
    "height": 95,
    "x": 700,
    "y": 1702,
    "playable": true,
    "path": "M 130.00 0.00 L 126.00 4.00 L 124.00 4.00 L 123.00 5.00 L 123.00 7.00 L 113.00 16.00 L 111.00 16.00 L 107.00 18.00 L 104.00 18.00 L 100.00 20.00 L 84.00 19.00 L 73.00 36.00 L 71.00 38.00 L 62.00 43.00 L 40.00 42.00 L 37.00 45.00 L 38.00 60.00 L 30.00 64.00 L 14.00 82.00 L 3.00 87.00 L 0.00 90.00 L 0.00 93.00 L 7.00 93.00 L 10.00 95.00 L 15.00 95.00 L 18.00 93.00 L 25.00 93.00 L 26.00 92.00 L 53.00 92.00 L 54.00 91.00 L 96.00 90.00 L 97.00 89.00 L 108.00 89.00 L 109.00 88.00 L 118.00 88.00 L 119.00 89.00 L 118.00 93.00 L 120.00 93.00 L 121.00 88.00 L 123.00 84.00 L 124.00 67.00 L 128.00 60.00 L 128.00 51.00 L 129.00 50.00 L 129.00 13.00 L 130.00 12.00 Z",
    "province": "REGION_75",
    "rootTerritory": "REGION_75",
    "viewBox": "0 0 130 95",
    "unitSlots": [
      {
        "name": "main",
        "x": 62,
        "y": 81,
        "territory": "REGION_75",
        "arrowReceiver": {
          "x": 62,
          "y": 111
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 62,
        "y": 81,
        "territory": "REGION_75",
        "arrowReceiver": {
          "x": 62,
          "y": 111
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_77": {
    "abbr": "DRA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 1229,
        "y": 86,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 1294,
    "height": 151,
    "x": 0,
    "y": 1768,
    "playable": true,
    "path": "M 1294.000 0.000 L 1280.000 0.000 L 1262.000 10.000 L 1238.000 14.000 L 1223.000 22.000 L 1204.000 23.000 L 1130.000 45.000 L 1106.000 44.000 L 1068.000 55.000 L 1031.000 57.000 L 1028.000 59.000 L 1017.000 59.000 L 1014.000 61.000 L 991.000 62.000 L 988.000 64.000 L 980.000 64.000 L 979.000 65.000 L 976.000 65.000 L 973.000 63.000 L 961.000 63.000 L 958.000 67.000 L 944.000 68.000 L 943.000 69.000 L 910.000 70.000 L 909.000 71.000 L 900.000 71.000 L 897.000 73.000 L 878.000 73.000 L 875.000 75.000 L 837.000 77.000 L 837.000 112.000 L 835.000 114.000 L 750.000 114.000 L 746.000 108.000 L 746.953 91.005 L 695.464 95.972 L 695.464 95.972 L 682.000 98.000 L 673.000 109.000 L 658.000 109.000 L 649.000 104.000 L 629.000 105.000 L 628.000 106.000 L 624.000 106.000 L 623.000 104.000 L 606.000 105.000 L 603.000 102.000 L 589.000 103.000 L 587.000 100.000 L 578.000 101.000 L 577.000 98.000 L 563.000 97.000 L 562.000 96.000 L 511.000 94.000 L 510.000 93.000 L 500.000 93.000 L 499.000 92.000 L 457.000 91.000 L 456.000 90.000 L 434.000 89.000 L 433.000 88.000 L 412.000 88.000 L 411.000 87.000 L 401.000 87.000 L 400.000 86.000 L 390.000 86.000 L 389.000 85.000 L 350.000 84.000 L 349.000 83.000 L 340.000 83.000 L 339.000 82.000 L 298.000 81.000 L 297.000 80.000 L 244.000 77.000 L 243.000 76.000 L 205.000 75.000 L 194.000 72.000 L 193.000 71.000 L 192.227 60.175 L 187.798 60.337 L 174.110 58.273 L 152.692 55.044 L 114.116 49.228 L 93.971 46.191 L 90.743 45.704 L 69.085 42.439 L 63.753 41.635 L 50.065 39.571 L 46.836 39.085 L 38.037 37.758 L 33.831 37.124 L 23.758 35.605 L 0.070 32.034 L 0.000 151.000 L 1294.000 151.000 Z",
    "province": "REGION_77",
    "rootTerritory": "REGION_77",
    "viewBox": "0 0 1294 151",
    "unitSlots": [
      {
        "name": "main",
        "x": 648,
        "y": 104,
        "territory": "REGION_77",
        "arrowReceiver": {
          "x": 648,
          "y": 134
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 648,
        "y": 104,
        "territory": "REGION_77",
        "arrowReceiver": {
          "x": 648,
          "y": 134
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_80": {
    "abbr": "BRS",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 71,
        "y": 70,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 188,
    "height": 204,
    "x": -1,
    "y": 0,
    "playable": true,
    "path": "M 188.000 0.000 L 1.000 0.000 L 0.258 203.674 L 7.289 202.281 L 16.222 199.836 L 27.709 196.693 L 54.319 189.411 L 66.052 186.201 L 78.423 182.815 L 84.258 181.218 L 84.258 181.218 L 94.000 170.000 L 94.000 162.000 L 103.000 156.000 L 107.000 147.000 L 120.000 134.000 L 121.000 125.000 L 125.000 120.000 L 140.000 89.000 L 148.000 78.000 L 162.000 49.000 L 169.000 40.000 L 188.000 2.000 Z",
    "province": "REGION_80",
    "rootTerritory": "REGION_80",
    "viewBox": "0 0 188 204",
    "unitSlots": [
      {
        "name": "main",
        "x": 102,
        "y": 4,
        "territory": "REGION_80",
        "arrowReceiver": {
          "x": 102,
          "y": 34
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 102,
        "y": 4,
        "territory": "REGION_80",
        "arrowReceiver": {
          "x": 102,
          "y": 34
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_81": {
    "abbr": "BES",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 223,
        "y": 52,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 313,
    "height": 132,
    "x": 118,
    "y": 0,
    "playable": true,
    "path": "M 0.00 132.00 L 2.00 132.00 L 4.00 129.00 L 19.00 127.00 L 28.00 122.00 L 50.00 123.00 L 60.00 115.00 L 60.00 108.00 L 64.00 104.00 L 72.00 102.00 L 76.00 97.00 L 94.00 99.00 L 123.00 81.00 L 168.00 79.00 L 169.00 78.00 L 175.00 78.00 L 181.00 82.00 L 180.00 92.00 L 186.00 98.00 L 191.00 101.00 L 193.00 104.00 L 194.00 114.00 L 197.00 116.00 L 211.00 116.00 L 216.00 119.00 L 245.00 120.00 L 259.00 91.00 L 271.00 76.00 L 282.00 53.00 L 290.00 43.00 L 297.00 28.00 L 305.00 18.00 L 313.00 2.00 L 313.00 0.00 L 68.00 0.00 L 49.00 38.00 L 42.00 47.00 L 28.00 76.00 L 20.00 87.00 L 5.00 118.00 L 1.00 123.00 Z",
    "province": "REGION_81",
    "rootTerritory": "REGION_81",
    "viewBox": "0 0 313 132",
    "unitSlots": [
      {
        "name": "main",
        "x": 192,
        "y": 7,
        "territory": "REGION_81",
        "arrowReceiver": {
          "x": 192,
          "y": 37
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 192,
        "y": 7,
        "territory": "REGION_81",
        "arrowReceiver": {
          "x": 192,
          "y": 37
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_82": {
    "abbr": "NAO",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 350,
        "y": 450,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 559,
    "height": 691,
    "x": 735,
    "y": 0,
    "playable": true,
    "path": "M 0.000 0.000 L 3.000 6.000 L 9.000 13.000 L 15.000 26.000 L 27.000 42.000 L 44.000 61.000 L 54.000 62.000 L 59.000 65.000 L 66.000 66.000 L 74.000 75.000 L 95.000 80.000 L 105.000 94.000 L 125.000 111.000 L 131.000 114.000 L 144.000 114.000 L 160.000 123.000 L 160.000 145.000 L 150.000 153.000 L 150.000 156.000 L 152.000 159.000 L 152.000 173.000 L 142.000 181.000 L 142.000 184.000 L 150.000 199.000 L 150.000 214.000 L 158.000 222.000 L 159.000 238.000 L 155.000 242.000 L 141.000 242.000 L 136.000 239.000 L 124.000 239.000 L 123.000 240.000 L 125.000 256.000 L 132.000 273.000 L 132.000 283.000 L 134.000 286.000 L 134.000 295.000 L 138.000 305.000 L 141.000 333.000 L 142.000 334.000 L 142.000 337.000 L 146.000 348.000 L 147.000 355.000 L 149.000 359.000 L 149.000 362.000 L 150.000 363.000 L 151.000 369.000 L 154.000 377.000 L 153.000 389.000 L 152.000 390.000 L 144.000 390.000 L 144.000 400.000 L 146.000 402.000 L 145.000 403.000 L 141.000 401.000 L 125.000 401.000 L 122.000 403.000 L 121.000 402.000 L 113.364 404.773 L 113.364 404.773 L 113.364 404.773 L 101.337 415.386 L 80.672 433.623 L 70.231 442.715 L 70.231 442.715 L 70.231 442.715 L 70.210 452.995 L 70.232 453.974 L 70.529 466.969 L 70.552 467.988 L 70.780 477.984 L 70.804 479.004 L 72.194 504.156 L 80.000 504.000 L 93.000 517.000 L 96.000 523.000 L 100.000 528.000 L 122.000 572.000 L 141.000 597.000 L 151.000 617.000 L 142.778 624.328 L 145.891 629.071 L 151.358 637.412 L 153.039 639.975 L 159.725 650.174 L 167.796 662.486 L 171.287 667.812 L 172.968 670.375 L 182.850 685.449 L 187.205 690.968 L 187.205 690.968 L 187.205 690.968 L 192.815 688.891 L 193.950 688.702 L 196.869 688.213 L 202.057 687.345 L 205.949 686.694 L 211.137 685.826 L 230.919 682.516 L 232.054 682.326 L 236.919 681.512 L 238.054 681.322 L 241.945 680.671 L 243.080 680.481 L 253.944 678.663 L 255.079 678.473 L 258.970 677.822 L 260.105 677.632 L 264.970 676.818 L 266.105 676.628 L 270.969 675.814 L 272.104 675.624 L 276.969 674.810 L 278.104 674.620 L 282.968 673.806 L 284.103 673.616 L 288.967 672.802 L 290.102 672.612 L 295.940 671.636 L 297.075 671.446 L 301.939 670.632 L 303.074 670.442 L 307.938 669.628 L 309.073 669.438 L 313.938 668.624 L 315.073 668.434 L 320.909 667.457 L 322.045 667.267 L 326.909 666.454 L 328.044 666.263 L 332.908 665.450 L 334.043 665.260 L 338.907 664.446 L 340.042 664.256 L 344.907 663.442 L 346.042 663.252 L 350.906 662.438 L 352.041 662.248 L 368.904 659.426 L 374.093 658.558 L 390.956 655.736 L 396.145 654.868 L 407.981 652.888 L 409.116 652.698 L 414.954 651.721 L 416.089 651.531 L 421.926 650.554 L 423.061 650.364 L 428.898 649.388 L 430.033 649.198 L 434.898 648.384 L 436.033 648.194 L 439.924 647.543 L 441.059 647.353 L 444.951 646.701 L 446.086 646.512 L 452.895 645.372 L 454.031 645.182 L 461.002 644.016 L 462.138 643.826 L 467.974 642.849 L 469.110 642.659 L 474.947 641.682 L 476.083 641.492 L 480.946 640.678 L 482.081 640.488 L 494.891 638.345 L 496.025 638.155 L 500.890 637.341 L 502.025 637.151 L 506.889 636.337 L 508.024 636.147 L 512.889 635.333 L 514.024 635.143 L 518.888 634.330 L 520.023 634.140 L 524.888 633.326 L 526.023 633.136 L 531.860 632.159 L 532.995 631.969 L 537.859 631.155 L 538.994 630.965 L 543.859 630.151 L 544.994 629.961 L 549.858 629.147 L 550.993 628.957 L 558.958 627.625 L 558.958 627.625 L 558.958 627.625 L 559.000 0.000 Z",
    "province": "REGION_82",
    "rootTerritory": "REGION_82",
    "viewBox": "0 0 559 691",
    "unitSlots": [
      {
        "name": "main",
        "x": 276,
        "y": 1,
        "territory": "REGION_82",
        "arrowReceiver": {
          "x": 276,
          "y": 31
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 276,
        "y": 1,
        "territory": "REGION_82",
        "arrowReceiver": {
          "x": 276,
          "y": 31
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_83": {
    "abbr": "LBS",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 204,
        "y": 172,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 290,
    "height": 295,
    "x": 600,
    "y": 96,
    "playable": true,
    "path": "M 5.00 10.00 L 1.00 16.00 L 0.00 23.00 L 10.00 22.00 L 13.00 26.00 L 30.00 29.00 L 42.00 40.00 L 53.00 40.00 L 72.00 58.00 L 74.00 69.00 L 80.00 75.00 L 83.00 76.00 L 90.00 83.00 L 105.00 84.00 L 111.00 88.00 L 111.00 96.00 L 121.00 115.00 L 121.00 129.00 L 115.00 133.00 L 114.00 138.00 L 111.00 142.00 L 97.00 142.00 L 90.00 138.00 L 85.00 138.00 L 75.00 146.00 L 84.00 162.00 L 84.00 174.00 L 93.00 178.00 L 102.00 186.00 L 120.00 187.00 L 130.00 181.00 L 131.00 175.00 L 135.00 170.00 L 145.00 178.00 L 145.00 183.00 L 165.00 201.00 L 170.00 211.00 L 178.00 213.00 L 188.00 222.00 L 203.00 223.00 L 208.00 231.00 L 220.00 233.00 L 232.00 239.00 L 235.00 242.00 L 237.00 246.00 L 237.00 248.00 L 239.00 251.00 L 239.00 253.00 L 245.00 266.00 L 246.00 271.00 L 249.00 276.00 L 249.00 278.00 L 253.00 286.00 L 256.00 287.00 L 261.00 292.00 L 277.00 293.00 L 280.00 295.00 L 289.00 295.00 L 290.00 279.00 L 289.00 278.00 L 289.00 275.00 L 287.00 272.00 L 287.00 268.00 L 285.00 265.00 L 285.00 261.00 L 283.00 258.00 L 283.00 253.00 L 280.00 248.00 L 280.00 242.00 L 277.00 237.00 L 274.00 206.00 L 270.00 199.00 L 270.00 188.00 L 268.00 185.00 L 268.00 173.00 L 261.00 160.00 L 259.00 144.00 L 249.00 144.00 L 246.00 139.00 L 234.00 134.00 L 226.00 124.00 L 215.00 119.00 L 208.00 108.00 L 200.00 106.00 L 186.00 92.00 L 185.00 92.00 L 171.00 78.00 L 172.00 61.00 L 168.00 57.00 L 151.00 53.00 L 146.00 45.00 L 128.00 40.00 L 114.00 25.00 L 106.00 23.00 L 101.00 17.00 L 93.00 17.00 L 85.00 10.00 L 81.00 10.00 L 78.00 12.00 L 58.00 12.00 L 48.00 5.00 L 45.00 5.00 L 44.00 4.00 L 37.00 4.00 L 36.00 3.00 L 29.00 3.00 L 28.00 2.00 L 25.00 2.00 L 23.00 0.00 L 19.00 0.00 L 17.00 5.00 L 12.00 9.00 Z",
    "province": "REGION_83",
    "rootTerritory": "REGION_83",
    "viewBox": "0 0 290 295",
    "unitSlots": [
      {
        "name": "main",
        "x": 160,
        "y": 141,
        "territory": "REGION_83",
        "arrowReceiver": {
          "x": 160,
          "y": 171
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 160,
        "y": 141,
        "territory": "REGION_83",
        "arrowReceiver": {
          "x": 160,
          "y": 171
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_84": {
    "abbr": "GOA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 35,
        "y": 156,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 88,
    "height": 187,
    "x": 75,
    "y": 177,
    "playable": true,
    "path": "M 77.00 0.00 L 67.00 2.00 L 59.00 7.00 L 45.00 7.00 L 43.00 12.00 L 32.00 21.00 L 32.00 48.00 L 28.00 51.00 L 25.00 78.00 L 20.00 87.00 L 19.00 105.00 L 7.00 129.00 L 7.00 148.00 L 1.00 159.00 L 0.00 177.00 L 7.00 181.00 L 15.00 181.00 L 30.00 186.00 L 49.00 187.00 L 51.00 184.00 L 65.00 175.00 L 66.00 173.00 L 67.00 165.00 L 65.00 159.00 L 65.00 140.00 L 73.00 125.00 L 75.00 86.00 L 83.00 78.00 L 85.00 32.00 L 88.00 27.00 L 88.00 21.00 L 85.00 18.00 L 84.00 6.00 Z",
    "province": "REGION_84",
    "rootTerritory": "REGION_84",
    "viewBox": "0 0 88 187",
    "unitSlots": [
      {
        "name": "main",
        "x": 39,
        "y": 169,
        "territory": "REGION_84",
        "arrowReceiver": {
          "x": 39,
          "y": 199
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 39,
        "y": 169,
        "territory": "REGION_84",
        "arrowReceiver": {
          "x": 39,
          "y": 199
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_85": {
    "abbr": "NPO",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 52,
        "y": 61,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 124,
    "height": 870,
    "x": -1,
    "y": 181,
    "playable": true,
    "path": "M 84.258 0.218 L 64.430 5.644 L 52.699 8.855 L 26.088 16.137 L 14.602 19.280 L 7.289 21.281 L 0.258 22.674 L 1.065 864.149 L 35.903 867.910 L 39.293 868.276 L 46.247 869.027 L 46.247 869.027 L 54.000 869.000 L 57.092 860.236 L 59.366 836.034 L 60.315 825.935 L 61.246 816.024 L 61.543 812.862 L 63.973 786.998 L 64.457 781.855 L 66.794 756.980 L 66.896 755.896 L 69.521 727.955 L 69.623 726.870 L 71.300 709.029 L 71.597 705.867 L 73.748 682.977 L 74.138 678.825 L 77.407 644.039 L 77.890 638.895 L 79.948 616.995 L 80.431 611.852 L 81.828 596.984 L 81.930 595.899 L 85.301 560.028 L 85.598 556.867 L 86.250 549.929 L 86.352 548.844 L 86.881 543.215 L 78.000 538.000 L 56.000 538.000 L 39.000 531.000 L 41.000 495.000 L 46.000 486.000 L 45.000 474.000 L 49.000 470.000 L 50.000 441.000 L 56.000 430.000 L 56.000 397.000 L 62.000 383.000 L 62.000 379.000 L 60.000 377.000 L 61.000 376.000 L 63.000 359.000 L 56.000 346.000 L 56.000 327.000 L 60.000 320.000 L 58.000 297.000 L 62.000 290.000 L 63.000 281.000 L 72.000 269.000 L 85.000 238.000 L 91.000 233.000 L 104.000 217.000 L 104.000 213.000 L 114.000 205.000 L 124.000 185.000 L 124.000 182.000 L 108.000 181.000 L 93.000 176.000 L 85.000 176.000 L 77.000 171.000 L 78.000 157.000 L 84.000 146.000 L 84.000 127.000 L 96.000 103.000 L 97.000 85.000 L 102.000 76.000 L 105.000 49.000 L 109.000 46.000 L 109.000 18.000 L 98.000 18.000 L 97.000 17.000 L 86.000 17.000 L 82.000 14.000 Z",
    "province": "REGION_85",
    "rootTerritory": "REGION_85",
    "viewBox": "0 0 124 870",
    "unitSlots": [
      {
        "name": "main",
        "x": 64,
        "y": 185,
        "territory": "REGION_85",
        "arrowReceiver": {
          "x": 64,
          "y": 215
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 64,
        "y": 185,
        "territory": "REGION_85",
        "arrowReceiver": {
          "x": 64,
          "y": 215
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_86": {
    "abbr": "GSL",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 67,
        "y": 59,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 122,
    "height": 99,
    "x": 731,
    "y": 344,
    "playable": true,
    "path": "M 121.854 38.257 L 121.854 38.257 L 116.819 25.462 L 115.529 22.186 L 114.846 20.451 L 112.059 13.368 L 109.879 7.828 L 106.834 0.091 L 106.834 0.091 L 106.834 0.091 L 106.834 0.091 L 97.000 8.000 L 89.000 8.000 L 75.000 26.000 L 12.000 26.000 L 0.000 41.000 L 0.000 54.000 L 1.000 55.000 L 24.000 55.000 L 31.000 51.000 L 35.000 54.000 L 31.000 57.000 L 30.000 80.000 L 37.000 83.000 L 44.444 94.384 L 67.558 97.638 L 74.231 98.715 L 91.019 84.022 L 91.583 83.524 L 98.989 76.988 L 99.554 76.490 L 117.364 60.773 L 116.000 55.000 L 117.000 54.000 L 121.854 38.257 Z",
    "province": "REGION_86",
    "rootTerritory": "REGION_86",
    "viewBox": "0 0 122 99",
    "unitSlots": [
      {
        "name": "main",
        "x": 56,
        "y": 34,
        "territory": "REGION_86",
        "arrowReceiver": {
          "x": 56,
          "y": 64
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 56,
        "y": 34,
        "territory": "REGION_86",
        "arrowReceiver": {
          "x": 56,
          "y": 64
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_88": {
    "abbr": "BTR",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 74,
        "y": 79,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 149,
    "height": 125,
    "x": 738,
    "y": 503,
    "playable": true,
    "path": "M 149.000 112.000 L 139.000 92.000 L 120.000 67.000 L 101.000 28.000 L 94.000 18.000 L 93.000 15.000 L 79.000 0.000 L 75.000 0.000 L 74.000 1.000 L 69.194 1.156 L 63.671 9.790 L 54.414 24.264 L 49.166 32.468 L 42.595 42.741 L 40.942 45.326 L 32.998 57.551 L 0.954 124.348 L 64.979 123.101 L 66.002 123.077 L 95.985 122.367 L 97.008 122.342 L 139.778 121.328 L 139.778 121.328 L 149.000 120.000 Z",
    "province": "REGION_88",
    "rootTerritory": "REGION_88",
    "viewBox": "0 0 149 125",
    "unitSlots": [
      {
        "name": "main",
        "x": 70,
        "y": 108,
        "territory": "REGION_88",
        "arrowReceiver": {
          "x": 70,
          "y": 138
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 70,
        "y": 108,
        "territory": "REGION_88",
        "arrowReceiver": {
          "x": 70,
          "y": 138
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_90": {
    "abbr": "ACB",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 47,
        "y": 72,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 157,
    "height": 129,
    "x": 148,
    "y": 814,
    "playable": true,
    "path": "M 9.117 3.876 L 6.000 54.000 L 4.000 57.000 L 4.000 65.000 L 1.000 70.000 L 1.000 88.000 L 0.000 89.000 L 0.000 109.000 L 1.000 110.000 L 18.000 115.000 L 76.000 118.000 L 85.000 123.000 L 93.000 123.000 L 96.000 125.000 L 114.000 125.000 L 117.000 127.000 L 153.013 128.947 L 155.844 86.060 L 156.160 81.274 L 156.160 81.274 L 127.000 63.000 L 108.000 56.000 L 91.000 43.000 L 72.000 35.000 L 50.000 11.000 L 40.860 0.163 L 40.860 0.163 L 36.829 0.634 Z",
    "province": "REGION_90",
    "rootTerritory": "REGION_90",
    "viewBox": "0 0 157 129",
    "unitSlots": [
      {
        "name": "main",
        "x": 81,
        "y": 91,
        "territory": "REGION_90",
        "arrowReceiver": {
          "x": 81,
          "y": 121
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 81,
        "y": 91,
        "territory": "REGION_90",
        "arrowReceiver": {
          "x": 81,
          "y": 121
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_91": {
    "abbr": "BOC",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 40,
        "y": 28,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 97,
    "height": 56,
    "x": 315,
    "y": 806,
    "playable": true,
    "path": "M 1.072 0.737 L 0.000 10.000 L 2.000 12.000 L 3.000 23.000 L 5.000 27.000 L 31.000 53.000 L 35.000 53.000 L 36.000 56.000 L 39.000 56.000 L 40.000 54.000 L 49.000 53.000 L 55.000 50.000 L 56.000 48.000 L 69.000 48.000 L 73.000 52.000 L 73.000 54.000 L 77.000 54.000 L 78.000 47.000 L 89.000 38.000 L 96.851 10.082 L 64.011 6.878 L 60.851 6.570 L 44.006 4.926 L 38.865 4.424 L 28.957 3.458 L 27.872 3.352 Z",
    "province": "REGION_91",
    "rootTerritory": "REGION_91",
    "viewBox": "0 0 97 56",
    "unitSlots": [
      {
        "name": "main",
        "x": 51,
        "y": 9,
        "territory": "REGION_91",
        "arrowReceiver": {
          "x": 51,
          "y": 39
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 51,
        "y": 9,
        "territory": "REGION_91",
        "arrowReceiver": {
          "x": 51,
          "y": 39
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_92": {
    "abbr": "JAM",
    "type": "Coast",
    "centerPos": {
      "x": 18,
      "y": 16
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 35,
        "y": 9,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 68,
    "height": 44,
    "x": 597,
    "y": 869,
    "playable": true,
    "path": "M 0.00 9.00 L 2.00 42.00 L 17.00 42.00 L 18.00 43.00 L 29.00 43.00 L 30.00 44.00 L 35.00 43.00 L 67.00 44.00 L 68.00 43.00 L 68.00 16.00 L 67.00 15.00 L 68.00 9.00 L 61.00 9.00 L 56.00 0.00 L 13.00 0.00 L 12.00 3.00 L 5.00 9.00 Z",
    "province": "REGION_92",
    "rootTerritory": "REGION_92",
    "viewBox": "0 0 68 44",
    "unitSlots": [
      {
        "name": "main",
        "x": 28,
        "y": 2,
        "territory": "REGION_92",
        "arrowReceiver": {
          "x": 28,
          "y": 32
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 28,
        "y": 2,
        "territory": "REGION_92",
        "arrowReceiver": {
          "x": 28,
          "y": 32
        }
      }
    },
    "texture": {
      "texture": "#A8ABCE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_93": {
    "abbr": "GOH",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 34,
        "y": 22,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 58,
    "height": 44,
    "x": 443,
    "y": 861,
    "playable": true,
    "path": "M 0.00 44.00 L 57.00 42.00 L 56.00 30.00 L 58.00 27.00 L 58.00 12.00 L 54.00 4.00 L 50.00 1.00 L 20.00 0.00 L 20.00 3.00 L 16.00 10.00 L 11.00 10.00 L 8.00 17.00 L 7.00 30.00 L 1.00 35.00 Z",
    "province": "REGION_93",
    "rootTerritory": "REGION_93",
    "viewBox": "0 0 58 44",
    "unitSlots": [
      {
        "name": "main",
        "x": 28,
        "y": 37,
        "territory": "REGION_93",
        "arrowReceiver": {
          "x": 28,
          "y": 67
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 28,
        "y": 37,
        "territory": "REGION_93",
        "arrowReceiver": {
          "x": 28,
          "y": 67
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_95": {
    "abbr": "GOT",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 44,
        "y": 67,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 84,
    "height": 106,
    "x": 301,
    "y": 893,
    "playable": true,
    "path": "M 3.160 2.274 L 0.013 49.947 L 8.000 54.000 L 8.000 95.000 L 7.000 97.000 L 11.000 102.000 L 44.000 103.000 L 49.000 106.000 L 54.000 106.000 L 55.000 105.000 L 65.000 105.000 L 66.000 104.000 L 71.000 104.000 L 72.000 105.000 L 74.000 105.000 L 80.864 103.134 L 80.864 103.134 L 80.000 95.000 L 81.000 94.000 L 81.000 84.000 L 83.000 81.000 L 84.000 51.000 L 74.000 41.000 L 74.000 36.000 L 62.000 35.000 L 41.000 14.000 L 42.000 13.000 L 41.000 0.000 L 31.000 0.000 L 30.000 1.000 L 19.000 1.000 L 18.000 2.000 L 3.160 2.274 L 3.160 2.274 Z",
    "province": "REGION_95",
    "rootTerritory": "REGION_95",
    "viewBox": "0 0 84 106",
    "unitSlots": [
      {
        "name": "main",
        "x": 42,
        "y": 86,
        "territory": "REGION_95",
        "arrowReceiver": {
          "x": 42,
          "y": 116
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 42,
        "y": 86,
        "territory": "REGION_95",
        "arrowReceiver": {
          "x": 42,
          "y": 116
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_98": {
    "abbr": "THI",
    "type": "Coast",
    "centerPos": {
      "x": -9,
      "y": 11
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 34,
        "y": 28,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 67,
    "height": 51,
    "x": 879,
    "y": 960,
    "playable": true,
    "path": "M 67.00 2.00 L 65.00 0.00 L 62.00 0.00 L 63.00 5.00 L 60.00 10.00 L 26.00 9.00 L 19.00 13.00 L 3.00 13.00 L 2.00 12.00 L 2.00 4.00 L 0.00 4.00 L 0.00 42.00 L 19.00 40.00 L 20.00 41.00 L 20.00 51.00 L 34.00 51.00 L 45.00 44.00 L 51.00 44.00 L 66.00 27.00 Z",
    "province": "REGION_98",
    "rootTerritory": "REGION_98",
    "viewBox": "0 0 67 51",
    "unitSlots": [
      {
        "name": "main",
        "x": 27,
        "y": 5,
        "territory": "REGION_98",
        "arrowReceiver": {
          "x": 27,
          "y": 35
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 27,
        "y": 5,
        "territory": "REGION_98",
        "arrowReceiver": {
          "x": 27,
          "y": 35
        }
      }
    },
    "texture": {
      "texture": "#A8ABCE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_99": {
    "abbr": "MAB",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 114,
        "y": 48,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 166,
    "height": 94,
    "x": 1055,
    "y": 1102,
    "playable": true,
    "path": "M 163.00 2.00 L 138.00 0.00 L 127.00 6.00 L 104.00 5.00 L 81.00 13.00 L 55.00 12.00 L 42.00 19.00 L 8.00 20.00 L 8.00 22.00 L 10.00 24.00 L 9.00 42.00 L 0.00 51.00 L 0.00 53.00 L 27.00 54.00 L 32.00 60.00 L 45.00 60.00 L 46.00 61.00 L 46.00 71.00 L 53.00 75.00 L 69.00 78.00 L 75.00 86.00 L 75.00 94.00 L 94.00 93.00 L 99.00 90.00 L 135.00 92.00 L 140.00 89.00 L 164.00 92.00 L 166.00 14.00 L 163.00 9.00 Z",
    "province": "REGION_99",
    "rootTerritory": "REGION_99",
    "viewBox": "0 0 166 94",
    "unitSlots": [
      {
        "name": "main",
        "x": 85,
        "y": 50,
        "territory": "REGION_99",
        "arrowReceiver": {
          "x": 85,
          "y": 80
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 85,
        "y": 50,
        "territory": "REGION_99",
        "arrowReceiver": {
          "x": 85,
          "y": 80
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_100": {
    "abbr": "TSB",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 65,
        "y": 129,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 113,
    "height": 177,
    "x": 1166,
    "y": 1229,
    "playable": true,
    "path": "M 107.073 0.130 L 84.563 3.890 L 84.000 20.000 L 78.000 32.000 L 66.000 43.000 L 37.000 95.000 L 20.000 107.000 L 18.000 110.000 L 1.000 158.000 L 0.000 176.000 L 14.000 176.000 L 17.000 174.000 L 32.000 174.000 L 35.000 172.000 L 46.000 172.000 L 47.000 171.000 L 54.000 171.000 L 55.000 172.000 L 55.000 177.000 L 71.000 176.000 L 76.000 173.000 L 87.000 172.000 L 108.000 161.000 L 109.000 122.000 L 113.000 119.000 L 113.000 99.000 L 112.000 98.000 L 112.000 88.000 L 111.000 87.000 L 113.000 6.000 Z",
    "province": "REGION_100",
    "rootTerritory": "REGION_100",
    "viewBox": "0 0 113 177",
    "unitSlots": [
      {
        "name": "main",
        "x": 51,
        "y": 147,
        "territory": "REGION_100",
        "arrowReceiver": {
          "x": 51,
          "y": 177
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 51,
        "y": 147,
        "territory": "REGION_100",
        "arrowReceiver": {
          "x": 51,
          "y": 177
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_101": {
    "abbr": "BPA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 87,
        "y": 89,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 311,
    "height": 179,
    "x": 366,
    "y": 1272,
    "playable": true,
    "path": "M 2.205 0.017 L 1.441 81.996 L 1.430 83.003 L 0.403 169.454 L 0.403 169.454 L 0.403 169.454 L 9.000 170.000 L 13.000 173.000 L 25.000 173.000 L 26.000 174.000 L 38.000 174.000 L 39.000 175.000 L 75.000 175.000 L 76.000 176.000 L 199.000 177.000 L 200.000 178.000 L 260.000 178.000 L 261.000 179.000 L 308.000 179.000 L 311.000 177.000 L 311.000 174.000 L 302.000 175.000 L 295.000 166.000 L 276.000 158.000 L 274.000 155.000 L 271.000 155.000 L 249.000 135.000 L 249.000 120.000 L 225.000 92.000 L 223.000 88.000 L 223.000 78.000 L 219.000 70.000 L 219.000 65.000 L 218.000 64.000 L 218.000 62.000 L 211.000 48.000 L 209.000 46.000 L 204.000 35.000 L 174.037 7.050 Z",
    "province": "REGION_101",
    "rootTerritory": "REGION_101",
    "viewBox": "0 0 311 179",
    "unitSlots": [
      {
        "name": "main",
        "x": 147,
        "y": 156,
        "territory": "REGION_101",
        "arrowReceiver": {
          "x": 147,
          "y": 186
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 147,
        "y": 156,
        "territory": "REGION_101",
        "arrowReceiver": {
          "x": 147,
          "y": 186
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_102": {
    "abbr": "GUB",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 52,
        "y": 76,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 101,
    "height": 162,
    "x": 1124,
    "y": 1399,
    "playable": true,
    "path": "M 98.00 0.00 L 75.00 1.00 L 72.00 3.00 L 57.00 3.00 L 54.00 5.00 L 42.00 5.00 L 30.00 29.00 L 11.00 49.00 L 6.00 61.00 L 0.00 68.00 L 2.00 72.00 L 2.00 78.00 L 3.00 80.00 L 5.00 81.00 L 7.00 162.00 L 44.00 157.00 L 63.00 147.00 L 89.00 145.00 L 99.00 138.00 L 101.00 44.00 L 100.00 43.00 L 100.00 34.00 L 99.00 33.00 Z",
    "province": "REGION_102",
    "rootTerritory": "REGION_102",
    "viewBox": "0 0 101 162",
    "unitSlots": [
      {
        "name": "main",
        "x": 42,
        "y": 82,
        "territory": "REGION_102",
        "arrowReceiver": {
          "x": 42,
          "y": 112
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 42,
        "y": 82,
        "territory": "REGION_102",
        "arrowReceiver": {
          "x": 42,
          "y": 112
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_103": {
    "abbr": "BDP",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 146,
        "y": 101,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 213,
    "height": 183,
    "x": 918,
    "y": 1480,
    "playable": true,
    "path": "M 211.00 0.00 L 208.00 0.00 L 205.00 2.00 L 199.00 3.00 L 198.00 4.00 L 189.00 4.00 L 176.00 13.00 L 156.00 12.00 L 140.00 27.00 L 125.00 31.00 L 106.00 46.00 L 97.00 49.00 L 79.00 81.00 L 79.00 84.00 L 78.00 85.00 L 78.00 88.00 L 77.00 89.00 L 76.00 94.00 L 66.00 103.00 L 63.00 104.00 L 44.00 122.00 L 36.00 123.00 L 29.00 132.00 L 18.00 137.00 L 6.00 151.00 L 8.00 170.00 L 5.00 176.00 L 0.00 181.00 L 0.00 183.00 L 32.00 183.00 L 41.00 178.00 L 79.00 178.00 L 82.00 176.00 L 90.00 176.00 L 93.00 174.00 L 136.00 173.00 L 140.00 169.00 L 178.00 166.00 L 182.00 164.00 L 185.00 164.00 L 186.00 163.00 L 206.00 157.00 L 210.00 152.00 L 209.00 119.00 L 213.00 112.00 Z",
    "province": "REGION_103",
    "rootTerritory": "REGION_103",
    "viewBox": "0 0 213 183",
    "unitSlots": [
      {
        "name": "main",
        "x": 111,
        "y": 142,
        "territory": "REGION_103",
        "arrowReceiver": {
          "x": 111,
          "y": 172
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 111,
        "y": 142,
        "territory": "REGION_103",
        "arrowReceiver": {
          "x": 111,
          "y": 172
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_104": {
    "abbr": "NEN",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 47,
        "y": 33,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 79,
    "height": 108,
    "x": 679,
    "y": 411,
    "playable": true,
    "path": "M 63.00 2.00 L 37.00 0.00 L 21.00 30.00 L 15.00 32.00 L 4.00 33.00 L 6.00 76.00 L 2.00 86.00 L 0.00 87.00 L 1.00 108.00 L 15.00 106.00 L 24.00 99.00 L 38.00 94.00 L 40.00 91.00 L 40.00 77.00 L 38.00 73.00 L 62.00 52.00 L 70.00 53.00 L 79.00 46.00 L 78.00 29.00 L 68.00 21.00 L 66.00 5.00 Z",
    "province": "REGION_104",
    "rootTerritory": "REGION_104",
    "viewBox": "0 0 79 108",
    "unitSlots": [
      {
        "name": "main",
        "x": 41,
        "y": 33,
        "territory": "REGION_104",
        "arrowReceiver": {
          "x": 41,
          "y": 63
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 41,
        "y": 33,
        "territory": "REGION_104",
        "arrowReceiver": {
          "x": 41,
          "y": 63
        }
      }
    },
    "texture": {
      "texture": "#A6C4E7",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_106": {
    "abbr": "NYC",
    "type": "Coast",
    "centerPos": {
      "x": -6.5,
      "y": 20
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 10.5,
        "y": 13,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 21,
    "height": 49,
    "x": 660,
    "y": 496,
    "playable": true,
    "path": "M 1.00 0.00 L 0.00 14.00 L 3.00 19.00 L 3.00 29.00 L 1.00 31.00 L 0.00 35.00 L 3.00 39.00 L 3.00 49.00 L 7.00 49.00 L 15.00 42.00 L 20.00 32.00 L 20.00 26.00 L 21.00 25.00 L 20.00 2.00 L 8.00 3.00 L 5.00 0.00 Z",
    "province": "REGION_106",
    "rootTerritory": "REGION_106",
    "viewBox": "0 0 21 49",
    "unitSlots": [
      {
        "name": "main",
        "x": 13,
        "y": 11,
        "territory": "REGION_106",
        "arrowReceiver": {
          "x": 13,
          "y": 41
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 13,
        "y": 11,
        "territory": "REGION_106",
        "arrowReceiver": {
          "x": 13,
          "y": 41
        }
      }
    },
    "texture": {
      "texture": "#A6C4E7",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_107": {
    "abbr": "WDC",
    "type": "Coast",
    "centerPos": {
      "x": 11,
      "y": 5
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 54,
        "y": 22,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "nc",
        "x": 8.27,
        "y": 13.46,
        "text": "nc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "sc",
        "x": 64.15,
        "y": 45.98,
        "text": "sc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 74,
    "height": 63,
    "x": 590,
    "y": 496,
    "playable": true,
    "path": "M 0.00 7.00 L 0.00 24.00 L 3.00 28.00 L 11.00 28.00 L 15.00 32.00 L 25.00 31.00 L 31.00 29.00 L 47.00 42.00 L 50.00 49.00 L 56.00 49.00 L 61.00 54.00 L 61.00 63.00 L 63.00 63.00 L 71.00 58.00 L 74.00 52.00 L 74.00 37.00 L 72.00 35.00 L 72.00 33.00 L 74.00 31.00 L 74.00 17.00 L 71.00 12.00 L 72.00 0.00 L 53.00 1.00 L 52.00 2.00 L 11.00 0.00 L 3.00 4.00 Z",
    "province": "REGION_107",
    "rootTerritory": "REGION_107",
    "viewBox": "0 0 74 63",
    "unitSlots": [
      {
        "name": "main",
        "x": 37,
        "y": 25,
        "territory": "REGION_107",
        "arrowReceiver": {
          "x": 37,
          "y": 55
        }
      },
      {
        "name": "nc",
        "x": 8.27,
        "y": 13.46,
        "territory": "REGION_107_NORTH_COAST",
        "arrowReceiver": {
          "x": 8.27,
          "y": 43.46
        }
      },
      {
        "name": "sc",
        "x": 64.15,
        "y": 45.98,
        "territory": "REGION_107_SOUTH_COAST",
        "arrowReceiver": {
          "x": 64.15,
          "y": 75.98
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 37,
        "y": 25,
        "territory": "REGION_107",
        "arrowReceiver": {
          "x": 37,
          "y": 55
        }
      },
      "nc": {
        "name": "nc",
        "x": 8.27,
        "y": 13.46,
        "territory": "REGION_107_NORTH_COAST",
        "arrowReceiver": {
          "x": 8.27,
          "y": 43.46
        }
      },
      "sc": {
        "name": "sc",
        "x": 64.15,
        "y": 45.98,
        "territory": "REGION_107_SOUTH_COAST",
        "arrowReceiver": {
          "x": 64.15,
          "y": 75.98
        }
      }
    },
    "texture": {
      "texture": "#A6C4E7",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_109": {
    "abbr": "VIR",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 29,
        "y": 31,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 87,
    "height": 55,
    "x": 565,
    "y": 518,
    "playable": true,
    "path": "M 1.00 26.00 L 1.00 35.00 L 5.00 39.00 L 5.00 49.00 L 0.00 53.00 L 0.00 55.00 L 49.00 53.00 L 50.00 52.00 L 68.00 51.00 L 73.00 46.00 L 87.00 47.00 L 87.00 30.00 L 83.00 26.00 L 77.00 26.00 L 73.00 18.00 L 58.00 6.00 L 42.00 9.00 L 38.00 5.00 L 30.00 5.00 L 26.00 0.00 L 24.00 0.00 L 24.00 8.00 L 23.00 9.00 L 18.00 8.00 Z",
    "province": "REGION_109",
    "rootTerritory": "REGION_109",
    "viewBox": "0 0 87 55",
    "unitSlots": [
      {
        "name": "main",
        "x": 50,
        "y": 46,
        "territory": "REGION_109",
        "arrowReceiver": {
          "x": 50,
          "y": 76
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 50,
        "y": 46,
        "territory": "REGION_109",
        "arrowReceiver": {
          "x": 50,
          "y": 76
        }
      }
    },
    "texture": {
      "texture": "#A6C4E7",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_111": {
    "abbr": "CHA",
    "type": "Coast",
    "centerPos": {
      "x": 29,
      "y": 70
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 46,
        "y": 63,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 139,
    "height": 101,
    "x": 515,
    "y": 563,
    "playable": true,
    "path": "M 139.00 1.00 L 121.00 0.00 L 116.00 5.00 L 85.00 7.00 L 84.00 8.00 L 49.00 9.00 L 50.00 20.00 L 43.00 27.00 L 26.00 33.00 L 19.00 41.00 L 5.00 43.00 L 0.00 46.00 L 2.00 74.00 L 5.00 77.00 L 4.00 95.00 L 11.00 101.00 L 26.00 101.00 L 27.00 100.00 L 48.00 101.00 L 53.00 99.00 L 59.00 99.00 L 66.00 91.00 L 96.00 65.00 L 128.00 49.00 L 139.00 27.00 Z",
    "province": "REGION_111",
    "rootTerritory": "REGION_111",
    "viewBox": "0 0 139 101",
    "unitSlots": [
      {
        "name": "main",
        "x": 63,
        "y": 37,
        "territory": "REGION_111",
        "arrowReceiver": {
          "x": 63,
          "y": 67
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 63,
        "y": 37,
        "territory": "REGION_111",
        "arrowReceiver": {
          "x": 63,
          "y": 67
        }
      }
    },
    "texture": {
      "texture": "#A6C4E7",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_113": {
    "abbr": "FLL",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 81,
        "y": 25,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 111,
    "height": 92,
    "x": 468,
    "y": 657,
    "playable": true,
    "path": "M 0.00 12.00 L 0.00 14.00 L 5.00 17.00 L 30.00 21.00 L 35.00 28.00 L 51.00 28.00 L 56.00 26.00 L 60.00 34.00 L 75.00 47.00 L 74.00 60.00 L 73.00 61.00 L 73.00 74.00 L 88.00 71.00 L 99.00 88.00 L 103.00 92.00 L 105.00 92.00 L 107.00 90.00 L 108.00 80.00 L 111.00 75.00 L 111.00 70.00 L 107.00 60.00 L 106.00 46.00 L 101.00 37.00 L 101.00 25.00 L 102.00 24.00 L 110.00 24.00 L 107.00 5.00 L 105.00 3.00 L 93.00 6.00 L 88.00 6.00 L 87.00 5.00 L 60.00 6.00 L 53.00 0.00 L 50.00 0.00 L 50.00 6.00 L 49.00 7.00 L 7.00 6.00 L 7.00 11.00 L 6.00 12.00 Z",
    "province": "REGION_113",
    "rootTerritory": "REGION_113",
    "viewBox": "0 0 111 92",
    "unitSlots": [
      {
        "name": "main",
        "x": 57,
        "y": 9,
        "territory": "REGION_113",
        "arrowReceiver": {
          "x": 57,
          "y": 39
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 57,
        "y": 9,
        "territory": "REGION_113",
        "arrowReceiver": {
          "x": 57,
          "y": 39
        }
      }
    },
    "texture": {
      "texture": "#A6C4E7",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_120": {
    "abbr": "RUP",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 119,
        "y": 146,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 276,
    "height": 193,
    "x": 268,
    "y": 190,
    "playable": true,
    "path": "M 276.00 5.00 L 268.00 4.00 L 263.00 1.00 L 248.00 0.00 L 225.00 10.00 L 218.00 10.00 L 210.00 17.00 L 198.00 16.00 L 181.00 25.00 L 175.00 25.00 L 167.00 28.00 L 151.00 28.00 L 131.00 37.00 L 115.00 49.00 L 112.00 55.00 L 112.00 60.00 L 118.00 63.00 L 125.00 64.00 L 138.00 73.00 L 140.00 77.00 L 140.00 90.00 L 134.00 97.00 L 129.00 98.00 L 124.00 101.00 L 117.00 101.00 L 114.00 103.00 L 92.00 102.00 L 57.00 120.00 L 49.00 121.00 L 44.00 124.00 L 38.00 124.00 L 29.00 129.00 L 15.00 129.00 L 14.00 130.00 L 3.00 130.00 L 1.00 131.00 L 0.00 140.00 L 6.00 151.00 L 6.00 159.00 L 3.00 164.00 L 4.00 173.00 L 9.00 177.00 L 24.00 179.00 L 38.00 184.00 L 56.00 185.00 L 66.00 187.00 L 79.00 187.00 L 80.00 188.00 L 112.00 189.00 L 115.00 191.00 L 126.00 191.00 L 129.00 193.00 L 156.00 193.00 L 161.00 162.00 L 217.00 100.00 L 214.00 82.00 L 203.00 77.00 L 204.00 58.00 L 226.00 34.00 L 234.00 32.00 L 242.00 21.00 L 250.00 20.00 L 258.00 13.00 L 271.00 13.00 L 276.00 7.00 Z",
    "province": "REGION_120",
    "rootTerritory": "REGION_120",
    "viewBox": "0 0 276 193",
    "unitSlots": [
      {
        "name": "main",
        "x": 105,
        "y": 132,
        "territory": "REGION_120",
        "arrowReceiver": {
          "x": 105,
          "y": 162
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 105,
        "y": 132,
        "territory": "REGION_120",
        "arrowReceiver": {
          "x": 105,
          "y": 162
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_122": {
    "abbr": "GLB",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 63,
        "y": 58,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 136,
    "height": 110,
    "x": 139,
    "y": 254,
    "playable": true,
    "path": "M 10.00 7.00 L 8.00 46.00 L 0.00 61.00 L 0.00 84.00 L 2.00 90.00 L 4.00 90.00 L 6.00 85.00 L 29.00 85.00 L 54.00 98.00 L 79.00 100.00 L 80.00 101.00 L 86.00 101.00 L 90.00 103.00 L 100.00 103.00 L 112.00 110.00 L 135.00 110.00 L 133.00 102.00 L 136.00 97.00 L 136.00 85.00 L 130.00 74.00 L 131.00 67.00 L 110.00 66.00 L 102.00 58.00 L 104.00 40.00 L 99.00 32.00 L 87.00 24.00 L 81.00 23.00 L 55.00 14.00 L 52.00 14.00 L 46.00 11.00 L 25.00 13.00 L 18.00 9.00 L 18.00 0.00 L 16.00 0.00 Z",
    "province": "REGION_122",
    "rootTerritory": "REGION_122",
    "viewBox": "0 0 136 110",
    "unitSlots": [
      {
        "name": "main",
        "x": 62,
        "y": 82,
        "territory": "REGION_122",
        "arrowReceiver": {
          "x": 62,
          "y": 112
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 62,
        "y": 82,
        "territory": "REGION_122",
        "arrowReceiver": {
          "x": 62,
          "y": 112
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_123": {
    "abbr": "ONT",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 74,
        "y": 52,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "nc",
        "x": 163.31,
        "y": 76.61,
        "text": "nc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "sc",
        "x": 118.81,
        "y": 100.16,
        "text": "sc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 182,
    "height": 112,
    "x": 423,
    "y": 289,
    "playable": true,
    "path": "M 5.00 61.00 L 0.00 94.00 L 12.00 94.00 L 21.00 101.00 L 35.00 102.00 L 44.00 97.00 L 61.00 96.00 L 65.00 99.00 L 65.00 103.00 L 68.00 103.00 L 75.00 96.00 L 78.00 96.00 L 79.00 97.00 L 105.00 99.00 L 112.00 110.00 L 115.00 111.00 L 122.00 111.00 L 133.00 105.00 L 141.00 105.00 L 151.00 112.00 L 172.00 110.00 L 173.00 109.00 L 175.00 111.00 L 177.00 111.00 L 177.00 108.00 L 179.00 105.00 L 182.00 80.00 L 172.00 80.00 L 168.00 78.00 L 161.00 70.00 L 159.00 62.00 L 149.00 54.00 L 149.00 32.00 L 147.00 29.00 L 124.00 28.00 L 78.00 2.00 L 67.00 2.00 L 64.00 0.00 L 60.00 0.00 Z",
    "province": "REGION_123",
    "rootTerritory": "REGION_123",
    "viewBox": "0 0 182 112",
    "unitSlots": [
      {
        "name": "main",
        "x": 86,
        "y": 85,
        "territory": "REGION_123",
        "arrowReceiver": {
          "x": 86,
          "y": 115
        }
      },
      {
        "name": "nc",
        "x": 163.31,
        "y": 76.61,
        "territory": "REGION_123_NORTH_COAST",
        "arrowReceiver": {
          "x": 163.31,
          "y": 106.61
        }
      },
      {
        "name": "sc",
        "x": 118.81,
        "y": 100.16,
        "territory": "REGION_123_SOUTH_COAST",
        "arrowReceiver": {
          "x": 118.81,
          "y": 130.16
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 86,
        "y": 85,
        "territory": "REGION_123",
        "arrowReceiver": {
          "x": 86,
          "y": 115
        }
      },
      "nc": {
        "name": "nc",
        "x": 163.31,
        "y": 76.61,
        "territory": "REGION_123_NORTH_COAST",
        "arrowReceiver": {
          "x": 163.31,
          "y": 106.61
        }
      },
      "sc": {
        "name": "sc",
        "x": 118.81,
        "y": 100.16,
        "territory": "REGION_123_SOUTH_COAST",
        "arrowReceiver": {
          "x": 118.81,
          "y": 130.16
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_124": {
    "abbr": "ORE",
    "type": "Coast",
    "centerPos": {
      "x": 62,
      "y": 58
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 79,
        "y": 51,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 165,
    "height": 118,
    "x": 87,
    "y": 338,
    "playable": true,
    "path": "M 0.00 76.00 L 0.00 78.00 L 29.00 79.00 L 36.00 86.00 L 48.00 92.00 L 56.00 92.00 L 60.00 96.00 L 74.00 97.00 L 79.00 100.00 L 89.00 101.00 L 98.00 106.00 L 118.00 109.00 L 138.00 118.00 L 151.00 118.00 L 151.00 115.00 L 148.00 110.00 L 149.00 97.00 L 144.00 92.00 L 141.00 70.00 L 152.00 58.00 L 157.00 48.00 L 154.00 27.00 L 155.00 26.00 L 165.00 26.00 L 165.00 24.00 L 154.00 18.00 L 144.00 18.00 L 140.00 16.00 L 134.00 16.00 L 133.00 15.00 L 108.00 13.00 L 83.00 0.00 L 56.00 0.00 L 52.00 12.00 L 36.00 23.00 L 25.00 46.00 L 15.00 54.00 L 15.00 58.00 Z",
    "province": "REGION_124",
    "rootTerritory": "REGION_124",
    "viewBox": "0 0 165 118",
    "unitSlots": [
      {
        "name": "main",
        "x": 71,
        "y": 76,
        "territory": "REGION_124",
        "arrowReceiver": {
          "x": 71,
          "y": 106
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 71,
        "y": 76,
        "territory": "REGION_124",
        "arrowReceiver": {
          "x": 71,
          "y": 106
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_125": {
    "abbr": "DAK",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 60,
        "y": 55,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 137,
    "height": 116,
    "x": 227,
    "y": 363,
    "playable": true,
    "path": "M 13.00 0.00 L 16.00 21.00 L 11.00 31.00 L 0.00 43.00 L 3.00 69.00 L 8.00 74.00 L 7.00 87.00 L 10.00 93.00 L 12.00 94.00 L 23.00 94.00 L 31.00 100.00 L 44.00 101.00 L 50.00 106.00 L 72.00 105.00 L 84.00 110.00 L 104.00 110.00 L 116.00 115.00 L 137.00 116.00 L 137.00 114.00 L 133.00 110.00 L 132.00 100.00 L 125.00 92.00 L 126.00 74.00 L 129.00 69.00 L 127.00 54.00 L 113.00 41.00 L 111.00 13.00 L 76.00 9.00 L 71.00 6.00 L 52.00 3.00 L 49.00 0.00 Z",
    "province": "REGION_125",
    "rootTerritory": "REGION_125",
    "viewBox": "0 0 137 116",
    "unitSlots": [
      {
        "name": "main",
        "x": 63,
        "y": 44,
        "territory": "REGION_125",
        "arrowReceiver": {
          "x": 63,
          "y": 74
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 63,
        "y": 44,
        "territory": "REGION_125",
        "arrowReceiver": {
          "x": 63,
          "y": 74
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_126": {
    "abbr": "IOW",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 54,
        "y": 42,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 153,
    "height": 132,
    "x": 337,
    "y": 376,
    "playable": true,
    "path": "M 0.00 0.00 L 2.00 30.00 L 16.00 43.00 L 18.00 54.00 L 15.00 59.00 L 14.00 81.00 L 21.00 89.00 L 22.00 99.00 L 26.00 103.00 L 31.00 103.00 L 34.00 105.00 L 40.00 105.00 L 43.00 100.00 L 53.00 99.00 L 63.00 107.00 L 64.00 118.00 L 67.00 126.00 L 98.00 128.00 L 113.00 132.00 L 125.00 119.00 L 125.00 115.00 L 119.00 105.00 L 116.00 89.00 L 89.00 65.00 L 90.00 50.00 L 108.00 40.00 L 115.00 40.00 L 123.00 31.00 L 138.00 25.00 L 145.00 17.00 L 152.00 18.00 L 153.00 17.00 L 152.00 10.00 L 149.00 8.00 L 136.00 8.00 L 135.00 9.00 L 128.00 9.00 L 121.00 13.00 L 109.00 13.00 L 100.00 6.00 L 62.00 6.00 L 59.00 4.00 L 48.00 4.00 L 45.00 2.00 Z",
    "province": "REGION_126",
    "rootTerritory": "REGION_126",
    "viewBox": "0 0 153 132",
    "unitSlots": [
      {
        "name": "main",
        "x": 72,
        "y": 17,
        "territory": "REGION_126",
        "arrowReceiver": {
          "x": 72,
          "y": 47
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 72,
        "y": 17,
        "territory": "REGION_126",
        "arrowReceiver": {
          "x": 72,
          "y": 47
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_127": {
    "abbr": "TOR",
    "type": "Coast",
    "centerPos": {
      "x": 65,
      "y": 47
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 82,
        "y": 40,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 110,
    "height": 79,
    "x": 542,
    "y": 393,
    "playable": true,
    "path": "M 0.00 6.00 L 0.00 8.00 L 6.00 9.00 L 9.00 14.00 L 9.00 16.00 L 11.00 20.00 L 11.00 31.00 L 12.00 32.00 L 13.00 31.00 L 14.00 32.00 L 32.00 31.00 L 36.00 36.00 L 51.00 37.00 L 59.00 45.00 L 59.00 64.00 L 48.00 74.00 L 49.00 79.00 L 58.00 79.00 L 62.00 74.00 L 82.00 75.00 L 89.00 67.00 L 101.00 61.00 L 101.00 58.00 L 110.00 41.00 L 110.00 24.00 L 100.00 13.00 L 86.00 13.00 L 83.00 16.00 L 63.00 16.00 L 61.00 14.00 L 57.00 4.00 L 34.00 7.00 L 24.00 0.00 L 12.00 0.00 Z",
    "province": "REGION_127",
    "rootTerritory": "REGION_127",
    "viewBox": "0 0 110 79",
    "unitSlots": [
      {
        "name": "main",
        "x": 52,
        "y": 23,
        "territory": "REGION_127",
        "arrowReceiver": {
          "x": 52,
          "y": 53
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 52,
        "y": 23,
        "territory": "REGION_127",
        "arrowReceiver": {
          "x": 52,
          "y": 53
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_129": {
    "abbr": "ACA",
    "type": "Coast",
    "centerPos": {
      "x": 15,
      "y": 112
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 32,
        "y": 105,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 94,
    "height": 173,
    "x": 54,
    "y": 415,
    "playable": true,
    "path": "M 32.00 0.00 L 29.00 2.00 L 16.00 33.00 L 7.00 45.00 L 6.00 54.00 L 2.00 61.00 L 4.00 84.00 L 0.00 91.00 L 0.00 114.00 L 7.00 127.00 L 4.00 146.00 L 8.00 146.00 L 11.00 139.00 L 20.00 139.00 L 26.00 142.00 L 29.00 145.00 L 40.00 163.00 L 40.00 173.00 L 44.00 173.00 L 48.00 168.00 L 73.00 167.00 L 76.00 164.00 L 77.00 161.00 L 78.00 148.00 L 74.00 141.00 L 74.00 136.00 L 72.00 132.00 L 65.00 100.00 L 56.00 82.00 L 55.00 65.00 L 71.00 43.00 L 79.00 24.00 L 88.00 18.00 L 94.00 19.00 L 94.00 16.00 L 91.00 14.00 L 83.00 14.00 L 71.00 8.00 L 64.00 1.00 Z",
    "province": "REGION_129",
    "rootTerritory": "REGION_129",
    "viewBox": "0 0 94 173",
    "unitSlots": [
      {
        "name": "main",
        "x": 39,
        "y": 132,
        "territory": "REGION_129",
        "arrowReceiver": {
          "x": 39,
          "y": 162
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 39,
        "y": 132,
        "territory": "REGION_129",
        "arrowReceiver": {
          "x": 39,
          "y": 162
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_130": {
    "abbr": "GBD",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 54,
        "y": 53,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 170,
    "height": 120,
    "x": 108,
    "y": 432,
    "playable": true,
    "path": "M 18.00 120.00 L 20.00 120.00 L 20.00 110.00 L 21.00 109.00 L 41.00 106.00 L 50.00 101.00 L 65.00 102.00 L 70.00 99.00 L 87.00 100.00 L 136.00 75.00 L 151.00 76.00 L 159.00 38.00 L 160.00 37.00 L 170.00 37.00 L 170.00 35.00 L 165.00 31.00 L 152.00 30.00 L 144.00 24.00 L 119.00 23.00 L 99.00 14.00 L 79.00 11.00 L 70.00 6.00 L 60.00 5.00 L 55.00 2.00 L 40.00 1.00 L 39.00 0.00 L 30.00 1.00 L 24.00 5.00 L 16.00 24.00 L 0.00 46.00 L 1.00 67.00 L 10.00 85.00 Z",
    "province": "REGION_130",
    "rootTerritory": "REGION_130",
    "viewBox": "0 0 170 120",
    "unitSlots": [
      {
        "name": "main",
        "x": 79,
        "y": 44,
        "territory": "REGION_130",
        "arrowReceiver": {
          "x": 79,
          "y": 74
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 79,
        "y": 44,
        "territory": "REGION_130",
        "arrowReceiver": {
          "x": 79,
          "y": 74
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_131": {
    "abbr": "MIC",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 12,
        "y": 20,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 26,
    "height": 43,
    "x": 524,
    "y": 447,
    "playable": true,
    "path": "M 21.00 0.00 L 19.00 0.00 L 2.00 14.00 L 2.00 36.00 L 0.00 41.00 L 21.00 43.00 L 21.00 41.00 L 26.00 33.00 L 26.00 31.00 L 22.00 29.00 L 23.00 11.00 L 25.00 8.00 L 25.00 3.00 Z",
    "province": "REGION_131",
    "rootTerritory": "REGION_131",
    "viewBox": "0 0 26 43",
    "unitSlots": [
      {
        "name": "main",
        "x": 24,
        "y": 39,
        "territory": "REGION_131",
        "arrowReceiver": {
          "x": 24,
          "y": 69
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 24,
        "y": 39,
        "territory": "REGION_131",
        "arrowReceiver": {
          "x": 24,
          "y": 69
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_132": {
    "abbr": "MIS",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 140,
        "y": 86,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 208,
    "height": 160,
    "x": 258,
    "y": 467,
    "playable": true,
    "path": "M 8.00 1.00 L 0.00 41.00 L 11.00 41.00 L 26.00 58.00 L 33.00 61.00 L 34.00 63.00 L 57.00 65.00 L 75.00 76.00 L 85.00 78.00 L 88.00 80.00 L 84.00 112.00 L 80.00 119.00 L 80.00 131.00 L 106.00 132.00 L 117.00 138.00 L 130.00 137.00 L 147.00 147.00 L 146.00 156.00 L 148.00 157.00 L 157.00 157.00 L 162.00 160.00 L 178.00 159.00 L 179.00 148.00 L 182.00 142.00 L 199.00 126.00 L 208.00 107.00 L 208.00 103.00 L 199.00 88.00 L 199.00 78.00 L 193.00 74.00 L 193.00 67.00 L 189.00 63.00 L 189.00 44.00 L 191.00 42.00 L 191.00 39.00 L 179.00 36.00 L 148.00 34.00 L 145.00 29.00 L 143.00 14.00 L 134.00 7.00 L 120.00 8.00 L 118.00 12.00 L 115.00 13.00 L 112.00 11.00 L 87.00 10.00 L 75.00 5.00 L 55.00 5.00 L 43.00 0.00 Z",
    "province": "REGION_132",
    "rootTerritory": "REGION_132",
    "viewBox": "0 0 208 160",
    "unitSlots": [
      {
        "name": "main",
        "x": 95,
        "y": 42,
        "territory": "REGION_132",
        "arrowReceiver": {
          "x": 95,
          "y": 72
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 95,
        "y": 42,
        "territory": "REGION_132",
        "arrowReceiver": {
          "x": 95,
          "y": 72
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_134": {
    "abbr": "APA",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 71,
        "y": 65,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 166,
    "height": 121,
    "x": 127,
    "y": 506,
    "playable": true,
    "path": "M 166.00 21.00 L 159.00 18.00 L 144.00 1.00 L 115.00 0.00 L 66.00 25.00 L 49.00 24.00 L 44.00 27.00 L 29.00 26.00 L 20.00 31.00 L 0.00 34.00 L 0.00 52.00 L 4.00 59.00 L 2.00 72.00 L 14.00 71.00 L 18.00 76.00 L 29.00 78.00 L 30.00 79.00 L 31.00 91.00 L 34.00 90.00 L 40.00 97.00 L 46.00 97.00 L 49.00 101.00 L 50.00 110.00 L 65.00 113.00 L 73.00 117.00 L 85.00 117.00 L 90.00 120.00 L 103.00 121.00 L 104.00 112.00 L 111.00 106.00 L 112.00 62.00 L 132.00 37.00 L 160.00 23.00 L 166.00 24.00 Z",
    "province": "REGION_134",
    "rootTerritory": "REGION_134",
    "viewBox": "0 0 166 121",
    "unitSlots": [
      {
        "name": "main",
        "x": 70,
        "y": 33,
        "territory": "REGION_134",
        "arrowReceiver": {
          "x": 70,
          "y": 63
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 70,
        "y": 33,
        "territory": "REGION_134",
        "arrowReceiver": {
          "x": 70,
          "y": 63
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_135": {
    "abbr": "TEX",
    "type": "Coast",
    "centerPos": {
      "x": 73,
      "y": 127
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 90,
        "y": 120,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 177,
    "height": 209,
    "x": 229,
    "y": 528,
    "playable": true,
    "path": "M 56.00 0.00 L 28.00 14.00 L 9.00 38.00 L 8.00 82.00 L 0.00 90.00 L 0.00 115.00 L 4.00 122.00 L 2.00 145.00 L 10.00 149.00 L 21.00 149.00 L 34.00 139.00 L 36.00 140.00 L 60.00 178.00 L 62.00 198.00 L 84.00 209.00 L 99.00 209.00 L 101.00 188.00 L 112.00 171.00 L 129.00 167.00 L 146.00 155.00 L 159.00 153.00 L 158.00 145.00 L 162.00 142.00 L 167.00 132.00 L 166.00 124.00 L 163.00 119.00 L 163.00 103.00 L 168.00 95.00 L 176.00 95.00 L 177.00 84.00 L 161.00 75.00 L 148.00 76.00 L 137.00 70.00 L 111.00 69.00 L 110.00 68.00 L 110.00 60.00 L 114.00 53.00 L 118.00 17.00 L 106.00 14.00 L 88.00 3.00 Z",
    "province": "REGION_135",
    "rootTerritory": "REGION_135",
    "viewBox": "0 0 177 209",
    "unitSlots": [
      {
        "name": "main",
        "x": 83,
        "y": 87,
        "territory": "REGION_135",
        "arrowReceiver": {
          "x": 83,
          "y": 117
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 83,
        "y": 87,
        "territory": "REGION_135",
        "arrowReceiver": {
          "x": 83,
          "y": 117
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_139": {
    "abbr": "YUC",
    "type": "Coast",
    "centerPos": {
      "x": 53,
      "y": 13
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 44,
        "y": 30,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 85,
    "height": 67,
    "x": 391,
    "y": 805,
    "playable": true,
    "path": "M 85.00 7.00 L 72.00 0.00 L 53.00 0.00 L 50.00 3.00 L 18.00 9.00 L 12.00 37.00 L 1.00 46.00 L 0.00 55.00 L 9.00 56.00 L 14.00 62.00 L 20.00 65.00 L 37.00 65.00 L 46.00 55.00 L 60.00 55.00 L 63.00 58.00 L 63.00 67.00 L 70.00 67.00 L 73.00 61.00 L 73.00 41.00 L 83.00 27.00 Z",
    "province": "REGION_139",
    "rootTerritory": "REGION_139",
    "viewBox": "0 0 85 67",
    "unitSlots": [
      {
        "name": "main",
        "x": 32,
        "y": 47,
        "territory": "REGION_139",
        "arrowReceiver": {
          "x": 32,
          "y": 77
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 32,
        "y": 47,
        "territory": "REGION_139",
        "arrowReceiver": {
          "x": 32,
          "y": 77
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_140": {
    "abbr": "STD",
    "type": "Coast",
    "centerPos": {
      "x": 29,
      "y": 9
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 20,
        "y": 26,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 54,
    "height": 51,
    "x": 763,
    "y": 810,
    "playable": true,
    "path": "M 2.00 13.00 L 2.00 45.00 L 0.00 48.00 L 0.00 51.00 L 10.00 50.00 L 23.00 43.00 L 39.00 45.00 L 45.00 38.00 L 54.00 35.00 L 54.00 31.00 L 51.00 29.00 L 52.00 21.00 L 46.00 15.00 L 35.00 13.00 L 25.00 2.00 L 21.00 0.00 L 13.00 0.00 L 13.00 9.00 L 12.00 10.00 L 7.00 10.00 Z",
    "province": "REGION_140",
    "rootTerritory": "REGION_140",
    "viewBox": "0 0 54 51",
    "unitSlots": [
      {
        "name": "main",
        "x": 27,
        "y": 23,
        "territory": "REGION_140",
        "arrowReceiver": {
          "x": 27,
          "y": 53
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 27,
        "y": 23,
        "territory": "REGION_140",
        "arrowReceiver": {
          "x": 27,
          "y": 53
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_144": {
    "abbr": "HON",
    "type": "Coast",
    "centerPos": {
      "x": -10,
      "y": 24
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 29,
        "y": 41,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "nc",
        "x": 54.78,
        "y": 13.65,
        "text": "nc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "sc",
        "x": 18.83,
        "y": 56.68,
        "text": "sc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 69,
    "height": 67,
    "x": 461,
    "y": 923,
    "playable": true,
    "path": "M 68.00 0.00 L 65.00 0.00 L 64.00 8.00 L 61.00 11.00 L 52.00 12.00 L 45.00 10.00 L 38.00 10.00 L 28.00 22.00 L 14.00 23.00 L 11.00 28.00 L 5.00 33.00 L 5.00 35.00 L 0.00 40.00 L 1.00 44.00 L 12.00 55.00 L 24.00 60.00 L 28.00 60.00 L 41.00 67.00 L 44.00 67.00 L 44.00 53.00 L 51.00 46.00 L 50.00 31.00 L 56.00 24.00 L 60.00 17.00 L 69.00 17.00 L 69.00 2.00 Z",
    "province": "REGION_144",
    "rootTerritory": "REGION_144",
    "viewBox": "0 0 69 67",
    "unitSlots": [
      {
        "name": "main",
        "x": 30,
        "y": 32,
        "territory": "REGION_144",
        "arrowReceiver": {
          "x": 30,
          "y": 62
        }
      },
      {
        "name": "nc",
        "x": 54.78,
        "y": 13.65,
        "territory": "REGION_144_NORTH_COAST",
        "arrowReceiver": {
          "x": 54.78,
          "y": 43.65
        }
      },
      {
        "name": "sc",
        "x": 18.83,
        "y": 56.68,
        "territory": "REGION_144_SOUTH_COAST",
        "arrowReceiver": {
          "x": 18.83,
          "y": 86.68
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 30,
        "y": 32,
        "territory": "REGION_144",
        "arrowReceiver": {
          "x": 30,
          "y": 62
        }
      },
      "nc": {
        "name": "nc",
        "x": 54.78,
        "y": 13.65,
        "territory": "REGION_144_NORTH_COAST",
        "arrowReceiver": {
          "x": 54.78,
          "y": 43.65
        }
      },
      "sc": {
        "name": "sc",
        "x": 18.83,
        "y": 56.68,
        "territory": "REGION_144_SOUTH_COAST",
        "arrowReceiver": {
          "x": 18.83,
          "y": 86.68
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_145": {
    "abbr": "GEO",
    "type": "Coast",
    "centerPos": {
      "x": 17,
      "y": 44
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 34,
        "y": 37,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 68,
    "height": 115,
    "x": 890,
    "y": 1027,
    "playable": true,
    "path": "M 21.00 0.00 L 21.00 12.00 L 12.00 22.00 L 12.00 32.00 L 5.00 38.00 L 0.00 40.00 L 0.00 42.00 L 6.00 49.00 L 7.00 52.00 L 14.00 52.00 L 19.00 56.00 L 20.00 64.00 L 29.00 72.00 L 29.00 82.00 L 21.00 97.00 L 21.00 103.00 L 27.00 112.00 L 35.00 115.00 L 41.00 109.00 L 51.00 104.00 L 60.00 103.00 L 60.00 101.00 L 43.00 78.00 L 42.00 75.00 L 45.00 59.00 L 54.00 50.00 L 59.00 39.00 L 66.00 39.00 L 68.00 38.00 L 68.00 36.00 L 33.00 1.00 Z",
    "province": "REGION_145",
    "rootTerritory": "REGION_145",
    "viewBox": "0 0 68 115",
    "unitSlots": [
      {
        "name": "main",
        "x": 34,
        "y": 37,
        "territory": "REGION_145",
        "arrowReceiver": {
          "x": 34,
          "y": 67
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 34,
        "y": 37,
        "territory": "REGION_145",
        "arrowReceiver": {
          "x": 34,
          "y": 67
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_147": {
    "abbr": "SUR",
    "type": "Coast",
    "centerPos": {
      "x": 15,
      "y": 38
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 32,
        "y": 31,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 65,
    "height": 68,
    "x": 931,
    "y": 1062,
    "playable": true,
    "path": "M 62.00 0.00 L 16.00 3.00 L 12.00 13.00 L 3.00 22.00 L 0.00 43.00 L 18.00 68.00 L 30.00 67.00 L 41.00 56.00 L 60.00 55.00 L 60.00 53.00 L 65.00 45.00 L 65.00 41.00 L 59.00 30.00 Z",
    "province": "REGION_147",
    "rootTerritory": "REGION_147",
    "viewBox": "0 0 65 68",
    "unitSlots": [
      {
        "name": "main",
        "x": 31,
        "y": 30,
        "territory": "REGION_147",
        "arrowReceiver": {
          "x": 31,
          "y": 60
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 31,
        "y": 30,
        "territory": "REGION_147",
        "arrowReceiver": {
          "x": 31,
          "y": 60
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_148": {
    "abbr": "CAY",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 21,
        "y": 21,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 55,
    "height": 58,
    "x": 989,
    "y": 1062,
    "playable": true,
    "path": "M 3.00 0.00 L 0.00 32.00 L 6.00 43.00 L 1.00 51.00 L 1.00 55.00 L 3.00 55.00 L 7.00 58.00 L 25.00 57.00 L 31.00 49.00 L 39.00 31.00 L 44.00 26.00 L 55.00 26.00 L 55.00 21.00 L 41.00 8.00 L 31.00 1.00 Z",
    "province": "REGION_148",
    "rootTerritory": "REGION_148",
    "viewBox": "0 0 55 58",
    "unitSlots": [
      {
        "name": "main",
        "x": 23,
        "y": 21,
        "territory": "REGION_148",
        "arrowReceiver": {
          "x": 23,
          "y": 51
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 23,
        "y": 21,
        "territory": "REGION_148",
        "arrowReceiver": {
          "x": 23,
          "y": 51
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_151": {
    "abbr": "ECU",
    "type": "Coast",
    "centerPos": {
      "x": 13,
      "y": 46
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 30,
        "y": 39,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 89,
    "height": 82,
    "x": 545,
    "y": 1165,
    "playable": true,
    "path": "M 46.00 0.00 L 42.00 0.00 L 39.00 2.00 L 32.00 2.00 L 25.00 12.00 L 10.00 11.00 L 9.00 16.00 L 0.00 24.00 L 0.00 56.00 L 10.00 63.00 L 11.00 66.00 L 22.00 66.00 L 23.00 67.00 L 22.00 77.00 L 31.00 82.00 L 33.00 82.00 L 36.00 79.00 L 42.00 66.00 L 44.00 64.00 L 46.00 64.00 L 47.00 62.00 L 72.00 50.00 L 89.00 35.00 L 89.00 33.00 L 79.00 32.00 L 69.00 27.00 L 64.00 22.00 L 63.00 10.00 Z",
    "province": "REGION_151",
    "rootTerritory": "REGION_151",
    "viewBox": "0 0 89 82",
    "unitSlots": [
      {
        "name": "main",
        "x": 46,
        "y": 40,
        "territory": "REGION_151",
        "arrowReceiver": {
          "x": 46,
          "y": 70
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 46,
        "y": 40,
        "territory": "REGION_151",
        "arrowReceiver": {
          "x": 46,
          "y": 70
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_154": {
    "abbr": "ACR",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 64,
        "y": 38,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 98,
    "height": 55,
    "x": 675,
    "y": 1295,
    "playable": true,
    "path": "M 0.00 4.00 L 0.00 6.00 L 6.00 13.00 L 10.00 21.00 L 11.00 27.00 L 20.00 30.00 L 25.00 37.00 L 30.00 38.00 L 33.00 33.00 L 48.00 33.00 L 49.00 34.00 L 49.00 48.00 L 52.00 53.00 L 66.00 53.00 L 68.00 55.00 L 75.00 54.00 L 81.00 51.00 L 98.00 38.00 L 98.00 36.00 L 94.00 36.00 L 52.00 14.00 L 38.00 12.00 L 27.00 6.00 L 17.00 5.00 L 8.00 0.00 L 3.00 0.00 Z",
    "province": "REGION_154",
    "rootTerritory": "REGION_154",
    "viewBox": "0 0 98 55",
    "unitSlots": [
      {
        "name": "main",
        "x": 63,
        "y": 38,
        "territory": "REGION_154",
        "arrowReceiver": {
          "x": 63,
          "y": 68
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 63,
        "y": 38,
        "territory": "REGION_154",
        "arrowReceiver": {
          "x": 63,
          "y": 68
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_155": {
    "abbr": "BNI",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 40,
        "y": 38,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 98,
    "height": 77,
    "x": 744,
    "y": 1332,
    "playable": true,
    "path": "M 0.00 17.00 L 0.00 21.00 L 8.00 36.00 L 7.00 56.00 L 46.00 77.00 L 51.00 76.00 L 60.00 69.00 L 65.00 61.00 L 74.00 57.00 L 74.00 51.00 L 73.00 50.00 L 74.00 46.00 L 88.00 39.00 L 98.00 39.00 L 98.00 37.00 L 79.00 33.00 L 66.00 20.00 L 66.00 4.00 L 36.00 6.00 L 30.00 0.00 L 27.00 0.00 L 7.00 15.00 Z",
    "province": "REGION_155",
    "rootTerritory": "REGION_155",
    "viewBox": "0 0 98 77",
    "unitSlots": [
      {
        "name": "main",
        "x": 52,
        "y": 43,
        "territory": "REGION_155",
        "arrowReceiver": {
          "x": 52,
          "y": 73
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 52,
        "y": 43,
        "territory": "REGION_155",
        "arrowReceiver": {
          "x": 52,
          "y": 73
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_156": {
    "abbr": "STC",
    "type": "Land",
    "centerPos": {
      "x": 33,
      "y": 54
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 50,
        "y": 47,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 127,
    "height": 111,
    "x": 792,
    "y": 1370,
    "playable": true,
    "path": "M 24.00 7.00 L 25.00 17.00 L 15.00 22.00 L 11.00 29.00 L 0.00 37.00 L 0.00 40.00 L 4.00 43.00 L 15.00 65.00 L 20.00 85.00 L 20.00 89.00 L 24.00 101.00 L 33.00 109.00 L 42.00 111.00 L 46.00 104.00 L 52.00 99.00 L 59.00 98.00 L 67.00 95.00 L 96.00 95.00 L 100.00 96.00 L 112.00 104.00 L 112.00 110.00 L 115.00 111.00 L 125.00 95.00 L 127.00 73.00 L 117.00 64.00 L 118.00 52.00 L 116.00 50.00 L 94.00 50.00 L 90.00 46.00 L 87.00 40.00 L 90.00 16.00 L 85.00 13.00 L 77.00 13.00 L 52.00 0.00 L 38.00 0.00 Z",
    "province": "REGION_156",
    "rootTerritory": "REGION_156",
    "viewBox": "0 0 127 111",
    "unitSlots": [
      {
        "name": "main",
        "x": 66,
        "y": 73,
        "territory": "REGION_156",
        "arrowReceiver": {
          "x": 66,
          "y": 103
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 66,
        "y": 73,
        "territory": "REGION_156",
        "arrowReceiver": {
          "x": 66,
          "y": 103
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_157": {
    "abbr": "PAZ",
    "type": "Land",
    "centerPos": {
      "x": 20,
      "y": 63
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 37,
        "y": 56,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 75,
    "height": 96,
    "x": 740,
    "y": 1387,
    "playable": true,
    "path": "M 11.00 0.00 L 11.00 8.00 L 0.00 29.00 L 1.00 44.00 L 6.00 50.00 L 6.00 62.00 L 4.00 65.00 L 4.00 70.00 L 6.00 73.00 L 8.00 89.00 L 14.00 96.00 L 17.00 96.00 L 20.00 94.00 L 43.00 95.00 L 51.00 89.00 L 61.00 77.00 L 75.00 77.00 L 68.00 46.00 L 57.00 24.00 L 55.00 22.00 L 30.00 10.00 L 14.00 0.00 Z",
    "province": "REGION_157",
    "rootTerritory": "REGION_157",
    "viewBox": "0 0 75 96",
    "unitSlots": [
      {
        "name": "main",
        "x": 38,
        "y": 61,
        "territory": "REGION_157",
        "arrowReceiver": {
          "x": 38,
          "y": 91
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 38,
        "y": 61,
        "territory": "REGION_157",
        "arrowReceiver": {
          "x": 38,
          "y": 91
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_158": {
    "abbr": "POT",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 51,
        "y": 38,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 88,
    "height": 93,
    "x": 746,
    "y": 1463,
    "playable": true,
    "path": "M 69.00 0.00 L 53.00 0.00 L 47.00 8.00 L 35.00 18.00 L 12.00 17.00 L 9.00 19.00 L 10.00 32.00 L 0.00 42.00 L 2.00 75.00 L 9.00 81.00 L 9.00 93.00 L 28.00 90.00 L 43.00 64.00 L 65.00 64.00 L 73.00 56.00 L 77.00 55.00 L 76.00 42.00 L 88.00 21.00 L 88.00 17.00 L 81.00 15.00 L 71.00 6.00 Z",
    "province": "REGION_158",
    "rootTerritory": "REGION_158",
    "viewBox": "0 0 88 93",
    "unitSlots": [
      {
        "name": "main",
        "x": 45,
        "y": 31,
        "territory": "REGION_158",
        "arrowReceiver": {
          "x": 45,
          "y": 61
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 45,
        "y": 31,
        "territory": "REGION_158",
        "arrowReceiver": {
          "x": 45,
          "y": 61
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_159": {
    "abbr": "CHB",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 38,
        "y": 44,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 89,
    "height": 107,
    "x": 821,
    "y": 1464,
    "playable": true,
    "path": "M 73.00 1.00 L 69.00 0.00 L 36.00 0.00 L 19.00 5.00 L 13.00 12.00 L 12.00 18.00 L 0.00 39.00 L 1.00 55.00 L 13.00 71.00 L 12.00 88.00 L 25.00 103.00 L 33.00 107.00 L 37.00 107.00 L 36.00 98.00 L 57.00 74.00 L 65.00 70.00 L 75.00 50.00 L 76.00 43.00 L 81.00 38.00 L 89.00 39.00 L 89.00 36.00 L 86.00 33.00 L 84.00 8.00 Z",
    "province": "REGION_159",
    "rootTerritory": "REGION_159",
    "viewBox": "0 0 89 107",
    "unitSlots": [
      {
        "name": "main",
        "x": 39,
        "y": 37,
        "territory": "REGION_159",
        "arrowReceiver": {
          "x": 39,
          "y": 67
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 39,
        "y": 37,
        "territory": "REGION_159",
        "arrowReceiver": {
          "x": 39,
          "y": 67
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_160": {
    "abbr": "ATF",
    "type": "Coast",
    "centerPos": {
      "x": 34,
      "y": 12
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 29,
        "y": 29,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 65,
    "height": 57,
    "x": 691,
    "y": 1507,
    "playable": true,
    "path": "M 12.00 0.00 L 4.00 15.00 L 0.00 48.00 L 9.00 47.00 L 10.00 48.00 L 18.00 48.00 L 23.00 51.00 L 37.00 51.00 L 44.00 47.00 L 55.00 47.00 L 58.00 52.00 L 58.00 57.00 L 60.00 57.00 L 65.00 51.00 L 65.00 35.00 L 58.00 29.00 L 56.00 0.00 L 54.00 0.00 L 52.00 3.00 L 42.00 8.00 L 17.00 8.00 L 14.00 4.00 L 14.00 0.00 Z",
    "province": "REGION_160",
    "rootTerritory": "REGION_160",
    "viewBox": "0 0 65 57",
    "unitSlots": [
      {
        "name": "main",
        "x": 27,
        "y": 46,
        "territory": "REGION_160",
        "arrowReceiver": {
          "x": 27,
          "y": 76
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 27,
        "y": 46,
        "territory": "REGION_160",
        "arrowReceiver": {
          "x": 27,
          "y": 76
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_161": {
    "abbr": "ASU",
    "type": "Land",
    "centerPos": {
      "x": 38,
      "y": 60
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 55,
        "y": 53,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 91,
    "height": 96,
    "x": 856,
    "y": 1501,
    "playable": true,
    "path": "M 75.00 2.00 L 44.00 0.00 L 40.00 4.00 L 39.00 11.00 L 29.00 31.00 L 20.00 36.00 L 0.00 59.00 L 2.00 76.00 L 7.00 83.00 L 28.00 93.00 L 31.00 96.00 L 50.00 96.00 L 62.00 90.00 L 84.00 75.00 L 90.00 63.00 L 90.00 48.00 L 88.00 45.00 L 88.00 42.00 L 91.00 37.00 L 91.00 22.00 L 83.00 21.00 L 77.00 17.00 L 77.00 6.00 Z",
    "province": "REGION_161",
    "rootTerritory": "REGION_161",
    "viewBox": "0 0 91 96",
    "unitSlots": [
      {
        "name": "main",
        "x": 37,
        "y": 59,
        "territory": "REGION_161",
        "arrowReceiver": {
          "x": 37,
          "y": 89
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 37,
        "y": 59,
        "territory": "REGION_161",
        "arrowReceiver": {
          "x": 37,
          "y": 89
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_162": {
    "abbr": "URU",
    "type": "Coast",
    "centerPos": {
      "x": 19,
      "y": 45
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 36,
        "y": 38,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 82,
    "height": 70,
    "x": 845,
    "y": 1603,
    "playable": true,
    "path": "M 81.00 29.00 L 67.00 13.00 L 65.00 12.00 L 53.00 12.00 L 43.00 0.00 L 20.00 2.00 L 2.00 36.00 L 0.00 63.00 L 7.00 70.00 L 12.00 69.00 L 40.00 70.00 L 45.00 67.00 L 65.00 66.00 L 73.00 61.00 L 79.00 55.00 L 82.00 49.00 Z",
    "province": "REGION_162",
    "rootTerritory": "REGION_162",
    "viewBox": "0 0 82 70",
    "unitSlots": [
      {
        "name": "main",
        "x": 36,
        "y": 36,
        "territory": "REGION_162",
        "arrowReceiver": {
          "x": 36,
          "y": 66
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 36,
        "y": 36,
        "territory": "REGION_162",
        "arrowReceiver": {
          "x": 36,
          "y": 66
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_163": {
    "abbr": "MDZ",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 55,
        "y": 42,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 97,
    "height": 119,
    "x": 662,
    "y": 1621,
    "playable": true,
    "path": "M 96.00 0.00 L 80.00 0.00 L 77.00 2.00 L 53.00 0.00 L 53.00 11.00 L 34.00 30.00 L 32.00 34.00 L 31.00 46.00 L 34.00 51.00 L 34.00 66.00 L 29.00 76.00 L 25.00 78.00 L 15.00 90.00 L 13.00 105.00 L 0.00 115.00 L 1.00 119.00 L 5.00 119.00 L 13.00 110.00 L 27.00 109.00 L 33.00 106.00 L 45.00 94.00 L 58.00 89.00 L 63.00 82.00 L 65.00 73.00 L 83.00 38.00 L 85.00 20.00 L 86.00 19.00 L 97.00 19.00 Z",
    "province": "REGION_163",
    "rootTerritory": "REGION_163",
    "viewBox": "0 0 97 119",
    "unitSlots": [
      {
        "name": "main",
        "x": 63,
        "y": 28,
        "territory": "REGION_163",
        "arrowReceiver": {
          "x": 63,
          "y": 58
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 63,
        "y": 28,
        "territory": "REGION_163",
        "arrowReceiver": {
          "x": 63,
          "y": 58
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_164": {
    "abbr": "PAM",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 81,
        "y": 44,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 128,
    "height": 109,
    "x": 694,
    "y": 1639,
    "playable": true,
    "path": "M 106.00 2.00 L 52.00 0.00 L 50.00 18.00 L 32.00 53.00 L 30.00 62.00 L 23.00 71.00 L 11.00 75.00 L 0.00 86.00 L 0.00 88.00 L 8.00 88.00 L 12.00 93.00 L 29.00 94.00 L 37.00 98.00 L 40.00 101.00 L 43.00 109.00 L 45.00 109.00 L 48.00 106.00 L 71.00 107.00 L 77.00 104.00 L 79.00 102.00 L 81.00 98.00 L 84.00 95.00 L 92.00 83.00 L 108.00 84.00 L 109.00 83.00 L 125.00 78.00 L 127.00 75.00 L 127.00 71.00 L 128.00 70.00 L 127.00 62.00 L 119.00 54.00 L 121.00 18.00 Z",
    "province": "REGION_164",
    "rootTerritory": "REGION_164",
    "viewBox": "0 0 128 109",
    "unitSlots": [
      {
        "name": "main",
        "x": 72,
        "y": 64,
        "territory": "REGION_164",
        "arrowReceiver": {
          "x": 72,
          "y": 94
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 72,
        "y": 64,
        "territory": "REGION_164",
        "arrowReceiver": {
          "x": 72,
          "y": 94
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_169": {
    "abbr": "LOR",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 45,
        "y": 39,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 114,
    "height": 153,
    "x": 590,
    "y": 1198,
    "playable": true,
    "path": "M 43.00 0.00 L 25.00 16.00 L 0.00 28.00 L 0.00 31.00 L 6.00 31.00 L 7.00 30.00 L 12.00 31.00 L 14.00 36.00 L 14.00 55.00 L 28.00 66.00 L 43.00 70.00 L 49.00 73.00 L 49.00 86.00 L 42.00 92.00 L 42.00 95.00 L 44.00 98.00 L 42.00 112.00 L 44.00 114.00 L 46.00 114.00 L 49.00 110.00 L 62.00 109.00 L 65.00 113.00 L 64.00 129.00 L 69.00 138.00 L 68.00 145.00 L 69.00 146.00 L 79.00 145.00 L 84.00 153.00 L 93.00 153.00 L 97.00 148.00 L 111.00 143.00 L 114.00 137.00 L 114.00 133.00 L 112.00 133.00 L 107.00 126.00 L 99.00 124.00 L 97.00 122.00 L 96.00 116.00 L 92.00 108.00 L 87.00 102.00 L 89.00 99.00 L 89.00 96.00 L 86.00 96.00 L 82.00 94.00 L 82.00 86.00 L 89.00 77.00 L 91.00 60.00 L 101.00 52.00 L 105.00 50.00 L 112.00 51.00 L 112.00 49.00 L 108.00 47.00 L 95.00 46.00 L 84.00 31.00 L 73.00 26.00 L 69.00 15.00 L 65.00 11.00 L 52.00 5.00 L 47.00 0.00 Z",
    "province": "REGION_169",
    "rootTerritory": "REGION_169",
    "viewBox": "0 0 114 153",
    "unitSlots": [
      {
        "name": "main",
        "x": 59,
        "y": 50,
        "territory": "REGION_169",
        "arrowReceiver": {
          "x": 59,
          "y": 80
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 59,
        "y": 50,
        "territory": "REGION_169",
        "arrowReceiver": {
          "x": 59,
          "y": 80
        }
      }
    },
    "texture": {
      "texture": "#E8A7C1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_170": {
    "abbr": "CAJ",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 63,
        "y": 64,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 120,
    "height": 124,
    "x": 536,
    "y": 1227,
    "playable": true,
    "path": "M 17.00 3.00 L 0.00 13.00 L 0.00 30.00 L 4.00 37.00 L 3.00 58.00 L 32.00 81.00 L 46.00 107.00 L 51.00 124.00 L 53.00 124.00 L 53.00 114.00 L 55.00 112.00 L 63.00 113.00 L 76.00 106.00 L 86.00 107.00 L 92.00 100.00 L 113.00 98.00 L 114.00 97.00 L 119.00 98.00 L 120.00 82.00 L 118.00 79.00 L 101.00 80.00 L 99.00 82.00 L 97.00 81.00 L 99.00 76.00 L 98.00 64.00 L 104.00 59.00 L 104.00 42.00 L 84.00 36.00 L 69.00 24.00 L 69.00 5.00 L 67.00 0.00 L 51.00 1.00 L 44.00 15.00 L 41.00 18.00 L 32.00 13.00 L 33.00 3.00 Z",
    "province": "REGION_170",
    "rootTerritory": "REGION_170",
    "viewBox": "0 0 120 124",
    "unitSlots": [
      {
        "name": "main",
        "x": 48,
        "y": 42,
        "territory": "REGION_170",
        "arrowReceiver": {
          "x": 48,
          "y": 72
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 48,
        "y": 42,
        "territory": "REGION_170",
        "arrowReceiver": {
          "x": 48,
          "y": 72
        }
      }
    },
    "texture": {
      "texture": "#E8A7C1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_171": {
    "abbr": "LMA",
    "type": "Coast",
    "centerPos": {
      "x": 22,
      "y": 46
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 39,
        "y": 39,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 91,
    "height": 105,
    "x": 588,
    "y": 1323,
    "playable": true,
    "path": "M 66.00 0.00 L 38.00 3.00 L 32.00 10.00 L 22.00 9.00 L 9.00 16.00 L 7.00 15.00 L 1.00 15.00 L 0.00 16.00 L 0.00 37.00 L 4.00 45.00 L 26.00 71.00 L 26.00 86.00 L 47.00 105.00 L 51.00 105.00 L 51.00 94.00 L 55.00 90.00 L 67.00 90.00 L 71.00 95.00 L 75.00 95.00 L 91.00 80.00 L 91.00 76.00 L 86.00 72.00 L 79.00 72.00 L 67.00 58.00 L 68.00 44.00 L 72.00 40.00 L 71.00 33.00 L 79.00 27.00 L 86.00 27.00 L 86.00 25.00 L 83.00 19.00 L 73.00 20.00 L 71.00 18.00 L 72.00 11.00 Z",
    "province": "REGION_171",
    "rootTerritory": "REGION_171",
    "viewBox": "0 0 91 105",
    "unitSlots": [
      {
        "name": "main",
        "x": 37,
        "y": 21,
        "territory": "REGION_171",
        "arrowReceiver": {
          "x": 37,
          "y": 51
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 37,
        "y": 21,
        "territory": "REGION_171",
        "arrowReceiver": {
          "x": 37,
          "y": 51
        }
      }
    },
    "texture": {
      "texture": "#E8A7C1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_172": {
    "abbr": "CUZ",
    "type": "Land",
    "centerPos": {
      "x": 37,
      "y": 56
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 54,
        "y": 49,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 99,
    "height": 102,
    "x": 654,
    "y": 1327,
    "playable": true,
    "path": "M 4.00 27.00 L 5.00 34.00 L 1.00 38.00 L 0.00 56.00 L 11.00 69.00 L 18.00 69.00 L 24.00 74.00 L 23.00 78.00 L 32.00 78.00 L 45.00 85.00 L 57.00 86.00 L 65.00 92.00 L 88.00 102.00 L 87.00 91.00 L 98.00 70.00 L 99.00 39.00 L 91.00 24.00 L 91.00 22.00 L 89.00 20.00 L 75.00 20.00 L 71.00 14.00 L 71.00 0.00 L 52.00 0.00 L 45.00 13.00 L 31.00 18.00 L 27.00 23.00 L 11.00 22.00 Z",
    "province": "REGION_172",
    "rootTerritory": "REGION_172",
    "viewBox": "0 0 99 102",
    "unitSlots": [
      {
        "name": "main",
        "x": 43,
        "y": 41,
        "territory": "REGION_172",
        "arrowReceiver": {
          "x": 43,
          "y": 71
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 43,
        "y": 41,
        "territory": "REGION_172",
        "arrowReceiver": {
          "x": 43,
          "y": 71
        }
      }
    },
    "texture": {
      "texture": "#E8A7C1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_174": {
    "abbr": "ACM",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 43,
        "y": 30,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 78,
    "height": 68,
    "x": 672,
    "y": 1553,
    "playable": true,
    "path": "M 76.00 0.00 L 61.00 0.00 L 54.00 4.00 L 44.00 4.00 L 39.00 1.00 L 20.00 0.00 L 0.00 39.00 L 0.00 52.00 L 2.00 52.00 L 4.00 50.00 L 25.00 49.00 L 28.00 55.00 L 30.00 55.00 L 34.00 58.00 L 42.00 59.00 L 43.00 60.00 L 42.00 65.00 L 43.00 68.00 L 45.00 68.00 L 71.00 39.00 L 76.00 37.00 L 78.00 33.00 L 78.00 4.00 Z",
    "province": "REGION_174",
    "rootTerritory": "REGION_174",
    "viewBox": "0 0 78 68",
    "unitSlots": [
      {
        "name": "main",
        "x": 36,
        "y": 25,
        "territory": "REGION_174",
        "arrowReceiver": {
          "x": 36,
          "y": 55
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 36,
        "y": 25,
        "territory": "REGION_174",
        "arrowReceiver": {
          "x": 36,
          "y": 55
        }
      }
    },
    "texture": {
      "texture": "#D4BCAE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_183": {
    "abbr": "COS",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 13,
        "y": 15,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "nc",
        "x": 31.47,
        "y": 45.02,
        "text": "nc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "sc",
        "x": 14.72,
        "y": 43.65,
        "text": "sc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 45,
    "height": 52,
    "x": 482,
    "y": 982,
    "playable": true,
    "path": "M 3.00 0.00 L 3.00 10.00 L 0.00 13.00 L 0.00 19.00 L 2.00 23.00 L 9.00 28.00 L 13.00 28.00 L 16.00 30.00 L 20.00 31.00 L 41.00 52.00 L 45.00 52.00 L 44.00 39.00 L 36.00 23.00 L 23.00 10.00 L 23.00 7.00 L 10.00 0.00 Z",
    "province": "REGION_183",
    "rootTerritory": "REGION_183",
    "viewBox": "0 0 45 52",
    "unitSlots": [
      {
        "name": "main",
        "x": 24,
        "y": 16,
        "territory": "REGION_183",
        "arrowReceiver": {
          "x": 24,
          "y": 46
        }
      },
      {
        "name": "nc",
        "x": 31.47,
        "y": 45.02,
        "territory": "REGION_183_NORTH_COAST",
        "arrowReceiver": {
          "x": 31.47,
          "y": 75.02
        }
      },
      {
        "name": "sc",
        "x": 14.72,
        "y": 43.65,
        "territory": "REGION_183_SOUTH_COAST",
        "arrowReceiver": {
          "x": 14.72,
          "y": 73.65
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 24,
        "y": 16,
        "territory": "REGION_183",
        "arrowReceiver": {
          "x": 24,
          "y": 46
        }
      },
      "nc": {
        "name": "nc",
        "x": 31.47,
        "y": 45.02,
        "territory": "REGION_183_NORTH_COAST",
        "arrowReceiver": {
          "x": 31.47,
          "y": 75.02
        }
      },
      "sc": {
        "name": "sc",
        "x": 14.72,
        "y": 43.65,
        "territory": "REGION_183_SOUTH_COAST",
        "arrowReceiver": {
          "x": 14.72,
          "y": 73.65
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_184": {
    "abbr": "STM",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 15,
        "y": 59,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 62,
    "height": 81,
    "x": 661,
    "y": 970,
    "playable": true,
    "path": "M 60.00 2.00 L 54.00 2.00 L 53.00 1.00 L 47.00 1.00 L 46.00 0.00 L 38.00 1.00 L 25.00 11.00 L 21.00 12.00 L 21.00 20.00 L 12.00 30.00 L 8.00 30.00 L 8.00 49.00 L 0.00 64.00 L 0.00 66.00 L 9.00 80.00 L 11.00 81.00 L 16.00 81.00 L 19.00 79.00 L 23.00 79.00 L 28.00 76.00 L 27.00 75.00 L 27.00 69.00 L 28.00 68.00 L 28.00 66.00 L 26.00 63.00 L 27.00 59.00 L 25.00 56.00 L 26.00 44.00 L 34.00 34.00 L 34.00 29.00 L 35.00 28.00 L 35.00 24.00 L 36.00 23.00 L 46.00 20.00 L 52.00 9.00 L 62.00 10.00 L 62.00 6.00 Z",
    "province": "REGION_184",
    "rootTerritory": "REGION_184",
    "viewBox": "0 0 62 81",
    "unitSlots": [
      {
        "name": "main",
        "x": 37,
        "y": 15,
        "territory": "REGION_184",
        "arrowReceiver": {
          "x": 37,
          "y": 45
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 37,
        "y": 15,
        "territory": "REGION_184",
        "arrowReceiver": {
          "x": 37,
          "y": 45
        }
      }
    },
    "texture": {
      "texture": "#E9D99E",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_185": {
    "abbr": "CAT",
    "type": "Coast",
    "centerPos": {
      "x": -2,
      "y": 12
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 15,
        "y": 45,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 37,
    "height": 83,
    "x": 636,
    "y": 1000,
    "playable": true,
    "path": "M 34.00 0.00 L 25.00 1.00 L 21.00 4.00 L 18.00 13.00 L 11.00 19.00 L 11.00 27.00 L 0.00 40.00 L 1.00 52.00 L 11.00 61.00 L 14.00 83.00 L 17.00 83.00 L 18.00 73.00 L 26.00 65.00 L 27.00 62.00 L 34.00 57.00 L 35.00 54.00 L 37.00 52.00 L 35.00 51.00 L 34.00 46.00 L 27.00 36.00 L 27.00 34.00 L 34.00 21.00 Z",
    "province": "REGION_185",
    "rootTerritory": "REGION_185",
    "viewBox": "0 0 37 83",
    "unitSlots": [
      {
        "name": "main",
        "x": 22,
        "y": 58,
        "territory": "REGION_185",
        "arrowReceiver": {
          "x": 22,
          "y": 88
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 22,
        "y": 58,
        "territory": "REGION_185",
        "arrowReceiver": {
          "x": 22,
          "y": 88
        }
      }
    },
    "texture": {
      "texture": "#E9D99E",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_188": {
    "abbr": "BOG",
    "type": "Land",
    "centerPos": {
      "x": 22,
      "y": 41
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 39,
        "y": 34,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 69,
    "height": 97,
    "x": 641,
    "y": 1047,
    "playable": true,
    "path": "M 48.00 0.00 L 42.00 3.00 L 39.00 3.00 L 38.00 4.00 L 33.00 5.00 L 31.00 7.00 L 27.00 8.00 L 21.00 13.00 L 20.00 16.00 L 12.00 24.00 L 10.00 40.00 L 15.00 43.00 L 15.00 51.00 L 1.00 76.00 L 1.00 79.00 L 0.00 80.00 L 0.00 94.00 L 2.00 94.00 L 15.00 81.00 L 27.00 81.00 L 40.00 92.00 L 53.00 90.00 L 57.00 95.00 L 57.00 97.00 L 59.00 97.00 L 60.00 81.00 L 57.00 78.00 L 60.00 74.00 L 60.00 58.00 L 58.00 55.00 L 58.00 52.00 L 69.00 37.00 L 69.00 19.00 L 65.00 17.00 L 63.00 17.00 L 59.00 14.00 L 56.00 14.00 L 53.00 11.00 Z",
    "province": "REGION_188",
    "rootTerritory": "REGION_188",
    "viewBox": "0 0 69 97",
    "unitSlots": [
      {
        "name": "main",
        "x": 32,
        "y": 78,
        "territory": "REGION_188",
        "arrowReceiver": {
          "x": 32,
          "y": 108
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 32,
        "y": 78,
        "territory": "REGION_188",
        "arrowReceiver": {
          "x": 32,
          "y": 108
        }
      }
    },
    "texture": {
      "texture": "#E9D99E",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_190": {
    "abbr": "CAQ",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 126,
        "y": 74,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 204,
    "height": 122,
    "x": 607,
    "y": 1127,
    "playable": true,
    "path": "M 0.00 49.00 L 1.00 62.00 L 5.00 66.00 L 15.00 71.00 L 28.00 72.00 L 33.00 77.00 L 46.00 83.00 L 51.00 88.00 L 55.00 99.00 L 65.00 103.00 L 76.00 118.00 L 89.00 119.00 L 94.00 122.00 L 98.00 122.00 L 101.00 116.00 L 113.00 116.00 L 120.00 120.00 L 131.00 120.00 L 132.00 119.00 L 143.00 120.00 L 149.00 112.00 L 163.00 111.00 L 178.00 95.00 L 196.00 86.00 L 201.00 86.00 L 204.00 81.00 L 204.00 78.00 L 199.00 69.00 L 199.00 55.00 L 198.00 54.00 L 195.00 54.00 L 183.00 47.00 L 167.00 48.00 L 149.00 32.00 L 142.00 33.00 L 135.00 29.00 L 121.00 29.00 L 116.00 32.00 L 98.00 23.00 L 93.00 18.00 L 92.00 13.00 L 89.00 9.00 L 76.00 11.00 L 63.00 0.00 L 47.00 0.00 L 36.00 11.00 L 35.00 10.00 L 35.00 4.00 L 32.00 4.00 L 20.00 10.00 L 14.00 20.00 L 14.00 22.00 L 19.00 27.00 L 18.00 43.00 L 12.00 49.00 Z",
    "province": "REGION_190",
    "rootTerritory": "REGION_190",
    "viewBox": "0 0 204 122",
    "unitSlots": [
      {
        "name": "main",
        "x": 103,
        "y": 62,
        "territory": "REGION_190",
        "arrowReceiver": {
          "x": 103,
          "y": 92
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 103,
        "y": 62,
        "territory": "REGION_190",
        "arrowReceiver": {
          "x": 103,
          "y": 92
        }
      }
    },
    "texture": {
      "texture": "#E9D99E",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_192": {
    "abbr": "CUM",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 63,
        "y": 45,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 81,
    "height": 79,
    "x": 831,
    "y": 989,
    "playable": true,
    "path": "M 7.00 2.00 L 0.00 9.00 L 0.00 12.00 L 10.00 11.00 L 17.00 19.00 L 19.00 30.00 L 31.00 41.00 L 38.00 41.00 L 44.00 45.00 L 48.00 55.00 L 59.00 68.00 L 58.00 79.00 L 63.00 79.00 L 72.00 72.00 L 72.00 62.00 L 81.00 52.00 L 81.00 36.00 L 76.00 33.00 L 68.00 24.00 L 69.00 23.00 L 69.00 10.00 L 46.00 12.00 L 37.00 7.00 L 36.00 0.00 Z",
    "province": "REGION_192",
    "rootTerritory": "REGION_192",
    "viewBox": "0 0 81 79",
    "unitSlots": [
      {
        "name": "main",
        "x": 29,
        "y": 12,
        "territory": "REGION_192",
        "arrowReceiver": {
          "x": 29,
          "y": 42
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 29,
        "y": 12,
        "territory": "REGION_192",
        "arrowReceiver": {
          "x": 29,
          "y": 42
        }
      }
    },
    "texture": {
      "texture": "#FDDEAC",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_193": {
    "abbr": "CCS",
    "type": "Coast",
    "centerPos": {
      "x": 58,
      "y": 8
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 49,
        "y": 25,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 110,
    "height": 53,
    "x": 753,
    "y": 992,
    "playable": true,
    "path": "M 0.00 16.00 L 0.00 18.00 L 9.00 18.00 L 28.00 43.00 L 36.00 48.00 L 48.00 53.00 L 52.00 53.00 L 59.00 49.00 L 78.00 50.00 L 101.00 38.00 L 110.00 38.00 L 110.00 36.00 L 98.00 25.00 L 96.00 14.00 L 90.00 7.00 L 75.00 9.00 L 59.00 0.00 L 20.00 1.00 L 17.00 3.00 L 7.00 3.00 Z",
    "province": "REGION_193",
    "rootTerritory": "REGION_193",
    "viewBox": "0 0 110 53",
    "unitSlots": [
      {
        "name": "main",
        "x": 42,
        "y": 16,
        "territory": "REGION_193",
        "arrowReceiver": {
          "x": 42,
          "y": 46
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 42,
        "y": 16,
        "territory": "REGION_193",
        "arrowReceiver": {
          "x": 42,
          "y": 46
        }
      }
    },
    "texture": {
      "texture": "#FDDEAC",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_195": {
    "abbr": "ANG",
    "type": "Land",
    "centerPos": {
      "x": 67,
      "y": 46
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 84,
        "y": 39,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 127,
    "height": 141,
    "x": 771,
    "y": 1029,
    "playable": true,
    "path": "M 104.00 2.00 L 100.00 0.00 L 81.00 0.00 L 58.00 12.00 L 39.00 11.00 L 32.00 15.00 L 22.00 15.00 L 0.00 53.00 L 0.00 78.00 L 7.00 89.00 L 18.00 94.00 L 28.00 102.00 L 27.00 108.00 L 19.00 115.00 L 20.00 135.00 L 23.00 140.00 L 30.00 141.00 L 29.00 129.00 L 33.00 126.00 L 47.00 127.00 L 67.00 113.00 L 68.00 108.00 L 61.00 101.00 L 58.00 95.00 L 58.00 75.00 L 60.00 73.00 L 74.00 73.00 L 83.00 78.00 L 89.00 78.00 L 111.00 67.00 L 118.00 55.00 L 127.00 50.00 L 126.00 45.00 L 119.00 37.00 L 120.00 26.00 L 109.00 13.00 Z",
    "province": "REGION_195",
    "rootTerritory": "REGION_195",
    "viewBox": "0 0 127 141",
    "unitSlots": [
      {
        "name": "main",
        "x": 60,
        "y": 55,
        "territory": "REGION_195",
        "arrowReceiver": {
          "x": 60,
          "y": 85
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 60,
        "y": 55,
        "territory": "REGION_195",
        "arrowReceiver": {
          "x": 60,
          "y": 85
        }
      }
    },
    "texture": {
      "texture": "#FDDEAC",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M001": {
    "abbr": "NWT",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 117,
        "y": 137,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 538,
    "height": 231,
    "x": 184,
    "y": 91,
    "playable": true,
    "path": "M 0.00 176.00 L 40.00 188.00 L 52.00 196.00 L 58.00 205.00 L 56.00 223.00 L 63.00 230.00 L 88.00 231.00 L 89.00 230.00 L 100.00 230.00 L 101.00 229.00 L 115.00 229.00 L 124.00 224.00 L 130.00 224.00 L 135.00 221.00 L 143.00 220.00 L 178.00 202.00 L 200.00 203.00 L 203.00 201.00 L 210.00 201.00 L 215.00 198.00 L 220.00 197.00 L 225.00 191.00 L 225.00 174.00 L 223.00 170.00 L 213.00 163.00 L 201.00 160.00 L 197.00 157.00 L 200.00 150.00 L 217.00 137.00 L 237.00 128.00 L 253.00 128.00 L 261.00 125.00 L 267.00 125.00 L 284.00 116.00 L 296.00 117.00 L 304.00 110.00 L 311.00 110.00 L 334.00 100.00 L 345.00 101.00 L 350.00 104.00 L 361.00 105.00 L 369.00 96.00 L 374.00 96.00 L 377.00 93.00 L 378.00 84.00 L 380.00 79.00 L 390.00 78.00 L 394.00 73.00 L 450.00 78.00 L 451.00 79.00 L 451.00 88.00 L 449.00 90.00 L 449.00 92.00 L 455.00 94.00 L 459.00 99.00 L 459.00 106.00 L 457.00 108.00 L 457.00 110.00 L 468.00 109.00 L 474.00 116.00 L 489.00 123.00 L 498.00 135.00 L 498.00 145.00 L 504.00 144.00 L 511.00 148.00 L 530.00 148.00 L 532.00 140.00 L 538.00 136.00 L 538.00 118.00 L 528.00 99.00 L 528.00 91.00 L 523.00 88.00 L 508.00 87.00 L 491.00 72.00 L 489.00 61.00 L 475.00 48.00 L 473.00 44.00 L 460.00 44.00 L 448.00 33.00 L 431.00 30.00 L 428.00 26.00 L 411.00 27.00 L 401.00 20.00 L 378.00 20.00 L 377.00 21.00 L 359.00 20.00 L 351.00 25.00 L 340.00 26.00 L 333.00 30.00 L 329.00 30.00 L 321.00 26.00 L 316.00 21.00 L 316.00 17.00 L 293.00 18.00 L 278.00 10.00 L 262.00 7.00 L 254.00 0.00 L 230.00 0.00 L 216.00 8.00 L 211.00 9.00 L 206.00 17.00 L 207.00 31.00 L 216.00 36.00 L 217.00 42.00 L 214.00 45.00 L 209.00 44.00 L 200.00 35.00 L 195.00 35.00 L 192.00 33.00 L 188.00 33.00 L 183.00 28.00 L 152.00 27.00 L 147.00 24.00 L 133.00 24.00 L 131.00 22.00 L 128.00 22.00 L 128.00 27.00 L 129.00 28.00 L 128.00 31.00 L 127.00 30.00 L 121.00 31.00 L 73.00 65.00 L 23.00 90.00 L 10.00 101.00 L 12.00 107.00 L 20.00 113.00 L 21.00 128.00 L 9.00 152.00 L 6.00 155.00 L 6.00 172.00 L 4.00 174.00 L 0.00 174.00 Z",
    "province": "M001",
    "rootTerritory": "M001",
    "viewBox": "0 0 538 231",
    "unitSlots": [
      {
        "name": "main",
        "x": 196,
        "y": 86,
        "territory": "M001",
        "arrowReceiver": {
          "x": 196,
          "y": 116
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 196,
        "y": 86,
        "territory": "M001",
        "arrowReceiver": {
          "x": 196,
          "y": 116
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M002": {
    "abbr": "GRE",
    "type": "Coast",
    "centerPos": {
      "x": 182,
      "y": 89
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 199,
        "y": 82,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 327,
    "height": 202,
    "x": 569,
    "y": 41,
    "playable": true,
    "path": "M 2.00 30.00 L 0.00 57.00 L 7.00 64.00 L 26.00 64.00 L 29.00 66.00 L 43.00 66.00 L 49.00 62.00 L 52.00 56.00 L 54.00 58.00 L 77.00 61.00 L 87.00 68.00 L 111.00 68.00 L 114.00 66.00 L 122.00 73.00 L 130.00 73.00 L 135.00 79.00 L 143.00 81.00 L 157.00 96.00 L 175.00 101.00 L 180.00 109.00 L 197.00 113.00 L 202.00 118.00 L 201.00 135.00 L 229.00 162.00 L 237.00 164.00 L 244.00 175.00 L 255.00 180.00 L 263.00 190.00 L 275.00 195.00 L 278.00 198.00 L 278.00 200.00 L 300.00 199.00 L 305.00 202.00 L 323.00 202.00 L 326.00 199.00 L 325.00 179.00 L 317.00 171.00 L 317.00 156.00 L 310.00 143.00 L 310.00 141.00 L 319.00 134.00 L 319.00 116.00 L 318.00 113.00 L 327.00 106.00 L 327.00 80.00 L 312.00 72.00 L 300.00 72.00 L 293.00 69.00 L 274.00 53.00 L 263.00 38.00 L 242.00 33.00 L 234.00 24.00 L 227.00 23.00 L 222.00 20.00 L 210.00 19.00 L 178.00 2.00 L 150.00 5.00 L 141.00 0.00 L 115.00 0.00 L 75.00 13.00 L 44.00 17.00 L 17.00 31.00 Z",
    "province": "M002",
    "rootTerritory": "M002",
    "viewBox": "0 0 327 202",
    "unitSlots": [
      {
        "name": "main",
        "x": 155,
        "y": 44,
        "territory": "M002",
        "arrowReceiver": {
          "x": 155,
          "y": 74
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 155,
        "y": 44,
        "territory": "M002",
        "arrowReceiver": {
          "x": 155,
          "y": 74
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M003": {
    "abbr": "BAH",
    "type": "Coast",
    "centerPos": {
      "x": 39,
      "y": 16
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 56,
        "y": 9,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 111,
    "height": 95,
    "x": 623,
    "y": 642,
    "playable": true,
    "path": "M 110.00 0.00 L 3.00 1.00 L 0.00 45.00 L 5.00 50.00 L 6.00 95.00 L 79.00 95.00 L 87.00 86.00 L 100.00 86.00 L 101.00 85.00 L 106.00 86.00 L 111.00 81.00 Z",
    "province": "M003",
    "rootTerritory": "M003",
    "viewBox": "0 0 111 95",
    "unitSlots": [
      {
        "name": "main",
        "x": 61,
        "y": 70,
        "territory": "M003",
        "arrowReceiver": {
          "x": 61,
          "y": 100
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 61,
        "y": 70,
        "territory": "M003",
        "arrowReceiver": {
          "x": 61,
          "y": 100
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M004": {
    "abbr": "HAI",
    "type": "Coast",
    "centerPos": {
      "x": 25,
      "y": 29
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 42,
        "y": 26,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 59,
    "height": 55,
    "x": 707,
    "y": 824,
    "playable": true,
    "path": "M 59.00 0.00 L 56.00 0.00 L 53.00 2.00 L 33.00 2.00 L 31.00 6.00 L 31.00 12.00 L 19.00 26.00 L 20.00 43.00 L 13.00 51.00 L 3.00 51.00 L 0.00 52.00 L 0.00 54.00 L 13.00 54.00 L 14.00 55.00 L 43.00 54.00 L 48.00 44.00 L 53.00 39.00 L 56.00 38.00 L 59.00 33.00 Z",
    "province": "M004",
    "rootTerritory": "M004",
    "viewBox": "0 0 59 55",
    "unitSlots": [
      {
        "name": "main",
        "x": 28,
        "y": 26,
        "territory": "M004",
        "arrowReceiver": {
          "x": 28,
          "y": 56
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 28,
        "y": 26,
        "territory": "M004",
        "arrowReceiver": {
          "x": 28,
          "y": 56
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M005": {
    "abbr": "WIN",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 34,
        "y": 37,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 68,
    "height": 99,
    "x": 879,
    "y": 875,
    "playable": true,
    "path": "M 66.00 0.00 L 62.00 0.00 L 61.00 1.00 L 20.00 1.00 L 9.00 7.00 L 9.00 13.00 L 0.00 21.00 L 1.00 99.00 L 21.00 99.00 L 28.00 95.00 L 62.00 96.00 L 64.00 92.00 L 63.00 87.00 L 67.00 84.00 L 67.00 76.00 L 68.00 75.00 L 68.00 2.00 Z",
    "province": "M005",
    "rootTerritory": "M005",
    "viewBox": "0 0 68 99",
    "unitSlots": [
      {
        "name": "main",
        "x": 26,
        "y": 78,
        "territory": "M005",
        "arrowReceiver": {
          "x": 26,
          "y": 108
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 26,
        "y": 78,
        "territory": "M005",
        "arrowReceiver": {
          "x": 26,
          "y": 108
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_50_a": {
    "abbr": "FIS",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 28,
        "y": 44,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 64,
    "height": 79,
    "x": 534,
    "y": 727,
    "playable": true,
    "path": "M 4.00 3.00 L 0.00 77.00 L 3.00 76.00 L 5.00 71.00 L 56.00 70.00 L 57.00 71.00 L 57.00 79.00 L 63.00 78.00 L 62.00 40.00 L 63.00 39.00 L 63.00 29.00 L 64.00 28.00 L 64.00 15.00 L 58.00 12.00 L 51.00 11.00 L 46.00 3.00 L 44.00 3.00 L 41.00 8.00 L 40.00 18.00 L 38.00 20.00 L 34.00 16.00 L 24.00 0.00 Z",
    "province": "REGION_50_a",
    "rootTerritory": "REGION_50_a",
    "viewBox": "0 0 64 79",
    "unitSlots": [
      {
        "name": "main",
        "x": 32,
        "y": 41,
        "territory": "REGION_50_a",
        "arrowReceiver": {
          "x": 32,
          "y": 71
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 32,
        "y": 41,
        "territory": "REGION_50_a",
        "arrowReceiver": {
          "x": 32,
          "y": 71
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_49_a": {
    "abbr": "CVB",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 156,
        "y": 101,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 209,
    "height": 160,
    "x": 568,
    "y": 680,
    "playable": true,
    "path": "M 0.000 0.000 L 0.000 16.000 L 5.000 25.000 L 6.000 39.000 L 10.000 51.000 L 15.000 59.000 L 25.000 61.000 L 29.000 64.000 L 28.000 84.000 L 27.000 85.000 L 27.000 108.000 L 28.000 109.000 L 26.687 133.733 L 29.177 134.219 L 52.838 138.832 L 58.594 139.954 L 65.525 141.305 L 73.000 136.000 L 98.000 137.000 L 110.000 150.000 L 141.000 150.000 L 143.210 155.814 L 165.664 159.584 L 165.664 159.584 L 165.664 159.584 L 165.664 159.584 L 171.000 158.000 L 171.000 152.000 L 174.000 147.000 L 194.000 147.000 L 204.000 141.000 L 209.000 141.000 L 209.000 120.000 L 208.000 119.000 L 207.000 101.000 L 206.000 100.000 L 206.000 85.000 L 203.000 80.000 L 201.000 53.000 L 193.000 45.000 L 170.000 46.000 L 167.000 43.000 L 163.000 43.000 L 159.000 47.000 L 158.000 46.000 L 140.000 47.000 L 132.000 56.000 L 63.000 56.000 L 62.000 55.000 L 61.000 10.000 L 56.314 1.228 L 56.314 1.228 Z",
    "province": "REGION_49_a",
    "rootTerritory": "REGION_49_a",
    "viewBox": "0 0 209 160",
    "unitSlots": [
      {
        "name": "main",
        "x": 112,
        "y": 116,
        "territory": "REGION_49_a",
        "arrowReceiver": {
          "x": 112,
          "y": 146
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 112,
        "y": 116,
        "territory": "REGION_49_a",
        "arrowReceiver": {
          "x": 112,
          "y": 146
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M006": {
    "abbr": "STC",
    "type": "Coast",
    "centerPos": {
      "x": 27,
      "y": 1
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 22,
        "y": 18,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 79,
    "height": 40,
    "x": 632,
    "y": 815,
    "playable": true,
    "path": "M 0.00 7.00 L 0.00 9.00 L 3.00 9.00 L 5.00 12.00 L 5.00 28.00 L 10.00 32.00 L 10.00 38.00 L 14.00 38.00 L 15.00 39.00 L 22.00 39.00 L 23.00 40.00 L 26.00 40.00 L 30.00 34.00 L 35.00 33.00 L 36.00 32.00 L 39.00 32.00 L 40.00 31.00 L 41.00 32.00 L 44.00 26.00 L 57.00 27.00 L 69.00 20.00 L 79.00 21.00 L 79.00 14.00 L 48.00 14.00 L 36.00 1.00 L 7.00 0.00 Z",
    "province": "M006",
    "rootTerritory": "M006",
    "viewBox": "0 0 79 40",
    "unitSlots": [
      {
        "name": "main",
        "x": 24,
        "y": 25,
        "territory": "M006",
        "arrowReceiver": {
          "x": 24,
          "y": 55
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 24,
        "y": 25,
        "territory": "M006",
        "arrowReceiver": {
          "x": 24,
          "y": 55
        }
      }
    },
    "texture": {
      "texture": "#E19EAA",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M007": {
    "abbr": "HAV",
    "type": "Coast",
    "centerPos": {
      "x": 33,
      "y": -1
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 24,
        "y": 16,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 70,
    "height": 36,
    "x": 522,
    "y": 796,
    "playable": true,
    "path": "M 70.00 0.00 L 15.00 1.00 L 14.00 5.00 L 0.00 20.00 L 0.00 33.00 L 2.00 36.00 L 17.00 36.00 L 42.00 23.00 L 48.00 24.00 L 49.00 25.00 L 68.00 25.00 L 68.00 24.00 L 70.00 23.00 Z",
    "province": "M007",
    "rootTerritory": "M007",
    "viewBox": "0 0 70 36",
    "unitSlots": [
      {
        "name": "main",
        "x": 34,
        "y": 6,
        "territory": "M007",
        "arrowReceiver": {
          "x": 34,
          "y": 36
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 34,
        "y": 6,
        "territory": "M007",
        "arrowReceiver": {
          "x": 34,
          "y": 36
        }
      }
    },
    "texture": {
      "texture": "#E19EAA",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_62_a": {
    "abbr": "GCH",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 71,
        "y": 65,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 139,
    "height": 167,
    "x": 403,
    "y": 1009,
    "playable": true,
    "path": "M 9.342 0.164 L 8.666 6.974 L 8.579 8.047 L 7.526 20.962 L 7.438 22.035 L 6.385 34.951 L 6.298 36.024 L 4.671 55.974 L 4.584 57.046 L 3.000 85.000 L 2.000 86.000 L 2.000 96.000 L 0.000 100.000 L 0.000 108.000 L 3.000 111.000 L 17.000 111.000 L 18.000 112.000 L 32.000 112.000 L 33.000 113.000 L 33.000 132.000 L 34.000 133.000 L 34.000 151.000 L 35.000 152.000 L 33.246 164.997 L 131.751 166.719 L 132.374 156.023 L 132.436 154.967 L 133.656 134.039 L 133.718 132.983 L 134.705 116.042 L 134.767 114.986 L 135.464 103.027 L 135.525 101.971 L 136.223 90.013 L 136.284 88.957 L 137.214 73.013 L 137.275 71.957 L 138.379 53.022 L 138.441 51.967 L 138.951 43.219 L 124.000 33.000 L 124.000 24.000 L 122.000 24.000 L 102.000 4.000 L 95.000 4.000 L 91.000 2.000 L 88.000 2.000 L 87.000 3.000 L 64.000 3.000 L 63.000 2.000 L 28.000 2.000 L 27.000 1.000 Z",
    "province": "REGION_62_a",
    "rootTerritory": "REGION_62_a",
    "viewBox": "0 0 139 167",
    "unitSlots": [
      {
        "name": "main",
        "x": 76,
        "y": 51,
        "territory": "REGION_62_a",
        "arrowReceiver": {
          "x": 76,
          "y": 81
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 76,
        "y": 51,
        "territory": "REGION_62_a",
        "arrowReceiver": {
          "x": 76,
          "y": 81
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_62_b_a": {
    "abbr": "AEM",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 39,
        "y": 39,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 76,
    "height": 83,
    "x": 504,
    "y": 939,
    "playable": true,
    "path": "M 15.000 0.000 L 12.000 6.000 L 6.000 13.000 L 7.000 28.000 L 0.000 35.000 L 0.000 55.000 L 13.000 68.000 L 20.000 83.000 L 22.000 83.000 L 22.000 79.000 L 24.000 77.000 L 57.000 78.000 L 65.000 80.000 L 72.000 80.000 L 71.174 65.705 L 71.678 59.053 L 71.916 55.917 L 73.424 36.033 L 73.662 32.898 L 75.922 3.098 Z",
    "province": "REGION_62_b_a",
    "rootTerritory": "REGION_62_b_a",
    "viewBox": "0 0 76 83",
    "unitSlots": [
      {
        "name": "main",
        "x": 35,
        "y": 36,
        "territory": "REGION_62_b_a",
        "arrowReceiver": {
          "x": 35,
          "y": 66
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 35,
        "y": 36,
        "territory": "REGION_62_b_a",
        "arrowReceiver": {
          "x": 35,
          "y": 66
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_65_a": {
    "abbr": "GOP",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 41,
        "y": 42,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 79,
    "height": 129,
    "x": 534,
    "y": 1049,
    "playable": true,
    "path": "M 68.000 0.000 L 59.000 0.000 L 56.000 2.000 L 45.000 2.000 L 44.000 3.000 L 27.000 3.000 L 26.000 4.000 L 7.951 3.219 L 7.951 3.219 L 5.807 39.989 L 5.746 41.043 L 4.990 54.000 L 4.929 55.053 L 4.232 67.013 L 4.170 68.067 L 3.473 80.027 L 3.411 81.081 L 0.751 126.719 L 38.000 129.000 L 45.000 119.000 L 52.000 119.000 L 55.000 117.000 L 55.000 115.000 L 50.000 112.000 L 50.000 96.000 L 76.000 70.000 L 75.000 55.000 L 76.000 54.000 L 76.000 45.000 L 77.000 44.000 L 77.000 32.000 L 79.000 29.000 L 79.000 26.000 L 69.000 17.000 Z",
    "province": "REGION_65_a",
    "rootTerritory": "REGION_65_a",
    "viewBox": "0 0 79 129",
    "unitSlots": [
      {
        "name": "main",
        "x": 41,
        "y": 70,
        "territory": "REGION_65_a",
        "arrowReceiver": {
          "x": 41,
          "y": 100
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 41,
        "y": 70,
        "territory": "REGION_65_a",
        "arrowReceiver": {
          "x": 41,
          "y": 100
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_97_a": {
    "abbr": "GOU",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 49,
        "y": 41,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 108,
    "height": 101,
    "x": 575,
    "y": 941,
    "playable": true,
    "path": "M 4.922 1.098 L 4.478 6.959 L 4.397 8.031 L 3.416 20.954 L 3.335 22.027 L 1.896 40.992 L 1.815 42.064 L 0.609 57.969 L 0.527 59.041 L 0.174 63.705 L 0.174 63.705 L 10.000 65.000 L 14.000 67.000 L 26.000 76.000 L 36.000 82.000 L 48.000 94.000 L 55.000 95.000 L 60.000 98.000 L 60.000 101.000 L 62.000 101.000 L 73.000 88.000 L 73.000 80.000 L 80.000 74.000 L 83.000 65.000 L 88.000 61.000 L 100.000 60.000 L 108.000 51.000 L 107.493 3.139 L 96.024 2.537 L 94.975 2.482 L 52.648 0.162 L 52.648 0.162 Z",
    "province": "REGION_97_a",
    "rootTerritory": "REGION_97_a",
    "viewBox": "0 0 108 101",
    "unitSlots": [
      {
        "name": "main",
        "x": 49,
        "y": 8,
        "territory": "REGION_97_a",
        "arrowReceiver": {
          "x": 49,
          "y": 38
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 49,
        "y": 8,
        "territory": "REGION_97_a",
        "arrowReceiver": {
          "x": 49,
          "y": 38
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M008": {
    "abbr": "PAN",
    "type": "Coast",
    "centerPos": {
      "x": 33,
      "y": 12
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 24,
        "y": 29,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 99,
    "height": 48,
    "x": 525,
    "y": 1006,
    "playable": true,
    "path": "M 99.00 27.00 L 89.00 17.00 L 64.00 0.00 L 50.00 0.00 L 50.00 11.00 L 49.00 12.00 L 39.00 11.00 L 38.00 10.00 L 22.00 10.00 L 21.00 9.00 L 1.00 9.00 L 0.00 10.00 L 1.00 38.00 L 17.00 48.00 L 55.00 47.00 L 56.00 46.00 L 67.00 46.00 L 70.00 44.00 L 77.00 44.00 L 76.00 35.00 L 79.00 31.00 L 97.00 30.00 L 99.00 29.00 Z",
    "province": "M008",
    "rootTerritory": "M008",
    "viewBox": "0 0 99 48",
    "unitSlots": [
      {
        "name": "main",
        "x": 55,
        "y": 24,
        "territory": "M008",
        "arrowReceiver": {
          "x": 55,
          "y": 54
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 55,
        "y": 24,
        "territory": "M008",
        "arrowReceiver": {
          "x": 55,
          "y": 54
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_76_a": {
    "abbr": "FAC",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 54,
        "y": 39,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 158,
    "height": 74,
    "x": 661,
    "y": 1790,
    "playable": true,
    "path": "M 157.781 0.389 L 134.000 0.000 L 133.000 1.000 L 91.000 2.000 L 90.000 3.000 L 63.000 3.000 L 62.000 4.000 L 55.000 4.000 L 52.000 6.000 L 48.000 4.000 L 38.000 4.000 L 35.000 15.000 L 26.000 26.000 L 1.000 38.000 L 0.000 41.000 L 2.000 43.000 L 5.000 43.000 L 29.000 56.000 L 37.000 64.000 L 34.464 73.972 L 85.953 69.005 L 83.000 63.000 L 84.000 37.000 L 85.000 36.000 L 85.000 27.000 L 86.000 26.000 L 153.890 27.023 L 155.392 16.745 Z",
    "province": "REGION_76_a",
    "rootTerritory": "REGION_76_a",
    "viewBox": "0 0 158 74",
    "unitSlots": [
      {
        "name": "main",
        "x": 84,
        "y": 22,
        "territory": "REGION_76_a",
        "arrowReceiver": {
          "x": 84,
          "y": 52
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 84,
        "y": 22,
        "territory": "REGION_76_a",
        "arrowReceiver": {
          "x": 84,
          "y": 52
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_167_a": {
    "abbr": "PTG",
    "type": "Coast",
    "centerPos": {
      "x": 31,
      "y": 54
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 48,
        "y": 47,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 115,
    "height": 118,
    "x": 624,
    "y": 1726,
    "playable": true,
    "path": "M 111.00 12.00 L 100.00 6.00 L 84.00 5.00 L 80.00 0.00 L 68.00 0.00 L 63.00 3.00 L 49.00 4.00 L 41.00 13.00 L 24.00 12.00 L 19.00 25.00 L 12.00 34.00 L 13.00 47.00 L 10.00 52.00 L 0.00 63.00 L 0.00 67.00 L 3.00 70.00 L 12.00 72.00 L 12.00 88.00 L 1.00 112.00 L 1.00 117.00 L 2.00 118.00 L 15.00 118.00 L 24.00 109.00 L 24.00 103.00 L 25.00 102.00 L 35.00 102.00 L 37.00 104.00 L 39.00 104.00 L 65.00 91.00 L 73.00 81.00 L 77.00 68.00 L 81.00 64.00 L 92.00 59.00 L 107.00 42.00 L 115.00 38.00 L 114.00 18.00 Z",
    "province": "REGION_167_a",
    "rootTerritory": "REGION_167_a",
    "viewBox": "0 0 115 118",
    "unitSlots": [
      {
        "name": "main",
        "x": 72,
        "y": 23,
        "territory": "REGION_167_a",
        "arrowReceiver": {
          "x": 72,
          "y": 53
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 72,
        "y": 23,
        "territory": "REGION_167_a",
        "arrowReceiver": {
          "x": 72,
          "y": 53
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_175_b": {
    "abbr": "TCH",
    "type": "Coast",
    "centerPos": {
      "x": 15,
      "y": 36
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 32,
        "y": 37,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 62,
    "height": 58,
    "x": 623,
    "y": 1679,
    "playable": true,
    "path": "M 18.00 0.00 L 0.00 21.00 L 0.00 24.00 L 9.00 24.00 L 10.00 25.00 L 11.00 48.00 L 13.00 54.00 L 19.00 55.00 L 24.00 58.00 L 41.00 58.00 L 53.00 49.00 L 55.00 34.00 L 62.00 26.00 L 62.00 23.00 L 51.00 23.00 L 39.00 17.00 L 38.00 15.00 L 33.00 15.00 L 25.00 11.00 L 23.00 9.00 L 23.00 0.00 Z",
    "province": "REGION_175_b",
    "rootTerritory": "REGION_175_b",
    "viewBox": "0 0 62 58",
    "unitSlots": [
      {
        "name": "main",
        "x": 28,
        "y": 14,
        "territory": "REGION_175_b",
        "arrowReceiver": {
          "x": 28,
          "y": 44
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 28,
        "y": 14,
        "territory": "REGION_175_b",
        "arrowReceiver": {
          "x": 28,
          "y": 44
        }
      }
    },
    "texture": {
      "texture": "#D4BCAE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_175_a_a": {
    "abbr": "VPS",
    "type": "Coast",
    "centerPos": {
      "x": -2,
      "y": 55
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 15,
        "y": 60,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 56,
    "height": 94,
    "x": 645,
    "y": 1601,
    "playable": true,
    "path": "M 54.00 0.00 L 29.00 1.00 L 25.00 6.00 L 17.00 39.00 L 4.00 56.00 L 5.00 66.00 L 0.00 75.00 L 0.00 89.00 L 9.00 94.00 L 16.00 94.00 L 15.00 84.00 L 25.00 66.00 L 26.00 59.00 L 48.00 7.00 L 56.00 7.00 L 56.00 4.00 Z",
    "province": "REGION_175_a_a",
    "rootTerritory": "REGION_175_a_a",
    "viewBox": "0 0 56 94",
    "unitSlots": [
      {
        "name": "main",
        "x": 13,
        "y": 56,
        "territory": "REGION_175_a_a",
        "arrowReceiver": {
          "x": 13,
          "y": 86
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 13,
        "y": 56,
        "territory": "REGION_175_a_a",
        "arrowReceiver": {
          "x": 13,
          "y": 86
        }
      }
    },
    "texture": {
      "texture": "#D4BCAE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_175_a_b": {
    "abbr": "STD",
    "type": "Land",
    "centerPos": {
      "x": 3,
      "y": 36
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 20,
        "y": 77,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 57,
    "height": 96,
    "x": 659,
    "y": 1607,
    "playable": true,
    "path": "M 57.00 4.00 L 49.00 3.00 L 45.00 0.00 L 32.00 0.00 L 11.00 51.00 L 10.00 58.00 L 0.00 76.00 L 1.00 90.00 L 13.00 96.00 L 27.00 96.00 L 30.00 93.00 L 33.00 92.00 L 38.00 82.00 L 38.00 63.00 L 35.00 58.00 L 36.00 50.00 L 38.00 46.00 L 57.00 27.00 L 57.00 10.00 L 56.00 9.00 Z",
    "province": "REGION_175_a_b",
    "rootTerritory": "REGION_175_a_b",
    "viewBox": "0 0 57 96",
    "unitSlots": [
      {
        "name": "main",
        "x": 13,
        "y": 68,
        "territory": "REGION_175_a_b",
        "arrowReceiver": {
          "x": 13,
          "y": 98
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 13,
        "y": 68,
        "territory": "REGION_175_a_b",
        "arrowReceiver": {
          "x": 13,
          "y": 98
        }
      }
    },
    "texture": {
      "texture": "#D4BCAE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_173_a": {
    "abbr": "ARE",
    "type": "Coast",
    "centerPos": {
      "x": 79,
      "y": 16
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 70,
        "y": 33,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 109,
    "height": 65,
    "x": 638,
    "y": 1404,
    "playable": true,
    "path": "M 0.00 11.00 L 0.00 24.00 L 2.00 27.00 L 21.00 35.00 L 28.00 44.00 L 46.00 43.00 L 50.00 45.00 L 66.00 65.00 L 68.00 65.00 L 68.00 61.00 L 72.00 57.00 L 78.00 56.00 L 95.00 47.00 L 103.00 47.00 L 105.00 51.00 L 107.00 51.00 L 109.00 47.00 L 109.00 31.00 L 104.00 24.00 L 83.00 14.00 L 75.00 8.00 L 63.00 7.00 L 50.00 0.00 L 36.00 0.00 L 23.00 13.00 L 19.00 8.00 L 3.00 8.00 Z",
    "province": "REGION_173_a",
    "rootTerritory": "REGION_173_a",
    "viewBox": "0 0 109 65",
    "unitSlots": [
      {
        "name": "main",
        "x": 38,
        "y": 15,
        "territory": "REGION_173_a",
        "arrowReceiver": {
          "x": 38,
          "y": 45
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 38,
        "y": 15,
        "territory": "REGION_173_a",
        "arrowReceiver": {
          "x": 38,
          "y": 45
        }
      }
    },
    "texture": {
      "texture": "#E8A7C1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_173_b": {
    "abbr": "TRP",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 25,
        "y": 40,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 54,
    "height": 66,
    "x": 703,
    "y": 1450,
    "playable": true,
    "path": "M 40.00 0.00 L 28.00 0.00 L 11.00 9.00 L 5.00 10.00 L 2.00 13.00 L 0.00 47.00 L 1.00 48.00 L 1.00 63.00 L 3.00 66.00 L 32.00 66.00 L 42.00 61.00 L 45.00 55.00 L 54.00 47.00 L 54.00 33.00 L 46.00 24.00 L 44.00 8.00 Z",
    "province": "REGION_173_b",
    "rootTerritory": "REGION_173_b",
    "viewBox": "0 0 54 66",
    "unitSlots": [
      {
        "name": "main",
        "x": 20,
        "y": 29,
        "territory": "REGION_173_b",
        "arrowReceiver": {
          "x": 20,
          "y": 59
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 20,
        "y": 29,
        "territory": "REGION_173_b",
        "arrowReceiver": {
          "x": 20,
          "y": 59
        }
      }
    },
    "texture": {
      "texture": "#E8A7C1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_60_a": {
    "abbr": "GOF",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 50,
        "y": 43,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 109,
    "height": 67,
    "x": 381,
    "y": 945,
    "playable": true,
    "path": "M 3.000 0.000 L 2.000 27.000 L 0.000 30.000 L 0.864 51.134 L 0.864 51.134 L 7.587 53.987 L 31.342 64.164 L 50.000 65.000 L 51.000 66.000 L 88.000 66.000 L 89.000 67.000 L 108.000 67.000 L 109.000 66.000 L 109.000 65.000 L 106.000 63.000 L 106.000 61.000 L 102.000 54.000 L 103.000 51.000 L 105.000 49.000 L 105.000 36.000 L 94.000 32.000 L 82.000 19.000 L 79.000 19.000 L 77.000 21.000 L 65.000 21.000 L 61.000 17.000 L 51.000 17.000 L 38.000 10.000 L 36.000 10.000 L 35.000 9.000 L 30.000 9.000 L 25.000 6.000 L 19.000 6.000 L 14.000 3.000 L 7.000 2.000 L 5.000 0.000 Z",
    "province": "REGION_60_a",
    "rootTerritory": "REGION_60_a",
    "viewBox": "0 0 109 67",
    "unitSlots": [
      {
        "name": "main",
        "x": 46,
        "y": 45,
        "territory": "REGION_60_a",
        "arrowReceiver": {
          "x": 46,
          "y": 75
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 46,
        "y": 45,
        "territory": "REGION_60_a",
        "arrowReceiver": {
          "x": 46,
          "y": 75
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M013": {
    "abbr": "AMZ",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 117,
        "y": 146,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 189,
    "height": 201,
    "x": 671,
    "y": 1138,
    "playable": true,
    "path": "M 178.00 8.00 L 171.00 1.00 L 167.00 0.00 L 164.00 4.00 L 145.00 17.00 L 140.00 16.00 L 131.00 16.00 L 128.00 18.00 L 129.00 34.00 L 134.00 38.00 L 134.00 60.00 L 138.00 67.00 L 137.00 72.00 L 135.00 74.00 L 130.00 74.00 L 112.00 83.00 L 97.00 99.00 L 83.00 100.00 L 77.00 107.00 L 58.00 108.00 L 51.00 104.00 L 35.00 104.00 L 34.00 108.00 L 32.00 110.00 L 22.00 109.00 L 18.00 111.00 L 9.00 118.00 L 7.00 135.00 L 0.00 144.00 L 0.00 156.00 L 13.00 159.00 L 19.00 163.00 L 29.00 164.00 L 40.00 170.00 L 54.00 172.00 L 96.00 194.00 L 100.00 194.00 L 107.00 201.00 L 140.00 199.00 L 142.00 194.00 L 149.00 186.00 L 170.00 178.00 L 173.00 173.00 L 181.00 166.00 L 181.00 164.00 L 176.00 164.00 L 168.00 147.00 L 168.00 134.00 L 167.00 133.00 L 167.00 124.00 L 166.00 123.00 L 167.00 103.00 L 172.00 95.00 L 188.00 77.00 L 188.00 70.00 L 189.00 69.00 L 189.00 61.00 L 178.00 49.00 L 175.00 43.00 L 176.00 16.00 L 178.00 13.00 Z",
    "province": "M013",
    "rootTerritory": "M013",
    "viewBox": "0 0 189 201",
    "unitSlots": [
      {
        "name": "main",
        "x": 85,
        "y": 148,
        "territory": "M013",
        "arrowReceiver": {
          "x": 85,
          "y": 178
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 85,
        "y": 148,
        "territory": "M013",
        "arrowReceiver": {
          "x": 85,
          "y": 178
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M014": {
    "abbr": "MAN",
    "type": "Land",
    "centerPos": {
      "x": 34,
      "y": 185
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 51,
        "y": 178,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 123,
    "height": 234,
    "x": 828,
    "y": 1078,
    "playable": true,
    "path": "M 78.00 0.00 L 67.00 0.00 L 61.00 3.00 L 52.00 17.00 L 30.00 28.00 L 28.00 28.00 L 19.00 23.00 L 1.00 23.00 L 0.00 24.00 L 0.00 48.00 L 3.00 54.00 L 20.00 70.00 L 18.00 74.00 L 17.00 105.00 L 20.00 111.00 L 31.00 123.00 L 30.00 135.00 L 14.00 153.00 L 9.00 161.00 L 8.00 185.00 L 9.00 186.00 L 9.00 195.00 L 10.00 196.00 L 10.00 209.00 L 17.00 225.00 L 23.00 225.00 L 33.00 234.00 L 97.00 234.00 L 103.00 224.00 L 103.00 222.00 L 92.00 208.00 L 92.00 191.00 L 117.00 152.00 L 117.00 139.00 L 120.00 138.00 L 123.00 131.00 L 123.00 127.00 L 117.00 123.00 L 110.00 122.00 L 100.00 111.00 L 95.00 110.00 L 90.00 103.00 L 90.00 71.00 L 96.00 65.00 L 96.00 62.00 L 89.00 58.00 L 85.00 52.00 L 84.00 48.00 L 92.00 33.00 L 92.00 19.00 L 83.00 11.00 L 82.00 3.00 Z",
    "province": "M014",
    "rootTerritory": "M014",
    "viewBox": "0 0 123 234",
    "unitSlots": [
      {
        "name": "main",
        "x": 59,
        "y": 160,
        "territory": "M014",
        "arrowReceiver": {
          "x": 59,
          "y": 190
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 59,
        "y": 160,
        "territory": "M014",
        "arrowReceiver": {
          "x": 59,
          "y": 190
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M016": {
    "abbr": "PAR",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 94,
        "y": 109,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 185,
    "height": 229,
    "x": 917,
    "y": 1087,
    "playable": true,
    "path": "M 127.00 0.00 L 114.00 0.00 L 110.00 4.00 L 102.00 22.00 L 95.00 31.00 L 81.00 32.00 L 77.00 29.00 L 53.00 30.00 L 42.00 41.00 L 22.00 43.00 L 12.00 48.00 L 0.00 60.00 L 0.00 96.00 L 4.00 102.00 L 9.00 103.00 L 19.00 114.00 L 26.00 115.00 L 33.00 120.00 L 30.00 127.00 L 27.00 128.00 L 27.00 141.00 L 2.00 180.00 L 2.00 201.00 L 22.00 226.00 L 106.00 229.00 L 129.00 197.00 L 130.00 179.00 L 145.00 165.00 L 144.00 150.00 L 168.00 129.00 L 181.00 103.00 L 182.00 93.00 L 185.00 88.00 L 185.00 74.00 L 172.00 74.00 L 167.00 68.00 L 153.00 68.00 L 152.00 67.00 L 142.00 67.00 L 141.00 66.00 L 148.00 59.00 L 149.00 37.00 L 137.00 26.00 L 133.00 4.00 Z",
    "province": "M016",
    "rootTerritory": "M016",
    "viewBox": "0 0 185 229",
    "unitSlots": [
      {
        "name": "main",
        "x": 80,
        "y": 73,
        "territory": "M016",
        "arrowReceiver": {
          "x": 80,
          "y": 103
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 80,
        "y": 73,
        "territory": "M016",
        "arrowReceiver": {
          "x": 80,
          "y": 103
        }
      }
    },
    "texture": {
      "texture": "#B0CEB1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M015": {
    "abbr": "MVS",
    "type": "Coast",
    "centerPos": {
      "x": 31,
      "y": 16
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 48,
        "y": 9,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 95,
    "height": 68,
    "x": 743,
    "y": 1815,
    "playable": true,
    "path": "M 2.00 0.00 L 0.00 40.00 L 3.00 45.00 L 2.00 63.00 L 5.00 68.00 L 94.00 68.00 L 95.00 67.00 L 95.00 1.00 Z",
    "province": "M015",
    "rootTerritory": "M015",
    "viewBox": "0 0 95 68",
    "unitSlots": [
      {
        "name": "main",
        "x": 41,
        "y": 17,
        "territory": "M015",
        "arrowReceiver": {
          "x": 41,
          "y": 47
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 41,
        "y": 17,
        "territory": "M015",
        "arrowReceiver": {
          "x": 41,
          "y": 47
        }
      }
    },
    "texture": {
      "texture": "#A8ABCE",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_64_a_a": {
    "abbr": "MPO",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 186,
        "y": 339,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 357,
    "height": 444,
    "x": 56,
    "y": 724,
    "playable": true,
    "path": "M 29.881 0.215 L 29.436 4.947 L 29.334 6.031 L 28.123 18.917 L 28.021 20.002 L 27.276 27.932 L 27.174 29.016 L 26.429 36.946 L 26.327 38.031 L 25.582 45.961 L 25.480 47.046 L 23.422 68.946 L 23.320 70.030 L 21.635 87.966 L 21.533 89.050 L 20.229 102.927 L 20.127 104.012 L 19.382 111.942 L 19.280 113.026 L 17.781 128.980 L 17.679 130.064 L 16.469 142.950 L 16.367 144.035 L 15.342 154.938 L 15.240 156.023 L 14.122 167.917 L 14.021 169.002 L 12.335 186.937 L 12.233 188.022 L 11.395 196.943 L 11.293 198.027 L 10.455 206.948 L 10.353 208.033 L 9.422 217.945 L 9.320 219.031 L 8.295 229.934 L 8.193 231.019 L 7.448 238.948 L 7.346 240.033 L 6.601 247.963 L 6.499 249.047 L 5.381 260.942 L 5.279 262.026 L 4.627 268.965 L 4.526 270.049 L 3.128 284.918 L 3.027 286.002 L 2.188 294.923 L 2.086 296.008 L 1.434 302.947 L 1.332 304.031 L 0.587 311.961 L 0.485 313.046 L 0.092 317.236 L 29.000 318.000 L 34.000 321.000 L 46.000 321.000 L 47.000 322.000 L 70.000 322.000 L 71.000 323.000 L 82.000 323.000 L 87.000 329.000 L 87.000 388.000 L 86.000 389.000 L 85.975 400.662 L 88.000 409.232 L 90.068 417.985 L 90.843 421.267 L 92.340 428.006 L 98.953 428.492 L 100.038 428.594 L 114.908 429.979 L 115.993 430.080 L 122.932 430.726 L 124.016 430.827 L 130.956 431.474 L 132.040 431.575 L 141.953 432.498 L 143.038 432.599 L 151.960 433.430 L 153.044 433.531 L 160.975 434.270 L 162.060 434.371 L 172.964 435.387 L 174.048 435.488 L 187.926 436.781 L 189.012 436.882 L 201.992 438.091 L 203.076 438.192 L 215.963 439.393 L 217.047 439.494 L 226.960 440.417 L 228.046 440.518 L 235.975 441.257 L 237.060 441.358 L 245.982 442.189 L 247.066 442.290 L 263.989 443.867 L 262.000 432.000 L 266.000 428.000 L 267.000 428.000 L 274.000 421.000 L 275.000 421.000 L 283.000 413.000 L 284.000 413.000 L 339.000 364.000 L 349.957 361.996 L 350.200 359.016 L 350.288 357.943 L 352.400 332.032 L 352.488 330.959 L 353.055 324.005 L 353.142 322.931 L 354.276 309.022 L 354.364 307.949 L 355.498 294.039 L 355.585 292.967 L 356.342 285.164 L 335.490 276.219 L 329.548 273.697 L 325.864 272.134 L 325.864 272.134 L 317.000 275.000 L 316.000 274.000 L 296.000 274.000 L 291.000 271.000 L 258.000 270.000 L 254.000 265.000 L 254.000 221.000 L 252.000 218.000 L 222.000 217.000 L 221.000 216.000 L 211.000 216.000 L 208.000 214.000 L 190.000 214.000 L 187.000 212.000 L 179.000 212.000 L 170.000 207.000 L 111.000 204.000 L 110.000 203.000 L 107.000 203.000 L 106.000 202.000 L 95.000 199.000 L 93.000 197.000 L 94.000 162.000 L 97.000 157.000 L 97.000 149.000 L 99.000 146.000 L 102.000 93.000 L 90.000 94.000 L 86.000 89.000 L 70.000 87.000 L 66.000 84.000 L 66.000 77.000 L 67.000 76.000 L 67.000 60.000 L 68.000 59.000 L 68.000 51.000 L 69.000 50.000 L 69.000 42.000 L 67.000 39.000 L 67.000 29.000 L 45.000 6.000 L 45.000 0.000 Z",
    "province": "REGION_64_a_a",
    "rootTerritory": "REGION_64_a_a",
    "viewBox": "0 0 357 444",
    "unitSlots": [
      {
        "name": "main",
        "x": 174,
        "y": 288,
        "territory": "REGION_64_a_a",
        "arrowReceiver": {
          "x": 174,
          "y": 318
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 174,
        "y": 288,
        "territory": "REGION_64_a_a",
        "arrowReceiver": {
          "x": 174,
          "y": 318
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_64_a_b": {
    "abbr": "GAL",
    "type": "Coast",
    "centerPos": {
      "x": 50,
      "y": 82
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 67,
        "y": 75,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 122,
    "height": 128,
    "x": 317,
    "y": 1087,
    "playable": true,
    "path": "M 88.00 0.00 L 76.00 0.00 L 0.00 67.00 L 0.00 81.00 L 8.00 81.00 L 11.00 83.00 L 11.00 127.00 L 104.00 128.00 L 105.00 127.00 L 118.00 127.00 L 119.00 126.00 L 120.00 88.00 L 122.00 86.00 L 120.00 33.00 L 91.00 32.00 L 87.00 28.00 L 89.00 21.00 L 89.00 1.00 Z",
    "province": "REGION_64_a_b",
    "rootTerritory": "REGION_64_a_b",
    "viewBox": "0 0 122 128",
    "unitSlots": [
      {
        "name": "main",
        "x": 86,
        "y": 106,
        "territory": "REGION_64_a_b",
        "arrowReceiver": {
          "x": 86,
          "y": 136
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 86,
        "y": 106,
        "territory": "REGION_64_a_b",
        "arrowReceiver": {
          "x": 86,
          "y": 136
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_43_a": {
    "abbr": "GSC",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 33,
        "y": 135,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 71,
    "height": 172,
    "x": 37,
    "y": 553,
    "playable": true,
    "path": "M 26.000 0.000 L 17.000 23.000 L 17.000 56.000 L 11.000 67.000 L 10.000 96.000 L 6.000 100.000 L 7.000 112.000 L 2.000 121.000 L 0.000 161.000 L 16.000 167.000 L 38.000 167.000 L 48.881 171.215 L 64.000 172.000 L 64.000 162.000 L 71.000 154.000 L 68.000 126.000 L 63.000 121.000 L 62.000 111.000 L 45.000 95.000 L 47.000 36.000 L 48.000 35.000 L 58.000 35.000 L 58.000 23.000 L 45.000 3.000 L 39.000 0.000 Z",
    "province": "REGION_43_a",
    "rootTerritory": "REGION_43_a",
    "viewBox": "0 0 71 172",
    "unitSlots": [
      {
        "name": "main",
        "x": 34,
        "y": 147,
        "territory": "REGION_43_a",
        "arrowReceiver": {
          "x": 34,
          "y": 177
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 34,
        "y": 147,
        "territory": "REGION_43_a",
        "arrowReceiver": {
          "x": 34,
          "y": 177
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M019": {
    "abbr": "ALA",
    "type": "Coast",
    "centerPos": {
      "x": 112,
      "y": 67
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 129,
        "y": 60,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 234,
    "height": 191,
    "x": 80,
    "y": 77,
    "playable": true,
    "path": "M 232.00 25.00 L 229.00 21.00 L 226.00 20.00 L 219.00 13.00 L 220.00 3.00 L 215.00 0.00 L 159.00 3.00 L 130.00 21.00 L 112.00 19.00 L 108.00 24.00 L 100.00 26.00 L 97.00 29.00 L 97.00 36.00 L 86.00 45.00 L 64.00 44.00 L 55.00 49.00 L 40.00 51.00 L 38.00 55.00 L 25.00 68.00 L 21.00 77.00 L 12.00 83.00 L 12.00 91.00 L 3.00 99.00 L 2.00 103.00 L 0.00 105.00 L 0.00 120.00 L 3.00 122.00 L 28.00 123.00 L 39.00 114.00 L 42.00 108.00 L 56.00 108.00 L 64.00 103.00 L 71.00 102.00 L 78.00 108.00 L 79.00 120.00 L 82.00 123.00 L 79.00 130.00 L 76.00 188.00 L 82.00 191.00 L 110.00 189.00 L 111.00 188.00 L 111.00 171.00 L 114.00 168.00 L 126.00 144.00 L 125.00 125.00 L 119.00 121.00 L 116.00 116.00 L 132.00 103.00 L 179.00 80.00 L 229.00 45.00 L 234.00 46.00 Z",
    "province": "M019",
    "rootTerritory": "M019",
    "viewBox": "0 0 234 191",
    "unitSlots": [
      {
        "name": "main",
        "x": 117,
        "y": 50,
        "territory": "M019",
        "arrowReceiver": {
          "x": 117,
          "y": 80
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 117,
        "y": 50,
        "territory": "M019",
        "arrowReceiver": {
          "x": 117,
          "y": 80
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M020": {
    "abbr": "WDM",
    "type": "Coast",
    "centerPos": {
      "x": 30,
      "y": 39
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 47,
        "y": 32,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "nc",
        "x": 65.91,
        "y": 21.55,
        "text": "nc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "sc",
        "x": 21.49,
        "y": 72.54,
        "text": "sc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 81,
    "height": 93,
    "x": 374,
    "y": 859,
    "playable": true,
    "path": "M 79.00 0.00 L 61.00 0.00 L 52.00 10.00 L 39.00 10.00 L 33.00 7.00 L 28.00 1.00 L 13.00 0.00 L 11.00 12.00 L 25.00 34.00 L 24.00 39.00 L 22.00 41.00 L 5.00 51.00 L 4.00 70.00 L 0.00 71.00 L 0.00 77.00 L 12.00 89.00 L 19.00 90.00 L 24.00 93.00 L 30.00 93.00 L 30.00 88.00 L 31.00 87.00 L 35.00 87.00 L 37.00 84.00 L 49.00 82.00 L 49.00 70.00 L 51.00 68.00 L 51.00 60.00 L 53.00 56.00 L 56.00 53.00 L 63.00 51.00 L 66.00 46.00 L 70.00 46.00 L 71.00 39.00 L 77.00 34.00 L 78.00 21.00 L 81.00 16.00 L 81.00 2.00 Z",
    "province": "M020",
    "rootTerritory": "M020",
    "viewBox": "0 0 81 93",
    "unitSlots": [
      {
        "name": "main",
        "x": 39,
        "y": 10,
        "territory": "M020",
        "arrowReceiver": {
          "x": 39,
          "y": 40
        }
      },
      {
        "name": "nc",
        "x": 65.91,
        "y": 21.55,
        "territory": "M020_NORTH_COAST",
        "arrowReceiver": {
          "x": 65.91,
          "y": 51.55
        }
      },
      {
        "name": "sc",
        "x": 21.49,
        "y": 72.54,
        "territory": "M020_SOUTH_COAST",
        "arrowReceiver": {
          "x": 21.49,
          "y": 102.54
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 39,
        "y": 10,
        "territory": "M020",
        "arrowReceiver": {
          "x": 39,
          "y": 40
        }
      },
      "nc": {
        "name": "nc",
        "x": 65.91,
        "y": 21.55,
        "territory": "M020_NORTH_COAST",
        "arrowReceiver": {
          "x": 65.91,
          "y": 51.55
        }
      },
      "sc": {
        "name": "sc",
        "x": 21.49,
        "y": 72.54,
        "territory": "M020_SOUTH_COAST",
        "arrowReceiver": {
          "x": 21.49,
          "y": 102.54
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M009": {
    "abbr": "EST",
    "type": "Coast",
    "centerPos": {
      "x": 23,
      "y": 16
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 40,
        "y": 9,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 87,
    "height": 76,
    "x": 134,
    "y": 1644,
    "playable": true,
    "path": "M 3.00 3.00 L 0.00 66.00 L 4.00 73.00 L 22.00 73.00 L 23.00 74.00 L 36.00 75.00 L 37.00 76.00 L 40.00 74.00 L 40.00 64.00 L 41.00 63.00 L 57.00 63.00 L 58.00 62.00 L 74.00 62.00 L 75.00 61.00 L 75.00 59.00 L 76.00 58.00 L 76.00 53.00 L 77.00 52.00 L 77.00 47.00 L 78.00 46.00 L 78.00 42.00 L 79.00 41.00 L 79.00 36.00 L 80.00 35.00 L 80.00 30.00 L 81.00 29.00 L 81.00 27.00 L 87.00 21.00 L 87.00 6.00 L 85.00 2.00 L 48.00 2.00 L 45.00 0.00 L 23.00 0.00 L 20.00 2.00 Z",
    "province": "M009",
    "rootTerritory": "M009",
    "viewBox": "0 0 87 76",
    "unitSlots": [
      {
        "name": "main",
        "x": 50,
        "y": 46,
        "territory": "M009",
        "arrowReceiver": {
          "x": 50,
          "y": 76
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 50,
        "y": 46,
        "territory": "M009",
        "arrowReceiver": {
          "x": 50,
          "y": 76
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M010_a": {
    "abbr": "TDF",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 45,
        "y": 29,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 77,
    "height": 46,
    "x": 622,
    "y": 1832,
    "playable": true,
    "path": "M 77.00 20.00 L 70.00 13.00 L 63.00 10.00 L 54.00 4.00 L 46.00 0.00 L 41.00 0.00 L 40.00 10.00 L 12.00 37.00 L 6.00 40.00 L 0.00 40.00 L 0.00 43.00 L 25.00 41.00 L 34.00 46.00 L 53.00 46.00 L 62.00 35.00 L 75.00 34.00 Z",
    "province": "M010_a",
    "rootTerritory": "M010_a",
    "viewBox": "0 0 77 46",
    "unitSlots": [
      {
        "name": "main",
        "x": 37,
        "y": 23,
        "territory": "M010_a",
        "arrowReceiver": {
          "x": 37,
          "y": 53
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 37,
        "y": 23,
        "territory": "M010_a",
        "arrowReceiver": {
          "x": 37,
          "y": 53
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M010": {
    "abbr": "MGL",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 32,
        "y": 57,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 92,
    "height": 83,
    "x": 572,
    "y": 1791,
    "playable": true,
    "path": "M 92.00 40.00 L 89.00 36.00 L 75.00 36.00 L 75.00 42.00 L 65.00 52.00 L 56.00 52.00 L 54.00 49.00 L 65.00 25.00 L 65.00 5.00 L 60.00 5.00 L 57.00 4.00 L 53.00 0.00 L 50.00 0.00 L 45.00 8.00 L 39.00 14.00 L 29.00 13.00 L 28.00 21.00 L 25.00 27.00 L 1.00 58.00 L 0.00 72.00 L 2.00 72.00 L 4.00 74.00 L 4.00 79.00 L 13.00 78.00 L 15.00 81.00 L 29.00 80.00 L 32.00 83.00 L 58.00 82.00 L 64.00 79.00 L 91.00 53.00 Z",
    "province": "M010",
    "rootTerritory": "M010",
    "viewBox": "0 0 92 83",
    "unitSlots": [
      {
        "name": "main",
        "x": 37,
        "y": 48,
        "territory": "M010",
        "arrowReceiver": {
          "x": 37,
          "y": 78
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 37,
        "y": 48,
        "territory": "M010",
        "arrowReceiver": {
          "x": 37,
          "y": 78
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M023": {
    "abbr": "PNH",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 97,
        "y": 94,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 215,
    "height": 207,
    "x": 470,
    "y": 163,
    "playable": true,
    "path": "M 106.00 0.00 L 102.00 5.00 L 92.00 6.00 L 90.00 19.00 L 86.00 23.00 L 81.00 23.00 L 67.00 39.00 L 54.00 39.00 L 46.00 46.00 L 38.00 47.00 L 30.00 58.00 L 22.00 60.00 L 1.00 83.00 L 0.00 106.00 L 5.00 107.00 L 11.00 111.00 L 14.00 127.00 L 18.00 129.00 L 29.00 129.00 L 75.00 155.00 L 98.00 156.00 L 101.00 160.00 L 101.00 182.00 L 111.00 190.00 L 111.00 193.00 L 114.00 200.00 L 123.00 207.00 L 144.00 206.00 L 146.00 201.00 L 151.00 197.00 L 151.00 180.00 L 146.00 171.00 L 145.00 167.00 L 147.00 165.00 L 150.00 164.00 L 169.00 145.00 L 169.00 131.00 L 167.00 127.00 L 166.00 118.00 L 163.00 112.00 L 156.00 106.00 L 161.00 100.00 L 161.00 85.00 L 156.00 78.00 L 157.00 75.00 L 159.00 73.00 L 180.00 74.00 L 184.00 79.00 L 204.00 79.00 L 205.00 80.00 L 207.00 77.00 L 215.00 71.00 L 215.00 69.00 L 214.00 68.00 L 214.00 64.00 L 212.00 59.00 L 205.00 50.00 L 190.00 43.00 L 184.00 36.00 L 175.00 36.00 L 174.00 35.00 L 174.00 25.00 L 171.00 21.00 L 168.00 20.00 L 166.00 18.00 L 166.00 5.00 Z",
    "province": "M023",
    "rootTerritory": "M023",
    "viewBox": "0 0 215 207",
    "unitSlots": [
      {
        "name": "main",
        "x": 111,
        "y": 62,
        "territory": "M023",
        "arrowReceiver": {
          "x": 111,
          "y": 92
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 111,
        "y": 62,
        "territory": "M023",
        "arrowReceiver": {
          "x": 111,
          "y": 92
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M024_a": {
    "abbr": "EGL",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 29,
        "y": 29,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 116,
    "height": 81,
    "x": 544,
    "y": 423,
    "playable": true,
    "path": "M 0.000 68.000 L 18.000 76.000 L 27.000 76.000 L 31.000 71.000 L 46.000 71.000 L 47.000 72.000 L 46.000 81.000 L 49.000 81.000 L 51.000 78.000 L 59.000 74.000 L 74.000 75.000 L 74.000 65.000 L 90.000 55.000 L 103.000 42.000 L 106.000 35.000 L 116.000 25.000 L 116.000 23.000 L 111.000 23.000 L 85.000 36.000 L 78.000 44.000 L 58.000 43.000 L 54.000 48.000 L 49.000 48.000 L 48.000 45.000 L 58.000 36.000 L 58.000 13.000 L 51.000 6.000 L 36.000 5.000 L 32.000 0.000 L 18.000 0.000 L 17.000 1.000 L 9.431 0.251 L 7.408 7.483 L 3.571 21.204 L 2.433 25.270 L 2.433 25.270 L 2.433 25.270 L 2.000 33.000 L 2.000 43.000 L 1.000 44.000 L 1.000 55.000 L 4.000 57.000 L 0.000 63.000 Z",
    "province": "M024_a",
    "rootTerritory": "M024_a",
    "viewBox": "0 0 116 81",
    "unitSlots": [
      {
        "name": "main",
        "x": 57,
        "y": 51,
        "territory": "M024_a",
        "arrowReceiver": {
          "x": 57,
          "y": 81
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 57,
        "y": 51,
        "territory": "M024_a",
        "arrowReceiver": {
          "x": 57,
          "y": 81
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M024": {
    "abbr": "ERI",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 47,
        "y": 32,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 69,
    "height": 56,
    "x": 617,
    "y": 444,
    "playable": true,
    "path": "M 67.00 0.00 L 44.00 0.00 L 32.00 12.00 L 29.00 19.00 L 15.00 33.00 L 0.00 42.00 L 0.00 54.00 L 27.00 55.00 L 28.00 54.00 L 46.00 53.00 L 49.00 56.00 L 65.00 55.00 L 69.00 45.00 Z",
    "province": "M024",
    "rootTerritory": "M024",
    "viewBox": "0 0 69 56",
    "unitSlots": [
      {
        "name": "main",
        "x": 29,
        "y": 41,
        "territory": "M024",
        "arrowReceiver": {
          "x": 29,
          "y": 71
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 29,
        "y": 41,
        "territory": "M024",
        "arrowReceiver": {
          "x": 29,
          "y": 71
        }
      }
    },
    "texture": {
      "texture": "#A6C4E7",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M017_a": {
    "abbr": "SOC",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 46,
        "y": 154,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 78,
    "height": 187,
    "x": 118,
    "y": 632,
    "playable": true,
    "path": "M 12.000 0.000 L 11.000 10.000 L 6.000 19.000 L 5.000 31.000 L 0.000 40.000 L 0.000 45.000 L 13.000 59.000 L 13.000 97.000 L 26.000 109.000 L 26.000 117.000 L 25.000 118.000 L 25.000 129.000 L 18.000 136.000 L 6.000 135.000 L 3.000 179.000 L 22.000 182.000 L 26.000 187.000 L 70.860 182.163 L 70.860 182.163 L 78.000 170.000 L 78.000 141.000 L 72.000 129.000 L 55.000 109.000 L 49.000 90.000 L 40.000 83.000 L 39.000 64.000 L 29.000 55.000 L 29.000 42.000 L 16.000 28.000 L 15.000 7.000 L 14.000 6.000 L 14.000 0.000 Z",
    "province": "M017_a",
    "rootTerritory": "M017_a",
    "viewBox": "0 0 78 187",
    "unitSlots": [
      {
        "name": "main",
        "x": 51,
        "y": 156,
        "territory": "M017_a",
        "arrowReceiver": {
          "x": 51,
          "y": 186
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 51,
        "y": 156,
        "territory": "M017_a",
        "arrowReceiver": {
          "x": 51,
          "y": 186
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M017": {
    "abbr": "BCA",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 29,
        "y": 36,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 78,
    "height": 193,
    "x": 81,
    "y": 576,
    "playable": true,
    "path": "M 49.00 0.00 L 44.00 5.00 L 19.00 6.00 L 15.00 11.00 L 2.00 11.00 L 0.00 74.00 L 17.00 90.00 L 18.00 100.00 L 23.00 105.00 L 26.00 129.00 L 19.00 137.00 L 19.00 156.00 L 41.00 179.00 L 41.00 189.00 L 44.00 193.00 L 57.00 193.00 L 63.00 187.00 L 64.00 163.00 L 51.00 151.00 L 51.00 113.00 L 38.00 98.00 L 43.00 89.00 L 44.00 77.00 L 49.00 68.00 L 51.00 54.00 L 68.00 38.00 L 78.00 26.00 L 78.00 15.00 L 77.00 14.00 L 77.00 7.00 L 66.00 5.00 L 62.00 0.00 Z",
    "province": "M017",
    "rootTerritory": "M017",
    "viewBox": "0 0 78 193",
    "unitSlots": [
      {
        "name": "main",
        "x": 34,
        "y": 14,
        "territory": "M017",
        "arrowReceiver": {
          "x": 34,
          "y": 44
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 34,
        "y": 14,
        "territory": "M017",
        "arrowReceiver": {
          "x": 34,
          "y": 44
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M018": {
    "abbr": "CLI",
    "type": "Coast",
    "centerPos": {
      "x": 32,
      "y": 69
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 49,
        "y": 62,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "nc",
        "x": 39.43,
        "y": 18.99,
        "text": "nc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "sc",
        "x": 11.05,
        "y": 113.88,
        "text": "sc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 74,
    "height": 143,
    "x": 583,
    "y": 1034,
    "playable": true,
    "path": "M 46.00 0.00 L 19.00 2.00 L 17.00 5.00 L 19.00 34.00 L 28.00 42.00 L 26.00 67.00 L 25.00 68.00 L 25.00 84.00 L 0.00 109.00 L 0.00 129.00 L 24.00 143.00 L 38.00 143.00 L 43.00 138.00 L 44.00 118.00 L 40.00 113.00 L 46.00 104.00 L 59.00 98.00 L 61.00 89.00 L 74.00 66.00 L 74.00 54.00 L 69.00 51.00 L 65.00 25.00 L 55.00 16.00 L 53.00 3.00 Z",
    "province": "M018",
    "rootTerritory": "M018",
    "viewBox": "0 0 74 143",
    "unitSlots": [
      {
        "name": "main",
        "x": 45,
        "y": 54,
        "territory": "M018",
        "arrowReceiver": {
          "x": 45,
          "y": 84
        }
      },
      {
        "name": "nc",
        "x": 39.43,
        "y": 18.99,
        "territory": "REGION_187_NORTH_COAST",
        "arrowReceiver": {
          "x": 39.43,
          "y": 48.99
        }
      },
      {
        "name": "sc",
        "x": 11.05,
        "y": 113.88,
        "territory": "REGION_187_SOUTH_COAST",
        "arrowReceiver": {
          "x": 11.05,
          "y": 143.88
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 45,
        "y": 54,
        "territory": "M018",
        "arrowReceiver": {
          "x": 45,
          "y": 84
        }
      },
      "nc": {
        "name": "nc",
        "x": 39.43,
        "y": 18.99,
        "territory": "REGION_187_NORTH_COAST",
        "arrowReceiver": {
          "x": 39.43,
          "y": 48.99
        }
      },
      "sc": {
        "name": "sc",
        "x": 11.05,
        "y": 113.88,
        "territory": "REGION_187_SOUTH_COAST",
        "arrowReceiver": {
          "x": 11.05,
          "y": 143.88
        }
      }
    },
    "texture": {
      "texture": "#E9D99E",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M025": {
    "abbr": "CHI",
    "type": "Coast",
    "centerPos": {
      "x": 35,
      "y": 119
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 52,
        "y": 112,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 167,
    "height": 157,
    "x": 425,
    "y": 415,
    "playable": true,
    "path": "M 1.00 9.00 L 0.00 28.00 L 27.00 52.00 L 30.00 68.00 L 36.00 78.00 L 21.00 94.00 L 21.00 117.00 L 25.00 121.00 L 25.00 128.00 L 31.00 132.00 L 31.00 142.00 L 40.00 157.00 L 42.00 157.00 L 46.00 149.00 L 59.00 147.00 L 67.00 137.00 L 77.00 138.00 L 82.00 132.00 L 90.00 133.00 L 107.00 116.00 L 117.00 116.00 L 120.00 121.00 L 139.00 123.00 L 140.00 124.00 L 140.00 131.00 L 142.00 131.00 L 160.00 112.00 L 165.00 113.00 L 167.00 78.00 L 148.00 78.00 L 144.00 83.00 L 135.00 82.00 L 118.00 73.00 L 99.00 72.00 L 93.00 82.00 L 83.00 87.00 L 76.00 87.00 L 75.00 88.00 L 69.00 88.00 L 65.00 80.00 L 65.00 51.00 L 71.00 42.00 L 69.00 27.00 L 73.00 20.00 L 72.00 17.00 L 70.00 16.00 L 56.00 16.00 L 55.00 15.00 L 41.00 15.00 L 38.00 10.00 L 28.00 10.00 L 27.00 9.00 L 27.00 0.00 L 18.00 0.00 L 16.00 2.00 Z",
    "province": "M025",
    "rootTerritory": "M025",
    "viewBox": "0 0 167 157",
    "unitSlots": [
      {
        "name": "main",
        "x": 88,
        "y": 94,
        "territory": "M025",
        "arrowReceiver": {
          "x": 88,
          "y": 124
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 88,
        "y": 94,
        "territory": "M025",
        "arrowReceiver": {
          "x": 88,
          "y": 124
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M022": {
    "abbr": "WGL",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 73,
        "y": 41,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 103,
    "height": 120,
    "x": 451,
    "y": 384,
    "playable": true,
    "path": "M 79.000 3.000 L 45.000 0.000 L 36.000 9.000 L 29.000 8.000 L 22.000 16.000 L 7.000 22.000 L 0.000 29.000 L 0.000 42.000 L 10.000 42.000 L 13.000 47.000 L 42.000 48.000 L 45.000 50.000 L 42.000 55.000 L 44.000 71.000 L 38.000 80.000 L 38.000 114.000 L 41.000 120.000 L 59.000 119.000 L 70.000 113.000 L 76.000 101.000 L 76.000 79.000 L 95.433 64.270 L 96.577 60.183 L 97.509 56.848 L 98.874 51.970 L 99.806 48.636 L 103.000 27.000 L 100.000 21.000 L 100.000 19.000 L 99.000 17.000 L 86.000 14.000 Z",
    "province": "M022",
    "rootTerritory": "M022",
    "viewBox": "0 0 103 120",
    "unitSlots": [
      {
        "name": "main",
        "x": 46,
        "y": 29,
        "territory": "M022",
        "arrowReceiver": {
          "x": 46,
          "y": 59
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 46,
        "y": 29,
        "territory": "M022",
        "arrowReceiver": {
          "x": 46,
          "y": 59
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M021_a": {
    "abbr": "KEB",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 48,
        "y": 78,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 149,
    "height": 126,
    "x": 0,
    "y": 1045,
    "playable": true,
    "path": "M 0.065 0.149 L 0.000 126.000 L 143.000 125.000 L 146.000 122.000 L 145.000 114.000 L 146.000 113.000 L 148.340 107.006 L 148.340 107.006 L 148.340 107.006 L 147.464 102.894 L 146.119 97.203 L 145.844 96.037 L 145.172 93.192 L 144.896 92.026 L 144.224 89.180 L 143.948 88.013 L 141.975 79.662 L 141.975 79.662 L 141.975 79.662 L 133.000 80.000 L 128.000 78.000 L 117.000 69.000 L 113.000 67.000 L 102.000 58.000 L 98.000 56.000 L 83.000 44.000 L 79.000 42.000 L 68.000 33.000 L 64.000 31.000 L 52.000 22.000 L 45.000 14.000 L 45.247 5.027 L 39.071 4.360 L 37.973 4.241 L 33.033 3.708 L 31.934 3.589 L 24.030 2.736 L 22.931 2.617 L 14.039 1.657 L 12.940 1.539 L 5.036 0.685 L 0.065 0.149 Z",
    "province": "M021_a",
    "rootTerritory": "M021_a",
    "viewBox": "0 0 149 126",
    "unitSlots": [
      {
        "name": "main",
        "x": 73,
        "y": 95,
        "territory": "M021_a",
        "arrowReceiver": {
          "x": 73,
          "y": 125
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 73,
        "y": 95,
        "territory": "M021_a",
        "arrowReceiver": {
          "x": 73,
          "y": 125
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M021_b": {
    "abbr": "HAW",
    "type": "Coast",
    "centerPos": {
      "x": 43,
      "y": 42
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 60,
        "y": 35,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 100,
    "height": 86,
    "x": 44,
    "y": 1040,
    "playable": true,
    "path": "M 0.00 9.00 L 0.00 21.00 L 6.00 28.00 L 86.00 86.00 L 99.00 85.00 L 99.00 75.00 L 100.00 74.00 L 100.00 11.00 L 96.00 6.00 L 50.00 4.00 L 43.00 1.00 L 12.00 0.00 L 7.00 9.00 Z",
    "province": "M021_b",
    "rootTerritory": "M021_b",
    "viewBox": "0 0 100 86",
    "unitSlots": [
      {
        "name": "main",
        "x": 96,
        "y": 15,
        "territory": "M021_b",
        "arrowReceiver": {
          "x": 96,
          "y": 45
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 96,
        "y": 15,
        "territory": "M021_b",
        "arrowReceiver": {
          "x": 96,
          "y": 45
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_110_a": {
    "abbr": "TEN",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 44,
        "y": 92,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 136,
    "height": 135,
    "x": 435,
    "y": 530,
    "playable": true,
    "path": "M 131.00 7.00 L 112.00 5.00 L 109.00 0.00 L 95.00 0.00 L 78.00 17.00 L 70.00 16.00 L 65.00 22.00 L 55.00 21.00 L 47.00 31.00 L 34.00 33.00 L 21.00 61.00 L 4.00 77.00 L 1.00 83.00 L 0.00 96.00 L 6.00 96.00 L 7.00 97.00 L 7.00 109.00 L 5.00 116.00 L 5.00 123.00 L 11.00 126.00 L 36.00 128.00 L 40.00 131.00 L 40.00 134.00 L 84.00 135.00 L 86.00 108.00 L 83.00 105.00 L 81.00 81.00 L 87.00 77.00 L 101.00 75.00 L 108.00 67.00 L 125.00 61.00 L 131.00 55.00 L 131.00 43.00 L 136.00 39.00 L 136.00 25.00 L 132.00 21.00 Z",
    "province": "REGION_110_a",
    "rootTerritory": "REGION_110_a",
    "viewBox": "0 0 136 135",
    "unitSlots": [
      {
        "name": "main",
        "x": 80,
        "y": 46,
        "territory": "REGION_110_a",
        "arrowReceiver": {
          "x": 80,
          "y": 76
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 80,
        "y": 46,
        "territory": "REGION_110_a",
        "arrowReceiver": {
          "x": 80,
          "y": 76
        }
      }
    },
    "texture": {
      "texture": "#A6C4E7",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M021": {
    "abbr": "NOR",
    "type": "Coast",
    "centerPos": {
      "x": 16,
      "y": 0
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 33,
        "y": 41,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 90,
    "height": 68,
    "x": 386,
    "y": 622,
    "playable": true,
    "path": "M 5.00 7.00 L 5.00 27.00 L 9.00 36.00 L 4.00 46.00 L 0.00 49.00 L 1.00 60.00 L 9.00 63.00 L 27.00 64.00 L 34.00 68.00 L 48.00 68.00 L 58.00 64.00 L 63.00 52.00 L 67.00 49.00 L 90.00 48.00 L 90.00 37.00 L 89.00 36.00 L 81.00 34.00 L 62.00 33.00 L 55.00 29.00 L 57.00 19.00 L 57.00 3.00 L 36.00 4.00 L 31.00 1.00 L 22.00 1.00 L 21.00 0.00 L 9.00 0.00 Z",
    "province": "M021",
    "rootTerritory": "M021",
    "viewBox": "0 0 90 68",
    "unitSlots": [
      {
        "name": "main",
        "x": 44,
        "y": 39,
        "territory": "M021",
        "arrowReceiver": {
          "x": 44,
          "y": 69
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 44,
        "y": 39,
        "territory": "M021",
        "arrowReceiver": {
          "x": 44,
          "y": 69
        }
      }
    },
    "texture": {
      "texture": "#A6C4E7",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M012_a": {
    "abbr": "EIS",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 28,
        "y": 22,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 44,
    "height": 37,
    "x": 403,
    "y": 926,
    "playable": true,
    "path": "M 0.00 19.00 L 0.00 27.00 L 14.00 30.00 L 27.00 37.00 L 38.00 37.00 L 38.00 30.00 L 44.00 19.00 L 44.00 17.00 L 24.00 5.00 L 22.00 3.00 L 22.00 0.00 L 20.00 0.00 L 19.00 1.00 L 19.00 13.00 L 18.00 14.00 L 6.00 16.00 L 4.00 19.00 Z",
    "province": "M012_a",
    "rootTerritory": "M012_a",
    "viewBox": "0 0 44 37",
    "unitSlots": [
      {
        "name": "main",
        "x": 19,
        "y": 21,
        "territory": "M012_a",
        "arrowReceiver": {
          "x": 19,
          "y": 51
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 19,
        "y": 21,
        "territory": "M012_a",
        "arrowReceiver": {
          "x": 19,
          "y": 51
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M012": {
    "abbr": "HDS",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 38,
        "y": 25,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "nc",
        "x": 87.82,
        "y": 23.72,
        "text": "nc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "sc",
        "x": 30.98,
        "y": 49.49,
        "text": "sc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 103,
    "height": 65,
    "x": 424,
    "y": 902,
    "playable": true,
    "path": "M 103.00 16.00 L 93.00 4.00 L 85.00 0.00 L 14.00 2.00 L 11.00 7.00 L 6.00 8.00 L 2.00 11.00 L 0.00 15.00 L 0.00 29.00 L 18.00 40.00 L 21.00 43.00 L 16.00 52.00 L 16.00 61.00 L 20.00 65.00 L 36.00 65.00 L 43.00 58.00 L 43.00 56.00 L 49.00 51.00 L 53.00 45.00 L 67.00 44.00 L 77.00 32.00 L 87.00 34.00 L 100.00 33.00 L 102.00 31.00 Z",
    "province": "M012",
    "rootTerritory": "M012",
    "viewBox": "0 0 103 65",
    "unitSlots": [
      {
        "name": "main",
        "x": 48,
        "y": 17,
        "territory": "M012",
        "arrowReceiver": {
          "x": 48,
          "y": 47
        }
      },
      {
        "name": "nc",
        "x": 87.82,
        "y": 23.72,
        "territory": "M012_NORTH_COAST",
        "arrowReceiver": {
          "x": 87.82,
          "y": 53.72
        }
      },
      {
        "name": "sc",
        "x": 30.98,
        "y": 49.49,
        "territory": "M012_SOUTH_COAST",
        "arrowReceiver": {
          "x": 30.98,
          "y": 79.49
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 48,
        "y": 17,
        "territory": "M012",
        "arrowReceiver": {
          "x": 48,
          "y": 47
        }
      },
      "nc": {
        "name": "nc",
        "x": 87.82,
        "y": 23.72,
        "territory": "M012_NORTH_COAST",
        "arrowReceiver": {
          "x": 87.82,
          "y": 53.72
        }
      },
      "sc": {
        "name": "sc",
        "x": 30.98,
        "y": 49.49,
        "territory": "M012_SOUTH_COAST",
        "arrowReceiver": {
          "x": 30.98,
          "y": 79.49
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_20_a_a_a": {
    "abbr": "MEX",
    "type": "Land",
    "centerPos": {
      "x": 20,
      "y": 70
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 37,
        "y": 63,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 72,
    "height": 118,
    "x": 230,
    "y": 747,
    "playable": true,
    "path": "M 34.00 0.00 L 32.00 3.00 L 9.00 18.00 L 9.00 36.00 L 15.00 40.00 L 18.00 44.00 L 1.00 58.00 L 0.00 60.00 L 0.00 78.00 L 13.00 85.00 L 22.00 85.00 L 25.00 92.00 L 25.00 100.00 L 49.00 118.00 L 66.00 118.00 L 67.00 116.00 L 66.00 99.00 L 72.00 90.00 L 72.00 79.00 L 59.00 45.00 L 58.00 31.00 L 51.00 24.00 L 51.00 8.00 L 48.00 1.00 Z",
    "province": "REGION_20_a_a_a",
    "rootTerritory": "REGION_20_a_a_a",
    "viewBox": "0 0 72 118",
    "unitSlots": [
      {
        "name": "main",
        "x": 33,
        "y": 73,
        "territory": "REGION_20_a_a_a",
        "arrowReceiver": {
          "x": 33,
          "y": 103
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 33,
        "y": 73,
        "territory": "REGION_20_a_a_a",
        "arrowReceiver": {
          "x": 33,
          "y": 103
        }
      }
    },
    "texture": {
      "texture": "#BED3B0",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M026_a": {
    "abbr": "VER",
    "type": "Coast",
    "centerPos": {
      "x": 27,
      "y": 85
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 44,
        "y": 86,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 64,
    "height": 109,
    "x": 288,
    "y": 781,
    "playable": true,
    "path": "M 0.00 0.00 L 0.00 13.00 L 13.00 47.00 L 13.00 54.00 L 7.00 63.00 L 8.00 84.00 L 22.00 84.00 L 27.00 90.00 L 29.00 98.00 L 35.00 104.00 L 41.00 107.00 L 52.00 107.00 L 54.00 109.00 L 56.00 109.00 L 58.00 107.00 L 60.00 97.00 L 62.00 93.00 L 64.00 85.00 L 64.00 77.00 L 60.00 77.00 L 33.00 50.00 L 31.00 46.00 L 30.00 35.00 L 28.00 33.00 L 29.00 24.00 L 23.00 17.00 L 21.00 2.00 L 8.00 3.00 L 7.00 1.00 Z",
    "province": "M026_a",
    "rootTerritory": "M026_a",
    "viewBox": "0 0 64 109",
    "unitSlots": [
      {
        "name": "main",
        "x": 35,
        "y": 77,
        "territory": "M026_a",
        "arrowReceiver": {
          "x": 35,
          "y": 107
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 35,
        "y": 77,
        "territory": "M026_a",
        "arrowReceiver": {
          "x": 35,
          "y": 107
        }
      }
    },
    "texture": {
      "texture": "#BED3B0",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M026_b": {
    "abbr": "CPZ",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 28,
        "y": 36,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "nc",
        "x": 37.21,
        "y": 17.33,
        "text": "nc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "sc",
        "x": 32.32,
        "y": 68.96,
        "text": "sc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 59,
    "height": 78,
    "x": 341,
    "y": 853,
    "playable": true,
    "path": "M 28.00 0.00 L 27.00 2.00 L 21.00 5.00 L 12.00 6.00 L 10.00 8.00 L 8.00 19.00 L 4.00 31.00 L 4.00 38.00 L 1.00 43.00 L 0.00 56.00 L 20.00 76.00 L 38.00 78.00 L 39.00 59.00 L 58.00 47.00 L 59.00 37.00 L 45.00 16.00 L 48.00 7.00 L 48.00 3.00 L 45.00 0.00 Z",
    "province": "M026_b",
    "rootTerritory": "M026_b",
    "viewBox": "0 0 59 78",
    "unitSlots": [
      {
        "name": "main",
        "x": 29,
        "y": 42,
        "territory": "M026_b",
        "arrowReceiver": {
          "x": 29,
          "y": 72
        }
      },
      {
        "name": "nc",
        "x": 37.21,
        "y": 17.33,
        "territory": "REGION_20_a_b_NORTH_COAST",
        "arrowReceiver": {
          "x": 37.21,
          "y": 47.33
        }
      },
      {
        "name": "sc",
        "x": 32.32,
        "y": 68.96,
        "territory": "REGION_20_a_b_SOUTH_COAST",
        "arrowReceiver": {
          "x": 32.32,
          "y": 98.96
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 29,
        "y": 42,
        "territory": "M026_b",
        "arrowReceiver": {
          "x": 29,
          "y": 72
        }
      },
      "nc": {
        "name": "nc",
        "x": 37.21,
        "y": 17.33,
        "territory": "REGION_20_a_b_NORTH_COAST",
        "arrowReceiver": {
          "x": 37.21,
          "y": 47.33
        }
      },
      "sc": {
        "name": "sc",
        "x": 32.32,
        "y": 68.96,
        "territory": "REGION_20_a_b_SOUTH_COAST",
        "arrowReceiver": {
          "x": 32.32,
          "y": 98.96
        }
      }
    },
    "texture": {
      "texture": "#BED3B0",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M026": {
    "abbr": "ECA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 126,
        "y": 106,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 268,
    "height": 176,
    "x": 627,
    "y": 826,
    "playable": true,
    "path": "M 268.000 52.000 L 266.000 50.000 L 244.000 51.000 L 240.000 45.000 L 239.000 26.000 L 205.000 26.000 L 203.000 23.000 L 203.000 21.000 L 204.000 20.000 L 204.000 11.000 L 205.000 10.000 L 205.205 0.964 L 205.205 0.964 L 205.205 0.964 L 192.032 2.342 L 190.947 2.456 L 186.245 2.948 L 187.000 11.000 L 186.000 12.000 L 186.000 15.000 L 188.000 17.000 L 186.000 19.000 L 180.000 20.000 L 173.000 28.000 L 156.000 26.000 L 145.000 33.000 L 134.000 34.000 L 125.000 42.000 L 122.000 49.000 L 120.000 51.000 L 38.000 51.000 L 36.000 53.000 L 37.000 84.000 L 35.000 86.000 L 0.000 85.002 L 0.648 115.162 L 0.648 115.162 L 0.648 115.162 L 18.988 116.222 L 20.038 116.277 L 33.999 117.010 L 35.049 117.065 L 55.493 118.139 L 61.000 115.000 L 156.000 116.000 L 157.000 117.000 L 158.000 122.000 L 160.000 123.000 L 160.000 168.000 L 184.000 167.000 L 198.000 176.000 L 204.000 176.000 L 213.000 166.000 L 237.000 164.000 L 240.000 168.000 L 241.000 173.000 L 247.000 176.000 L 253.000 176.000 L 253.000 72.000 L 262.000 64.000 L 262.000 58.000 L 268.000 54.000 Z",
    "province": "M026",
    "rootTerritory": "M026",
    "viewBox": "0 0 268 176",
    "unitSlots": [
      {
        "name": "main",
        "x": 126,
        "y": 106,
        "territory": "M026",
        "arrowReceiver": {
          "x": 126,
          "y": 136
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 126,
        "y": 106,
        "territory": "M026",
        "arrowReceiver": {
          "x": 126,
          "y": 136
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M027": {
    "abbr": "SAR",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 106,
        "y": 99,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 214,
    "height": 205,
    "x": 724,
    "y": 624,
    "playable": true,
    "path": "M 153.778 0.328 L 144.013 0.561 L 142.990 0.585 L 63.011 2.479 L 61.988 2.503 L 41.999 2.977 L 40.976 3.001 L 14.954 3.348 L 0.000 17.000 L 8.000 22.000 L 8.000 100.000 L 11.000 103.000 L 35.000 102.000 L 44.000 111.000 L 46.000 139.000 L 49.000 142.000 L 49.000 149.000 L 50.000 150.000 L 50.000 164.000 L 51.000 165.000 L 51.000 179.000 L 52.000 180.000 L 52.000 187.000 L 61.000 188.000 L 72.000 200.000 L 82.000 201.000 L 89.245 204.948 L 108.205 202.964 L 108.205 202.964 L 109.000 198.000 L 109.000 182.000 L 110.000 181.000 L 110.000 178.000 L 112.000 175.000 L 158.000 176.000 L 160.000 178.000 L 162.000 183.000 L 213.761 182.713 L 212.040 164.128 L 211.891 163.015 L 210.972 156.138 L 210.823 155.024 L 210.297 151.094 L 210.148 149.980 L 209.622 146.050 L 209.473 144.937 L 208.422 137.077 L 208.273 135.963 L 207.222 128.104 L 207.073 126.990 L 206.022 119.131 L 205.873 118.017 L 205.085 112.122 L 204.936 111.009 L 202.947 96.141 L 202.798 95.027 L 202.141 90.115 L 201.449 84.940 L 200.529 78.063 L 200.380 76.949 L 198.205 66.968 L 198.205 66.968 L 198.205 66.968 L 188.676 53.557 L 185.782 49.143 L 171.186 26.878 L 169.510 24.321 L 164.497 16.674 L 161.603 12.260 L 156.590 4.613 Z",
    "province": "M027",
    "rootTerritory": "M027",
    "viewBox": "0 0 214 205",
    "unitSlots": [
      {
        "name": "main",
        "x": 106,
        "y": 99,
        "territory": "M027",
        "arrowReceiver": {
          "x": 106,
          "y": 129
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 106,
        "y": 99,
        "territory": "M027",
        "arrowReceiver": {
          "x": 106,
          "y": 129
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_194_a": {
    "abbr": "BQI",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 46,
        "y": 34,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 92,
    "height": 72,
    "x": 710,
    "y": 1009,
    "playable": true,
    "path": "M 35.00 0.00 L 35.00 1.00 L 25.00 11.00 L 17.00 13.00 L 9.00 21.00 L 6.00 30.00 L 3.00 33.00 L 0.00 34.00 L 0.00 37.00 L 16.00 56.00 L 19.00 57.00 L 21.00 59.00 L 25.00 59.00 L 36.00 71.00 L 64.00 72.00 L 68.00 63.00 L 71.00 60.00 L 80.00 41.00 L 85.00 36.00 L 92.00 36.00 L 92.00 34.00 L 84.00 32.00 L 76.00 28.00 L 54.00 0.00 Z",
    "province": "REGION_194_a",
    "rootTerritory": "REGION_194_a",
    "viewBox": "0 0 92 72",
    "unitSlots": [
      {
        "name": "main",
        "x": 46,
        "y": 34,
        "territory": "REGION_194_a",
        "arrowReceiver": {
          "x": 46,
          "y": 64
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 46,
        "y": 34,
        "territory": "REGION_194_a",
        "arrowReceiver": {
          "x": 46,
          "y": 64
        }
      }
    },
    "texture": {
      "texture": "#FDDEAC",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_191_a": {
    "abbr": "MCB",
    "type": "Coast",
    "centerPos": {
      "x": 9,
      "y": 2
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 52,
        "y": 19,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 95,
    "height": 70,
    "x": 685,
    "y": 973,
    "playable": true,
    "path": "M 95.00 18.00 L 87.00 9.00 L 79.00 9.00 L 70.00 1.00 L 49.00 0.00 L 49.00 1.00 L 43.00 7.00 L 26.00 5.00 L 20.00 16.00 L 10.00 19.00 L 9.00 30.00 L 1.00 38.00 L 0.00 55.00 L 3.00 58.00 L 3.00 61.00 L 5.00 64.00 L 12.00 65.00 L 18.00 68.00 L 22.00 68.00 L 24.00 70.00 L 27.00 68.00 L 31.00 69.00 L 35.00 59.00 L 44.00 50.00 L 52.00 48.00 L 62.00 37.00 L 70.00 36.00 L 77.00 23.00 L 95.00 21.00 Z",
    "province": "REGION_191_a",
    "rootTerritory": "REGION_191_a",
    "viewBox": "0 0 95 70",
    "unitSlots": [
      {
        "name": "main",
        "x": 52,
        "y": 19,
        "territory": "REGION_191_a",
        "arrowReceiver": {
          "x": 52,
          "y": 49
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 52,
        "y": 19,
        "territory": "REGION_191_a",
        "arrowReceiver": {
          "x": 52,
          "y": 49
        }
      }
    },
    "texture": {
      "texture": "#FDDEAC",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M028": {
    "abbr": "ORI",
    "type": "Land",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 57,
        "y": 88,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 118,
    "height": 145,
    "x": 689,
    "y": 1038,
    "playable": true,
    "path": "M 1.00 0.00 L 0.00 1.00 L 0.00 10.00 L 2.00 13.00 L 2.00 15.00 L 4.00 19.00 L 10.00 23.00 L 13.00 23.00 L 14.00 24.00 L 14.00 28.00 L 17.00 28.00 L 20.00 30.00 L 20.00 45.00 L 8.00 60.00 L 8.00 65.00 L 11.00 68.00 L 11.00 82.00 L 7.00 85.00 L 7.00 89.00 L 11.00 92.00 L 10.00 110.00 L 33.00 123.00 L 37.00 123.00 L 40.00 119.00 L 52.00 119.00 L 57.00 123.00 L 66.00 122.00 L 82.00 138.00 L 100.00 137.00 L 110.00 144.00 L 117.00 145.00 L 118.00 136.00 L 112.00 131.00 L 107.00 130.00 L 103.00 125.00 L 103.00 117.00 L 102.00 116.00 L 102.00 108.00 L 110.00 101.00 L 112.00 92.00 L 103.00 84.00 L 92.00 80.00 L 83.00 68.00 L 84.00 42.00 L 59.00 41.00 L 48.00 29.00 L 39.00 29.00 L 37.00 28.00 L 29.00 19.00 L 29.00 18.00 L 22.00 11.00 L 19.00 4.00 L 16.00 4.00 L 15.00 3.00 L 12.00 3.00 L 11.00 2.00 Z",
    "province": "M028",
    "rootTerritory": "M028",
    "viewBox": "0 0 118 145",
    "unitSlots": [
      {
        "name": "main",
        "x": 57,
        "y": 88,
        "territory": "M028",
        "arrowReceiver": {
          "x": 57,
          "y": 118
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 57,
        "y": 88,
        "territory": "M028",
        "arrowReceiver": {
          "x": 57,
          "y": 118
        }
      }
    },
    "texture": {
      "texture": "#FDDEAC",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_9_a": {
    "abbr": "HOR",
    "type": "Land",
    "centerPos": {
      "x": 70,
      "y": 199
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 87,
        "y": 192,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 175,
    "height": 266,
    "x": 974,
    "y": 1225,
    "playable": true,
    "path": "M 103.00 0.00 L 95.00 1.00 L 86.00 10.00 L 87.00 25.00 L 72.00 39.00 L 71.00 58.00 L 47.00 89.00 L 44.00 142.00 L 35.00 160.00 L 0.00 200.00 L 0.00 206.00 L 2.00 210.00 L 11.00 215.00 L 13.00 215.00 L 21.00 219.00 L 28.00 226.00 L 31.00 233.00 L 42.00 233.00 L 47.00 237.00 L 51.00 237.00 L 56.00 233.00 L 72.00 232.00 L 76.00 236.00 L 75.00 246.00 L 82.00 252.00 L 82.00 258.00 L 83.00 259.00 L 83.00 265.00 L 84.00 266.00 L 88.00 266.00 L 91.00 263.00 L 101.00 263.00 L 106.00 255.00 L 127.00 246.00 L 137.00 237.00 L 138.00 237.00 L 147.00 228.00 L 148.00 212.00 L 167.00 193.00 L 169.00 174.00 L 171.00 169.00 L 173.00 167.00 L 173.00 159.00 L 174.00 158.00 L 174.00 143.00 L 175.00 142.00 L 175.00 139.00 L 173.00 136.00 L 173.00 132.00 L 166.00 128.00 L 151.00 129.00 L 148.00 126.00 L 131.00 126.00 L 127.00 130.00 L 124.00 129.00 L 122.00 127.00 L 127.00 70.00 L 115.00 60.00 L 119.00 52.00 L 119.00 40.00 L 105.00 32.00 L 108.00 27.00 L 108.00 5.00 Z",
    "province": "REGION_9_a",
    "rootTerritory": "REGION_9_a",
    "viewBox": "0 0 175 266",
    "unitSlots": [
      {
        "name": "main",
        "x": 87,
        "y": 192,
        "territory": "REGION_9_a",
        "arrowReceiver": {
          "x": 87,
          "y": 222
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 87,
        "y": 192,
        "territory": "REGION_9_a",
        "arrowReceiver": {
          "x": 87,
          "y": 222
        }
      }
    },
    "texture": {
      "texture": "#B0CEB1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M029": {
    "abbr": "RDJ",
    "type": "Coast",
    "centerPos": {
      "x": 10,
      "y": 112
    },
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 27,
        "y": 119,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 98,
    "height": 134,
    "x": 1075,
    "y": 1360,
    "playable": true,
    "path": "M 98.00 6.00 L 82.00 4.00 L 76.00 0.00 L 75.00 7.00 L 74.00 8.00 L 74.00 23.00 L 73.00 24.00 L 73.00 32.00 L 71.00 34.00 L 68.00 35.00 L 65.00 56.00 L 46.00 75.00 L 45.00 91.00 L 24.00 110.00 L 3.00 119.00 L 0.00 122.00 L 0.00 127.00 L 8.00 127.00 L 12.00 134.00 L 22.00 134.00 L 33.00 125.00 L 43.00 125.00 L 51.00 120.00 L 50.00 108.00 L 56.00 103.00 L 61.00 89.00 L 80.00 71.00 L 92.00 47.00 L 93.00 28.00 L 96.00 26.00 L 98.00 21.00 Z",
    "province": "M029",
    "rootTerritory": "M029",
    "viewBox": "0 0 98 134",
    "unitSlots": [
      {
        "name": "main",
        "x": 27,
        "y": 119,
        "territory": "M029",
        "arrowReceiver": {
          "x": 27,
          "y": 149
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 27,
        "y": 119,
        "territory": "M029",
        "arrowReceiver": {
          "x": 27,
          "y": 149
        }
      }
    },
    "texture": {
      "texture": "#B0CEB1",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_49_b_a_a": {
    "abbr": "NCA",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 102,
        "y": 48,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 209,
    "height": 61,
    "x": 525,
    "y": 818,
    "playable": true,
    "path": "M 1.000 13.000 L 0.000 40.000 L 1.000 41.000 L 1.000 48.000 L 2.000 49.000 L 3.000 59.000 L 80.000 61.000 L 87.000 52.000 L 126.000 52.000 L 131.000 61.000 L 197.000 58.000 L 203.000 52.000 L 202.000 33.000 L 208.664 21.584 L 208.664 21.584 L 173.068 15.608 L 163.000 23.000 L 149.000 22.000 L 147.000 25.000 L 149.000 28.000 L 148.000 30.000 L 144.000 28.000 L 138.000 29.000 L 137.000 30.000 L 135.000 30.000 L 131.000 36.000 L 127.000 36.000 L 126.000 35.000 L 122.000 35.000 L 118.000 32.000 L 118.000 27.000 L 113.000 23.000 L 113.000 18.000 L 112.000 18.000 L 111.000 16.000 L 109.000 16.000 L 108.000 15.000 L 106.000 15.000 L 105.000 14.000 L 103.000 14.000 L 102.000 13.000 L 100.000 13.000 L 99.000 12.000 L 97.000 12.000 L 96.000 11.000 L 94.000 11.000 L 93.000 10.000 L 91.000 10.000 L 69.000 2.000 L 59.000 2.000 L 58.000 1.000 L 44.000 1.000 L 43.000 0.000 L 36.000 0.000 L 35.000 2.000 L 13.000 13.000 Z",
    "province": "REGION_49_b_a_a",
    "rootTerritory": "REGION_49_b_a_a",
    "viewBox": "0 0 209 61",
    "unitSlots": [
      {
        "name": "main",
        "x": 102,
        "y": 48,
        "territory": "REGION_49_b_a_a",
        "arrowReceiver": {
          "x": 102,
          "y": 78
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 102,
        "y": 48,
        "territory": "REGION_49_b_a_a",
        "arrowReceiver": {
          "x": 102,
          "y": 78
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M030": {
    "abbr": "KMG",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 17,
        "y": 13,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "nc",
        "x": 41,
        "y": 10.06,
        "text": "nc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      },
      {
        "name": "sc",
        "x": 41,
        "y": 23,
        "text": "sc",
        "style": {
          "fontSize": 8,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 47,
    "height": 29,
    "x": 591,
    "y": 804,
    "playable": true,
    "path": "M 0.00 1.00 L 2.00 15.00 L 18.00 20.00 L 24.00 23.00 L 27.00 23.00 L 30.00 25.00 L 33.00 25.00 L 34.00 26.00 L 42.00 28.00 L 43.00 29.00 L 47.00 28.00 L 47.00 18.00 L 36.00 17.00 L 35.00 15.00 L 31.00 12.00 L 28.00 12.00 L 23.00 9.00 L 17.00 9.00 L 16.00 8.00 L 14.00 8.00 L 12.00 7.00 L 6.00 0.00 Z",
    "province": "M030",
    "rootTerritory": "M030",
    "viewBox": "0 0 47 29",
    "unitSlots": [
      {
        "name": "main",
        "x": 17,
        "y": 13,
        "territory": "M030",
        "arrowReceiver": {
          "x": 17,
          "y": 43
        }
      },
      {
        "name": "nc",
        "x": 41,
        "y": 10.06,
        "territory": "M030_NORTH_COAST",
        "arrowReceiver": {
          "x": 41,
          "y": 40.06
        }
      },
      {
        "name": "sc",
        "x": 41,
        "y": 23,
        "territory": "M030_SOUTH_COAST",
        "arrowReceiver": {
          "x": 41,
          "y": 53
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 17,
        "y": 13,
        "territory": "M030",
        "arrowReceiver": {
          "x": 17,
          "y": 43
        }
      },
      "nc": {
        "name": "nc",
        "x": 41,
        "y": 10.06,
        "territory": "M030_NORTH_COAST",
        "arrowReceiver": {
          "x": 41,
          "y": 40.06
        }
      },
      "sc": {
        "name": "sc",
        "x": 41,
        "y": 23,
        "territory": "M030_SOUTH_COAST",
        "arrowReceiver": {
          "x": 41,
          "y": 53
        }
      }
    },
    "texture": {
      "texture": "#E19EAA",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "REGION_73_a_a": {
    "abbr": "GOC",
    "type": "Sea",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 232,
        "y": 44,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 463,
    "height": 201,
    "x": 172,
    "y": 1666,
    "playable": true,
    "path": "M 0.00 48.00 L 0.00 58.00 L 1.00 59.00 L 1.00 63.00 L 2.00 64.00 L 3.00 72.00 L 4.00 73.00 L 4.00 78.00 L 5.00 79.00 L 6.00 89.00 L 7.00 90.00 L 7.00 94.00 L 8.00 95.00 L 8.00 100.00 L 9.00 101.00 L 10.00 112.00 L 11.00 113.00 L 11.00 117.00 L 12.00 118.00 L 12.00 123.00 L 14.00 127.00 L 14.00 132.00 L 16.00 136.00 L 17.00 147.00 L 18.00 148.00 L 19.00 158.00 L 20.00 159.00 L 20.00 175.00 L 22.00 176.00 L 25.00 176.00 L 28.00 178.00 L 74.00 179.00 L 75.00 180.00 L 85.00 180.00 L 86.00 181.00 L 107.00 182.00 L 108.00 183.00 L 117.00 183.00 L 118.00 184.00 L 157.00 185.00 L 158.00 186.00 L 180.00 186.00 L 181.00 187.00 L 203.00 187.00 L 204.00 188.00 L 218.00 188.00 L 219.00 189.00 L 226.00 189.00 L 227.00 190.00 L 233.00 190.00 L 234.00 191.00 L 245.00 191.00 L 246.00 192.00 L 262.00 192.00 L 263.00 193.00 L 279.00 193.00 L 280.00 194.00 L 295.00 194.00 L 296.00 195.00 L 312.00 195.00 L 313.00 196.00 L 329.00 196.00 L 330.00 197.00 L 346.00 197.00 L 347.00 198.00 L 363.00 198.00 L 364.00 199.00 L 380.00 199.00 L 381.00 200.00 L 396.00 200.00 L 397.00 201.00 L 405.00 201.00 L 405.00 197.00 L 401.00 194.00 L 402.00 184.00 L 414.00 170.00 L 417.00 164.00 L 423.00 158.00 L 425.00 154.00 L 425.00 152.00 L 428.00 147.00 L 428.00 143.00 L 430.00 139.00 L 432.00 137.00 L 434.00 137.00 L 436.00 130.00 L 438.00 127.00 L 440.00 120.00 L 443.00 115.00 L 443.00 112.00 L 449.00 100.00 L 450.00 94.00 L 454.00 86.00 L 454.00 77.00 L 457.00 75.00 L 461.00 65.00 L 461.00 56.00 L 463.00 53.00 L 463.00 41.00 L 462.00 40.00 L 462.00 36.00 L 302.00 34.00 L 295.00 29.00 L 284.00 29.00 L 283.00 30.00 L 261.00 30.00 L 260.00 31.00 L 239.00 31.00 L 238.00 30.00 L 219.00 30.00 L 218.00 29.00 L 199.00 29.00 L 198.00 28.00 L 188.00 28.00 L 179.00 23.00 L 121.00 24.00 L 112.00 18.00 L 51.00 14.00 L 37.00 0.00 L 23.00 0.00 L 22.00 19.00 L 37.00 35.00 L 34.00 39.00 L 1.00 40.00 L 1.00 47.00 Z",
    "province": "REGION_73_a_a",
    "rootTerritory": "REGION_73_a_a",
    "viewBox": "0 0 463 201",
    "unitSlots": [
      {
        "name": "main",
        "x": 232,
        "y": 44,
        "territory": "REGION_73_a_a",
        "arrowReceiver": {
          "x": 232,
          "y": 74
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 232,
        "y": 44,
        "territory": "REGION_73_a_a",
        "arrowReceiver": {
          "x": 232,
          "y": 74
        }
      }
    },
    "texture": {
      "texture": "#8FB3D9",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  },
  "M031": {
    "abbr": "AYS",
    "type": "Coast",
    "fill": "none",
    "labels": [
      {
        "name": "main",
        "x": 41,
        "y": 9,
        "style": {
          "fontSize": 10,
          "textAnchor": "middle",
          "dominantBaseline": "central"
        }
      }
    ],
    "width": 58,
    "height": 77,
    "x": 606,
    "y": 1729,
    "playable": true,
    "path": "M 28.00 0.00 L 42.00 7.00 L 57.00 7.00 L 58.00 9.00 L 58.00 11.00 L 43.00 11.00 L 38.00 25.00 L 31.00 32.00 L 32.00 48.00 L 13.00 67.00 L 12.00 74.00 L 9.00 77.00 L 0.00 76.00 L 21.00 22.00 L 21.00 14.00 L 24.00 12.00 L 28.00 1.00 Z",
    "province": "M031",
    "rootTerritory": "M031",
    "viewBox": "0 0 58 77",
    "unitSlots": [
      {
        "name": "main",
        "x": 41,
        "y": 9,
        "territory": "M031",
        "arrowReceiver": {
          "x": 41,
          "y": 39
        }
      }
    ],
    "unitSlotsBySlotName": {
      "main": {
        "name": "main",
        "x": 41,
        "y": 9,
        "territory": "M031",
        "arrowReceiver": {
          "x": 41,
          "y": 39
        }
      }
    },
    "texture": {
      "texture": "#C9C3B5",
      "strokeOpacity": 0.5,
      "strokeWidth": 7
    }
  }
} as unknown as MapVariant["provincesMapData"];

const territoryMap = {
  "REGION_1": {
    "territory": "REGION_1",
    "unitSlotName": "main",
    "province": "REGION_1",
    "provinceMapData": {
      "abbr": "QUE",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 84,
          "y": 90,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 239,
      "height": 175,
      "x": 599,
      "y": 235,
      "playable": true,
      "path": "M 0.00 168.00 L 4.00 175.00 L 28.00 175.00 L 32.00 172.00 L 33.00 169.00 L 36.00 166.00 L 42.00 163.00 L 46.00 163.00 L 47.00 162.00 L 55.00 162.00 L 56.00 161.00 L 64.00 161.00 L 65.00 160.00 L 69.00 160.00 L 72.00 158.00 L 93.00 158.00 L 96.00 160.00 L 105.00 149.00 L 110.00 132.00 L 123.00 123.00 L 142.00 124.00 L 153.00 136.00 L 209.00 136.00 L 223.00 118.00 L 238.00 117.00 L 239.00 111.00 L 237.00 109.00 L 237.00 105.00 L 236.00 104.00 L 236.00 100.00 L 225.00 94.00 L 211.00 91.00 L 206.00 83.00 L 191.00 82.00 L 181.00 73.00 L 173.00 71.00 L 168.00 61.00 L 147.00 42.00 L 147.00 37.00 L 137.00 29.00 L 133.00 28.00 L 133.00 32.00 L 131.00 35.00 L 130.00 40.00 L 126.00 44.00 L 120.00 47.00 L 105.00 46.00 L 95.00 37.00 L 88.00 34.00 L 86.00 32.00 L 86.00 21.00 L 76.00 10.00 L 75.00 6.00 L 57.00 6.00 L 53.00 1.00 L 27.00 0.00 L 26.00 8.00 L 31.00 15.00 L 31.00 26.00 L 24.00 33.00 L 24.00 35.00 L 27.00 36.00 L 35.00 46.00 L 36.00 53.00 L 39.00 61.00 L 39.00 71.00 L 20.00 90.00 L 15.00 92.00 L 16.00 101.00 L 21.00 110.00 L 21.00 123.00 L 15.00 128.00 L 14.00 131.00 L 12.00 133.00 L 5.00 134.00 L 5.00 137.00 L 4.00 138.00 L 4.00 145.00 L 3.00 146.00 L 3.00 153.00 L 2.00 154.00 L 2.00 157.00 L 0.00 160.00 Z",
      "province": "REGION_1",
      "rootTerritory": "REGION_1",
      "viewBox": "0 0 239 175",
      "unitSlots": [
        {
          "name": "main",
          "x": 134,
          "y": 112,
          "territory": "REGION_1",
          "arrowReceiver": {
            "x": 134,
            "y": 142
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 134,
          "y": 112,
          "territory": "REGION_1",
          "arrowReceiver": {
            "x": 134,
            "y": 142
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "魁北克": {
    "territory": "REGION_1",
    "unitSlotName": "main",
    "province": "REGION_1",
    "provinceMapData": {
      "abbr": "QUE",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 84,
          "y": 90,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 239,
      "height": 175,
      "x": 599,
      "y": 235,
      "playable": true,
      "path": "M 0.00 168.00 L 4.00 175.00 L 28.00 175.00 L 32.00 172.00 L 33.00 169.00 L 36.00 166.00 L 42.00 163.00 L 46.00 163.00 L 47.00 162.00 L 55.00 162.00 L 56.00 161.00 L 64.00 161.00 L 65.00 160.00 L 69.00 160.00 L 72.00 158.00 L 93.00 158.00 L 96.00 160.00 L 105.00 149.00 L 110.00 132.00 L 123.00 123.00 L 142.00 124.00 L 153.00 136.00 L 209.00 136.00 L 223.00 118.00 L 238.00 117.00 L 239.00 111.00 L 237.00 109.00 L 237.00 105.00 L 236.00 104.00 L 236.00 100.00 L 225.00 94.00 L 211.00 91.00 L 206.00 83.00 L 191.00 82.00 L 181.00 73.00 L 173.00 71.00 L 168.00 61.00 L 147.00 42.00 L 147.00 37.00 L 137.00 29.00 L 133.00 28.00 L 133.00 32.00 L 131.00 35.00 L 130.00 40.00 L 126.00 44.00 L 120.00 47.00 L 105.00 46.00 L 95.00 37.00 L 88.00 34.00 L 86.00 32.00 L 86.00 21.00 L 76.00 10.00 L 75.00 6.00 L 57.00 6.00 L 53.00 1.00 L 27.00 0.00 L 26.00 8.00 L 31.00 15.00 L 31.00 26.00 L 24.00 33.00 L 24.00 35.00 L 27.00 36.00 L 35.00 46.00 L 36.00 53.00 L 39.00 61.00 L 39.00 71.00 L 20.00 90.00 L 15.00 92.00 L 16.00 101.00 L 21.00 110.00 L 21.00 123.00 L 15.00 128.00 L 14.00 131.00 L 12.00 133.00 L 5.00 134.00 L 5.00 137.00 L 4.00 138.00 L 4.00 145.00 L 3.00 146.00 L 3.00 153.00 L 2.00 154.00 L 2.00 157.00 L 0.00 160.00 Z",
      "province": "REGION_1",
      "rootTerritory": "REGION_1",
      "viewBox": "0 0 239 175",
      "unitSlots": [
        {
          "name": "main",
          "x": 134,
          "y": 112,
          "territory": "REGION_1",
          "arrowReceiver": {
            "x": 134,
            "y": 142
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 134,
          "y": 112,
          "territory": "REGION_1",
          "arrowReceiver": {
            "x": 134,
            "y": 142
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_2": {
    "territory": "REGION_2",
    "unitSlotName": "main",
    "province": "REGION_2",
    "provinceMapData": {
      "abbr": "NEW",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 37,
      "x": 840,
      "y": 369,
      "playable": true,
      "path": "M 8.00 0.00 L 6.00 3.00 L 8.00 19.00 L 0.00 29.00 L 0.00 35.00 L 11.00 35.00 L 12.00 34.00 L 14.00 35.00 L 19.00 35.00 L 22.00 33.00 L 33.00 33.00 L 40.00 37.00 L 44.00 37.00 L 45.00 34.00 L 40.00 29.00 L 41.00 20.00 L 34.00 19.00 L 33.00 18.00 L 23.00 18.00 L 15.00 14.00 L 13.00 12.00 L 11.00 12.00 L 10.00 11.00 L 10.00 0.00 Z",
      "province": "REGION_2",
      "rootTerritory": "REGION_2",
      "viewBox": "0 0 45 37",
      "unitSlots": [
        {
          "name": "main",
          "x": 30,
          "y": 46,
          "territory": "REGION_2",
          "arrowReceiver": {
            "x": 30,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30,
          "y": 46,
          "territory": "REGION_2",
          "arrowReceiver": {
            "x": 30,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "纽芬兰": {
    "territory": "REGION_2",
    "unitSlotName": "main",
    "province": "REGION_2",
    "provinceMapData": {
      "abbr": "NEW",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 37,
      "x": 840,
      "y": 369,
      "playable": true,
      "path": "M 8.00 0.00 L 6.00 3.00 L 8.00 19.00 L 0.00 29.00 L 0.00 35.00 L 11.00 35.00 L 12.00 34.00 L 14.00 35.00 L 19.00 35.00 L 22.00 33.00 L 33.00 33.00 L 40.00 37.00 L 44.00 37.00 L 45.00 34.00 L 40.00 29.00 L 41.00 20.00 L 34.00 19.00 L 33.00 18.00 L 23.00 18.00 L 15.00 14.00 L 13.00 12.00 L 11.00 12.00 L 10.00 11.00 L 10.00 0.00 Z",
      "province": "REGION_2",
      "rootTerritory": "REGION_2",
      "viewBox": "0 0 45 37",
      "unitSlots": [
        {
          "name": "main",
          "x": 30,
          "y": 46,
          "territory": "REGION_2",
          "arrowReceiver": {
            "x": 30,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30,
          "y": 46,
          "territory": "REGION_2",
          "arrowReceiver": {
            "x": 30,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_3": {
    "territory": "REGION_3",
    "unitSlotName": "main",
    "province": "REGION_3",
    "provinceMapData": {
      "abbr": "MON",
      "type": "Coast",
      "centerPos": {
        "x": 56,
        "y": 44
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 61,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 138,
      "height": 97,
      "x": 630,
      "y": 357,
      "playable": true,
      "path": "M 123.00 12.00 L 113.00 1.00 L 90.00 0.00 L 78.00 8.00 L 74.00 23.00 L 64.00 36.00 L 62.00 35.00 L 39.00 35.00 L 36.00 37.00 L 9.00 40.00 L 1.00 44.00 L 0.00 50.00 L 10.00 50.00 L 21.00 62.00 L 21.00 75.00 L 12.00 92.00 L 12.00 97.00 L 14.00 97.00 L 27.00 90.00 L 31.00 90.00 L 33.00 88.00 L 57.00 88.00 L 58.00 87.00 L 71.00 86.00 L 86.00 57.00 L 88.00 55.00 L 91.00 55.00 L 98.00 46.00 L 113.00 48.00 L 118.00 45.00 L 133.00 46.00 L 137.00 43.00 L 138.00 40.00 L 134.00 37.00 L 130.00 37.00 L 122.00 41.00 L 104.00 41.00 L 102.00 39.00 L 102.00 30.00 L 115.00 14.00 L 123.00 14.00 Z",
      "province": "REGION_3",
      "rootTerritory": "REGION_3",
      "viewBox": "0 0 138 97",
      "unitSlots": [
        {
          "name": "main",
          "x": 70,
          "y": 42,
          "territory": "REGION_3",
          "arrowReceiver": {
            "x": 70,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 70,
          "y": 42,
          "territory": "REGION_3",
          "arrowReceiver": {
            "x": 70,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "蒙特利尔": {
    "territory": "REGION_3",
    "unitSlotName": "main",
    "province": "REGION_3",
    "provinceMapData": {
      "abbr": "MON",
      "type": "Coast",
      "centerPos": {
        "x": 56,
        "y": 44
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 61,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 138,
      "height": 97,
      "x": 630,
      "y": 357,
      "playable": true,
      "path": "M 123.00 12.00 L 113.00 1.00 L 90.00 0.00 L 78.00 8.00 L 74.00 23.00 L 64.00 36.00 L 62.00 35.00 L 39.00 35.00 L 36.00 37.00 L 9.00 40.00 L 1.00 44.00 L 0.00 50.00 L 10.00 50.00 L 21.00 62.00 L 21.00 75.00 L 12.00 92.00 L 12.00 97.00 L 14.00 97.00 L 27.00 90.00 L 31.00 90.00 L 33.00 88.00 L 57.00 88.00 L 58.00 87.00 L 71.00 86.00 L 86.00 57.00 L 88.00 55.00 L 91.00 55.00 L 98.00 46.00 L 113.00 48.00 L 118.00 45.00 L 133.00 46.00 L 137.00 43.00 L 138.00 40.00 L 134.00 37.00 L 130.00 37.00 L 122.00 41.00 L 104.00 41.00 L 102.00 39.00 L 102.00 30.00 L 115.00 14.00 L 123.00 14.00 Z",
      "province": "REGION_3",
      "rootTerritory": "REGION_3",
      "viewBox": "0 0 138 97",
      "unitSlots": [
        {
          "name": "main",
          "x": 70,
          "y": 42,
          "territory": "REGION_3",
          "arrowReceiver": {
            "x": 70,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 70,
          "y": 42,
          "territory": "REGION_3",
          "arrowReceiver": {
            "x": 70,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_4": {
    "territory": "REGION_4",
    "unitSlotName": "main",
    "province": "REGION_4",
    "provinceMapData": {
      "abbr": "HAL",
      "type": "Coast",
      "centerPos": {
        "x": 15,
        "y": 13
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 10,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 90,
      "height": 61,
      "x": 720,
      "y": 401,
      "playable": true,
      "path": "M 0.00 9.00 L 0.00 11.00 L 3.00 12.00 L 20.00 13.00 L 24.00 17.00 L 26.00 33.00 L 35.00 40.00 L 51.00 39.00 L 55.00 42.00 L 55.00 51.00 L 51.00 58.00 L 51.00 61.00 L 53.00 61.00 L 55.00 59.00 L 60.00 50.00 L 76.00 42.00 L 84.00 42.00 L 84.00 40.00 L 90.00 34.00 L 90.00 32.00 L 83.00 32.00 L 76.00 36.00 L 59.00 36.00 L 50.00 25.00 L 42.00 21.00 L 43.00 1.00 L 26.00 0.00 L 21.00 3.00 L 6.00 1.00 Z",
      "province": "REGION_4",
      "rootTerritory": "REGION_4",
      "viewBox": "0 0 90 61",
      "unitSlots": [
        {
          "name": "main",
          "x": 54,
          "y": 26,
          "territory": "REGION_4",
          "arrowReceiver": {
            "x": 54,
            "y": 56
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 54,
          "y": 26,
          "territory": "REGION_4",
          "arrowReceiver": {
            "x": 54,
            "y": 56
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "哈利法克斯": {
    "territory": "REGION_4",
    "unitSlotName": "main",
    "province": "REGION_4",
    "provinceMapData": {
      "abbr": "HAL",
      "type": "Coast",
      "centerPos": {
        "x": 15,
        "y": 13
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 10,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 90,
      "height": 61,
      "x": 720,
      "y": 401,
      "playable": true,
      "path": "M 0.00 9.00 L 0.00 11.00 L 3.00 12.00 L 20.00 13.00 L 24.00 17.00 L 26.00 33.00 L 35.00 40.00 L 51.00 39.00 L 55.00 42.00 L 55.00 51.00 L 51.00 58.00 L 51.00 61.00 L 53.00 61.00 L 55.00 59.00 L 60.00 50.00 L 76.00 42.00 L 84.00 42.00 L 84.00 40.00 L 90.00 34.00 L 90.00 32.00 L 83.00 32.00 L 76.00 36.00 L 59.00 36.00 L 50.00 25.00 L 42.00 21.00 L 43.00 1.00 L 26.00 0.00 L 21.00 3.00 L 6.00 1.00 Z",
      "province": "REGION_4",
      "rootTerritory": "REGION_4",
      "viewBox": "0 0 90 61",
      "unitSlots": [
        {
          "name": "main",
          "x": 54,
          "y": 26,
          "territory": "REGION_4",
          "arrowReceiver": {
            "x": 54,
            "y": 56
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 54,
          "y": 26,
          "territory": "REGION_4",
          "arrowReceiver": {
            "x": 54,
            "y": 56
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_8": {
    "territory": "REGION_8",
    "unitSlotName": "main",
    "province": "REGION_8",
    "provinceMapData": {
      "abbr": "SAS",
      "type": "Coast",
      "centerPos": {
        "x": 70,
        "y": 96
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 87,
          "y": 89,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 179,
      "height": 202,
      "x": 1073,
      "y": 1172,
      "playable": true,
      "path": "M 28.00 0.00 L 25.00 5.00 L 24.00 16.00 L 11.00 42.00 L 0.00 52.00 L 0.00 54.00 L 8.00 60.00 L 8.00 77.00 L 5.00 82.00 L 5.00 87.00 L 19.00 95.00 L 19.00 102.00 L 15.00 109.00 L 15.00 114.00 L 22.00 122.00 L 27.00 125.00 L 26.00 139.00 L 24.00 141.00 L 24.00 158.00 L 23.00 159.00 L 23.00 170.00 L 22.00 171.00 L 22.00 183.00 L 27.00 185.00 L 35.00 180.00 L 46.00 180.00 L 51.00 183.00 L 64.00 182.00 L 72.00 186.00 L 76.00 191.00 L 79.00 190.00 L 84.00 193.00 L 98.00 195.00 L 99.00 196.00 L 99.00 202.00 L 101.00 202.00 L 113.00 167.00 L 132.00 153.00 L 144.00 129.00 L 150.00 121.00 L 158.00 104.00 L 172.00 91.00 L 178.00 79.00 L 179.00 62.00 L 177.00 59.00 L 176.00 51.00 L 172.00 44.00 L 153.00 43.00 L 137.00 26.00 L 136.00 20.00 L 135.00 19.00 L 120.00 18.00 L 115.00 21.00 L 79.00 19.00 L 74.00 22.00 L 59.00 23.00 L 58.00 22.00 L 58.00 14.00 L 53.00 7.00 L 50.00 7.00 L 45.00 5.00 L 40.00 5.00 L 31.00 0.00 Z",
      "province": "REGION_8",
      "rootTerritory": "REGION_8",
      "viewBox": "0 0 179 202",
      "unitSlots": [
        {
          "name": "main",
          "x": 96,
          "y": 61,
          "territory": "REGION_8",
          "arrowReceiver": {
            "x": 96,
            "y": 91
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 96,
          "y": 61,
          "territory": "REGION_8",
          "arrowReceiver": {
            "x": 96,
            "y": 91
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "圣萨尔瓦多": {
    "territory": "REGION_8",
    "unitSlotName": "main",
    "province": "REGION_8",
    "provinceMapData": {
      "abbr": "SAS",
      "type": "Coast",
      "centerPos": {
        "x": 70,
        "y": 96
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 87,
          "y": 89,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 179,
      "height": 202,
      "x": 1073,
      "y": 1172,
      "playable": true,
      "path": "M 28.00 0.00 L 25.00 5.00 L 24.00 16.00 L 11.00 42.00 L 0.00 52.00 L 0.00 54.00 L 8.00 60.00 L 8.00 77.00 L 5.00 82.00 L 5.00 87.00 L 19.00 95.00 L 19.00 102.00 L 15.00 109.00 L 15.00 114.00 L 22.00 122.00 L 27.00 125.00 L 26.00 139.00 L 24.00 141.00 L 24.00 158.00 L 23.00 159.00 L 23.00 170.00 L 22.00 171.00 L 22.00 183.00 L 27.00 185.00 L 35.00 180.00 L 46.00 180.00 L 51.00 183.00 L 64.00 182.00 L 72.00 186.00 L 76.00 191.00 L 79.00 190.00 L 84.00 193.00 L 98.00 195.00 L 99.00 196.00 L 99.00 202.00 L 101.00 202.00 L 113.00 167.00 L 132.00 153.00 L 144.00 129.00 L 150.00 121.00 L 158.00 104.00 L 172.00 91.00 L 178.00 79.00 L 179.00 62.00 L 177.00 59.00 L 176.00 51.00 L 172.00 44.00 L 153.00 43.00 L 137.00 26.00 L 136.00 20.00 L 135.00 19.00 L 120.00 18.00 L 115.00 21.00 L 79.00 19.00 L 74.00 22.00 L 59.00 23.00 L 58.00 22.00 L 58.00 14.00 L 53.00 7.00 L 50.00 7.00 L 45.00 5.00 L 40.00 5.00 L 31.00 0.00 Z",
      "province": "REGION_8",
      "rootTerritory": "REGION_8",
      "viewBox": "0 0 179 202",
      "unitSlots": [
        {
          "name": "main",
          "x": 96,
          "y": 61,
          "territory": "REGION_8",
          "arrowReceiver": {
            "x": 96,
            "y": 91
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 96,
          "y": 61,
          "territory": "REGION_8",
          "arrowReceiver": {
            "x": 96,
            "y": 91
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_10": {
    "territory": "REGION_10",
    "unitSlotName": "main",
    "province": "REGION_10",
    "provinceMapData": {
      "abbr": "MAT",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 133,
          "y": 71,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 213,
      "height": 221,
      "x": 809,
      "y": 1301,
      "playable": true,
      "path": "M 42.00 1.00 L 34.00 8.00 L 30.00 14.00 L 13.00 20.00 L 6.00 25.00 L 0.00 35.00 L 0.00 53.00 L 12.00 65.00 L 31.00 69.00 L 58.00 83.00 L 66.00 83.00 L 70.00 85.00 L 72.00 88.00 L 71.00 89.00 L 69.00 111.00 L 72.00 117.00 L 75.00 120.00 L 97.00 120.00 L 100.00 123.00 L 99.00 135.00 L 109.00 144.00 L 109.00 146.00 L 108.00 147.00 L 107.00 162.00 L 96.00 179.00 L 97.00 198.00 L 100.00 202.00 L 120.00 203.00 L 123.00 208.00 L 123.00 219.00 L 126.00 221.00 L 129.00 221.00 L 145.00 204.00 L 159.00 200.00 L 160.00 195.00 L 175.00 178.00 L 184.00 159.00 L 186.00 157.00 L 197.00 157.00 L 196.00 152.00 L 189.00 143.00 L 170.00 134.00 L 166.00 127.00 L 201.00 85.00 L 210.00 67.00 L 213.00 14.00 L 132.00 11.00 L 123.00 0.00 L 120.00 0.00 L 114.00 10.00 L 54.00 10.00 L 44.00 1.00 Z",
      "province": "REGION_10",
      "rootTerritory": "REGION_10",
      "viewBox": "0 0 213 221",
      "unitSlots": [
        {
          "name": "main",
          "x": 106,
          "y": 46,
          "territory": "REGION_10",
          "arrowReceiver": {
            "x": 106,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 106,
          "y": 46,
          "territory": "REGION_10",
          "arrowReceiver": {
            "x": 106,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "马托格罗索": {
    "territory": "REGION_10",
    "unitSlotName": "main",
    "province": "REGION_10",
    "provinceMapData": {
      "abbr": "MAT",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 133,
          "y": 71,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 213,
      "height": 221,
      "x": 809,
      "y": 1301,
      "playable": true,
      "path": "M 42.00 1.00 L 34.00 8.00 L 30.00 14.00 L 13.00 20.00 L 6.00 25.00 L 0.00 35.00 L 0.00 53.00 L 12.00 65.00 L 31.00 69.00 L 58.00 83.00 L 66.00 83.00 L 70.00 85.00 L 72.00 88.00 L 71.00 89.00 L 69.00 111.00 L 72.00 117.00 L 75.00 120.00 L 97.00 120.00 L 100.00 123.00 L 99.00 135.00 L 109.00 144.00 L 109.00 146.00 L 108.00 147.00 L 107.00 162.00 L 96.00 179.00 L 97.00 198.00 L 100.00 202.00 L 120.00 203.00 L 123.00 208.00 L 123.00 219.00 L 126.00 221.00 L 129.00 221.00 L 145.00 204.00 L 159.00 200.00 L 160.00 195.00 L 175.00 178.00 L 184.00 159.00 L 186.00 157.00 L 197.00 157.00 L 196.00 152.00 L 189.00 143.00 L 170.00 134.00 L 166.00 127.00 L 201.00 85.00 L 210.00 67.00 L 213.00 14.00 L 132.00 11.00 L 123.00 0.00 L 120.00 0.00 L 114.00 10.00 L 54.00 10.00 L 44.00 1.00 Z",
      "province": "REGION_10",
      "rootTerritory": "REGION_10",
      "viewBox": "0 0 213 221",
      "unitSlots": [
        {
          "name": "main",
          "x": 106,
          "y": 46,
          "territory": "REGION_10",
          "arrowReceiver": {
            "x": 106,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 106,
          "y": 46,
          "territory": "REGION_10",
          "arrowReceiver": {
            "x": 106,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_12": {
    "territory": "REGION_12",
    "unitSlotName": "main",
    "province": "REGION_12",
    "provinceMapData": {
      "abbr": "SAP",
      "type": "Coast",
      "centerPos": {
        "x": 45,
        "y": 37
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 62,
          "y": 30,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 121,
      "height": 72,
      "x": 967,
      "y": 1456,
      "playable": true,
      "path": "M 121.00 35.00 L 118.00 30.00 L 97.00 31.00 L 93.00 33.00 L 91.00 31.00 L 90.00 19.00 L 83.00 12.00 L 84.00 4.00 L 81.00 0.00 L 62.00 1.00 L 57.00 4.00 L 50.00 1.00 L 26.00 1.00 L 16.00 21.00 L 1.00 38.00 L 0.00 45.00 L 19.00 45.00 L 24.00 48.00 L 44.00 50.00 L 46.00 54.00 L 48.00 64.00 L 55.00 72.00 L 57.00 72.00 L 78.00 56.00 L 93.00 52.00 L 109.00 37.00 L 121.00 38.00 Z",
      "province": "REGION_12",
      "rootTerritory": "REGION_12",
      "viewBox": "0 0 121 72",
      "unitSlots": [
        {
          "name": "main",
          "x": 56,
          "y": 36,
          "territory": "REGION_12",
          "arrowReceiver": {
            "x": 56,
            "y": 66
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 56,
          "y": 36,
          "territory": "REGION_12",
          "arrowReceiver": {
            "x": 56,
            "y": 66
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "圣保罗": {
    "territory": "REGION_12",
    "unitSlotName": "main",
    "province": "REGION_12",
    "provinceMapData": {
      "abbr": "SAP",
      "type": "Coast",
      "centerPos": {
        "x": 45,
        "y": 37
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 62,
          "y": 30,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 121,
      "height": 72,
      "x": 967,
      "y": 1456,
      "playable": true,
      "path": "M 121.00 35.00 L 118.00 30.00 L 97.00 31.00 L 93.00 33.00 L 91.00 31.00 L 90.00 19.00 L 83.00 12.00 L 84.00 4.00 L 81.00 0.00 L 62.00 1.00 L 57.00 4.00 L 50.00 1.00 L 26.00 1.00 L 16.00 21.00 L 1.00 38.00 L 0.00 45.00 L 19.00 45.00 L 24.00 48.00 L 44.00 50.00 L 46.00 54.00 L 48.00 64.00 L 55.00 72.00 L 57.00 72.00 L 78.00 56.00 L 93.00 52.00 L 109.00 37.00 L 121.00 38.00 Z",
      "province": "REGION_12",
      "rootTerritory": "REGION_12",
      "viewBox": "0 0 121 72",
      "unitSlots": [
        {
          "name": "main",
          "x": 56,
          "y": 36,
          "territory": "REGION_12",
          "arrowReceiver": {
            "x": 56,
            "y": 66
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 56,
          "y": 36,
          "territory": "REGION_12",
          "arrowReceiver": {
            "x": 56,
            "y": 66
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_13": {
    "territory": "REGION_13",
    "unitSlotName": "main",
    "province": "REGION_13",
    "provinceMapData": {
      "abbr": "RGS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 88,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 133,
      "height": 132,
      "x": 890,
      "y": 1500,
      "playable": true,
      "path": "M 123.00 5.00 L 103.00 3.00 L 98.00 0.00 L 74.00 0.00 L 62.00 4.00 L 47.00 20.00 L 47.00 23.00 L 51.00 23.00 L 56.00 25.00 L 56.00 36.00 L 52.00 43.00 L 52.00 46.00 L 55.00 51.00 L 55.00 62.00 L 49.00 74.00 L 26.00 90.00 L 14.00 96.00 L 8.00 96.00 L 0.00 107.00 L 0.00 109.00 L 6.00 116.00 L 18.00 116.00 L 20.00 117.00 L 33.00 132.00 L 36.00 132.00 L 48.00 118.00 L 59.00 113.00 L 66.00 104.00 L 74.00 103.00 L 93.00 85.00 L 101.00 80.00 L 105.00 76.00 L 109.00 61.00 L 125.00 32.00 L 127.00 30.00 L 133.00 28.00 L 133.00 26.00 L 126.00 18.00 Z",
      "province": "REGION_13",
      "rootTerritory": "REGION_13",
      "viewBox": "0 0 133 132",
      "unitSlots": [
        {
          "name": "main",
          "x": 57,
          "y": 86,
          "territory": "REGION_13",
          "arrowReceiver": {
            "x": 57,
            "y": 116
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57,
          "y": 86,
          "territory": "REGION_13",
          "arrowReceiver": {
            "x": 57,
            "y": 116
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "南里奥格兰德": {
    "territory": "REGION_13",
    "unitSlotName": "main",
    "province": "REGION_13",
    "provinceMapData": {
      "abbr": "RGS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 88,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 133,
      "height": 132,
      "x": 890,
      "y": 1500,
      "playable": true,
      "path": "M 123.00 5.00 L 103.00 3.00 L 98.00 0.00 L 74.00 0.00 L 62.00 4.00 L 47.00 20.00 L 47.00 23.00 L 51.00 23.00 L 56.00 25.00 L 56.00 36.00 L 52.00 43.00 L 52.00 46.00 L 55.00 51.00 L 55.00 62.00 L 49.00 74.00 L 26.00 90.00 L 14.00 96.00 L 8.00 96.00 L 0.00 107.00 L 0.00 109.00 L 6.00 116.00 L 18.00 116.00 L 20.00 117.00 L 33.00 132.00 L 36.00 132.00 L 48.00 118.00 L 59.00 113.00 L 66.00 104.00 L 74.00 103.00 L 93.00 85.00 L 101.00 80.00 L 105.00 76.00 L 109.00 61.00 L 125.00 32.00 L 127.00 30.00 L 133.00 28.00 L 133.00 26.00 L 126.00 18.00 Z",
      "province": "REGION_13",
      "rootTerritory": "REGION_13",
      "viewBox": "0 0 133 132",
      "unitSlots": [
        {
          "name": "main",
          "x": 57,
          "y": 86,
          "territory": "REGION_13",
          "arrowReceiver": {
            "x": 57,
            "y": 116
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57,
          "y": 86,
          "territory": "REGION_13",
          "arrowReceiver": {
            "x": 57,
            "y": 116
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_15": {
    "territory": "REGION_15",
    "unitSlotName": "main",
    "province": "REGION_15",
    "provinceMapData": {
      "abbr": "ARO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 157,
          "y": 57,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 418,
      "height": 137,
      "x": 362,
      "y": 0,
      "playable": true,
      "path": "M 0.00 120.00 L 3.00 120.00 L 8.00 125.00 L 12.00 125.00 L 15.00 127.00 L 20.00 127.00 L 29.00 136.00 L 38.00 137.00 L 40.00 135.00 L 39.00 125.00 L 30.00 120.00 L 29.00 110.00 L 35.00 101.00 L 40.00 100.00 L 54.00 92.00 L 74.00 92.00 L 82.00 99.00 L 98.00 102.00 L 113.00 110.00 L 136.00 109.00 L 137.00 114.00 L 141.00 118.00 L 149.00 122.00 L 157.00 122.00 L 164.00 118.00 L 175.00 117.00 L 183.00 112.00 L 190.00 112.00 L 191.00 113.00 L 221.00 112.00 L 231.00 119.00 L 239.00 119.00 L 240.00 114.00 L 244.00 109.00 L 244.00 106.00 L 238.00 106.00 L 235.00 104.00 L 216.00 104.00 L 208.00 96.00 L 209.00 80.00 L 211.00 72.00 L 226.00 73.00 L 253.00 59.00 L 284.00 55.00 L 324.00 42.00 L 346.00 42.00 L 355.00 47.00 L 383.00 44.00 L 415.00 61.00 L 418.00 61.00 L 418.00 58.00 L 403.00 42.00 L 388.00 22.00 L 383.00 11.00 L 375.00 0.00 L 68.00 0.00 L 60.00 16.00 L 52.00 26.00 L 45.00 41.00 L 37.00 51.00 L 26.00 74.00 L 14.00 89.00 L 0.00 117.00 Z",
      "province": "REGION_15",
      "rootTerritory": "REGION_15",
      "viewBox": "0 0 418 137",
      "unitSlots": [
        {
          "name": "main",
          "x": 231,
          "y": 49,
          "territory": "REGION_15",
          "arrowReceiver": {
            "x": 231,
            "y": 79
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 231,
          "y": 49,
          "territory": "REGION_15",
          "arrowReceiver": {
            "x": 231,
            "y": 79
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "北冰洋": {
    "territory": "REGION_15",
    "unitSlotName": "main",
    "province": "REGION_15",
    "provinceMapData": {
      "abbr": "ARO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 157,
          "y": 57,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 418,
      "height": 137,
      "x": 362,
      "y": 0,
      "playable": true,
      "path": "M 0.00 120.00 L 3.00 120.00 L 8.00 125.00 L 12.00 125.00 L 15.00 127.00 L 20.00 127.00 L 29.00 136.00 L 38.00 137.00 L 40.00 135.00 L 39.00 125.00 L 30.00 120.00 L 29.00 110.00 L 35.00 101.00 L 40.00 100.00 L 54.00 92.00 L 74.00 92.00 L 82.00 99.00 L 98.00 102.00 L 113.00 110.00 L 136.00 109.00 L 137.00 114.00 L 141.00 118.00 L 149.00 122.00 L 157.00 122.00 L 164.00 118.00 L 175.00 117.00 L 183.00 112.00 L 190.00 112.00 L 191.00 113.00 L 221.00 112.00 L 231.00 119.00 L 239.00 119.00 L 240.00 114.00 L 244.00 109.00 L 244.00 106.00 L 238.00 106.00 L 235.00 104.00 L 216.00 104.00 L 208.00 96.00 L 209.00 80.00 L 211.00 72.00 L 226.00 73.00 L 253.00 59.00 L 284.00 55.00 L 324.00 42.00 L 346.00 42.00 L 355.00 47.00 L 383.00 44.00 L 415.00 61.00 L 418.00 61.00 L 418.00 58.00 L 403.00 42.00 L 388.00 22.00 L 383.00 11.00 L 375.00 0.00 L 68.00 0.00 L 60.00 16.00 L 52.00 26.00 L 45.00 41.00 L 37.00 51.00 L 26.00 74.00 L 14.00 89.00 L 0.00 117.00 Z",
      "province": "REGION_15",
      "rootTerritory": "REGION_15",
      "viewBox": "0 0 418 137",
      "unitSlots": [
        {
          "name": "main",
          "x": 231,
          "y": 49,
          "territory": "REGION_15",
          "arrowReceiver": {
            "x": 231,
            "y": 79
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 231,
          "y": 49,
          "territory": "REGION_15",
          "arrowReceiver": {
            "x": 231,
            "y": 79
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_16": {
    "territory": "REGION_16",
    "unitSlotName": "main",
    "province": "REGION_16",
    "provinceMapData": {
      "abbr": "SON",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 22,
          "y": 43,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 104,
      "x": 131,
      "y": 595,
      "playable": true,
      "path": "M 32.00 0.00 L 27.00 1.00 L 27.00 5.00 L 24.00 9.00 L 0.00 33.00 L 2.00 67.00 L 15.00 81.00 L 15.00 94.00 L 25.00 104.00 L 28.00 104.00 L 31.00 101.00 L 30.00 81.00 L 36.00 74.00 L 39.00 59.00 L 44.00 51.00 L 45.00 9.00 L 44.00 7.00 L 38.00 7.00 Z",
      "province": "REGION_16",
      "rootTerritory": "REGION_16",
      "viewBox": "0 0 45 104",
      "unitSlots": [
        {
          "name": "main",
          "x": 26,
          "y": 46,
          "territory": "REGION_16",
          "arrowReceiver": {
            "x": 26,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 26,
          "y": 46,
          "territory": "REGION_16",
          "arrowReceiver": {
            "x": 26,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "索诺拉": {
    "territory": "REGION_16",
    "unitSlotName": "main",
    "province": "REGION_16",
    "provinceMapData": {
      "abbr": "SON",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 22,
          "y": 43,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 104,
      "x": 131,
      "y": 595,
      "playable": true,
      "path": "M 32.00 0.00 L 27.00 1.00 L 27.00 5.00 L 24.00 9.00 L 0.00 33.00 L 2.00 67.00 L 15.00 81.00 L 15.00 94.00 L 25.00 104.00 L 28.00 104.00 L 31.00 101.00 L 30.00 81.00 L 36.00 74.00 L 39.00 59.00 L 44.00 51.00 L 45.00 9.00 L 44.00 7.00 L 38.00 7.00 Z",
      "province": "REGION_16",
      "rootTerritory": "REGION_16",
      "viewBox": "0 0 45 104",
      "unitSlots": [
        {
          "name": "main",
          "x": 26,
          "y": 46,
          "territory": "REGION_16",
          "arrowReceiver": {
            "x": 26,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 26,
          "y": 46,
          "territory": "REGION_16",
          "arrowReceiver": {
            "x": 26,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_17": {
    "territory": "REGION_17",
    "unitSlotName": "main",
    "province": "REGION_17",
    "provinceMapData": {
      "abbr": "CHH",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 39,
          "y": 65,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 154,
      "height": 180,
      "x": 160,
      "y": 605,
      "playable": true,
      "path": "M 15.00 0.00 L 14.00 39.00 L 9.00 47.00 L 6.00 62.00 L 0.00 69.00 L 1.00 91.00 L 3.00 91.00 L 5.00 89.00 L 13.00 89.00 L 20.00 95.00 L 21.00 102.00 L 27.00 108.00 L 30.00 108.00 L 33.00 103.00 L 40.00 103.00 L 44.00 105.00 L 53.00 105.00 L 60.00 107.00 L 84.00 109.00 L 85.00 110.00 L 85.00 128.00 L 84.00 131.00 L 87.00 133.00 L 102.00 132.00 L 110.00 139.00 L 112.00 139.00 L 115.00 144.00 L 117.00 145.00 L 120.00 152.00 L 120.00 168.00 L 126.00 173.00 L 127.00 178.00 L 130.00 177.00 L 133.00 178.00 L 134.00 180.00 L 139.00 180.00 L 141.00 152.00 L 154.00 133.00 L 154.00 130.00 L 132.00 119.00 L 130.00 99.00 L 107.00 62.00 L 101.00 61.00 L 88.00 71.00 L 81.00 71.00 L 72.00 66.00 L 74.00 43.00 L 70.00 36.00 L 70.00 21.00 L 59.00 20.00 L 54.00 17.00 L 42.00 17.00 L 34.00 13.00 L 19.00 10.00 L 17.00 0.00 Z",
      "province": "REGION_17",
      "rootTerritory": "REGION_17",
      "viewBox": "0 0 154 180",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 86,
          "territory": "REGION_17",
          "arrowReceiver": {
            "x": 63,
            "y": 116
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 86,
          "territory": "REGION_17",
          "arrowReceiver": {
            "x": 63,
            "y": 116
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "奇瓦瓦": {
    "territory": "REGION_17",
    "unitSlotName": "main",
    "province": "REGION_17",
    "provinceMapData": {
      "abbr": "CHH",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 39,
          "y": 65,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 154,
      "height": 180,
      "x": 160,
      "y": 605,
      "playable": true,
      "path": "M 15.00 0.00 L 14.00 39.00 L 9.00 47.00 L 6.00 62.00 L 0.00 69.00 L 1.00 91.00 L 3.00 91.00 L 5.00 89.00 L 13.00 89.00 L 20.00 95.00 L 21.00 102.00 L 27.00 108.00 L 30.00 108.00 L 33.00 103.00 L 40.00 103.00 L 44.00 105.00 L 53.00 105.00 L 60.00 107.00 L 84.00 109.00 L 85.00 110.00 L 85.00 128.00 L 84.00 131.00 L 87.00 133.00 L 102.00 132.00 L 110.00 139.00 L 112.00 139.00 L 115.00 144.00 L 117.00 145.00 L 120.00 152.00 L 120.00 168.00 L 126.00 173.00 L 127.00 178.00 L 130.00 177.00 L 133.00 178.00 L 134.00 180.00 L 139.00 180.00 L 141.00 152.00 L 154.00 133.00 L 154.00 130.00 L 132.00 119.00 L 130.00 99.00 L 107.00 62.00 L 101.00 61.00 L 88.00 71.00 L 81.00 71.00 L 72.00 66.00 L 74.00 43.00 L 70.00 36.00 L 70.00 21.00 L 59.00 20.00 L 54.00 17.00 L 42.00 17.00 L 34.00 13.00 L 19.00 10.00 L 17.00 0.00 Z",
      "province": "REGION_17",
      "rootTerritory": "REGION_17",
      "viewBox": "0 0 154 180",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 86,
          "territory": "REGION_17",
          "arrowReceiver": {
            "x": 63,
            "y": 116
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 86,
          "territory": "REGION_17",
          "arrowReceiver": {
            "x": 63,
            "y": 116
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_18": {
    "territory": "REGION_18",
    "unitSlotName": "main",
    "province": "REGION_18",
    "provinceMapData": {
      "abbr": "MAO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 233,
          "y": 161,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 372,
      "height": 606,
      "x": 922,
      "y": 627,
      "playable": true,
      "path": "M 0.205 63.968 L 1.968 70.870 L 2.117 71.984 L 3.449 81.940 L 3.598 83.054 L 4.124 86.983 L 4.273 88.097 L 5.324 95.957 L 5.473 97.071 L 6.261 102.965 L 6.410 104.079 L 7.067 108.991 L 7.216 110.105 L 9.336 125.955 L 9.485 127.069 L 11.079 138.989 L 11.228 140.103 L 12.674 150.910 L 12.823 152.024 L 14.137 161.848 L 14.286 162.962 L 15.468 171.804 L 15.617 172.917 L 15.761 179.713 L 15.927 184.009 L 16.548 188.931 L 16.688 190.039 L 17.185 193.977 L 17.325 195.085 L 18.567 204.928 L 18.707 206.037 L 19.576 212.927 L 19.716 214.036 L 20.462 219.942 L 20.601 221.050 L 22.605 236.924 L 22.745 238.032 L 23.777 246.210 L 23.777 246.210 L 24.000 305.000 L 56.000 303.000 L 59.000 301.000 L 64.000 300.000 L 72.000 296.000 L 110.000 294.000 L 113.000 292.000 L 123.000 292.000 L 126.000 290.000 L 187.000 289.000 L 191.000 296.000 L 191.000 311.000 L 193.000 314.000 L 193.000 326.000 L 194.000 327.000 L 194.000 334.000 L 195.000 335.000 L 195.000 348.000 L 196.000 349.000 L 196.000 355.000 L 197.000 356.000 L 198.000 390.000 L 200.000 393.000 L 200.000 407.000 L 201.000 408.000 L 203.000 482.000 L 207.000 489.000 L 217.000 489.000 L 238.000 481.000 L 262.000 482.000 L 273.000 476.000 L 294.000 478.000 L 295.000 479.000 L 295.000 486.000 L 298.000 491.000 L 296.000 565.000 L 295.000 566.000 L 286.000 565.000 L 287.000 573.000 L 302.000 589.000 L 321.000 590.000 L 325.000 596.000 L 329.000 606.000 L 351.073 602.130 L 371.955 590.420 L 371.955 590.420 L 371.958 0.625 L 363.020 2.120 L 361.885 2.310 L 356.048 3.287 L 354.912 3.477 L 350.049 4.291 L 348.913 4.481 L 343.077 5.457 L 341.941 5.647 L 337.077 6.461 L 335.942 6.651 L 331.078 7.465 L 329.942 7.655 L 325.078 8.469 L 323.943 8.659 L 319.079 9.473 L 317.944 9.663 L 313.080 10.477 L 311.944 10.667 L 307.080 11.481 L 305.945 11.671 L 301.081 12.484 L 299.946 12.674 L 295.082 13.488 L 293.946 13.678 L 289.082 14.492 L 287.947 14.682 L 278.056 16.337 L 276.921 16.527 L 272.057 17.341 L 270.922 17.531 L 267.031 18.182 L 265.895 18.372 L 262.004 19.023 L 260.868 19.213 L 256.005 20.027 L 254.869 20.217 L 248.060 21.357 L 246.924 21.547 L 242.060 22.360 L 240.925 22.550 L 236.061 23.364 L 234.925 23.554 L 230.062 24.368 L 228.926 24.558 L 224.062 25.372 L 222.927 25.562 L 218.063 26.376 L 216.927 26.566 L 212.064 27.380 L 210.928 27.570 L 198.119 29.713 L 196.984 29.903 L 189.039 31.233 L 187.903 31.423 L 181.094 32.562 L 179.958 32.752 L 175.095 33.566 L 173.959 33.756 L 169.095 34.570 L 167.960 34.760 L 163.096 35.574 L 161.960 35.764 L 157.097 36.577 L 155.961 36.767 L 151.097 37.581 L 149.962 37.771 L 145.098 38.585 L 143.962 38.775 L 139.099 39.589 L 137.963 39.779 L 133.099 40.593 L 131.964 40.783 L 126.127 41.760 L 124.992 41.950 L 120.128 42.763 L 118.992 42.953 L 102.130 45.775 L 100.994 45.965 L 91.104 47.620 L 89.968 47.810 L 86.077 48.461 L 84.942 48.651 L 81.051 49.302 L 79.915 49.492 L 75.051 50.306 L 73.916 50.496 L 70.025 51.147 L 68.889 51.337 L 62.080 52.477 L 56.890 53.345 L 49.108 54.647 L 47.973 54.837 L 37.110 56.655 L 35.974 56.845 L 32.083 57.496 L 30.947 57.686 L 27.056 58.337 L 25.921 58.527 L 9.058 61.349 L 7.923 61.539 Z",
      "province": "REGION_18",
      "rootTerritory": "REGION_18",
      "viewBox": "0 0 372 606",
      "unitSlots": [
        {
          "name": "main",
          "x": 188,
          "y": 67,
          "territory": "REGION_18",
          "arrowReceiver": {
            "x": 188,
            "y": 97
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 188,
          "y": 67,
          "territory": "REGION_18",
          "arrowReceiver": {
            "x": 188,
            "y": 97
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "中大西洋": {
    "territory": "REGION_18",
    "unitSlotName": "main",
    "province": "REGION_18",
    "provinceMapData": {
      "abbr": "MAO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 233,
          "y": 161,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 372,
      "height": 606,
      "x": 922,
      "y": 627,
      "playable": true,
      "path": "M 0.205 63.968 L 1.968 70.870 L 2.117 71.984 L 3.449 81.940 L 3.598 83.054 L 4.124 86.983 L 4.273 88.097 L 5.324 95.957 L 5.473 97.071 L 6.261 102.965 L 6.410 104.079 L 7.067 108.991 L 7.216 110.105 L 9.336 125.955 L 9.485 127.069 L 11.079 138.989 L 11.228 140.103 L 12.674 150.910 L 12.823 152.024 L 14.137 161.848 L 14.286 162.962 L 15.468 171.804 L 15.617 172.917 L 15.761 179.713 L 15.927 184.009 L 16.548 188.931 L 16.688 190.039 L 17.185 193.977 L 17.325 195.085 L 18.567 204.928 L 18.707 206.037 L 19.576 212.927 L 19.716 214.036 L 20.462 219.942 L 20.601 221.050 L 22.605 236.924 L 22.745 238.032 L 23.777 246.210 L 23.777 246.210 L 24.000 305.000 L 56.000 303.000 L 59.000 301.000 L 64.000 300.000 L 72.000 296.000 L 110.000 294.000 L 113.000 292.000 L 123.000 292.000 L 126.000 290.000 L 187.000 289.000 L 191.000 296.000 L 191.000 311.000 L 193.000 314.000 L 193.000 326.000 L 194.000 327.000 L 194.000 334.000 L 195.000 335.000 L 195.000 348.000 L 196.000 349.000 L 196.000 355.000 L 197.000 356.000 L 198.000 390.000 L 200.000 393.000 L 200.000 407.000 L 201.000 408.000 L 203.000 482.000 L 207.000 489.000 L 217.000 489.000 L 238.000 481.000 L 262.000 482.000 L 273.000 476.000 L 294.000 478.000 L 295.000 479.000 L 295.000 486.000 L 298.000 491.000 L 296.000 565.000 L 295.000 566.000 L 286.000 565.000 L 287.000 573.000 L 302.000 589.000 L 321.000 590.000 L 325.000 596.000 L 329.000 606.000 L 351.073 602.130 L 371.955 590.420 L 371.955 590.420 L 371.958 0.625 L 363.020 2.120 L 361.885 2.310 L 356.048 3.287 L 354.912 3.477 L 350.049 4.291 L 348.913 4.481 L 343.077 5.457 L 341.941 5.647 L 337.077 6.461 L 335.942 6.651 L 331.078 7.465 L 329.942 7.655 L 325.078 8.469 L 323.943 8.659 L 319.079 9.473 L 317.944 9.663 L 313.080 10.477 L 311.944 10.667 L 307.080 11.481 L 305.945 11.671 L 301.081 12.484 L 299.946 12.674 L 295.082 13.488 L 293.946 13.678 L 289.082 14.492 L 287.947 14.682 L 278.056 16.337 L 276.921 16.527 L 272.057 17.341 L 270.922 17.531 L 267.031 18.182 L 265.895 18.372 L 262.004 19.023 L 260.868 19.213 L 256.005 20.027 L 254.869 20.217 L 248.060 21.357 L 246.924 21.547 L 242.060 22.360 L 240.925 22.550 L 236.061 23.364 L 234.925 23.554 L 230.062 24.368 L 228.926 24.558 L 224.062 25.372 L 222.927 25.562 L 218.063 26.376 L 216.927 26.566 L 212.064 27.380 L 210.928 27.570 L 198.119 29.713 L 196.984 29.903 L 189.039 31.233 L 187.903 31.423 L 181.094 32.562 L 179.958 32.752 L 175.095 33.566 L 173.959 33.756 L 169.095 34.570 L 167.960 34.760 L 163.096 35.574 L 161.960 35.764 L 157.097 36.577 L 155.961 36.767 L 151.097 37.581 L 149.962 37.771 L 145.098 38.585 L 143.962 38.775 L 139.099 39.589 L 137.963 39.779 L 133.099 40.593 L 131.964 40.783 L 126.127 41.760 L 124.992 41.950 L 120.128 42.763 L 118.992 42.953 L 102.130 45.775 L 100.994 45.965 L 91.104 47.620 L 89.968 47.810 L 86.077 48.461 L 84.942 48.651 L 81.051 49.302 L 79.915 49.492 L 75.051 50.306 L 73.916 50.496 L 70.025 51.147 L 68.889 51.337 L 62.080 52.477 L 56.890 53.345 L 49.108 54.647 L 47.973 54.837 L 37.110 56.655 L 35.974 56.845 L 32.083 57.496 L 30.947 57.686 L 27.056 58.337 L 25.921 58.527 L 9.058 61.349 L 7.923 61.539 Z",
      "province": "REGION_18",
      "rootTerritory": "REGION_18",
      "viewBox": "0 0 372 606",
      "unitSlots": [
        {
          "name": "main",
          "x": 188,
          "y": 67,
          "territory": "REGION_18",
          "arrowReceiver": {
            "x": 188,
            "y": 97
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 188,
          "y": 67,
          "territory": "REGION_18",
          "arrowReceiver": {
            "x": 188,
            "y": 97
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_19": {
    "territory": "REGION_19",
    "unitSlotName": "main",
    "province": "REGION_19",
    "provinceMapData": {
      "abbr": "GUA",
      "type": "Coast",
      "centerPos": {
        "x": 42,
        "y": 57
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 59,
          "y": 50,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 120,
      "height": 143,
      "x": 156,
      "y": 693,
      "playable": true,
      "path": "M 7.00 0.00 L 0.00 5.00 L 1.00 24.00 L 10.00 31.00 L 16.00 50.00 L 33.00 70.00 L 39.00 82.00 L 39.00 107.00 L 33.00 114.00 L 31.00 120.00 L 36.00 128.00 L 50.00 143.00 L 57.00 142.00 L 63.00 137.00 L 63.00 128.00 L 75.00 121.00 L 76.00 114.00 L 95.00 98.00 L 95.00 96.00 L 84.00 88.00 L 84.00 74.00 L 108.00 58.00 L 110.00 55.00 L 120.00 56.00 L 120.00 53.00 L 118.00 50.00 L 116.00 50.00 L 107.00 42.00 L 99.00 44.00 L 93.00 44.00 L 90.00 41.00 L 90.00 20.00 L 66.00 18.00 L 59.00 16.00 L 50.00 16.00 L 46.00 14.00 L 35.00 14.00 L 32.00 18.00 L 26.00 12.00 L 25.00 5.00 L 19.00 0.00 Z",
      "province": "REGION_19",
      "rootTerritory": "REGION_19",
      "viewBox": "0 0 120 143",
      "unitSlots": [
        {
          "name": "main",
          "x": 70,
          "y": 52,
          "territory": "REGION_19",
          "arrowReceiver": {
            "x": 70,
            "y": 82
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 70,
          "y": 52,
          "territory": "REGION_19",
          "arrowReceiver": {
            "x": 70,
            "y": 82
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "瓜达拉哈拉": {
    "territory": "REGION_19",
    "unitSlotName": "main",
    "province": "REGION_19",
    "provinceMapData": {
      "abbr": "GUA",
      "type": "Coast",
      "centerPos": {
        "x": 42,
        "y": 57
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 59,
          "y": 50,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 120,
      "height": 143,
      "x": 156,
      "y": 693,
      "playable": true,
      "path": "M 7.00 0.00 L 0.00 5.00 L 1.00 24.00 L 10.00 31.00 L 16.00 50.00 L 33.00 70.00 L 39.00 82.00 L 39.00 107.00 L 33.00 114.00 L 31.00 120.00 L 36.00 128.00 L 50.00 143.00 L 57.00 142.00 L 63.00 137.00 L 63.00 128.00 L 75.00 121.00 L 76.00 114.00 L 95.00 98.00 L 95.00 96.00 L 84.00 88.00 L 84.00 74.00 L 108.00 58.00 L 110.00 55.00 L 120.00 56.00 L 120.00 53.00 L 118.00 50.00 L 116.00 50.00 L 107.00 42.00 L 99.00 44.00 L 93.00 44.00 L 90.00 41.00 L 90.00 20.00 L 66.00 18.00 L 59.00 16.00 L 50.00 16.00 L 46.00 14.00 L 35.00 14.00 L 32.00 18.00 L 26.00 12.00 L 25.00 5.00 L 19.00 0.00 Z",
      "province": "REGION_19",
      "rootTerritory": "REGION_19",
      "viewBox": "0 0 120 143",
      "unitSlots": [
        {
          "name": "main",
          "x": 70,
          "y": 52,
          "territory": "REGION_19",
          "arrowReceiver": {
            "x": 70,
            "y": 82
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 70,
          "y": 52,
          "territory": "REGION_19",
          "arrowReceiver": {
            "x": 70,
            "y": 82
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_21": {
    "territory": "REGION_21",
    "unitSlotName": "main",
    "province": "REGION_21",
    "provinceMapData": {
      "abbr": "MEH",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 23,
          "y": 26,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 73,
      "height": 66,
      "x": 206,
      "y": 813,
      "playable": true,
      "path": "M 12.00 6.00 L 12.00 15.00 L 7.00 20.00 L 0.00 22.00 L 0.00 24.00 L 12.00 37.00 L 31.00 45.00 L 48.00 58.00 L 65.00 65.00 L 72.00 66.00 L 73.00 64.00 L 72.00 49.00 L 50.00 32.00 L 50.00 24.00 L 48.00 18.00 L 39.00 18.00 L 27.00 12.00 L 25.00 10.00 L 25.00 0.00 L 22.00 0.00 Z",
      "province": "REGION_21",
      "rootTerritory": "REGION_21",
      "viewBox": "0 0 73 66",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 39,
          "territory": "REGION_21",
          "arrowReceiver": {
            "x": 48,
            "y": 69
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 39,
          "territory": "REGION_21",
          "arrowReceiver": {
            "x": 48,
            "y": 69
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "米却背": {
    "territory": "REGION_21",
    "unitSlotName": "main",
    "province": "REGION_21",
    "provinceMapData": {
      "abbr": "MEH",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 23,
          "y": 26,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 73,
      "height": 66,
      "x": 206,
      "y": 813,
      "playable": true,
      "path": "M 12.00 6.00 L 12.00 15.00 L 7.00 20.00 L 0.00 22.00 L 0.00 24.00 L 12.00 37.00 L 31.00 45.00 L 48.00 58.00 L 65.00 65.00 L 72.00 66.00 L 73.00 64.00 L 72.00 49.00 L 50.00 32.00 L 50.00 24.00 L 48.00 18.00 L 39.00 18.00 L 27.00 12.00 L 25.00 10.00 L 25.00 0.00 L 22.00 0.00 Z",
      "province": "REGION_21",
      "rootTerritory": "REGION_21",
      "viewBox": "0 0 73 66",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 39,
          "territory": "REGION_21",
          "arrowReceiver": {
            "x": 48,
            "y": 69
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 39,
          "territory": "REGION_21",
          "arrowReceiver": {
            "x": 48,
            "y": 69
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_22": {
    "territory": "REGION_22",
    "unitSlotName": "main",
    "province": "REGION_22",
    "provinceMapData": {
      "abbr": "OAX",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 27,
          "y": 16,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 71,
      "height": 37,
      "x": 276,
      "y": 862,
      "playable": true,
      "path": "M 1.00 0.00 L 2.00 13.00 L 0.00 18.00 L 28.00 33.00 L 30.00 35.00 L 30.00 37.00 L 36.00 37.00 L 39.00 34.00 L 59.00 33.00 L 60.00 32.00 L 64.00 32.00 L 65.00 35.00 L 68.00 35.00 L 71.00 28.00 L 70.00 25.00 L 55.00 25.00 L 49.00 22.00 L 42.00 15.00 L 40.00 7.00 L 36.00 2.00 L 22.00 2.00 L 21.00 0.00 L 19.00 0.00 L 18.00 2.00 L 5.00 2.00 L 3.00 0.00 Z",
      "province": "REGION_22",
      "rootTerritory": "REGION_22",
      "viewBox": "0 0 71 37",
      "unitSlots": [
        {
          "name": "main",
          "x": 35,
          "y": 31,
          "territory": "REGION_22",
          "arrowReceiver": {
            "x": 35,
            "y": 61
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35,
          "y": 31,
          "territory": "REGION_22",
          "arrowReceiver": {
            "x": 35,
            "y": 61
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "瓦哈卡": {
    "territory": "REGION_22",
    "unitSlotName": "main",
    "province": "REGION_22",
    "provinceMapData": {
      "abbr": "OAX",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 27,
          "y": 16,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 71,
      "height": 37,
      "x": 276,
      "y": 862,
      "playable": true,
      "path": "M 1.00 0.00 L 2.00 13.00 L 0.00 18.00 L 28.00 33.00 L 30.00 35.00 L 30.00 37.00 L 36.00 37.00 L 39.00 34.00 L 59.00 33.00 L 60.00 32.00 L 64.00 32.00 L 65.00 35.00 L 68.00 35.00 L 71.00 28.00 L 70.00 25.00 L 55.00 25.00 L 49.00 22.00 L 42.00 15.00 L 40.00 7.00 L 36.00 2.00 L 22.00 2.00 L 21.00 0.00 L 19.00 0.00 L 18.00 2.00 L 5.00 2.00 L 3.00 0.00 Z",
      "province": "REGION_22",
      "rootTerritory": "REGION_22",
      "viewBox": "0 0 71 37",
      "unitSlots": [
        {
          "name": "main",
          "x": 35,
          "y": 31,
          "territory": "REGION_22",
          "arrowReceiver": {
            "x": 35,
            "y": 61
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35,
          "y": 31,
          "territory": "REGION_22",
          "arrowReceiver": {
            "x": 35,
            "y": 61
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_23": {
    "territory": "REGION_23",
    "unitSlotName": "main",
    "province": "REGION_23",
    "provinceMapData": {
      "abbr": "SAO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 384,
          "y": 478,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 480,
      "height": 629,
      "x": 814,
      "y": 1217,
      "playable": true,
      "path": "M 479.955 0.420 L 467.292 7.521 L 464.917 8.853 L 459.073 12.130 L 464.000 20.000 L 463.000 78.000 L 462.000 79.000 L 462.000 101.000 L 463.000 102.000 L 463.000 112.000 L 464.000 113.000 L 464.000 129.000 L 460.000 132.000 L 459.000 171.000 L 437.000 183.000 L 426.000 184.000 L 421.000 187.000 L 407.000 188.000 L 408.000 217.000 L 409.000 218.000 L 409.000 227.000 L 410.000 228.000 L 408.000 318.000 L 397.000 326.000 L 371.000 328.000 L 352.000 338.000 L 316.000 343.000 L 316.000 373.000 L 312.000 380.000 L 313.000 413.000 L 308.000 419.000 L 303.000 421.000 L 300.000 421.000 L 287.000 426.000 L 284.000 426.000 L 280.000 428.000 L 242.000 431.000 L 238.000 435.000 L 195.000 436.000 L 192.000 438.000 L 183.000 438.000 L 179.000 440.000 L 176.000 445.000 L 175.000 481.000 L 171.000 488.000 L 170.000 516.000 L 166.000 523.000 L 162.000 523.000 L 161.000 524.000 L 153.000 524.000 L 152.000 525.000 L 143.000 525.000 L 142.000 526.000 L 138.000 526.000 L 131.000 530.000 L 103.000 531.000 L 99.000 534.000 L 86.000 532.000 L 83.000 534.000 L 53.000 535.000 L 50.000 538.000 L 37.000 537.000 L 36.000 538.000 L 13.000 539.000 L 13.000 543.000 L 9.000 550.000 L 8.000 567.000 L 4.985 571.998 L 0.890 600.023 L 22.000 600.000 L 23.000 601.000 L 23.000 629.000 L 33.000 629.000 L 34.000 628.000 L 53.000 628.000 L 54.000 627.000 L 63.000 627.000 L 66.000 625.000 L 85.000 625.000 L 88.000 623.000 L 97.000 623.000 L 98.000 622.000 L 131.000 621.000 L 132.000 620.000 L 146.000 619.000 L 149.000 615.000 L 157.000 615.000 L 160.000 617.000 L 167.000 617.000 L 168.000 616.000 L 176.000 616.000 L 179.000 614.000 L 190.000 614.000 L 191.000 613.000 L 202.000 613.000 L 205.000 611.000 L 216.000 611.000 L 219.000 609.000 L 257.000 607.000 L 258.000 606.000 L 261.000 606.000 L 265.000 604.000 L 268.000 604.000 L 272.000 602.000 L 275.000 602.000 L 276.000 601.000 L 278.000 601.000 L 282.000 599.000 L 285.000 599.000 L 289.000 597.000 L 292.000 597.000 L 293.000 596.000 L 319.000 597.000 L 320.000 596.000 L 323.000 596.000 L 324.000 595.000 L 326.000 595.000 L 330.000 593.000 L 333.000 593.000 L 340.000 590.000 L 343.000 590.000 L 350.000 587.000 L 353.000 587.000 L 354.000 586.000 L 360.000 585.000 L 367.000 582.000 L 370.000 582.000 L 377.000 579.000 L 380.000 579.000 L 387.000 576.000 L 390.000 576.000 L 391.000 575.000 L 401.000 575.000 L 402.000 574.000 L 411.000 574.000 L 426.000 566.000 L 450.000 562.000 L 468.000 552.000 L 480.000 552.000 Z",
      "province": "REGION_23",
      "rootTerritory": "REGION_23",
      "viewBox": "0 0 480 629",
      "unitSlots": [
        {
          "name": "main",
          "x": 247,
          "y": 546,
          "territory": "REGION_23",
          "arrowReceiver": {
            "x": 247,
            "y": 576
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 247,
          "y": 546,
          "territory": "REGION_23",
          "arrowReceiver": {
            "x": 247,
            "y": 576
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "南大西洋": {
    "territory": "REGION_23",
    "unitSlotName": "main",
    "province": "REGION_23",
    "provinceMapData": {
      "abbr": "SAO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 384,
          "y": 478,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 480,
      "height": 629,
      "x": 814,
      "y": 1217,
      "playable": true,
      "path": "M 479.955 0.420 L 467.292 7.521 L 464.917 8.853 L 459.073 12.130 L 464.000 20.000 L 463.000 78.000 L 462.000 79.000 L 462.000 101.000 L 463.000 102.000 L 463.000 112.000 L 464.000 113.000 L 464.000 129.000 L 460.000 132.000 L 459.000 171.000 L 437.000 183.000 L 426.000 184.000 L 421.000 187.000 L 407.000 188.000 L 408.000 217.000 L 409.000 218.000 L 409.000 227.000 L 410.000 228.000 L 408.000 318.000 L 397.000 326.000 L 371.000 328.000 L 352.000 338.000 L 316.000 343.000 L 316.000 373.000 L 312.000 380.000 L 313.000 413.000 L 308.000 419.000 L 303.000 421.000 L 300.000 421.000 L 287.000 426.000 L 284.000 426.000 L 280.000 428.000 L 242.000 431.000 L 238.000 435.000 L 195.000 436.000 L 192.000 438.000 L 183.000 438.000 L 179.000 440.000 L 176.000 445.000 L 175.000 481.000 L 171.000 488.000 L 170.000 516.000 L 166.000 523.000 L 162.000 523.000 L 161.000 524.000 L 153.000 524.000 L 152.000 525.000 L 143.000 525.000 L 142.000 526.000 L 138.000 526.000 L 131.000 530.000 L 103.000 531.000 L 99.000 534.000 L 86.000 532.000 L 83.000 534.000 L 53.000 535.000 L 50.000 538.000 L 37.000 537.000 L 36.000 538.000 L 13.000 539.000 L 13.000 543.000 L 9.000 550.000 L 8.000 567.000 L 4.985 571.998 L 0.890 600.023 L 22.000 600.000 L 23.000 601.000 L 23.000 629.000 L 33.000 629.000 L 34.000 628.000 L 53.000 628.000 L 54.000 627.000 L 63.000 627.000 L 66.000 625.000 L 85.000 625.000 L 88.000 623.000 L 97.000 623.000 L 98.000 622.000 L 131.000 621.000 L 132.000 620.000 L 146.000 619.000 L 149.000 615.000 L 157.000 615.000 L 160.000 617.000 L 167.000 617.000 L 168.000 616.000 L 176.000 616.000 L 179.000 614.000 L 190.000 614.000 L 191.000 613.000 L 202.000 613.000 L 205.000 611.000 L 216.000 611.000 L 219.000 609.000 L 257.000 607.000 L 258.000 606.000 L 261.000 606.000 L 265.000 604.000 L 268.000 604.000 L 272.000 602.000 L 275.000 602.000 L 276.000 601.000 L 278.000 601.000 L 282.000 599.000 L 285.000 599.000 L 289.000 597.000 L 292.000 597.000 L 293.000 596.000 L 319.000 597.000 L 320.000 596.000 L 323.000 596.000 L 324.000 595.000 L 326.000 595.000 L 330.000 593.000 L 333.000 593.000 L 340.000 590.000 L 343.000 590.000 L 350.000 587.000 L 353.000 587.000 L 354.000 586.000 L 360.000 585.000 L 367.000 582.000 L 370.000 582.000 L 377.000 579.000 L 380.000 579.000 L 387.000 576.000 L 390.000 576.000 L 391.000 575.000 L 401.000 575.000 L 402.000 574.000 L 411.000 574.000 L 426.000 566.000 L 450.000 562.000 L 468.000 552.000 L 480.000 552.000 Z",
      "province": "REGION_23",
      "rootTerritory": "REGION_23",
      "viewBox": "0 0 480 629",
      "unitSlots": [
        {
          "name": "main",
          "x": 247,
          "y": 546,
          "territory": "REGION_23",
          "arrowReceiver": {
            "x": 247,
            "y": 576
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 247,
          "y": 546,
          "territory": "REGION_23",
          "arrowReceiver": {
            "x": 247,
            "y": 576
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_24": {
    "territory": "REGION_24",
    "unitSlotName": "main",
    "province": "REGION_24",
    "provinceMapData": {
      "abbr": "TKM",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 23,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 76,
      "height": 73,
      "x": 749,
      "y": 1517,
      "playable": true,
      "path": "M 74.00 0.00 L 68.00 1.00 L 60.00 9.00 L 38.00 9.00 L 25.00 33.00 L 23.00 35.00 L 6.00 38.00 L 0.00 46.00 L 0.00 53.00 L 11.00 61.00 L 21.00 60.00 L 31.00 73.00 L 33.00 73.00 L 33.00 61.00 L 35.00 57.00 L 66.00 23.00 L 74.00 6.00 L 76.00 5.00 Z",
      "province": "REGION_24",
      "rootTerritory": "REGION_24",
      "viewBox": "0 0 76 73",
      "unitSlots": [
        {
          "name": "main",
          "x": 35,
          "y": 42,
          "territory": "REGION_24",
          "arrowReceiver": {
            "x": 35,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35,
          "y": 42,
          "territory": "REGION_24",
          "arrowReceiver": {
            "x": 35,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "图库曼": {
    "territory": "REGION_24",
    "unitSlotName": "main",
    "province": "REGION_24",
    "provinceMapData": {
      "abbr": "TKM",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 23,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 76,
      "height": 73,
      "x": 749,
      "y": 1517,
      "playable": true,
      "path": "M 74.00 0.00 L 68.00 1.00 L 60.00 9.00 L 38.00 9.00 L 25.00 33.00 L 23.00 35.00 L 6.00 38.00 L 0.00 46.00 L 0.00 53.00 L 11.00 61.00 L 21.00 60.00 L 31.00 73.00 L 33.00 73.00 L 33.00 61.00 L 35.00 57.00 L 66.00 23.00 L 74.00 6.00 L 76.00 5.00 Z",
      "province": "REGION_24",
      "rootTerritory": "REGION_24",
      "viewBox": "0 0 76 73",
      "unitSlots": [
        {
          "name": "main",
          "x": 35,
          "y": 42,
          "territory": "REGION_24",
          "arrowReceiver": {
            "x": 35,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35,
          "y": 42,
          "territory": "REGION_24",
          "arrowReceiver": {
            "x": 35,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_25": {
    "territory": "REGION_25",
    "unitSlotName": "main",
    "province": "REGION_25",
    "provinceMapData": {
      "abbr": "TUC",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 37,
          "y": 46,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 78,
      "height": 77,
      "x": 781,
      "y": 1521,
      "playable": true,
      "path": "M 45.00 0.00 L 41.00 0.00 L 33.00 17.00 L 2.00 51.00 L 0.00 55.00 L 0.00 71.00 L 2.00 73.00 L 31.00 77.00 L 48.00 65.00 L 55.00 65.00 L 58.00 63.00 L 67.00 64.00 L 78.00 55.00 L 77.00 49.00 L 67.00 45.00 L 53.00 29.00 L 54.00 12.00 Z",
      "province": "REGION_25",
      "rootTerritory": "REGION_25",
      "viewBox": "0 0 78 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 42,
          "y": 53,
          "territory": "REGION_25",
          "arrowReceiver": {
            "x": 42,
            "y": 83
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42,
          "y": 53,
          "territory": "REGION_25",
          "arrowReceiver": {
            "x": 42,
            "y": 83
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "南查科": {
    "territory": "REGION_25",
    "unitSlotName": "main",
    "province": "REGION_25",
    "provinceMapData": {
      "abbr": "TUC",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 37,
          "y": 46,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 78,
      "height": 77,
      "x": 781,
      "y": 1521,
      "playable": true,
      "path": "M 45.00 0.00 L 41.00 0.00 L 33.00 17.00 L 2.00 51.00 L 0.00 55.00 L 0.00 71.00 L 2.00 73.00 L 31.00 77.00 L 48.00 65.00 L 55.00 65.00 L 58.00 63.00 L 67.00 64.00 L 78.00 55.00 L 77.00 49.00 L 67.00 45.00 L 53.00 29.00 L 54.00 12.00 Z",
      "province": "REGION_25",
      "rootTerritory": "REGION_25",
      "viewBox": "0 0 78 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 42,
          "y": 53,
          "territory": "REGION_25",
          "arrowReceiver": {
            "x": 42,
            "y": 83
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42,
          "y": 53,
          "territory": "REGION_25",
          "arrowReceiver": {
            "x": 42,
            "y": 83
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_26": {
    "territory": "REGION_26",
    "unitSlotName": "main",
    "province": "REGION_26",
    "provinceMapData": {
      "abbr": "LAR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35,
          "y": 35,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 55,
      "x": 715,
      "y": 1569,
      "playable": true,
      "path": "M 69.00 23.00 L 57.00 7.00 L 47.00 8.00 L 38.00 1.00 L 34.00 0.00 L 34.00 15.00 L 32.00 19.00 L 26.00 22.00 L 0.00 51.00 L 0.00 53.00 L 26.00 55.00 L 36.00 51.00 L 44.00 50.00 L 49.00 42.00 L 67.00 25.00 L 69.00 25.00 Z",
      "province": "REGION_26",
      "rootTerritory": "REGION_26",
      "viewBox": "0 0 69 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 31,
          "y": 39,
          "territory": "REGION_26",
          "arrowReceiver": {
            "x": 31,
            "y": 69
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 31,
          "y": 39,
          "territory": "REGION_26",
          "arrowReceiver": {
            "x": 31,
            "y": 69
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "拉里奥哈": {
    "territory": "REGION_26",
    "unitSlotName": "main",
    "province": "REGION_26",
    "provinceMapData": {
      "abbr": "LAR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35,
          "y": 35,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 55,
      "x": 715,
      "y": 1569,
      "playable": true,
      "path": "M 69.00 23.00 L 57.00 7.00 L 47.00 8.00 L 38.00 1.00 L 34.00 0.00 L 34.00 15.00 L 32.00 19.00 L 26.00 22.00 L 0.00 51.00 L 0.00 53.00 L 26.00 55.00 L 36.00 51.00 L 44.00 50.00 L 49.00 42.00 L 67.00 25.00 L 69.00 25.00 Z",
      "province": "REGION_26",
      "rootTerritory": "REGION_26",
      "viewBox": "0 0 69 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 31,
          "y": 39,
          "territory": "REGION_26",
          "arrowReceiver": {
            "x": 31,
            "y": 69
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 31,
          "y": 39,
          "territory": "REGION_26",
          "arrowReceiver": {
            "x": 31,
            "y": 69
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_27": {
    "territory": "REGION_27",
    "unitSlotName": "main",
    "province": "REGION_27",
    "provinceMapData": {
      "abbr": "CRR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 21,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 61,
      "height": 77,
      "x": 838,
      "y": 1575,
      "playable": true,
      "path": "M 61.00 21.00 L 51.00 21.00 L 48.00 18.00 L 27.00 8.00 L 21.00 0.00 L 17.00 1.00 L 9.00 8.00 L 9.00 10.00 L 14.00 10.00 L 17.00 15.00 L 18.00 32.00 L 5.00 45.00 L 6.00 53.00 L 0.00 61.00 L 1.00 73.00 L 6.00 77.00 L 9.00 77.00 L 10.00 66.00 L 27.00 33.00 L 29.00 31.00 L 48.00 29.00 L 51.00 33.00 L 54.00 33.00 L 60.00 25.00 Z",
      "province": "REGION_27",
      "rootTerritory": "REGION_27",
      "viewBox": "0 0 61 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 15,
          "territory": "REGION_27",
          "arrowReceiver": {
            "x": 39,
            "y": 45
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 15,
          "territory": "REGION_27",
          "arrowReceiver": {
            "x": 39,
            "y": 45
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "科连特斯": {
    "territory": "REGION_27",
    "unitSlotName": "main",
    "province": "REGION_27",
    "provinceMapData": {
      "abbr": "CRR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 21,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 61,
      "height": 77,
      "x": 838,
      "y": 1575,
      "playable": true,
      "path": "M 61.00 21.00 L 51.00 21.00 L 48.00 18.00 L 27.00 8.00 L 21.00 0.00 L 17.00 1.00 L 9.00 8.00 L 9.00 10.00 L 14.00 10.00 L 17.00 15.00 L 18.00 32.00 L 5.00 45.00 L 6.00 53.00 L 0.00 61.00 L 1.00 73.00 L 6.00 77.00 L 9.00 77.00 L 10.00 66.00 L 27.00 33.00 L 29.00 31.00 L 48.00 29.00 L 51.00 33.00 L 54.00 33.00 L 60.00 25.00 Z",
      "province": "REGION_27",
      "rootTerritory": "REGION_27",
      "viewBox": "0 0 61 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 15,
          "territory": "REGION_27",
          "arrowReceiver": {
            "x": 39,
            "y": 45
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 15,
          "territory": "REGION_27",
          "arrowReceiver": {
            "x": 39,
            "y": 45
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_28": {
    "territory": "REGION_28",
    "unitSlotName": "main",
    "province": "REGION_28",
    "provinceMapData": {
      "abbr": "CHA",
      "type": "Land",
      "centerPos": {
        "x": 19,
        "y": 26
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36,
          "y": 19,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 54,
      "height": 71,
      "x": 803,
      "y": 1583,
      "playable": true,
      "path": "M 51.00 1.00 L 34.00 0.00 L 31.00 2.00 L 24.00 2.00 L 8.00 13.00 L 8.00 15.00 L 13.00 15.00 L 18.00 17.00 L 18.00 26.00 L 0.00 61.00 L 0.00 64.00 L 6.00 71.00 L 8.00 71.00 L 25.00 62.00 L 33.00 62.00 L 35.00 64.00 L 37.00 64.00 L 36.00 55.00 L 42.00 47.00 L 41.00 39.00 L 54.00 26.00 L 53.00 5.00 Z",
      "province": "REGION_28",
      "rootTerritory": "REGION_28",
      "viewBox": "0 0 54 71",
      "unitSlots": [
        {
          "name": "main",
          "x": 20,
          "y": 53,
          "territory": "REGION_28",
          "arrowReceiver": {
            "x": 20,
            "y": 83
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 20,
          "y": 53,
          "territory": "REGION_28",
          "arrowReceiver": {
            "x": 20,
            "y": 83
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡塔马卡": {
    "territory": "REGION_28",
    "unitSlotName": "main",
    "province": "REGION_28",
    "provinceMapData": {
      "abbr": "CHA",
      "type": "Land",
      "centerPos": {
        "x": 19,
        "y": 26
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36,
          "y": 19,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 54,
      "height": 71,
      "x": 803,
      "y": 1583,
      "playable": true,
      "path": "M 51.00 1.00 L 34.00 0.00 L 31.00 2.00 L 24.00 2.00 L 8.00 13.00 L 8.00 15.00 L 13.00 15.00 L 18.00 17.00 L 18.00 26.00 L 0.00 61.00 L 0.00 64.00 L 6.00 71.00 L 8.00 71.00 L 25.00 62.00 L 33.00 62.00 L 35.00 64.00 L 37.00 64.00 L 36.00 55.00 L 42.00 47.00 L 41.00 39.00 L 54.00 26.00 L 53.00 5.00 Z",
      "province": "REGION_28",
      "rootTerritory": "REGION_28",
      "viewBox": "0 0 54 71",
      "unitSlots": [
        {
          "name": "main",
          "x": 20,
          "y": 53,
          "territory": "REGION_28",
          "arrowReceiver": {
            "x": 20,
            "y": 83
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 20,
          "y": 53,
          "territory": "REGION_28",
          "arrowReceiver": {
            "x": 20,
            "y": 83
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_29": {
    "territory": "REGION_29",
    "unitSlotName": "main",
    "province": "REGION_29",
    "provinceMapData": {
      "abbr": "SVC",
      "type": "Land",
      "centerPos": {
        "x": 1,
        "y": 8
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 76,
      "height": 53,
      "x": 746,
      "y": 1593,
      "playable": true,
      "path": "M 0.00 27.00 L 0.00 29.00 L 10.00 29.00 L 11.00 30.00 L 12.00 47.00 L 14.00 48.00 L 52.00 49.00 L 56.00 53.00 L 58.00 53.00 L 76.00 18.00 L 76.00 5.00 L 34.00 0.00 L 17.00 16.00 L 11.00 25.00 Z",
      "province": "REGION_29",
      "rootTerritory": "REGION_29",
      "viewBox": "0 0 76 53",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 27,
          "territory": "REGION_29",
          "arrowReceiver": {
            "x": 27,
            "y": 57
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 27,
          "territory": "REGION_29",
          "arrowReceiver": {
            "x": 27,
            "y": 57
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "科尔多瓦": {
    "territory": "REGION_29",
    "unitSlotName": "main",
    "province": "REGION_29",
    "provinceMapData": {
      "abbr": "SVC",
      "type": "Land",
      "centerPos": {
        "x": 1,
        "y": 8
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 76,
      "height": 53,
      "x": 746,
      "y": 1593,
      "playable": true,
      "path": "M 0.00 27.00 L 0.00 29.00 L 10.00 29.00 L 11.00 30.00 L 12.00 47.00 L 14.00 48.00 L 52.00 49.00 L 56.00 53.00 L 58.00 53.00 L 76.00 18.00 L 76.00 5.00 L 34.00 0.00 L 17.00 16.00 L 11.00 25.00 Z",
      "province": "REGION_29",
      "rootTerritory": "REGION_29",
      "viewBox": "0 0 76 53",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 27,
          "territory": "REGION_29",
          "arrowReceiver": {
            "x": 27,
            "y": 57
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 27,
          "territory": "REGION_29",
          "arrowReceiver": {
            "x": 27,
            "y": 57
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_30": {
    "territory": "REGION_30",
    "unitSlotName": "main",
    "province": "REGION_30",
    "provinceMapData": {
      "abbr": "BUE",
      "type": "Coast",
      "centerPos": {
        "x": 4,
        "y": -10
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21,
          "y": 31,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 41,
      "height": 62,
      "x": 810,
      "y": 1644,
      "playable": true,
      "path": "M 28.00 0.00 L 16.00 0.00 L 0.00 8.00 L 0.00 11.00 L 4.00 15.00 L 2.00 51.00 L 6.00 55.00 L 7.00 55.00 L 13.00 62.00 L 14.00 61.00 L 16.00 61.00 L 19.00 58.00 L 28.00 54.00 L 40.00 40.00 L 39.00 30.00 L 41.00 28.00 L 41.00 25.00 L 36.00 20.00 L 37.00 7.00 Z",
      "province": "REGION_30",
      "rootTerritory": "REGION_30",
      "viewBox": "0 0 41 62",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 14,
          "territory": "REGION_30",
          "arrowReceiver": {
            "x": 24,
            "y": 44
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 14,
          "territory": "REGION_30",
          "arrowReceiver": {
            "x": 24,
            "y": 44
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "布宜诺斯艾利斯": {
    "territory": "REGION_30",
    "unitSlotName": "main",
    "province": "REGION_30",
    "provinceMapData": {
      "abbr": "BUE",
      "type": "Coast",
      "centerPos": {
        "x": 4,
        "y": -10
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21,
          "y": 31,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 41,
      "height": 62,
      "x": 810,
      "y": 1644,
      "playable": true,
      "path": "M 28.00 0.00 L 16.00 0.00 L 0.00 8.00 L 0.00 11.00 L 4.00 15.00 L 2.00 51.00 L 6.00 55.00 L 7.00 55.00 L 13.00 62.00 L 14.00 61.00 L 16.00 61.00 L 19.00 58.00 L 28.00 54.00 L 40.00 40.00 L 39.00 30.00 L 41.00 28.00 L 41.00 25.00 L 36.00 20.00 L 37.00 7.00 Z",
      "province": "REGION_30",
      "rootTerritory": "REGION_30",
      "viewBox": "0 0 41 62",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 14,
          "territory": "REGION_30",
          "arrowReceiver": {
            "x": 24,
            "y": 44
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 14,
          "territory": "REGION_30",
          "arrowReceiver": {
            "x": 24,
            "y": 44
          }
        }
      },
      "texture": {
        "texture": "#C6A8D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_40": {
    "territory": "REGION_40",
    "unitSlotName": "main",
    "province": "REGION_40",
    "provinceMapData": {
      "abbr": "MAB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 68,
          "y": 33,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 92,
      "height": 55,
      "x": 715,
      "y": 438,
      "playable": true,
      "path": "M 90.231 4.715 L 79.000 4.000 L 62.000 13.000 L 61.000 12.000 L 60.444 0.384 L 60.444 0.384 L 41.000 2.000 L 42.000 17.000 L 32.000 25.000 L 24.000 24.000 L 0.000 45.000 L 3.013 54.222 L 30.003 53.795 L 37.995 53.669 L 57.994 53.353 L 58.997 53.337 L 91.113 52.829 L 90.806 41.091 L 90.666 34.975 Z",
      "province": "REGION_40",
      "rootTerritory": "REGION_40",
      "viewBox": "0 0 92 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 52,
          "y": 41,
          "territory": "REGION_40",
          "arrowReceiver": {
            "x": 52,
            "y": 71
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 52,
          "y": 41,
          "territory": "REGION_40",
          "arrowReceiver": {
            "x": 52,
            "y": 71
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "马萨诸塞湾": {
    "territory": "REGION_40",
    "unitSlotName": "main",
    "province": "REGION_40",
    "provinceMapData": {
      "abbr": "MAB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 68,
          "y": 33,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 92,
      "height": 55,
      "x": 715,
      "y": 438,
      "playable": true,
      "path": "M 90.231 4.715 L 79.000 4.000 L 62.000 13.000 L 61.000 12.000 L 60.444 0.384 L 60.444 0.384 L 41.000 2.000 L 42.000 17.000 L 32.000 25.000 L 24.000 24.000 L 0.000 45.000 L 3.013 54.222 L 30.003 53.795 L 37.995 53.669 L 57.994 53.353 L 58.997 53.337 L 91.113 52.829 L 90.806 41.091 L 90.666 34.975 Z",
      "province": "REGION_40",
      "rootTerritory": "REGION_40",
      "viewBox": "0 0 92 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 52,
          "y": 41,
          "territory": "REGION_40",
          "arrowReceiver": {
            "x": 52,
            "y": 71
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 52,
          "y": 41,
          "territory": "REGION_40",
          "arrowReceiver": {
            "x": 52,
            "y": 71
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_42": {
    "territory": "REGION_42",
    "unitSlotName": "main",
    "province": "REGION_42",
    "provinceMapData": {
      "abbr": "GUL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 92,
          "y": 37,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 157,
      "height": 72,
      "x": 651,
      "y": 490,
      "playable": true,
      "path": "M 155.113 0.829 L 120.999 1.368 L 119.998 1.384 L 109.000 1.558 L 107.997 1.574 L 97.002 1.748 L 96.005 1.763 L 67.013 2.222 L 67.000 10.000 L 64.000 14.000 L 50.000 19.000 L 41.000 26.000 L 29.000 28.000 L 28.000 36.000 L 23.000 46.000 L 14.000 54.000 L 12.000 54.000 L 9.000 62.000 L 1.000 67.000 L 0.000 71.000 L 1.000 72.000 L 119.998 70.551 L 126.566 60.478 L 136.619 44.759 L 141.530 37.082 L 149.185 25.114 L 156.194 14.156 Z",
      "province": "REGION_42",
      "rootTerritory": "REGION_42",
      "viewBox": "0 0 157 72",
      "unitSlots": [
        {
          "name": "main",
          "x": 69,
          "y": 59,
          "territory": "REGION_42",
          "arrowReceiver": {
            "x": 69,
            "y": 89
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 69,
          "y": 59,
          "territory": "REGION_42",
          "arrowReceiver": {
            "x": 69,
            "y": 89
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "墨西哥湾流": {
    "territory": "REGION_42",
    "unitSlotName": "main",
    "province": "REGION_42",
    "provinceMapData": {
      "abbr": "GUL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 92,
          "y": 37,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 157,
      "height": 72,
      "x": 651,
      "y": 490,
      "playable": true,
      "path": "M 155.113 0.829 L 120.999 1.368 L 119.998 1.384 L 109.000 1.558 L 107.997 1.574 L 97.002 1.748 L 96.005 1.763 L 67.013 2.222 L 67.000 10.000 L 64.000 14.000 L 50.000 19.000 L 41.000 26.000 L 29.000 28.000 L 28.000 36.000 L 23.000 46.000 L 14.000 54.000 L 12.000 54.000 L 9.000 62.000 L 1.000 67.000 L 0.000 71.000 L 1.000 72.000 L 119.998 70.551 L 126.566 60.478 L 136.619 44.759 L 141.530 37.082 L 149.185 25.114 L 156.194 14.156 Z",
      "province": "REGION_42",
      "rootTerritory": "REGION_42",
      "viewBox": "0 0 157 72",
      "unitSlots": [
        {
          "name": "main",
          "x": 69,
          "y": 59,
          "territory": "REGION_42",
          "arrowReceiver": {
            "x": 69,
            "y": 89
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 69,
          "y": 59,
          "territory": "REGION_42",
          "arrowReceiver": {
            "x": 69,
            "y": 89
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_44": {
    "territory": "REGION_44",
    "unitSlotName": "main",
    "province": "REGION_44",
    "provinceMapData": {
      "abbr": "ANC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 119,
          "y": 42,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 198,
      "height": 122,
      "x": 573,
      "y": 560,
      "playable": true,
      "path": "M 197.998 0.551 L 81.000 1.000 L 78.000 0.000 L 78.000 5.000 L 80.000 6.000 L 80.000 28.000 L 69.000 50.000 L 67.000 52.000 L 36.000 67.000 L 1.000 98.000 L 0.000 103.000 L 2.000 108.000 L 4.019 119.831 L 51.314 121.228 L 51.314 121.228 L 52.000 106.000 L 53.000 105.000 L 53.000 92.000 L 55.000 84.000 L 151.188 81.083 L 165.954 67.348 L 172.406 53.176 L 181.574 34.295 L 186.856 23.417 L 191.732 13.375 L 197.998 0.551 Z",
      "province": "REGION_44",
      "rootTerritory": "REGION_44",
      "viewBox": "0 0 198 122",
      "unitSlots": [
        {
          "name": "main",
          "x": 87,
          "y": 80,
          "territory": "REGION_44",
          "arrowReceiver": {
            "x": 87,
            "y": 110
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 87,
          "y": 80,
          "territory": "REGION_44",
          "arrowReceiver": {
            "x": 87,
            "y": 110
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "安的列斯洋流": {
    "territory": "REGION_44",
    "unitSlotName": "main",
    "province": "REGION_44",
    "provinceMapData": {
      "abbr": "ANC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 119,
          "y": 42,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 198,
      "height": 122,
      "x": 573,
      "y": 560,
      "playable": true,
      "path": "M 197.998 0.551 L 81.000 1.000 L 78.000 0.000 L 78.000 5.000 L 80.000 6.000 L 80.000 28.000 L 69.000 50.000 L 67.000 52.000 L 36.000 67.000 L 1.000 98.000 L 0.000 103.000 L 2.000 108.000 L 4.019 119.831 L 51.314 121.228 L 51.314 121.228 L 52.000 106.000 L 53.000 105.000 L 53.000 92.000 L 55.000 84.000 L 151.188 81.083 L 165.954 67.348 L 172.406 53.176 L 181.574 34.295 L 186.856 23.417 L 191.732 13.375 L 197.998 0.551 Z",
      "province": "REGION_44",
      "rootTerritory": "REGION_44",
      "viewBox": "0 0 198 122",
      "unitSlots": [
        {
          "name": "main",
          "x": 87,
          "y": 80,
          "territory": "REGION_44",
          "arrowReceiver": {
            "x": 87,
            "y": 110
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 87,
          "y": 80,
          "territory": "REGION_44",
          "arrowReceiver": {
            "x": 87,
            "y": 110
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_47": {
    "territory": "REGION_47",
    "unitSlotName": "main",
    "province": "REGION_47",
    "provinceMapData": {
      "abbr": "APB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 30,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 117,
      "height": 61,
      "x": 427,
      "y": 669,
      "playable": true,
      "path": "M 3.00 20.00 L 2.00 36.00 L 0.00 39.00 L 0.00 51.00 L 3.00 57.00 L 115.00 61.00 L 117.00 33.00 L 102.00 20.00 L 98.00 12.00 L 95.00 12.00 L 90.00 15.00 L 78.00 15.00 L 73.00 8.00 L 48.00 4.00 L 45.00 3.00 L 42.00 0.00 L 24.00 1.00 L 21.00 3.00 L 15.00 16.00 Z",
      "province": "REGION_47",
      "rootTerritory": "REGION_47",
      "viewBox": "0 0 117 61",
      "unitSlots": [
        {
          "name": "main",
          "x": 64,
          "y": 33,
          "territory": "REGION_47",
          "arrowReceiver": {
            "x": 64,
            "y": 63
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 64,
          "y": 33,
          "territory": "REGION_47",
          "arrowReceiver": {
            "x": 64,
            "y": 63
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿帕拉齐湾": {
    "territory": "REGION_47",
    "unitSlotName": "main",
    "province": "REGION_47",
    "provinceMapData": {
      "abbr": "APB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 30,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 117,
      "height": 61,
      "x": 427,
      "y": 669,
      "playable": true,
      "path": "M 3.00 20.00 L 2.00 36.00 L 0.00 39.00 L 0.00 51.00 L 3.00 57.00 L 115.00 61.00 L 117.00 33.00 L 102.00 20.00 L 98.00 12.00 L 95.00 12.00 L 90.00 15.00 L 78.00 15.00 L 73.00 8.00 L 48.00 4.00 L 45.00 3.00 L 42.00 0.00 L 24.00 1.00 L 21.00 3.00 L 15.00 16.00 Z",
      "province": "REGION_47",
      "rootTerritory": "REGION_47",
      "viewBox": "0 0 117 61",
      "unitSlots": [
        {
          "name": "main",
          "x": 64,
          "y": 33,
          "territory": "REGION_47",
          "arrowReceiver": {
            "x": 64,
            "y": 63
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 64,
          "y": 33,
          "territory": "REGION_47",
          "arrowReceiver": {
            "x": 64,
            "y": 63
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_48": {
    "territory": "REGION_48",
    "unitSlotName": "main",
    "province": "REGION_48",
    "provinceMapData": {
      "abbr": "GOM",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 83,
          "y": 75,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 244,
      "height": 139,
      "x": 298,
      "y": 680,
      "playable": true,
      "path": "M 2.000 75.000 L 0.000 105.000 L 5.000 104.000 L 10.000 105.000 L 12.000 120.000 L 18.072 126.737 L 42.984 129.168 L 44.069 129.274 L 53.978 130.240 L 59.119 130.742 L 75.964 132.385 L 79.123 132.694 L 113.851 136.082 L 113.851 136.082 L 145.000 129.000 L 148.000 126.000 L 163.000 126.000 L 175.920 133.964 L 175.920 133.964 L 225.039 138.033 L 237.000 125.000 L 239.000 80.000 L 240.000 79.000 L 240.000 62.000 L 241.000 61.000 L 241.000 52.000 L 244.000 51.000 L 244.000 49.000 L 134.000 45.000 L 130.000 38.000 L 130.000 30.000 L 132.000 27.000 L 133.000 9.000 L 124.000 9.000 L 117.000 5.000 L 99.000 4.000 L 90.000 0.000 L 87.000 0.000 L 86.000 1.000 L 75.000 2.000 L 58.000 14.000 L 41.000 18.000 L 31.000 34.000 L 29.000 55.000 L 28.000 56.000 L 15.000 56.000 Z",
      "province": "REGION_48",
      "rootTerritory": "REGION_48",
      "viewBox": "0 0 244 139",
      "unitSlots": [
        {
          "name": "main",
          "x": 119,
          "y": 93,
          "territory": "REGION_48",
          "arrowReceiver": {
            "x": 119,
            "y": 123
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 119,
          "y": 93,
          "territory": "REGION_48",
          "arrowReceiver": {
            "x": 119,
            "y": 123
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "墨西哥湾": {
    "territory": "REGION_48",
    "unitSlotName": "main",
    "province": "REGION_48",
    "provinceMapData": {
      "abbr": "GOM",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 83,
          "y": 75,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 244,
      "height": 139,
      "x": 298,
      "y": 680,
      "playable": true,
      "path": "M 2.000 75.000 L 0.000 105.000 L 5.000 104.000 L 10.000 105.000 L 12.000 120.000 L 18.072 126.737 L 42.984 129.168 L 44.069 129.274 L 53.978 130.240 L 59.119 130.742 L 75.964 132.385 L 79.123 132.694 L 113.851 136.082 L 113.851 136.082 L 145.000 129.000 L 148.000 126.000 L 163.000 126.000 L 175.920 133.964 L 175.920 133.964 L 225.039 138.033 L 237.000 125.000 L 239.000 80.000 L 240.000 79.000 L 240.000 62.000 L 241.000 61.000 L 241.000 52.000 L 244.000 51.000 L 244.000 49.000 L 134.000 45.000 L 130.000 38.000 L 130.000 30.000 L 132.000 27.000 L 133.000 9.000 L 124.000 9.000 L 117.000 5.000 L 99.000 4.000 L 90.000 0.000 L 87.000 0.000 L 86.000 1.000 L 75.000 2.000 L 58.000 14.000 L 41.000 18.000 L 31.000 34.000 L 29.000 55.000 L 28.000 56.000 L 15.000 56.000 Z",
      "province": "REGION_48",
      "rootTerritory": "REGION_48",
      "viewBox": "0 0 244 139",
      "unitSlots": [
        {
          "name": "main",
          "x": 119,
          "y": 93,
          "territory": "REGION_48",
          "arrowReceiver": {
            "x": 119,
            "y": 123
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 119,
          "y": 93,
          "territory": "REGION_48",
          "arrowReceiver": {
            "x": 119,
            "y": 123
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_51": {
    "territory": "REGION_51",
    "unitSlotName": "main",
    "province": "REGION_51",
    "provinceMapData": {
      "abbr": "BDL",
      "type": "Coast",
      "centerPos": {
        "x": 11,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 57,
      "height": 55,
      "x": 831,
      "y": 798,
      "playable": true,
      "path": "M 5.00 0.00 L 5.00 2.00 L 3.00 5.00 L 3.00 24.00 L 1.00 27.00 L 1.00 30.00 L 2.00 31.00 L 1.00 45.00 L 0.00 46.00 L 1.00 55.00 L 50.00 54.00 L 52.00 52.00 L 52.00 20.00 L 57.00 17.00 L 57.00 4.00 L 55.00 1.00 L 31.00 1.00 L 30.00 0.00 Z",
      "province": "REGION_51",
      "rootTerritory": "REGION_51",
      "viewBox": "0 0 57 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 25,
          "y": 36,
          "territory": "REGION_51",
          "arrowReceiver": {
            "x": 25,
            "y": 66
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 25,
          "y": 36,
          "territory": "REGION_51",
          "arrowReceiver": {
            "x": 25,
            "y": 66
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "波多黎各": {
    "territory": "REGION_51",
    "unitSlotName": "main",
    "province": "REGION_51",
    "provinceMapData": {
      "abbr": "BDL",
      "type": "Coast",
      "centerPos": {
        "x": 11,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 57,
      "height": 55,
      "x": 831,
      "y": 798,
      "playable": true,
      "path": "M 5.00 0.00 L 5.00 2.00 L 3.00 5.00 L 3.00 24.00 L 1.00 27.00 L 1.00 30.00 L 2.00 31.00 L 1.00 45.00 L 0.00 46.00 L 1.00 55.00 L 50.00 54.00 L 52.00 52.00 L 52.00 20.00 L 57.00 17.00 L 57.00 4.00 L 55.00 1.00 L 31.00 1.00 L 30.00 0.00 Z",
      "province": "REGION_51",
      "rootTerritory": "REGION_51",
      "viewBox": "0 0 57 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 25,
          "y": 36,
          "territory": "REGION_51",
          "arrowReceiver": {
            "x": 25,
            "y": 66
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 25,
          "y": 36,
          "territory": "REGION_51",
          "arrowReceiver": {
            "x": 25,
            "y": 66
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_52": {
    "territory": "REGION_52",
    "unitSlotName": "main",
    "province": "REGION_52",
    "provinceMapData": {
      "abbr": "PUE",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 40,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 73,
      "x": 865,
      "y": 807,
      "playable": true,
      "path": "M 21.00 0.00 L 22.00 6.00 L 17.00 9.00 L 17.00 41.00 L 13.00 44.00 L 0.00 45.00 L 3.00 71.00 L 8.00 72.00 L 11.00 70.00 L 25.00 70.00 L 30.00 73.00 L 35.00 70.00 L 41.00 70.00 L 42.00 69.00 L 52.00 69.00 L 53.00 68.00 L 75.00 68.00 L 76.00 67.00 L 80.00 67.00 L 81.00 66.00 L 81.00 62.00 L 80.00 61.00 L 80.00 56.00 L 79.00 55.00 L 79.00 48.00 L 78.00 47.00 L 78.00 39.00 L 77.00 38.00 L 77.00 32.00 L 76.00 31.00 L 75.00 13.00 L 74.00 12.00 L 73.00 0.00 Z",
      "province": "REGION_52",
      "rootTerritory": "REGION_52",
      "viewBox": "0 0 81 73",
      "unitSlots": [
        {
          "name": "main",
          "x": 40,
          "y": 42,
          "territory": "REGION_52",
          "arrowReceiver": {
            "x": 40,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 40,
          "y": 42,
          "territory": "REGION_52",
          "arrowReceiver": {
            "x": 40,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿内加达海峡": {
    "territory": "REGION_52",
    "unitSlotName": "main",
    "province": "REGION_52",
    "provinceMapData": {
      "abbr": "PUE",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 40,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 73,
      "x": 865,
      "y": 807,
      "playable": true,
      "path": "M 21.00 0.00 L 22.00 6.00 L 17.00 9.00 L 17.00 41.00 L 13.00 44.00 L 0.00 45.00 L 3.00 71.00 L 8.00 72.00 L 11.00 70.00 L 25.00 70.00 L 30.00 73.00 L 35.00 70.00 L 41.00 70.00 L 42.00 69.00 L 52.00 69.00 L 53.00 68.00 L 75.00 68.00 L 76.00 67.00 L 80.00 67.00 L 81.00 66.00 L 81.00 62.00 L 80.00 61.00 L 80.00 56.00 L 79.00 55.00 L 79.00 48.00 L 78.00 47.00 L 78.00 39.00 L 77.00 38.00 L 77.00 32.00 L 76.00 31.00 L 75.00 13.00 L 74.00 12.00 L 73.00 0.00 Z",
      "province": "REGION_52",
      "rootTerritory": "REGION_52",
      "viewBox": "0 0 81 73",
      "unitSlots": [
        {
          "name": "main",
          "x": 40,
          "y": 42,
          "territory": "REGION_52",
          "arrowReceiver": {
            "x": 40,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 40,
          "y": 42,
          "territory": "REGION_52",
          "arrowReceiver": {
            "x": 40,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_53": {
    "territory": "REGION_53",
    "unitSlotName": "main",
    "province": "REGION_53",
    "provinceMapData": {
      "abbr": "SOY",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 23,
          "y": 15,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 63,
      "height": 31,
      "x": 464,
      "y": 813,
      "playable": true,
      "path": "M 0.543 27.893 L 0.543 27.893 L 32.000 28.988 L 33.038 29.024 L 62.476 30.048 L 62.476 30.048 L 63.000 18.000 L 59.000 14.000 L 59.039 5.033 L 9.920 0.964 L 9.000 17.000 Z",
      "province": "REGION_53",
      "rootTerritory": "REGION_53",
      "viewBox": "0 0 63 31",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 18,
          "territory": "REGION_53",
          "arrowReceiver": {
            "x": 41,
            "y": 48
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 18,
          "territory": "REGION_53",
          "arrowReceiver": {
            "x": 41,
            "y": 48
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "尤卡坦海峡": {
    "territory": "REGION_53",
    "unitSlotName": "main",
    "province": "REGION_53",
    "provinceMapData": {
      "abbr": "SOY",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 23,
          "y": 15,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 63,
      "height": 31,
      "x": 464,
      "y": 813,
      "playable": true,
      "path": "M 0.543 27.893 L 0.543 27.893 L 32.000 28.988 L 33.038 29.024 L 62.476 30.048 L 62.476 30.048 L 63.000 18.000 L 59.000 14.000 L 59.039 5.033 L 9.920 0.964 L 9.000 17.000 Z",
      "province": "REGION_53",
      "rootTerritory": "REGION_53",
      "viewBox": "0 0 63 31",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 18,
          "territory": "REGION_53",
          "arrowReceiver": {
            "x": 41,
            "y": 48
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 18,
          "territory": "REGION_53",
          "arrowReceiver": {
            "x": 41,
            "y": 48
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_55": {
    "territory": "REGION_55",
    "unitSlotName": "main",
    "province": "REGION_55",
    "provinceMapData": {
      "abbr": "WCA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 94,
          "y": 69,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 165,
      "height": 102,
      "x": 463,
      "y": 840,
      "playable": true,
      "path": "M 1.543 0.893 L 0.000 22.000 L 28.000 23.000 L 33.000 27.000 L 37.000 35.000 L 37.000 46.000 L 35.000 49.000 L 36.000 63.000 L 44.000 63.000 L 52.000 67.000 L 63.000 80.000 L 63.000 84.000 L 66.000 87.000 L 66.000 100.000 L 71.000 100.000 L 72.000 101.000 L 101.000 101.000 L 102.000 102.000 L 127.998 101.888 L 128.995 101.861 L 164.648 101.162 L 164.000 71.002 L 138.000 70.000 L 137.000 69.000 L 135.000 38.000 L 68.000 36.000 L 65.000 34.000 L 63.476 3.048 L 35.995 2.092 L 34.957 2.056 L 1.543 0.893 Z",
      "province": "REGION_55",
      "rootTerritory": "REGION_55",
      "viewBox": "0 0 165 102",
      "unitSlots": [
        {
          "name": "main",
          "x": 108,
          "y": 63,
          "territory": "REGION_55",
          "arrowReceiver": {
            "x": 108,
            "y": 93
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 108,
          "y": 63,
          "territory": "REGION_55",
          "arrowReceiver": {
            "x": 108,
            "y": 93
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "西加勒比海": {
    "territory": "REGION_55",
    "unitSlotName": "main",
    "province": "REGION_55",
    "provinceMapData": {
      "abbr": "WCA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 94,
          "y": 69,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 165,
      "height": 102,
      "x": 463,
      "y": 840,
      "playable": true,
      "path": "M 1.543 0.893 L 0.000 22.000 L 28.000 23.000 L 33.000 27.000 L 37.000 35.000 L 37.000 46.000 L 35.000 49.000 L 36.000 63.000 L 44.000 63.000 L 52.000 67.000 L 63.000 80.000 L 63.000 84.000 L 66.000 87.000 L 66.000 100.000 L 71.000 100.000 L 72.000 101.000 L 101.000 101.000 L 102.000 102.000 L 127.998 101.888 L 128.995 101.861 L 164.648 101.162 L 164.000 71.002 L 138.000 70.000 L 137.000 69.000 L 135.000 38.000 L 68.000 36.000 L 65.000 34.000 L 63.476 3.048 L 35.995 2.092 L 34.957 2.056 L 1.543 0.893 Z",
      "province": "REGION_55",
      "rootTerritory": "REGION_55",
      "viewBox": "0 0 165 102",
      "unitSlots": [
        {
          "name": "main",
          "x": 108,
          "y": 63,
          "territory": "REGION_55",
          "arrowReceiver": {
            "x": 108,
            "y": 93
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 108,
          "y": 63,
          "territory": "REGION_55",
          "arrowReceiver": {
            "x": 108,
            "y": 93
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_59": {
    "territory": "REGION_59",
    "unitSlotName": "main",
    "province": "REGION_59",
    "provinceMapData": {
      "abbr": "GUC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 147,
          "y": 78,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 233,
      "height": 208,
      "x": 897,
      "y": 915,
      "playable": true,
      "path": "M 49.00 16.00 L 49.00 33.00 L 48.00 34.00 L 48.00 42.00 L 46.00 44.00 L 46.00 47.00 L 48.00 49.00 L 47.00 70.00 L 31.00 88.00 L 25.00 88.00 L 14.00 95.00 L 2.00 95.00 L 0.00 97.00 L 0.00 99.00 L 4.00 104.00 L 12.00 110.00 L 14.00 113.00 L 24.00 114.00 L 60.00 150.00 L 107.00 148.00 L 108.00 149.00 L 121.00 149.00 L 125.00 151.00 L 146.00 170.00 L 146.00 174.00 L 152.00 178.00 L 156.00 200.00 L 165.00 208.00 L 202.00 207.00 L 215.00 200.00 L 233.00 201.00 L 233.00 198.00 L 229.00 191.00 L 226.00 103.00 L 224.00 100.00 L 223.00 66.00 L 222.00 65.00 L 222.00 54.00 L 221.00 53.00 L 220.00 37.00 L 219.00 36.00 L 219.00 24.00 L 217.00 21.00 L 217.00 6.00 L 214.00 0.00 L 149.00 1.00 L 146.00 3.00 L 136.00 3.00 L 133.00 5.00 L 96.00 7.00 L 78.00 14.00 Z",
      "province": "REGION_59",
      "rootTerritory": "REGION_59",
      "viewBox": "0 0 233 208",
      "unitSlots": [
        {
          "name": "main",
          "x": 112,
          "y": 89,
          "territory": "REGION_59",
          "arrowReceiver": {
            "x": 112,
            "y": 119
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 112,
          "y": 89,
          "territory": "REGION_59",
          "arrowReceiver": {
            "x": 112,
            "y": 119
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "特立尼达海域": {
    "territory": "REGION_59",
    "unitSlotName": "main",
    "province": "REGION_59",
    "provinceMapData": {
      "abbr": "GUC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 147,
          "y": 78,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 233,
      "height": 208,
      "x": 897,
      "y": 915,
      "playable": true,
      "path": "M 49.00 16.00 L 49.00 33.00 L 48.00 34.00 L 48.00 42.00 L 46.00 44.00 L 46.00 47.00 L 48.00 49.00 L 47.00 70.00 L 31.00 88.00 L 25.00 88.00 L 14.00 95.00 L 2.00 95.00 L 0.00 97.00 L 0.00 99.00 L 4.00 104.00 L 12.00 110.00 L 14.00 113.00 L 24.00 114.00 L 60.00 150.00 L 107.00 148.00 L 108.00 149.00 L 121.00 149.00 L 125.00 151.00 L 146.00 170.00 L 146.00 174.00 L 152.00 178.00 L 156.00 200.00 L 165.00 208.00 L 202.00 207.00 L 215.00 200.00 L 233.00 201.00 L 233.00 198.00 L 229.00 191.00 L 226.00 103.00 L 224.00 100.00 L 223.00 66.00 L 222.00 65.00 L 222.00 54.00 L 221.00 53.00 L 220.00 37.00 L 219.00 36.00 L 219.00 24.00 L 217.00 21.00 L 217.00 6.00 L 214.00 0.00 L 149.00 1.00 L 146.00 3.00 L 136.00 3.00 L 133.00 5.00 L 96.00 7.00 L 78.00 14.00 Z",
      "province": "REGION_59",
      "rootTerritory": "REGION_59",
      "viewBox": "0 0 233 208",
      "unitSlots": [
        {
          "name": "main",
          "x": 112,
          "y": 89,
          "territory": "REGION_59",
          "arrowReceiver": {
            "x": 112,
            "y": 119
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 112,
          "y": 89,
          "territory": "REGION_59",
          "arrowReceiver": {
            "x": 112,
            "y": 119
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_61": {
    "territory": "REGION_61",
    "unitSlotName": "main",
    "province": "REGION_61",
    "provinceMapData": {
      "abbr": "GOV",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 86,
          "y": 21,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 107,
      "height": 54,
      "x": 682,
      "y": 940,
      "playable": true,
      "path": "M 0.493 4.139 L 0.493 4.139 L 0.493 4.139 L 0.000 43.000 L 6.000 42.000 L 21.000 31.000 L 37.000 33.000 L 40.000 40.000 L 42.000 41.000 L 47.000 41.000 L 54.000 34.000 L 61.000 34.000 L 62.000 35.000 L 70.000 35.000 L 81.000 43.000 L 88.000 43.000 L 97.000 54.000 L 106.000 54.000 L 105.000 48.000 L 107.000 46.000 L 107.000 29.000 L 106.000 28.000 L 106.000 8.000 L 104.000 5.000 L 104.000 1.000 L 6.000 0.000 Z",
      "province": "REGION_61",
      "rootTerritory": "REGION_61",
      "viewBox": "0 0 107 54",
      "unitSlots": [
        {
          "name": "main",
          "x": 49,
          "y": 7,
          "territory": "REGION_61",
          "arrowReceiver": {
            "x": 49,
            "y": 37
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 49,
          "y": 7,
          "territory": "REGION_61",
          "arrowReceiver": {
            "x": 49,
            "y": 37
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "委内瑞拉湾": {
    "territory": "REGION_61",
    "unitSlotName": "main",
    "province": "REGION_61",
    "provinceMapData": {
      "abbr": "GOV",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 86,
          "y": 21,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 107,
      "height": 54,
      "x": 682,
      "y": 940,
      "playable": true,
      "path": "M 0.493 4.139 L 0.493 4.139 L 0.493 4.139 L 0.000 43.000 L 6.000 42.000 L 21.000 31.000 L 37.000 33.000 L 40.000 40.000 L 42.000 41.000 L 47.000 41.000 L 54.000 34.000 L 61.000 34.000 L 62.000 35.000 L 70.000 35.000 L 81.000 43.000 L 88.000 43.000 L 97.000 54.000 L 106.000 54.000 L 105.000 48.000 L 107.000 46.000 L 107.000 29.000 L 106.000 28.000 L 106.000 8.000 L 104.000 5.000 L 104.000 1.000 L 6.000 0.000 Z",
      "province": "REGION_61",
      "rootTerritory": "REGION_61",
      "viewBox": "0 0 107 54",
      "unitSlots": [
        {
          "name": "main",
          "x": 49,
          "y": 7,
          "territory": "REGION_61",
          "arrowReceiver": {
            "x": 49,
            "y": 37
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 49,
          "y": 7,
          "territory": "REGION_61",
          "arrowReceiver": {
            "x": 49,
            "y": 37
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_68": {
    "territory": "REGION_68",
    "unitSlotName": "main",
    "province": "REGION_68",
    "provinceMapData": {
      "abbr": "SPO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 192,
          "y": 181,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 367,
      "height": 676,
      "x": 0,
      "y": 1152,
      "playable": true,
      "path": "M 0.00 18.00 L 0.00 648.00 L 9.00 649.00 L 10.00 650.00 L 15.00 650.00 L 16.00 651.00 L 21.00 651.00 L 22.00 652.00 L 38.00 653.00 L 43.00 655.00 L 58.00 656.00 L 59.00 657.00 L 64.00 657.00 L 65.00 658.00 L 75.00 659.00 L 76.00 660.00 L 81.00 660.00 L 82.00 661.00 L 87.00 661.00 L 88.00 662.00 L 97.00 662.00 L 98.00 663.00 L 102.00 663.00 L 103.00 664.00 L 109.00 664.00 L 114.00 666.00 L 120.00 666.00 L 121.00 667.00 L 127.00 667.00 L 128.00 668.00 L 148.00 670.00 L 149.00 671.00 L 154.00 671.00 L 155.00 672.00 L 160.00 672.00 L 161.00 673.00 L 192.00 676.00 L 191.00 668.00 L 190.00 667.00 L 190.00 662.00 L 189.00 661.00 L 189.00 656.00 L 188.00 655.00 L 188.00 651.00 L 187.00 650.00 L 187.00 647.00 L 185.00 642.00 L 185.00 638.00 L 184.00 637.00 L 184.00 630.00 L 182.00 625.00 L 182.00 620.00 L 181.00 619.00 L 181.00 615.00 L 180.00 614.00 L 180.00 610.00 L 179.00 609.00 L 179.00 602.00 L 178.00 601.00 L 178.00 597.00 L 177.00 596.00 L 177.00 593.00 L 175.00 588.00 L 175.00 584.00 L 174.00 583.00 L 172.00 569.00 L 170.00 568.00 L 163.00 568.00 L 162.00 567.00 L 157.00 567.00 L 156.00 566.00 L 150.00 566.00 L 149.00 565.00 L 140.00 564.00 L 135.00 556.00 L 138.00 497.00 L 139.00 496.00 L 156.00 495.00 L 159.00 493.00 L 165.00 493.00 L 163.00 443.00 L 160.00 438.00 L 162.00 422.00 L 159.00 417.00 L 161.00 355.00 L 162.00 354.00 L 201.00 355.00 L 202.00 356.00 L 213.00 356.00 L 214.00 357.00 L 224.00 357.00 L 225.00 358.00 L 237.00 358.00 L 246.00 363.00 L 277.00 362.00 L 280.00 364.00 L 313.00 365.00 L 314.00 366.00 L 324.00 366.00 L 327.00 368.00 L 343.00 368.00 L 344.00 369.00 L 352.00 369.00 L 353.00 370.00 L 363.00 371.00 L 364.00 329.00 L 365.00 328.00 L 365.00 303.00 L 366.00 302.00 L 366.00 279.00 L 367.00 278.00 L 367.00 61.00 L 330.00 61.00 L 329.00 60.00 L 329.00 18.00 L 330.00 17.00 L 327.00 15.00 L 318.00 16.00 L 317.00 15.00 L 299.00 14.00 L 298.00 13.00 L 284.00 13.00 L 283.00 12.00 L 279.00 12.00 L 278.00 11.00 L 248.00 10.00 L 247.00 9.00 L 231.00 8.00 L 230.00 7.00 L 207.00 6.00 L 206.00 5.00 L 191.00 4.00 L 190.00 3.00 L 173.00 3.00 L 172.00 2.00 L 161.00 2.00 L 160.00 1.00 L 155.00 1.00 L 154.00 0.00 L 148.00 0.00 L 145.00 13.00 L 141.00 17.00 Z",
      "province": "REGION_68",
      "rootTerritory": "REGION_68",
      "viewBox": "0 0 367 676",
      "unitSlots": [
        {
          "name": "main",
          "x": 187,
          "y": 66,
          "territory": "REGION_68",
          "arrowReceiver": {
            "x": 187,
            "y": 96
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 187,
          "y": 66,
          "territory": "REGION_68",
          "arrowReceiver": {
            "x": 187,
            "y": 96
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "南太平洋": {
    "territory": "REGION_68",
    "unitSlotName": "main",
    "province": "REGION_68",
    "provinceMapData": {
      "abbr": "SPO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 192,
          "y": 181,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 367,
      "height": 676,
      "x": 0,
      "y": 1152,
      "playable": true,
      "path": "M 0.00 18.00 L 0.00 648.00 L 9.00 649.00 L 10.00 650.00 L 15.00 650.00 L 16.00 651.00 L 21.00 651.00 L 22.00 652.00 L 38.00 653.00 L 43.00 655.00 L 58.00 656.00 L 59.00 657.00 L 64.00 657.00 L 65.00 658.00 L 75.00 659.00 L 76.00 660.00 L 81.00 660.00 L 82.00 661.00 L 87.00 661.00 L 88.00 662.00 L 97.00 662.00 L 98.00 663.00 L 102.00 663.00 L 103.00 664.00 L 109.00 664.00 L 114.00 666.00 L 120.00 666.00 L 121.00 667.00 L 127.00 667.00 L 128.00 668.00 L 148.00 670.00 L 149.00 671.00 L 154.00 671.00 L 155.00 672.00 L 160.00 672.00 L 161.00 673.00 L 192.00 676.00 L 191.00 668.00 L 190.00 667.00 L 190.00 662.00 L 189.00 661.00 L 189.00 656.00 L 188.00 655.00 L 188.00 651.00 L 187.00 650.00 L 187.00 647.00 L 185.00 642.00 L 185.00 638.00 L 184.00 637.00 L 184.00 630.00 L 182.00 625.00 L 182.00 620.00 L 181.00 619.00 L 181.00 615.00 L 180.00 614.00 L 180.00 610.00 L 179.00 609.00 L 179.00 602.00 L 178.00 601.00 L 178.00 597.00 L 177.00 596.00 L 177.00 593.00 L 175.00 588.00 L 175.00 584.00 L 174.00 583.00 L 172.00 569.00 L 170.00 568.00 L 163.00 568.00 L 162.00 567.00 L 157.00 567.00 L 156.00 566.00 L 150.00 566.00 L 149.00 565.00 L 140.00 564.00 L 135.00 556.00 L 138.00 497.00 L 139.00 496.00 L 156.00 495.00 L 159.00 493.00 L 165.00 493.00 L 163.00 443.00 L 160.00 438.00 L 162.00 422.00 L 159.00 417.00 L 161.00 355.00 L 162.00 354.00 L 201.00 355.00 L 202.00 356.00 L 213.00 356.00 L 214.00 357.00 L 224.00 357.00 L 225.00 358.00 L 237.00 358.00 L 246.00 363.00 L 277.00 362.00 L 280.00 364.00 L 313.00 365.00 L 314.00 366.00 L 324.00 366.00 L 327.00 368.00 L 343.00 368.00 L 344.00 369.00 L 352.00 369.00 L 353.00 370.00 L 363.00 371.00 L 364.00 329.00 L 365.00 328.00 L 365.00 303.00 L 366.00 302.00 L 366.00 279.00 L 367.00 278.00 L 367.00 61.00 L 330.00 61.00 L 329.00 60.00 L 329.00 18.00 L 330.00 17.00 L 327.00 15.00 L 318.00 16.00 L 317.00 15.00 L 299.00 14.00 L 298.00 13.00 L 284.00 13.00 L 283.00 12.00 L 279.00 12.00 L 278.00 11.00 L 248.00 10.00 L 247.00 9.00 L 231.00 8.00 L 230.00 7.00 L 207.00 6.00 L 206.00 5.00 L 191.00 4.00 L 190.00 3.00 L 173.00 3.00 L 172.00 2.00 L 161.00 2.00 L 160.00 1.00 L 155.00 1.00 L 154.00 0.00 L 148.00 0.00 L 145.00 13.00 L 141.00 17.00 Z",
      "province": "REGION_68",
      "rootTerritory": "REGION_68",
      "viewBox": "0 0 367 676",
      "unitSlots": [
        {
          "name": "main",
          "x": 187,
          "y": 66,
          "territory": "REGION_68",
          "arrowReceiver": {
            "x": 187,
            "y": 96
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 187,
          "y": 66,
          "territory": "REGION_68",
          "arrowReceiver": {
            "x": 187,
            "y": 96
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_69": {
    "territory": "REGION_69",
    "unitSlotName": "main",
    "province": "REGION_69",
    "provinceMapData": {
      "abbr": "GOG",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 118,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 191,
      "height": 107,
      "x": 366,
      "y": 1173,
      "playable": true,
      "path": "M 0.762 40.010 L 1.348 74.949 L 1.400 77.991 L 2.205 99.017 L 27.997 100.073 L 29.035 100.115 L 48.004 100.891 L 49.042 100.934 L 68.012 101.710 L 69.049 101.753 L 98.003 102.938 L 99.040 102.980 L 123.002 103.961 L 124.039 104.004 L 148.000 104.984 L 149.038 105.027 L 174.037 106.050 L 175.000 89.000 L 171.000 82.000 L 171.000 69.000 L 185.000 60.000 L 191.000 58.000 L 191.000 54.000 L 180.000 46.000 L 180.000 18.000 L 189.000 10.000 L 190.000 3.000 L 180.000 3.000 L 179.000 2.000 L 125.001 1.950 L 123.984 1.932 L 76.998 1.115 L 75.980 1.097 L 70.246 0.997 L 69.000 38.000 L 67.000 40.000 L 54.000 40.000 L 53.000 41.000 L 10.000 41.000 L 9.000 40.000 Z",
      "province": "REGION_69",
      "rootTerritory": "REGION_69",
      "viewBox": "0 0 191 107",
      "unitSlots": [
        {
          "name": "main",
          "x": 97,
          "y": 54,
          "territory": "REGION_69",
          "arrowReceiver": {
            "x": 97,
            "y": 84
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 97,
          "y": 54,
          "territory": "REGION_69",
          "arrowReceiver": {
            "x": 97,
            "y": 84
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "瓜亚基尔湾": {
    "territory": "REGION_69",
    "unitSlotName": "main",
    "province": "REGION_69",
    "provinceMapData": {
      "abbr": "GOG",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 118,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 191,
      "height": 107,
      "x": 366,
      "y": 1173,
      "playable": true,
      "path": "M 0.762 40.010 L 1.348 74.949 L 1.400 77.991 L 2.205 99.017 L 27.997 100.073 L 29.035 100.115 L 48.004 100.891 L 49.042 100.934 L 68.012 101.710 L 69.049 101.753 L 98.003 102.938 L 99.040 102.980 L 123.002 103.961 L 124.039 104.004 L 148.000 104.984 L 149.038 105.027 L 174.037 106.050 L 175.000 89.000 L 171.000 82.000 L 171.000 69.000 L 185.000 60.000 L 191.000 58.000 L 191.000 54.000 L 180.000 46.000 L 180.000 18.000 L 189.000 10.000 L 190.000 3.000 L 180.000 3.000 L 179.000 2.000 L 125.001 1.950 L 123.984 1.932 L 76.998 1.115 L 75.980 1.097 L 70.246 0.997 L 69.000 38.000 L 67.000 40.000 L 54.000 40.000 L 53.000 41.000 L 10.000 41.000 L 9.000 40.000 Z",
      "province": "REGION_69",
      "rootTerritory": "REGION_69",
      "viewBox": "0 0 191 107",
      "unitSlots": [
        {
          "name": "main",
          "x": 97,
          "y": 54,
          "territory": "REGION_69",
          "arrowReceiver": {
            "x": 97,
            "y": 84
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 97,
          "y": 54,
          "territory": "REGION_69",
          "arrowReceiver": {
            "x": 97,
            "y": 84
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_70": {
    "territory": "REGION_70",
    "unitSlotName": "main",
    "province": "REGION_70",
    "provinceMapData": {
      "abbr": "MEB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 244,
          "y": 49,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 343,
      "height": 93,
      "x": 363,
      "y": 1441,
      "playable": true,
      "path": "M 3.403 0.454 L 0.067 82.081 L 31.991 83.319 L 33.019 83.349 L 67.989 84.369 L 69.017 84.399 L 141.985 86.528 L 143.013 86.557 L 174.986 87.490 L 176.014 87.520 L 202.992 88.307 L 204.020 88.337 L 239.988 89.387 L 241.017 89.417 L 279.984 90.553 L 281.012 90.583 L 313.984 91.545 L 315.012 91.575 L 331.991 92.071 L 333.000 83.000 L 342.000 67.000 L 341.000 48.000 L 342.000 47.000 L 343.000 27.000 L 331.000 11.000 L 323.000 5.000 L 313.000 5.000 L 309.000 9.000 L 266.000 9.000 L 265.000 8.000 L 205.000 8.000 L 204.000 7.000 L 81.000 6.000 L 80.000 5.000 L 44.000 5.000 L 43.000 4.000 L 18.000 3.000 L 17.000 2.000 L 9.000 2.000 L 3.403 0.454 Z",
      "province": "REGION_70",
      "rootTerritory": "REGION_70",
      "viewBox": "0 0 343 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 170,
          "y": 26,
          "territory": "REGION_70",
          "arrowReceiver": {
            "x": 170,
            "y": 56
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 170,
          "y": 26,
          "territory": "REGION_70",
          "arrowReceiver": {
            "x": 170,
            "y": 56
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "梅希约内斯湾": {
    "territory": "REGION_70",
    "unitSlotName": "main",
    "province": "REGION_70",
    "provinceMapData": {
      "abbr": "MEB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 244,
          "y": 49,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 343,
      "height": 93,
      "x": 363,
      "y": 1441,
      "playable": true,
      "path": "M 3.403 0.454 L 0.067 82.081 L 31.991 83.319 L 33.019 83.349 L 67.989 84.369 L 69.017 84.399 L 141.985 86.528 L 143.013 86.557 L 174.986 87.490 L 176.014 87.520 L 202.992 88.307 L 204.020 88.337 L 239.988 89.387 L 241.017 89.417 L 279.984 90.553 L 281.012 90.583 L 313.984 91.545 L 315.012 91.575 L 331.991 92.071 L 333.000 83.000 L 342.000 67.000 L 341.000 48.000 L 342.000 47.000 L 343.000 27.000 L 331.000 11.000 L 323.000 5.000 L 313.000 5.000 L 309.000 9.000 L 266.000 9.000 L 265.000 8.000 L 205.000 8.000 L 204.000 7.000 L 81.000 6.000 L 80.000 5.000 L 44.000 5.000 L 43.000 4.000 L 18.000 3.000 L 17.000 2.000 L 9.000 2.000 L 3.403 0.454 Z",
      "province": "REGION_70",
      "rootTerritory": "REGION_70",
      "viewBox": "0 0 343 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 170,
          "y": 26,
          "territory": "REGION_70",
          "arrowReceiver": {
            "x": 170,
            "y": 56
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 170,
          "y": 26,
          "territory": "REGION_70",
          "arrowReceiver": {
            "x": 170,
            "y": 56
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_71": {
    "territory": "REGION_71",
    "unitSlotName": "main",
    "province": "REGION_71",
    "provinceMapData": {
      "abbr": "HUC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 149,
          "y": 98,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 537,
      "height": 198,
      "x": 158,
      "y": 1505,
      "playable": true,
      "path": "M 6.000 140.000 L 16.000 140.000 L 17.000 142.000 L 59.000 142.000 L 62.000 147.000 L 62.000 158.000 L 55.000 165.000 L 55.000 169.000 L 60.000 174.000 L 64.000 176.000 L 71.000 176.000 L 72.000 177.000 L 86.000 177.000 L 87.000 178.000 L 123.000 180.000 L 134.000 186.000 L 189.000 185.000 L 202.000 190.000 L 247.000 191.000 L 248.000 192.000 L 261.000 192.000 L 262.000 193.000 L 306.000 191.000 L 315.000 196.000 L 466.000 198.000 L 485.000 175.000 L 488.000 175.000 L 488.000 173.000 L 493.000 164.000 L 492.000 154.000 L 505.000 137.000 L 512.000 107.000 L 515.000 102.000 L 515.000 89.000 L 534.000 52.000 L 536.991 28.071 L 469.996 26.116 L 468.971 26.086 L 445.988 25.416 L 444.963 25.386 L 425.978 24.832 L 424.952 24.802 L 367.997 23.141 L 366.972 23.111 L 330.999 22.061 L 329.974 22.031 L 221.031 18.853 L 217.982 18.764 L 205.067 18.081 L 205.067 18.081 L 171.000 14.000 L 168.000 12.000 L 158.000 12.000 L 157.000 11.000 L 124.000 10.000 L 121.000 8.000 L 90.000 9.000 L 81.000 4.000 L 69.000 4.000 L 68.000 3.000 L 46.000 2.000 L 45.000 1.000 L 2.000 0.000 L 0.000 66.000 L 3.000 71.000 L 1.000 87.000 L 4.000 92.000 Z",
      "province": "REGION_71",
      "rootTerritory": "REGION_71",
      "viewBox": "0 0 537 198",
      "unitSlots": [
        {
          "name": "main",
          "x": 268,
          "y": 25,
          "territory": "REGION_71",
          "arrowReceiver": {
            "x": 268,
            "y": 55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 268,
          "y": 25,
          "territory": "REGION_71",
          "arrowReceiver": {
            "x": 268,
            "y": 55
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "洪堡洋流": {
    "territory": "REGION_71",
    "unitSlotName": "main",
    "province": "REGION_71",
    "provinceMapData": {
      "abbr": "HUC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 149,
          "y": 98,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 537,
      "height": 198,
      "x": 158,
      "y": 1505,
      "playable": true,
      "path": "M 6.000 140.000 L 16.000 140.000 L 17.000 142.000 L 59.000 142.000 L 62.000 147.000 L 62.000 158.000 L 55.000 165.000 L 55.000 169.000 L 60.000 174.000 L 64.000 176.000 L 71.000 176.000 L 72.000 177.000 L 86.000 177.000 L 87.000 178.000 L 123.000 180.000 L 134.000 186.000 L 189.000 185.000 L 202.000 190.000 L 247.000 191.000 L 248.000 192.000 L 261.000 192.000 L 262.000 193.000 L 306.000 191.000 L 315.000 196.000 L 466.000 198.000 L 485.000 175.000 L 488.000 175.000 L 488.000 173.000 L 493.000 164.000 L 492.000 154.000 L 505.000 137.000 L 512.000 107.000 L 515.000 102.000 L 515.000 89.000 L 534.000 52.000 L 536.991 28.071 L 469.996 26.116 L 468.971 26.086 L 445.988 25.416 L 444.963 25.386 L 425.978 24.832 L 424.952 24.802 L 367.997 23.141 L 366.972 23.111 L 330.999 22.061 L 329.974 22.031 L 221.031 18.853 L 217.982 18.764 L 205.067 18.081 L 205.067 18.081 L 171.000 14.000 L 168.000 12.000 L 158.000 12.000 L 157.000 11.000 L 124.000 10.000 L 121.000 8.000 L 90.000 9.000 L 81.000 4.000 L 69.000 4.000 L 68.000 3.000 L 46.000 2.000 L 45.000 1.000 L 2.000 0.000 L 0.000 66.000 L 3.000 71.000 L 1.000 87.000 L 4.000 92.000 Z",
      "province": "REGION_71",
      "rootTerritory": "REGION_71",
      "viewBox": "0 0 537 198",
      "unitSlots": [
        {
          "name": "main",
          "x": 268,
          "y": 25,
          "territory": "REGION_71",
          "arrowReceiver": {
            "x": 268,
            "y": 55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 268,
          "y": 25,
          "territory": "REGION_71",
          "arrowReceiver": {
            "x": 268,
            "y": 55
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_72": {
    "territory": "REGION_72",
    "unitSlotName": "main",
    "province": "REGION_72",
    "provinceMapData": {
      "abbr": "RDP",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 104,
          "y": 48,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 166,
      "height": 101,
      "x": 828,
      "y": 1657,
      "playable": true,
      "path": "M 166.000 0.000 L 130.000 0.000 L 119.000 5.000 L 89.000 5.000 L 80.000 11.000 L 60.000 12.000 L 55.000 15.000 L 45.000 15.000 L 44.000 14.000 L 27.000 14.000 L 26.000 15.000 L 24.000 13.000 L 22.000 13.000 L 20.000 15.000 L 21.000 25.000 L 9.000 39.000 L 2.216 45.271 L 2.216 45.271 L 2.216 45.271 L 1.435 68.948 L 1.202 76.007 L 1.004 82.000 L 0.903 85.063 L 0.408 100.047 L 11.000 100.000 L 12.000 99.000 L 24.000 99.000 L 25.000 98.000 L 38.000 99.000 L 41.000 96.000 L 71.000 95.000 L 74.000 93.000 L 87.000 95.000 L 91.000 92.000 L 119.000 91.000 L 126.000 87.000 L 154.000 84.000 L 157.000 78.000 L 158.000 50.000 L 162.000 43.000 L 163.000 7.000 L 166.000 3.000 Z",
      "province": "REGION_72",
      "rootTerritory": "REGION_72",
      "viewBox": "0 0 166 101",
      "unitSlots": [
        {
          "name": "main",
          "x": 76,
          "y": 76,
          "territory": "REGION_72",
          "arrowReceiver": {
            "x": 76,
            "y": 106
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 76,
          "y": 76,
          "territory": "REGION_72",
          "arrowReceiver": {
            "x": 76,
            "y": 106
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "拉普拉塔河": {
    "territory": "REGION_72",
    "unitSlotName": "main",
    "province": "REGION_72",
    "provinceMapData": {
      "abbr": "RDP",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 104,
          "y": 48,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 166,
      "height": 101,
      "x": 828,
      "y": 1657,
      "playable": true,
      "path": "M 166.000 0.000 L 130.000 0.000 L 119.000 5.000 L 89.000 5.000 L 80.000 11.000 L 60.000 12.000 L 55.000 15.000 L 45.000 15.000 L 44.000 14.000 L 27.000 14.000 L 26.000 15.000 L 24.000 13.000 L 22.000 13.000 L 20.000 15.000 L 21.000 25.000 L 9.000 39.000 L 2.216 45.271 L 2.216 45.271 L 2.216 45.271 L 1.435 68.948 L 1.202 76.007 L 1.004 82.000 L 0.903 85.063 L 0.408 100.047 L 11.000 100.000 L 12.000 99.000 L 24.000 99.000 L 25.000 98.000 L 38.000 99.000 L 41.000 96.000 L 71.000 95.000 L 74.000 93.000 L 87.000 95.000 L 91.000 92.000 L 119.000 91.000 L 126.000 87.000 L 154.000 84.000 L 157.000 78.000 L 158.000 50.000 L 162.000 43.000 L 163.000 7.000 L 166.000 3.000 Z",
      "province": "REGION_72",
      "rootTerritory": "REGION_72",
      "viewBox": "0 0 166 101",
      "unitSlots": [
        {
          "name": "main",
          "x": 76,
          "y": 76,
          "territory": "REGION_72",
          "arrowReceiver": {
            "x": 76,
            "y": 106
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 76,
          "y": 76,
          "territory": "REGION_72",
          "arrowReceiver": {
            "x": 76,
            "y": 106
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_75": {
    "territory": "REGION_75",
    "unitSlotName": "main",
    "province": "REGION_75",
    "provinceMapData": {
      "abbr": "BLK",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 95,
          "y": 58,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 130,
      "height": 95,
      "x": 700,
      "y": 1702,
      "playable": true,
      "path": "M 130.00 0.00 L 126.00 4.00 L 124.00 4.00 L 123.00 5.00 L 123.00 7.00 L 113.00 16.00 L 111.00 16.00 L 107.00 18.00 L 104.00 18.00 L 100.00 20.00 L 84.00 19.00 L 73.00 36.00 L 71.00 38.00 L 62.00 43.00 L 40.00 42.00 L 37.00 45.00 L 38.00 60.00 L 30.00 64.00 L 14.00 82.00 L 3.00 87.00 L 0.00 90.00 L 0.00 93.00 L 7.00 93.00 L 10.00 95.00 L 15.00 95.00 L 18.00 93.00 L 25.00 93.00 L 26.00 92.00 L 53.00 92.00 L 54.00 91.00 L 96.00 90.00 L 97.00 89.00 L 108.00 89.00 L 109.00 88.00 L 118.00 88.00 L 119.00 89.00 L 118.00 93.00 L 120.00 93.00 L 121.00 88.00 L 123.00 84.00 L 124.00 67.00 L 128.00 60.00 L 128.00 51.00 L 129.00 50.00 L 129.00 13.00 L 130.00 12.00 Z",
      "province": "REGION_75",
      "rootTerritory": "REGION_75",
      "viewBox": "0 0 130 95",
      "unitSlots": [
        {
          "name": "main",
          "x": 62,
          "y": 81,
          "territory": "REGION_75",
          "arrowReceiver": {
            "x": 62,
            "y": 111
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 62,
          "y": 81,
          "territory": "REGION_75",
          "arrowReceiver": {
            "x": 62,
            "y": 111
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "布兰卡湾": {
    "territory": "REGION_75",
    "unitSlotName": "main",
    "province": "REGION_75",
    "provinceMapData": {
      "abbr": "BLK",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 95,
          "y": 58,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 130,
      "height": 95,
      "x": 700,
      "y": 1702,
      "playable": true,
      "path": "M 130.00 0.00 L 126.00 4.00 L 124.00 4.00 L 123.00 5.00 L 123.00 7.00 L 113.00 16.00 L 111.00 16.00 L 107.00 18.00 L 104.00 18.00 L 100.00 20.00 L 84.00 19.00 L 73.00 36.00 L 71.00 38.00 L 62.00 43.00 L 40.00 42.00 L 37.00 45.00 L 38.00 60.00 L 30.00 64.00 L 14.00 82.00 L 3.00 87.00 L 0.00 90.00 L 0.00 93.00 L 7.00 93.00 L 10.00 95.00 L 15.00 95.00 L 18.00 93.00 L 25.00 93.00 L 26.00 92.00 L 53.00 92.00 L 54.00 91.00 L 96.00 90.00 L 97.00 89.00 L 108.00 89.00 L 109.00 88.00 L 118.00 88.00 L 119.00 89.00 L 118.00 93.00 L 120.00 93.00 L 121.00 88.00 L 123.00 84.00 L 124.00 67.00 L 128.00 60.00 L 128.00 51.00 L 129.00 50.00 L 129.00 13.00 L 130.00 12.00 Z",
      "province": "REGION_75",
      "rootTerritory": "REGION_75",
      "viewBox": "0 0 130 95",
      "unitSlots": [
        {
          "name": "main",
          "x": 62,
          "y": 81,
          "territory": "REGION_75",
          "arrowReceiver": {
            "x": 62,
            "y": 111
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 62,
          "y": 81,
          "territory": "REGION_75",
          "arrowReceiver": {
            "x": 62,
            "y": 111
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_77": {
    "territory": "REGION_77",
    "unitSlotName": "main",
    "province": "REGION_77",
    "provinceMapData": {
      "abbr": "DRA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 1229,
          "y": 86,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 1294,
      "height": 151,
      "x": 0,
      "y": 1768,
      "playable": true,
      "path": "M 1294.000 0.000 L 1280.000 0.000 L 1262.000 10.000 L 1238.000 14.000 L 1223.000 22.000 L 1204.000 23.000 L 1130.000 45.000 L 1106.000 44.000 L 1068.000 55.000 L 1031.000 57.000 L 1028.000 59.000 L 1017.000 59.000 L 1014.000 61.000 L 991.000 62.000 L 988.000 64.000 L 980.000 64.000 L 979.000 65.000 L 976.000 65.000 L 973.000 63.000 L 961.000 63.000 L 958.000 67.000 L 944.000 68.000 L 943.000 69.000 L 910.000 70.000 L 909.000 71.000 L 900.000 71.000 L 897.000 73.000 L 878.000 73.000 L 875.000 75.000 L 837.000 77.000 L 837.000 112.000 L 835.000 114.000 L 750.000 114.000 L 746.000 108.000 L 746.953 91.005 L 695.464 95.972 L 695.464 95.972 L 682.000 98.000 L 673.000 109.000 L 658.000 109.000 L 649.000 104.000 L 629.000 105.000 L 628.000 106.000 L 624.000 106.000 L 623.000 104.000 L 606.000 105.000 L 603.000 102.000 L 589.000 103.000 L 587.000 100.000 L 578.000 101.000 L 577.000 98.000 L 563.000 97.000 L 562.000 96.000 L 511.000 94.000 L 510.000 93.000 L 500.000 93.000 L 499.000 92.000 L 457.000 91.000 L 456.000 90.000 L 434.000 89.000 L 433.000 88.000 L 412.000 88.000 L 411.000 87.000 L 401.000 87.000 L 400.000 86.000 L 390.000 86.000 L 389.000 85.000 L 350.000 84.000 L 349.000 83.000 L 340.000 83.000 L 339.000 82.000 L 298.000 81.000 L 297.000 80.000 L 244.000 77.000 L 243.000 76.000 L 205.000 75.000 L 194.000 72.000 L 193.000 71.000 L 192.227 60.175 L 187.798 60.337 L 174.110 58.273 L 152.692 55.044 L 114.116 49.228 L 93.971 46.191 L 90.743 45.704 L 69.085 42.439 L 63.753 41.635 L 50.065 39.571 L 46.836 39.085 L 38.037 37.758 L 33.831 37.124 L 23.758 35.605 L 0.070 32.034 L 0.000 151.000 L 1294.000 151.000 Z",
      "province": "REGION_77",
      "rootTerritory": "REGION_77",
      "viewBox": "0 0 1294 151",
      "unitSlots": [
        {
          "name": "main",
          "x": 648,
          "y": 104,
          "territory": "REGION_77",
          "arrowReceiver": {
            "x": 648,
            "y": 134
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 648,
          "y": 104,
          "territory": "REGION_77",
          "arrowReceiver": {
            "x": 648,
            "y": 134
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "德雷克海峡": {
    "territory": "REGION_77",
    "unitSlotName": "main",
    "province": "REGION_77",
    "provinceMapData": {
      "abbr": "DRA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 1229,
          "y": 86,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 1294,
      "height": 151,
      "x": 0,
      "y": 1768,
      "playable": true,
      "path": "M 1294.000 0.000 L 1280.000 0.000 L 1262.000 10.000 L 1238.000 14.000 L 1223.000 22.000 L 1204.000 23.000 L 1130.000 45.000 L 1106.000 44.000 L 1068.000 55.000 L 1031.000 57.000 L 1028.000 59.000 L 1017.000 59.000 L 1014.000 61.000 L 991.000 62.000 L 988.000 64.000 L 980.000 64.000 L 979.000 65.000 L 976.000 65.000 L 973.000 63.000 L 961.000 63.000 L 958.000 67.000 L 944.000 68.000 L 943.000 69.000 L 910.000 70.000 L 909.000 71.000 L 900.000 71.000 L 897.000 73.000 L 878.000 73.000 L 875.000 75.000 L 837.000 77.000 L 837.000 112.000 L 835.000 114.000 L 750.000 114.000 L 746.000 108.000 L 746.953 91.005 L 695.464 95.972 L 695.464 95.972 L 682.000 98.000 L 673.000 109.000 L 658.000 109.000 L 649.000 104.000 L 629.000 105.000 L 628.000 106.000 L 624.000 106.000 L 623.000 104.000 L 606.000 105.000 L 603.000 102.000 L 589.000 103.000 L 587.000 100.000 L 578.000 101.000 L 577.000 98.000 L 563.000 97.000 L 562.000 96.000 L 511.000 94.000 L 510.000 93.000 L 500.000 93.000 L 499.000 92.000 L 457.000 91.000 L 456.000 90.000 L 434.000 89.000 L 433.000 88.000 L 412.000 88.000 L 411.000 87.000 L 401.000 87.000 L 400.000 86.000 L 390.000 86.000 L 389.000 85.000 L 350.000 84.000 L 349.000 83.000 L 340.000 83.000 L 339.000 82.000 L 298.000 81.000 L 297.000 80.000 L 244.000 77.000 L 243.000 76.000 L 205.000 75.000 L 194.000 72.000 L 193.000 71.000 L 192.227 60.175 L 187.798 60.337 L 174.110 58.273 L 152.692 55.044 L 114.116 49.228 L 93.971 46.191 L 90.743 45.704 L 69.085 42.439 L 63.753 41.635 L 50.065 39.571 L 46.836 39.085 L 38.037 37.758 L 33.831 37.124 L 23.758 35.605 L 0.070 32.034 L 0.000 151.000 L 1294.000 151.000 Z",
      "province": "REGION_77",
      "rootTerritory": "REGION_77",
      "viewBox": "0 0 1294 151",
      "unitSlots": [
        {
          "name": "main",
          "x": 648,
          "y": 104,
          "territory": "REGION_77",
          "arrowReceiver": {
            "x": 648,
            "y": 134
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 648,
          "y": 104,
          "territory": "REGION_77",
          "arrowReceiver": {
            "x": 648,
            "y": 134
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_80": {
    "territory": "REGION_80",
    "unitSlotName": "main",
    "province": "REGION_80",
    "provinceMapData": {
      "abbr": "BRS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 71,
          "y": 70,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 188,
      "height": 204,
      "x": -1,
      "y": 0,
      "playable": true,
      "path": "M 188.000 0.000 L 1.000 0.000 L 0.258 203.674 L 7.289 202.281 L 16.222 199.836 L 27.709 196.693 L 54.319 189.411 L 66.052 186.201 L 78.423 182.815 L 84.258 181.218 L 84.258 181.218 L 94.000 170.000 L 94.000 162.000 L 103.000 156.000 L 107.000 147.000 L 120.000 134.000 L 121.000 125.000 L 125.000 120.000 L 140.000 89.000 L 148.000 78.000 L 162.000 49.000 L 169.000 40.000 L 188.000 2.000 Z",
      "province": "REGION_80",
      "rootTerritory": "REGION_80",
      "viewBox": "0 0 188 204",
      "unitSlots": [
        {
          "name": "main",
          "x": 102,
          "y": 4,
          "territory": "REGION_80",
          "arrowReceiver": {
            "x": 102,
            "y": 34
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 102,
          "y": 4,
          "territory": "REGION_80",
          "arrowReceiver": {
            "x": 102,
            "y": 34
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "白令海": {
    "territory": "REGION_80",
    "unitSlotName": "main",
    "province": "REGION_80",
    "provinceMapData": {
      "abbr": "BRS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 71,
          "y": 70,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 188,
      "height": 204,
      "x": -1,
      "y": 0,
      "playable": true,
      "path": "M 188.000 0.000 L 1.000 0.000 L 0.258 203.674 L 7.289 202.281 L 16.222 199.836 L 27.709 196.693 L 54.319 189.411 L 66.052 186.201 L 78.423 182.815 L 84.258 181.218 L 84.258 181.218 L 94.000 170.000 L 94.000 162.000 L 103.000 156.000 L 107.000 147.000 L 120.000 134.000 L 121.000 125.000 L 125.000 120.000 L 140.000 89.000 L 148.000 78.000 L 162.000 49.000 L 169.000 40.000 L 188.000 2.000 Z",
      "province": "REGION_80",
      "rootTerritory": "REGION_80",
      "viewBox": "0 0 188 204",
      "unitSlots": [
        {
          "name": "main",
          "x": 102,
          "y": 4,
          "territory": "REGION_80",
          "arrowReceiver": {
            "x": 102,
            "y": 34
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 102,
          "y": 4,
          "territory": "REGION_80",
          "arrowReceiver": {
            "x": 102,
            "y": 34
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_81": {
    "territory": "REGION_81",
    "unitSlotName": "main",
    "province": "REGION_81",
    "provinceMapData": {
      "abbr": "BES",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 223,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 313,
      "height": 132,
      "x": 118,
      "y": 0,
      "playable": true,
      "path": "M 0.00 132.00 L 2.00 132.00 L 4.00 129.00 L 19.00 127.00 L 28.00 122.00 L 50.00 123.00 L 60.00 115.00 L 60.00 108.00 L 64.00 104.00 L 72.00 102.00 L 76.00 97.00 L 94.00 99.00 L 123.00 81.00 L 168.00 79.00 L 169.00 78.00 L 175.00 78.00 L 181.00 82.00 L 180.00 92.00 L 186.00 98.00 L 191.00 101.00 L 193.00 104.00 L 194.00 114.00 L 197.00 116.00 L 211.00 116.00 L 216.00 119.00 L 245.00 120.00 L 259.00 91.00 L 271.00 76.00 L 282.00 53.00 L 290.00 43.00 L 297.00 28.00 L 305.00 18.00 L 313.00 2.00 L 313.00 0.00 L 68.00 0.00 L 49.00 38.00 L 42.00 47.00 L 28.00 76.00 L 20.00 87.00 L 5.00 118.00 L 1.00 123.00 Z",
      "province": "REGION_81",
      "rootTerritory": "REGION_81",
      "viewBox": "0 0 313 132",
      "unitSlots": [
        {
          "name": "main",
          "x": 192,
          "y": 7,
          "territory": "REGION_81",
          "arrowReceiver": {
            "x": 192,
            "y": 37
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 192,
          "y": 7,
          "territory": "REGION_81",
          "arrowReceiver": {
            "x": 192,
            "y": 37
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "波弗特海": {
    "territory": "REGION_81",
    "unitSlotName": "main",
    "province": "REGION_81",
    "provinceMapData": {
      "abbr": "BES",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 223,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 313,
      "height": 132,
      "x": 118,
      "y": 0,
      "playable": true,
      "path": "M 0.00 132.00 L 2.00 132.00 L 4.00 129.00 L 19.00 127.00 L 28.00 122.00 L 50.00 123.00 L 60.00 115.00 L 60.00 108.00 L 64.00 104.00 L 72.00 102.00 L 76.00 97.00 L 94.00 99.00 L 123.00 81.00 L 168.00 79.00 L 169.00 78.00 L 175.00 78.00 L 181.00 82.00 L 180.00 92.00 L 186.00 98.00 L 191.00 101.00 L 193.00 104.00 L 194.00 114.00 L 197.00 116.00 L 211.00 116.00 L 216.00 119.00 L 245.00 120.00 L 259.00 91.00 L 271.00 76.00 L 282.00 53.00 L 290.00 43.00 L 297.00 28.00 L 305.00 18.00 L 313.00 2.00 L 313.00 0.00 L 68.00 0.00 L 49.00 38.00 L 42.00 47.00 L 28.00 76.00 L 20.00 87.00 L 5.00 118.00 L 1.00 123.00 Z",
      "province": "REGION_81",
      "rootTerritory": "REGION_81",
      "viewBox": "0 0 313 132",
      "unitSlots": [
        {
          "name": "main",
          "x": 192,
          "y": 7,
          "territory": "REGION_81",
          "arrowReceiver": {
            "x": 192,
            "y": 37
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 192,
          "y": 7,
          "territory": "REGION_81",
          "arrowReceiver": {
            "x": 192,
            "y": 37
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_82": {
    "territory": "REGION_82",
    "unitSlotName": "main",
    "province": "REGION_82",
    "provinceMapData": {
      "abbr": "NAO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 350,
          "y": 450,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 559,
      "height": 691,
      "x": 735,
      "y": 0,
      "playable": true,
      "path": "M 0.000 0.000 L 3.000 6.000 L 9.000 13.000 L 15.000 26.000 L 27.000 42.000 L 44.000 61.000 L 54.000 62.000 L 59.000 65.000 L 66.000 66.000 L 74.000 75.000 L 95.000 80.000 L 105.000 94.000 L 125.000 111.000 L 131.000 114.000 L 144.000 114.000 L 160.000 123.000 L 160.000 145.000 L 150.000 153.000 L 150.000 156.000 L 152.000 159.000 L 152.000 173.000 L 142.000 181.000 L 142.000 184.000 L 150.000 199.000 L 150.000 214.000 L 158.000 222.000 L 159.000 238.000 L 155.000 242.000 L 141.000 242.000 L 136.000 239.000 L 124.000 239.000 L 123.000 240.000 L 125.000 256.000 L 132.000 273.000 L 132.000 283.000 L 134.000 286.000 L 134.000 295.000 L 138.000 305.000 L 141.000 333.000 L 142.000 334.000 L 142.000 337.000 L 146.000 348.000 L 147.000 355.000 L 149.000 359.000 L 149.000 362.000 L 150.000 363.000 L 151.000 369.000 L 154.000 377.000 L 153.000 389.000 L 152.000 390.000 L 144.000 390.000 L 144.000 400.000 L 146.000 402.000 L 145.000 403.000 L 141.000 401.000 L 125.000 401.000 L 122.000 403.000 L 121.000 402.000 L 113.364 404.773 L 113.364 404.773 L 113.364 404.773 L 101.337 415.386 L 80.672 433.623 L 70.231 442.715 L 70.231 442.715 L 70.231 442.715 L 70.210 452.995 L 70.232 453.974 L 70.529 466.969 L 70.552 467.988 L 70.780 477.984 L 70.804 479.004 L 72.194 504.156 L 80.000 504.000 L 93.000 517.000 L 96.000 523.000 L 100.000 528.000 L 122.000 572.000 L 141.000 597.000 L 151.000 617.000 L 142.778 624.328 L 145.891 629.071 L 151.358 637.412 L 153.039 639.975 L 159.725 650.174 L 167.796 662.486 L 171.287 667.812 L 172.968 670.375 L 182.850 685.449 L 187.205 690.968 L 187.205 690.968 L 187.205 690.968 L 192.815 688.891 L 193.950 688.702 L 196.869 688.213 L 202.057 687.345 L 205.949 686.694 L 211.137 685.826 L 230.919 682.516 L 232.054 682.326 L 236.919 681.512 L 238.054 681.322 L 241.945 680.671 L 243.080 680.481 L 253.944 678.663 L 255.079 678.473 L 258.970 677.822 L 260.105 677.632 L 264.970 676.818 L 266.105 676.628 L 270.969 675.814 L 272.104 675.624 L 276.969 674.810 L 278.104 674.620 L 282.968 673.806 L 284.103 673.616 L 288.967 672.802 L 290.102 672.612 L 295.940 671.636 L 297.075 671.446 L 301.939 670.632 L 303.074 670.442 L 307.938 669.628 L 309.073 669.438 L 313.938 668.624 L 315.073 668.434 L 320.909 667.457 L 322.045 667.267 L 326.909 666.454 L 328.044 666.263 L 332.908 665.450 L 334.043 665.260 L 338.907 664.446 L 340.042 664.256 L 344.907 663.442 L 346.042 663.252 L 350.906 662.438 L 352.041 662.248 L 368.904 659.426 L 374.093 658.558 L 390.956 655.736 L 396.145 654.868 L 407.981 652.888 L 409.116 652.698 L 414.954 651.721 L 416.089 651.531 L 421.926 650.554 L 423.061 650.364 L 428.898 649.388 L 430.033 649.198 L 434.898 648.384 L 436.033 648.194 L 439.924 647.543 L 441.059 647.353 L 444.951 646.701 L 446.086 646.512 L 452.895 645.372 L 454.031 645.182 L 461.002 644.016 L 462.138 643.826 L 467.974 642.849 L 469.110 642.659 L 474.947 641.682 L 476.083 641.492 L 480.946 640.678 L 482.081 640.488 L 494.891 638.345 L 496.025 638.155 L 500.890 637.341 L 502.025 637.151 L 506.889 636.337 L 508.024 636.147 L 512.889 635.333 L 514.024 635.143 L 518.888 634.330 L 520.023 634.140 L 524.888 633.326 L 526.023 633.136 L 531.860 632.159 L 532.995 631.969 L 537.859 631.155 L 538.994 630.965 L 543.859 630.151 L 544.994 629.961 L 549.858 629.147 L 550.993 628.957 L 558.958 627.625 L 558.958 627.625 L 558.958 627.625 L 559.000 0.000 Z",
      "province": "REGION_82",
      "rootTerritory": "REGION_82",
      "viewBox": "0 0 559 691",
      "unitSlots": [
        {
          "name": "main",
          "x": 276,
          "y": 1,
          "territory": "REGION_82",
          "arrowReceiver": {
            "x": 276,
            "y": 31
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 276,
          "y": 1,
          "territory": "REGION_82",
          "arrowReceiver": {
            "x": 276,
            "y": 31
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "北大西洋": {
    "territory": "REGION_82",
    "unitSlotName": "main",
    "province": "REGION_82",
    "provinceMapData": {
      "abbr": "NAO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 350,
          "y": 450,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 559,
      "height": 691,
      "x": 735,
      "y": 0,
      "playable": true,
      "path": "M 0.000 0.000 L 3.000 6.000 L 9.000 13.000 L 15.000 26.000 L 27.000 42.000 L 44.000 61.000 L 54.000 62.000 L 59.000 65.000 L 66.000 66.000 L 74.000 75.000 L 95.000 80.000 L 105.000 94.000 L 125.000 111.000 L 131.000 114.000 L 144.000 114.000 L 160.000 123.000 L 160.000 145.000 L 150.000 153.000 L 150.000 156.000 L 152.000 159.000 L 152.000 173.000 L 142.000 181.000 L 142.000 184.000 L 150.000 199.000 L 150.000 214.000 L 158.000 222.000 L 159.000 238.000 L 155.000 242.000 L 141.000 242.000 L 136.000 239.000 L 124.000 239.000 L 123.000 240.000 L 125.000 256.000 L 132.000 273.000 L 132.000 283.000 L 134.000 286.000 L 134.000 295.000 L 138.000 305.000 L 141.000 333.000 L 142.000 334.000 L 142.000 337.000 L 146.000 348.000 L 147.000 355.000 L 149.000 359.000 L 149.000 362.000 L 150.000 363.000 L 151.000 369.000 L 154.000 377.000 L 153.000 389.000 L 152.000 390.000 L 144.000 390.000 L 144.000 400.000 L 146.000 402.000 L 145.000 403.000 L 141.000 401.000 L 125.000 401.000 L 122.000 403.000 L 121.000 402.000 L 113.364 404.773 L 113.364 404.773 L 113.364 404.773 L 101.337 415.386 L 80.672 433.623 L 70.231 442.715 L 70.231 442.715 L 70.231 442.715 L 70.210 452.995 L 70.232 453.974 L 70.529 466.969 L 70.552 467.988 L 70.780 477.984 L 70.804 479.004 L 72.194 504.156 L 80.000 504.000 L 93.000 517.000 L 96.000 523.000 L 100.000 528.000 L 122.000 572.000 L 141.000 597.000 L 151.000 617.000 L 142.778 624.328 L 145.891 629.071 L 151.358 637.412 L 153.039 639.975 L 159.725 650.174 L 167.796 662.486 L 171.287 667.812 L 172.968 670.375 L 182.850 685.449 L 187.205 690.968 L 187.205 690.968 L 187.205 690.968 L 192.815 688.891 L 193.950 688.702 L 196.869 688.213 L 202.057 687.345 L 205.949 686.694 L 211.137 685.826 L 230.919 682.516 L 232.054 682.326 L 236.919 681.512 L 238.054 681.322 L 241.945 680.671 L 243.080 680.481 L 253.944 678.663 L 255.079 678.473 L 258.970 677.822 L 260.105 677.632 L 264.970 676.818 L 266.105 676.628 L 270.969 675.814 L 272.104 675.624 L 276.969 674.810 L 278.104 674.620 L 282.968 673.806 L 284.103 673.616 L 288.967 672.802 L 290.102 672.612 L 295.940 671.636 L 297.075 671.446 L 301.939 670.632 L 303.074 670.442 L 307.938 669.628 L 309.073 669.438 L 313.938 668.624 L 315.073 668.434 L 320.909 667.457 L 322.045 667.267 L 326.909 666.454 L 328.044 666.263 L 332.908 665.450 L 334.043 665.260 L 338.907 664.446 L 340.042 664.256 L 344.907 663.442 L 346.042 663.252 L 350.906 662.438 L 352.041 662.248 L 368.904 659.426 L 374.093 658.558 L 390.956 655.736 L 396.145 654.868 L 407.981 652.888 L 409.116 652.698 L 414.954 651.721 L 416.089 651.531 L 421.926 650.554 L 423.061 650.364 L 428.898 649.388 L 430.033 649.198 L 434.898 648.384 L 436.033 648.194 L 439.924 647.543 L 441.059 647.353 L 444.951 646.701 L 446.086 646.512 L 452.895 645.372 L 454.031 645.182 L 461.002 644.016 L 462.138 643.826 L 467.974 642.849 L 469.110 642.659 L 474.947 641.682 L 476.083 641.492 L 480.946 640.678 L 482.081 640.488 L 494.891 638.345 L 496.025 638.155 L 500.890 637.341 L 502.025 637.151 L 506.889 636.337 L 508.024 636.147 L 512.889 635.333 L 514.024 635.143 L 518.888 634.330 L 520.023 634.140 L 524.888 633.326 L 526.023 633.136 L 531.860 632.159 L 532.995 631.969 L 537.859 631.155 L 538.994 630.965 L 543.859 630.151 L 544.994 629.961 L 549.858 629.147 L 550.993 628.957 L 558.958 627.625 L 558.958 627.625 L 558.958 627.625 L 559.000 0.000 Z",
      "province": "REGION_82",
      "rootTerritory": "REGION_82",
      "viewBox": "0 0 559 691",
      "unitSlots": [
        {
          "name": "main",
          "x": 276,
          "y": 1,
          "territory": "REGION_82",
          "arrowReceiver": {
            "x": 276,
            "y": 31
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 276,
          "y": 1,
          "territory": "REGION_82",
          "arrowReceiver": {
            "x": 276,
            "y": 31
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_83": {
    "territory": "REGION_83",
    "unitSlotName": "main",
    "province": "REGION_83",
    "provinceMapData": {
      "abbr": "LBS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 204,
          "y": 172,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 290,
      "height": 295,
      "x": 600,
      "y": 96,
      "playable": true,
      "path": "M 5.00 10.00 L 1.00 16.00 L 0.00 23.00 L 10.00 22.00 L 13.00 26.00 L 30.00 29.00 L 42.00 40.00 L 53.00 40.00 L 72.00 58.00 L 74.00 69.00 L 80.00 75.00 L 83.00 76.00 L 90.00 83.00 L 105.00 84.00 L 111.00 88.00 L 111.00 96.00 L 121.00 115.00 L 121.00 129.00 L 115.00 133.00 L 114.00 138.00 L 111.00 142.00 L 97.00 142.00 L 90.00 138.00 L 85.00 138.00 L 75.00 146.00 L 84.00 162.00 L 84.00 174.00 L 93.00 178.00 L 102.00 186.00 L 120.00 187.00 L 130.00 181.00 L 131.00 175.00 L 135.00 170.00 L 145.00 178.00 L 145.00 183.00 L 165.00 201.00 L 170.00 211.00 L 178.00 213.00 L 188.00 222.00 L 203.00 223.00 L 208.00 231.00 L 220.00 233.00 L 232.00 239.00 L 235.00 242.00 L 237.00 246.00 L 237.00 248.00 L 239.00 251.00 L 239.00 253.00 L 245.00 266.00 L 246.00 271.00 L 249.00 276.00 L 249.00 278.00 L 253.00 286.00 L 256.00 287.00 L 261.00 292.00 L 277.00 293.00 L 280.00 295.00 L 289.00 295.00 L 290.00 279.00 L 289.00 278.00 L 289.00 275.00 L 287.00 272.00 L 287.00 268.00 L 285.00 265.00 L 285.00 261.00 L 283.00 258.00 L 283.00 253.00 L 280.00 248.00 L 280.00 242.00 L 277.00 237.00 L 274.00 206.00 L 270.00 199.00 L 270.00 188.00 L 268.00 185.00 L 268.00 173.00 L 261.00 160.00 L 259.00 144.00 L 249.00 144.00 L 246.00 139.00 L 234.00 134.00 L 226.00 124.00 L 215.00 119.00 L 208.00 108.00 L 200.00 106.00 L 186.00 92.00 L 185.00 92.00 L 171.00 78.00 L 172.00 61.00 L 168.00 57.00 L 151.00 53.00 L 146.00 45.00 L 128.00 40.00 L 114.00 25.00 L 106.00 23.00 L 101.00 17.00 L 93.00 17.00 L 85.00 10.00 L 81.00 10.00 L 78.00 12.00 L 58.00 12.00 L 48.00 5.00 L 45.00 5.00 L 44.00 4.00 L 37.00 4.00 L 36.00 3.00 L 29.00 3.00 L 28.00 2.00 L 25.00 2.00 L 23.00 0.00 L 19.00 0.00 L 17.00 5.00 L 12.00 9.00 Z",
      "province": "REGION_83",
      "rootTerritory": "REGION_83",
      "viewBox": "0 0 290 295",
      "unitSlots": [
        {
          "name": "main",
          "x": 160,
          "y": 141,
          "territory": "REGION_83",
          "arrowReceiver": {
            "x": 160,
            "y": 171
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 160,
          "y": 141,
          "territory": "REGION_83",
          "arrowReceiver": {
            "x": 160,
            "y": 171
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "拉布拉多海": {
    "territory": "REGION_83",
    "unitSlotName": "main",
    "province": "REGION_83",
    "provinceMapData": {
      "abbr": "LBS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 204,
          "y": 172,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 290,
      "height": 295,
      "x": 600,
      "y": 96,
      "playable": true,
      "path": "M 5.00 10.00 L 1.00 16.00 L 0.00 23.00 L 10.00 22.00 L 13.00 26.00 L 30.00 29.00 L 42.00 40.00 L 53.00 40.00 L 72.00 58.00 L 74.00 69.00 L 80.00 75.00 L 83.00 76.00 L 90.00 83.00 L 105.00 84.00 L 111.00 88.00 L 111.00 96.00 L 121.00 115.00 L 121.00 129.00 L 115.00 133.00 L 114.00 138.00 L 111.00 142.00 L 97.00 142.00 L 90.00 138.00 L 85.00 138.00 L 75.00 146.00 L 84.00 162.00 L 84.00 174.00 L 93.00 178.00 L 102.00 186.00 L 120.00 187.00 L 130.00 181.00 L 131.00 175.00 L 135.00 170.00 L 145.00 178.00 L 145.00 183.00 L 165.00 201.00 L 170.00 211.00 L 178.00 213.00 L 188.00 222.00 L 203.00 223.00 L 208.00 231.00 L 220.00 233.00 L 232.00 239.00 L 235.00 242.00 L 237.00 246.00 L 237.00 248.00 L 239.00 251.00 L 239.00 253.00 L 245.00 266.00 L 246.00 271.00 L 249.00 276.00 L 249.00 278.00 L 253.00 286.00 L 256.00 287.00 L 261.00 292.00 L 277.00 293.00 L 280.00 295.00 L 289.00 295.00 L 290.00 279.00 L 289.00 278.00 L 289.00 275.00 L 287.00 272.00 L 287.00 268.00 L 285.00 265.00 L 285.00 261.00 L 283.00 258.00 L 283.00 253.00 L 280.00 248.00 L 280.00 242.00 L 277.00 237.00 L 274.00 206.00 L 270.00 199.00 L 270.00 188.00 L 268.00 185.00 L 268.00 173.00 L 261.00 160.00 L 259.00 144.00 L 249.00 144.00 L 246.00 139.00 L 234.00 134.00 L 226.00 124.00 L 215.00 119.00 L 208.00 108.00 L 200.00 106.00 L 186.00 92.00 L 185.00 92.00 L 171.00 78.00 L 172.00 61.00 L 168.00 57.00 L 151.00 53.00 L 146.00 45.00 L 128.00 40.00 L 114.00 25.00 L 106.00 23.00 L 101.00 17.00 L 93.00 17.00 L 85.00 10.00 L 81.00 10.00 L 78.00 12.00 L 58.00 12.00 L 48.00 5.00 L 45.00 5.00 L 44.00 4.00 L 37.00 4.00 L 36.00 3.00 L 29.00 3.00 L 28.00 2.00 L 25.00 2.00 L 23.00 0.00 L 19.00 0.00 L 17.00 5.00 L 12.00 9.00 Z",
      "province": "REGION_83",
      "rootTerritory": "REGION_83",
      "viewBox": "0 0 290 295",
      "unitSlots": [
        {
          "name": "main",
          "x": 160,
          "y": 141,
          "territory": "REGION_83",
          "arrowReceiver": {
            "x": 160,
            "y": 171
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 160,
          "y": 141,
          "territory": "REGION_83",
          "arrowReceiver": {
            "x": 160,
            "y": 171
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_84": {
    "territory": "REGION_84",
    "unitSlotName": "main",
    "province": "REGION_84",
    "provinceMapData": {
      "abbr": "GOA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35,
          "y": 156,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 88,
      "height": 187,
      "x": 75,
      "y": 177,
      "playable": true,
      "path": "M 77.00 0.00 L 67.00 2.00 L 59.00 7.00 L 45.00 7.00 L 43.00 12.00 L 32.00 21.00 L 32.00 48.00 L 28.00 51.00 L 25.00 78.00 L 20.00 87.00 L 19.00 105.00 L 7.00 129.00 L 7.00 148.00 L 1.00 159.00 L 0.00 177.00 L 7.00 181.00 L 15.00 181.00 L 30.00 186.00 L 49.00 187.00 L 51.00 184.00 L 65.00 175.00 L 66.00 173.00 L 67.00 165.00 L 65.00 159.00 L 65.00 140.00 L 73.00 125.00 L 75.00 86.00 L 83.00 78.00 L 85.00 32.00 L 88.00 27.00 L 88.00 21.00 L 85.00 18.00 L 84.00 6.00 Z",
      "province": "REGION_84",
      "rootTerritory": "REGION_84",
      "viewBox": "0 0 88 187",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 169,
          "territory": "REGION_84",
          "arrowReceiver": {
            "x": 39,
            "y": 199
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 169,
          "territory": "REGION_84",
          "arrowReceiver": {
            "x": 39,
            "y": 199
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿拉斯加湾": {
    "territory": "REGION_84",
    "unitSlotName": "main",
    "province": "REGION_84",
    "provinceMapData": {
      "abbr": "GOA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35,
          "y": 156,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 88,
      "height": 187,
      "x": 75,
      "y": 177,
      "playable": true,
      "path": "M 77.00 0.00 L 67.00 2.00 L 59.00 7.00 L 45.00 7.00 L 43.00 12.00 L 32.00 21.00 L 32.00 48.00 L 28.00 51.00 L 25.00 78.00 L 20.00 87.00 L 19.00 105.00 L 7.00 129.00 L 7.00 148.00 L 1.00 159.00 L 0.00 177.00 L 7.00 181.00 L 15.00 181.00 L 30.00 186.00 L 49.00 187.00 L 51.00 184.00 L 65.00 175.00 L 66.00 173.00 L 67.00 165.00 L 65.00 159.00 L 65.00 140.00 L 73.00 125.00 L 75.00 86.00 L 83.00 78.00 L 85.00 32.00 L 88.00 27.00 L 88.00 21.00 L 85.00 18.00 L 84.00 6.00 Z",
      "province": "REGION_84",
      "rootTerritory": "REGION_84",
      "viewBox": "0 0 88 187",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 169,
          "territory": "REGION_84",
          "arrowReceiver": {
            "x": 39,
            "y": 199
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 169,
          "territory": "REGION_84",
          "arrowReceiver": {
            "x": 39,
            "y": 199
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_85": {
    "territory": "REGION_85",
    "unitSlotName": "main",
    "province": "REGION_85",
    "provinceMapData": {
      "abbr": "NPO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 52,
          "y": 61,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 124,
      "height": 870,
      "x": -1,
      "y": 181,
      "playable": true,
      "path": "M 84.258 0.218 L 64.430 5.644 L 52.699 8.855 L 26.088 16.137 L 14.602 19.280 L 7.289 21.281 L 0.258 22.674 L 1.065 864.149 L 35.903 867.910 L 39.293 868.276 L 46.247 869.027 L 46.247 869.027 L 54.000 869.000 L 57.092 860.236 L 59.366 836.034 L 60.315 825.935 L 61.246 816.024 L 61.543 812.862 L 63.973 786.998 L 64.457 781.855 L 66.794 756.980 L 66.896 755.896 L 69.521 727.955 L 69.623 726.870 L 71.300 709.029 L 71.597 705.867 L 73.748 682.977 L 74.138 678.825 L 77.407 644.039 L 77.890 638.895 L 79.948 616.995 L 80.431 611.852 L 81.828 596.984 L 81.930 595.899 L 85.301 560.028 L 85.598 556.867 L 86.250 549.929 L 86.352 548.844 L 86.881 543.215 L 78.000 538.000 L 56.000 538.000 L 39.000 531.000 L 41.000 495.000 L 46.000 486.000 L 45.000 474.000 L 49.000 470.000 L 50.000 441.000 L 56.000 430.000 L 56.000 397.000 L 62.000 383.000 L 62.000 379.000 L 60.000 377.000 L 61.000 376.000 L 63.000 359.000 L 56.000 346.000 L 56.000 327.000 L 60.000 320.000 L 58.000 297.000 L 62.000 290.000 L 63.000 281.000 L 72.000 269.000 L 85.000 238.000 L 91.000 233.000 L 104.000 217.000 L 104.000 213.000 L 114.000 205.000 L 124.000 185.000 L 124.000 182.000 L 108.000 181.000 L 93.000 176.000 L 85.000 176.000 L 77.000 171.000 L 78.000 157.000 L 84.000 146.000 L 84.000 127.000 L 96.000 103.000 L 97.000 85.000 L 102.000 76.000 L 105.000 49.000 L 109.000 46.000 L 109.000 18.000 L 98.000 18.000 L 97.000 17.000 L 86.000 17.000 L 82.000 14.000 Z",
      "province": "REGION_85",
      "rootTerritory": "REGION_85",
      "viewBox": "0 0 124 870",
      "unitSlots": [
        {
          "name": "main",
          "x": 64,
          "y": 185,
          "territory": "REGION_85",
          "arrowReceiver": {
            "x": 64,
            "y": 215
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 64,
          "y": 185,
          "territory": "REGION_85",
          "arrowReceiver": {
            "x": 64,
            "y": 215
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "北太平洋": {
    "territory": "REGION_85",
    "unitSlotName": "main",
    "province": "REGION_85",
    "provinceMapData": {
      "abbr": "NPO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 52,
          "y": 61,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 124,
      "height": 870,
      "x": -1,
      "y": 181,
      "playable": true,
      "path": "M 84.258 0.218 L 64.430 5.644 L 52.699 8.855 L 26.088 16.137 L 14.602 19.280 L 7.289 21.281 L 0.258 22.674 L 1.065 864.149 L 35.903 867.910 L 39.293 868.276 L 46.247 869.027 L 46.247 869.027 L 54.000 869.000 L 57.092 860.236 L 59.366 836.034 L 60.315 825.935 L 61.246 816.024 L 61.543 812.862 L 63.973 786.998 L 64.457 781.855 L 66.794 756.980 L 66.896 755.896 L 69.521 727.955 L 69.623 726.870 L 71.300 709.029 L 71.597 705.867 L 73.748 682.977 L 74.138 678.825 L 77.407 644.039 L 77.890 638.895 L 79.948 616.995 L 80.431 611.852 L 81.828 596.984 L 81.930 595.899 L 85.301 560.028 L 85.598 556.867 L 86.250 549.929 L 86.352 548.844 L 86.881 543.215 L 78.000 538.000 L 56.000 538.000 L 39.000 531.000 L 41.000 495.000 L 46.000 486.000 L 45.000 474.000 L 49.000 470.000 L 50.000 441.000 L 56.000 430.000 L 56.000 397.000 L 62.000 383.000 L 62.000 379.000 L 60.000 377.000 L 61.000 376.000 L 63.000 359.000 L 56.000 346.000 L 56.000 327.000 L 60.000 320.000 L 58.000 297.000 L 62.000 290.000 L 63.000 281.000 L 72.000 269.000 L 85.000 238.000 L 91.000 233.000 L 104.000 217.000 L 104.000 213.000 L 114.000 205.000 L 124.000 185.000 L 124.000 182.000 L 108.000 181.000 L 93.000 176.000 L 85.000 176.000 L 77.000 171.000 L 78.000 157.000 L 84.000 146.000 L 84.000 127.000 L 96.000 103.000 L 97.000 85.000 L 102.000 76.000 L 105.000 49.000 L 109.000 46.000 L 109.000 18.000 L 98.000 18.000 L 97.000 17.000 L 86.000 17.000 L 82.000 14.000 Z",
      "province": "REGION_85",
      "rootTerritory": "REGION_85",
      "viewBox": "0 0 124 870",
      "unitSlots": [
        {
          "name": "main",
          "x": 64,
          "y": 185,
          "territory": "REGION_85",
          "arrowReceiver": {
            "x": 64,
            "y": 215
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 64,
          "y": 185,
          "territory": "REGION_85",
          "arrowReceiver": {
            "x": 64,
            "y": 215
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_86": {
    "territory": "REGION_86",
    "unitSlotName": "main",
    "province": "REGION_86",
    "provinceMapData": {
      "abbr": "GSL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 67,
          "y": 59,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 122,
      "height": 99,
      "x": 731,
      "y": 344,
      "playable": true,
      "path": "M 121.854 38.257 L 121.854 38.257 L 116.819 25.462 L 115.529 22.186 L 114.846 20.451 L 112.059 13.368 L 109.879 7.828 L 106.834 0.091 L 106.834 0.091 L 106.834 0.091 L 106.834 0.091 L 97.000 8.000 L 89.000 8.000 L 75.000 26.000 L 12.000 26.000 L 0.000 41.000 L 0.000 54.000 L 1.000 55.000 L 24.000 55.000 L 31.000 51.000 L 35.000 54.000 L 31.000 57.000 L 30.000 80.000 L 37.000 83.000 L 44.444 94.384 L 67.558 97.638 L 74.231 98.715 L 91.019 84.022 L 91.583 83.524 L 98.989 76.988 L 99.554 76.490 L 117.364 60.773 L 116.000 55.000 L 117.000 54.000 L 121.854 38.257 Z",
      "province": "REGION_86",
      "rootTerritory": "REGION_86",
      "viewBox": "0 0 122 99",
      "unitSlots": [
        {
          "name": "main",
          "x": 56,
          "y": 34,
          "territory": "REGION_86",
          "arrowReceiver": {
            "x": 56,
            "y": 64
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 56,
          "y": 34,
          "territory": "REGION_86",
          "arrowReceiver": {
            "x": 56,
            "y": 64
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "圣劳伦斯湾": {
    "territory": "REGION_86",
    "unitSlotName": "main",
    "province": "REGION_86",
    "provinceMapData": {
      "abbr": "GSL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 67,
          "y": 59,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 122,
      "height": 99,
      "x": 731,
      "y": 344,
      "playable": true,
      "path": "M 121.854 38.257 L 121.854 38.257 L 116.819 25.462 L 115.529 22.186 L 114.846 20.451 L 112.059 13.368 L 109.879 7.828 L 106.834 0.091 L 106.834 0.091 L 106.834 0.091 L 106.834 0.091 L 97.000 8.000 L 89.000 8.000 L 75.000 26.000 L 12.000 26.000 L 0.000 41.000 L 0.000 54.000 L 1.000 55.000 L 24.000 55.000 L 31.000 51.000 L 35.000 54.000 L 31.000 57.000 L 30.000 80.000 L 37.000 83.000 L 44.444 94.384 L 67.558 97.638 L 74.231 98.715 L 91.019 84.022 L 91.583 83.524 L 98.989 76.988 L 99.554 76.490 L 117.364 60.773 L 116.000 55.000 L 117.000 54.000 L 121.854 38.257 Z",
      "province": "REGION_86",
      "rootTerritory": "REGION_86",
      "viewBox": "0 0 122 99",
      "unitSlots": [
        {
          "name": "main",
          "x": 56,
          "y": 34,
          "territory": "REGION_86",
          "arrowReceiver": {
            "x": 56,
            "y": 64
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 56,
          "y": 34,
          "territory": "REGION_86",
          "arrowReceiver": {
            "x": 56,
            "y": 64
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_88": {
    "territory": "REGION_88",
    "unitSlotName": "main",
    "province": "REGION_88",
    "provinceMapData": {
      "abbr": "BTR",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 74,
          "y": 79,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 149,
      "height": 125,
      "x": 738,
      "y": 503,
      "playable": true,
      "path": "M 149.000 112.000 L 139.000 92.000 L 120.000 67.000 L 101.000 28.000 L 94.000 18.000 L 93.000 15.000 L 79.000 0.000 L 75.000 0.000 L 74.000 1.000 L 69.194 1.156 L 63.671 9.790 L 54.414 24.264 L 49.166 32.468 L 42.595 42.741 L 40.942 45.326 L 32.998 57.551 L 0.954 124.348 L 64.979 123.101 L 66.002 123.077 L 95.985 122.367 L 97.008 122.342 L 139.778 121.328 L 139.778 121.328 L 149.000 120.000 Z",
      "province": "REGION_88",
      "rootTerritory": "REGION_88",
      "viewBox": "0 0 149 125",
      "unitSlots": [
        {
          "name": "main",
          "x": 70,
          "y": 108,
          "territory": "REGION_88",
          "arrowReceiver": {
            "x": 70,
            "y": 138
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 70,
          "y": 108,
          "territory": "REGION_88",
          "arrowReceiver": {
            "x": 70,
            "y": 138
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "百慕大三角": {
    "territory": "REGION_88",
    "unitSlotName": "main",
    "province": "REGION_88",
    "provinceMapData": {
      "abbr": "BTR",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 74,
          "y": 79,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 149,
      "height": 125,
      "x": 738,
      "y": 503,
      "playable": true,
      "path": "M 149.000 112.000 L 139.000 92.000 L 120.000 67.000 L 101.000 28.000 L 94.000 18.000 L 93.000 15.000 L 79.000 0.000 L 75.000 0.000 L 74.000 1.000 L 69.194 1.156 L 63.671 9.790 L 54.414 24.264 L 49.166 32.468 L 42.595 42.741 L 40.942 45.326 L 32.998 57.551 L 0.954 124.348 L 64.979 123.101 L 66.002 123.077 L 95.985 122.367 L 97.008 122.342 L 139.778 121.328 L 139.778 121.328 L 149.000 120.000 Z",
      "province": "REGION_88",
      "rootTerritory": "REGION_88",
      "viewBox": "0 0 149 125",
      "unitSlots": [
        {
          "name": "main",
          "x": 70,
          "y": 108,
          "territory": "REGION_88",
          "arrowReceiver": {
            "x": 70,
            "y": 138
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 70,
          "y": 108,
          "territory": "REGION_88",
          "arrowReceiver": {
            "x": 70,
            "y": 138
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_90": {
    "territory": "REGION_90",
    "unitSlotName": "main",
    "province": "REGION_90",
    "provinceMapData": {
      "abbr": "ACB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 72,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 157,
      "height": 129,
      "x": 148,
      "y": 814,
      "playable": true,
      "path": "M 9.117 3.876 L 6.000 54.000 L 4.000 57.000 L 4.000 65.000 L 1.000 70.000 L 1.000 88.000 L 0.000 89.000 L 0.000 109.000 L 1.000 110.000 L 18.000 115.000 L 76.000 118.000 L 85.000 123.000 L 93.000 123.000 L 96.000 125.000 L 114.000 125.000 L 117.000 127.000 L 153.013 128.947 L 155.844 86.060 L 156.160 81.274 L 156.160 81.274 L 127.000 63.000 L 108.000 56.000 L 91.000 43.000 L 72.000 35.000 L 50.000 11.000 L 40.860 0.163 L 40.860 0.163 L 36.829 0.634 Z",
      "province": "REGION_90",
      "rootTerritory": "REGION_90",
      "viewBox": "0 0 157 129",
      "unitSlots": [
        {
          "name": "main",
          "x": 81,
          "y": 91,
          "territory": "REGION_90",
          "arrowReceiver": {
            "x": 81,
            "y": 121
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 81,
          "y": 91,
          "territory": "REGION_90",
          "arrowReceiver": {
            "x": 81,
            "y": 121
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿卡普尔科湾": {
    "territory": "REGION_90",
    "unitSlotName": "main",
    "province": "REGION_90",
    "provinceMapData": {
      "abbr": "ACB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 72,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 157,
      "height": 129,
      "x": 148,
      "y": 814,
      "playable": true,
      "path": "M 9.117 3.876 L 6.000 54.000 L 4.000 57.000 L 4.000 65.000 L 1.000 70.000 L 1.000 88.000 L 0.000 89.000 L 0.000 109.000 L 1.000 110.000 L 18.000 115.000 L 76.000 118.000 L 85.000 123.000 L 93.000 123.000 L 96.000 125.000 L 114.000 125.000 L 117.000 127.000 L 153.013 128.947 L 155.844 86.060 L 156.160 81.274 L 156.160 81.274 L 127.000 63.000 L 108.000 56.000 L 91.000 43.000 L 72.000 35.000 L 50.000 11.000 L 40.860 0.163 L 40.860 0.163 L 36.829 0.634 Z",
      "province": "REGION_90",
      "rootTerritory": "REGION_90",
      "viewBox": "0 0 157 129",
      "unitSlots": [
        {
          "name": "main",
          "x": 81,
          "y": 91,
          "territory": "REGION_90",
          "arrowReceiver": {
            "x": 81,
            "y": 121
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 81,
          "y": 91,
          "territory": "REGION_90",
          "arrowReceiver": {
            "x": 81,
            "y": 121
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_91": {
    "territory": "REGION_91",
    "unitSlotName": "main",
    "province": "REGION_91",
    "provinceMapData": {
      "abbr": "BOC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 28,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 97,
      "height": 56,
      "x": 315,
      "y": 806,
      "playable": true,
      "path": "M 1.072 0.737 L 0.000 10.000 L 2.000 12.000 L 3.000 23.000 L 5.000 27.000 L 31.000 53.000 L 35.000 53.000 L 36.000 56.000 L 39.000 56.000 L 40.000 54.000 L 49.000 53.000 L 55.000 50.000 L 56.000 48.000 L 69.000 48.000 L 73.000 52.000 L 73.000 54.000 L 77.000 54.000 L 78.000 47.000 L 89.000 38.000 L 96.851 10.082 L 64.011 6.878 L 60.851 6.570 L 44.006 4.926 L 38.865 4.424 L 28.957 3.458 L 27.872 3.352 Z",
      "province": "REGION_91",
      "rootTerritory": "REGION_91",
      "viewBox": "0 0 97 56",
      "unitSlots": [
        {
          "name": "main",
          "x": 51,
          "y": 9,
          "territory": "REGION_91",
          "arrowReceiver": {
            "x": 51,
            "y": 39
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51,
          "y": 9,
          "territory": "REGION_91",
          "arrowReceiver": {
            "x": 51,
            "y": 39
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "坎佩切湾": {
    "territory": "REGION_91",
    "unitSlotName": "main",
    "province": "REGION_91",
    "provinceMapData": {
      "abbr": "BOC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 28,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 97,
      "height": 56,
      "x": 315,
      "y": 806,
      "playable": true,
      "path": "M 1.072 0.737 L 0.000 10.000 L 2.000 12.000 L 3.000 23.000 L 5.000 27.000 L 31.000 53.000 L 35.000 53.000 L 36.000 56.000 L 39.000 56.000 L 40.000 54.000 L 49.000 53.000 L 55.000 50.000 L 56.000 48.000 L 69.000 48.000 L 73.000 52.000 L 73.000 54.000 L 77.000 54.000 L 78.000 47.000 L 89.000 38.000 L 96.851 10.082 L 64.011 6.878 L 60.851 6.570 L 44.006 4.926 L 38.865 4.424 L 28.957 3.458 L 27.872 3.352 Z",
      "province": "REGION_91",
      "rootTerritory": "REGION_91",
      "viewBox": "0 0 97 56",
      "unitSlots": [
        {
          "name": "main",
          "x": 51,
          "y": 9,
          "territory": "REGION_91",
          "arrowReceiver": {
            "x": 51,
            "y": 39
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51,
          "y": 9,
          "territory": "REGION_91",
          "arrowReceiver": {
            "x": 51,
            "y": 39
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_92": {
    "territory": "REGION_92",
    "unitSlotName": "main",
    "province": "REGION_92",
    "provinceMapData": {
      "abbr": "JAM",
      "type": "Coast",
      "centerPos": {
        "x": 18,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 68,
      "height": 44,
      "x": 597,
      "y": 869,
      "playable": true,
      "path": "M 0.00 9.00 L 2.00 42.00 L 17.00 42.00 L 18.00 43.00 L 29.00 43.00 L 30.00 44.00 L 35.00 43.00 L 67.00 44.00 L 68.00 43.00 L 68.00 16.00 L 67.00 15.00 L 68.00 9.00 L 61.00 9.00 L 56.00 0.00 L 13.00 0.00 L 12.00 3.00 L 5.00 9.00 Z",
      "province": "REGION_92",
      "rootTerritory": "REGION_92",
      "viewBox": "0 0 68 44",
      "unitSlots": [
        {
          "name": "main",
          "x": 28,
          "y": 2,
          "territory": "REGION_92",
          "arrowReceiver": {
            "x": 28,
            "y": 32
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28,
          "y": 2,
          "territory": "REGION_92",
          "arrowReceiver": {
            "x": 28,
            "y": 32
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "牙买加": {
    "territory": "REGION_92",
    "unitSlotName": "main",
    "province": "REGION_92",
    "provinceMapData": {
      "abbr": "JAM",
      "type": "Coast",
      "centerPos": {
        "x": 18,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 35,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 68,
      "height": 44,
      "x": 597,
      "y": 869,
      "playable": true,
      "path": "M 0.00 9.00 L 2.00 42.00 L 17.00 42.00 L 18.00 43.00 L 29.00 43.00 L 30.00 44.00 L 35.00 43.00 L 67.00 44.00 L 68.00 43.00 L 68.00 16.00 L 67.00 15.00 L 68.00 9.00 L 61.00 9.00 L 56.00 0.00 L 13.00 0.00 L 12.00 3.00 L 5.00 9.00 Z",
      "province": "REGION_92",
      "rootTerritory": "REGION_92",
      "viewBox": "0 0 68 44",
      "unitSlots": [
        {
          "name": "main",
          "x": 28,
          "y": 2,
          "territory": "REGION_92",
          "arrowReceiver": {
            "x": 28,
            "y": 32
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28,
          "y": 2,
          "territory": "REGION_92",
          "arrowReceiver": {
            "x": 28,
            "y": 32
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_93": {
    "territory": "REGION_93",
    "unitSlotName": "main",
    "province": "REGION_93",
    "provinceMapData": {
      "abbr": "GOH",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 58,
      "height": 44,
      "x": 443,
      "y": 861,
      "playable": true,
      "path": "M 0.00 44.00 L 57.00 42.00 L 56.00 30.00 L 58.00 27.00 L 58.00 12.00 L 54.00 4.00 L 50.00 1.00 L 20.00 0.00 L 20.00 3.00 L 16.00 10.00 L 11.00 10.00 L 8.00 17.00 L 7.00 30.00 L 1.00 35.00 Z",
      "province": "REGION_93",
      "rootTerritory": "REGION_93",
      "viewBox": "0 0 58 44",
      "unitSlots": [
        {
          "name": "main",
          "x": 28,
          "y": 37,
          "territory": "REGION_93",
          "arrowReceiver": {
            "x": 28,
            "y": 67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28,
          "y": 37,
          "territory": "REGION_93",
          "arrowReceiver": {
            "x": 28,
            "y": 67
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "洪都拉斯湾": {
    "territory": "REGION_93",
    "unitSlotName": "main",
    "province": "REGION_93",
    "provinceMapData": {
      "abbr": "GOH",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 58,
      "height": 44,
      "x": 443,
      "y": 861,
      "playable": true,
      "path": "M 0.00 44.00 L 57.00 42.00 L 56.00 30.00 L 58.00 27.00 L 58.00 12.00 L 54.00 4.00 L 50.00 1.00 L 20.00 0.00 L 20.00 3.00 L 16.00 10.00 L 11.00 10.00 L 8.00 17.00 L 7.00 30.00 L 1.00 35.00 Z",
      "province": "REGION_93",
      "rootTerritory": "REGION_93",
      "viewBox": "0 0 58 44",
      "unitSlots": [
        {
          "name": "main",
          "x": 28,
          "y": 37,
          "territory": "REGION_93",
          "arrowReceiver": {
            "x": 28,
            "y": 67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28,
          "y": 37,
          "territory": "REGION_93",
          "arrowReceiver": {
            "x": 28,
            "y": 67
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_95": {
    "territory": "REGION_95",
    "unitSlotName": "main",
    "province": "REGION_95",
    "provinceMapData": {
      "abbr": "GOT",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 67,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 84,
      "height": 106,
      "x": 301,
      "y": 893,
      "playable": true,
      "path": "M 3.160 2.274 L 0.013 49.947 L 8.000 54.000 L 8.000 95.000 L 7.000 97.000 L 11.000 102.000 L 44.000 103.000 L 49.000 106.000 L 54.000 106.000 L 55.000 105.000 L 65.000 105.000 L 66.000 104.000 L 71.000 104.000 L 72.000 105.000 L 74.000 105.000 L 80.864 103.134 L 80.864 103.134 L 80.000 95.000 L 81.000 94.000 L 81.000 84.000 L 83.000 81.000 L 84.000 51.000 L 74.000 41.000 L 74.000 36.000 L 62.000 35.000 L 41.000 14.000 L 42.000 13.000 L 41.000 0.000 L 31.000 0.000 L 30.000 1.000 L 19.000 1.000 L 18.000 2.000 L 3.160 2.274 L 3.160 2.274 Z",
      "province": "REGION_95",
      "rootTerritory": "REGION_95",
      "viewBox": "0 0 84 106",
      "unitSlots": [
        {
          "name": "main",
          "x": 42,
          "y": 86,
          "territory": "REGION_95",
          "arrowReceiver": {
            "x": 42,
            "y": 116
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42,
          "y": 86,
          "territory": "REGION_95",
          "arrowReceiver": {
            "x": 42,
            "y": 116
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "特万特佩克湾": {
    "territory": "REGION_95",
    "unitSlotName": "main",
    "province": "REGION_95",
    "provinceMapData": {
      "abbr": "GOT",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 67,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 84,
      "height": 106,
      "x": 301,
      "y": 893,
      "playable": true,
      "path": "M 3.160 2.274 L 0.013 49.947 L 8.000 54.000 L 8.000 95.000 L 7.000 97.000 L 11.000 102.000 L 44.000 103.000 L 49.000 106.000 L 54.000 106.000 L 55.000 105.000 L 65.000 105.000 L 66.000 104.000 L 71.000 104.000 L 72.000 105.000 L 74.000 105.000 L 80.864 103.134 L 80.864 103.134 L 80.000 95.000 L 81.000 94.000 L 81.000 84.000 L 83.000 81.000 L 84.000 51.000 L 74.000 41.000 L 74.000 36.000 L 62.000 35.000 L 41.000 14.000 L 42.000 13.000 L 41.000 0.000 L 31.000 0.000 L 30.000 1.000 L 19.000 1.000 L 18.000 2.000 L 3.160 2.274 L 3.160 2.274 Z",
      "province": "REGION_95",
      "rootTerritory": "REGION_95",
      "viewBox": "0 0 84 106",
      "unitSlots": [
        {
          "name": "main",
          "x": 42,
          "y": 86,
          "territory": "REGION_95",
          "arrowReceiver": {
            "x": 42,
            "y": 116
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42,
          "y": 86,
          "territory": "REGION_95",
          "arrowReceiver": {
            "x": 42,
            "y": 116
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_98": {
    "territory": "REGION_98",
    "unitSlotName": "main",
    "province": "REGION_98",
    "provinceMapData": {
      "abbr": "THI",
      "type": "Coast",
      "centerPos": {
        "x": -9,
        "y": 11
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34,
          "y": 28,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 67,
      "height": 51,
      "x": 879,
      "y": 960,
      "playable": true,
      "path": "M 67.00 2.00 L 65.00 0.00 L 62.00 0.00 L 63.00 5.00 L 60.00 10.00 L 26.00 9.00 L 19.00 13.00 L 3.00 13.00 L 2.00 12.00 L 2.00 4.00 L 0.00 4.00 L 0.00 42.00 L 19.00 40.00 L 20.00 41.00 L 20.00 51.00 L 34.00 51.00 L 45.00 44.00 L 51.00 44.00 L 66.00 27.00 Z",
      "province": "REGION_98",
      "rootTerritory": "REGION_98",
      "viewBox": "0 0 67 51",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 5,
          "territory": "REGION_98",
          "arrowReceiver": {
            "x": 27,
            "y": 35
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 5,
          "territory": "REGION_98",
          "arrowReceiver": {
            "x": 27,
            "y": 35
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "特立尼达": {
    "territory": "REGION_98",
    "unitSlotName": "main",
    "province": "REGION_98",
    "provinceMapData": {
      "abbr": "THI",
      "type": "Coast",
      "centerPos": {
        "x": -9,
        "y": 11
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34,
          "y": 28,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 67,
      "height": 51,
      "x": 879,
      "y": 960,
      "playable": true,
      "path": "M 67.00 2.00 L 65.00 0.00 L 62.00 0.00 L 63.00 5.00 L 60.00 10.00 L 26.00 9.00 L 19.00 13.00 L 3.00 13.00 L 2.00 12.00 L 2.00 4.00 L 0.00 4.00 L 0.00 42.00 L 19.00 40.00 L 20.00 41.00 L 20.00 51.00 L 34.00 51.00 L 45.00 44.00 L 51.00 44.00 L 66.00 27.00 Z",
      "province": "REGION_98",
      "rootTerritory": "REGION_98",
      "viewBox": "0 0 67 51",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 5,
          "territory": "REGION_98",
          "arrowReceiver": {
            "x": 27,
            "y": 35
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 5,
          "territory": "REGION_98",
          "arrowReceiver": {
            "x": 27,
            "y": 35
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_99": {
    "territory": "REGION_99",
    "unitSlotName": "main",
    "province": "REGION_99",
    "provinceMapData": {
      "abbr": "MAB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 114,
          "y": 48,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 166,
      "height": 94,
      "x": 1055,
      "y": 1102,
      "playable": true,
      "path": "M 163.00 2.00 L 138.00 0.00 L 127.00 6.00 L 104.00 5.00 L 81.00 13.00 L 55.00 12.00 L 42.00 19.00 L 8.00 20.00 L 8.00 22.00 L 10.00 24.00 L 9.00 42.00 L 0.00 51.00 L 0.00 53.00 L 27.00 54.00 L 32.00 60.00 L 45.00 60.00 L 46.00 61.00 L 46.00 71.00 L 53.00 75.00 L 69.00 78.00 L 75.00 86.00 L 75.00 94.00 L 94.00 93.00 L 99.00 90.00 L 135.00 92.00 L 140.00 89.00 L 164.00 92.00 L 166.00 14.00 L 163.00 9.00 Z",
      "province": "REGION_99",
      "rootTerritory": "REGION_99",
      "viewBox": "0 0 166 94",
      "unitSlots": [
        {
          "name": "main",
          "x": 85,
          "y": 50,
          "territory": "REGION_99",
          "arrowReceiver": {
            "x": 85,
            "y": 80
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 85,
          "y": 50,
          "territory": "REGION_99",
          "arrowReceiver": {
            "x": 85,
            "y": 80
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "马拉若湾": {
    "territory": "REGION_99",
    "unitSlotName": "main",
    "province": "REGION_99",
    "provinceMapData": {
      "abbr": "MAB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 114,
          "y": 48,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 166,
      "height": 94,
      "x": 1055,
      "y": 1102,
      "playable": true,
      "path": "M 163.00 2.00 L 138.00 0.00 L 127.00 6.00 L 104.00 5.00 L 81.00 13.00 L 55.00 12.00 L 42.00 19.00 L 8.00 20.00 L 8.00 22.00 L 10.00 24.00 L 9.00 42.00 L 0.00 51.00 L 0.00 53.00 L 27.00 54.00 L 32.00 60.00 L 45.00 60.00 L 46.00 61.00 L 46.00 71.00 L 53.00 75.00 L 69.00 78.00 L 75.00 86.00 L 75.00 94.00 L 94.00 93.00 L 99.00 90.00 L 135.00 92.00 L 140.00 89.00 L 164.00 92.00 L 166.00 14.00 L 163.00 9.00 Z",
      "province": "REGION_99",
      "rootTerritory": "REGION_99",
      "viewBox": "0 0 166 94",
      "unitSlots": [
        {
          "name": "main",
          "x": 85,
          "y": 50,
          "territory": "REGION_99",
          "arrowReceiver": {
            "x": 85,
            "y": 80
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 85,
          "y": 50,
          "territory": "REGION_99",
          "arrowReceiver": {
            "x": 85,
            "y": 80
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_100": {
    "territory": "REGION_100",
    "unitSlotName": "main",
    "province": "REGION_100",
    "provinceMapData": {
      "abbr": "TSB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 65,
          "y": 129,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 113,
      "height": 177,
      "x": 1166,
      "y": 1229,
      "playable": true,
      "path": "M 107.073 0.130 L 84.563 3.890 L 84.000 20.000 L 78.000 32.000 L 66.000 43.000 L 37.000 95.000 L 20.000 107.000 L 18.000 110.000 L 1.000 158.000 L 0.000 176.000 L 14.000 176.000 L 17.000 174.000 L 32.000 174.000 L 35.000 172.000 L 46.000 172.000 L 47.000 171.000 L 54.000 171.000 L 55.000 172.000 L 55.000 177.000 L 71.000 176.000 L 76.000 173.000 L 87.000 172.000 L 108.000 161.000 L 109.000 122.000 L 113.000 119.000 L 113.000 99.000 L 112.000 98.000 L 112.000 88.000 L 111.000 87.000 L 113.000 6.000 Z",
      "province": "REGION_100",
      "rootTerritory": "REGION_100",
      "viewBox": "0 0 113 177",
      "unitSlots": [
        {
          "name": "main",
          "x": 51,
          "y": 147,
          "territory": "REGION_100",
          "arrowReceiver": {
            "x": 51,
            "y": 177
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51,
          "y": 147,
          "territory": "REGION_100",
          "arrowReceiver": {
            "x": 51,
            "y": 177
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "万圣湾": {
    "territory": "REGION_100",
    "unitSlotName": "main",
    "province": "REGION_100",
    "provinceMapData": {
      "abbr": "TSB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 65,
          "y": 129,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 113,
      "height": 177,
      "x": 1166,
      "y": 1229,
      "playable": true,
      "path": "M 107.073 0.130 L 84.563 3.890 L 84.000 20.000 L 78.000 32.000 L 66.000 43.000 L 37.000 95.000 L 20.000 107.000 L 18.000 110.000 L 1.000 158.000 L 0.000 176.000 L 14.000 176.000 L 17.000 174.000 L 32.000 174.000 L 35.000 172.000 L 46.000 172.000 L 47.000 171.000 L 54.000 171.000 L 55.000 172.000 L 55.000 177.000 L 71.000 176.000 L 76.000 173.000 L 87.000 172.000 L 108.000 161.000 L 109.000 122.000 L 113.000 119.000 L 113.000 99.000 L 112.000 98.000 L 112.000 88.000 L 111.000 87.000 L 113.000 6.000 Z",
      "province": "REGION_100",
      "rootTerritory": "REGION_100",
      "viewBox": "0 0 113 177",
      "unitSlots": [
        {
          "name": "main",
          "x": 51,
          "y": 147,
          "territory": "REGION_100",
          "arrowReceiver": {
            "x": 51,
            "y": 177
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51,
          "y": 147,
          "territory": "REGION_100",
          "arrowReceiver": {
            "x": 51,
            "y": 177
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_101": {
    "territory": "REGION_101",
    "unitSlotName": "main",
    "province": "REGION_101",
    "provinceMapData": {
      "abbr": "BPA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 87,
          "y": 89,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 311,
      "height": 179,
      "x": 366,
      "y": 1272,
      "playable": true,
      "path": "M 2.205 0.017 L 1.441 81.996 L 1.430 83.003 L 0.403 169.454 L 0.403 169.454 L 0.403 169.454 L 9.000 170.000 L 13.000 173.000 L 25.000 173.000 L 26.000 174.000 L 38.000 174.000 L 39.000 175.000 L 75.000 175.000 L 76.000 176.000 L 199.000 177.000 L 200.000 178.000 L 260.000 178.000 L 261.000 179.000 L 308.000 179.000 L 311.000 177.000 L 311.000 174.000 L 302.000 175.000 L 295.000 166.000 L 276.000 158.000 L 274.000 155.000 L 271.000 155.000 L 249.000 135.000 L 249.000 120.000 L 225.000 92.000 L 223.000 88.000 L 223.000 78.000 L 219.000 70.000 L 219.000 65.000 L 218.000 64.000 L 218.000 62.000 L 211.000 48.000 L 209.000 46.000 L 204.000 35.000 L 174.037 7.050 Z",
      "province": "REGION_101",
      "rootTerritory": "REGION_101",
      "viewBox": "0 0 311 179",
      "unitSlots": [
        {
          "name": "main",
          "x": 147,
          "y": 156,
          "territory": "REGION_101",
          "arrowReceiver": {
            "x": 147,
            "y": 186
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 147,
          "y": 156,
          "territory": "REGION_101",
          "arrowReceiver": {
            "x": 147,
            "y": 186
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "帕拉卡斯湾": {
    "territory": "REGION_101",
    "unitSlotName": "main",
    "province": "REGION_101",
    "provinceMapData": {
      "abbr": "BPA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 87,
          "y": 89,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 311,
      "height": 179,
      "x": 366,
      "y": 1272,
      "playable": true,
      "path": "M 2.205 0.017 L 1.441 81.996 L 1.430 83.003 L 0.403 169.454 L 0.403 169.454 L 0.403 169.454 L 9.000 170.000 L 13.000 173.000 L 25.000 173.000 L 26.000 174.000 L 38.000 174.000 L 39.000 175.000 L 75.000 175.000 L 76.000 176.000 L 199.000 177.000 L 200.000 178.000 L 260.000 178.000 L 261.000 179.000 L 308.000 179.000 L 311.000 177.000 L 311.000 174.000 L 302.000 175.000 L 295.000 166.000 L 276.000 158.000 L 274.000 155.000 L 271.000 155.000 L 249.000 135.000 L 249.000 120.000 L 225.000 92.000 L 223.000 88.000 L 223.000 78.000 L 219.000 70.000 L 219.000 65.000 L 218.000 64.000 L 218.000 62.000 L 211.000 48.000 L 209.000 46.000 L 204.000 35.000 L 174.037 7.050 Z",
      "province": "REGION_101",
      "rootTerritory": "REGION_101",
      "viewBox": "0 0 311 179",
      "unitSlots": [
        {
          "name": "main",
          "x": 147,
          "y": 156,
          "territory": "REGION_101",
          "arrowReceiver": {
            "x": 147,
            "y": 186
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 147,
          "y": 156,
          "territory": "REGION_101",
          "arrowReceiver": {
            "x": 147,
            "y": 186
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_102": {
    "territory": "REGION_102",
    "unitSlotName": "main",
    "province": "REGION_102",
    "provinceMapData": {
      "abbr": "GUB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 52,
          "y": 76,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 101,
      "height": 162,
      "x": 1124,
      "y": 1399,
      "playable": true,
      "path": "M 98.00 0.00 L 75.00 1.00 L 72.00 3.00 L 57.00 3.00 L 54.00 5.00 L 42.00 5.00 L 30.00 29.00 L 11.00 49.00 L 6.00 61.00 L 0.00 68.00 L 2.00 72.00 L 2.00 78.00 L 3.00 80.00 L 5.00 81.00 L 7.00 162.00 L 44.00 157.00 L 63.00 147.00 L 89.00 145.00 L 99.00 138.00 L 101.00 44.00 L 100.00 43.00 L 100.00 34.00 L 99.00 33.00 Z",
      "province": "REGION_102",
      "rootTerritory": "REGION_102",
      "viewBox": "0 0 101 162",
      "unitSlots": [
        {
          "name": "main",
          "x": 42,
          "y": 82,
          "territory": "REGION_102",
          "arrowReceiver": {
            "x": 42,
            "y": 112
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42,
          "y": 82,
          "territory": "REGION_102",
          "arrowReceiver": {
            "x": 42,
            "y": 112
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "瓜纳巴拉湾": {
    "territory": "REGION_102",
    "unitSlotName": "main",
    "province": "REGION_102",
    "provinceMapData": {
      "abbr": "GUB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 52,
          "y": 76,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 101,
      "height": 162,
      "x": 1124,
      "y": 1399,
      "playable": true,
      "path": "M 98.00 0.00 L 75.00 1.00 L 72.00 3.00 L 57.00 3.00 L 54.00 5.00 L 42.00 5.00 L 30.00 29.00 L 11.00 49.00 L 6.00 61.00 L 0.00 68.00 L 2.00 72.00 L 2.00 78.00 L 3.00 80.00 L 5.00 81.00 L 7.00 162.00 L 44.00 157.00 L 63.00 147.00 L 89.00 145.00 L 99.00 138.00 L 101.00 44.00 L 100.00 43.00 L 100.00 34.00 L 99.00 33.00 Z",
      "province": "REGION_102",
      "rootTerritory": "REGION_102",
      "viewBox": "0 0 101 162",
      "unitSlots": [
        {
          "name": "main",
          "x": 42,
          "y": 82,
          "territory": "REGION_102",
          "arrowReceiver": {
            "x": 42,
            "y": 112
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42,
          "y": 82,
          "territory": "REGION_102",
          "arrowReceiver": {
            "x": 42,
            "y": 112
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_103": {
    "territory": "REGION_103",
    "unitSlotName": "main",
    "province": "REGION_103",
    "provinceMapData": {
      "abbr": "BDP",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 146,
          "y": 101,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 213,
      "height": 183,
      "x": 918,
      "y": 1480,
      "playable": true,
      "path": "M 211.00 0.00 L 208.00 0.00 L 205.00 2.00 L 199.00 3.00 L 198.00 4.00 L 189.00 4.00 L 176.00 13.00 L 156.00 12.00 L 140.00 27.00 L 125.00 31.00 L 106.00 46.00 L 97.00 49.00 L 79.00 81.00 L 79.00 84.00 L 78.00 85.00 L 78.00 88.00 L 77.00 89.00 L 76.00 94.00 L 66.00 103.00 L 63.00 104.00 L 44.00 122.00 L 36.00 123.00 L 29.00 132.00 L 18.00 137.00 L 6.00 151.00 L 8.00 170.00 L 5.00 176.00 L 0.00 181.00 L 0.00 183.00 L 32.00 183.00 L 41.00 178.00 L 79.00 178.00 L 82.00 176.00 L 90.00 176.00 L 93.00 174.00 L 136.00 173.00 L 140.00 169.00 L 178.00 166.00 L 182.00 164.00 L 185.00 164.00 L 186.00 163.00 L 206.00 157.00 L 210.00 152.00 L 209.00 119.00 L 213.00 112.00 Z",
      "province": "REGION_103",
      "rootTerritory": "REGION_103",
      "viewBox": "0 0 213 183",
      "unitSlots": [
        {
          "name": "main",
          "x": 111,
          "y": 142,
          "territory": "REGION_103",
          "arrowReceiver": {
            "x": 111,
            "y": 172
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 111,
          "y": 142,
          "territory": "REGION_103",
          "arrowReceiver": {
            "x": 111,
            "y": 172
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "巴拉那瓜湾": {
    "territory": "REGION_103",
    "unitSlotName": "main",
    "province": "REGION_103",
    "provinceMapData": {
      "abbr": "BDP",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 146,
          "y": 101,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 213,
      "height": 183,
      "x": 918,
      "y": 1480,
      "playable": true,
      "path": "M 211.00 0.00 L 208.00 0.00 L 205.00 2.00 L 199.00 3.00 L 198.00 4.00 L 189.00 4.00 L 176.00 13.00 L 156.00 12.00 L 140.00 27.00 L 125.00 31.00 L 106.00 46.00 L 97.00 49.00 L 79.00 81.00 L 79.00 84.00 L 78.00 85.00 L 78.00 88.00 L 77.00 89.00 L 76.00 94.00 L 66.00 103.00 L 63.00 104.00 L 44.00 122.00 L 36.00 123.00 L 29.00 132.00 L 18.00 137.00 L 6.00 151.00 L 8.00 170.00 L 5.00 176.00 L 0.00 181.00 L 0.00 183.00 L 32.00 183.00 L 41.00 178.00 L 79.00 178.00 L 82.00 176.00 L 90.00 176.00 L 93.00 174.00 L 136.00 173.00 L 140.00 169.00 L 178.00 166.00 L 182.00 164.00 L 185.00 164.00 L 186.00 163.00 L 206.00 157.00 L 210.00 152.00 L 209.00 119.00 L 213.00 112.00 Z",
      "province": "REGION_103",
      "rootTerritory": "REGION_103",
      "viewBox": "0 0 213 183",
      "unitSlots": [
        {
          "name": "main",
          "x": 111,
          "y": 142,
          "territory": "REGION_103",
          "arrowReceiver": {
            "x": 111,
            "y": 172
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 111,
          "y": 142,
          "territory": "REGION_103",
          "arrowReceiver": {
            "x": 111,
            "y": 172
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_104": {
    "territory": "REGION_104",
    "unitSlotName": "main",
    "province": "REGION_104",
    "provinceMapData": {
      "abbr": "NEN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 33,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 79,
      "height": 108,
      "x": 679,
      "y": 411,
      "playable": true,
      "path": "M 63.00 2.00 L 37.00 0.00 L 21.00 30.00 L 15.00 32.00 L 4.00 33.00 L 6.00 76.00 L 2.00 86.00 L 0.00 87.00 L 1.00 108.00 L 15.00 106.00 L 24.00 99.00 L 38.00 94.00 L 40.00 91.00 L 40.00 77.00 L 38.00 73.00 L 62.00 52.00 L 70.00 53.00 L 79.00 46.00 L 78.00 29.00 L 68.00 21.00 L 66.00 5.00 Z",
      "province": "REGION_104",
      "rootTerritory": "REGION_104",
      "viewBox": "0 0 79 108",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 33,
          "territory": "REGION_104",
          "arrowReceiver": {
            "x": 41,
            "y": 63
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 33,
          "territory": "REGION_104",
          "arrowReceiver": {
            "x": 41,
            "y": 63
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "新英格兰": {
    "territory": "REGION_104",
    "unitSlotName": "main",
    "province": "REGION_104",
    "provinceMapData": {
      "abbr": "NEN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 33,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 79,
      "height": 108,
      "x": 679,
      "y": 411,
      "playable": true,
      "path": "M 63.00 2.00 L 37.00 0.00 L 21.00 30.00 L 15.00 32.00 L 4.00 33.00 L 6.00 76.00 L 2.00 86.00 L 0.00 87.00 L 1.00 108.00 L 15.00 106.00 L 24.00 99.00 L 38.00 94.00 L 40.00 91.00 L 40.00 77.00 L 38.00 73.00 L 62.00 52.00 L 70.00 53.00 L 79.00 46.00 L 78.00 29.00 L 68.00 21.00 L 66.00 5.00 Z",
      "province": "REGION_104",
      "rootTerritory": "REGION_104",
      "viewBox": "0 0 79 108",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 33,
          "territory": "REGION_104",
          "arrowReceiver": {
            "x": 41,
            "y": 63
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 33,
          "territory": "REGION_104",
          "arrowReceiver": {
            "x": 41,
            "y": 63
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_106": {
    "territory": "REGION_106",
    "unitSlotName": "main",
    "province": "REGION_106",
    "provinceMapData": {
      "abbr": "NYC",
      "type": "Coast",
      "centerPos": {
        "x": -6.5,
        "y": 20
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 10.5,
          "y": 13,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 21,
      "height": 49,
      "x": 660,
      "y": 496,
      "playable": true,
      "path": "M 1.00 0.00 L 0.00 14.00 L 3.00 19.00 L 3.00 29.00 L 1.00 31.00 L 0.00 35.00 L 3.00 39.00 L 3.00 49.00 L 7.00 49.00 L 15.00 42.00 L 20.00 32.00 L 20.00 26.00 L 21.00 25.00 L 20.00 2.00 L 8.00 3.00 L 5.00 0.00 Z",
      "province": "REGION_106",
      "rootTerritory": "REGION_106",
      "viewBox": "0 0 21 49",
      "unitSlots": [
        {
          "name": "main",
          "x": 13,
          "y": 11,
          "territory": "REGION_106",
          "arrowReceiver": {
            "x": 13,
            "y": 41
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 13,
          "y": 11,
          "territory": "REGION_106",
          "arrowReceiver": {
            "x": 13,
            "y": 41
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "纽约": {
    "territory": "REGION_106",
    "unitSlotName": "main",
    "province": "REGION_106",
    "provinceMapData": {
      "abbr": "NYC",
      "type": "Coast",
      "centerPos": {
        "x": -6.5,
        "y": 20
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 10.5,
          "y": 13,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 21,
      "height": 49,
      "x": 660,
      "y": 496,
      "playable": true,
      "path": "M 1.00 0.00 L 0.00 14.00 L 3.00 19.00 L 3.00 29.00 L 1.00 31.00 L 0.00 35.00 L 3.00 39.00 L 3.00 49.00 L 7.00 49.00 L 15.00 42.00 L 20.00 32.00 L 20.00 26.00 L 21.00 25.00 L 20.00 2.00 L 8.00 3.00 L 5.00 0.00 Z",
      "province": "REGION_106",
      "rootTerritory": "REGION_106",
      "viewBox": "0 0 21 49",
      "unitSlots": [
        {
          "name": "main",
          "x": 13,
          "y": 11,
          "territory": "REGION_106",
          "arrowReceiver": {
            "x": 13,
            "y": 41
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 13,
          "y": 11,
          "territory": "REGION_106",
          "arrowReceiver": {
            "x": 13,
            "y": 41
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_107": {
    "territory": "REGION_107",
    "unitSlotName": "main",
    "province": "REGION_107",
    "provinceMapData": {
      "abbr": "WDC",
      "type": "Coast",
      "centerPos": {
        "x": 11,
        "y": 5
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 63,
      "x": 590,
      "y": 496,
      "playable": true,
      "path": "M 0.00 7.00 L 0.00 24.00 L 3.00 28.00 L 11.00 28.00 L 15.00 32.00 L 25.00 31.00 L 31.00 29.00 L 47.00 42.00 L 50.00 49.00 L 56.00 49.00 L 61.00 54.00 L 61.00 63.00 L 63.00 63.00 L 71.00 58.00 L 74.00 52.00 L 74.00 37.00 L 72.00 35.00 L 72.00 33.00 L 74.00 31.00 L 74.00 17.00 L 71.00 12.00 L 72.00 0.00 L 53.00 1.00 L 52.00 2.00 L 11.00 0.00 L 3.00 4.00 Z",
      "province": "REGION_107",
      "rootTerritory": "REGION_107",
      "viewBox": "0 0 74 63",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        "nc": {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        "sc": {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "华盛顿特区": {
    "territory": "REGION_107",
    "unitSlotName": "main",
    "province": "REGION_107",
    "provinceMapData": {
      "abbr": "WDC",
      "type": "Coast",
      "centerPos": {
        "x": 11,
        "y": 5
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 63,
      "x": 590,
      "y": 496,
      "playable": true,
      "path": "M 0.00 7.00 L 0.00 24.00 L 3.00 28.00 L 11.00 28.00 L 15.00 32.00 L 25.00 31.00 L 31.00 29.00 L 47.00 42.00 L 50.00 49.00 L 56.00 49.00 L 61.00 54.00 L 61.00 63.00 L 63.00 63.00 L 71.00 58.00 L 74.00 52.00 L 74.00 37.00 L 72.00 35.00 L 72.00 33.00 L 74.00 31.00 L 74.00 17.00 L 71.00 12.00 L 72.00 0.00 L 53.00 1.00 L 52.00 2.00 L 11.00 0.00 L 3.00 4.00 Z",
      "province": "REGION_107",
      "rootTerritory": "REGION_107",
      "viewBox": "0 0 74 63",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        "nc": {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        "sc": {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_109": {
    "territory": "REGION_109",
    "unitSlotName": "main",
    "province": "REGION_109",
    "provinceMapData": {
      "abbr": "VIR",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 31,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 87,
      "height": 55,
      "x": 565,
      "y": 518,
      "playable": true,
      "path": "M 1.00 26.00 L 1.00 35.00 L 5.00 39.00 L 5.00 49.00 L 0.00 53.00 L 0.00 55.00 L 49.00 53.00 L 50.00 52.00 L 68.00 51.00 L 73.00 46.00 L 87.00 47.00 L 87.00 30.00 L 83.00 26.00 L 77.00 26.00 L 73.00 18.00 L 58.00 6.00 L 42.00 9.00 L 38.00 5.00 L 30.00 5.00 L 26.00 0.00 L 24.00 0.00 L 24.00 8.00 L 23.00 9.00 L 18.00 8.00 Z",
      "province": "REGION_109",
      "rootTerritory": "REGION_109",
      "viewBox": "0 0 87 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 50,
          "y": 46,
          "territory": "REGION_109",
          "arrowReceiver": {
            "x": 50,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 50,
          "y": 46,
          "territory": "REGION_109",
          "arrowReceiver": {
            "x": 50,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "弗吉尼亚": {
    "territory": "REGION_109",
    "unitSlotName": "main",
    "province": "REGION_109",
    "provinceMapData": {
      "abbr": "VIR",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 31,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 87,
      "height": 55,
      "x": 565,
      "y": 518,
      "playable": true,
      "path": "M 1.00 26.00 L 1.00 35.00 L 5.00 39.00 L 5.00 49.00 L 0.00 53.00 L 0.00 55.00 L 49.00 53.00 L 50.00 52.00 L 68.00 51.00 L 73.00 46.00 L 87.00 47.00 L 87.00 30.00 L 83.00 26.00 L 77.00 26.00 L 73.00 18.00 L 58.00 6.00 L 42.00 9.00 L 38.00 5.00 L 30.00 5.00 L 26.00 0.00 L 24.00 0.00 L 24.00 8.00 L 23.00 9.00 L 18.00 8.00 Z",
      "province": "REGION_109",
      "rootTerritory": "REGION_109",
      "viewBox": "0 0 87 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 50,
          "y": 46,
          "territory": "REGION_109",
          "arrowReceiver": {
            "x": 50,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 50,
          "y": 46,
          "territory": "REGION_109",
          "arrowReceiver": {
            "x": 50,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_111": {
    "territory": "REGION_111",
    "unitSlotName": "main",
    "province": "REGION_111",
    "provinceMapData": {
      "abbr": "CHA",
      "type": "Coast",
      "centerPos": {
        "x": 29,
        "y": 70
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 46,
          "y": 63,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 139,
      "height": 101,
      "x": 515,
      "y": 563,
      "playable": true,
      "path": "M 139.00 1.00 L 121.00 0.00 L 116.00 5.00 L 85.00 7.00 L 84.00 8.00 L 49.00 9.00 L 50.00 20.00 L 43.00 27.00 L 26.00 33.00 L 19.00 41.00 L 5.00 43.00 L 0.00 46.00 L 2.00 74.00 L 5.00 77.00 L 4.00 95.00 L 11.00 101.00 L 26.00 101.00 L 27.00 100.00 L 48.00 101.00 L 53.00 99.00 L 59.00 99.00 L 66.00 91.00 L 96.00 65.00 L 128.00 49.00 L 139.00 27.00 Z",
      "province": "REGION_111",
      "rootTerritory": "REGION_111",
      "viewBox": "0 0 139 101",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 37,
          "territory": "REGION_111",
          "arrowReceiver": {
            "x": 63,
            "y": 67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 37,
          "territory": "REGION_111",
          "arrowReceiver": {
            "x": 63,
            "y": 67
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "查尔斯顿": {
    "territory": "REGION_111",
    "unitSlotName": "main",
    "province": "REGION_111",
    "provinceMapData": {
      "abbr": "CHA",
      "type": "Coast",
      "centerPos": {
        "x": 29,
        "y": 70
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 46,
          "y": 63,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 139,
      "height": 101,
      "x": 515,
      "y": 563,
      "playable": true,
      "path": "M 139.00 1.00 L 121.00 0.00 L 116.00 5.00 L 85.00 7.00 L 84.00 8.00 L 49.00 9.00 L 50.00 20.00 L 43.00 27.00 L 26.00 33.00 L 19.00 41.00 L 5.00 43.00 L 0.00 46.00 L 2.00 74.00 L 5.00 77.00 L 4.00 95.00 L 11.00 101.00 L 26.00 101.00 L 27.00 100.00 L 48.00 101.00 L 53.00 99.00 L 59.00 99.00 L 66.00 91.00 L 96.00 65.00 L 128.00 49.00 L 139.00 27.00 Z",
      "province": "REGION_111",
      "rootTerritory": "REGION_111",
      "viewBox": "0 0 139 101",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 37,
          "territory": "REGION_111",
          "arrowReceiver": {
            "x": 63,
            "y": 67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 37,
          "territory": "REGION_111",
          "arrowReceiver": {
            "x": 63,
            "y": 67
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_113": {
    "territory": "REGION_113",
    "unitSlotName": "main",
    "province": "REGION_113",
    "provinceMapData": {
      "abbr": "FLL",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 81,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 111,
      "height": 92,
      "x": 468,
      "y": 657,
      "playable": true,
      "path": "M 0.00 12.00 L 0.00 14.00 L 5.00 17.00 L 30.00 21.00 L 35.00 28.00 L 51.00 28.00 L 56.00 26.00 L 60.00 34.00 L 75.00 47.00 L 74.00 60.00 L 73.00 61.00 L 73.00 74.00 L 88.00 71.00 L 99.00 88.00 L 103.00 92.00 L 105.00 92.00 L 107.00 90.00 L 108.00 80.00 L 111.00 75.00 L 111.00 70.00 L 107.00 60.00 L 106.00 46.00 L 101.00 37.00 L 101.00 25.00 L 102.00 24.00 L 110.00 24.00 L 107.00 5.00 L 105.00 3.00 L 93.00 6.00 L 88.00 6.00 L 87.00 5.00 L 60.00 6.00 L 53.00 0.00 L 50.00 0.00 L 50.00 6.00 L 49.00 7.00 L 7.00 6.00 L 7.00 11.00 L 6.00 12.00 Z",
      "province": "REGION_113",
      "rootTerritory": "REGION_113",
      "viewBox": "0 0 111 92",
      "unitSlots": [
        {
          "name": "main",
          "x": 57,
          "y": 9,
          "territory": "REGION_113",
          "arrowReceiver": {
            "x": 57,
            "y": 39
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57,
          "y": 9,
          "territory": "REGION_113",
          "arrowReceiver": {
            "x": 57,
            "y": 39
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "佛罗里达": {
    "territory": "REGION_113",
    "unitSlotName": "main",
    "province": "REGION_113",
    "provinceMapData": {
      "abbr": "FLL",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 81,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 111,
      "height": 92,
      "x": 468,
      "y": 657,
      "playable": true,
      "path": "M 0.00 12.00 L 0.00 14.00 L 5.00 17.00 L 30.00 21.00 L 35.00 28.00 L 51.00 28.00 L 56.00 26.00 L 60.00 34.00 L 75.00 47.00 L 74.00 60.00 L 73.00 61.00 L 73.00 74.00 L 88.00 71.00 L 99.00 88.00 L 103.00 92.00 L 105.00 92.00 L 107.00 90.00 L 108.00 80.00 L 111.00 75.00 L 111.00 70.00 L 107.00 60.00 L 106.00 46.00 L 101.00 37.00 L 101.00 25.00 L 102.00 24.00 L 110.00 24.00 L 107.00 5.00 L 105.00 3.00 L 93.00 6.00 L 88.00 6.00 L 87.00 5.00 L 60.00 6.00 L 53.00 0.00 L 50.00 0.00 L 50.00 6.00 L 49.00 7.00 L 7.00 6.00 L 7.00 11.00 L 6.00 12.00 Z",
      "province": "REGION_113",
      "rootTerritory": "REGION_113",
      "viewBox": "0 0 111 92",
      "unitSlots": [
        {
          "name": "main",
          "x": 57,
          "y": 9,
          "territory": "REGION_113",
          "arrowReceiver": {
            "x": 57,
            "y": 39
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57,
          "y": 9,
          "territory": "REGION_113",
          "arrowReceiver": {
            "x": 57,
            "y": 39
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_120": {
    "territory": "REGION_120",
    "unitSlotName": "main",
    "province": "REGION_120",
    "provinceMapData": {
      "abbr": "RUP",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 119,
          "y": 146,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 276,
      "height": 193,
      "x": 268,
      "y": 190,
      "playable": true,
      "path": "M 276.00 5.00 L 268.00 4.00 L 263.00 1.00 L 248.00 0.00 L 225.00 10.00 L 218.00 10.00 L 210.00 17.00 L 198.00 16.00 L 181.00 25.00 L 175.00 25.00 L 167.00 28.00 L 151.00 28.00 L 131.00 37.00 L 115.00 49.00 L 112.00 55.00 L 112.00 60.00 L 118.00 63.00 L 125.00 64.00 L 138.00 73.00 L 140.00 77.00 L 140.00 90.00 L 134.00 97.00 L 129.00 98.00 L 124.00 101.00 L 117.00 101.00 L 114.00 103.00 L 92.00 102.00 L 57.00 120.00 L 49.00 121.00 L 44.00 124.00 L 38.00 124.00 L 29.00 129.00 L 15.00 129.00 L 14.00 130.00 L 3.00 130.00 L 1.00 131.00 L 0.00 140.00 L 6.00 151.00 L 6.00 159.00 L 3.00 164.00 L 4.00 173.00 L 9.00 177.00 L 24.00 179.00 L 38.00 184.00 L 56.00 185.00 L 66.00 187.00 L 79.00 187.00 L 80.00 188.00 L 112.00 189.00 L 115.00 191.00 L 126.00 191.00 L 129.00 193.00 L 156.00 193.00 L 161.00 162.00 L 217.00 100.00 L 214.00 82.00 L 203.00 77.00 L 204.00 58.00 L 226.00 34.00 L 234.00 32.00 L 242.00 21.00 L 250.00 20.00 L 258.00 13.00 L 271.00 13.00 L 276.00 7.00 Z",
      "province": "REGION_120",
      "rootTerritory": "REGION_120",
      "viewBox": "0 0 276 193",
      "unitSlots": [
        {
          "name": "main",
          "x": 105,
          "y": 132,
          "territory": "REGION_120",
          "arrowReceiver": {
            "x": 105,
            "y": 162
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 105,
          "y": 132,
          "territory": "REGION_120",
          "arrowReceiver": {
            "x": 105,
            "y": 162
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "鲁珀特地": {
    "territory": "REGION_120",
    "unitSlotName": "main",
    "province": "REGION_120",
    "provinceMapData": {
      "abbr": "RUP",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 119,
          "y": 146,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 276,
      "height": 193,
      "x": 268,
      "y": 190,
      "playable": true,
      "path": "M 276.00 5.00 L 268.00 4.00 L 263.00 1.00 L 248.00 0.00 L 225.00 10.00 L 218.00 10.00 L 210.00 17.00 L 198.00 16.00 L 181.00 25.00 L 175.00 25.00 L 167.00 28.00 L 151.00 28.00 L 131.00 37.00 L 115.00 49.00 L 112.00 55.00 L 112.00 60.00 L 118.00 63.00 L 125.00 64.00 L 138.00 73.00 L 140.00 77.00 L 140.00 90.00 L 134.00 97.00 L 129.00 98.00 L 124.00 101.00 L 117.00 101.00 L 114.00 103.00 L 92.00 102.00 L 57.00 120.00 L 49.00 121.00 L 44.00 124.00 L 38.00 124.00 L 29.00 129.00 L 15.00 129.00 L 14.00 130.00 L 3.00 130.00 L 1.00 131.00 L 0.00 140.00 L 6.00 151.00 L 6.00 159.00 L 3.00 164.00 L 4.00 173.00 L 9.00 177.00 L 24.00 179.00 L 38.00 184.00 L 56.00 185.00 L 66.00 187.00 L 79.00 187.00 L 80.00 188.00 L 112.00 189.00 L 115.00 191.00 L 126.00 191.00 L 129.00 193.00 L 156.00 193.00 L 161.00 162.00 L 217.00 100.00 L 214.00 82.00 L 203.00 77.00 L 204.00 58.00 L 226.00 34.00 L 234.00 32.00 L 242.00 21.00 L 250.00 20.00 L 258.00 13.00 L 271.00 13.00 L 276.00 7.00 Z",
      "province": "REGION_120",
      "rootTerritory": "REGION_120",
      "viewBox": "0 0 276 193",
      "unitSlots": [
        {
          "name": "main",
          "x": 105,
          "y": 132,
          "territory": "REGION_120",
          "arrowReceiver": {
            "x": 105,
            "y": 162
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 105,
          "y": 132,
          "territory": "REGION_120",
          "arrowReceiver": {
            "x": 105,
            "y": 162
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_122": {
    "territory": "REGION_122",
    "unitSlotName": "main",
    "province": "REGION_122",
    "provinceMapData": {
      "abbr": "GLB",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 63,
          "y": 58,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 136,
      "height": 110,
      "x": 139,
      "y": 254,
      "playable": true,
      "path": "M 10.00 7.00 L 8.00 46.00 L 0.00 61.00 L 0.00 84.00 L 2.00 90.00 L 4.00 90.00 L 6.00 85.00 L 29.00 85.00 L 54.00 98.00 L 79.00 100.00 L 80.00 101.00 L 86.00 101.00 L 90.00 103.00 L 100.00 103.00 L 112.00 110.00 L 135.00 110.00 L 133.00 102.00 L 136.00 97.00 L 136.00 85.00 L 130.00 74.00 L 131.00 67.00 L 110.00 66.00 L 102.00 58.00 L 104.00 40.00 L 99.00 32.00 L 87.00 24.00 L 81.00 23.00 L 55.00 14.00 L 52.00 14.00 L 46.00 11.00 L 25.00 13.00 L 18.00 9.00 L 18.00 0.00 L 16.00 0.00 Z",
      "province": "REGION_122",
      "rootTerritory": "REGION_122",
      "viewBox": "0 0 136 110",
      "unitSlots": [
        {
          "name": "main",
          "x": 62,
          "y": 82,
          "territory": "REGION_122",
          "arrowReceiver": {
            "x": 62,
            "y": 112
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 62,
          "y": 82,
          "territory": "REGION_122",
          "arrowReceiver": {
            "x": 62,
            "y": 112
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "哥伦比亚省": {
    "territory": "REGION_122",
    "unitSlotName": "main",
    "province": "REGION_122",
    "provinceMapData": {
      "abbr": "GLB",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 63,
          "y": 58,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 136,
      "height": 110,
      "x": 139,
      "y": 254,
      "playable": true,
      "path": "M 10.00 7.00 L 8.00 46.00 L 0.00 61.00 L 0.00 84.00 L 2.00 90.00 L 4.00 90.00 L 6.00 85.00 L 29.00 85.00 L 54.00 98.00 L 79.00 100.00 L 80.00 101.00 L 86.00 101.00 L 90.00 103.00 L 100.00 103.00 L 112.00 110.00 L 135.00 110.00 L 133.00 102.00 L 136.00 97.00 L 136.00 85.00 L 130.00 74.00 L 131.00 67.00 L 110.00 66.00 L 102.00 58.00 L 104.00 40.00 L 99.00 32.00 L 87.00 24.00 L 81.00 23.00 L 55.00 14.00 L 52.00 14.00 L 46.00 11.00 L 25.00 13.00 L 18.00 9.00 L 18.00 0.00 L 16.00 0.00 Z",
      "province": "REGION_122",
      "rootTerritory": "REGION_122",
      "viewBox": "0 0 136 110",
      "unitSlots": [
        {
          "name": "main",
          "x": 62,
          "y": 82,
          "territory": "REGION_122",
          "arrowReceiver": {
            "x": 62,
            "y": 112
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 62,
          "y": 82,
          "territory": "REGION_122",
          "arrowReceiver": {
            "x": 62,
            "y": 112
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_123": {
    "territory": "REGION_123",
    "unitSlotName": "main",
    "province": "REGION_123",
    "provinceMapData": {
      "abbr": "ONT",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 74,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 182,
      "height": 112,
      "x": 423,
      "y": 289,
      "playable": true,
      "path": "M 5.00 61.00 L 0.00 94.00 L 12.00 94.00 L 21.00 101.00 L 35.00 102.00 L 44.00 97.00 L 61.00 96.00 L 65.00 99.00 L 65.00 103.00 L 68.00 103.00 L 75.00 96.00 L 78.00 96.00 L 79.00 97.00 L 105.00 99.00 L 112.00 110.00 L 115.00 111.00 L 122.00 111.00 L 133.00 105.00 L 141.00 105.00 L 151.00 112.00 L 172.00 110.00 L 173.00 109.00 L 175.00 111.00 L 177.00 111.00 L 177.00 108.00 L 179.00 105.00 L 182.00 80.00 L 172.00 80.00 L 168.00 78.00 L 161.00 70.00 L 159.00 62.00 L 149.00 54.00 L 149.00 32.00 L 147.00 29.00 L 124.00 28.00 L 78.00 2.00 L 67.00 2.00 L 64.00 0.00 L 60.00 0.00 Z",
      "province": "REGION_123",
      "rootTerritory": "REGION_123",
      "viewBox": "0 0 182 112",
      "unitSlots": [
        {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        "nc": {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        "sc": {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "安大略": {
    "territory": "REGION_123",
    "unitSlotName": "main",
    "province": "REGION_123",
    "provinceMapData": {
      "abbr": "ONT",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 74,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 182,
      "height": 112,
      "x": 423,
      "y": 289,
      "playable": true,
      "path": "M 5.00 61.00 L 0.00 94.00 L 12.00 94.00 L 21.00 101.00 L 35.00 102.00 L 44.00 97.00 L 61.00 96.00 L 65.00 99.00 L 65.00 103.00 L 68.00 103.00 L 75.00 96.00 L 78.00 96.00 L 79.00 97.00 L 105.00 99.00 L 112.00 110.00 L 115.00 111.00 L 122.00 111.00 L 133.00 105.00 L 141.00 105.00 L 151.00 112.00 L 172.00 110.00 L 173.00 109.00 L 175.00 111.00 L 177.00 111.00 L 177.00 108.00 L 179.00 105.00 L 182.00 80.00 L 172.00 80.00 L 168.00 78.00 L 161.00 70.00 L 159.00 62.00 L 149.00 54.00 L 149.00 32.00 L 147.00 29.00 L 124.00 28.00 L 78.00 2.00 L 67.00 2.00 L 64.00 0.00 L 60.00 0.00 Z",
      "province": "REGION_123",
      "rootTerritory": "REGION_123",
      "viewBox": "0 0 182 112",
      "unitSlots": [
        {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        "nc": {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        "sc": {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_124": {
    "territory": "REGION_124",
    "unitSlotName": "main",
    "province": "REGION_124",
    "provinceMapData": {
      "abbr": "ORE",
      "type": "Coast",
      "centerPos": {
        "x": 62,
        "y": 58
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 79,
          "y": 51,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 165,
      "height": 118,
      "x": 87,
      "y": 338,
      "playable": true,
      "path": "M 0.00 76.00 L 0.00 78.00 L 29.00 79.00 L 36.00 86.00 L 48.00 92.00 L 56.00 92.00 L 60.00 96.00 L 74.00 97.00 L 79.00 100.00 L 89.00 101.00 L 98.00 106.00 L 118.00 109.00 L 138.00 118.00 L 151.00 118.00 L 151.00 115.00 L 148.00 110.00 L 149.00 97.00 L 144.00 92.00 L 141.00 70.00 L 152.00 58.00 L 157.00 48.00 L 154.00 27.00 L 155.00 26.00 L 165.00 26.00 L 165.00 24.00 L 154.00 18.00 L 144.00 18.00 L 140.00 16.00 L 134.00 16.00 L 133.00 15.00 L 108.00 13.00 L 83.00 0.00 L 56.00 0.00 L 52.00 12.00 L 36.00 23.00 L 25.00 46.00 L 15.00 54.00 L 15.00 58.00 Z",
      "province": "REGION_124",
      "rootTerritory": "REGION_124",
      "viewBox": "0 0 165 118",
      "unitSlots": [
        {
          "name": "main",
          "x": 71,
          "y": 76,
          "territory": "REGION_124",
          "arrowReceiver": {
            "x": 71,
            "y": 106
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 71,
          "y": 76,
          "territory": "REGION_124",
          "arrowReceiver": {
            "x": 71,
            "y": 106
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "俄勒冈乡域": {
    "territory": "REGION_124",
    "unitSlotName": "main",
    "province": "REGION_124",
    "provinceMapData": {
      "abbr": "ORE",
      "type": "Coast",
      "centerPos": {
        "x": 62,
        "y": 58
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 79,
          "y": 51,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 165,
      "height": 118,
      "x": 87,
      "y": 338,
      "playable": true,
      "path": "M 0.00 76.00 L 0.00 78.00 L 29.00 79.00 L 36.00 86.00 L 48.00 92.00 L 56.00 92.00 L 60.00 96.00 L 74.00 97.00 L 79.00 100.00 L 89.00 101.00 L 98.00 106.00 L 118.00 109.00 L 138.00 118.00 L 151.00 118.00 L 151.00 115.00 L 148.00 110.00 L 149.00 97.00 L 144.00 92.00 L 141.00 70.00 L 152.00 58.00 L 157.00 48.00 L 154.00 27.00 L 155.00 26.00 L 165.00 26.00 L 165.00 24.00 L 154.00 18.00 L 144.00 18.00 L 140.00 16.00 L 134.00 16.00 L 133.00 15.00 L 108.00 13.00 L 83.00 0.00 L 56.00 0.00 L 52.00 12.00 L 36.00 23.00 L 25.00 46.00 L 15.00 54.00 L 15.00 58.00 Z",
      "province": "REGION_124",
      "rootTerritory": "REGION_124",
      "viewBox": "0 0 165 118",
      "unitSlots": [
        {
          "name": "main",
          "x": 71,
          "y": 76,
          "territory": "REGION_124",
          "arrowReceiver": {
            "x": 71,
            "y": 106
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 71,
          "y": 76,
          "territory": "REGION_124",
          "arrowReceiver": {
            "x": 71,
            "y": 106
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_125": {
    "territory": "REGION_125",
    "unitSlotName": "main",
    "province": "REGION_125",
    "provinceMapData": {
      "abbr": "DAK",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 60,
          "y": 55,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 137,
      "height": 116,
      "x": 227,
      "y": 363,
      "playable": true,
      "path": "M 13.00 0.00 L 16.00 21.00 L 11.00 31.00 L 0.00 43.00 L 3.00 69.00 L 8.00 74.00 L 7.00 87.00 L 10.00 93.00 L 12.00 94.00 L 23.00 94.00 L 31.00 100.00 L 44.00 101.00 L 50.00 106.00 L 72.00 105.00 L 84.00 110.00 L 104.00 110.00 L 116.00 115.00 L 137.00 116.00 L 137.00 114.00 L 133.00 110.00 L 132.00 100.00 L 125.00 92.00 L 126.00 74.00 L 129.00 69.00 L 127.00 54.00 L 113.00 41.00 L 111.00 13.00 L 76.00 9.00 L 71.00 6.00 L 52.00 3.00 L 49.00 0.00 Z",
      "province": "REGION_125",
      "rootTerritory": "REGION_125",
      "viewBox": "0 0 137 116",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 44,
          "territory": "REGION_125",
          "arrowReceiver": {
            "x": 63,
            "y": 74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 44,
          "territory": "REGION_125",
          "arrowReceiver": {
            "x": 63,
            "y": 74
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "达科他": {
    "territory": "REGION_125",
    "unitSlotName": "main",
    "province": "REGION_125",
    "provinceMapData": {
      "abbr": "DAK",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 60,
          "y": 55,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 137,
      "height": 116,
      "x": 227,
      "y": 363,
      "playable": true,
      "path": "M 13.00 0.00 L 16.00 21.00 L 11.00 31.00 L 0.00 43.00 L 3.00 69.00 L 8.00 74.00 L 7.00 87.00 L 10.00 93.00 L 12.00 94.00 L 23.00 94.00 L 31.00 100.00 L 44.00 101.00 L 50.00 106.00 L 72.00 105.00 L 84.00 110.00 L 104.00 110.00 L 116.00 115.00 L 137.00 116.00 L 137.00 114.00 L 133.00 110.00 L 132.00 100.00 L 125.00 92.00 L 126.00 74.00 L 129.00 69.00 L 127.00 54.00 L 113.00 41.00 L 111.00 13.00 L 76.00 9.00 L 71.00 6.00 L 52.00 3.00 L 49.00 0.00 Z",
      "province": "REGION_125",
      "rootTerritory": "REGION_125",
      "viewBox": "0 0 137 116",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 44,
          "territory": "REGION_125",
          "arrowReceiver": {
            "x": 63,
            "y": 74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 44,
          "territory": "REGION_125",
          "arrowReceiver": {
            "x": 63,
            "y": 74
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_126": {
    "territory": "REGION_126",
    "unitSlotName": "main",
    "province": "REGION_126",
    "provinceMapData": {
      "abbr": "IOW",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 42,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 153,
      "height": 132,
      "x": 337,
      "y": 376,
      "playable": true,
      "path": "M 0.00 0.00 L 2.00 30.00 L 16.00 43.00 L 18.00 54.00 L 15.00 59.00 L 14.00 81.00 L 21.00 89.00 L 22.00 99.00 L 26.00 103.00 L 31.00 103.00 L 34.00 105.00 L 40.00 105.00 L 43.00 100.00 L 53.00 99.00 L 63.00 107.00 L 64.00 118.00 L 67.00 126.00 L 98.00 128.00 L 113.00 132.00 L 125.00 119.00 L 125.00 115.00 L 119.00 105.00 L 116.00 89.00 L 89.00 65.00 L 90.00 50.00 L 108.00 40.00 L 115.00 40.00 L 123.00 31.00 L 138.00 25.00 L 145.00 17.00 L 152.00 18.00 L 153.00 17.00 L 152.00 10.00 L 149.00 8.00 L 136.00 8.00 L 135.00 9.00 L 128.00 9.00 L 121.00 13.00 L 109.00 13.00 L 100.00 6.00 L 62.00 6.00 L 59.00 4.00 L 48.00 4.00 L 45.00 2.00 Z",
      "province": "REGION_126",
      "rootTerritory": "REGION_126",
      "viewBox": "0 0 153 132",
      "unitSlots": [
        {
          "name": "main",
          "x": 72,
          "y": 17,
          "territory": "REGION_126",
          "arrowReceiver": {
            "x": 72,
            "y": 47
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 72,
          "y": 17,
          "territory": "REGION_126",
          "arrowReceiver": {
            "x": 72,
            "y": 47
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "爱荷华领地": {
    "territory": "REGION_126",
    "unitSlotName": "main",
    "province": "REGION_126",
    "provinceMapData": {
      "abbr": "IOW",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 42,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 153,
      "height": 132,
      "x": 337,
      "y": 376,
      "playable": true,
      "path": "M 0.00 0.00 L 2.00 30.00 L 16.00 43.00 L 18.00 54.00 L 15.00 59.00 L 14.00 81.00 L 21.00 89.00 L 22.00 99.00 L 26.00 103.00 L 31.00 103.00 L 34.00 105.00 L 40.00 105.00 L 43.00 100.00 L 53.00 99.00 L 63.00 107.00 L 64.00 118.00 L 67.00 126.00 L 98.00 128.00 L 113.00 132.00 L 125.00 119.00 L 125.00 115.00 L 119.00 105.00 L 116.00 89.00 L 89.00 65.00 L 90.00 50.00 L 108.00 40.00 L 115.00 40.00 L 123.00 31.00 L 138.00 25.00 L 145.00 17.00 L 152.00 18.00 L 153.00 17.00 L 152.00 10.00 L 149.00 8.00 L 136.00 8.00 L 135.00 9.00 L 128.00 9.00 L 121.00 13.00 L 109.00 13.00 L 100.00 6.00 L 62.00 6.00 L 59.00 4.00 L 48.00 4.00 L 45.00 2.00 Z",
      "province": "REGION_126",
      "rootTerritory": "REGION_126",
      "viewBox": "0 0 153 132",
      "unitSlots": [
        {
          "name": "main",
          "x": 72,
          "y": 17,
          "territory": "REGION_126",
          "arrowReceiver": {
            "x": 72,
            "y": 47
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 72,
          "y": 17,
          "territory": "REGION_126",
          "arrowReceiver": {
            "x": 72,
            "y": 47
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_127": {
    "territory": "REGION_127",
    "unitSlotName": "main",
    "province": "REGION_127",
    "provinceMapData": {
      "abbr": "TOR",
      "type": "Coast",
      "centerPos": {
        "x": 65,
        "y": 47
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 82,
          "y": 40,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 110,
      "height": 79,
      "x": 542,
      "y": 393,
      "playable": true,
      "path": "M 0.00 6.00 L 0.00 8.00 L 6.00 9.00 L 9.00 14.00 L 9.00 16.00 L 11.00 20.00 L 11.00 31.00 L 12.00 32.00 L 13.00 31.00 L 14.00 32.00 L 32.00 31.00 L 36.00 36.00 L 51.00 37.00 L 59.00 45.00 L 59.00 64.00 L 48.00 74.00 L 49.00 79.00 L 58.00 79.00 L 62.00 74.00 L 82.00 75.00 L 89.00 67.00 L 101.00 61.00 L 101.00 58.00 L 110.00 41.00 L 110.00 24.00 L 100.00 13.00 L 86.00 13.00 L 83.00 16.00 L 63.00 16.00 L 61.00 14.00 L 57.00 4.00 L 34.00 7.00 L 24.00 0.00 L 12.00 0.00 Z",
      "province": "REGION_127",
      "rootTerritory": "REGION_127",
      "viewBox": "0 0 110 79",
      "unitSlots": [
        {
          "name": "main",
          "x": 52,
          "y": 23,
          "territory": "REGION_127",
          "arrowReceiver": {
            "x": 52,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 52,
          "y": 23,
          "territory": "REGION_127",
          "arrowReceiver": {
            "x": 52,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "多伦多": {
    "territory": "REGION_127",
    "unitSlotName": "main",
    "province": "REGION_127",
    "provinceMapData": {
      "abbr": "TOR",
      "type": "Coast",
      "centerPos": {
        "x": 65,
        "y": 47
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 82,
          "y": 40,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 110,
      "height": 79,
      "x": 542,
      "y": 393,
      "playable": true,
      "path": "M 0.00 6.00 L 0.00 8.00 L 6.00 9.00 L 9.00 14.00 L 9.00 16.00 L 11.00 20.00 L 11.00 31.00 L 12.00 32.00 L 13.00 31.00 L 14.00 32.00 L 32.00 31.00 L 36.00 36.00 L 51.00 37.00 L 59.00 45.00 L 59.00 64.00 L 48.00 74.00 L 49.00 79.00 L 58.00 79.00 L 62.00 74.00 L 82.00 75.00 L 89.00 67.00 L 101.00 61.00 L 101.00 58.00 L 110.00 41.00 L 110.00 24.00 L 100.00 13.00 L 86.00 13.00 L 83.00 16.00 L 63.00 16.00 L 61.00 14.00 L 57.00 4.00 L 34.00 7.00 L 24.00 0.00 L 12.00 0.00 Z",
      "province": "REGION_127",
      "rootTerritory": "REGION_127",
      "viewBox": "0 0 110 79",
      "unitSlots": [
        {
          "name": "main",
          "x": 52,
          "y": 23,
          "territory": "REGION_127",
          "arrowReceiver": {
            "x": 52,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 52,
          "y": 23,
          "territory": "REGION_127",
          "arrowReceiver": {
            "x": 52,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_129": {
    "territory": "REGION_129",
    "unitSlotName": "main",
    "province": "REGION_129",
    "provinceMapData": {
      "abbr": "ACA",
      "type": "Coast",
      "centerPos": {
        "x": 15,
        "y": 112
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 105,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 94,
      "height": 173,
      "x": 54,
      "y": 415,
      "playable": true,
      "path": "M 32.00 0.00 L 29.00 2.00 L 16.00 33.00 L 7.00 45.00 L 6.00 54.00 L 2.00 61.00 L 4.00 84.00 L 0.00 91.00 L 0.00 114.00 L 7.00 127.00 L 4.00 146.00 L 8.00 146.00 L 11.00 139.00 L 20.00 139.00 L 26.00 142.00 L 29.00 145.00 L 40.00 163.00 L 40.00 173.00 L 44.00 173.00 L 48.00 168.00 L 73.00 167.00 L 76.00 164.00 L 77.00 161.00 L 78.00 148.00 L 74.00 141.00 L 74.00 136.00 L 72.00 132.00 L 65.00 100.00 L 56.00 82.00 L 55.00 65.00 L 71.00 43.00 L 79.00 24.00 L 88.00 18.00 L 94.00 19.00 L 94.00 16.00 L 91.00 14.00 L 83.00 14.00 L 71.00 8.00 L 64.00 1.00 Z",
      "province": "REGION_129",
      "rootTerritory": "REGION_129",
      "viewBox": "0 0 94 173",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 132,
          "territory": "REGION_129",
          "arrowReceiver": {
            "x": 39,
            "y": 162
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 132,
          "territory": "REGION_129",
          "arrowReceiver": {
            "x": 39,
            "y": 162
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "上加利福尼亚": {
    "territory": "REGION_129",
    "unitSlotName": "main",
    "province": "REGION_129",
    "provinceMapData": {
      "abbr": "ACA",
      "type": "Coast",
      "centerPos": {
        "x": 15,
        "y": 112
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 105,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 94,
      "height": 173,
      "x": 54,
      "y": 415,
      "playable": true,
      "path": "M 32.00 0.00 L 29.00 2.00 L 16.00 33.00 L 7.00 45.00 L 6.00 54.00 L 2.00 61.00 L 4.00 84.00 L 0.00 91.00 L 0.00 114.00 L 7.00 127.00 L 4.00 146.00 L 8.00 146.00 L 11.00 139.00 L 20.00 139.00 L 26.00 142.00 L 29.00 145.00 L 40.00 163.00 L 40.00 173.00 L 44.00 173.00 L 48.00 168.00 L 73.00 167.00 L 76.00 164.00 L 77.00 161.00 L 78.00 148.00 L 74.00 141.00 L 74.00 136.00 L 72.00 132.00 L 65.00 100.00 L 56.00 82.00 L 55.00 65.00 L 71.00 43.00 L 79.00 24.00 L 88.00 18.00 L 94.00 19.00 L 94.00 16.00 L 91.00 14.00 L 83.00 14.00 L 71.00 8.00 L 64.00 1.00 Z",
      "province": "REGION_129",
      "rootTerritory": "REGION_129",
      "viewBox": "0 0 94 173",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 132,
          "territory": "REGION_129",
          "arrowReceiver": {
            "x": 39,
            "y": 162
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 132,
          "territory": "REGION_129",
          "arrowReceiver": {
            "x": 39,
            "y": 162
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_130": {
    "territory": "REGION_130",
    "unitSlotName": "main",
    "province": "REGION_130",
    "provinceMapData": {
      "abbr": "GBD",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 53,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 170,
      "height": 120,
      "x": 108,
      "y": 432,
      "playable": true,
      "path": "M 18.00 120.00 L 20.00 120.00 L 20.00 110.00 L 21.00 109.00 L 41.00 106.00 L 50.00 101.00 L 65.00 102.00 L 70.00 99.00 L 87.00 100.00 L 136.00 75.00 L 151.00 76.00 L 159.00 38.00 L 160.00 37.00 L 170.00 37.00 L 170.00 35.00 L 165.00 31.00 L 152.00 30.00 L 144.00 24.00 L 119.00 23.00 L 99.00 14.00 L 79.00 11.00 L 70.00 6.00 L 60.00 5.00 L 55.00 2.00 L 40.00 1.00 L 39.00 0.00 L 30.00 1.00 L 24.00 5.00 L 16.00 24.00 L 0.00 46.00 L 1.00 67.00 L 10.00 85.00 Z",
      "province": "REGION_130",
      "rootTerritory": "REGION_130",
      "viewBox": "0 0 170 120",
      "unitSlots": [
        {
          "name": "main",
          "x": 79,
          "y": 44,
          "territory": "REGION_130",
          "arrowReceiver": {
            "x": 79,
            "y": 74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 79,
          "y": 44,
          "territory": "REGION_130",
          "arrowReceiver": {
            "x": 79,
            "y": 74
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "大盆地沙漠": {
    "territory": "REGION_130",
    "unitSlotName": "main",
    "province": "REGION_130",
    "provinceMapData": {
      "abbr": "GBD",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 53,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 170,
      "height": 120,
      "x": 108,
      "y": 432,
      "playable": true,
      "path": "M 18.00 120.00 L 20.00 120.00 L 20.00 110.00 L 21.00 109.00 L 41.00 106.00 L 50.00 101.00 L 65.00 102.00 L 70.00 99.00 L 87.00 100.00 L 136.00 75.00 L 151.00 76.00 L 159.00 38.00 L 160.00 37.00 L 170.00 37.00 L 170.00 35.00 L 165.00 31.00 L 152.00 30.00 L 144.00 24.00 L 119.00 23.00 L 99.00 14.00 L 79.00 11.00 L 70.00 6.00 L 60.00 5.00 L 55.00 2.00 L 40.00 1.00 L 39.00 0.00 L 30.00 1.00 L 24.00 5.00 L 16.00 24.00 L 0.00 46.00 L 1.00 67.00 L 10.00 85.00 Z",
      "province": "REGION_130",
      "rootTerritory": "REGION_130",
      "viewBox": "0 0 170 120",
      "unitSlots": [
        {
          "name": "main",
          "x": 79,
          "y": 44,
          "territory": "REGION_130",
          "arrowReceiver": {
            "x": 79,
            "y": 74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 79,
          "y": 44,
          "territory": "REGION_130",
          "arrowReceiver": {
            "x": 79,
            "y": 74
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_131": {
    "territory": "REGION_131",
    "unitSlotName": "main",
    "province": "REGION_131",
    "provinceMapData": {
      "abbr": "MIC",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 12,
          "y": 20,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 26,
      "height": 43,
      "x": 524,
      "y": 447,
      "playable": true,
      "path": "M 21.00 0.00 L 19.00 0.00 L 2.00 14.00 L 2.00 36.00 L 0.00 41.00 L 21.00 43.00 L 21.00 41.00 L 26.00 33.00 L 26.00 31.00 L 22.00 29.00 L 23.00 11.00 L 25.00 8.00 L 25.00 3.00 Z",
      "province": "REGION_131",
      "rootTerritory": "REGION_131",
      "viewBox": "0 0 26 43",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 39,
          "territory": "REGION_131",
          "arrowReceiver": {
            "x": 24,
            "y": 69
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 39,
          "territory": "REGION_131",
          "arrowReceiver": {
            "x": 24,
            "y": 69
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "密歇根": {
    "territory": "REGION_131",
    "unitSlotName": "main",
    "province": "REGION_131",
    "provinceMapData": {
      "abbr": "MIC",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 12,
          "y": 20,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 26,
      "height": 43,
      "x": 524,
      "y": 447,
      "playable": true,
      "path": "M 21.00 0.00 L 19.00 0.00 L 2.00 14.00 L 2.00 36.00 L 0.00 41.00 L 21.00 43.00 L 21.00 41.00 L 26.00 33.00 L 26.00 31.00 L 22.00 29.00 L 23.00 11.00 L 25.00 8.00 L 25.00 3.00 Z",
      "province": "REGION_131",
      "rootTerritory": "REGION_131",
      "viewBox": "0 0 26 43",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 39,
          "territory": "REGION_131",
          "arrowReceiver": {
            "x": 24,
            "y": 69
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 39,
          "territory": "REGION_131",
          "arrowReceiver": {
            "x": 24,
            "y": 69
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_132": {
    "territory": "REGION_132",
    "unitSlotName": "main",
    "province": "REGION_132",
    "provinceMapData": {
      "abbr": "MIS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 140,
          "y": 86,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 208,
      "height": 160,
      "x": 258,
      "y": 467,
      "playable": true,
      "path": "M 8.00 1.00 L 0.00 41.00 L 11.00 41.00 L 26.00 58.00 L 33.00 61.00 L 34.00 63.00 L 57.00 65.00 L 75.00 76.00 L 85.00 78.00 L 88.00 80.00 L 84.00 112.00 L 80.00 119.00 L 80.00 131.00 L 106.00 132.00 L 117.00 138.00 L 130.00 137.00 L 147.00 147.00 L 146.00 156.00 L 148.00 157.00 L 157.00 157.00 L 162.00 160.00 L 178.00 159.00 L 179.00 148.00 L 182.00 142.00 L 199.00 126.00 L 208.00 107.00 L 208.00 103.00 L 199.00 88.00 L 199.00 78.00 L 193.00 74.00 L 193.00 67.00 L 189.00 63.00 L 189.00 44.00 L 191.00 42.00 L 191.00 39.00 L 179.00 36.00 L 148.00 34.00 L 145.00 29.00 L 143.00 14.00 L 134.00 7.00 L 120.00 8.00 L 118.00 12.00 L 115.00 13.00 L 112.00 11.00 L 87.00 10.00 L 75.00 5.00 L 55.00 5.00 L 43.00 0.00 Z",
      "province": "REGION_132",
      "rootTerritory": "REGION_132",
      "viewBox": "0 0 208 160",
      "unitSlots": [
        {
          "name": "main",
          "x": 95,
          "y": 42,
          "territory": "REGION_132",
          "arrowReceiver": {
            "x": 95,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 95,
          "y": 42,
          "territory": "REGION_132",
          "arrowReceiver": {
            "x": 95,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "密苏里": {
    "territory": "REGION_132",
    "unitSlotName": "main",
    "province": "REGION_132",
    "provinceMapData": {
      "abbr": "MIS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 140,
          "y": 86,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 208,
      "height": 160,
      "x": 258,
      "y": 467,
      "playable": true,
      "path": "M 8.00 1.00 L 0.00 41.00 L 11.00 41.00 L 26.00 58.00 L 33.00 61.00 L 34.00 63.00 L 57.00 65.00 L 75.00 76.00 L 85.00 78.00 L 88.00 80.00 L 84.00 112.00 L 80.00 119.00 L 80.00 131.00 L 106.00 132.00 L 117.00 138.00 L 130.00 137.00 L 147.00 147.00 L 146.00 156.00 L 148.00 157.00 L 157.00 157.00 L 162.00 160.00 L 178.00 159.00 L 179.00 148.00 L 182.00 142.00 L 199.00 126.00 L 208.00 107.00 L 208.00 103.00 L 199.00 88.00 L 199.00 78.00 L 193.00 74.00 L 193.00 67.00 L 189.00 63.00 L 189.00 44.00 L 191.00 42.00 L 191.00 39.00 L 179.00 36.00 L 148.00 34.00 L 145.00 29.00 L 143.00 14.00 L 134.00 7.00 L 120.00 8.00 L 118.00 12.00 L 115.00 13.00 L 112.00 11.00 L 87.00 10.00 L 75.00 5.00 L 55.00 5.00 L 43.00 0.00 Z",
      "province": "REGION_132",
      "rootTerritory": "REGION_132",
      "viewBox": "0 0 208 160",
      "unitSlots": [
        {
          "name": "main",
          "x": 95,
          "y": 42,
          "territory": "REGION_132",
          "arrowReceiver": {
            "x": 95,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 95,
          "y": 42,
          "territory": "REGION_132",
          "arrowReceiver": {
            "x": 95,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_134": {
    "territory": "REGION_134",
    "unitSlotName": "main",
    "province": "REGION_134",
    "provinceMapData": {
      "abbr": "APA",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 71,
          "y": 65,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 166,
      "height": 121,
      "x": 127,
      "y": 506,
      "playable": true,
      "path": "M 166.00 21.00 L 159.00 18.00 L 144.00 1.00 L 115.00 0.00 L 66.00 25.00 L 49.00 24.00 L 44.00 27.00 L 29.00 26.00 L 20.00 31.00 L 0.00 34.00 L 0.00 52.00 L 4.00 59.00 L 2.00 72.00 L 14.00 71.00 L 18.00 76.00 L 29.00 78.00 L 30.00 79.00 L 31.00 91.00 L 34.00 90.00 L 40.00 97.00 L 46.00 97.00 L 49.00 101.00 L 50.00 110.00 L 65.00 113.00 L 73.00 117.00 L 85.00 117.00 L 90.00 120.00 L 103.00 121.00 L 104.00 112.00 L 111.00 106.00 L 112.00 62.00 L 132.00 37.00 L 160.00 23.00 L 166.00 24.00 Z",
      "province": "REGION_134",
      "rootTerritory": "REGION_134",
      "viewBox": "0 0 166 121",
      "unitSlots": [
        {
          "name": "main",
          "x": 70,
          "y": 33,
          "territory": "REGION_134",
          "arrowReceiver": {
            "x": 70,
            "y": 63
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 70,
          "y": 33,
          "territory": "REGION_134",
          "arrowReceiver": {
            "x": 70,
            "y": 63
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿帕奇里亚": {
    "territory": "REGION_134",
    "unitSlotName": "main",
    "province": "REGION_134",
    "provinceMapData": {
      "abbr": "APA",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 71,
          "y": 65,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 166,
      "height": 121,
      "x": 127,
      "y": 506,
      "playable": true,
      "path": "M 166.00 21.00 L 159.00 18.00 L 144.00 1.00 L 115.00 0.00 L 66.00 25.00 L 49.00 24.00 L 44.00 27.00 L 29.00 26.00 L 20.00 31.00 L 0.00 34.00 L 0.00 52.00 L 4.00 59.00 L 2.00 72.00 L 14.00 71.00 L 18.00 76.00 L 29.00 78.00 L 30.00 79.00 L 31.00 91.00 L 34.00 90.00 L 40.00 97.00 L 46.00 97.00 L 49.00 101.00 L 50.00 110.00 L 65.00 113.00 L 73.00 117.00 L 85.00 117.00 L 90.00 120.00 L 103.00 121.00 L 104.00 112.00 L 111.00 106.00 L 112.00 62.00 L 132.00 37.00 L 160.00 23.00 L 166.00 24.00 Z",
      "province": "REGION_134",
      "rootTerritory": "REGION_134",
      "viewBox": "0 0 166 121",
      "unitSlots": [
        {
          "name": "main",
          "x": 70,
          "y": 33,
          "territory": "REGION_134",
          "arrowReceiver": {
            "x": 70,
            "y": 63
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 70,
          "y": 33,
          "territory": "REGION_134",
          "arrowReceiver": {
            "x": 70,
            "y": 63
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_135": {
    "territory": "REGION_135",
    "unitSlotName": "main",
    "province": "REGION_135",
    "provinceMapData": {
      "abbr": "TEX",
      "type": "Coast",
      "centerPos": {
        "x": 73,
        "y": 127
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 90,
          "y": 120,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 177,
      "height": 209,
      "x": 229,
      "y": 528,
      "playable": true,
      "path": "M 56.00 0.00 L 28.00 14.00 L 9.00 38.00 L 8.00 82.00 L 0.00 90.00 L 0.00 115.00 L 4.00 122.00 L 2.00 145.00 L 10.00 149.00 L 21.00 149.00 L 34.00 139.00 L 36.00 140.00 L 60.00 178.00 L 62.00 198.00 L 84.00 209.00 L 99.00 209.00 L 101.00 188.00 L 112.00 171.00 L 129.00 167.00 L 146.00 155.00 L 159.00 153.00 L 158.00 145.00 L 162.00 142.00 L 167.00 132.00 L 166.00 124.00 L 163.00 119.00 L 163.00 103.00 L 168.00 95.00 L 176.00 95.00 L 177.00 84.00 L 161.00 75.00 L 148.00 76.00 L 137.00 70.00 L 111.00 69.00 L 110.00 68.00 L 110.00 60.00 L 114.00 53.00 L 118.00 17.00 L 106.00 14.00 L 88.00 3.00 Z",
      "province": "REGION_135",
      "rootTerritory": "REGION_135",
      "viewBox": "0 0 177 209",
      "unitSlots": [
        {
          "name": "main",
          "x": 83,
          "y": 87,
          "territory": "REGION_135",
          "arrowReceiver": {
            "x": 83,
            "y": 117
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 83,
          "y": 87,
          "territory": "REGION_135",
          "arrowReceiver": {
            "x": 83,
            "y": 117
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "德克萨斯": {
    "territory": "REGION_135",
    "unitSlotName": "main",
    "province": "REGION_135",
    "provinceMapData": {
      "abbr": "TEX",
      "type": "Coast",
      "centerPos": {
        "x": 73,
        "y": 127
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 90,
          "y": 120,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 177,
      "height": 209,
      "x": 229,
      "y": 528,
      "playable": true,
      "path": "M 56.00 0.00 L 28.00 14.00 L 9.00 38.00 L 8.00 82.00 L 0.00 90.00 L 0.00 115.00 L 4.00 122.00 L 2.00 145.00 L 10.00 149.00 L 21.00 149.00 L 34.00 139.00 L 36.00 140.00 L 60.00 178.00 L 62.00 198.00 L 84.00 209.00 L 99.00 209.00 L 101.00 188.00 L 112.00 171.00 L 129.00 167.00 L 146.00 155.00 L 159.00 153.00 L 158.00 145.00 L 162.00 142.00 L 167.00 132.00 L 166.00 124.00 L 163.00 119.00 L 163.00 103.00 L 168.00 95.00 L 176.00 95.00 L 177.00 84.00 L 161.00 75.00 L 148.00 76.00 L 137.00 70.00 L 111.00 69.00 L 110.00 68.00 L 110.00 60.00 L 114.00 53.00 L 118.00 17.00 L 106.00 14.00 L 88.00 3.00 Z",
      "province": "REGION_135",
      "rootTerritory": "REGION_135",
      "viewBox": "0 0 177 209",
      "unitSlots": [
        {
          "name": "main",
          "x": 83,
          "y": 87,
          "territory": "REGION_135",
          "arrowReceiver": {
            "x": 83,
            "y": 117
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 83,
          "y": 87,
          "territory": "REGION_135",
          "arrowReceiver": {
            "x": 83,
            "y": 117
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_139": {
    "territory": "REGION_139",
    "unitSlotName": "main",
    "province": "REGION_139",
    "provinceMapData": {
      "abbr": "YUC",
      "type": "Coast",
      "centerPos": {
        "x": 53,
        "y": 13
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 30,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 85,
      "height": 67,
      "x": 391,
      "y": 805,
      "playable": true,
      "path": "M 85.00 7.00 L 72.00 0.00 L 53.00 0.00 L 50.00 3.00 L 18.00 9.00 L 12.00 37.00 L 1.00 46.00 L 0.00 55.00 L 9.00 56.00 L 14.00 62.00 L 20.00 65.00 L 37.00 65.00 L 46.00 55.00 L 60.00 55.00 L 63.00 58.00 L 63.00 67.00 L 70.00 67.00 L 73.00 61.00 L 73.00 41.00 L 83.00 27.00 Z",
      "province": "REGION_139",
      "rootTerritory": "REGION_139",
      "viewBox": "0 0 85 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 32,
          "y": 47,
          "territory": "REGION_139",
          "arrowReceiver": {
            "x": 32,
            "y": 77
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 32,
          "y": 47,
          "territory": "REGION_139",
          "arrowReceiver": {
            "x": 32,
            "y": 77
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "尤卡坦": {
    "territory": "REGION_139",
    "unitSlotName": "main",
    "province": "REGION_139",
    "provinceMapData": {
      "abbr": "YUC",
      "type": "Coast",
      "centerPos": {
        "x": 53,
        "y": 13
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 30,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 85,
      "height": 67,
      "x": 391,
      "y": 805,
      "playable": true,
      "path": "M 85.00 7.00 L 72.00 0.00 L 53.00 0.00 L 50.00 3.00 L 18.00 9.00 L 12.00 37.00 L 1.00 46.00 L 0.00 55.00 L 9.00 56.00 L 14.00 62.00 L 20.00 65.00 L 37.00 65.00 L 46.00 55.00 L 60.00 55.00 L 63.00 58.00 L 63.00 67.00 L 70.00 67.00 L 73.00 61.00 L 73.00 41.00 L 83.00 27.00 Z",
      "province": "REGION_139",
      "rootTerritory": "REGION_139",
      "viewBox": "0 0 85 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 32,
          "y": 47,
          "territory": "REGION_139",
          "arrowReceiver": {
            "x": 32,
            "y": 77
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 32,
          "y": 47,
          "territory": "REGION_139",
          "arrowReceiver": {
            "x": 32,
            "y": 77
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_140": {
    "territory": "REGION_140",
    "unitSlotName": "main",
    "province": "REGION_140",
    "provinceMapData": {
      "abbr": "STD",
      "type": "Coast",
      "centerPos": {
        "x": 29,
        "y": 9
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20,
          "y": 26,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 54,
      "height": 51,
      "x": 763,
      "y": 810,
      "playable": true,
      "path": "M 2.00 13.00 L 2.00 45.00 L 0.00 48.00 L 0.00 51.00 L 10.00 50.00 L 23.00 43.00 L 39.00 45.00 L 45.00 38.00 L 54.00 35.00 L 54.00 31.00 L 51.00 29.00 L 52.00 21.00 L 46.00 15.00 L 35.00 13.00 L 25.00 2.00 L 21.00 0.00 L 13.00 0.00 L 13.00 9.00 L 12.00 10.00 L 7.00 10.00 Z",
      "province": "REGION_140",
      "rootTerritory": "REGION_140",
      "viewBox": "0 0 54 51",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 23,
          "territory": "REGION_140",
          "arrowReceiver": {
            "x": 27,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 23,
          "territory": "REGION_140",
          "arrowReceiver": {
            "x": 27,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "圣多明各": {
    "territory": "REGION_140",
    "unitSlotName": "main",
    "province": "REGION_140",
    "provinceMapData": {
      "abbr": "STD",
      "type": "Coast",
      "centerPos": {
        "x": 29,
        "y": 9
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20,
          "y": 26,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 54,
      "height": 51,
      "x": 763,
      "y": 810,
      "playable": true,
      "path": "M 2.00 13.00 L 2.00 45.00 L 0.00 48.00 L 0.00 51.00 L 10.00 50.00 L 23.00 43.00 L 39.00 45.00 L 45.00 38.00 L 54.00 35.00 L 54.00 31.00 L 51.00 29.00 L 52.00 21.00 L 46.00 15.00 L 35.00 13.00 L 25.00 2.00 L 21.00 0.00 L 13.00 0.00 L 13.00 9.00 L 12.00 10.00 L 7.00 10.00 Z",
      "province": "REGION_140",
      "rootTerritory": "REGION_140",
      "viewBox": "0 0 54 51",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 23,
          "territory": "REGION_140",
          "arrowReceiver": {
            "x": 27,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 23,
          "territory": "REGION_140",
          "arrowReceiver": {
            "x": 27,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_144": {
    "territory": "REGION_144",
    "unitSlotName": "main",
    "province": "REGION_144",
    "provinceMapData": {
      "abbr": "HON",
      "type": "Coast",
      "centerPos": {
        "x": -10,
        "y": 24
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 67,
      "x": 461,
      "y": 923,
      "playable": true,
      "path": "M 68.00 0.00 L 65.00 0.00 L 64.00 8.00 L 61.00 11.00 L 52.00 12.00 L 45.00 10.00 L 38.00 10.00 L 28.00 22.00 L 14.00 23.00 L 11.00 28.00 L 5.00 33.00 L 5.00 35.00 L 0.00 40.00 L 1.00 44.00 L 12.00 55.00 L 24.00 60.00 L 28.00 60.00 L 41.00 67.00 L 44.00 67.00 L 44.00 53.00 L 51.00 46.00 L 50.00 31.00 L 56.00 24.00 L 60.00 17.00 L 69.00 17.00 L 69.00 2.00 Z",
      "province": "REGION_144",
      "rootTerritory": "REGION_144",
      "viewBox": "0 0 69 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        "nc": {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        "sc": {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "尼加拉瓜": {
    "territory": "REGION_144",
    "unitSlotName": "main",
    "province": "REGION_144",
    "provinceMapData": {
      "abbr": "HON",
      "type": "Coast",
      "centerPos": {
        "x": -10,
        "y": 24
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 67,
      "x": 461,
      "y": 923,
      "playable": true,
      "path": "M 68.00 0.00 L 65.00 0.00 L 64.00 8.00 L 61.00 11.00 L 52.00 12.00 L 45.00 10.00 L 38.00 10.00 L 28.00 22.00 L 14.00 23.00 L 11.00 28.00 L 5.00 33.00 L 5.00 35.00 L 0.00 40.00 L 1.00 44.00 L 12.00 55.00 L 24.00 60.00 L 28.00 60.00 L 41.00 67.00 L 44.00 67.00 L 44.00 53.00 L 51.00 46.00 L 50.00 31.00 L 56.00 24.00 L 60.00 17.00 L 69.00 17.00 L 69.00 2.00 Z",
      "province": "REGION_144",
      "rootTerritory": "REGION_144",
      "viewBox": "0 0 69 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        "nc": {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        "sc": {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_145": {
    "territory": "REGION_145",
    "unitSlotName": "main",
    "province": "REGION_145",
    "provinceMapData": {
      "abbr": "GEO",
      "type": "Coast",
      "centerPos": {
        "x": 17,
        "y": 44
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34,
          "y": 37,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 68,
      "height": 115,
      "x": 890,
      "y": 1027,
      "playable": true,
      "path": "M 21.00 0.00 L 21.00 12.00 L 12.00 22.00 L 12.00 32.00 L 5.00 38.00 L 0.00 40.00 L 0.00 42.00 L 6.00 49.00 L 7.00 52.00 L 14.00 52.00 L 19.00 56.00 L 20.00 64.00 L 29.00 72.00 L 29.00 82.00 L 21.00 97.00 L 21.00 103.00 L 27.00 112.00 L 35.00 115.00 L 41.00 109.00 L 51.00 104.00 L 60.00 103.00 L 60.00 101.00 L 43.00 78.00 L 42.00 75.00 L 45.00 59.00 L 54.00 50.00 L 59.00 39.00 L 66.00 39.00 L 68.00 38.00 L 68.00 36.00 L 33.00 1.00 Z",
      "province": "REGION_145",
      "rootTerritory": "REGION_145",
      "viewBox": "0 0 68 115",
      "unitSlots": [
        {
          "name": "main",
          "x": 34,
          "y": 37,
          "territory": "REGION_145",
          "arrowReceiver": {
            "x": 34,
            "y": 67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34,
          "y": 37,
          "territory": "REGION_145",
          "arrowReceiver": {
            "x": 34,
            "y": 67
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "乔治敦": {
    "territory": "REGION_145",
    "unitSlotName": "main",
    "province": "REGION_145",
    "provinceMapData": {
      "abbr": "GEO",
      "type": "Coast",
      "centerPos": {
        "x": 17,
        "y": 44
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34,
          "y": 37,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 68,
      "height": 115,
      "x": 890,
      "y": 1027,
      "playable": true,
      "path": "M 21.00 0.00 L 21.00 12.00 L 12.00 22.00 L 12.00 32.00 L 5.00 38.00 L 0.00 40.00 L 0.00 42.00 L 6.00 49.00 L 7.00 52.00 L 14.00 52.00 L 19.00 56.00 L 20.00 64.00 L 29.00 72.00 L 29.00 82.00 L 21.00 97.00 L 21.00 103.00 L 27.00 112.00 L 35.00 115.00 L 41.00 109.00 L 51.00 104.00 L 60.00 103.00 L 60.00 101.00 L 43.00 78.00 L 42.00 75.00 L 45.00 59.00 L 54.00 50.00 L 59.00 39.00 L 66.00 39.00 L 68.00 38.00 L 68.00 36.00 L 33.00 1.00 Z",
      "province": "REGION_145",
      "rootTerritory": "REGION_145",
      "viewBox": "0 0 68 115",
      "unitSlots": [
        {
          "name": "main",
          "x": 34,
          "y": 37,
          "territory": "REGION_145",
          "arrowReceiver": {
            "x": 34,
            "y": 67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34,
          "y": 37,
          "territory": "REGION_145",
          "arrowReceiver": {
            "x": 34,
            "y": 67
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_147": {
    "territory": "REGION_147",
    "unitSlotName": "main",
    "province": "REGION_147",
    "provinceMapData": {
      "abbr": "SUR",
      "type": "Coast",
      "centerPos": {
        "x": 15,
        "y": 38
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 31,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 65,
      "height": 68,
      "x": 931,
      "y": 1062,
      "playable": true,
      "path": "M 62.00 0.00 L 16.00 3.00 L 12.00 13.00 L 3.00 22.00 L 0.00 43.00 L 18.00 68.00 L 30.00 67.00 L 41.00 56.00 L 60.00 55.00 L 60.00 53.00 L 65.00 45.00 L 65.00 41.00 L 59.00 30.00 Z",
      "province": "REGION_147",
      "rootTerritory": "REGION_147",
      "viewBox": "0 0 65 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 31,
          "y": 30,
          "territory": "REGION_147",
          "arrowReceiver": {
            "x": 31,
            "y": 60
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 31,
          "y": 30,
          "territory": "REGION_147",
          "arrowReceiver": {
            "x": 31,
            "y": 60
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "苏里南": {
    "territory": "REGION_147",
    "unitSlotName": "main",
    "province": "REGION_147",
    "provinceMapData": {
      "abbr": "SUR",
      "type": "Coast",
      "centerPos": {
        "x": 15,
        "y": 38
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 31,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 65,
      "height": 68,
      "x": 931,
      "y": 1062,
      "playable": true,
      "path": "M 62.00 0.00 L 16.00 3.00 L 12.00 13.00 L 3.00 22.00 L 0.00 43.00 L 18.00 68.00 L 30.00 67.00 L 41.00 56.00 L 60.00 55.00 L 60.00 53.00 L 65.00 45.00 L 65.00 41.00 L 59.00 30.00 Z",
      "province": "REGION_147",
      "rootTerritory": "REGION_147",
      "viewBox": "0 0 65 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 31,
          "y": 30,
          "territory": "REGION_147",
          "arrowReceiver": {
            "x": 31,
            "y": 60
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 31,
          "y": 30,
          "territory": "REGION_147",
          "arrowReceiver": {
            "x": 31,
            "y": 60
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_148": {
    "territory": "REGION_148",
    "unitSlotName": "main",
    "province": "REGION_148",
    "provinceMapData": {
      "abbr": "CAY",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21,
          "y": 21,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 55,
      "height": 58,
      "x": 989,
      "y": 1062,
      "playable": true,
      "path": "M 3.00 0.00 L 0.00 32.00 L 6.00 43.00 L 1.00 51.00 L 1.00 55.00 L 3.00 55.00 L 7.00 58.00 L 25.00 57.00 L 31.00 49.00 L 39.00 31.00 L 44.00 26.00 L 55.00 26.00 L 55.00 21.00 L 41.00 8.00 L 31.00 1.00 Z",
      "province": "REGION_148",
      "rootTerritory": "REGION_148",
      "viewBox": "0 0 55 58",
      "unitSlots": [
        {
          "name": "main",
          "x": 23,
          "y": 21,
          "territory": "REGION_148",
          "arrowReceiver": {
            "x": 23,
            "y": 51
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 23,
          "y": 21,
          "territory": "REGION_148",
          "arrowReceiver": {
            "x": 23,
            "y": 51
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡宴": {
    "territory": "REGION_148",
    "unitSlotName": "main",
    "province": "REGION_148",
    "provinceMapData": {
      "abbr": "CAY",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 21,
          "y": 21,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 55,
      "height": 58,
      "x": 989,
      "y": 1062,
      "playable": true,
      "path": "M 3.00 0.00 L 0.00 32.00 L 6.00 43.00 L 1.00 51.00 L 1.00 55.00 L 3.00 55.00 L 7.00 58.00 L 25.00 57.00 L 31.00 49.00 L 39.00 31.00 L 44.00 26.00 L 55.00 26.00 L 55.00 21.00 L 41.00 8.00 L 31.00 1.00 Z",
      "province": "REGION_148",
      "rootTerritory": "REGION_148",
      "viewBox": "0 0 55 58",
      "unitSlots": [
        {
          "name": "main",
          "x": 23,
          "y": 21,
          "territory": "REGION_148",
          "arrowReceiver": {
            "x": 23,
            "y": 51
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 23,
          "y": 21,
          "territory": "REGION_148",
          "arrowReceiver": {
            "x": 23,
            "y": 51
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_151": {
    "territory": "REGION_151",
    "unitSlotName": "main",
    "province": "REGION_151",
    "provinceMapData": {
      "abbr": "ECU",
      "type": "Coast",
      "centerPos": {
        "x": 13,
        "y": 46
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 30,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 89,
      "height": 82,
      "x": 545,
      "y": 1165,
      "playable": true,
      "path": "M 46.00 0.00 L 42.00 0.00 L 39.00 2.00 L 32.00 2.00 L 25.00 12.00 L 10.00 11.00 L 9.00 16.00 L 0.00 24.00 L 0.00 56.00 L 10.00 63.00 L 11.00 66.00 L 22.00 66.00 L 23.00 67.00 L 22.00 77.00 L 31.00 82.00 L 33.00 82.00 L 36.00 79.00 L 42.00 66.00 L 44.00 64.00 L 46.00 64.00 L 47.00 62.00 L 72.00 50.00 L 89.00 35.00 L 89.00 33.00 L 79.00 32.00 L 69.00 27.00 L 64.00 22.00 L 63.00 10.00 Z",
      "province": "REGION_151",
      "rootTerritory": "REGION_151",
      "viewBox": "0 0 89 82",
      "unitSlots": [
        {
          "name": "main",
          "x": 46,
          "y": 40,
          "territory": "REGION_151",
          "arrowReceiver": {
            "x": 46,
            "y": 70
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 46,
          "y": 40,
          "territory": "REGION_151",
          "arrowReceiver": {
            "x": 46,
            "y": 70
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "厄瓜多尔": {
    "territory": "REGION_151",
    "unitSlotName": "main",
    "province": "REGION_151",
    "provinceMapData": {
      "abbr": "ECU",
      "type": "Coast",
      "centerPos": {
        "x": 13,
        "y": 46
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 30,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 89,
      "height": 82,
      "x": 545,
      "y": 1165,
      "playable": true,
      "path": "M 46.00 0.00 L 42.00 0.00 L 39.00 2.00 L 32.00 2.00 L 25.00 12.00 L 10.00 11.00 L 9.00 16.00 L 0.00 24.00 L 0.00 56.00 L 10.00 63.00 L 11.00 66.00 L 22.00 66.00 L 23.00 67.00 L 22.00 77.00 L 31.00 82.00 L 33.00 82.00 L 36.00 79.00 L 42.00 66.00 L 44.00 64.00 L 46.00 64.00 L 47.00 62.00 L 72.00 50.00 L 89.00 35.00 L 89.00 33.00 L 79.00 32.00 L 69.00 27.00 L 64.00 22.00 L 63.00 10.00 Z",
      "province": "REGION_151",
      "rootTerritory": "REGION_151",
      "viewBox": "0 0 89 82",
      "unitSlots": [
        {
          "name": "main",
          "x": 46,
          "y": 40,
          "territory": "REGION_151",
          "arrowReceiver": {
            "x": 46,
            "y": 70
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 46,
          "y": 40,
          "territory": "REGION_151",
          "arrowReceiver": {
            "x": 46,
            "y": 70
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_154": {
    "territory": "REGION_154",
    "unitSlotName": "main",
    "province": "REGION_154",
    "provinceMapData": {
      "abbr": "ACR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 64,
          "y": 38,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 98,
      "height": 55,
      "x": 675,
      "y": 1295,
      "playable": true,
      "path": "M 0.00 4.00 L 0.00 6.00 L 6.00 13.00 L 10.00 21.00 L 11.00 27.00 L 20.00 30.00 L 25.00 37.00 L 30.00 38.00 L 33.00 33.00 L 48.00 33.00 L 49.00 34.00 L 49.00 48.00 L 52.00 53.00 L 66.00 53.00 L 68.00 55.00 L 75.00 54.00 L 81.00 51.00 L 98.00 38.00 L 98.00 36.00 L 94.00 36.00 L 52.00 14.00 L 38.00 12.00 L 27.00 6.00 L 17.00 5.00 L 8.00 0.00 L 3.00 0.00 Z",
      "province": "REGION_154",
      "rootTerritory": "REGION_154",
      "viewBox": "0 0 98 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 38,
          "territory": "REGION_154",
          "arrowReceiver": {
            "x": 63,
            "y": 68
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 38,
          "territory": "REGION_154",
          "arrowReceiver": {
            "x": 63,
            "y": 68
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿克里": {
    "territory": "REGION_154",
    "unitSlotName": "main",
    "province": "REGION_154",
    "provinceMapData": {
      "abbr": "ACR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 64,
          "y": 38,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 98,
      "height": 55,
      "x": 675,
      "y": 1295,
      "playable": true,
      "path": "M 0.00 4.00 L 0.00 6.00 L 6.00 13.00 L 10.00 21.00 L 11.00 27.00 L 20.00 30.00 L 25.00 37.00 L 30.00 38.00 L 33.00 33.00 L 48.00 33.00 L 49.00 34.00 L 49.00 48.00 L 52.00 53.00 L 66.00 53.00 L 68.00 55.00 L 75.00 54.00 L 81.00 51.00 L 98.00 38.00 L 98.00 36.00 L 94.00 36.00 L 52.00 14.00 L 38.00 12.00 L 27.00 6.00 L 17.00 5.00 L 8.00 0.00 L 3.00 0.00 Z",
      "province": "REGION_154",
      "rootTerritory": "REGION_154",
      "viewBox": "0 0 98 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 38,
          "territory": "REGION_154",
          "arrowReceiver": {
            "x": 63,
            "y": 68
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 38,
          "territory": "REGION_154",
          "arrowReceiver": {
            "x": 63,
            "y": 68
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_155": {
    "territory": "REGION_155",
    "unitSlotName": "main",
    "province": "REGION_155",
    "provinceMapData": {
      "abbr": "BNI",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 38,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 98,
      "height": 77,
      "x": 744,
      "y": 1332,
      "playable": true,
      "path": "M 0.00 17.00 L 0.00 21.00 L 8.00 36.00 L 7.00 56.00 L 46.00 77.00 L 51.00 76.00 L 60.00 69.00 L 65.00 61.00 L 74.00 57.00 L 74.00 51.00 L 73.00 50.00 L 74.00 46.00 L 88.00 39.00 L 98.00 39.00 L 98.00 37.00 L 79.00 33.00 L 66.00 20.00 L 66.00 4.00 L 36.00 6.00 L 30.00 0.00 L 27.00 0.00 L 7.00 15.00 Z",
      "province": "REGION_155",
      "rootTerritory": "REGION_155",
      "viewBox": "0 0 98 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 52,
          "y": 43,
          "territory": "REGION_155",
          "arrowReceiver": {
            "x": 52,
            "y": 73
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 52,
          "y": 43,
          "territory": "REGION_155",
          "arrowReceiver": {
            "x": 52,
            "y": 73
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "贝尼": {
    "territory": "REGION_155",
    "unitSlotName": "main",
    "province": "REGION_155",
    "provinceMapData": {
      "abbr": "BNI",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 38,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 98,
      "height": 77,
      "x": 744,
      "y": 1332,
      "playable": true,
      "path": "M 0.00 17.00 L 0.00 21.00 L 8.00 36.00 L 7.00 56.00 L 46.00 77.00 L 51.00 76.00 L 60.00 69.00 L 65.00 61.00 L 74.00 57.00 L 74.00 51.00 L 73.00 50.00 L 74.00 46.00 L 88.00 39.00 L 98.00 39.00 L 98.00 37.00 L 79.00 33.00 L 66.00 20.00 L 66.00 4.00 L 36.00 6.00 L 30.00 0.00 L 27.00 0.00 L 7.00 15.00 Z",
      "province": "REGION_155",
      "rootTerritory": "REGION_155",
      "viewBox": "0 0 98 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 52,
          "y": 43,
          "territory": "REGION_155",
          "arrowReceiver": {
            "x": 52,
            "y": 73
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 52,
          "y": 43,
          "territory": "REGION_155",
          "arrowReceiver": {
            "x": 52,
            "y": 73
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_156": {
    "territory": "REGION_156",
    "unitSlotName": "main",
    "province": "REGION_156",
    "provinceMapData": {
      "abbr": "STC",
      "type": "Land",
      "centerPos": {
        "x": 33,
        "y": 54
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 50,
          "y": 47,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 127,
      "height": 111,
      "x": 792,
      "y": 1370,
      "playable": true,
      "path": "M 24.00 7.00 L 25.00 17.00 L 15.00 22.00 L 11.00 29.00 L 0.00 37.00 L 0.00 40.00 L 4.00 43.00 L 15.00 65.00 L 20.00 85.00 L 20.00 89.00 L 24.00 101.00 L 33.00 109.00 L 42.00 111.00 L 46.00 104.00 L 52.00 99.00 L 59.00 98.00 L 67.00 95.00 L 96.00 95.00 L 100.00 96.00 L 112.00 104.00 L 112.00 110.00 L 115.00 111.00 L 125.00 95.00 L 127.00 73.00 L 117.00 64.00 L 118.00 52.00 L 116.00 50.00 L 94.00 50.00 L 90.00 46.00 L 87.00 40.00 L 90.00 16.00 L 85.00 13.00 L 77.00 13.00 L 52.00 0.00 L 38.00 0.00 Z",
      "province": "REGION_156",
      "rootTerritory": "REGION_156",
      "viewBox": "0 0 127 111",
      "unitSlots": [
        {
          "name": "main",
          "x": 66,
          "y": 73,
          "territory": "REGION_156",
          "arrowReceiver": {
            "x": 66,
            "y": 103
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 66,
          "y": 73,
          "territory": "REGION_156",
          "arrowReceiver": {
            "x": 66,
            "y": 103
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "圣克鲁斯": {
    "territory": "REGION_156",
    "unitSlotName": "main",
    "province": "REGION_156",
    "provinceMapData": {
      "abbr": "STC",
      "type": "Land",
      "centerPos": {
        "x": 33,
        "y": 54
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 50,
          "y": 47,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 127,
      "height": 111,
      "x": 792,
      "y": 1370,
      "playable": true,
      "path": "M 24.00 7.00 L 25.00 17.00 L 15.00 22.00 L 11.00 29.00 L 0.00 37.00 L 0.00 40.00 L 4.00 43.00 L 15.00 65.00 L 20.00 85.00 L 20.00 89.00 L 24.00 101.00 L 33.00 109.00 L 42.00 111.00 L 46.00 104.00 L 52.00 99.00 L 59.00 98.00 L 67.00 95.00 L 96.00 95.00 L 100.00 96.00 L 112.00 104.00 L 112.00 110.00 L 115.00 111.00 L 125.00 95.00 L 127.00 73.00 L 117.00 64.00 L 118.00 52.00 L 116.00 50.00 L 94.00 50.00 L 90.00 46.00 L 87.00 40.00 L 90.00 16.00 L 85.00 13.00 L 77.00 13.00 L 52.00 0.00 L 38.00 0.00 Z",
      "province": "REGION_156",
      "rootTerritory": "REGION_156",
      "viewBox": "0 0 127 111",
      "unitSlots": [
        {
          "name": "main",
          "x": 66,
          "y": 73,
          "territory": "REGION_156",
          "arrowReceiver": {
            "x": 66,
            "y": 103
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 66,
          "y": 73,
          "territory": "REGION_156",
          "arrowReceiver": {
            "x": 66,
            "y": 103
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_157": {
    "territory": "REGION_157",
    "unitSlotName": "main",
    "province": "REGION_157",
    "provinceMapData": {
      "abbr": "PAZ",
      "type": "Land",
      "centerPos": {
        "x": 20,
        "y": 63
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 37,
          "y": 56,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 75,
      "height": 96,
      "x": 740,
      "y": 1387,
      "playable": true,
      "path": "M 11.00 0.00 L 11.00 8.00 L 0.00 29.00 L 1.00 44.00 L 6.00 50.00 L 6.00 62.00 L 4.00 65.00 L 4.00 70.00 L 6.00 73.00 L 8.00 89.00 L 14.00 96.00 L 17.00 96.00 L 20.00 94.00 L 43.00 95.00 L 51.00 89.00 L 61.00 77.00 L 75.00 77.00 L 68.00 46.00 L 57.00 24.00 L 55.00 22.00 L 30.00 10.00 L 14.00 0.00 Z",
      "province": "REGION_157",
      "rootTerritory": "REGION_157",
      "viewBox": "0 0 75 96",
      "unitSlots": [
        {
          "name": "main",
          "x": 38,
          "y": 61,
          "territory": "REGION_157",
          "arrowReceiver": {
            "x": 38,
            "y": 91
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 38,
          "y": 61,
          "territory": "REGION_157",
          "arrowReceiver": {
            "x": 38,
            "y": 91
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "拉巴斯": {
    "territory": "REGION_157",
    "unitSlotName": "main",
    "province": "REGION_157",
    "provinceMapData": {
      "abbr": "PAZ",
      "type": "Land",
      "centerPos": {
        "x": 20,
        "y": 63
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 37,
          "y": 56,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 75,
      "height": 96,
      "x": 740,
      "y": 1387,
      "playable": true,
      "path": "M 11.00 0.00 L 11.00 8.00 L 0.00 29.00 L 1.00 44.00 L 6.00 50.00 L 6.00 62.00 L 4.00 65.00 L 4.00 70.00 L 6.00 73.00 L 8.00 89.00 L 14.00 96.00 L 17.00 96.00 L 20.00 94.00 L 43.00 95.00 L 51.00 89.00 L 61.00 77.00 L 75.00 77.00 L 68.00 46.00 L 57.00 24.00 L 55.00 22.00 L 30.00 10.00 L 14.00 0.00 Z",
      "province": "REGION_157",
      "rootTerritory": "REGION_157",
      "viewBox": "0 0 75 96",
      "unitSlots": [
        {
          "name": "main",
          "x": 38,
          "y": 61,
          "territory": "REGION_157",
          "arrowReceiver": {
            "x": 38,
            "y": 91
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 38,
          "y": 61,
          "territory": "REGION_157",
          "arrowReceiver": {
            "x": 38,
            "y": 91
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_158": {
    "territory": "REGION_158",
    "unitSlotName": "main",
    "province": "REGION_158",
    "provinceMapData": {
      "abbr": "POT",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51,
          "y": 38,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 88,
      "height": 93,
      "x": 746,
      "y": 1463,
      "playable": true,
      "path": "M 69.00 0.00 L 53.00 0.00 L 47.00 8.00 L 35.00 18.00 L 12.00 17.00 L 9.00 19.00 L 10.00 32.00 L 0.00 42.00 L 2.00 75.00 L 9.00 81.00 L 9.00 93.00 L 28.00 90.00 L 43.00 64.00 L 65.00 64.00 L 73.00 56.00 L 77.00 55.00 L 76.00 42.00 L 88.00 21.00 L 88.00 17.00 L 81.00 15.00 L 71.00 6.00 Z",
      "province": "REGION_158",
      "rootTerritory": "REGION_158",
      "viewBox": "0 0 88 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 45,
          "y": 31,
          "territory": "REGION_158",
          "arrowReceiver": {
            "x": 45,
            "y": 61
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45,
          "y": 31,
          "territory": "REGION_158",
          "arrowReceiver": {
            "x": 45,
            "y": 61
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "波多西": {
    "territory": "REGION_158",
    "unitSlotName": "main",
    "province": "REGION_158",
    "provinceMapData": {
      "abbr": "POT",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51,
          "y": 38,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 88,
      "height": 93,
      "x": 746,
      "y": 1463,
      "playable": true,
      "path": "M 69.00 0.00 L 53.00 0.00 L 47.00 8.00 L 35.00 18.00 L 12.00 17.00 L 9.00 19.00 L 10.00 32.00 L 0.00 42.00 L 2.00 75.00 L 9.00 81.00 L 9.00 93.00 L 28.00 90.00 L 43.00 64.00 L 65.00 64.00 L 73.00 56.00 L 77.00 55.00 L 76.00 42.00 L 88.00 21.00 L 88.00 17.00 L 81.00 15.00 L 71.00 6.00 Z",
      "province": "REGION_158",
      "rootTerritory": "REGION_158",
      "viewBox": "0 0 88 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 45,
          "y": 31,
          "territory": "REGION_158",
          "arrowReceiver": {
            "x": 45,
            "y": 61
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45,
          "y": 31,
          "territory": "REGION_158",
          "arrowReceiver": {
            "x": 45,
            "y": 61
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_159": {
    "territory": "REGION_159",
    "unitSlotName": "main",
    "province": "REGION_159",
    "provinceMapData": {
      "abbr": "CHB",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 44,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 89,
      "height": 107,
      "x": 821,
      "y": 1464,
      "playable": true,
      "path": "M 73.00 1.00 L 69.00 0.00 L 36.00 0.00 L 19.00 5.00 L 13.00 12.00 L 12.00 18.00 L 0.00 39.00 L 1.00 55.00 L 13.00 71.00 L 12.00 88.00 L 25.00 103.00 L 33.00 107.00 L 37.00 107.00 L 36.00 98.00 L 57.00 74.00 L 65.00 70.00 L 75.00 50.00 L 76.00 43.00 L 81.00 38.00 L 89.00 39.00 L 89.00 36.00 L 86.00 33.00 L 84.00 8.00 Z",
      "province": "REGION_159",
      "rootTerritory": "REGION_159",
      "viewBox": "0 0 89 107",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 37,
          "territory": "REGION_159",
          "arrowReceiver": {
            "x": 39,
            "y": 67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 37,
          "territory": "REGION_159",
          "arrowReceiver": {
            "x": 39,
            "y": 67
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "北查科": {
    "territory": "REGION_159",
    "unitSlotName": "main",
    "province": "REGION_159",
    "provinceMapData": {
      "abbr": "CHB",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 44,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 89,
      "height": 107,
      "x": 821,
      "y": 1464,
      "playable": true,
      "path": "M 73.00 1.00 L 69.00 0.00 L 36.00 0.00 L 19.00 5.00 L 13.00 12.00 L 12.00 18.00 L 0.00 39.00 L 1.00 55.00 L 13.00 71.00 L 12.00 88.00 L 25.00 103.00 L 33.00 107.00 L 37.00 107.00 L 36.00 98.00 L 57.00 74.00 L 65.00 70.00 L 75.00 50.00 L 76.00 43.00 L 81.00 38.00 L 89.00 39.00 L 89.00 36.00 L 86.00 33.00 L 84.00 8.00 Z",
      "province": "REGION_159",
      "rootTerritory": "REGION_159",
      "viewBox": "0 0 89 107",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 37,
          "territory": "REGION_159",
          "arrowReceiver": {
            "x": 39,
            "y": 67
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 37,
          "territory": "REGION_159",
          "arrowReceiver": {
            "x": 39,
            "y": 67
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_160": {
    "territory": "REGION_160",
    "unitSlotName": "main",
    "province": "REGION_160",
    "provinceMapData": {
      "abbr": "ATF",
      "type": "Coast",
      "centerPos": {
        "x": 34,
        "y": 12
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 29,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 65,
      "height": 57,
      "x": 691,
      "y": 1507,
      "playable": true,
      "path": "M 12.00 0.00 L 4.00 15.00 L 0.00 48.00 L 9.00 47.00 L 10.00 48.00 L 18.00 48.00 L 23.00 51.00 L 37.00 51.00 L 44.00 47.00 L 55.00 47.00 L 58.00 52.00 L 58.00 57.00 L 60.00 57.00 L 65.00 51.00 L 65.00 35.00 L 58.00 29.00 L 56.00 0.00 L 54.00 0.00 L 52.00 3.00 L 42.00 8.00 L 17.00 8.00 L 14.00 4.00 L 14.00 0.00 Z",
      "province": "REGION_160",
      "rootTerritory": "REGION_160",
      "viewBox": "0 0 65 57",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 46,
          "territory": "REGION_160",
          "arrowReceiver": {
            "x": 27,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 46,
          "territory": "REGION_160",
          "arrowReceiver": {
            "x": 27,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "安托法加斯塔": {
    "territory": "REGION_160",
    "unitSlotName": "main",
    "province": "REGION_160",
    "provinceMapData": {
      "abbr": "ATF",
      "type": "Coast",
      "centerPos": {
        "x": 34,
        "y": 12
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 29,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 65,
      "height": 57,
      "x": 691,
      "y": 1507,
      "playable": true,
      "path": "M 12.00 0.00 L 4.00 15.00 L 0.00 48.00 L 9.00 47.00 L 10.00 48.00 L 18.00 48.00 L 23.00 51.00 L 37.00 51.00 L 44.00 47.00 L 55.00 47.00 L 58.00 52.00 L 58.00 57.00 L 60.00 57.00 L 65.00 51.00 L 65.00 35.00 L 58.00 29.00 L 56.00 0.00 L 54.00 0.00 L 52.00 3.00 L 42.00 8.00 L 17.00 8.00 L 14.00 4.00 L 14.00 0.00 Z",
      "province": "REGION_160",
      "rootTerritory": "REGION_160",
      "viewBox": "0 0 65 57",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 46,
          "territory": "REGION_160",
          "arrowReceiver": {
            "x": 27,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 46,
          "territory": "REGION_160",
          "arrowReceiver": {
            "x": 27,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_161": {
    "territory": "REGION_161",
    "unitSlotName": "main",
    "province": "REGION_161",
    "provinceMapData": {
      "abbr": "ASU",
      "type": "Land",
      "centerPos": {
        "x": 38,
        "y": 60
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 55,
          "y": 53,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 91,
      "height": 96,
      "x": 856,
      "y": 1501,
      "playable": true,
      "path": "M 75.00 2.00 L 44.00 0.00 L 40.00 4.00 L 39.00 11.00 L 29.00 31.00 L 20.00 36.00 L 0.00 59.00 L 2.00 76.00 L 7.00 83.00 L 28.00 93.00 L 31.00 96.00 L 50.00 96.00 L 62.00 90.00 L 84.00 75.00 L 90.00 63.00 L 90.00 48.00 L 88.00 45.00 L 88.00 42.00 L 91.00 37.00 L 91.00 22.00 L 83.00 21.00 L 77.00 17.00 L 77.00 6.00 Z",
      "province": "REGION_161",
      "rootTerritory": "REGION_161",
      "viewBox": "0 0 91 96",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 59,
          "territory": "REGION_161",
          "arrowReceiver": {
            "x": 37,
            "y": 89
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 59,
          "territory": "REGION_161",
          "arrowReceiver": {
            "x": 37,
            "y": 89
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "亚松森": {
    "territory": "REGION_161",
    "unitSlotName": "main",
    "province": "REGION_161",
    "provinceMapData": {
      "abbr": "ASU",
      "type": "Land",
      "centerPos": {
        "x": 38,
        "y": 60
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 55,
          "y": 53,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 91,
      "height": 96,
      "x": 856,
      "y": 1501,
      "playable": true,
      "path": "M 75.00 2.00 L 44.00 0.00 L 40.00 4.00 L 39.00 11.00 L 29.00 31.00 L 20.00 36.00 L 0.00 59.00 L 2.00 76.00 L 7.00 83.00 L 28.00 93.00 L 31.00 96.00 L 50.00 96.00 L 62.00 90.00 L 84.00 75.00 L 90.00 63.00 L 90.00 48.00 L 88.00 45.00 L 88.00 42.00 L 91.00 37.00 L 91.00 22.00 L 83.00 21.00 L 77.00 17.00 L 77.00 6.00 Z",
      "province": "REGION_161",
      "rootTerritory": "REGION_161",
      "viewBox": "0 0 91 96",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 59,
          "territory": "REGION_161",
          "arrowReceiver": {
            "x": 37,
            "y": 89
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 59,
          "territory": "REGION_161",
          "arrowReceiver": {
            "x": 37,
            "y": 89
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_162": {
    "territory": "REGION_162",
    "unitSlotName": "main",
    "province": "REGION_162",
    "provinceMapData": {
      "abbr": "URU",
      "type": "Coast",
      "centerPos": {
        "x": 19,
        "y": 45
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36,
          "y": 38,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 82,
      "height": 70,
      "x": 845,
      "y": 1603,
      "playable": true,
      "path": "M 81.00 29.00 L 67.00 13.00 L 65.00 12.00 L 53.00 12.00 L 43.00 0.00 L 20.00 2.00 L 2.00 36.00 L 0.00 63.00 L 7.00 70.00 L 12.00 69.00 L 40.00 70.00 L 45.00 67.00 L 65.00 66.00 L 73.00 61.00 L 79.00 55.00 L 82.00 49.00 Z",
      "province": "REGION_162",
      "rootTerritory": "REGION_162",
      "viewBox": "0 0 82 70",
      "unitSlots": [
        {
          "name": "main",
          "x": 36,
          "y": 36,
          "territory": "REGION_162",
          "arrowReceiver": {
            "x": 36,
            "y": 66
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 36,
          "y": 36,
          "territory": "REGION_162",
          "arrowReceiver": {
            "x": 36,
            "y": 66
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "乌拉圭": {
    "territory": "REGION_162",
    "unitSlotName": "main",
    "province": "REGION_162",
    "provinceMapData": {
      "abbr": "URU",
      "type": "Coast",
      "centerPos": {
        "x": 19,
        "y": 45
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 36,
          "y": 38,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 82,
      "height": 70,
      "x": 845,
      "y": 1603,
      "playable": true,
      "path": "M 81.00 29.00 L 67.00 13.00 L 65.00 12.00 L 53.00 12.00 L 43.00 0.00 L 20.00 2.00 L 2.00 36.00 L 0.00 63.00 L 7.00 70.00 L 12.00 69.00 L 40.00 70.00 L 45.00 67.00 L 65.00 66.00 L 73.00 61.00 L 79.00 55.00 L 82.00 49.00 Z",
      "province": "REGION_162",
      "rootTerritory": "REGION_162",
      "viewBox": "0 0 82 70",
      "unitSlots": [
        {
          "name": "main",
          "x": 36,
          "y": 36,
          "territory": "REGION_162",
          "arrowReceiver": {
            "x": 36,
            "y": 66
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 36,
          "y": 36,
          "territory": "REGION_162",
          "arrowReceiver": {
            "x": 36,
            "y": 66
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_163": {
    "territory": "REGION_163",
    "unitSlotName": "main",
    "province": "REGION_163",
    "provinceMapData": {
      "abbr": "MDZ",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 55,
          "y": 42,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 97,
      "height": 119,
      "x": 662,
      "y": 1621,
      "playable": true,
      "path": "M 96.00 0.00 L 80.00 0.00 L 77.00 2.00 L 53.00 0.00 L 53.00 11.00 L 34.00 30.00 L 32.00 34.00 L 31.00 46.00 L 34.00 51.00 L 34.00 66.00 L 29.00 76.00 L 25.00 78.00 L 15.00 90.00 L 13.00 105.00 L 0.00 115.00 L 1.00 119.00 L 5.00 119.00 L 13.00 110.00 L 27.00 109.00 L 33.00 106.00 L 45.00 94.00 L 58.00 89.00 L 63.00 82.00 L 65.00 73.00 L 83.00 38.00 L 85.00 20.00 L 86.00 19.00 L 97.00 19.00 Z",
      "province": "REGION_163",
      "rootTerritory": "REGION_163",
      "viewBox": "0 0 97 119",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 28,
          "territory": "REGION_163",
          "arrowReceiver": {
            "x": 63,
            "y": 58
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 28,
          "territory": "REGION_163",
          "arrowReceiver": {
            "x": 63,
            "y": 58
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "门多萨": {
    "territory": "REGION_163",
    "unitSlotName": "main",
    "province": "REGION_163",
    "provinceMapData": {
      "abbr": "MDZ",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 55,
          "y": 42,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 97,
      "height": 119,
      "x": 662,
      "y": 1621,
      "playable": true,
      "path": "M 96.00 0.00 L 80.00 0.00 L 77.00 2.00 L 53.00 0.00 L 53.00 11.00 L 34.00 30.00 L 32.00 34.00 L 31.00 46.00 L 34.00 51.00 L 34.00 66.00 L 29.00 76.00 L 25.00 78.00 L 15.00 90.00 L 13.00 105.00 L 0.00 115.00 L 1.00 119.00 L 5.00 119.00 L 13.00 110.00 L 27.00 109.00 L 33.00 106.00 L 45.00 94.00 L 58.00 89.00 L 63.00 82.00 L 65.00 73.00 L 83.00 38.00 L 85.00 20.00 L 86.00 19.00 L 97.00 19.00 Z",
      "province": "REGION_163",
      "rootTerritory": "REGION_163",
      "viewBox": "0 0 97 119",
      "unitSlots": [
        {
          "name": "main",
          "x": 63,
          "y": 28,
          "territory": "REGION_163",
          "arrowReceiver": {
            "x": 63,
            "y": 58
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 63,
          "y": 28,
          "territory": "REGION_163",
          "arrowReceiver": {
            "x": 63,
            "y": 58
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_164": {
    "territory": "REGION_164",
    "unitSlotName": "main",
    "province": "REGION_164",
    "provinceMapData": {
      "abbr": "PAM",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 81,
          "y": 44,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 128,
      "height": 109,
      "x": 694,
      "y": 1639,
      "playable": true,
      "path": "M 106.00 2.00 L 52.00 0.00 L 50.00 18.00 L 32.00 53.00 L 30.00 62.00 L 23.00 71.00 L 11.00 75.00 L 0.00 86.00 L 0.00 88.00 L 8.00 88.00 L 12.00 93.00 L 29.00 94.00 L 37.00 98.00 L 40.00 101.00 L 43.00 109.00 L 45.00 109.00 L 48.00 106.00 L 71.00 107.00 L 77.00 104.00 L 79.00 102.00 L 81.00 98.00 L 84.00 95.00 L 92.00 83.00 L 108.00 84.00 L 109.00 83.00 L 125.00 78.00 L 127.00 75.00 L 127.00 71.00 L 128.00 70.00 L 127.00 62.00 L 119.00 54.00 L 121.00 18.00 Z",
      "province": "REGION_164",
      "rootTerritory": "REGION_164",
      "viewBox": "0 0 128 109",
      "unitSlots": [
        {
          "name": "main",
          "x": 72,
          "y": 64,
          "territory": "REGION_164",
          "arrowReceiver": {
            "x": 72,
            "y": 94
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 72,
          "y": 64,
          "territory": "REGION_164",
          "arrowReceiver": {
            "x": 72,
            "y": 94
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "潘帕斯": {
    "territory": "REGION_164",
    "unitSlotName": "main",
    "province": "REGION_164",
    "provinceMapData": {
      "abbr": "PAM",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 81,
          "y": 44,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 128,
      "height": 109,
      "x": 694,
      "y": 1639,
      "playable": true,
      "path": "M 106.00 2.00 L 52.00 0.00 L 50.00 18.00 L 32.00 53.00 L 30.00 62.00 L 23.00 71.00 L 11.00 75.00 L 0.00 86.00 L 0.00 88.00 L 8.00 88.00 L 12.00 93.00 L 29.00 94.00 L 37.00 98.00 L 40.00 101.00 L 43.00 109.00 L 45.00 109.00 L 48.00 106.00 L 71.00 107.00 L 77.00 104.00 L 79.00 102.00 L 81.00 98.00 L 84.00 95.00 L 92.00 83.00 L 108.00 84.00 L 109.00 83.00 L 125.00 78.00 L 127.00 75.00 L 127.00 71.00 L 128.00 70.00 L 127.00 62.00 L 119.00 54.00 L 121.00 18.00 Z",
      "province": "REGION_164",
      "rootTerritory": "REGION_164",
      "viewBox": "0 0 128 109",
      "unitSlots": [
        {
          "name": "main",
          "x": 72,
          "y": 64,
          "territory": "REGION_164",
          "arrowReceiver": {
            "x": 72,
            "y": 94
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 72,
          "y": 64,
          "territory": "REGION_164",
          "arrowReceiver": {
            "x": 72,
            "y": 94
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_169": {
    "territory": "REGION_169",
    "unitSlotName": "main",
    "province": "REGION_169",
    "provinceMapData": {
      "abbr": "LOR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 45,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 114,
      "height": 153,
      "x": 590,
      "y": 1198,
      "playable": true,
      "path": "M 43.00 0.00 L 25.00 16.00 L 0.00 28.00 L 0.00 31.00 L 6.00 31.00 L 7.00 30.00 L 12.00 31.00 L 14.00 36.00 L 14.00 55.00 L 28.00 66.00 L 43.00 70.00 L 49.00 73.00 L 49.00 86.00 L 42.00 92.00 L 42.00 95.00 L 44.00 98.00 L 42.00 112.00 L 44.00 114.00 L 46.00 114.00 L 49.00 110.00 L 62.00 109.00 L 65.00 113.00 L 64.00 129.00 L 69.00 138.00 L 68.00 145.00 L 69.00 146.00 L 79.00 145.00 L 84.00 153.00 L 93.00 153.00 L 97.00 148.00 L 111.00 143.00 L 114.00 137.00 L 114.00 133.00 L 112.00 133.00 L 107.00 126.00 L 99.00 124.00 L 97.00 122.00 L 96.00 116.00 L 92.00 108.00 L 87.00 102.00 L 89.00 99.00 L 89.00 96.00 L 86.00 96.00 L 82.00 94.00 L 82.00 86.00 L 89.00 77.00 L 91.00 60.00 L 101.00 52.00 L 105.00 50.00 L 112.00 51.00 L 112.00 49.00 L 108.00 47.00 L 95.00 46.00 L 84.00 31.00 L 73.00 26.00 L 69.00 15.00 L 65.00 11.00 L 52.00 5.00 L 47.00 0.00 Z",
      "province": "REGION_169",
      "rootTerritory": "REGION_169",
      "viewBox": "0 0 114 153",
      "unitSlots": [
        {
          "name": "main",
          "x": 59,
          "y": 50,
          "territory": "REGION_169",
          "arrowReceiver": {
            "x": 59,
            "y": 80
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 59,
          "y": 50,
          "territory": "REGION_169",
          "arrowReceiver": {
            "x": 59,
            "y": 80
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "洛雷托": {
    "territory": "REGION_169",
    "unitSlotName": "main",
    "province": "REGION_169",
    "provinceMapData": {
      "abbr": "LOR",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 45,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 114,
      "height": 153,
      "x": 590,
      "y": 1198,
      "playable": true,
      "path": "M 43.00 0.00 L 25.00 16.00 L 0.00 28.00 L 0.00 31.00 L 6.00 31.00 L 7.00 30.00 L 12.00 31.00 L 14.00 36.00 L 14.00 55.00 L 28.00 66.00 L 43.00 70.00 L 49.00 73.00 L 49.00 86.00 L 42.00 92.00 L 42.00 95.00 L 44.00 98.00 L 42.00 112.00 L 44.00 114.00 L 46.00 114.00 L 49.00 110.00 L 62.00 109.00 L 65.00 113.00 L 64.00 129.00 L 69.00 138.00 L 68.00 145.00 L 69.00 146.00 L 79.00 145.00 L 84.00 153.00 L 93.00 153.00 L 97.00 148.00 L 111.00 143.00 L 114.00 137.00 L 114.00 133.00 L 112.00 133.00 L 107.00 126.00 L 99.00 124.00 L 97.00 122.00 L 96.00 116.00 L 92.00 108.00 L 87.00 102.00 L 89.00 99.00 L 89.00 96.00 L 86.00 96.00 L 82.00 94.00 L 82.00 86.00 L 89.00 77.00 L 91.00 60.00 L 101.00 52.00 L 105.00 50.00 L 112.00 51.00 L 112.00 49.00 L 108.00 47.00 L 95.00 46.00 L 84.00 31.00 L 73.00 26.00 L 69.00 15.00 L 65.00 11.00 L 52.00 5.00 L 47.00 0.00 Z",
      "province": "REGION_169",
      "rootTerritory": "REGION_169",
      "viewBox": "0 0 114 153",
      "unitSlots": [
        {
          "name": "main",
          "x": 59,
          "y": 50,
          "territory": "REGION_169",
          "arrowReceiver": {
            "x": 59,
            "y": 80
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 59,
          "y": 50,
          "territory": "REGION_169",
          "arrowReceiver": {
            "x": 59,
            "y": 80
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_170": {
    "territory": "REGION_170",
    "unitSlotName": "main",
    "province": "REGION_170",
    "provinceMapData": {
      "abbr": "CAJ",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 63,
          "y": 64,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 120,
      "height": 124,
      "x": 536,
      "y": 1227,
      "playable": true,
      "path": "M 17.00 3.00 L 0.00 13.00 L 0.00 30.00 L 4.00 37.00 L 3.00 58.00 L 32.00 81.00 L 46.00 107.00 L 51.00 124.00 L 53.00 124.00 L 53.00 114.00 L 55.00 112.00 L 63.00 113.00 L 76.00 106.00 L 86.00 107.00 L 92.00 100.00 L 113.00 98.00 L 114.00 97.00 L 119.00 98.00 L 120.00 82.00 L 118.00 79.00 L 101.00 80.00 L 99.00 82.00 L 97.00 81.00 L 99.00 76.00 L 98.00 64.00 L 104.00 59.00 L 104.00 42.00 L 84.00 36.00 L 69.00 24.00 L 69.00 5.00 L 67.00 0.00 L 51.00 1.00 L 44.00 15.00 L 41.00 18.00 L 32.00 13.00 L 33.00 3.00 Z",
      "province": "REGION_170",
      "rootTerritory": "REGION_170",
      "viewBox": "0 0 120 124",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 42,
          "territory": "REGION_170",
          "arrowReceiver": {
            "x": 48,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 42,
          "territory": "REGION_170",
          "arrowReceiver": {
            "x": 48,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡哈马卡": {
    "territory": "REGION_170",
    "unitSlotName": "main",
    "province": "REGION_170",
    "provinceMapData": {
      "abbr": "CAJ",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 63,
          "y": 64,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 120,
      "height": 124,
      "x": 536,
      "y": 1227,
      "playable": true,
      "path": "M 17.00 3.00 L 0.00 13.00 L 0.00 30.00 L 4.00 37.00 L 3.00 58.00 L 32.00 81.00 L 46.00 107.00 L 51.00 124.00 L 53.00 124.00 L 53.00 114.00 L 55.00 112.00 L 63.00 113.00 L 76.00 106.00 L 86.00 107.00 L 92.00 100.00 L 113.00 98.00 L 114.00 97.00 L 119.00 98.00 L 120.00 82.00 L 118.00 79.00 L 101.00 80.00 L 99.00 82.00 L 97.00 81.00 L 99.00 76.00 L 98.00 64.00 L 104.00 59.00 L 104.00 42.00 L 84.00 36.00 L 69.00 24.00 L 69.00 5.00 L 67.00 0.00 L 51.00 1.00 L 44.00 15.00 L 41.00 18.00 L 32.00 13.00 L 33.00 3.00 Z",
      "province": "REGION_170",
      "rootTerritory": "REGION_170",
      "viewBox": "0 0 120 124",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 42,
          "territory": "REGION_170",
          "arrowReceiver": {
            "x": 48,
            "y": 72
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 42,
          "territory": "REGION_170",
          "arrowReceiver": {
            "x": 48,
            "y": 72
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_171": {
    "territory": "REGION_171",
    "unitSlotName": "main",
    "province": "REGION_171",
    "provinceMapData": {
      "abbr": "LMA",
      "type": "Coast",
      "centerPos": {
        "x": 22,
        "y": 46
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 39,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 91,
      "height": 105,
      "x": 588,
      "y": 1323,
      "playable": true,
      "path": "M 66.00 0.00 L 38.00 3.00 L 32.00 10.00 L 22.00 9.00 L 9.00 16.00 L 7.00 15.00 L 1.00 15.00 L 0.00 16.00 L 0.00 37.00 L 4.00 45.00 L 26.00 71.00 L 26.00 86.00 L 47.00 105.00 L 51.00 105.00 L 51.00 94.00 L 55.00 90.00 L 67.00 90.00 L 71.00 95.00 L 75.00 95.00 L 91.00 80.00 L 91.00 76.00 L 86.00 72.00 L 79.00 72.00 L 67.00 58.00 L 68.00 44.00 L 72.00 40.00 L 71.00 33.00 L 79.00 27.00 L 86.00 27.00 L 86.00 25.00 L 83.00 19.00 L 73.00 20.00 L 71.00 18.00 L 72.00 11.00 Z",
      "province": "REGION_171",
      "rootTerritory": "REGION_171",
      "viewBox": "0 0 91 105",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 21,
          "territory": "REGION_171",
          "arrowReceiver": {
            "x": 37,
            "y": 51
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 21,
          "territory": "REGION_171",
          "arrowReceiver": {
            "x": 37,
            "y": 51
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "利马": {
    "territory": "REGION_171",
    "unitSlotName": "main",
    "province": "REGION_171",
    "provinceMapData": {
      "abbr": "LMA",
      "type": "Coast",
      "centerPos": {
        "x": 22,
        "y": 46
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 39,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 91,
      "height": 105,
      "x": 588,
      "y": 1323,
      "playable": true,
      "path": "M 66.00 0.00 L 38.00 3.00 L 32.00 10.00 L 22.00 9.00 L 9.00 16.00 L 7.00 15.00 L 1.00 15.00 L 0.00 16.00 L 0.00 37.00 L 4.00 45.00 L 26.00 71.00 L 26.00 86.00 L 47.00 105.00 L 51.00 105.00 L 51.00 94.00 L 55.00 90.00 L 67.00 90.00 L 71.00 95.00 L 75.00 95.00 L 91.00 80.00 L 91.00 76.00 L 86.00 72.00 L 79.00 72.00 L 67.00 58.00 L 68.00 44.00 L 72.00 40.00 L 71.00 33.00 L 79.00 27.00 L 86.00 27.00 L 86.00 25.00 L 83.00 19.00 L 73.00 20.00 L 71.00 18.00 L 72.00 11.00 Z",
      "province": "REGION_171",
      "rootTerritory": "REGION_171",
      "viewBox": "0 0 91 105",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 21,
          "territory": "REGION_171",
          "arrowReceiver": {
            "x": 37,
            "y": 51
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 21,
          "territory": "REGION_171",
          "arrowReceiver": {
            "x": 37,
            "y": 51
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_172": {
    "territory": "REGION_172",
    "unitSlotName": "main",
    "province": "REGION_172",
    "provinceMapData": {
      "abbr": "CUZ",
      "type": "Land",
      "centerPos": {
        "x": 37,
        "y": 56
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 49,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 99,
      "height": 102,
      "x": 654,
      "y": 1327,
      "playable": true,
      "path": "M 4.00 27.00 L 5.00 34.00 L 1.00 38.00 L 0.00 56.00 L 11.00 69.00 L 18.00 69.00 L 24.00 74.00 L 23.00 78.00 L 32.00 78.00 L 45.00 85.00 L 57.00 86.00 L 65.00 92.00 L 88.00 102.00 L 87.00 91.00 L 98.00 70.00 L 99.00 39.00 L 91.00 24.00 L 91.00 22.00 L 89.00 20.00 L 75.00 20.00 L 71.00 14.00 L 71.00 0.00 L 52.00 0.00 L 45.00 13.00 L 31.00 18.00 L 27.00 23.00 L 11.00 22.00 Z",
      "province": "REGION_172",
      "rootTerritory": "REGION_172",
      "viewBox": "0 0 99 102",
      "unitSlots": [
        {
          "name": "main",
          "x": 43,
          "y": 41,
          "territory": "REGION_172",
          "arrowReceiver": {
            "x": 43,
            "y": 71
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 43,
          "y": 41,
          "territory": "REGION_172",
          "arrowReceiver": {
            "x": 43,
            "y": 71
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "库斯科": {
    "territory": "REGION_172",
    "unitSlotName": "main",
    "province": "REGION_172",
    "provinceMapData": {
      "abbr": "CUZ",
      "type": "Land",
      "centerPos": {
        "x": 37,
        "y": 56
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 49,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 99,
      "height": 102,
      "x": 654,
      "y": 1327,
      "playable": true,
      "path": "M 4.00 27.00 L 5.00 34.00 L 1.00 38.00 L 0.00 56.00 L 11.00 69.00 L 18.00 69.00 L 24.00 74.00 L 23.00 78.00 L 32.00 78.00 L 45.00 85.00 L 57.00 86.00 L 65.00 92.00 L 88.00 102.00 L 87.00 91.00 L 98.00 70.00 L 99.00 39.00 L 91.00 24.00 L 91.00 22.00 L 89.00 20.00 L 75.00 20.00 L 71.00 14.00 L 71.00 0.00 L 52.00 0.00 L 45.00 13.00 L 31.00 18.00 L 27.00 23.00 L 11.00 22.00 Z",
      "province": "REGION_172",
      "rootTerritory": "REGION_172",
      "viewBox": "0 0 99 102",
      "unitSlots": [
        {
          "name": "main",
          "x": 43,
          "y": 41,
          "territory": "REGION_172",
          "arrowReceiver": {
            "x": 43,
            "y": 71
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 43,
          "y": 41,
          "territory": "REGION_172",
          "arrowReceiver": {
            "x": 43,
            "y": 71
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_174": {
    "territory": "REGION_174",
    "unitSlotName": "main",
    "province": "REGION_174",
    "provinceMapData": {
      "abbr": "ACM",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 43,
          "y": 30,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 78,
      "height": 68,
      "x": 672,
      "y": 1553,
      "playable": true,
      "path": "M 76.00 0.00 L 61.00 0.00 L 54.00 4.00 L 44.00 4.00 L 39.00 1.00 L 20.00 0.00 L 0.00 39.00 L 0.00 52.00 L 2.00 52.00 L 4.00 50.00 L 25.00 49.00 L 28.00 55.00 L 30.00 55.00 L 34.00 58.00 L 42.00 59.00 L 43.00 60.00 L 42.00 65.00 L 43.00 68.00 L 45.00 68.00 L 71.00 39.00 L 76.00 37.00 L 78.00 33.00 L 78.00 4.00 Z",
      "province": "REGION_174",
      "rootTerritory": "REGION_174",
      "viewBox": "0 0 78 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 36,
          "y": 25,
          "territory": "REGION_174",
          "arrowReceiver": {
            "x": 36,
            "y": 55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 36,
          "y": 25,
          "territory": "REGION_174",
          "arrowReceiver": {
            "x": 36,
            "y": 55
          }
        }
      },
      "texture": {
        "texture": "#D4BCAE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿塔卡马": {
    "territory": "REGION_174",
    "unitSlotName": "main",
    "province": "REGION_174",
    "provinceMapData": {
      "abbr": "ACM",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 43,
          "y": 30,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 78,
      "height": 68,
      "x": 672,
      "y": 1553,
      "playable": true,
      "path": "M 76.00 0.00 L 61.00 0.00 L 54.00 4.00 L 44.00 4.00 L 39.00 1.00 L 20.00 0.00 L 0.00 39.00 L 0.00 52.00 L 2.00 52.00 L 4.00 50.00 L 25.00 49.00 L 28.00 55.00 L 30.00 55.00 L 34.00 58.00 L 42.00 59.00 L 43.00 60.00 L 42.00 65.00 L 43.00 68.00 L 45.00 68.00 L 71.00 39.00 L 76.00 37.00 L 78.00 33.00 L 78.00 4.00 Z",
      "province": "REGION_174",
      "rootTerritory": "REGION_174",
      "viewBox": "0 0 78 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 36,
          "y": 25,
          "territory": "REGION_174",
          "arrowReceiver": {
            "x": 36,
            "y": 55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 36,
          "y": 25,
          "territory": "REGION_174",
          "arrowReceiver": {
            "x": 36,
            "y": 55
          }
        }
      },
      "texture": {
        "texture": "#D4BCAE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_183": {
    "territory": "REGION_183",
    "unitSlotName": "main",
    "province": "REGION_183",
    "provinceMapData": {
      "abbr": "COS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 13,
          "y": 15,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 52,
      "x": 482,
      "y": 982,
      "playable": true,
      "path": "M 3.00 0.00 L 3.00 10.00 L 0.00 13.00 L 0.00 19.00 L 2.00 23.00 L 9.00 28.00 L 13.00 28.00 L 16.00 30.00 L 20.00 31.00 L 41.00 52.00 L 45.00 52.00 L 44.00 39.00 L 36.00 23.00 L 23.00 10.00 L 23.00 7.00 L 10.00 0.00 Z",
      "province": "REGION_183",
      "rootTerritory": "REGION_183",
      "viewBox": "0 0 45 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        "nc": {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        "sc": {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "哥斯达黎加": {
    "territory": "REGION_183",
    "unitSlotName": "main",
    "province": "REGION_183",
    "provinceMapData": {
      "abbr": "COS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 13,
          "y": 15,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 52,
      "x": 482,
      "y": 982,
      "playable": true,
      "path": "M 3.00 0.00 L 3.00 10.00 L 0.00 13.00 L 0.00 19.00 L 2.00 23.00 L 9.00 28.00 L 13.00 28.00 L 16.00 30.00 L 20.00 31.00 L 41.00 52.00 L 45.00 52.00 L 44.00 39.00 L 36.00 23.00 L 23.00 10.00 L 23.00 7.00 L 10.00 0.00 Z",
      "province": "REGION_183",
      "rootTerritory": "REGION_183",
      "viewBox": "0 0 45 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        "nc": {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        "sc": {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_184": {
    "territory": "REGION_184",
    "unitSlotName": "main",
    "province": "REGION_184",
    "provinceMapData": {
      "abbr": "STM",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 15,
          "y": 59,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 62,
      "height": 81,
      "x": 661,
      "y": 970,
      "playable": true,
      "path": "M 60.00 2.00 L 54.00 2.00 L 53.00 1.00 L 47.00 1.00 L 46.00 0.00 L 38.00 1.00 L 25.00 11.00 L 21.00 12.00 L 21.00 20.00 L 12.00 30.00 L 8.00 30.00 L 8.00 49.00 L 0.00 64.00 L 0.00 66.00 L 9.00 80.00 L 11.00 81.00 L 16.00 81.00 L 19.00 79.00 L 23.00 79.00 L 28.00 76.00 L 27.00 75.00 L 27.00 69.00 L 28.00 68.00 L 28.00 66.00 L 26.00 63.00 L 27.00 59.00 L 25.00 56.00 L 26.00 44.00 L 34.00 34.00 L 34.00 29.00 L 35.00 28.00 L 35.00 24.00 L 36.00 23.00 L 46.00 20.00 L 52.00 9.00 L 62.00 10.00 L 62.00 6.00 Z",
      "province": "REGION_184",
      "rootTerritory": "REGION_184",
      "viewBox": "0 0 62 81",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 15,
          "territory": "REGION_184",
          "arrowReceiver": {
            "x": 37,
            "y": 45
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 15,
          "territory": "REGION_184",
          "arrowReceiver": {
            "x": 37,
            "y": 45
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "圣玛尔塔": {
    "territory": "REGION_184",
    "unitSlotName": "main",
    "province": "REGION_184",
    "provinceMapData": {
      "abbr": "STM",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 15,
          "y": 59,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 62,
      "height": 81,
      "x": 661,
      "y": 970,
      "playable": true,
      "path": "M 60.00 2.00 L 54.00 2.00 L 53.00 1.00 L 47.00 1.00 L 46.00 0.00 L 38.00 1.00 L 25.00 11.00 L 21.00 12.00 L 21.00 20.00 L 12.00 30.00 L 8.00 30.00 L 8.00 49.00 L 0.00 64.00 L 0.00 66.00 L 9.00 80.00 L 11.00 81.00 L 16.00 81.00 L 19.00 79.00 L 23.00 79.00 L 28.00 76.00 L 27.00 75.00 L 27.00 69.00 L 28.00 68.00 L 28.00 66.00 L 26.00 63.00 L 27.00 59.00 L 25.00 56.00 L 26.00 44.00 L 34.00 34.00 L 34.00 29.00 L 35.00 28.00 L 35.00 24.00 L 36.00 23.00 L 46.00 20.00 L 52.00 9.00 L 62.00 10.00 L 62.00 6.00 Z",
      "province": "REGION_184",
      "rootTerritory": "REGION_184",
      "viewBox": "0 0 62 81",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 15,
          "territory": "REGION_184",
          "arrowReceiver": {
            "x": 37,
            "y": 45
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 15,
          "territory": "REGION_184",
          "arrowReceiver": {
            "x": 37,
            "y": 45
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_185": {
    "territory": "REGION_185",
    "unitSlotName": "main",
    "province": "REGION_185",
    "provinceMapData": {
      "abbr": "CAT",
      "type": "Coast",
      "centerPos": {
        "x": -2,
        "y": 12
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 15,
          "y": 45,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 37,
      "height": 83,
      "x": 636,
      "y": 1000,
      "playable": true,
      "path": "M 34.00 0.00 L 25.00 1.00 L 21.00 4.00 L 18.00 13.00 L 11.00 19.00 L 11.00 27.00 L 0.00 40.00 L 1.00 52.00 L 11.00 61.00 L 14.00 83.00 L 17.00 83.00 L 18.00 73.00 L 26.00 65.00 L 27.00 62.00 L 34.00 57.00 L 35.00 54.00 L 37.00 52.00 L 35.00 51.00 L 34.00 46.00 L 27.00 36.00 L 27.00 34.00 L 34.00 21.00 Z",
      "province": "REGION_185",
      "rootTerritory": "REGION_185",
      "viewBox": "0 0 37 83",
      "unitSlots": [
        {
          "name": "main",
          "x": 22,
          "y": 58,
          "territory": "REGION_185",
          "arrowReceiver": {
            "x": 22,
            "y": 88
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 22,
          "y": 58,
          "territory": "REGION_185",
          "arrowReceiver": {
            "x": 22,
            "y": 88
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡塔赫纳": {
    "territory": "REGION_185",
    "unitSlotName": "main",
    "province": "REGION_185",
    "provinceMapData": {
      "abbr": "CAT",
      "type": "Coast",
      "centerPos": {
        "x": -2,
        "y": 12
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 15,
          "y": 45,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 37,
      "height": 83,
      "x": 636,
      "y": 1000,
      "playable": true,
      "path": "M 34.00 0.00 L 25.00 1.00 L 21.00 4.00 L 18.00 13.00 L 11.00 19.00 L 11.00 27.00 L 0.00 40.00 L 1.00 52.00 L 11.00 61.00 L 14.00 83.00 L 17.00 83.00 L 18.00 73.00 L 26.00 65.00 L 27.00 62.00 L 34.00 57.00 L 35.00 54.00 L 37.00 52.00 L 35.00 51.00 L 34.00 46.00 L 27.00 36.00 L 27.00 34.00 L 34.00 21.00 Z",
      "province": "REGION_185",
      "rootTerritory": "REGION_185",
      "viewBox": "0 0 37 83",
      "unitSlots": [
        {
          "name": "main",
          "x": 22,
          "y": 58,
          "territory": "REGION_185",
          "arrowReceiver": {
            "x": 22,
            "y": 88
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 22,
          "y": 58,
          "territory": "REGION_185",
          "arrowReceiver": {
            "x": 22,
            "y": 88
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_188": {
    "territory": "REGION_188",
    "unitSlotName": "main",
    "province": "REGION_188",
    "provinceMapData": {
      "abbr": "BOG",
      "type": "Land",
      "centerPos": {
        "x": 22,
        "y": 41
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 39,
          "y": 34,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 97,
      "x": 641,
      "y": 1047,
      "playable": true,
      "path": "M 48.00 0.00 L 42.00 3.00 L 39.00 3.00 L 38.00 4.00 L 33.00 5.00 L 31.00 7.00 L 27.00 8.00 L 21.00 13.00 L 20.00 16.00 L 12.00 24.00 L 10.00 40.00 L 15.00 43.00 L 15.00 51.00 L 1.00 76.00 L 1.00 79.00 L 0.00 80.00 L 0.00 94.00 L 2.00 94.00 L 15.00 81.00 L 27.00 81.00 L 40.00 92.00 L 53.00 90.00 L 57.00 95.00 L 57.00 97.00 L 59.00 97.00 L 60.00 81.00 L 57.00 78.00 L 60.00 74.00 L 60.00 58.00 L 58.00 55.00 L 58.00 52.00 L 69.00 37.00 L 69.00 19.00 L 65.00 17.00 L 63.00 17.00 L 59.00 14.00 L 56.00 14.00 L 53.00 11.00 Z",
      "province": "REGION_188",
      "rootTerritory": "REGION_188",
      "viewBox": "0 0 69 97",
      "unitSlots": [
        {
          "name": "main",
          "x": 32,
          "y": 78,
          "territory": "REGION_188",
          "arrowReceiver": {
            "x": 32,
            "y": 108
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 32,
          "y": 78,
          "territory": "REGION_188",
          "arrowReceiver": {
            "x": 32,
            "y": 108
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "波哥大": {
    "territory": "REGION_188",
    "unitSlotName": "main",
    "province": "REGION_188",
    "provinceMapData": {
      "abbr": "BOG",
      "type": "Land",
      "centerPos": {
        "x": 22,
        "y": 41
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 39,
          "y": 34,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 97,
      "x": 641,
      "y": 1047,
      "playable": true,
      "path": "M 48.00 0.00 L 42.00 3.00 L 39.00 3.00 L 38.00 4.00 L 33.00 5.00 L 31.00 7.00 L 27.00 8.00 L 21.00 13.00 L 20.00 16.00 L 12.00 24.00 L 10.00 40.00 L 15.00 43.00 L 15.00 51.00 L 1.00 76.00 L 1.00 79.00 L 0.00 80.00 L 0.00 94.00 L 2.00 94.00 L 15.00 81.00 L 27.00 81.00 L 40.00 92.00 L 53.00 90.00 L 57.00 95.00 L 57.00 97.00 L 59.00 97.00 L 60.00 81.00 L 57.00 78.00 L 60.00 74.00 L 60.00 58.00 L 58.00 55.00 L 58.00 52.00 L 69.00 37.00 L 69.00 19.00 L 65.00 17.00 L 63.00 17.00 L 59.00 14.00 L 56.00 14.00 L 53.00 11.00 Z",
      "province": "REGION_188",
      "rootTerritory": "REGION_188",
      "viewBox": "0 0 69 97",
      "unitSlots": [
        {
          "name": "main",
          "x": 32,
          "y": 78,
          "territory": "REGION_188",
          "arrowReceiver": {
            "x": 32,
            "y": 108
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 32,
          "y": 78,
          "territory": "REGION_188",
          "arrowReceiver": {
            "x": 32,
            "y": 108
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_190": {
    "territory": "REGION_190",
    "unitSlotName": "main",
    "province": "REGION_190",
    "provinceMapData": {
      "abbr": "CAQ",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 126,
          "y": 74,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 204,
      "height": 122,
      "x": 607,
      "y": 1127,
      "playable": true,
      "path": "M 0.00 49.00 L 1.00 62.00 L 5.00 66.00 L 15.00 71.00 L 28.00 72.00 L 33.00 77.00 L 46.00 83.00 L 51.00 88.00 L 55.00 99.00 L 65.00 103.00 L 76.00 118.00 L 89.00 119.00 L 94.00 122.00 L 98.00 122.00 L 101.00 116.00 L 113.00 116.00 L 120.00 120.00 L 131.00 120.00 L 132.00 119.00 L 143.00 120.00 L 149.00 112.00 L 163.00 111.00 L 178.00 95.00 L 196.00 86.00 L 201.00 86.00 L 204.00 81.00 L 204.00 78.00 L 199.00 69.00 L 199.00 55.00 L 198.00 54.00 L 195.00 54.00 L 183.00 47.00 L 167.00 48.00 L 149.00 32.00 L 142.00 33.00 L 135.00 29.00 L 121.00 29.00 L 116.00 32.00 L 98.00 23.00 L 93.00 18.00 L 92.00 13.00 L 89.00 9.00 L 76.00 11.00 L 63.00 0.00 L 47.00 0.00 L 36.00 11.00 L 35.00 10.00 L 35.00 4.00 L 32.00 4.00 L 20.00 10.00 L 14.00 20.00 L 14.00 22.00 L 19.00 27.00 L 18.00 43.00 L 12.00 49.00 Z",
      "province": "REGION_190",
      "rootTerritory": "REGION_190",
      "viewBox": "0 0 204 122",
      "unitSlots": [
        {
          "name": "main",
          "x": 103,
          "y": 62,
          "territory": "REGION_190",
          "arrowReceiver": {
            "x": 103,
            "y": 92
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 103,
          "y": 62,
          "territory": "REGION_190",
          "arrowReceiver": {
            "x": 103,
            "y": 92
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡克塔": {
    "territory": "REGION_190",
    "unitSlotName": "main",
    "province": "REGION_190",
    "provinceMapData": {
      "abbr": "CAQ",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 126,
          "y": 74,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 204,
      "height": 122,
      "x": 607,
      "y": 1127,
      "playable": true,
      "path": "M 0.00 49.00 L 1.00 62.00 L 5.00 66.00 L 15.00 71.00 L 28.00 72.00 L 33.00 77.00 L 46.00 83.00 L 51.00 88.00 L 55.00 99.00 L 65.00 103.00 L 76.00 118.00 L 89.00 119.00 L 94.00 122.00 L 98.00 122.00 L 101.00 116.00 L 113.00 116.00 L 120.00 120.00 L 131.00 120.00 L 132.00 119.00 L 143.00 120.00 L 149.00 112.00 L 163.00 111.00 L 178.00 95.00 L 196.00 86.00 L 201.00 86.00 L 204.00 81.00 L 204.00 78.00 L 199.00 69.00 L 199.00 55.00 L 198.00 54.00 L 195.00 54.00 L 183.00 47.00 L 167.00 48.00 L 149.00 32.00 L 142.00 33.00 L 135.00 29.00 L 121.00 29.00 L 116.00 32.00 L 98.00 23.00 L 93.00 18.00 L 92.00 13.00 L 89.00 9.00 L 76.00 11.00 L 63.00 0.00 L 47.00 0.00 L 36.00 11.00 L 35.00 10.00 L 35.00 4.00 L 32.00 4.00 L 20.00 10.00 L 14.00 20.00 L 14.00 22.00 L 19.00 27.00 L 18.00 43.00 L 12.00 49.00 Z",
      "province": "REGION_190",
      "rootTerritory": "REGION_190",
      "viewBox": "0 0 204 122",
      "unitSlots": [
        {
          "name": "main",
          "x": 103,
          "y": 62,
          "territory": "REGION_190",
          "arrowReceiver": {
            "x": 103,
            "y": 92
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 103,
          "y": 62,
          "territory": "REGION_190",
          "arrowReceiver": {
            "x": 103,
            "y": 92
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_192": {
    "territory": "REGION_192",
    "unitSlotName": "main",
    "province": "REGION_192",
    "provinceMapData": {
      "abbr": "CUM",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 63,
          "y": 45,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 79,
      "x": 831,
      "y": 989,
      "playable": true,
      "path": "M 7.00 2.00 L 0.00 9.00 L 0.00 12.00 L 10.00 11.00 L 17.00 19.00 L 19.00 30.00 L 31.00 41.00 L 38.00 41.00 L 44.00 45.00 L 48.00 55.00 L 59.00 68.00 L 58.00 79.00 L 63.00 79.00 L 72.00 72.00 L 72.00 62.00 L 81.00 52.00 L 81.00 36.00 L 76.00 33.00 L 68.00 24.00 L 69.00 23.00 L 69.00 10.00 L 46.00 12.00 L 37.00 7.00 L 36.00 0.00 Z",
      "province": "REGION_192",
      "rootTerritory": "REGION_192",
      "viewBox": "0 0 81 79",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 12,
          "territory": "REGION_192",
          "arrowReceiver": {
            "x": 29,
            "y": 42
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 12,
          "territory": "REGION_192",
          "arrowReceiver": {
            "x": 29,
            "y": 42
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "库马纳": {
    "territory": "REGION_192",
    "unitSlotName": "main",
    "province": "REGION_192",
    "provinceMapData": {
      "abbr": "CUM",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 63,
          "y": 45,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 79,
      "x": 831,
      "y": 989,
      "playable": true,
      "path": "M 7.00 2.00 L 0.00 9.00 L 0.00 12.00 L 10.00 11.00 L 17.00 19.00 L 19.00 30.00 L 31.00 41.00 L 38.00 41.00 L 44.00 45.00 L 48.00 55.00 L 59.00 68.00 L 58.00 79.00 L 63.00 79.00 L 72.00 72.00 L 72.00 62.00 L 81.00 52.00 L 81.00 36.00 L 76.00 33.00 L 68.00 24.00 L 69.00 23.00 L 69.00 10.00 L 46.00 12.00 L 37.00 7.00 L 36.00 0.00 Z",
      "province": "REGION_192",
      "rootTerritory": "REGION_192",
      "viewBox": "0 0 81 79",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 12,
          "territory": "REGION_192",
          "arrowReceiver": {
            "x": 29,
            "y": 42
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 12,
          "territory": "REGION_192",
          "arrowReceiver": {
            "x": 29,
            "y": 42
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_193": {
    "territory": "REGION_193",
    "unitSlotName": "main",
    "province": "REGION_193",
    "provinceMapData": {
      "abbr": "CCS",
      "type": "Coast",
      "centerPos": {
        "x": 58,
        "y": 8
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 110,
      "height": 53,
      "x": 753,
      "y": 992,
      "playable": true,
      "path": "M 0.00 16.00 L 0.00 18.00 L 9.00 18.00 L 28.00 43.00 L 36.00 48.00 L 48.00 53.00 L 52.00 53.00 L 59.00 49.00 L 78.00 50.00 L 101.00 38.00 L 110.00 38.00 L 110.00 36.00 L 98.00 25.00 L 96.00 14.00 L 90.00 7.00 L 75.00 9.00 L 59.00 0.00 L 20.00 1.00 L 17.00 3.00 L 7.00 3.00 Z",
      "province": "REGION_193",
      "rootTerritory": "REGION_193",
      "viewBox": "0 0 110 53",
      "unitSlots": [
        {
          "name": "main",
          "x": 42,
          "y": 16,
          "territory": "REGION_193",
          "arrowReceiver": {
            "x": 42,
            "y": 46
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42,
          "y": 16,
          "territory": "REGION_193",
          "arrowReceiver": {
            "x": 42,
            "y": 46
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "加拉加斯": {
    "territory": "REGION_193",
    "unitSlotName": "main",
    "province": "REGION_193",
    "provinceMapData": {
      "abbr": "CCS",
      "type": "Coast",
      "centerPos": {
        "x": 58,
        "y": 8
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 110,
      "height": 53,
      "x": 753,
      "y": 992,
      "playable": true,
      "path": "M 0.00 16.00 L 0.00 18.00 L 9.00 18.00 L 28.00 43.00 L 36.00 48.00 L 48.00 53.00 L 52.00 53.00 L 59.00 49.00 L 78.00 50.00 L 101.00 38.00 L 110.00 38.00 L 110.00 36.00 L 98.00 25.00 L 96.00 14.00 L 90.00 7.00 L 75.00 9.00 L 59.00 0.00 L 20.00 1.00 L 17.00 3.00 L 7.00 3.00 Z",
      "province": "REGION_193",
      "rootTerritory": "REGION_193",
      "viewBox": "0 0 110 53",
      "unitSlots": [
        {
          "name": "main",
          "x": 42,
          "y": 16,
          "territory": "REGION_193",
          "arrowReceiver": {
            "x": 42,
            "y": 46
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 42,
          "y": 16,
          "territory": "REGION_193",
          "arrowReceiver": {
            "x": 42,
            "y": 46
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_195": {
    "territory": "REGION_195",
    "unitSlotName": "main",
    "province": "REGION_195",
    "provinceMapData": {
      "abbr": "ANG",
      "type": "Land",
      "centerPos": {
        "x": 67,
        "y": 46
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 84,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 127,
      "height": 141,
      "x": 771,
      "y": 1029,
      "playable": true,
      "path": "M 104.00 2.00 L 100.00 0.00 L 81.00 0.00 L 58.00 12.00 L 39.00 11.00 L 32.00 15.00 L 22.00 15.00 L 0.00 53.00 L 0.00 78.00 L 7.00 89.00 L 18.00 94.00 L 28.00 102.00 L 27.00 108.00 L 19.00 115.00 L 20.00 135.00 L 23.00 140.00 L 30.00 141.00 L 29.00 129.00 L 33.00 126.00 L 47.00 127.00 L 67.00 113.00 L 68.00 108.00 L 61.00 101.00 L 58.00 95.00 L 58.00 75.00 L 60.00 73.00 L 74.00 73.00 L 83.00 78.00 L 89.00 78.00 L 111.00 67.00 L 118.00 55.00 L 127.00 50.00 L 126.00 45.00 L 119.00 37.00 L 120.00 26.00 L 109.00 13.00 Z",
      "province": "REGION_195",
      "rootTerritory": "REGION_195",
      "viewBox": "0 0 127 141",
      "unitSlots": [
        {
          "name": "main",
          "x": 60,
          "y": 55,
          "territory": "REGION_195",
          "arrowReceiver": {
            "x": 60,
            "y": 85
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 60,
          "y": 55,
          "territory": "REGION_195",
          "arrowReceiver": {
            "x": 60,
            "y": 85
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "安戈斯图拉": {
    "territory": "REGION_195",
    "unitSlotName": "main",
    "province": "REGION_195",
    "provinceMapData": {
      "abbr": "ANG",
      "type": "Land",
      "centerPos": {
        "x": 67,
        "y": 46
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 84,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 127,
      "height": 141,
      "x": 771,
      "y": 1029,
      "playable": true,
      "path": "M 104.00 2.00 L 100.00 0.00 L 81.00 0.00 L 58.00 12.00 L 39.00 11.00 L 32.00 15.00 L 22.00 15.00 L 0.00 53.00 L 0.00 78.00 L 7.00 89.00 L 18.00 94.00 L 28.00 102.00 L 27.00 108.00 L 19.00 115.00 L 20.00 135.00 L 23.00 140.00 L 30.00 141.00 L 29.00 129.00 L 33.00 126.00 L 47.00 127.00 L 67.00 113.00 L 68.00 108.00 L 61.00 101.00 L 58.00 95.00 L 58.00 75.00 L 60.00 73.00 L 74.00 73.00 L 83.00 78.00 L 89.00 78.00 L 111.00 67.00 L 118.00 55.00 L 127.00 50.00 L 126.00 45.00 L 119.00 37.00 L 120.00 26.00 L 109.00 13.00 Z",
      "province": "REGION_195",
      "rootTerritory": "REGION_195",
      "viewBox": "0 0 127 141",
      "unitSlots": [
        {
          "name": "main",
          "x": 60,
          "y": 55,
          "territory": "REGION_195",
          "arrowReceiver": {
            "x": 60,
            "y": 85
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 60,
          "y": 55,
          "territory": "REGION_195",
          "arrowReceiver": {
            "x": 60,
            "y": 85
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M001": {
    "territory": "M001",
    "unitSlotName": "main",
    "province": "M001",
    "provinceMapData": {
      "abbr": "NWT",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 117,
          "y": 137,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 538,
      "height": 231,
      "x": 184,
      "y": 91,
      "playable": true,
      "path": "M 0.00 176.00 L 40.00 188.00 L 52.00 196.00 L 58.00 205.00 L 56.00 223.00 L 63.00 230.00 L 88.00 231.00 L 89.00 230.00 L 100.00 230.00 L 101.00 229.00 L 115.00 229.00 L 124.00 224.00 L 130.00 224.00 L 135.00 221.00 L 143.00 220.00 L 178.00 202.00 L 200.00 203.00 L 203.00 201.00 L 210.00 201.00 L 215.00 198.00 L 220.00 197.00 L 225.00 191.00 L 225.00 174.00 L 223.00 170.00 L 213.00 163.00 L 201.00 160.00 L 197.00 157.00 L 200.00 150.00 L 217.00 137.00 L 237.00 128.00 L 253.00 128.00 L 261.00 125.00 L 267.00 125.00 L 284.00 116.00 L 296.00 117.00 L 304.00 110.00 L 311.00 110.00 L 334.00 100.00 L 345.00 101.00 L 350.00 104.00 L 361.00 105.00 L 369.00 96.00 L 374.00 96.00 L 377.00 93.00 L 378.00 84.00 L 380.00 79.00 L 390.00 78.00 L 394.00 73.00 L 450.00 78.00 L 451.00 79.00 L 451.00 88.00 L 449.00 90.00 L 449.00 92.00 L 455.00 94.00 L 459.00 99.00 L 459.00 106.00 L 457.00 108.00 L 457.00 110.00 L 468.00 109.00 L 474.00 116.00 L 489.00 123.00 L 498.00 135.00 L 498.00 145.00 L 504.00 144.00 L 511.00 148.00 L 530.00 148.00 L 532.00 140.00 L 538.00 136.00 L 538.00 118.00 L 528.00 99.00 L 528.00 91.00 L 523.00 88.00 L 508.00 87.00 L 491.00 72.00 L 489.00 61.00 L 475.00 48.00 L 473.00 44.00 L 460.00 44.00 L 448.00 33.00 L 431.00 30.00 L 428.00 26.00 L 411.00 27.00 L 401.00 20.00 L 378.00 20.00 L 377.00 21.00 L 359.00 20.00 L 351.00 25.00 L 340.00 26.00 L 333.00 30.00 L 329.00 30.00 L 321.00 26.00 L 316.00 21.00 L 316.00 17.00 L 293.00 18.00 L 278.00 10.00 L 262.00 7.00 L 254.00 0.00 L 230.00 0.00 L 216.00 8.00 L 211.00 9.00 L 206.00 17.00 L 207.00 31.00 L 216.00 36.00 L 217.00 42.00 L 214.00 45.00 L 209.00 44.00 L 200.00 35.00 L 195.00 35.00 L 192.00 33.00 L 188.00 33.00 L 183.00 28.00 L 152.00 27.00 L 147.00 24.00 L 133.00 24.00 L 131.00 22.00 L 128.00 22.00 L 128.00 27.00 L 129.00 28.00 L 128.00 31.00 L 127.00 30.00 L 121.00 31.00 L 73.00 65.00 L 23.00 90.00 L 10.00 101.00 L 12.00 107.00 L 20.00 113.00 L 21.00 128.00 L 9.00 152.00 L 6.00 155.00 L 6.00 172.00 L 4.00 174.00 L 0.00 174.00 Z",
      "province": "M001",
      "rootTerritory": "M001",
      "viewBox": "0 0 538 231",
      "unitSlots": [
        {
          "name": "main",
          "x": 196,
          "y": 86,
          "territory": "M001",
          "arrowReceiver": {
            "x": 196,
            "y": 116
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 196,
          "y": 86,
          "territory": "M001",
          "arrowReceiver": {
            "x": 196,
            "y": 116
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "西北领地": {
    "territory": "M001",
    "unitSlotName": "main",
    "province": "M001",
    "provinceMapData": {
      "abbr": "NWT",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 117,
          "y": 137,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 538,
      "height": 231,
      "x": 184,
      "y": 91,
      "playable": true,
      "path": "M 0.00 176.00 L 40.00 188.00 L 52.00 196.00 L 58.00 205.00 L 56.00 223.00 L 63.00 230.00 L 88.00 231.00 L 89.00 230.00 L 100.00 230.00 L 101.00 229.00 L 115.00 229.00 L 124.00 224.00 L 130.00 224.00 L 135.00 221.00 L 143.00 220.00 L 178.00 202.00 L 200.00 203.00 L 203.00 201.00 L 210.00 201.00 L 215.00 198.00 L 220.00 197.00 L 225.00 191.00 L 225.00 174.00 L 223.00 170.00 L 213.00 163.00 L 201.00 160.00 L 197.00 157.00 L 200.00 150.00 L 217.00 137.00 L 237.00 128.00 L 253.00 128.00 L 261.00 125.00 L 267.00 125.00 L 284.00 116.00 L 296.00 117.00 L 304.00 110.00 L 311.00 110.00 L 334.00 100.00 L 345.00 101.00 L 350.00 104.00 L 361.00 105.00 L 369.00 96.00 L 374.00 96.00 L 377.00 93.00 L 378.00 84.00 L 380.00 79.00 L 390.00 78.00 L 394.00 73.00 L 450.00 78.00 L 451.00 79.00 L 451.00 88.00 L 449.00 90.00 L 449.00 92.00 L 455.00 94.00 L 459.00 99.00 L 459.00 106.00 L 457.00 108.00 L 457.00 110.00 L 468.00 109.00 L 474.00 116.00 L 489.00 123.00 L 498.00 135.00 L 498.00 145.00 L 504.00 144.00 L 511.00 148.00 L 530.00 148.00 L 532.00 140.00 L 538.00 136.00 L 538.00 118.00 L 528.00 99.00 L 528.00 91.00 L 523.00 88.00 L 508.00 87.00 L 491.00 72.00 L 489.00 61.00 L 475.00 48.00 L 473.00 44.00 L 460.00 44.00 L 448.00 33.00 L 431.00 30.00 L 428.00 26.00 L 411.00 27.00 L 401.00 20.00 L 378.00 20.00 L 377.00 21.00 L 359.00 20.00 L 351.00 25.00 L 340.00 26.00 L 333.00 30.00 L 329.00 30.00 L 321.00 26.00 L 316.00 21.00 L 316.00 17.00 L 293.00 18.00 L 278.00 10.00 L 262.00 7.00 L 254.00 0.00 L 230.00 0.00 L 216.00 8.00 L 211.00 9.00 L 206.00 17.00 L 207.00 31.00 L 216.00 36.00 L 217.00 42.00 L 214.00 45.00 L 209.00 44.00 L 200.00 35.00 L 195.00 35.00 L 192.00 33.00 L 188.00 33.00 L 183.00 28.00 L 152.00 27.00 L 147.00 24.00 L 133.00 24.00 L 131.00 22.00 L 128.00 22.00 L 128.00 27.00 L 129.00 28.00 L 128.00 31.00 L 127.00 30.00 L 121.00 31.00 L 73.00 65.00 L 23.00 90.00 L 10.00 101.00 L 12.00 107.00 L 20.00 113.00 L 21.00 128.00 L 9.00 152.00 L 6.00 155.00 L 6.00 172.00 L 4.00 174.00 L 0.00 174.00 Z",
      "province": "M001",
      "rootTerritory": "M001",
      "viewBox": "0 0 538 231",
      "unitSlots": [
        {
          "name": "main",
          "x": 196,
          "y": 86,
          "territory": "M001",
          "arrowReceiver": {
            "x": 196,
            "y": 116
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 196,
          "y": 86,
          "territory": "M001",
          "arrowReceiver": {
            "x": 196,
            "y": 116
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M002": {
    "territory": "M002",
    "unitSlotName": "main",
    "province": "M002",
    "provinceMapData": {
      "abbr": "GRE",
      "type": "Coast",
      "centerPos": {
        "x": 182,
        "y": 89
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 199,
          "y": 82,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 327,
      "height": 202,
      "x": 569,
      "y": 41,
      "playable": true,
      "path": "M 2.00 30.00 L 0.00 57.00 L 7.00 64.00 L 26.00 64.00 L 29.00 66.00 L 43.00 66.00 L 49.00 62.00 L 52.00 56.00 L 54.00 58.00 L 77.00 61.00 L 87.00 68.00 L 111.00 68.00 L 114.00 66.00 L 122.00 73.00 L 130.00 73.00 L 135.00 79.00 L 143.00 81.00 L 157.00 96.00 L 175.00 101.00 L 180.00 109.00 L 197.00 113.00 L 202.00 118.00 L 201.00 135.00 L 229.00 162.00 L 237.00 164.00 L 244.00 175.00 L 255.00 180.00 L 263.00 190.00 L 275.00 195.00 L 278.00 198.00 L 278.00 200.00 L 300.00 199.00 L 305.00 202.00 L 323.00 202.00 L 326.00 199.00 L 325.00 179.00 L 317.00 171.00 L 317.00 156.00 L 310.00 143.00 L 310.00 141.00 L 319.00 134.00 L 319.00 116.00 L 318.00 113.00 L 327.00 106.00 L 327.00 80.00 L 312.00 72.00 L 300.00 72.00 L 293.00 69.00 L 274.00 53.00 L 263.00 38.00 L 242.00 33.00 L 234.00 24.00 L 227.00 23.00 L 222.00 20.00 L 210.00 19.00 L 178.00 2.00 L 150.00 5.00 L 141.00 0.00 L 115.00 0.00 L 75.00 13.00 L 44.00 17.00 L 17.00 31.00 Z",
      "province": "M002",
      "rootTerritory": "M002",
      "viewBox": "0 0 327 202",
      "unitSlots": [
        {
          "name": "main",
          "x": 155,
          "y": 44,
          "territory": "M002",
          "arrowReceiver": {
            "x": 155,
            "y": 74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 155,
          "y": 44,
          "territory": "M002",
          "arrowReceiver": {
            "x": 155,
            "y": 74
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "格陵兰": {
    "territory": "M002",
    "unitSlotName": "main",
    "province": "M002",
    "provinceMapData": {
      "abbr": "GRE",
      "type": "Coast",
      "centerPos": {
        "x": 182,
        "y": 89
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 199,
          "y": 82,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 327,
      "height": 202,
      "x": 569,
      "y": 41,
      "playable": true,
      "path": "M 2.00 30.00 L 0.00 57.00 L 7.00 64.00 L 26.00 64.00 L 29.00 66.00 L 43.00 66.00 L 49.00 62.00 L 52.00 56.00 L 54.00 58.00 L 77.00 61.00 L 87.00 68.00 L 111.00 68.00 L 114.00 66.00 L 122.00 73.00 L 130.00 73.00 L 135.00 79.00 L 143.00 81.00 L 157.00 96.00 L 175.00 101.00 L 180.00 109.00 L 197.00 113.00 L 202.00 118.00 L 201.00 135.00 L 229.00 162.00 L 237.00 164.00 L 244.00 175.00 L 255.00 180.00 L 263.00 190.00 L 275.00 195.00 L 278.00 198.00 L 278.00 200.00 L 300.00 199.00 L 305.00 202.00 L 323.00 202.00 L 326.00 199.00 L 325.00 179.00 L 317.00 171.00 L 317.00 156.00 L 310.00 143.00 L 310.00 141.00 L 319.00 134.00 L 319.00 116.00 L 318.00 113.00 L 327.00 106.00 L 327.00 80.00 L 312.00 72.00 L 300.00 72.00 L 293.00 69.00 L 274.00 53.00 L 263.00 38.00 L 242.00 33.00 L 234.00 24.00 L 227.00 23.00 L 222.00 20.00 L 210.00 19.00 L 178.00 2.00 L 150.00 5.00 L 141.00 0.00 L 115.00 0.00 L 75.00 13.00 L 44.00 17.00 L 17.00 31.00 Z",
      "province": "M002",
      "rootTerritory": "M002",
      "viewBox": "0 0 327 202",
      "unitSlots": [
        {
          "name": "main",
          "x": 155,
          "y": 44,
          "territory": "M002",
          "arrowReceiver": {
            "x": 155,
            "y": 74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 155,
          "y": 44,
          "territory": "M002",
          "arrowReceiver": {
            "x": 155,
            "y": 74
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M003": {
    "territory": "M003",
    "unitSlotName": "main",
    "province": "M003",
    "provinceMapData": {
      "abbr": "BAH",
      "type": "Coast",
      "centerPos": {
        "x": 39,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 56,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 111,
      "height": 95,
      "x": 623,
      "y": 642,
      "playable": true,
      "path": "M 110.00 0.00 L 3.00 1.00 L 0.00 45.00 L 5.00 50.00 L 6.00 95.00 L 79.00 95.00 L 87.00 86.00 L 100.00 86.00 L 101.00 85.00 L 106.00 86.00 L 111.00 81.00 Z",
      "province": "M003",
      "rootTerritory": "M003",
      "viewBox": "0 0 111 95",
      "unitSlots": [
        {
          "name": "main",
          "x": 61,
          "y": 70,
          "territory": "M003",
          "arrowReceiver": {
            "x": 61,
            "y": 100
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 61,
          "y": 70,
          "territory": "M003",
          "arrowReceiver": {
            "x": 61,
            "y": 100
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "巴哈马": {
    "territory": "M003",
    "unitSlotName": "main",
    "province": "M003",
    "provinceMapData": {
      "abbr": "BAH",
      "type": "Coast",
      "centerPos": {
        "x": 39,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 56,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 111,
      "height": 95,
      "x": 623,
      "y": 642,
      "playable": true,
      "path": "M 110.00 0.00 L 3.00 1.00 L 0.00 45.00 L 5.00 50.00 L 6.00 95.00 L 79.00 95.00 L 87.00 86.00 L 100.00 86.00 L 101.00 85.00 L 106.00 86.00 L 111.00 81.00 Z",
      "province": "M003",
      "rootTerritory": "M003",
      "viewBox": "0 0 111 95",
      "unitSlots": [
        {
          "name": "main",
          "x": 61,
          "y": 70,
          "territory": "M003",
          "arrowReceiver": {
            "x": 61,
            "y": 100
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 61,
          "y": 70,
          "territory": "M003",
          "arrowReceiver": {
            "x": 61,
            "y": 100
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M004": {
    "territory": "M004",
    "unitSlotName": "main",
    "province": "M004",
    "provinceMapData": {
      "abbr": "HAI",
      "type": "Coast",
      "centerPos": {
        "x": 25,
        "y": 29
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 42,
          "y": 26,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 59,
      "height": 55,
      "x": 707,
      "y": 824,
      "playable": true,
      "path": "M 59.00 0.00 L 56.00 0.00 L 53.00 2.00 L 33.00 2.00 L 31.00 6.00 L 31.00 12.00 L 19.00 26.00 L 20.00 43.00 L 13.00 51.00 L 3.00 51.00 L 0.00 52.00 L 0.00 54.00 L 13.00 54.00 L 14.00 55.00 L 43.00 54.00 L 48.00 44.00 L 53.00 39.00 L 56.00 38.00 L 59.00 33.00 Z",
      "province": "M004",
      "rootTerritory": "M004",
      "viewBox": "0 0 59 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 28,
          "y": 26,
          "territory": "M004",
          "arrowReceiver": {
            "x": 28,
            "y": 56
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28,
          "y": 26,
          "territory": "M004",
          "arrowReceiver": {
            "x": 28,
            "y": 56
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "海地": {
    "territory": "M004",
    "unitSlotName": "main",
    "province": "M004",
    "provinceMapData": {
      "abbr": "HAI",
      "type": "Coast",
      "centerPos": {
        "x": 25,
        "y": 29
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 42,
          "y": 26,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 59,
      "height": 55,
      "x": 707,
      "y": 824,
      "playable": true,
      "path": "M 59.00 0.00 L 56.00 0.00 L 53.00 2.00 L 33.00 2.00 L 31.00 6.00 L 31.00 12.00 L 19.00 26.00 L 20.00 43.00 L 13.00 51.00 L 3.00 51.00 L 0.00 52.00 L 0.00 54.00 L 13.00 54.00 L 14.00 55.00 L 43.00 54.00 L 48.00 44.00 L 53.00 39.00 L 56.00 38.00 L 59.00 33.00 Z",
      "province": "M004",
      "rootTerritory": "M004",
      "viewBox": "0 0 59 55",
      "unitSlots": [
        {
          "name": "main",
          "x": 28,
          "y": 26,
          "territory": "M004",
          "arrowReceiver": {
            "x": 28,
            "y": 56
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28,
          "y": 26,
          "territory": "M004",
          "arrowReceiver": {
            "x": 28,
            "y": 56
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M005": {
    "territory": "M005",
    "unitSlotName": "main",
    "province": "M005",
    "provinceMapData": {
      "abbr": "WIN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34,
          "y": 37,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 68,
      "height": 99,
      "x": 879,
      "y": 875,
      "playable": true,
      "path": "M 66.00 0.00 L 62.00 0.00 L 61.00 1.00 L 20.00 1.00 L 9.00 7.00 L 9.00 13.00 L 0.00 21.00 L 1.00 99.00 L 21.00 99.00 L 28.00 95.00 L 62.00 96.00 L 64.00 92.00 L 63.00 87.00 L 67.00 84.00 L 67.00 76.00 L 68.00 75.00 L 68.00 2.00 Z",
      "province": "M005",
      "rootTerritory": "M005",
      "viewBox": "0 0 68 99",
      "unitSlots": [
        {
          "name": "main",
          "x": 26,
          "y": 78,
          "territory": "M005",
          "arrowReceiver": {
            "x": 26,
            "y": 108
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 26,
          "y": 78,
          "territory": "M005",
          "arrowReceiver": {
            "x": 26,
            "y": 108
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "西印度群岛": {
    "territory": "M005",
    "unitSlotName": "main",
    "province": "M005",
    "provinceMapData": {
      "abbr": "WIN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 34,
          "y": 37,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 68,
      "height": 99,
      "x": 879,
      "y": 875,
      "playable": true,
      "path": "M 66.00 0.00 L 62.00 0.00 L 61.00 1.00 L 20.00 1.00 L 9.00 7.00 L 9.00 13.00 L 0.00 21.00 L 1.00 99.00 L 21.00 99.00 L 28.00 95.00 L 62.00 96.00 L 64.00 92.00 L 63.00 87.00 L 67.00 84.00 L 67.00 76.00 L 68.00 75.00 L 68.00 2.00 Z",
      "province": "M005",
      "rootTerritory": "M005",
      "viewBox": "0 0 68 99",
      "unitSlots": [
        {
          "name": "main",
          "x": 26,
          "y": 78,
          "territory": "M005",
          "arrowReceiver": {
            "x": 26,
            "y": 108
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 26,
          "y": 78,
          "territory": "M005",
          "arrowReceiver": {
            "x": 26,
            "y": 108
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_50_a": {
    "territory": "REGION_50_a",
    "unitSlotName": "main",
    "province": "REGION_50_a",
    "provinceMapData": {
      "abbr": "FIS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 44,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 64,
      "height": 79,
      "x": 534,
      "y": 727,
      "playable": true,
      "path": "M 4.00 3.00 L 0.00 77.00 L 3.00 76.00 L 5.00 71.00 L 56.00 70.00 L 57.00 71.00 L 57.00 79.00 L 63.00 78.00 L 62.00 40.00 L 63.00 39.00 L 63.00 29.00 L 64.00 28.00 L 64.00 15.00 L 58.00 12.00 L 51.00 11.00 L 46.00 3.00 L 44.00 3.00 L 41.00 8.00 L 40.00 18.00 L 38.00 20.00 L 34.00 16.00 L 24.00 0.00 Z",
      "province": "REGION_50_a",
      "rootTerritory": "REGION_50_a",
      "viewBox": "0 0 64 79",
      "unitSlots": [
        {
          "name": "main",
          "x": 32,
          "y": 41,
          "territory": "REGION_50_a",
          "arrowReceiver": {
            "x": 32,
            "y": 71
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 32,
          "y": 41,
          "territory": "REGION_50_a",
          "arrowReceiver": {
            "x": 32,
            "y": 71
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "佛罗里达海峡": {
    "territory": "REGION_50_a",
    "unitSlotName": "main",
    "province": "REGION_50_a",
    "provinceMapData": {
      "abbr": "FIS",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 44,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 64,
      "height": 79,
      "x": 534,
      "y": 727,
      "playable": true,
      "path": "M 4.00 3.00 L 0.00 77.00 L 3.00 76.00 L 5.00 71.00 L 56.00 70.00 L 57.00 71.00 L 57.00 79.00 L 63.00 78.00 L 62.00 40.00 L 63.00 39.00 L 63.00 29.00 L 64.00 28.00 L 64.00 15.00 L 58.00 12.00 L 51.00 11.00 L 46.00 3.00 L 44.00 3.00 L 41.00 8.00 L 40.00 18.00 L 38.00 20.00 L 34.00 16.00 L 24.00 0.00 Z",
      "province": "REGION_50_a",
      "rootTerritory": "REGION_50_a",
      "viewBox": "0 0 64 79",
      "unitSlots": [
        {
          "name": "main",
          "x": 32,
          "y": 41,
          "territory": "REGION_50_a",
          "arrowReceiver": {
            "x": 32,
            "y": 71
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 32,
          "y": 41,
          "territory": "REGION_50_a",
          "arrowReceiver": {
            "x": 32,
            "y": 71
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_49_a": {
    "territory": "REGION_49_a",
    "unitSlotName": "main",
    "province": "REGION_49_a",
    "provinceMapData": {
      "abbr": "CVB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 156,
          "y": 101,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 209,
      "height": 160,
      "x": 568,
      "y": 680,
      "playable": true,
      "path": "M 0.000 0.000 L 0.000 16.000 L 5.000 25.000 L 6.000 39.000 L 10.000 51.000 L 15.000 59.000 L 25.000 61.000 L 29.000 64.000 L 28.000 84.000 L 27.000 85.000 L 27.000 108.000 L 28.000 109.000 L 26.687 133.733 L 29.177 134.219 L 52.838 138.832 L 58.594 139.954 L 65.525 141.305 L 73.000 136.000 L 98.000 137.000 L 110.000 150.000 L 141.000 150.000 L 143.210 155.814 L 165.664 159.584 L 165.664 159.584 L 165.664 159.584 L 165.664 159.584 L 171.000 158.000 L 171.000 152.000 L 174.000 147.000 L 194.000 147.000 L 204.000 141.000 L 209.000 141.000 L 209.000 120.000 L 208.000 119.000 L 207.000 101.000 L 206.000 100.000 L 206.000 85.000 L 203.000 80.000 L 201.000 53.000 L 193.000 45.000 L 170.000 46.000 L 167.000 43.000 L 163.000 43.000 L 159.000 47.000 L 158.000 46.000 L 140.000 47.000 L 132.000 56.000 L 63.000 56.000 L 62.000 55.000 L 61.000 10.000 L 56.314 1.228 L 56.314 1.228 Z",
      "province": "REGION_49_a",
      "rootTerritory": "REGION_49_a",
      "viewBox": "0 0 209 160",
      "unitSlots": [
        {
          "name": "main",
          "x": 112,
          "y": 116,
          "territory": "REGION_49_a",
          "arrowReceiver": {
            "x": 112,
            "y": 146
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 112,
          "y": 116,
          "territory": "REGION_49_a",
          "arrowReceiver": {
            "x": 112,
            "y": 146
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "巴哈马海峡": {
    "territory": "REGION_49_a",
    "unitSlotName": "main",
    "province": "REGION_49_a",
    "provinceMapData": {
      "abbr": "CVB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 156,
          "y": 101,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 209,
      "height": 160,
      "x": 568,
      "y": 680,
      "playable": true,
      "path": "M 0.000 0.000 L 0.000 16.000 L 5.000 25.000 L 6.000 39.000 L 10.000 51.000 L 15.000 59.000 L 25.000 61.000 L 29.000 64.000 L 28.000 84.000 L 27.000 85.000 L 27.000 108.000 L 28.000 109.000 L 26.687 133.733 L 29.177 134.219 L 52.838 138.832 L 58.594 139.954 L 65.525 141.305 L 73.000 136.000 L 98.000 137.000 L 110.000 150.000 L 141.000 150.000 L 143.210 155.814 L 165.664 159.584 L 165.664 159.584 L 165.664 159.584 L 165.664 159.584 L 171.000 158.000 L 171.000 152.000 L 174.000 147.000 L 194.000 147.000 L 204.000 141.000 L 209.000 141.000 L 209.000 120.000 L 208.000 119.000 L 207.000 101.000 L 206.000 100.000 L 206.000 85.000 L 203.000 80.000 L 201.000 53.000 L 193.000 45.000 L 170.000 46.000 L 167.000 43.000 L 163.000 43.000 L 159.000 47.000 L 158.000 46.000 L 140.000 47.000 L 132.000 56.000 L 63.000 56.000 L 62.000 55.000 L 61.000 10.000 L 56.314 1.228 L 56.314 1.228 Z",
      "province": "REGION_49_a",
      "rootTerritory": "REGION_49_a",
      "viewBox": "0 0 209 160",
      "unitSlots": [
        {
          "name": "main",
          "x": 112,
          "y": 116,
          "territory": "REGION_49_a",
          "arrowReceiver": {
            "x": 112,
            "y": 146
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 112,
          "y": 116,
          "territory": "REGION_49_a",
          "arrowReceiver": {
            "x": 112,
            "y": 146
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M006": {
    "territory": "M006",
    "unitSlotName": "main",
    "province": "M006",
    "provinceMapData": {
      "abbr": "STC",
      "type": "Coast",
      "centerPos": {
        "x": 27,
        "y": 1
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 22,
          "y": 18,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 79,
      "height": 40,
      "x": 632,
      "y": 815,
      "playable": true,
      "path": "M 0.00 7.00 L 0.00 9.00 L 3.00 9.00 L 5.00 12.00 L 5.00 28.00 L 10.00 32.00 L 10.00 38.00 L 14.00 38.00 L 15.00 39.00 L 22.00 39.00 L 23.00 40.00 L 26.00 40.00 L 30.00 34.00 L 35.00 33.00 L 36.00 32.00 L 39.00 32.00 L 40.00 31.00 L 41.00 32.00 L 44.00 26.00 L 57.00 27.00 L 69.00 20.00 L 79.00 21.00 L 79.00 14.00 L 48.00 14.00 L 36.00 1.00 L 7.00 0.00 Z",
      "province": "M006",
      "rootTerritory": "M006",
      "viewBox": "0 0 79 40",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 25,
          "territory": "M006",
          "arrowReceiver": {
            "x": 24,
            "y": 55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 25,
          "territory": "M006",
          "arrowReceiver": {
            "x": 24,
            "y": 55
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "古巴圣地亚哥": {
    "territory": "M006",
    "unitSlotName": "main",
    "province": "M006",
    "provinceMapData": {
      "abbr": "STC",
      "type": "Coast",
      "centerPos": {
        "x": 27,
        "y": 1
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 22,
          "y": 18,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 79,
      "height": 40,
      "x": 632,
      "y": 815,
      "playable": true,
      "path": "M 0.00 7.00 L 0.00 9.00 L 3.00 9.00 L 5.00 12.00 L 5.00 28.00 L 10.00 32.00 L 10.00 38.00 L 14.00 38.00 L 15.00 39.00 L 22.00 39.00 L 23.00 40.00 L 26.00 40.00 L 30.00 34.00 L 35.00 33.00 L 36.00 32.00 L 39.00 32.00 L 40.00 31.00 L 41.00 32.00 L 44.00 26.00 L 57.00 27.00 L 69.00 20.00 L 79.00 21.00 L 79.00 14.00 L 48.00 14.00 L 36.00 1.00 L 7.00 0.00 Z",
      "province": "M006",
      "rootTerritory": "M006",
      "viewBox": "0 0 79 40",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 25,
          "territory": "M006",
          "arrowReceiver": {
            "x": 24,
            "y": 55
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 25,
          "territory": "M006",
          "arrowReceiver": {
            "x": 24,
            "y": 55
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M007": {
    "territory": "M007",
    "unitSlotName": "main",
    "province": "M007",
    "provinceMapData": {
      "abbr": "HAV",
      "type": "Coast",
      "centerPos": {
        "x": 33,
        "y": -1
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 24,
          "y": 16,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 70,
      "height": 36,
      "x": 522,
      "y": 796,
      "playable": true,
      "path": "M 70.00 0.00 L 15.00 1.00 L 14.00 5.00 L 0.00 20.00 L 0.00 33.00 L 2.00 36.00 L 17.00 36.00 L 42.00 23.00 L 48.00 24.00 L 49.00 25.00 L 68.00 25.00 L 68.00 24.00 L 70.00 23.00 Z",
      "province": "M007",
      "rootTerritory": "M007",
      "viewBox": "0 0 70 36",
      "unitSlots": [
        {
          "name": "main",
          "x": 34,
          "y": 6,
          "territory": "M007",
          "arrowReceiver": {
            "x": 34,
            "y": 36
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34,
          "y": 6,
          "territory": "M007",
          "arrowReceiver": {
            "x": 34,
            "y": 36
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "哈瓦那": {
    "territory": "M007",
    "unitSlotName": "main",
    "province": "M007",
    "provinceMapData": {
      "abbr": "HAV",
      "type": "Coast",
      "centerPos": {
        "x": 33,
        "y": -1
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 24,
          "y": 16,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 70,
      "height": 36,
      "x": 522,
      "y": 796,
      "playable": true,
      "path": "M 70.00 0.00 L 15.00 1.00 L 14.00 5.00 L 0.00 20.00 L 0.00 33.00 L 2.00 36.00 L 17.00 36.00 L 42.00 23.00 L 48.00 24.00 L 49.00 25.00 L 68.00 25.00 L 68.00 24.00 L 70.00 23.00 Z",
      "province": "M007",
      "rootTerritory": "M007",
      "viewBox": "0 0 70 36",
      "unitSlots": [
        {
          "name": "main",
          "x": 34,
          "y": 6,
          "territory": "M007",
          "arrowReceiver": {
            "x": 34,
            "y": 36
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34,
          "y": 6,
          "territory": "M007",
          "arrowReceiver": {
            "x": 34,
            "y": 36
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_62_a": {
    "territory": "REGION_62_a",
    "unitSlotName": "main",
    "province": "REGION_62_a",
    "provinceMapData": {
      "abbr": "GCH",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 71,
          "y": 65,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 139,
      "height": 167,
      "x": 403,
      "y": 1009,
      "playable": true,
      "path": "M 9.342 0.164 L 8.666 6.974 L 8.579 8.047 L 7.526 20.962 L 7.438 22.035 L 6.385 34.951 L 6.298 36.024 L 4.671 55.974 L 4.584 57.046 L 3.000 85.000 L 2.000 86.000 L 2.000 96.000 L 0.000 100.000 L 0.000 108.000 L 3.000 111.000 L 17.000 111.000 L 18.000 112.000 L 32.000 112.000 L 33.000 113.000 L 33.000 132.000 L 34.000 133.000 L 34.000 151.000 L 35.000 152.000 L 33.246 164.997 L 131.751 166.719 L 132.374 156.023 L 132.436 154.967 L 133.656 134.039 L 133.718 132.983 L 134.705 116.042 L 134.767 114.986 L 135.464 103.027 L 135.525 101.971 L 136.223 90.013 L 136.284 88.957 L 137.214 73.013 L 137.275 71.957 L 138.379 53.022 L 138.441 51.967 L 138.951 43.219 L 124.000 33.000 L 124.000 24.000 L 122.000 24.000 L 102.000 4.000 L 95.000 4.000 L 91.000 2.000 L 88.000 2.000 L 87.000 3.000 L 64.000 3.000 L 63.000 2.000 L 28.000 2.000 L 27.000 1.000 Z",
      "province": "REGION_62_a",
      "rootTerritory": "REGION_62_a",
      "viewBox": "0 0 139 167",
      "unitSlots": [
        {
          "name": "main",
          "x": 76,
          "y": 51,
          "territory": "REGION_62_a",
          "arrowReceiver": {
            "x": 76,
            "y": 81
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 76,
          "y": 51,
          "territory": "REGION_62_a",
          "arrowReceiver": {
            "x": 76,
            "y": 81
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "奇里基湾": {
    "territory": "REGION_62_a",
    "unitSlotName": "main",
    "province": "REGION_62_a",
    "provinceMapData": {
      "abbr": "GCH",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 71,
          "y": 65,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 139,
      "height": 167,
      "x": 403,
      "y": 1009,
      "playable": true,
      "path": "M 9.342 0.164 L 8.666 6.974 L 8.579 8.047 L 7.526 20.962 L 7.438 22.035 L 6.385 34.951 L 6.298 36.024 L 4.671 55.974 L 4.584 57.046 L 3.000 85.000 L 2.000 86.000 L 2.000 96.000 L 0.000 100.000 L 0.000 108.000 L 3.000 111.000 L 17.000 111.000 L 18.000 112.000 L 32.000 112.000 L 33.000 113.000 L 33.000 132.000 L 34.000 133.000 L 34.000 151.000 L 35.000 152.000 L 33.246 164.997 L 131.751 166.719 L 132.374 156.023 L 132.436 154.967 L 133.656 134.039 L 133.718 132.983 L 134.705 116.042 L 134.767 114.986 L 135.464 103.027 L 135.525 101.971 L 136.223 90.013 L 136.284 88.957 L 137.214 73.013 L 137.275 71.957 L 138.379 53.022 L 138.441 51.967 L 138.951 43.219 L 124.000 33.000 L 124.000 24.000 L 122.000 24.000 L 102.000 4.000 L 95.000 4.000 L 91.000 2.000 L 88.000 2.000 L 87.000 3.000 L 64.000 3.000 L 63.000 2.000 L 28.000 2.000 L 27.000 1.000 Z",
      "province": "REGION_62_a",
      "rootTerritory": "REGION_62_a",
      "viewBox": "0 0 139 167",
      "unitSlots": [
        {
          "name": "main",
          "x": 76,
          "y": 51,
          "territory": "REGION_62_a",
          "arrowReceiver": {
            "x": 76,
            "y": 81
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 76,
          "y": 51,
          "territory": "REGION_62_a",
          "arrowReceiver": {
            "x": 76,
            "y": 81
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_62_b_a": {
    "territory": "REGION_62_b_a",
    "unitSlotName": "main",
    "province": "REGION_62_b_a",
    "provinceMapData": {
      "abbr": "AEM",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 39,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 76,
      "height": 83,
      "x": 504,
      "y": 939,
      "playable": true,
      "path": "M 15.000 0.000 L 12.000 6.000 L 6.000 13.000 L 7.000 28.000 L 0.000 35.000 L 0.000 55.000 L 13.000 68.000 L 20.000 83.000 L 22.000 83.000 L 22.000 79.000 L 24.000 77.000 L 57.000 78.000 L 65.000 80.000 L 72.000 80.000 L 71.174 65.705 L 71.678 59.053 L 71.916 55.917 L 73.424 36.033 L 73.662 32.898 L 75.922 3.098 Z",
      "province": "REGION_62_b_a",
      "rootTerritory": "REGION_62_b_a",
      "viewBox": "0 0 76 83",
      "unitSlots": [
        {
          "name": "main",
          "x": 35,
          "y": 36,
          "territory": "REGION_62_b_a",
          "arrowReceiver": {
            "x": 35,
            "y": 66
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35,
          "y": 36,
          "territory": "REGION_62_b_a",
          "arrowReceiver": {
            "x": 35,
            "y": 66
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿尔米兰特湾": {
    "territory": "REGION_62_b_a",
    "unitSlotName": "main",
    "province": "REGION_62_b_a",
    "provinceMapData": {
      "abbr": "AEM",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 39,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 76,
      "height": 83,
      "x": 504,
      "y": 939,
      "playable": true,
      "path": "M 15.000 0.000 L 12.000 6.000 L 6.000 13.000 L 7.000 28.000 L 0.000 35.000 L 0.000 55.000 L 13.000 68.000 L 20.000 83.000 L 22.000 83.000 L 22.000 79.000 L 24.000 77.000 L 57.000 78.000 L 65.000 80.000 L 72.000 80.000 L 71.174 65.705 L 71.678 59.053 L 71.916 55.917 L 73.424 36.033 L 73.662 32.898 L 75.922 3.098 Z",
      "province": "REGION_62_b_a",
      "rootTerritory": "REGION_62_b_a",
      "viewBox": "0 0 76 83",
      "unitSlots": [
        {
          "name": "main",
          "x": 35,
          "y": 36,
          "territory": "REGION_62_b_a",
          "arrowReceiver": {
            "x": 35,
            "y": 66
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35,
          "y": 36,
          "territory": "REGION_62_b_a",
          "arrowReceiver": {
            "x": 35,
            "y": 66
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_65_a": {
    "territory": "REGION_65_a",
    "unitSlotName": "main",
    "province": "REGION_65_a",
    "provinceMapData": {
      "abbr": "GOP",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 41,
          "y": 42,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 79,
      "height": 129,
      "x": 534,
      "y": 1049,
      "playable": true,
      "path": "M 68.000 0.000 L 59.000 0.000 L 56.000 2.000 L 45.000 2.000 L 44.000 3.000 L 27.000 3.000 L 26.000 4.000 L 7.951 3.219 L 7.951 3.219 L 5.807 39.989 L 5.746 41.043 L 4.990 54.000 L 4.929 55.053 L 4.232 67.013 L 4.170 68.067 L 3.473 80.027 L 3.411 81.081 L 0.751 126.719 L 38.000 129.000 L 45.000 119.000 L 52.000 119.000 L 55.000 117.000 L 55.000 115.000 L 50.000 112.000 L 50.000 96.000 L 76.000 70.000 L 75.000 55.000 L 76.000 54.000 L 76.000 45.000 L 77.000 44.000 L 77.000 32.000 L 79.000 29.000 L 79.000 26.000 L 69.000 17.000 Z",
      "province": "REGION_65_a",
      "rootTerritory": "REGION_65_a",
      "viewBox": "0 0 79 129",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 70,
          "territory": "REGION_65_a",
          "arrowReceiver": {
            "x": 41,
            "y": 100
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 70,
          "territory": "REGION_65_a",
          "arrowReceiver": {
            "x": 41,
            "y": 100
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "巴拿马湾": {
    "territory": "REGION_65_a",
    "unitSlotName": "main",
    "province": "REGION_65_a",
    "provinceMapData": {
      "abbr": "GOP",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 41,
          "y": 42,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 79,
      "height": 129,
      "x": 534,
      "y": 1049,
      "playable": true,
      "path": "M 68.000 0.000 L 59.000 0.000 L 56.000 2.000 L 45.000 2.000 L 44.000 3.000 L 27.000 3.000 L 26.000 4.000 L 7.951 3.219 L 7.951 3.219 L 5.807 39.989 L 5.746 41.043 L 4.990 54.000 L 4.929 55.053 L 4.232 67.013 L 4.170 68.067 L 3.473 80.027 L 3.411 81.081 L 0.751 126.719 L 38.000 129.000 L 45.000 119.000 L 52.000 119.000 L 55.000 117.000 L 55.000 115.000 L 50.000 112.000 L 50.000 96.000 L 76.000 70.000 L 75.000 55.000 L 76.000 54.000 L 76.000 45.000 L 77.000 44.000 L 77.000 32.000 L 79.000 29.000 L 79.000 26.000 L 69.000 17.000 Z",
      "province": "REGION_65_a",
      "rootTerritory": "REGION_65_a",
      "viewBox": "0 0 79 129",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 70,
          "territory": "REGION_65_a",
          "arrowReceiver": {
            "x": 41,
            "y": 100
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 70,
          "territory": "REGION_65_a",
          "arrowReceiver": {
            "x": 41,
            "y": 100
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_97_a": {
    "territory": "REGION_97_a",
    "unitSlotName": "main",
    "province": "REGION_97_a",
    "provinceMapData": {
      "abbr": "GOU",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 108,
      "height": 101,
      "x": 575,
      "y": 941,
      "playable": true,
      "path": "M 4.922 1.098 L 4.478 6.959 L 4.397 8.031 L 3.416 20.954 L 3.335 22.027 L 1.896 40.992 L 1.815 42.064 L 0.609 57.969 L 0.527 59.041 L 0.174 63.705 L 0.174 63.705 L 10.000 65.000 L 14.000 67.000 L 26.000 76.000 L 36.000 82.000 L 48.000 94.000 L 55.000 95.000 L 60.000 98.000 L 60.000 101.000 L 62.000 101.000 L 73.000 88.000 L 73.000 80.000 L 80.000 74.000 L 83.000 65.000 L 88.000 61.000 L 100.000 60.000 L 108.000 51.000 L 107.493 3.139 L 96.024 2.537 L 94.975 2.482 L 52.648 0.162 L 52.648 0.162 Z",
      "province": "REGION_97_a",
      "rootTerritory": "REGION_97_a",
      "viewBox": "0 0 108 101",
      "unitSlots": [
        {
          "name": "main",
          "x": 49,
          "y": 8,
          "territory": "REGION_97_a",
          "arrowReceiver": {
            "x": 49,
            "y": 38
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 49,
          "y": 8,
          "territory": "REGION_97_a",
          "arrowReceiver": {
            "x": 49,
            "y": 38
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "乌拉巴湾": {
    "territory": "REGION_97_a",
    "unitSlotName": "main",
    "province": "REGION_97_a",
    "provinceMapData": {
      "abbr": "GOU",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 108,
      "height": 101,
      "x": 575,
      "y": 941,
      "playable": true,
      "path": "M 4.922 1.098 L 4.478 6.959 L 4.397 8.031 L 3.416 20.954 L 3.335 22.027 L 1.896 40.992 L 1.815 42.064 L 0.609 57.969 L 0.527 59.041 L 0.174 63.705 L 0.174 63.705 L 10.000 65.000 L 14.000 67.000 L 26.000 76.000 L 36.000 82.000 L 48.000 94.000 L 55.000 95.000 L 60.000 98.000 L 60.000 101.000 L 62.000 101.000 L 73.000 88.000 L 73.000 80.000 L 80.000 74.000 L 83.000 65.000 L 88.000 61.000 L 100.000 60.000 L 108.000 51.000 L 107.493 3.139 L 96.024 2.537 L 94.975 2.482 L 52.648 0.162 L 52.648 0.162 Z",
      "province": "REGION_97_a",
      "rootTerritory": "REGION_97_a",
      "viewBox": "0 0 108 101",
      "unitSlots": [
        {
          "name": "main",
          "x": 49,
          "y": 8,
          "territory": "REGION_97_a",
          "arrowReceiver": {
            "x": 49,
            "y": 38
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 49,
          "y": 8,
          "territory": "REGION_97_a",
          "arrowReceiver": {
            "x": 49,
            "y": 38
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M008": {
    "territory": "M008",
    "unitSlotName": "main",
    "province": "M008",
    "provinceMapData": {
      "abbr": "PAN",
      "type": "Coast",
      "centerPos": {
        "x": 33,
        "y": 12
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 24,
          "y": 29,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 99,
      "height": 48,
      "x": 525,
      "y": 1006,
      "playable": true,
      "path": "M 99.00 27.00 L 89.00 17.00 L 64.00 0.00 L 50.00 0.00 L 50.00 11.00 L 49.00 12.00 L 39.00 11.00 L 38.00 10.00 L 22.00 10.00 L 21.00 9.00 L 1.00 9.00 L 0.00 10.00 L 1.00 38.00 L 17.00 48.00 L 55.00 47.00 L 56.00 46.00 L 67.00 46.00 L 70.00 44.00 L 77.00 44.00 L 76.00 35.00 L 79.00 31.00 L 97.00 30.00 L 99.00 29.00 Z",
      "province": "M008",
      "rootTerritory": "M008",
      "viewBox": "0 0 99 48",
      "unitSlots": [
        {
          "name": "main",
          "x": 55,
          "y": 24,
          "territory": "M008",
          "arrowReceiver": {
            "x": 55,
            "y": 54
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 55,
          "y": 24,
          "territory": "M008",
          "arrowReceiver": {
            "x": 55,
            "y": 54
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "巴拿马": {
    "territory": "M008",
    "unitSlotName": "main",
    "province": "M008",
    "provinceMapData": {
      "abbr": "PAN",
      "type": "Coast",
      "centerPos": {
        "x": 33,
        "y": 12
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 24,
          "y": 29,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 99,
      "height": 48,
      "x": 525,
      "y": 1006,
      "playable": true,
      "path": "M 99.00 27.00 L 89.00 17.00 L 64.00 0.00 L 50.00 0.00 L 50.00 11.00 L 49.00 12.00 L 39.00 11.00 L 38.00 10.00 L 22.00 10.00 L 21.00 9.00 L 1.00 9.00 L 0.00 10.00 L 1.00 38.00 L 17.00 48.00 L 55.00 47.00 L 56.00 46.00 L 67.00 46.00 L 70.00 44.00 L 77.00 44.00 L 76.00 35.00 L 79.00 31.00 L 97.00 30.00 L 99.00 29.00 Z",
      "province": "M008",
      "rootTerritory": "M008",
      "viewBox": "0 0 99 48",
      "unitSlots": [
        {
          "name": "main",
          "x": 55,
          "y": 24,
          "territory": "M008",
          "arrowReceiver": {
            "x": 55,
            "y": 54
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 55,
          "y": 24,
          "territory": "M008",
          "arrowReceiver": {
            "x": 55,
            "y": 54
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_76_a": {
    "territory": "REGION_76_a",
    "unitSlotName": "main",
    "province": "REGION_76_a",
    "provinceMapData": {
      "abbr": "FAC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 158,
      "height": 74,
      "x": 661,
      "y": 1790,
      "playable": true,
      "path": "M 157.781 0.389 L 134.000 0.000 L 133.000 1.000 L 91.000 2.000 L 90.000 3.000 L 63.000 3.000 L 62.000 4.000 L 55.000 4.000 L 52.000 6.000 L 48.000 4.000 L 38.000 4.000 L 35.000 15.000 L 26.000 26.000 L 1.000 38.000 L 0.000 41.000 L 2.000 43.000 L 5.000 43.000 L 29.000 56.000 L 37.000 64.000 L 34.464 73.972 L 85.953 69.005 L 83.000 63.000 L 84.000 37.000 L 85.000 36.000 L 85.000 27.000 L 86.000 26.000 L 153.890 27.023 L 155.392 16.745 Z",
      "province": "REGION_76_a",
      "rootTerritory": "REGION_76_a",
      "viewBox": "0 0 158 74",
      "unitSlots": [
        {
          "name": "main",
          "x": 84,
          "y": 22,
          "territory": "REGION_76_a",
          "arrowReceiver": {
            "x": 84,
            "y": 52
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 84,
          "y": 22,
          "territory": "REGION_76_a",
          "arrowReceiver": {
            "x": 84,
            "y": 52
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "福克兰洋流": {
    "territory": "REGION_76_a",
    "unitSlotName": "main",
    "province": "REGION_76_a",
    "provinceMapData": {
      "abbr": "FAC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 39,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 158,
      "height": 74,
      "x": 661,
      "y": 1790,
      "playable": true,
      "path": "M 157.781 0.389 L 134.000 0.000 L 133.000 1.000 L 91.000 2.000 L 90.000 3.000 L 63.000 3.000 L 62.000 4.000 L 55.000 4.000 L 52.000 6.000 L 48.000 4.000 L 38.000 4.000 L 35.000 15.000 L 26.000 26.000 L 1.000 38.000 L 0.000 41.000 L 2.000 43.000 L 5.000 43.000 L 29.000 56.000 L 37.000 64.000 L 34.464 73.972 L 85.953 69.005 L 83.000 63.000 L 84.000 37.000 L 85.000 36.000 L 85.000 27.000 L 86.000 26.000 L 153.890 27.023 L 155.392 16.745 Z",
      "province": "REGION_76_a",
      "rootTerritory": "REGION_76_a",
      "viewBox": "0 0 158 74",
      "unitSlots": [
        {
          "name": "main",
          "x": 84,
          "y": 22,
          "territory": "REGION_76_a",
          "arrowReceiver": {
            "x": 84,
            "y": 52
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 84,
          "y": 22,
          "territory": "REGION_76_a",
          "arrowReceiver": {
            "x": 84,
            "y": 52
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_167_a": {
    "territory": "REGION_167_a",
    "unitSlotName": "main",
    "province": "REGION_167_a",
    "provinceMapData": {
      "abbr": "PTG",
      "type": "Coast",
      "centerPos": {
        "x": 31,
        "y": 54
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 48,
          "y": 47,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 115,
      "height": 118,
      "x": 624,
      "y": 1726,
      "playable": true,
      "path": "M 111.00 12.00 L 100.00 6.00 L 84.00 5.00 L 80.00 0.00 L 68.00 0.00 L 63.00 3.00 L 49.00 4.00 L 41.00 13.00 L 24.00 12.00 L 19.00 25.00 L 12.00 34.00 L 13.00 47.00 L 10.00 52.00 L 0.00 63.00 L 0.00 67.00 L 3.00 70.00 L 12.00 72.00 L 12.00 88.00 L 1.00 112.00 L 1.00 117.00 L 2.00 118.00 L 15.00 118.00 L 24.00 109.00 L 24.00 103.00 L 25.00 102.00 L 35.00 102.00 L 37.00 104.00 L 39.00 104.00 L 65.00 91.00 L 73.00 81.00 L 77.00 68.00 L 81.00 64.00 L 92.00 59.00 L 107.00 42.00 L 115.00 38.00 L 114.00 18.00 Z",
      "province": "REGION_167_a",
      "rootTerritory": "REGION_167_a",
      "viewBox": "0 0 115 118",
      "unitSlots": [
        {
          "name": "main",
          "x": 72,
          "y": 23,
          "territory": "REGION_167_a",
          "arrowReceiver": {
            "x": 72,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 72,
          "y": 23,
          "territory": "REGION_167_a",
          "arrowReceiver": {
            "x": 72,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "巴塔哥尼亚": {
    "territory": "REGION_167_a",
    "unitSlotName": "main",
    "province": "REGION_167_a",
    "provinceMapData": {
      "abbr": "PTG",
      "type": "Coast",
      "centerPos": {
        "x": 31,
        "y": 54
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 48,
          "y": 47,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 115,
      "height": 118,
      "x": 624,
      "y": 1726,
      "playable": true,
      "path": "M 111.00 12.00 L 100.00 6.00 L 84.00 5.00 L 80.00 0.00 L 68.00 0.00 L 63.00 3.00 L 49.00 4.00 L 41.00 13.00 L 24.00 12.00 L 19.00 25.00 L 12.00 34.00 L 13.00 47.00 L 10.00 52.00 L 0.00 63.00 L 0.00 67.00 L 3.00 70.00 L 12.00 72.00 L 12.00 88.00 L 1.00 112.00 L 1.00 117.00 L 2.00 118.00 L 15.00 118.00 L 24.00 109.00 L 24.00 103.00 L 25.00 102.00 L 35.00 102.00 L 37.00 104.00 L 39.00 104.00 L 65.00 91.00 L 73.00 81.00 L 77.00 68.00 L 81.00 64.00 L 92.00 59.00 L 107.00 42.00 L 115.00 38.00 L 114.00 18.00 Z",
      "province": "REGION_167_a",
      "rootTerritory": "REGION_167_a",
      "viewBox": "0 0 115 118",
      "unitSlots": [
        {
          "name": "main",
          "x": 72,
          "y": 23,
          "territory": "REGION_167_a",
          "arrowReceiver": {
            "x": 72,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 72,
          "y": 23,
          "territory": "REGION_167_a",
          "arrowReceiver": {
            "x": 72,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_175_b": {
    "territory": "REGION_175_b",
    "unitSlotName": "main",
    "province": "REGION_175_b",
    "provinceMapData": {
      "abbr": "TCH",
      "type": "Coast",
      "centerPos": {
        "x": 15,
        "y": 36
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 37,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 62,
      "height": 58,
      "x": 623,
      "y": 1679,
      "playable": true,
      "path": "M 18.00 0.00 L 0.00 21.00 L 0.00 24.00 L 9.00 24.00 L 10.00 25.00 L 11.00 48.00 L 13.00 54.00 L 19.00 55.00 L 24.00 58.00 L 41.00 58.00 L 53.00 49.00 L 55.00 34.00 L 62.00 26.00 L 62.00 23.00 L 51.00 23.00 L 39.00 17.00 L 38.00 15.00 L 33.00 15.00 L 25.00 11.00 L 23.00 9.00 L 23.00 0.00 Z",
      "province": "REGION_175_b",
      "rootTerritory": "REGION_175_b",
      "viewBox": "0 0 62 58",
      "unitSlots": [
        {
          "name": "main",
          "x": 28,
          "y": 14,
          "territory": "REGION_175_b",
          "arrowReceiver": {
            "x": 28,
            "y": 44
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28,
          "y": 14,
          "territory": "REGION_175_b",
          "arrowReceiver": {
            "x": 28,
            "y": 44
          }
        }
      },
      "texture": {
        "texture": "#D4BCAE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "塔尔卡瓦诺": {
    "territory": "REGION_175_b",
    "unitSlotName": "main",
    "province": "REGION_175_b",
    "provinceMapData": {
      "abbr": "TCH",
      "type": "Coast",
      "centerPos": {
        "x": 15,
        "y": 36
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 37,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 62,
      "height": 58,
      "x": 623,
      "y": 1679,
      "playable": true,
      "path": "M 18.00 0.00 L 0.00 21.00 L 0.00 24.00 L 9.00 24.00 L 10.00 25.00 L 11.00 48.00 L 13.00 54.00 L 19.00 55.00 L 24.00 58.00 L 41.00 58.00 L 53.00 49.00 L 55.00 34.00 L 62.00 26.00 L 62.00 23.00 L 51.00 23.00 L 39.00 17.00 L 38.00 15.00 L 33.00 15.00 L 25.00 11.00 L 23.00 9.00 L 23.00 0.00 Z",
      "province": "REGION_175_b",
      "rootTerritory": "REGION_175_b",
      "viewBox": "0 0 62 58",
      "unitSlots": [
        {
          "name": "main",
          "x": 28,
          "y": 14,
          "territory": "REGION_175_b",
          "arrowReceiver": {
            "x": 28,
            "y": 44
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 28,
          "y": 14,
          "territory": "REGION_175_b",
          "arrowReceiver": {
            "x": 28,
            "y": 44
          }
        }
      },
      "texture": {
        "texture": "#D4BCAE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_175_a_a": {
    "territory": "REGION_175_a_a",
    "unitSlotName": "main",
    "province": "REGION_175_a_a",
    "provinceMapData": {
      "abbr": "VPS",
      "type": "Coast",
      "centerPos": {
        "x": -2,
        "y": 55
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 15,
          "y": 60,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 56,
      "height": 94,
      "x": 645,
      "y": 1601,
      "playable": true,
      "path": "M 54.00 0.00 L 29.00 1.00 L 25.00 6.00 L 17.00 39.00 L 4.00 56.00 L 5.00 66.00 L 0.00 75.00 L 0.00 89.00 L 9.00 94.00 L 16.00 94.00 L 15.00 84.00 L 25.00 66.00 L 26.00 59.00 L 48.00 7.00 L 56.00 7.00 L 56.00 4.00 Z",
      "province": "REGION_175_a_a",
      "rootTerritory": "REGION_175_a_a",
      "viewBox": "0 0 56 94",
      "unitSlots": [
        {
          "name": "main",
          "x": 13,
          "y": 56,
          "territory": "REGION_175_a_a",
          "arrowReceiver": {
            "x": 13,
            "y": 86
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 13,
          "y": 56,
          "territory": "REGION_175_a_a",
          "arrowReceiver": {
            "x": 13,
            "y": 86
          }
        }
      },
      "texture": {
        "texture": "#D4BCAE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "瓦尔帕莱索": {
    "territory": "REGION_175_a_a",
    "unitSlotName": "main",
    "province": "REGION_175_a_a",
    "provinceMapData": {
      "abbr": "VPS",
      "type": "Coast",
      "centerPos": {
        "x": -2,
        "y": 55
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 15,
          "y": 60,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 56,
      "height": 94,
      "x": 645,
      "y": 1601,
      "playable": true,
      "path": "M 54.00 0.00 L 29.00 1.00 L 25.00 6.00 L 17.00 39.00 L 4.00 56.00 L 5.00 66.00 L 0.00 75.00 L 0.00 89.00 L 9.00 94.00 L 16.00 94.00 L 15.00 84.00 L 25.00 66.00 L 26.00 59.00 L 48.00 7.00 L 56.00 7.00 L 56.00 4.00 Z",
      "province": "REGION_175_a_a",
      "rootTerritory": "REGION_175_a_a",
      "viewBox": "0 0 56 94",
      "unitSlots": [
        {
          "name": "main",
          "x": 13,
          "y": 56,
          "territory": "REGION_175_a_a",
          "arrowReceiver": {
            "x": 13,
            "y": 86
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 13,
          "y": 56,
          "territory": "REGION_175_a_a",
          "arrowReceiver": {
            "x": 13,
            "y": 86
          }
        }
      },
      "texture": {
        "texture": "#D4BCAE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_175_a_b": {
    "territory": "REGION_175_a_b",
    "unitSlotName": "main",
    "province": "REGION_175_a_b",
    "provinceMapData": {
      "abbr": "STD",
      "type": "Land",
      "centerPos": {
        "x": 3,
        "y": 36
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20,
          "y": 77,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 57,
      "height": 96,
      "x": 659,
      "y": 1607,
      "playable": true,
      "path": "M 57.00 4.00 L 49.00 3.00 L 45.00 0.00 L 32.00 0.00 L 11.00 51.00 L 10.00 58.00 L 0.00 76.00 L 1.00 90.00 L 13.00 96.00 L 27.00 96.00 L 30.00 93.00 L 33.00 92.00 L 38.00 82.00 L 38.00 63.00 L 35.00 58.00 L 36.00 50.00 L 38.00 46.00 L 57.00 27.00 L 57.00 10.00 L 56.00 9.00 Z",
      "province": "REGION_175_a_b",
      "rootTerritory": "REGION_175_a_b",
      "viewBox": "0 0 57 96",
      "unitSlots": [
        {
          "name": "main",
          "x": 13,
          "y": 68,
          "territory": "REGION_175_a_b",
          "arrowReceiver": {
            "x": 13,
            "y": 98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 13,
          "y": 68,
          "territory": "REGION_175_a_b",
          "arrowReceiver": {
            "x": 13,
            "y": 98
          }
        }
      },
      "texture": {
        "texture": "#D4BCAE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "圣地亚哥": {
    "territory": "REGION_175_a_b",
    "unitSlotName": "main",
    "province": "REGION_175_a_b",
    "provinceMapData": {
      "abbr": "STD",
      "type": "Land",
      "centerPos": {
        "x": 3,
        "y": 36
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 20,
          "y": 77,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 57,
      "height": 96,
      "x": 659,
      "y": 1607,
      "playable": true,
      "path": "M 57.00 4.00 L 49.00 3.00 L 45.00 0.00 L 32.00 0.00 L 11.00 51.00 L 10.00 58.00 L 0.00 76.00 L 1.00 90.00 L 13.00 96.00 L 27.00 96.00 L 30.00 93.00 L 33.00 92.00 L 38.00 82.00 L 38.00 63.00 L 35.00 58.00 L 36.00 50.00 L 38.00 46.00 L 57.00 27.00 L 57.00 10.00 L 56.00 9.00 Z",
      "province": "REGION_175_a_b",
      "rootTerritory": "REGION_175_a_b",
      "viewBox": "0 0 57 96",
      "unitSlots": [
        {
          "name": "main",
          "x": 13,
          "y": 68,
          "territory": "REGION_175_a_b",
          "arrowReceiver": {
            "x": 13,
            "y": 98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 13,
          "y": 68,
          "territory": "REGION_175_a_b",
          "arrowReceiver": {
            "x": 13,
            "y": 98
          }
        }
      },
      "texture": {
        "texture": "#D4BCAE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_173_a": {
    "territory": "REGION_173_a",
    "unitSlotName": "main",
    "province": "REGION_173_a",
    "provinceMapData": {
      "abbr": "ARE",
      "type": "Coast",
      "centerPos": {
        "x": 79,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 70,
          "y": 33,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 109,
      "height": 65,
      "x": 638,
      "y": 1404,
      "playable": true,
      "path": "M 0.00 11.00 L 0.00 24.00 L 2.00 27.00 L 21.00 35.00 L 28.00 44.00 L 46.00 43.00 L 50.00 45.00 L 66.00 65.00 L 68.00 65.00 L 68.00 61.00 L 72.00 57.00 L 78.00 56.00 L 95.00 47.00 L 103.00 47.00 L 105.00 51.00 L 107.00 51.00 L 109.00 47.00 L 109.00 31.00 L 104.00 24.00 L 83.00 14.00 L 75.00 8.00 L 63.00 7.00 L 50.00 0.00 L 36.00 0.00 L 23.00 13.00 L 19.00 8.00 L 3.00 8.00 Z",
      "province": "REGION_173_a",
      "rootTerritory": "REGION_173_a",
      "viewBox": "0 0 109 65",
      "unitSlots": [
        {
          "name": "main",
          "x": 38,
          "y": 15,
          "territory": "REGION_173_a",
          "arrowReceiver": {
            "x": 38,
            "y": 45
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 38,
          "y": 15,
          "territory": "REGION_173_a",
          "arrowReceiver": {
            "x": 38,
            "y": 45
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿雷基帕": {
    "territory": "REGION_173_a",
    "unitSlotName": "main",
    "province": "REGION_173_a",
    "provinceMapData": {
      "abbr": "ARE",
      "type": "Coast",
      "centerPos": {
        "x": 79,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 70,
          "y": 33,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 109,
      "height": 65,
      "x": 638,
      "y": 1404,
      "playable": true,
      "path": "M 0.00 11.00 L 0.00 24.00 L 2.00 27.00 L 21.00 35.00 L 28.00 44.00 L 46.00 43.00 L 50.00 45.00 L 66.00 65.00 L 68.00 65.00 L 68.00 61.00 L 72.00 57.00 L 78.00 56.00 L 95.00 47.00 L 103.00 47.00 L 105.00 51.00 L 107.00 51.00 L 109.00 47.00 L 109.00 31.00 L 104.00 24.00 L 83.00 14.00 L 75.00 8.00 L 63.00 7.00 L 50.00 0.00 L 36.00 0.00 L 23.00 13.00 L 19.00 8.00 L 3.00 8.00 Z",
      "province": "REGION_173_a",
      "rootTerritory": "REGION_173_a",
      "viewBox": "0 0 109 65",
      "unitSlots": [
        {
          "name": "main",
          "x": 38,
          "y": 15,
          "territory": "REGION_173_a",
          "arrowReceiver": {
            "x": 38,
            "y": 45
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 38,
          "y": 15,
          "territory": "REGION_173_a",
          "arrowReceiver": {
            "x": 38,
            "y": 45
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_173_b": {
    "territory": "REGION_173_b",
    "unitSlotName": "main",
    "province": "REGION_173_b",
    "provinceMapData": {
      "abbr": "TRP",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 25,
          "y": 40,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 54,
      "height": 66,
      "x": 703,
      "y": 1450,
      "playable": true,
      "path": "M 40.00 0.00 L 28.00 0.00 L 11.00 9.00 L 5.00 10.00 L 2.00 13.00 L 0.00 47.00 L 1.00 48.00 L 1.00 63.00 L 3.00 66.00 L 32.00 66.00 L 42.00 61.00 L 45.00 55.00 L 54.00 47.00 L 54.00 33.00 L 46.00 24.00 L 44.00 8.00 Z",
      "province": "REGION_173_b",
      "rootTerritory": "REGION_173_b",
      "viewBox": "0 0 54 66",
      "unitSlots": [
        {
          "name": "main",
          "x": 20,
          "y": 29,
          "territory": "REGION_173_b",
          "arrowReceiver": {
            "x": 20,
            "y": 59
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 20,
          "y": 29,
          "territory": "REGION_173_b",
          "arrowReceiver": {
            "x": 20,
            "y": 59
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "塔拉帕卡": {
    "territory": "REGION_173_b",
    "unitSlotName": "main",
    "province": "REGION_173_b",
    "provinceMapData": {
      "abbr": "TRP",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 25,
          "y": 40,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 54,
      "height": 66,
      "x": 703,
      "y": 1450,
      "playable": true,
      "path": "M 40.00 0.00 L 28.00 0.00 L 11.00 9.00 L 5.00 10.00 L 2.00 13.00 L 0.00 47.00 L 1.00 48.00 L 1.00 63.00 L 3.00 66.00 L 32.00 66.00 L 42.00 61.00 L 45.00 55.00 L 54.00 47.00 L 54.00 33.00 L 46.00 24.00 L 44.00 8.00 Z",
      "province": "REGION_173_b",
      "rootTerritory": "REGION_173_b",
      "viewBox": "0 0 54 66",
      "unitSlots": [
        {
          "name": "main",
          "x": 20,
          "y": 29,
          "territory": "REGION_173_b",
          "arrowReceiver": {
            "x": 20,
            "y": 59
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 20,
          "y": 29,
          "territory": "REGION_173_b",
          "arrowReceiver": {
            "x": 20,
            "y": 59
          }
        }
      },
      "texture": {
        "texture": "#E8A7C1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_60_a": {
    "territory": "REGION_60_a",
    "unitSlotName": "main",
    "province": "REGION_60_a",
    "provinceMapData": {
      "abbr": "GOF",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 50,
          "y": 43,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 109,
      "height": 67,
      "x": 381,
      "y": 945,
      "playable": true,
      "path": "M 3.000 0.000 L 2.000 27.000 L 0.000 30.000 L 0.864 51.134 L 0.864 51.134 L 7.587 53.987 L 31.342 64.164 L 50.000 65.000 L 51.000 66.000 L 88.000 66.000 L 89.000 67.000 L 108.000 67.000 L 109.000 66.000 L 109.000 65.000 L 106.000 63.000 L 106.000 61.000 L 102.000 54.000 L 103.000 51.000 L 105.000 49.000 L 105.000 36.000 L 94.000 32.000 L 82.000 19.000 L 79.000 19.000 L 77.000 21.000 L 65.000 21.000 L 61.000 17.000 L 51.000 17.000 L 38.000 10.000 L 36.000 10.000 L 35.000 9.000 L 30.000 9.000 L 25.000 6.000 L 19.000 6.000 L 14.000 3.000 L 7.000 2.000 L 5.000 0.000 Z",
      "province": "REGION_60_a",
      "rootTerritory": "REGION_60_a",
      "viewBox": "0 0 109 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 46,
          "y": 45,
          "territory": "REGION_60_a",
          "arrowReceiver": {
            "x": 46,
            "y": 75
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 46,
          "y": 45,
          "territory": "REGION_60_a",
          "arrowReceiver": {
            "x": 46,
            "y": 75
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "丰塞卡湾": {
    "territory": "REGION_60_a",
    "unitSlotName": "main",
    "province": "REGION_60_a",
    "provinceMapData": {
      "abbr": "GOF",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 50,
          "y": 43,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 109,
      "height": 67,
      "x": 381,
      "y": 945,
      "playable": true,
      "path": "M 3.000 0.000 L 2.000 27.000 L 0.000 30.000 L 0.864 51.134 L 0.864 51.134 L 7.587 53.987 L 31.342 64.164 L 50.000 65.000 L 51.000 66.000 L 88.000 66.000 L 89.000 67.000 L 108.000 67.000 L 109.000 66.000 L 109.000 65.000 L 106.000 63.000 L 106.000 61.000 L 102.000 54.000 L 103.000 51.000 L 105.000 49.000 L 105.000 36.000 L 94.000 32.000 L 82.000 19.000 L 79.000 19.000 L 77.000 21.000 L 65.000 21.000 L 61.000 17.000 L 51.000 17.000 L 38.000 10.000 L 36.000 10.000 L 35.000 9.000 L 30.000 9.000 L 25.000 6.000 L 19.000 6.000 L 14.000 3.000 L 7.000 2.000 L 5.000 0.000 Z",
      "province": "REGION_60_a",
      "rootTerritory": "REGION_60_a",
      "viewBox": "0 0 109 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 46,
          "y": 45,
          "territory": "REGION_60_a",
          "arrowReceiver": {
            "x": 46,
            "y": 75
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 46,
          "y": 45,
          "territory": "REGION_60_a",
          "arrowReceiver": {
            "x": 46,
            "y": 75
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M013": {
    "territory": "M013",
    "unitSlotName": "main",
    "province": "M013",
    "provinceMapData": {
      "abbr": "AMZ",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 117,
          "y": 146,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 189,
      "height": 201,
      "x": 671,
      "y": 1138,
      "playable": true,
      "path": "M 178.00 8.00 L 171.00 1.00 L 167.00 0.00 L 164.00 4.00 L 145.00 17.00 L 140.00 16.00 L 131.00 16.00 L 128.00 18.00 L 129.00 34.00 L 134.00 38.00 L 134.00 60.00 L 138.00 67.00 L 137.00 72.00 L 135.00 74.00 L 130.00 74.00 L 112.00 83.00 L 97.00 99.00 L 83.00 100.00 L 77.00 107.00 L 58.00 108.00 L 51.00 104.00 L 35.00 104.00 L 34.00 108.00 L 32.00 110.00 L 22.00 109.00 L 18.00 111.00 L 9.00 118.00 L 7.00 135.00 L 0.00 144.00 L 0.00 156.00 L 13.00 159.00 L 19.00 163.00 L 29.00 164.00 L 40.00 170.00 L 54.00 172.00 L 96.00 194.00 L 100.00 194.00 L 107.00 201.00 L 140.00 199.00 L 142.00 194.00 L 149.00 186.00 L 170.00 178.00 L 173.00 173.00 L 181.00 166.00 L 181.00 164.00 L 176.00 164.00 L 168.00 147.00 L 168.00 134.00 L 167.00 133.00 L 167.00 124.00 L 166.00 123.00 L 167.00 103.00 L 172.00 95.00 L 188.00 77.00 L 188.00 70.00 L 189.00 69.00 L 189.00 61.00 L 178.00 49.00 L 175.00 43.00 L 176.00 16.00 L 178.00 13.00 Z",
      "province": "M013",
      "rootTerritory": "M013",
      "viewBox": "0 0 189 201",
      "unitSlots": [
        {
          "name": "main",
          "x": 85,
          "y": 148,
          "territory": "M013",
          "arrowReceiver": {
            "x": 85,
            "y": 178
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 85,
          "y": 148,
          "territory": "M013",
          "arrowReceiver": {
            "x": 85,
            "y": 178
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "亚马逊": {
    "territory": "M013",
    "unitSlotName": "main",
    "province": "M013",
    "provinceMapData": {
      "abbr": "AMZ",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 117,
          "y": 146,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 189,
      "height": 201,
      "x": 671,
      "y": 1138,
      "playable": true,
      "path": "M 178.00 8.00 L 171.00 1.00 L 167.00 0.00 L 164.00 4.00 L 145.00 17.00 L 140.00 16.00 L 131.00 16.00 L 128.00 18.00 L 129.00 34.00 L 134.00 38.00 L 134.00 60.00 L 138.00 67.00 L 137.00 72.00 L 135.00 74.00 L 130.00 74.00 L 112.00 83.00 L 97.00 99.00 L 83.00 100.00 L 77.00 107.00 L 58.00 108.00 L 51.00 104.00 L 35.00 104.00 L 34.00 108.00 L 32.00 110.00 L 22.00 109.00 L 18.00 111.00 L 9.00 118.00 L 7.00 135.00 L 0.00 144.00 L 0.00 156.00 L 13.00 159.00 L 19.00 163.00 L 29.00 164.00 L 40.00 170.00 L 54.00 172.00 L 96.00 194.00 L 100.00 194.00 L 107.00 201.00 L 140.00 199.00 L 142.00 194.00 L 149.00 186.00 L 170.00 178.00 L 173.00 173.00 L 181.00 166.00 L 181.00 164.00 L 176.00 164.00 L 168.00 147.00 L 168.00 134.00 L 167.00 133.00 L 167.00 124.00 L 166.00 123.00 L 167.00 103.00 L 172.00 95.00 L 188.00 77.00 L 188.00 70.00 L 189.00 69.00 L 189.00 61.00 L 178.00 49.00 L 175.00 43.00 L 176.00 16.00 L 178.00 13.00 Z",
      "province": "M013",
      "rootTerritory": "M013",
      "viewBox": "0 0 189 201",
      "unitSlots": [
        {
          "name": "main",
          "x": 85,
          "y": 148,
          "territory": "M013",
          "arrowReceiver": {
            "x": 85,
            "y": 178
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 85,
          "y": 148,
          "territory": "M013",
          "arrowReceiver": {
            "x": 85,
            "y": 178
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M014": {
    "territory": "M014",
    "unitSlotName": "main",
    "province": "M014",
    "provinceMapData": {
      "abbr": "MAN",
      "type": "Land",
      "centerPos": {
        "x": 34,
        "y": 185
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51,
          "y": 178,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 123,
      "height": 234,
      "x": 828,
      "y": 1078,
      "playable": true,
      "path": "M 78.00 0.00 L 67.00 0.00 L 61.00 3.00 L 52.00 17.00 L 30.00 28.00 L 28.00 28.00 L 19.00 23.00 L 1.00 23.00 L 0.00 24.00 L 0.00 48.00 L 3.00 54.00 L 20.00 70.00 L 18.00 74.00 L 17.00 105.00 L 20.00 111.00 L 31.00 123.00 L 30.00 135.00 L 14.00 153.00 L 9.00 161.00 L 8.00 185.00 L 9.00 186.00 L 9.00 195.00 L 10.00 196.00 L 10.00 209.00 L 17.00 225.00 L 23.00 225.00 L 33.00 234.00 L 97.00 234.00 L 103.00 224.00 L 103.00 222.00 L 92.00 208.00 L 92.00 191.00 L 117.00 152.00 L 117.00 139.00 L 120.00 138.00 L 123.00 131.00 L 123.00 127.00 L 117.00 123.00 L 110.00 122.00 L 100.00 111.00 L 95.00 110.00 L 90.00 103.00 L 90.00 71.00 L 96.00 65.00 L 96.00 62.00 L 89.00 58.00 L 85.00 52.00 L 84.00 48.00 L 92.00 33.00 L 92.00 19.00 L 83.00 11.00 L 82.00 3.00 Z",
      "province": "M014",
      "rootTerritory": "M014",
      "viewBox": "0 0 123 234",
      "unitSlots": [
        {
          "name": "main",
          "x": 59,
          "y": 160,
          "territory": "M014",
          "arrowReceiver": {
            "x": 59,
            "y": 190
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 59,
          "y": 160,
          "territory": "M014",
          "arrowReceiver": {
            "x": 59,
            "y": 190
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "马瑙斯": {
    "territory": "M014",
    "unitSlotName": "main",
    "province": "M014",
    "provinceMapData": {
      "abbr": "MAN",
      "type": "Land",
      "centerPos": {
        "x": 34,
        "y": 185
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 51,
          "y": 178,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 123,
      "height": 234,
      "x": 828,
      "y": 1078,
      "playable": true,
      "path": "M 78.00 0.00 L 67.00 0.00 L 61.00 3.00 L 52.00 17.00 L 30.00 28.00 L 28.00 28.00 L 19.00 23.00 L 1.00 23.00 L 0.00 24.00 L 0.00 48.00 L 3.00 54.00 L 20.00 70.00 L 18.00 74.00 L 17.00 105.00 L 20.00 111.00 L 31.00 123.00 L 30.00 135.00 L 14.00 153.00 L 9.00 161.00 L 8.00 185.00 L 9.00 186.00 L 9.00 195.00 L 10.00 196.00 L 10.00 209.00 L 17.00 225.00 L 23.00 225.00 L 33.00 234.00 L 97.00 234.00 L 103.00 224.00 L 103.00 222.00 L 92.00 208.00 L 92.00 191.00 L 117.00 152.00 L 117.00 139.00 L 120.00 138.00 L 123.00 131.00 L 123.00 127.00 L 117.00 123.00 L 110.00 122.00 L 100.00 111.00 L 95.00 110.00 L 90.00 103.00 L 90.00 71.00 L 96.00 65.00 L 96.00 62.00 L 89.00 58.00 L 85.00 52.00 L 84.00 48.00 L 92.00 33.00 L 92.00 19.00 L 83.00 11.00 L 82.00 3.00 Z",
      "province": "M014",
      "rootTerritory": "M014",
      "viewBox": "0 0 123 234",
      "unitSlots": [
        {
          "name": "main",
          "x": 59,
          "y": 160,
          "territory": "M014",
          "arrowReceiver": {
            "x": 59,
            "y": 190
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 59,
          "y": 160,
          "territory": "M014",
          "arrowReceiver": {
            "x": 59,
            "y": 190
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M016": {
    "territory": "M016",
    "unitSlotName": "main",
    "province": "M016",
    "provinceMapData": {
      "abbr": "PAR",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 94,
          "y": 109,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 185,
      "height": 229,
      "x": 917,
      "y": 1087,
      "playable": true,
      "path": "M 127.00 0.00 L 114.00 0.00 L 110.00 4.00 L 102.00 22.00 L 95.00 31.00 L 81.00 32.00 L 77.00 29.00 L 53.00 30.00 L 42.00 41.00 L 22.00 43.00 L 12.00 48.00 L 0.00 60.00 L 0.00 96.00 L 4.00 102.00 L 9.00 103.00 L 19.00 114.00 L 26.00 115.00 L 33.00 120.00 L 30.00 127.00 L 27.00 128.00 L 27.00 141.00 L 2.00 180.00 L 2.00 201.00 L 22.00 226.00 L 106.00 229.00 L 129.00 197.00 L 130.00 179.00 L 145.00 165.00 L 144.00 150.00 L 168.00 129.00 L 181.00 103.00 L 182.00 93.00 L 185.00 88.00 L 185.00 74.00 L 172.00 74.00 L 167.00 68.00 L 153.00 68.00 L 152.00 67.00 L 142.00 67.00 L 141.00 66.00 L 148.00 59.00 L 149.00 37.00 L 137.00 26.00 L 133.00 4.00 Z",
      "province": "M016",
      "rootTerritory": "M016",
      "viewBox": "0 0 185 229",
      "unitSlots": [
        {
          "name": "main",
          "x": 80,
          "y": 73,
          "territory": "M016",
          "arrowReceiver": {
            "x": 80,
            "y": 103
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 80,
          "y": 73,
          "territory": "M016",
          "arrowReceiver": {
            "x": 80,
            "y": 103
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "帕拉": {
    "territory": "M016",
    "unitSlotName": "main",
    "province": "M016",
    "provinceMapData": {
      "abbr": "PAR",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 94,
          "y": 109,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 185,
      "height": 229,
      "x": 917,
      "y": 1087,
      "playable": true,
      "path": "M 127.00 0.00 L 114.00 0.00 L 110.00 4.00 L 102.00 22.00 L 95.00 31.00 L 81.00 32.00 L 77.00 29.00 L 53.00 30.00 L 42.00 41.00 L 22.00 43.00 L 12.00 48.00 L 0.00 60.00 L 0.00 96.00 L 4.00 102.00 L 9.00 103.00 L 19.00 114.00 L 26.00 115.00 L 33.00 120.00 L 30.00 127.00 L 27.00 128.00 L 27.00 141.00 L 2.00 180.00 L 2.00 201.00 L 22.00 226.00 L 106.00 229.00 L 129.00 197.00 L 130.00 179.00 L 145.00 165.00 L 144.00 150.00 L 168.00 129.00 L 181.00 103.00 L 182.00 93.00 L 185.00 88.00 L 185.00 74.00 L 172.00 74.00 L 167.00 68.00 L 153.00 68.00 L 152.00 67.00 L 142.00 67.00 L 141.00 66.00 L 148.00 59.00 L 149.00 37.00 L 137.00 26.00 L 133.00 4.00 Z",
      "province": "M016",
      "rootTerritory": "M016",
      "viewBox": "0 0 185 229",
      "unitSlots": [
        {
          "name": "main",
          "x": 80,
          "y": 73,
          "territory": "M016",
          "arrowReceiver": {
            "x": 80,
            "y": 103
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 80,
          "y": 73,
          "territory": "M016",
          "arrowReceiver": {
            "x": 80,
            "y": 103
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M015": {
    "territory": "M015",
    "unitSlotName": "main",
    "province": "M015",
    "provinceMapData": {
      "abbr": "MVS",
      "type": "Coast",
      "centerPos": {
        "x": 31,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 48,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 95,
      "height": 68,
      "x": 743,
      "y": 1815,
      "playable": true,
      "path": "M 2.00 0.00 L 0.00 40.00 L 3.00 45.00 L 2.00 63.00 L 5.00 68.00 L 94.00 68.00 L 95.00 67.00 L 95.00 1.00 Z",
      "province": "M015",
      "rootTerritory": "M015",
      "viewBox": "0 0 95 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 17,
          "territory": "M015",
          "arrowReceiver": {
            "x": 41,
            "y": 47
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 17,
          "territory": "M015",
          "arrowReceiver": {
            "x": 41,
            "y": 47
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "马尔维纳斯": {
    "territory": "M015",
    "unitSlotName": "main",
    "province": "M015",
    "provinceMapData": {
      "abbr": "MVS",
      "type": "Coast",
      "centerPos": {
        "x": 31,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 48,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 95,
      "height": 68,
      "x": 743,
      "y": 1815,
      "playable": true,
      "path": "M 2.00 0.00 L 0.00 40.00 L 3.00 45.00 L 2.00 63.00 L 5.00 68.00 L 94.00 68.00 L 95.00 67.00 L 95.00 1.00 Z",
      "province": "M015",
      "rootTerritory": "M015",
      "viewBox": "0 0 95 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 17,
          "territory": "M015",
          "arrowReceiver": {
            "x": 41,
            "y": 47
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 17,
          "territory": "M015",
          "arrowReceiver": {
            "x": 41,
            "y": 47
          }
        }
      },
      "texture": {
        "texture": "#A8ABCE",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_64_a_a": {
    "territory": "REGION_64_a_a",
    "unitSlotName": "main",
    "province": "REGION_64_a_a",
    "provinceMapData": {
      "abbr": "MPO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 186,
          "y": 339,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 357,
      "height": 444,
      "x": 56,
      "y": 724,
      "playable": true,
      "path": "M 29.881 0.215 L 29.436 4.947 L 29.334 6.031 L 28.123 18.917 L 28.021 20.002 L 27.276 27.932 L 27.174 29.016 L 26.429 36.946 L 26.327 38.031 L 25.582 45.961 L 25.480 47.046 L 23.422 68.946 L 23.320 70.030 L 21.635 87.966 L 21.533 89.050 L 20.229 102.927 L 20.127 104.012 L 19.382 111.942 L 19.280 113.026 L 17.781 128.980 L 17.679 130.064 L 16.469 142.950 L 16.367 144.035 L 15.342 154.938 L 15.240 156.023 L 14.122 167.917 L 14.021 169.002 L 12.335 186.937 L 12.233 188.022 L 11.395 196.943 L 11.293 198.027 L 10.455 206.948 L 10.353 208.033 L 9.422 217.945 L 9.320 219.031 L 8.295 229.934 L 8.193 231.019 L 7.448 238.948 L 7.346 240.033 L 6.601 247.963 L 6.499 249.047 L 5.381 260.942 L 5.279 262.026 L 4.627 268.965 L 4.526 270.049 L 3.128 284.918 L 3.027 286.002 L 2.188 294.923 L 2.086 296.008 L 1.434 302.947 L 1.332 304.031 L 0.587 311.961 L 0.485 313.046 L 0.092 317.236 L 29.000 318.000 L 34.000 321.000 L 46.000 321.000 L 47.000 322.000 L 70.000 322.000 L 71.000 323.000 L 82.000 323.000 L 87.000 329.000 L 87.000 388.000 L 86.000 389.000 L 85.975 400.662 L 88.000 409.232 L 90.068 417.985 L 90.843 421.267 L 92.340 428.006 L 98.953 428.492 L 100.038 428.594 L 114.908 429.979 L 115.993 430.080 L 122.932 430.726 L 124.016 430.827 L 130.956 431.474 L 132.040 431.575 L 141.953 432.498 L 143.038 432.599 L 151.960 433.430 L 153.044 433.531 L 160.975 434.270 L 162.060 434.371 L 172.964 435.387 L 174.048 435.488 L 187.926 436.781 L 189.012 436.882 L 201.992 438.091 L 203.076 438.192 L 215.963 439.393 L 217.047 439.494 L 226.960 440.417 L 228.046 440.518 L 235.975 441.257 L 237.060 441.358 L 245.982 442.189 L 247.066 442.290 L 263.989 443.867 L 262.000 432.000 L 266.000 428.000 L 267.000 428.000 L 274.000 421.000 L 275.000 421.000 L 283.000 413.000 L 284.000 413.000 L 339.000 364.000 L 349.957 361.996 L 350.200 359.016 L 350.288 357.943 L 352.400 332.032 L 352.488 330.959 L 353.055 324.005 L 353.142 322.931 L 354.276 309.022 L 354.364 307.949 L 355.498 294.039 L 355.585 292.967 L 356.342 285.164 L 335.490 276.219 L 329.548 273.697 L 325.864 272.134 L 325.864 272.134 L 317.000 275.000 L 316.000 274.000 L 296.000 274.000 L 291.000 271.000 L 258.000 270.000 L 254.000 265.000 L 254.000 221.000 L 252.000 218.000 L 222.000 217.000 L 221.000 216.000 L 211.000 216.000 L 208.000 214.000 L 190.000 214.000 L 187.000 212.000 L 179.000 212.000 L 170.000 207.000 L 111.000 204.000 L 110.000 203.000 L 107.000 203.000 L 106.000 202.000 L 95.000 199.000 L 93.000 197.000 L 94.000 162.000 L 97.000 157.000 L 97.000 149.000 L 99.000 146.000 L 102.000 93.000 L 90.000 94.000 L 86.000 89.000 L 70.000 87.000 L 66.000 84.000 L 66.000 77.000 L 67.000 76.000 L 67.000 60.000 L 68.000 59.000 L 68.000 51.000 L 69.000 50.000 L 69.000 42.000 L 67.000 39.000 L 67.000 29.000 L 45.000 6.000 L 45.000 0.000 Z",
      "province": "REGION_64_a_a",
      "rootTerritory": "REGION_64_a_a",
      "viewBox": "0 0 357 444",
      "unitSlots": [
        {
          "name": "main",
          "x": 174,
          "y": 288,
          "territory": "REGION_64_a_a",
          "arrowReceiver": {
            "x": 174,
            "y": 318
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 174,
          "y": 288,
          "territory": "REGION_64_a_a",
          "arrowReceiver": {
            "x": 174,
            "y": 318
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "中太平洋": {
    "territory": "REGION_64_a_a",
    "unitSlotName": "main",
    "province": "REGION_64_a_a",
    "provinceMapData": {
      "abbr": "MPO",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 186,
          "y": 339,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 357,
      "height": 444,
      "x": 56,
      "y": 724,
      "playable": true,
      "path": "M 29.881 0.215 L 29.436 4.947 L 29.334 6.031 L 28.123 18.917 L 28.021 20.002 L 27.276 27.932 L 27.174 29.016 L 26.429 36.946 L 26.327 38.031 L 25.582 45.961 L 25.480 47.046 L 23.422 68.946 L 23.320 70.030 L 21.635 87.966 L 21.533 89.050 L 20.229 102.927 L 20.127 104.012 L 19.382 111.942 L 19.280 113.026 L 17.781 128.980 L 17.679 130.064 L 16.469 142.950 L 16.367 144.035 L 15.342 154.938 L 15.240 156.023 L 14.122 167.917 L 14.021 169.002 L 12.335 186.937 L 12.233 188.022 L 11.395 196.943 L 11.293 198.027 L 10.455 206.948 L 10.353 208.033 L 9.422 217.945 L 9.320 219.031 L 8.295 229.934 L 8.193 231.019 L 7.448 238.948 L 7.346 240.033 L 6.601 247.963 L 6.499 249.047 L 5.381 260.942 L 5.279 262.026 L 4.627 268.965 L 4.526 270.049 L 3.128 284.918 L 3.027 286.002 L 2.188 294.923 L 2.086 296.008 L 1.434 302.947 L 1.332 304.031 L 0.587 311.961 L 0.485 313.046 L 0.092 317.236 L 29.000 318.000 L 34.000 321.000 L 46.000 321.000 L 47.000 322.000 L 70.000 322.000 L 71.000 323.000 L 82.000 323.000 L 87.000 329.000 L 87.000 388.000 L 86.000 389.000 L 85.975 400.662 L 88.000 409.232 L 90.068 417.985 L 90.843 421.267 L 92.340 428.006 L 98.953 428.492 L 100.038 428.594 L 114.908 429.979 L 115.993 430.080 L 122.932 430.726 L 124.016 430.827 L 130.956 431.474 L 132.040 431.575 L 141.953 432.498 L 143.038 432.599 L 151.960 433.430 L 153.044 433.531 L 160.975 434.270 L 162.060 434.371 L 172.964 435.387 L 174.048 435.488 L 187.926 436.781 L 189.012 436.882 L 201.992 438.091 L 203.076 438.192 L 215.963 439.393 L 217.047 439.494 L 226.960 440.417 L 228.046 440.518 L 235.975 441.257 L 237.060 441.358 L 245.982 442.189 L 247.066 442.290 L 263.989 443.867 L 262.000 432.000 L 266.000 428.000 L 267.000 428.000 L 274.000 421.000 L 275.000 421.000 L 283.000 413.000 L 284.000 413.000 L 339.000 364.000 L 349.957 361.996 L 350.200 359.016 L 350.288 357.943 L 352.400 332.032 L 352.488 330.959 L 353.055 324.005 L 353.142 322.931 L 354.276 309.022 L 354.364 307.949 L 355.498 294.039 L 355.585 292.967 L 356.342 285.164 L 335.490 276.219 L 329.548 273.697 L 325.864 272.134 L 325.864 272.134 L 317.000 275.000 L 316.000 274.000 L 296.000 274.000 L 291.000 271.000 L 258.000 270.000 L 254.000 265.000 L 254.000 221.000 L 252.000 218.000 L 222.000 217.000 L 221.000 216.000 L 211.000 216.000 L 208.000 214.000 L 190.000 214.000 L 187.000 212.000 L 179.000 212.000 L 170.000 207.000 L 111.000 204.000 L 110.000 203.000 L 107.000 203.000 L 106.000 202.000 L 95.000 199.000 L 93.000 197.000 L 94.000 162.000 L 97.000 157.000 L 97.000 149.000 L 99.000 146.000 L 102.000 93.000 L 90.000 94.000 L 86.000 89.000 L 70.000 87.000 L 66.000 84.000 L 66.000 77.000 L 67.000 76.000 L 67.000 60.000 L 68.000 59.000 L 68.000 51.000 L 69.000 50.000 L 69.000 42.000 L 67.000 39.000 L 67.000 29.000 L 45.000 6.000 L 45.000 0.000 Z",
      "province": "REGION_64_a_a",
      "rootTerritory": "REGION_64_a_a",
      "viewBox": "0 0 357 444",
      "unitSlots": [
        {
          "name": "main",
          "x": 174,
          "y": 288,
          "territory": "REGION_64_a_a",
          "arrowReceiver": {
            "x": 174,
            "y": 318
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 174,
          "y": 288,
          "territory": "REGION_64_a_a",
          "arrowReceiver": {
            "x": 174,
            "y": 318
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_64_a_b": {
    "territory": "REGION_64_a_b",
    "unitSlotName": "main",
    "province": "REGION_64_a_b",
    "provinceMapData": {
      "abbr": "GAL",
      "type": "Coast",
      "centerPos": {
        "x": 50,
        "y": 82
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 67,
          "y": 75,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 122,
      "height": 128,
      "x": 317,
      "y": 1087,
      "playable": true,
      "path": "M 88.00 0.00 L 76.00 0.00 L 0.00 67.00 L 0.00 81.00 L 8.00 81.00 L 11.00 83.00 L 11.00 127.00 L 104.00 128.00 L 105.00 127.00 L 118.00 127.00 L 119.00 126.00 L 120.00 88.00 L 122.00 86.00 L 120.00 33.00 L 91.00 32.00 L 87.00 28.00 L 89.00 21.00 L 89.00 1.00 Z",
      "province": "REGION_64_a_b",
      "rootTerritory": "REGION_64_a_b",
      "viewBox": "0 0 122 128",
      "unitSlots": [
        {
          "name": "main",
          "x": 86,
          "y": 106,
          "territory": "REGION_64_a_b",
          "arrowReceiver": {
            "x": 86,
            "y": 136
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 86,
          "y": 106,
          "territory": "REGION_64_a_b",
          "arrowReceiver": {
            "x": 86,
            "y": 136
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "加拉帕戈斯": {
    "territory": "REGION_64_a_b",
    "unitSlotName": "main",
    "province": "REGION_64_a_b",
    "provinceMapData": {
      "abbr": "GAL",
      "type": "Coast",
      "centerPos": {
        "x": 50,
        "y": 82
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 67,
          "y": 75,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 122,
      "height": 128,
      "x": 317,
      "y": 1087,
      "playable": true,
      "path": "M 88.00 0.00 L 76.00 0.00 L 0.00 67.00 L 0.00 81.00 L 8.00 81.00 L 11.00 83.00 L 11.00 127.00 L 104.00 128.00 L 105.00 127.00 L 118.00 127.00 L 119.00 126.00 L 120.00 88.00 L 122.00 86.00 L 120.00 33.00 L 91.00 32.00 L 87.00 28.00 L 89.00 21.00 L 89.00 1.00 Z",
      "province": "REGION_64_a_b",
      "rootTerritory": "REGION_64_a_b",
      "viewBox": "0 0 122 128",
      "unitSlots": [
        {
          "name": "main",
          "x": 86,
          "y": 106,
          "territory": "REGION_64_a_b",
          "arrowReceiver": {
            "x": 86,
            "y": 136
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 86,
          "y": 106,
          "territory": "REGION_64_a_b",
          "arrowReceiver": {
            "x": 86,
            "y": 136
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_43_a": {
    "territory": "REGION_43_a",
    "unitSlotName": "main",
    "province": "REGION_43_a",
    "provinceMapData": {
      "abbr": "GSC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 33,
          "y": 135,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 71,
      "height": 172,
      "x": 37,
      "y": 553,
      "playable": true,
      "path": "M 26.000 0.000 L 17.000 23.000 L 17.000 56.000 L 11.000 67.000 L 10.000 96.000 L 6.000 100.000 L 7.000 112.000 L 2.000 121.000 L 0.000 161.000 L 16.000 167.000 L 38.000 167.000 L 48.881 171.215 L 64.000 172.000 L 64.000 162.000 L 71.000 154.000 L 68.000 126.000 L 63.000 121.000 L 62.000 111.000 L 45.000 95.000 L 47.000 36.000 L 48.000 35.000 L 58.000 35.000 L 58.000 23.000 L 45.000 3.000 L 39.000 0.000 Z",
      "province": "REGION_43_a",
      "rootTerritory": "REGION_43_a",
      "viewBox": "0 0 71 172",
      "unitSlots": [
        {
          "name": "main",
          "x": 34,
          "y": 147,
          "territory": "REGION_43_a",
          "arrowReceiver": {
            "x": 34,
            "y": 177
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34,
          "y": 147,
          "territory": "REGION_43_a",
          "arrowReceiver": {
            "x": 34,
            "y": 177
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "圣卡塔利娜湾": {
    "territory": "REGION_43_a",
    "unitSlotName": "main",
    "province": "REGION_43_a",
    "provinceMapData": {
      "abbr": "GSC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 33,
          "y": 135,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 71,
      "height": 172,
      "x": 37,
      "y": 553,
      "playable": true,
      "path": "M 26.000 0.000 L 17.000 23.000 L 17.000 56.000 L 11.000 67.000 L 10.000 96.000 L 6.000 100.000 L 7.000 112.000 L 2.000 121.000 L 0.000 161.000 L 16.000 167.000 L 38.000 167.000 L 48.881 171.215 L 64.000 172.000 L 64.000 162.000 L 71.000 154.000 L 68.000 126.000 L 63.000 121.000 L 62.000 111.000 L 45.000 95.000 L 47.000 36.000 L 48.000 35.000 L 58.000 35.000 L 58.000 23.000 L 45.000 3.000 L 39.000 0.000 Z",
      "province": "REGION_43_a",
      "rootTerritory": "REGION_43_a",
      "viewBox": "0 0 71 172",
      "unitSlots": [
        {
          "name": "main",
          "x": 34,
          "y": 147,
          "territory": "REGION_43_a",
          "arrowReceiver": {
            "x": 34,
            "y": 177
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34,
          "y": 147,
          "territory": "REGION_43_a",
          "arrowReceiver": {
            "x": 34,
            "y": 177
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M019": {
    "territory": "M019",
    "unitSlotName": "main",
    "province": "M019",
    "provinceMapData": {
      "abbr": "ALA",
      "type": "Coast",
      "centerPos": {
        "x": 112,
        "y": 67
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 129,
          "y": 60,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 234,
      "height": 191,
      "x": 80,
      "y": 77,
      "playable": true,
      "path": "M 232.00 25.00 L 229.00 21.00 L 226.00 20.00 L 219.00 13.00 L 220.00 3.00 L 215.00 0.00 L 159.00 3.00 L 130.00 21.00 L 112.00 19.00 L 108.00 24.00 L 100.00 26.00 L 97.00 29.00 L 97.00 36.00 L 86.00 45.00 L 64.00 44.00 L 55.00 49.00 L 40.00 51.00 L 38.00 55.00 L 25.00 68.00 L 21.00 77.00 L 12.00 83.00 L 12.00 91.00 L 3.00 99.00 L 2.00 103.00 L 0.00 105.00 L 0.00 120.00 L 3.00 122.00 L 28.00 123.00 L 39.00 114.00 L 42.00 108.00 L 56.00 108.00 L 64.00 103.00 L 71.00 102.00 L 78.00 108.00 L 79.00 120.00 L 82.00 123.00 L 79.00 130.00 L 76.00 188.00 L 82.00 191.00 L 110.00 189.00 L 111.00 188.00 L 111.00 171.00 L 114.00 168.00 L 126.00 144.00 L 125.00 125.00 L 119.00 121.00 L 116.00 116.00 L 132.00 103.00 L 179.00 80.00 L 229.00 45.00 L 234.00 46.00 Z",
      "province": "M019",
      "rootTerritory": "M019",
      "viewBox": "0 0 234 191",
      "unitSlots": [
        {
          "name": "main",
          "x": 117,
          "y": 50,
          "territory": "M019",
          "arrowReceiver": {
            "x": 117,
            "y": 80
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 117,
          "y": 50,
          "territory": "M019",
          "arrowReceiver": {
            "x": 117,
            "y": 80
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "阿拉斯加": {
    "territory": "M019",
    "unitSlotName": "main",
    "province": "M019",
    "provinceMapData": {
      "abbr": "ALA",
      "type": "Coast",
      "centerPos": {
        "x": 112,
        "y": 67
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 129,
          "y": 60,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 234,
      "height": 191,
      "x": 80,
      "y": 77,
      "playable": true,
      "path": "M 232.00 25.00 L 229.00 21.00 L 226.00 20.00 L 219.00 13.00 L 220.00 3.00 L 215.00 0.00 L 159.00 3.00 L 130.00 21.00 L 112.00 19.00 L 108.00 24.00 L 100.00 26.00 L 97.00 29.00 L 97.00 36.00 L 86.00 45.00 L 64.00 44.00 L 55.00 49.00 L 40.00 51.00 L 38.00 55.00 L 25.00 68.00 L 21.00 77.00 L 12.00 83.00 L 12.00 91.00 L 3.00 99.00 L 2.00 103.00 L 0.00 105.00 L 0.00 120.00 L 3.00 122.00 L 28.00 123.00 L 39.00 114.00 L 42.00 108.00 L 56.00 108.00 L 64.00 103.00 L 71.00 102.00 L 78.00 108.00 L 79.00 120.00 L 82.00 123.00 L 79.00 130.00 L 76.00 188.00 L 82.00 191.00 L 110.00 189.00 L 111.00 188.00 L 111.00 171.00 L 114.00 168.00 L 126.00 144.00 L 125.00 125.00 L 119.00 121.00 L 116.00 116.00 L 132.00 103.00 L 179.00 80.00 L 229.00 45.00 L 234.00 46.00 Z",
      "province": "M019",
      "rootTerritory": "M019",
      "viewBox": "0 0 234 191",
      "unitSlots": [
        {
          "name": "main",
          "x": 117,
          "y": 50,
          "territory": "M019",
          "arrowReceiver": {
            "x": 117,
            "y": 80
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 117,
          "y": 50,
          "territory": "M019",
          "arrowReceiver": {
            "x": 117,
            "y": 80
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M020": {
    "territory": "M020",
    "unitSlotName": "main",
    "province": "M020",
    "provinceMapData": {
      "abbr": "WDM",
      "type": "Coast",
      "centerPos": {
        "x": 30,
        "y": 39
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 93,
      "x": 374,
      "y": 859,
      "playable": true,
      "path": "M 79.00 0.00 L 61.00 0.00 L 52.00 10.00 L 39.00 10.00 L 33.00 7.00 L 28.00 1.00 L 13.00 0.00 L 11.00 12.00 L 25.00 34.00 L 24.00 39.00 L 22.00 41.00 L 5.00 51.00 L 4.00 70.00 L 0.00 71.00 L 0.00 77.00 L 12.00 89.00 L 19.00 90.00 L 24.00 93.00 L 30.00 93.00 L 30.00 88.00 L 31.00 87.00 L 35.00 87.00 L 37.00 84.00 L 49.00 82.00 L 49.00 70.00 L 51.00 68.00 L 51.00 60.00 L 53.00 56.00 L 56.00 53.00 L 63.00 51.00 L 66.00 46.00 L 70.00 46.00 L 71.00 39.00 L 77.00 34.00 L 78.00 21.00 L 81.00 16.00 L 81.00 2.00 Z",
      "province": "M020",
      "rootTerritory": "M020",
      "viewBox": "0 0 81 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        "nc": {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        "sc": {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "危地马拉": {
    "territory": "M020",
    "unitSlotName": "main",
    "province": "M020",
    "provinceMapData": {
      "abbr": "WDM",
      "type": "Coast",
      "centerPos": {
        "x": 30,
        "y": 39
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 93,
      "x": 374,
      "y": 859,
      "playable": true,
      "path": "M 79.00 0.00 L 61.00 0.00 L 52.00 10.00 L 39.00 10.00 L 33.00 7.00 L 28.00 1.00 L 13.00 0.00 L 11.00 12.00 L 25.00 34.00 L 24.00 39.00 L 22.00 41.00 L 5.00 51.00 L 4.00 70.00 L 0.00 71.00 L 0.00 77.00 L 12.00 89.00 L 19.00 90.00 L 24.00 93.00 L 30.00 93.00 L 30.00 88.00 L 31.00 87.00 L 35.00 87.00 L 37.00 84.00 L 49.00 82.00 L 49.00 70.00 L 51.00 68.00 L 51.00 60.00 L 53.00 56.00 L 56.00 53.00 L 63.00 51.00 L 66.00 46.00 L 70.00 46.00 L 71.00 39.00 L 77.00 34.00 L 78.00 21.00 L 81.00 16.00 L 81.00 2.00 Z",
      "province": "M020",
      "rootTerritory": "M020",
      "viewBox": "0 0 81 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        "nc": {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        "sc": {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M009": {
    "territory": "M009",
    "unitSlotName": "main",
    "province": "M009",
    "provinceMapData": {
      "abbr": "EST",
      "type": "Coast",
      "centerPos": {
        "x": 23,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 87,
      "height": 76,
      "x": 134,
      "y": 1644,
      "playable": true,
      "path": "M 3.00 3.00 L 0.00 66.00 L 4.00 73.00 L 22.00 73.00 L 23.00 74.00 L 36.00 75.00 L 37.00 76.00 L 40.00 74.00 L 40.00 64.00 L 41.00 63.00 L 57.00 63.00 L 58.00 62.00 L 74.00 62.00 L 75.00 61.00 L 75.00 59.00 L 76.00 58.00 L 76.00 53.00 L 77.00 52.00 L 77.00 47.00 L 78.00 46.00 L 78.00 42.00 L 79.00 41.00 L 79.00 36.00 L 80.00 35.00 L 80.00 30.00 L 81.00 29.00 L 81.00 27.00 L 87.00 21.00 L 87.00 6.00 L 85.00 2.00 L 48.00 2.00 L 45.00 0.00 L 23.00 0.00 L 20.00 2.00 Z",
      "province": "M009",
      "rootTerritory": "M009",
      "viewBox": "0 0 87 76",
      "unitSlots": [
        {
          "name": "main",
          "x": 50,
          "y": 46,
          "territory": "M009",
          "arrowReceiver": {
            "x": 50,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 50,
          "y": 46,
          "territory": "M009",
          "arrowReceiver": {
            "x": 50,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "复活节岛": {
    "territory": "M009",
    "unitSlotName": "main",
    "province": "M009",
    "provinceMapData": {
      "abbr": "EST",
      "type": "Coast",
      "centerPos": {
        "x": 23,
        "y": 16
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 40,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 87,
      "height": 76,
      "x": 134,
      "y": 1644,
      "playable": true,
      "path": "M 3.00 3.00 L 0.00 66.00 L 4.00 73.00 L 22.00 73.00 L 23.00 74.00 L 36.00 75.00 L 37.00 76.00 L 40.00 74.00 L 40.00 64.00 L 41.00 63.00 L 57.00 63.00 L 58.00 62.00 L 74.00 62.00 L 75.00 61.00 L 75.00 59.00 L 76.00 58.00 L 76.00 53.00 L 77.00 52.00 L 77.00 47.00 L 78.00 46.00 L 78.00 42.00 L 79.00 41.00 L 79.00 36.00 L 80.00 35.00 L 80.00 30.00 L 81.00 29.00 L 81.00 27.00 L 87.00 21.00 L 87.00 6.00 L 85.00 2.00 L 48.00 2.00 L 45.00 0.00 L 23.00 0.00 L 20.00 2.00 Z",
      "province": "M009",
      "rootTerritory": "M009",
      "viewBox": "0 0 87 76",
      "unitSlots": [
        {
          "name": "main",
          "x": 50,
          "y": 46,
          "territory": "M009",
          "arrowReceiver": {
            "x": 50,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 50,
          "y": 46,
          "territory": "M009",
          "arrowReceiver": {
            "x": 50,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M010_a": {
    "territory": "M010_a",
    "unitSlotName": "main",
    "province": "M010_a",
    "provinceMapData": {
      "abbr": "TDF",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 45,
          "y": 29,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 77,
      "height": 46,
      "x": 622,
      "y": 1832,
      "playable": true,
      "path": "M 77.00 20.00 L 70.00 13.00 L 63.00 10.00 L 54.00 4.00 L 46.00 0.00 L 41.00 0.00 L 40.00 10.00 L 12.00 37.00 L 6.00 40.00 L 0.00 40.00 L 0.00 43.00 L 25.00 41.00 L 34.00 46.00 L 53.00 46.00 L 62.00 35.00 L 75.00 34.00 Z",
      "province": "M010_a",
      "rootTerritory": "M010_a",
      "viewBox": "0 0 77 46",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 23,
          "territory": "M010_a",
          "arrowReceiver": {
            "x": 37,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 23,
          "territory": "M010_a",
          "arrowReceiver": {
            "x": 37,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "火地岛": {
    "territory": "M010_a",
    "unitSlotName": "main",
    "province": "M010_a",
    "provinceMapData": {
      "abbr": "TDF",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 45,
          "y": 29,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 77,
      "height": 46,
      "x": 622,
      "y": 1832,
      "playable": true,
      "path": "M 77.00 20.00 L 70.00 13.00 L 63.00 10.00 L 54.00 4.00 L 46.00 0.00 L 41.00 0.00 L 40.00 10.00 L 12.00 37.00 L 6.00 40.00 L 0.00 40.00 L 0.00 43.00 L 25.00 41.00 L 34.00 46.00 L 53.00 46.00 L 62.00 35.00 L 75.00 34.00 Z",
      "province": "M010_a",
      "rootTerritory": "M010_a",
      "viewBox": "0 0 77 46",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 23,
          "territory": "M010_a",
          "arrowReceiver": {
            "x": 37,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 23,
          "territory": "M010_a",
          "arrowReceiver": {
            "x": 37,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M010": {
    "territory": "M010",
    "unitSlotName": "main",
    "province": "M010",
    "provinceMapData": {
      "abbr": "MGL",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 57,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 92,
      "height": 83,
      "x": 572,
      "y": 1791,
      "playable": true,
      "path": "M 92.00 40.00 L 89.00 36.00 L 75.00 36.00 L 75.00 42.00 L 65.00 52.00 L 56.00 52.00 L 54.00 49.00 L 65.00 25.00 L 65.00 5.00 L 60.00 5.00 L 57.00 4.00 L 53.00 0.00 L 50.00 0.00 L 45.00 8.00 L 39.00 14.00 L 29.00 13.00 L 28.00 21.00 L 25.00 27.00 L 1.00 58.00 L 0.00 72.00 L 2.00 72.00 L 4.00 74.00 L 4.00 79.00 L 13.00 78.00 L 15.00 81.00 L 29.00 80.00 L 32.00 83.00 L 58.00 82.00 L 64.00 79.00 L 91.00 53.00 Z",
      "province": "M010",
      "rootTerritory": "M010",
      "viewBox": "0 0 92 83",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 48,
          "territory": "M010",
          "arrowReceiver": {
            "x": 37,
            "y": 78
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 48,
          "territory": "M010",
          "arrowReceiver": {
            "x": 37,
            "y": 78
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "麦哲伦": {
    "territory": "M010",
    "unitSlotName": "main",
    "province": "M010",
    "provinceMapData": {
      "abbr": "MGL",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 32,
          "y": 57,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 92,
      "height": 83,
      "x": 572,
      "y": 1791,
      "playable": true,
      "path": "M 92.00 40.00 L 89.00 36.00 L 75.00 36.00 L 75.00 42.00 L 65.00 52.00 L 56.00 52.00 L 54.00 49.00 L 65.00 25.00 L 65.00 5.00 L 60.00 5.00 L 57.00 4.00 L 53.00 0.00 L 50.00 0.00 L 45.00 8.00 L 39.00 14.00 L 29.00 13.00 L 28.00 21.00 L 25.00 27.00 L 1.00 58.00 L 0.00 72.00 L 2.00 72.00 L 4.00 74.00 L 4.00 79.00 L 13.00 78.00 L 15.00 81.00 L 29.00 80.00 L 32.00 83.00 L 58.00 82.00 L 64.00 79.00 L 91.00 53.00 Z",
      "province": "M010",
      "rootTerritory": "M010",
      "viewBox": "0 0 92 83",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 48,
          "territory": "M010",
          "arrowReceiver": {
            "x": 37,
            "y": 78
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 48,
          "territory": "M010",
          "arrowReceiver": {
            "x": 37,
            "y": 78
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M023": {
    "territory": "M023",
    "unitSlotName": "main",
    "province": "M023",
    "provinceMapData": {
      "abbr": "PNH",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 97,
          "y": 94,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 215,
      "height": 207,
      "x": 470,
      "y": 163,
      "playable": true,
      "path": "M 106.00 0.00 L 102.00 5.00 L 92.00 6.00 L 90.00 19.00 L 86.00 23.00 L 81.00 23.00 L 67.00 39.00 L 54.00 39.00 L 46.00 46.00 L 38.00 47.00 L 30.00 58.00 L 22.00 60.00 L 1.00 83.00 L 0.00 106.00 L 5.00 107.00 L 11.00 111.00 L 14.00 127.00 L 18.00 129.00 L 29.00 129.00 L 75.00 155.00 L 98.00 156.00 L 101.00 160.00 L 101.00 182.00 L 111.00 190.00 L 111.00 193.00 L 114.00 200.00 L 123.00 207.00 L 144.00 206.00 L 146.00 201.00 L 151.00 197.00 L 151.00 180.00 L 146.00 171.00 L 145.00 167.00 L 147.00 165.00 L 150.00 164.00 L 169.00 145.00 L 169.00 131.00 L 167.00 127.00 L 166.00 118.00 L 163.00 112.00 L 156.00 106.00 L 161.00 100.00 L 161.00 85.00 L 156.00 78.00 L 157.00 75.00 L 159.00 73.00 L 180.00 74.00 L 184.00 79.00 L 204.00 79.00 L 205.00 80.00 L 207.00 77.00 L 215.00 71.00 L 215.00 69.00 L 214.00 68.00 L 214.00 64.00 L 212.00 59.00 L 205.00 50.00 L 190.00 43.00 L 184.00 36.00 L 175.00 36.00 L 174.00 35.00 L 174.00 25.00 L 171.00 21.00 L 168.00 20.00 L 166.00 18.00 L 166.00 5.00 Z",
      "province": "M023",
      "rootTerritory": "M023",
      "viewBox": "0 0 215 207",
      "unitSlots": [
        {
          "name": "main",
          "x": 111,
          "y": 62,
          "territory": "M023",
          "arrowReceiver": {
            "x": 111,
            "y": 92
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 111,
          "y": 62,
          "territory": "M023",
          "arrowReceiver": {
            "x": 111,
            "y": 92
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "哈德逊湾": {
    "territory": "M023",
    "unitSlotName": "main",
    "province": "M023",
    "provinceMapData": {
      "abbr": "PNH",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 97,
          "y": 94,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 215,
      "height": 207,
      "x": 470,
      "y": 163,
      "playable": true,
      "path": "M 106.00 0.00 L 102.00 5.00 L 92.00 6.00 L 90.00 19.00 L 86.00 23.00 L 81.00 23.00 L 67.00 39.00 L 54.00 39.00 L 46.00 46.00 L 38.00 47.00 L 30.00 58.00 L 22.00 60.00 L 1.00 83.00 L 0.00 106.00 L 5.00 107.00 L 11.00 111.00 L 14.00 127.00 L 18.00 129.00 L 29.00 129.00 L 75.00 155.00 L 98.00 156.00 L 101.00 160.00 L 101.00 182.00 L 111.00 190.00 L 111.00 193.00 L 114.00 200.00 L 123.00 207.00 L 144.00 206.00 L 146.00 201.00 L 151.00 197.00 L 151.00 180.00 L 146.00 171.00 L 145.00 167.00 L 147.00 165.00 L 150.00 164.00 L 169.00 145.00 L 169.00 131.00 L 167.00 127.00 L 166.00 118.00 L 163.00 112.00 L 156.00 106.00 L 161.00 100.00 L 161.00 85.00 L 156.00 78.00 L 157.00 75.00 L 159.00 73.00 L 180.00 74.00 L 184.00 79.00 L 204.00 79.00 L 205.00 80.00 L 207.00 77.00 L 215.00 71.00 L 215.00 69.00 L 214.00 68.00 L 214.00 64.00 L 212.00 59.00 L 205.00 50.00 L 190.00 43.00 L 184.00 36.00 L 175.00 36.00 L 174.00 35.00 L 174.00 25.00 L 171.00 21.00 L 168.00 20.00 L 166.00 18.00 L 166.00 5.00 Z",
      "province": "M023",
      "rootTerritory": "M023",
      "viewBox": "0 0 215 207",
      "unitSlots": [
        {
          "name": "main",
          "x": 111,
          "y": 62,
          "territory": "M023",
          "arrowReceiver": {
            "x": 111,
            "y": 92
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 111,
          "y": 62,
          "territory": "M023",
          "arrowReceiver": {
            "x": 111,
            "y": 92
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M024_a": {
    "territory": "M024_a",
    "unitSlotName": "main",
    "province": "M024_a",
    "provinceMapData": {
      "abbr": "EGL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 29,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 116,
      "height": 81,
      "x": 544,
      "y": 423,
      "playable": true,
      "path": "M 0.000 68.000 L 18.000 76.000 L 27.000 76.000 L 31.000 71.000 L 46.000 71.000 L 47.000 72.000 L 46.000 81.000 L 49.000 81.000 L 51.000 78.000 L 59.000 74.000 L 74.000 75.000 L 74.000 65.000 L 90.000 55.000 L 103.000 42.000 L 106.000 35.000 L 116.000 25.000 L 116.000 23.000 L 111.000 23.000 L 85.000 36.000 L 78.000 44.000 L 58.000 43.000 L 54.000 48.000 L 49.000 48.000 L 48.000 45.000 L 58.000 36.000 L 58.000 13.000 L 51.000 6.000 L 36.000 5.000 L 32.000 0.000 L 18.000 0.000 L 17.000 1.000 L 9.431 0.251 L 7.408 7.483 L 3.571 21.204 L 2.433 25.270 L 2.433 25.270 L 2.433 25.270 L 2.000 33.000 L 2.000 43.000 L 1.000 44.000 L 1.000 55.000 L 4.000 57.000 L 0.000 63.000 Z",
      "province": "M024_a",
      "rootTerritory": "M024_a",
      "viewBox": "0 0 116 81",
      "unitSlots": [
        {
          "name": "main",
          "x": 57,
          "y": 51,
          "territory": "M024_a",
          "arrowReceiver": {
            "x": 57,
            "y": 81
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57,
          "y": 51,
          "territory": "M024_a",
          "arrowReceiver": {
            "x": 57,
            "y": 81
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "东五大湖": {
    "territory": "M024_a",
    "unitSlotName": "main",
    "province": "M024_a",
    "provinceMapData": {
      "abbr": "EGL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 29,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 116,
      "height": 81,
      "x": 544,
      "y": 423,
      "playable": true,
      "path": "M 0.000 68.000 L 18.000 76.000 L 27.000 76.000 L 31.000 71.000 L 46.000 71.000 L 47.000 72.000 L 46.000 81.000 L 49.000 81.000 L 51.000 78.000 L 59.000 74.000 L 74.000 75.000 L 74.000 65.000 L 90.000 55.000 L 103.000 42.000 L 106.000 35.000 L 116.000 25.000 L 116.000 23.000 L 111.000 23.000 L 85.000 36.000 L 78.000 44.000 L 58.000 43.000 L 54.000 48.000 L 49.000 48.000 L 48.000 45.000 L 58.000 36.000 L 58.000 13.000 L 51.000 6.000 L 36.000 5.000 L 32.000 0.000 L 18.000 0.000 L 17.000 1.000 L 9.431 0.251 L 7.408 7.483 L 3.571 21.204 L 2.433 25.270 L 2.433 25.270 L 2.433 25.270 L 2.000 33.000 L 2.000 43.000 L 1.000 44.000 L 1.000 55.000 L 4.000 57.000 L 0.000 63.000 Z",
      "province": "M024_a",
      "rootTerritory": "M024_a",
      "viewBox": "0 0 116 81",
      "unitSlots": [
        {
          "name": "main",
          "x": 57,
          "y": 51,
          "territory": "M024_a",
          "arrowReceiver": {
            "x": 57,
            "y": 81
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57,
          "y": 51,
          "territory": "M024_a",
          "arrowReceiver": {
            "x": 57,
            "y": 81
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M024": {
    "territory": "M024",
    "unitSlotName": "main",
    "province": "M024",
    "provinceMapData": {
      "abbr": "ERI",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 56,
      "x": 617,
      "y": 444,
      "playable": true,
      "path": "M 67.00 0.00 L 44.00 0.00 L 32.00 12.00 L 29.00 19.00 L 15.00 33.00 L 0.00 42.00 L 0.00 54.00 L 27.00 55.00 L 28.00 54.00 L 46.00 53.00 L 49.00 56.00 L 65.00 55.00 L 69.00 45.00 Z",
      "province": "M024",
      "rootTerritory": "M024",
      "viewBox": "0 0 69 56",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 41,
          "territory": "M024",
          "arrowReceiver": {
            "x": 29,
            "y": 71
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 41,
          "territory": "M024",
          "arrowReceiver": {
            "x": 29,
            "y": 71
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "伊利运河": {
    "territory": "M024",
    "unitSlotName": "main",
    "province": "M024",
    "provinceMapData": {
      "abbr": "ERI",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 56,
      "x": 617,
      "y": 444,
      "playable": true,
      "path": "M 67.00 0.00 L 44.00 0.00 L 32.00 12.00 L 29.00 19.00 L 15.00 33.00 L 0.00 42.00 L 0.00 54.00 L 27.00 55.00 L 28.00 54.00 L 46.00 53.00 L 49.00 56.00 L 65.00 55.00 L 69.00 45.00 Z",
      "province": "M024",
      "rootTerritory": "M024",
      "viewBox": "0 0 69 56",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 41,
          "territory": "M024",
          "arrowReceiver": {
            "x": 29,
            "y": 71
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 41,
          "territory": "M024",
          "arrowReceiver": {
            "x": 29,
            "y": 71
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M017_a": {
    "territory": "M017_a",
    "unitSlotName": "main",
    "province": "M017_a",
    "provinceMapData": {
      "abbr": "SOC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 46,
          "y": 154,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 78,
      "height": 187,
      "x": 118,
      "y": 632,
      "playable": true,
      "path": "M 12.000 0.000 L 11.000 10.000 L 6.000 19.000 L 5.000 31.000 L 0.000 40.000 L 0.000 45.000 L 13.000 59.000 L 13.000 97.000 L 26.000 109.000 L 26.000 117.000 L 25.000 118.000 L 25.000 129.000 L 18.000 136.000 L 6.000 135.000 L 3.000 179.000 L 22.000 182.000 L 26.000 187.000 L 70.860 182.163 L 70.860 182.163 L 78.000 170.000 L 78.000 141.000 L 72.000 129.000 L 55.000 109.000 L 49.000 90.000 L 40.000 83.000 L 39.000 64.000 L 29.000 55.000 L 29.000 42.000 L 16.000 28.000 L 15.000 7.000 L 14.000 6.000 L 14.000 0.000 Z",
      "province": "M017_a",
      "rootTerritory": "M017_a",
      "viewBox": "0 0 78 187",
      "unitSlots": [
        {
          "name": "main",
          "x": 51,
          "y": 156,
          "territory": "M017_a",
          "arrowReceiver": {
            "x": 51,
            "y": 186
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51,
          "y": 156,
          "territory": "M017_a",
          "arrowReceiver": {
            "x": 51,
            "y": 186
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "科尔特斯海": {
    "territory": "M017_a",
    "unitSlotName": "main",
    "province": "M017_a",
    "provinceMapData": {
      "abbr": "SOC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 46,
          "y": 154,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 78,
      "height": 187,
      "x": 118,
      "y": 632,
      "playable": true,
      "path": "M 12.000 0.000 L 11.000 10.000 L 6.000 19.000 L 5.000 31.000 L 0.000 40.000 L 0.000 45.000 L 13.000 59.000 L 13.000 97.000 L 26.000 109.000 L 26.000 117.000 L 25.000 118.000 L 25.000 129.000 L 18.000 136.000 L 6.000 135.000 L 3.000 179.000 L 22.000 182.000 L 26.000 187.000 L 70.860 182.163 L 70.860 182.163 L 78.000 170.000 L 78.000 141.000 L 72.000 129.000 L 55.000 109.000 L 49.000 90.000 L 40.000 83.000 L 39.000 64.000 L 29.000 55.000 L 29.000 42.000 L 16.000 28.000 L 15.000 7.000 L 14.000 6.000 L 14.000 0.000 Z",
      "province": "M017_a",
      "rootTerritory": "M017_a",
      "viewBox": "0 0 78 187",
      "unitSlots": [
        {
          "name": "main",
          "x": 51,
          "y": 156,
          "territory": "M017_a",
          "arrowReceiver": {
            "x": 51,
            "y": 186
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 51,
          "y": 156,
          "territory": "M017_a",
          "arrowReceiver": {
            "x": 51,
            "y": 186
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M017": {
    "territory": "M017",
    "unitSlotName": "main",
    "province": "M017",
    "provinceMapData": {
      "abbr": "BCA",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 36,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 78,
      "height": 193,
      "x": 81,
      "y": 576,
      "playable": true,
      "path": "M 49.00 0.00 L 44.00 5.00 L 19.00 6.00 L 15.00 11.00 L 2.00 11.00 L 0.00 74.00 L 17.00 90.00 L 18.00 100.00 L 23.00 105.00 L 26.00 129.00 L 19.00 137.00 L 19.00 156.00 L 41.00 179.00 L 41.00 189.00 L 44.00 193.00 L 57.00 193.00 L 63.00 187.00 L 64.00 163.00 L 51.00 151.00 L 51.00 113.00 L 38.00 98.00 L 43.00 89.00 L 44.00 77.00 L 49.00 68.00 L 51.00 54.00 L 68.00 38.00 L 78.00 26.00 L 78.00 15.00 L 77.00 14.00 L 77.00 7.00 L 66.00 5.00 L 62.00 0.00 Z",
      "province": "M017",
      "rootTerritory": "M017",
      "viewBox": "0 0 78 193",
      "unitSlots": [
        {
          "name": "main",
          "x": 34,
          "y": 14,
          "territory": "M017",
          "arrowReceiver": {
            "x": 34,
            "y": 44
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34,
          "y": 14,
          "territory": "M017",
          "arrowReceiver": {
            "x": 34,
            "y": 44
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "下加利福尼亚": {
    "territory": "M017",
    "unitSlotName": "main",
    "province": "M017",
    "provinceMapData": {
      "abbr": "BCA",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 36,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 78,
      "height": 193,
      "x": 81,
      "y": 576,
      "playable": true,
      "path": "M 49.00 0.00 L 44.00 5.00 L 19.00 6.00 L 15.00 11.00 L 2.00 11.00 L 0.00 74.00 L 17.00 90.00 L 18.00 100.00 L 23.00 105.00 L 26.00 129.00 L 19.00 137.00 L 19.00 156.00 L 41.00 179.00 L 41.00 189.00 L 44.00 193.00 L 57.00 193.00 L 63.00 187.00 L 64.00 163.00 L 51.00 151.00 L 51.00 113.00 L 38.00 98.00 L 43.00 89.00 L 44.00 77.00 L 49.00 68.00 L 51.00 54.00 L 68.00 38.00 L 78.00 26.00 L 78.00 15.00 L 77.00 14.00 L 77.00 7.00 L 66.00 5.00 L 62.00 0.00 Z",
      "province": "M017",
      "rootTerritory": "M017",
      "viewBox": "0 0 78 193",
      "unitSlots": [
        {
          "name": "main",
          "x": 34,
          "y": 14,
          "territory": "M017",
          "arrowReceiver": {
            "x": 34,
            "y": 44
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 34,
          "y": 14,
          "territory": "M017",
          "arrowReceiver": {
            "x": 34,
            "y": 44
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M018": {
    "territory": "M018",
    "unitSlotName": "main",
    "province": "M018",
    "provinceMapData": {
      "abbr": "CLI",
      "type": "Coast",
      "centerPos": {
        "x": 32,
        "y": 69
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 62,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 143,
      "x": 583,
      "y": 1034,
      "playable": true,
      "path": "M 46.00 0.00 L 19.00 2.00 L 17.00 5.00 L 19.00 34.00 L 28.00 42.00 L 26.00 67.00 L 25.00 68.00 L 25.00 84.00 L 0.00 109.00 L 0.00 129.00 L 24.00 143.00 L 38.00 143.00 L 43.00 138.00 L 44.00 118.00 L 40.00 113.00 L 46.00 104.00 L 59.00 98.00 L 61.00 89.00 L 74.00 66.00 L 74.00 54.00 L 69.00 51.00 L 65.00 25.00 L 55.00 16.00 L 53.00 3.00 Z",
      "province": "M018",
      "rootTerritory": "M018",
      "viewBox": "0 0 74 143",
      "unitSlots": [
        {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        "nc": {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        "sc": {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡利": {
    "territory": "M018",
    "unitSlotName": "main",
    "province": "M018",
    "provinceMapData": {
      "abbr": "CLI",
      "type": "Coast",
      "centerPos": {
        "x": 32,
        "y": 69
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 62,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 143,
      "x": 583,
      "y": 1034,
      "playable": true,
      "path": "M 46.00 0.00 L 19.00 2.00 L 17.00 5.00 L 19.00 34.00 L 28.00 42.00 L 26.00 67.00 L 25.00 68.00 L 25.00 84.00 L 0.00 109.00 L 0.00 129.00 L 24.00 143.00 L 38.00 143.00 L 43.00 138.00 L 44.00 118.00 L 40.00 113.00 L 46.00 104.00 L 59.00 98.00 L 61.00 89.00 L 74.00 66.00 L 74.00 54.00 L 69.00 51.00 L 65.00 25.00 L 55.00 16.00 L 53.00 3.00 Z",
      "province": "M018",
      "rootTerritory": "M018",
      "viewBox": "0 0 74 143",
      "unitSlots": [
        {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        "nc": {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        "sc": {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M025": {
    "territory": "M025",
    "unitSlotName": "main",
    "province": "M025",
    "provinceMapData": {
      "abbr": "CHI",
      "type": "Coast",
      "centerPos": {
        "x": 35,
        "y": 119
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 52,
          "y": 112,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 167,
      "height": 157,
      "x": 425,
      "y": 415,
      "playable": true,
      "path": "M 1.00 9.00 L 0.00 28.00 L 27.00 52.00 L 30.00 68.00 L 36.00 78.00 L 21.00 94.00 L 21.00 117.00 L 25.00 121.00 L 25.00 128.00 L 31.00 132.00 L 31.00 142.00 L 40.00 157.00 L 42.00 157.00 L 46.00 149.00 L 59.00 147.00 L 67.00 137.00 L 77.00 138.00 L 82.00 132.00 L 90.00 133.00 L 107.00 116.00 L 117.00 116.00 L 120.00 121.00 L 139.00 123.00 L 140.00 124.00 L 140.00 131.00 L 142.00 131.00 L 160.00 112.00 L 165.00 113.00 L 167.00 78.00 L 148.00 78.00 L 144.00 83.00 L 135.00 82.00 L 118.00 73.00 L 99.00 72.00 L 93.00 82.00 L 83.00 87.00 L 76.00 87.00 L 75.00 88.00 L 69.00 88.00 L 65.00 80.00 L 65.00 51.00 L 71.00 42.00 L 69.00 27.00 L 73.00 20.00 L 72.00 17.00 L 70.00 16.00 L 56.00 16.00 L 55.00 15.00 L 41.00 15.00 L 38.00 10.00 L 28.00 10.00 L 27.00 9.00 L 27.00 0.00 L 18.00 0.00 L 16.00 2.00 Z",
      "province": "M025",
      "rootTerritory": "M025",
      "viewBox": "0 0 167 157",
      "unitSlots": [
        {
          "name": "main",
          "x": 88,
          "y": 94,
          "territory": "M025",
          "arrowReceiver": {
            "x": 88,
            "y": 124
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 88,
          "y": 94,
          "territory": "M025",
          "arrowReceiver": {
            "x": 88,
            "y": 124
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "芝加哥": {
    "territory": "M025",
    "unitSlotName": "main",
    "province": "M025",
    "provinceMapData": {
      "abbr": "CHI",
      "type": "Coast",
      "centerPos": {
        "x": 35,
        "y": 119
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 52,
          "y": 112,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 167,
      "height": 157,
      "x": 425,
      "y": 415,
      "playable": true,
      "path": "M 1.00 9.00 L 0.00 28.00 L 27.00 52.00 L 30.00 68.00 L 36.00 78.00 L 21.00 94.00 L 21.00 117.00 L 25.00 121.00 L 25.00 128.00 L 31.00 132.00 L 31.00 142.00 L 40.00 157.00 L 42.00 157.00 L 46.00 149.00 L 59.00 147.00 L 67.00 137.00 L 77.00 138.00 L 82.00 132.00 L 90.00 133.00 L 107.00 116.00 L 117.00 116.00 L 120.00 121.00 L 139.00 123.00 L 140.00 124.00 L 140.00 131.00 L 142.00 131.00 L 160.00 112.00 L 165.00 113.00 L 167.00 78.00 L 148.00 78.00 L 144.00 83.00 L 135.00 82.00 L 118.00 73.00 L 99.00 72.00 L 93.00 82.00 L 83.00 87.00 L 76.00 87.00 L 75.00 88.00 L 69.00 88.00 L 65.00 80.00 L 65.00 51.00 L 71.00 42.00 L 69.00 27.00 L 73.00 20.00 L 72.00 17.00 L 70.00 16.00 L 56.00 16.00 L 55.00 15.00 L 41.00 15.00 L 38.00 10.00 L 28.00 10.00 L 27.00 9.00 L 27.00 0.00 L 18.00 0.00 L 16.00 2.00 Z",
      "province": "M025",
      "rootTerritory": "M025",
      "viewBox": "0 0 167 157",
      "unitSlots": [
        {
          "name": "main",
          "x": 88,
          "y": 94,
          "territory": "M025",
          "arrowReceiver": {
            "x": 88,
            "y": 124
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 88,
          "y": 94,
          "territory": "M025",
          "arrowReceiver": {
            "x": 88,
            "y": 124
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M022": {
    "territory": "M022",
    "unitSlotName": "main",
    "province": "M022",
    "provinceMapData": {
      "abbr": "WGL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 73,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 103,
      "height": 120,
      "x": 451,
      "y": 384,
      "playable": true,
      "path": "M 79.000 3.000 L 45.000 0.000 L 36.000 9.000 L 29.000 8.000 L 22.000 16.000 L 7.000 22.000 L 0.000 29.000 L 0.000 42.000 L 10.000 42.000 L 13.000 47.000 L 42.000 48.000 L 45.000 50.000 L 42.000 55.000 L 44.000 71.000 L 38.000 80.000 L 38.000 114.000 L 41.000 120.000 L 59.000 119.000 L 70.000 113.000 L 76.000 101.000 L 76.000 79.000 L 95.433 64.270 L 96.577 60.183 L 97.509 56.848 L 98.874 51.970 L 99.806 48.636 L 103.000 27.000 L 100.000 21.000 L 100.000 19.000 L 99.000 17.000 L 86.000 14.000 Z",
      "province": "M022",
      "rootTerritory": "M022",
      "viewBox": "0 0 103 120",
      "unitSlots": [
        {
          "name": "main",
          "x": 46,
          "y": 29,
          "territory": "M022",
          "arrowReceiver": {
            "x": 46,
            "y": 59
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 46,
          "y": 29,
          "territory": "M022",
          "arrowReceiver": {
            "x": 46,
            "y": 59
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "西五大湖": {
    "territory": "M022",
    "unitSlotName": "main",
    "province": "M022",
    "provinceMapData": {
      "abbr": "WGL",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 73,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 103,
      "height": 120,
      "x": 451,
      "y": 384,
      "playable": true,
      "path": "M 79.000 3.000 L 45.000 0.000 L 36.000 9.000 L 29.000 8.000 L 22.000 16.000 L 7.000 22.000 L 0.000 29.000 L 0.000 42.000 L 10.000 42.000 L 13.000 47.000 L 42.000 48.000 L 45.000 50.000 L 42.000 55.000 L 44.000 71.000 L 38.000 80.000 L 38.000 114.000 L 41.000 120.000 L 59.000 119.000 L 70.000 113.000 L 76.000 101.000 L 76.000 79.000 L 95.433 64.270 L 96.577 60.183 L 97.509 56.848 L 98.874 51.970 L 99.806 48.636 L 103.000 27.000 L 100.000 21.000 L 100.000 19.000 L 99.000 17.000 L 86.000 14.000 Z",
      "province": "M022",
      "rootTerritory": "M022",
      "viewBox": "0 0 103 120",
      "unitSlots": [
        {
          "name": "main",
          "x": 46,
          "y": 29,
          "territory": "M022",
          "arrowReceiver": {
            "x": 46,
            "y": 59
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 46,
          "y": 29,
          "territory": "M022",
          "arrowReceiver": {
            "x": 46,
            "y": 59
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M021_a": {
    "territory": "M021_a",
    "unitSlotName": "main",
    "province": "M021_a",
    "provinceMapData": {
      "abbr": "KEB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 48,
          "y": 78,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 149,
      "height": 126,
      "x": 0,
      "y": 1045,
      "playable": true,
      "path": "M 0.065 0.149 L 0.000 126.000 L 143.000 125.000 L 146.000 122.000 L 145.000 114.000 L 146.000 113.000 L 148.340 107.006 L 148.340 107.006 L 148.340 107.006 L 147.464 102.894 L 146.119 97.203 L 145.844 96.037 L 145.172 93.192 L 144.896 92.026 L 144.224 89.180 L 143.948 88.013 L 141.975 79.662 L 141.975 79.662 L 141.975 79.662 L 133.000 80.000 L 128.000 78.000 L 117.000 69.000 L 113.000 67.000 L 102.000 58.000 L 98.000 56.000 L 83.000 44.000 L 79.000 42.000 L 68.000 33.000 L 64.000 31.000 L 52.000 22.000 L 45.000 14.000 L 45.247 5.027 L 39.071 4.360 L 37.973 4.241 L 33.033 3.708 L 31.934 3.589 L 24.030 2.736 L 22.931 2.617 L 14.039 1.657 L 12.940 1.539 L 5.036 0.685 L 0.065 0.149 Z",
      "province": "M021_a",
      "rootTerritory": "M021_a",
      "viewBox": "0 0 149 126",
      "unitSlots": [
        {
          "name": "main",
          "x": 73,
          "y": 95,
          "territory": "M021_a",
          "arrowReceiver": {
            "x": 73,
            "y": 125
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 73,
          "y": 95,
          "territory": "M021_a",
          "arrowReceiver": {
            "x": 73,
            "y": 125
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "凯阿拉凯夸湾": {
    "territory": "M021_a",
    "unitSlotName": "main",
    "province": "M021_a",
    "provinceMapData": {
      "abbr": "KEB",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 48,
          "y": 78,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 149,
      "height": 126,
      "x": 0,
      "y": 1045,
      "playable": true,
      "path": "M 0.065 0.149 L 0.000 126.000 L 143.000 125.000 L 146.000 122.000 L 145.000 114.000 L 146.000 113.000 L 148.340 107.006 L 148.340 107.006 L 148.340 107.006 L 147.464 102.894 L 146.119 97.203 L 145.844 96.037 L 145.172 93.192 L 144.896 92.026 L 144.224 89.180 L 143.948 88.013 L 141.975 79.662 L 141.975 79.662 L 141.975 79.662 L 133.000 80.000 L 128.000 78.000 L 117.000 69.000 L 113.000 67.000 L 102.000 58.000 L 98.000 56.000 L 83.000 44.000 L 79.000 42.000 L 68.000 33.000 L 64.000 31.000 L 52.000 22.000 L 45.000 14.000 L 45.247 5.027 L 39.071 4.360 L 37.973 4.241 L 33.033 3.708 L 31.934 3.589 L 24.030 2.736 L 22.931 2.617 L 14.039 1.657 L 12.940 1.539 L 5.036 0.685 L 0.065 0.149 Z",
      "province": "M021_a",
      "rootTerritory": "M021_a",
      "viewBox": "0 0 149 126",
      "unitSlots": [
        {
          "name": "main",
          "x": 73,
          "y": 95,
          "territory": "M021_a",
          "arrowReceiver": {
            "x": 73,
            "y": 125
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 73,
          "y": 95,
          "territory": "M021_a",
          "arrowReceiver": {
            "x": 73,
            "y": 125
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M021_b": {
    "territory": "M021_b",
    "unitSlotName": "main",
    "province": "M021_b",
    "provinceMapData": {
      "abbr": "HAW",
      "type": "Coast",
      "centerPos": {
        "x": 43,
        "y": 42
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 60,
          "y": 35,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 100,
      "height": 86,
      "x": 44,
      "y": 1040,
      "playable": true,
      "path": "M 0.00 9.00 L 0.00 21.00 L 6.00 28.00 L 86.00 86.00 L 99.00 85.00 L 99.00 75.00 L 100.00 74.00 L 100.00 11.00 L 96.00 6.00 L 50.00 4.00 L 43.00 1.00 L 12.00 0.00 L 7.00 9.00 Z",
      "province": "M021_b",
      "rootTerritory": "M021_b",
      "viewBox": "0 0 100 86",
      "unitSlots": [
        {
          "name": "main",
          "x": 96,
          "y": 15,
          "territory": "M021_b",
          "arrowReceiver": {
            "x": 96,
            "y": 45
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 96,
          "y": 15,
          "territory": "M021_b",
          "arrowReceiver": {
            "x": 96,
            "y": 45
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "夏威夷": {
    "territory": "M021_b",
    "unitSlotName": "main",
    "province": "M021_b",
    "provinceMapData": {
      "abbr": "HAW",
      "type": "Coast",
      "centerPos": {
        "x": 43,
        "y": 42
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 60,
          "y": 35,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 100,
      "height": 86,
      "x": 44,
      "y": 1040,
      "playable": true,
      "path": "M 0.00 9.00 L 0.00 21.00 L 6.00 28.00 L 86.00 86.00 L 99.00 85.00 L 99.00 75.00 L 100.00 74.00 L 100.00 11.00 L 96.00 6.00 L 50.00 4.00 L 43.00 1.00 L 12.00 0.00 L 7.00 9.00 Z",
      "province": "M021_b",
      "rootTerritory": "M021_b",
      "viewBox": "0 0 100 86",
      "unitSlots": [
        {
          "name": "main",
          "x": 96,
          "y": 15,
          "territory": "M021_b",
          "arrowReceiver": {
            "x": 96,
            "y": 45
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 96,
          "y": 15,
          "territory": "M021_b",
          "arrowReceiver": {
            "x": 96,
            "y": 45
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_110_a": {
    "territory": "REGION_110_a",
    "unitSlotName": "main",
    "province": "REGION_110_a",
    "provinceMapData": {
      "abbr": "TEN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 92,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 136,
      "height": 135,
      "x": 435,
      "y": 530,
      "playable": true,
      "path": "M 131.00 7.00 L 112.00 5.00 L 109.00 0.00 L 95.00 0.00 L 78.00 17.00 L 70.00 16.00 L 65.00 22.00 L 55.00 21.00 L 47.00 31.00 L 34.00 33.00 L 21.00 61.00 L 4.00 77.00 L 1.00 83.00 L 0.00 96.00 L 6.00 96.00 L 7.00 97.00 L 7.00 109.00 L 5.00 116.00 L 5.00 123.00 L 11.00 126.00 L 36.00 128.00 L 40.00 131.00 L 40.00 134.00 L 84.00 135.00 L 86.00 108.00 L 83.00 105.00 L 81.00 81.00 L 87.00 77.00 L 101.00 75.00 L 108.00 67.00 L 125.00 61.00 L 131.00 55.00 L 131.00 43.00 L 136.00 39.00 L 136.00 25.00 L 132.00 21.00 Z",
      "province": "REGION_110_a",
      "rootTerritory": "REGION_110_a",
      "viewBox": "0 0 136 135",
      "unitSlots": [
        {
          "name": "main",
          "x": 80,
          "y": 46,
          "territory": "REGION_110_a",
          "arrowReceiver": {
            "x": 80,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 80,
          "y": 46,
          "territory": "REGION_110_a",
          "arrowReceiver": {
            "x": 80,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "田纳西河谷": {
    "territory": "REGION_110_a",
    "unitSlotName": "main",
    "province": "REGION_110_a",
    "provinceMapData": {
      "abbr": "TEN",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 92,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 136,
      "height": 135,
      "x": 435,
      "y": 530,
      "playable": true,
      "path": "M 131.00 7.00 L 112.00 5.00 L 109.00 0.00 L 95.00 0.00 L 78.00 17.00 L 70.00 16.00 L 65.00 22.00 L 55.00 21.00 L 47.00 31.00 L 34.00 33.00 L 21.00 61.00 L 4.00 77.00 L 1.00 83.00 L 0.00 96.00 L 6.00 96.00 L 7.00 97.00 L 7.00 109.00 L 5.00 116.00 L 5.00 123.00 L 11.00 126.00 L 36.00 128.00 L 40.00 131.00 L 40.00 134.00 L 84.00 135.00 L 86.00 108.00 L 83.00 105.00 L 81.00 81.00 L 87.00 77.00 L 101.00 75.00 L 108.00 67.00 L 125.00 61.00 L 131.00 55.00 L 131.00 43.00 L 136.00 39.00 L 136.00 25.00 L 132.00 21.00 Z",
      "province": "REGION_110_a",
      "rootTerritory": "REGION_110_a",
      "viewBox": "0 0 136 135",
      "unitSlots": [
        {
          "name": "main",
          "x": 80,
          "y": 46,
          "territory": "REGION_110_a",
          "arrowReceiver": {
            "x": 80,
            "y": 76
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 80,
          "y": 46,
          "territory": "REGION_110_a",
          "arrowReceiver": {
            "x": 80,
            "y": 76
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M021": {
    "territory": "M021",
    "unitSlotName": "main",
    "province": "M021",
    "provinceMapData": {
      "abbr": "NOR",
      "type": "Coast",
      "centerPos": {
        "x": 16,
        "y": 0
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 33,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 90,
      "height": 68,
      "x": 386,
      "y": 622,
      "playable": true,
      "path": "M 5.00 7.00 L 5.00 27.00 L 9.00 36.00 L 4.00 46.00 L 0.00 49.00 L 1.00 60.00 L 9.00 63.00 L 27.00 64.00 L 34.00 68.00 L 48.00 68.00 L 58.00 64.00 L 63.00 52.00 L 67.00 49.00 L 90.00 48.00 L 90.00 37.00 L 89.00 36.00 L 81.00 34.00 L 62.00 33.00 L 55.00 29.00 L 57.00 19.00 L 57.00 3.00 L 36.00 4.00 L 31.00 1.00 L 22.00 1.00 L 21.00 0.00 L 9.00 0.00 Z",
      "province": "M021",
      "rootTerritory": "M021",
      "viewBox": "0 0 90 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 44,
          "y": 39,
          "territory": "M021",
          "arrowReceiver": {
            "x": 44,
            "y": 69
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 44,
          "y": 39,
          "territory": "M021",
          "arrowReceiver": {
            "x": 44,
            "y": 69
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "新奥尔良": {
    "territory": "M021",
    "unitSlotName": "main",
    "province": "M021",
    "provinceMapData": {
      "abbr": "NOR",
      "type": "Coast",
      "centerPos": {
        "x": 16,
        "y": 0
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 33,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 90,
      "height": 68,
      "x": 386,
      "y": 622,
      "playable": true,
      "path": "M 5.00 7.00 L 5.00 27.00 L 9.00 36.00 L 4.00 46.00 L 0.00 49.00 L 1.00 60.00 L 9.00 63.00 L 27.00 64.00 L 34.00 68.00 L 48.00 68.00 L 58.00 64.00 L 63.00 52.00 L 67.00 49.00 L 90.00 48.00 L 90.00 37.00 L 89.00 36.00 L 81.00 34.00 L 62.00 33.00 L 55.00 29.00 L 57.00 19.00 L 57.00 3.00 L 36.00 4.00 L 31.00 1.00 L 22.00 1.00 L 21.00 0.00 L 9.00 0.00 Z",
      "province": "M021",
      "rootTerritory": "M021",
      "viewBox": "0 0 90 68",
      "unitSlots": [
        {
          "name": "main",
          "x": 44,
          "y": 39,
          "territory": "M021",
          "arrowReceiver": {
            "x": 44,
            "y": 69
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 44,
          "y": 39,
          "territory": "M021",
          "arrowReceiver": {
            "x": 44,
            "y": 69
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M012_a": {
    "territory": "M012_a",
    "unitSlotName": "main",
    "province": "M012_a",
    "provinceMapData": {
      "abbr": "EIS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 44,
      "height": 37,
      "x": 403,
      "y": 926,
      "playable": true,
      "path": "M 0.00 19.00 L 0.00 27.00 L 14.00 30.00 L 27.00 37.00 L 38.00 37.00 L 38.00 30.00 L 44.00 19.00 L 44.00 17.00 L 24.00 5.00 L 22.00 3.00 L 22.00 0.00 L 20.00 0.00 L 19.00 1.00 L 19.00 13.00 L 18.00 14.00 L 6.00 16.00 L 4.00 19.00 Z",
      "province": "M012_a",
      "rootTerritory": "M012_a",
      "viewBox": "0 0 44 37",
      "unitSlots": [
        {
          "name": "main",
          "x": 19,
          "y": 21,
          "territory": "M012_a",
          "arrowReceiver": {
            "x": 19,
            "y": 51
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19,
          "y": 21,
          "territory": "M012_a",
          "arrowReceiver": {
            "x": 19,
            "y": 51
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "萨尔瓦多": {
    "territory": "M012_a",
    "unitSlotName": "main",
    "province": "M012_a",
    "provinceMapData": {
      "abbr": "EIS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 44,
      "height": 37,
      "x": 403,
      "y": 926,
      "playable": true,
      "path": "M 0.00 19.00 L 0.00 27.00 L 14.00 30.00 L 27.00 37.00 L 38.00 37.00 L 38.00 30.00 L 44.00 19.00 L 44.00 17.00 L 24.00 5.00 L 22.00 3.00 L 22.00 0.00 L 20.00 0.00 L 19.00 1.00 L 19.00 13.00 L 18.00 14.00 L 6.00 16.00 L 4.00 19.00 Z",
      "province": "M012_a",
      "rootTerritory": "M012_a",
      "viewBox": "0 0 44 37",
      "unitSlots": [
        {
          "name": "main",
          "x": 19,
          "y": 21,
          "territory": "M012_a",
          "arrowReceiver": {
            "x": 19,
            "y": 51
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 19,
          "y": 21,
          "territory": "M012_a",
          "arrowReceiver": {
            "x": 19,
            "y": 51
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M012": {
    "territory": "M012",
    "unitSlotName": "main",
    "province": "M012",
    "provinceMapData": {
      "abbr": "HDS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 103,
      "height": 65,
      "x": 424,
      "y": 902,
      "playable": true,
      "path": "M 103.00 16.00 L 93.00 4.00 L 85.00 0.00 L 14.00 2.00 L 11.00 7.00 L 6.00 8.00 L 2.00 11.00 L 0.00 15.00 L 0.00 29.00 L 18.00 40.00 L 21.00 43.00 L 16.00 52.00 L 16.00 61.00 L 20.00 65.00 L 36.00 65.00 L 43.00 58.00 L 43.00 56.00 L 49.00 51.00 L 53.00 45.00 L 67.00 44.00 L 77.00 32.00 L 87.00 34.00 L 100.00 33.00 L 102.00 31.00 Z",
      "province": "M012",
      "rootTerritory": "M012",
      "viewBox": "0 0 103 65",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        "nc": {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        "sc": {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "洪都拉斯": {
    "territory": "M012",
    "unitSlotName": "main",
    "province": "M012",
    "provinceMapData": {
      "abbr": "HDS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 103,
      "height": 65,
      "x": 424,
      "y": 902,
      "playable": true,
      "path": "M 103.00 16.00 L 93.00 4.00 L 85.00 0.00 L 14.00 2.00 L 11.00 7.00 L 6.00 8.00 L 2.00 11.00 L 0.00 15.00 L 0.00 29.00 L 18.00 40.00 L 21.00 43.00 L 16.00 52.00 L 16.00 61.00 L 20.00 65.00 L 36.00 65.00 L 43.00 58.00 L 43.00 56.00 L 49.00 51.00 L 53.00 45.00 L 67.00 44.00 L 77.00 32.00 L 87.00 34.00 L 100.00 33.00 L 102.00 31.00 Z",
      "province": "M012",
      "rootTerritory": "M012",
      "viewBox": "0 0 103 65",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        "nc": {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        "sc": {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_20_a_a_a": {
    "territory": "REGION_20_a_a_a",
    "unitSlotName": "main",
    "province": "REGION_20_a_a_a",
    "provinceMapData": {
      "abbr": "MEX",
      "type": "Land",
      "centerPos": {
        "x": 20,
        "y": 70
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 37,
          "y": 63,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 72,
      "height": 118,
      "x": 230,
      "y": 747,
      "playable": true,
      "path": "M 34.00 0.00 L 32.00 3.00 L 9.00 18.00 L 9.00 36.00 L 15.00 40.00 L 18.00 44.00 L 1.00 58.00 L 0.00 60.00 L 0.00 78.00 L 13.00 85.00 L 22.00 85.00 L 25.00 92.00 L 25.00 100.00 L 49.00 118.00 L 66.00 118.00 L 67.00 116.00 L 66.00 99.00 L 72.00 90.00 L 72.00 79.00 L 59.00 45.00 L 58.00 31.00 L 51.00 24.00 L 51.00 8.00 L 48.00 1.00 Z",
      "province": "REGION_20_a_a_a",
      "rootTerritory": "REGION_20_a_a_a",
      "viewBox": "0 0 72 118",
      "unitSlots": [
        {
          "name": "main",
          "x": 33,
          "y": 73,
          "territory": "REGION_20_a_a_a",
          "arrowReceiver": {
            "x": 33,
            "y": 103
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 33,
          "y": 73,
          "territory": "REGION_20_a_a_a",
          "arrowReceiver": {
            "x": 33,
            "y": 103
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "墨西哥城": {
    "territory": "REGION_20_a_a_a",
    "unitSlotName": "main",
    "province": "REGION_20_a_a_a",
    "provinceMapData": {
      "abbr": "MEX",
      "type": "Land",
      "centerPos": {
        "x": 20,
        "y": 70
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 37,
          "y": 63,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 72,
      "height": 118,
      "x": 230,
      "y": 747,
      "playable": true,
      "path": "M 34.00 0.00 L 32.00 3.00 L 9.00 18.00 L 9.00 36.00 L 15.00 40.00 L 18.00 44.00 L 1.00 58.00 L 0.00 60.00 L 0.00 78.00 L 13.00 85.00 L 22.00 85.00 L 25.00 92.00 L 25.00 100.00 L 49.00 118.00 L 66.00 118.00 L 67.00 116.00 L 66.00 99.00 L 72.00 90.00 L 72.00 79.00 L 59.00 45.00 L 58.00 31.00 L 51.00 24.00 L 51.00 8.00 L 48.00 1.00 Z",
      "province": "REGION_20_a_a_a",
      "rootTerritory": "REGION_20_a_a_a",
      "viewBox": "0 0 72 118",
      "unitSlots": [
        {
          "name": "main",
          "x": 33,
          "y": 73,
          "territory": "REGION_20_a_a_a",
          "arrowReceiver": {
            "x": 33,
            "y": 103
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 33,
          "y": 73,
          "territory": "REGION_20_a_a_a",
          "arrowReceiver": {
            "x": 33,
            "y": 103
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M026_a": {
    "territory": "M026_a",
    "unitSlotName": "main",
    "province": "M026_a",
    "provinceMapData": {
      "abbr": "VER",
      "type": "Coast",
      "centerPos": {
        "x": 27,
        "y": 85
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 86,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 64,
      "height": 109,
      "x": 288,
      "y": 781,
      "playable": true,
      "path": "M 0.00 0.00 L 0.00 13.00 L 13.00 47.00 L 13.00 54.00 L 7.00 63.00 L 8.00 84.00 L 22.00 84.00 L 27.00 90.00 L 29.00 98.00 L 35.00 104.00 L 41.00 107.00 L 52.00 107.00 L 54.00 109.00 L 56.00 109.00 L 58.00 107.00 L 60.00 97.00 L 62.00 93.00 L 64.00 85.00 L 64.00 77.00 L 60.00 77.00 L 33.00 50.00 L 31.00 46.00 L 30.00 35.00 L 28.00 33.00 L 29.00 24.00 L 23.00 17.00 L 21.00 2.00 L 8.00 3.00 L 7.00 1.00 Z",
      "province": "M026_a",
      "rootTerritory": "M026_a",
      "viewBox": "0 0 64 109",
      "unitSlots": [
        {
          "name": "main",
          "x": 35,
          "y": 77,
          "territory": "M026_a",
          "arrowReceiver": {
            "x": 35,
            "y": 107
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35,
          "y": 77,
          "territory": "M026_a",
          "arrowReceiver": {
            "x": 35,
            "y": 107
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "韦拉克鲁斯": {
    "territory": "M026_a",
    "unitSlotName": "main",
    "province": "M026_a",
    "provinceMapData": {
      "abbr": "VER",
      "type": "Coast",
      "centerPos": {
        "x": 27,
        "y": 85
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 44,
          "y": 86,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 64,
      "height": 109,
      "x": 288,
      "y": 781,
      "playable": true,
      "path": "M 0.00 0.00 L 0.00 13.00 L 13.00 47.00 L 13.00 54.00 L 7.00 63.00 L 8.00 84.00 L 22.00 84.00 L 27.00 90.00 L 29.00 98.00 L 35.00 104.00 L 41.00 107.00 L 52.00 107.00 L 54.00 109.00 L 56.00 109.00 L 58.00 107.00 L 60.00 97.00 L 62.00 93.00 L 64.00 85.00 L 64.00 77.00 L 60.00 77.00 L 33.00 50.00 L 31.00 46.00 L 30.00 35.00 L 28.00 33.00 L 29.00 24.00 L 23.00 17.00 L 21.00 2.00 L 8.00 3.00 L 7.00 1.00 Z",
      "province": "M026_a",
      "rootTerritory": "M026_a",
      "viewBox": "0 0 64 109",
      "unitSlots": [
        {
          "name": "main",
          "x": 35,
          "y": 77,
          "territory": "M026_a",
          "arrowReceiver": {
            "x": 35,
            "y": 107
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 35,
          "y": 77,
          "territory": "M026_a",
          "arrowReceiver": {
            "x": 35,
            "y": 107
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M026_b": {
    "territory": "M026_b",
    "unitSlotName": "main",
    "province": "M026_b",
    "provinceMapData": {
      "abbr": "CPZ",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 36,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 59,
      "height": 78,
      "x": 341,
      "y": 853,
      "playable": true,
      "path": "M 28.00 0.00 L 27.00 2.00 L 21.00 5.00 L 12.00 6.00 L 10.00 8.00 L 8.00 19.00 L 4.00 31.00 L 4.00 38.00 L 1.00 43.00 L 0.00 56.00 L 20.00 76.00 L 38.00 78.00 L 39.00 59.00 L 58.00 47.00 L 59.00 37.00 L 45.00 16.00 L 48.00 7.00 L 48.00 3.00 L 45.00 0.00 Z",
      "province": "M026_b",
      "rootTerritory": "M026_b",
      "viewBox": "0 0 59 78",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        "nc": {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        "sc": {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "恰帕斯": {
    "territory": "M026_b",
    "unitSlotName": "main",
    "province": "M026_b",
    "provinceMapData": {
      "abbr": "CPZ",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 36,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 59,
      "height": 78,
      "x": 341,
      "y": 853,
      "playable": true,
      "path": "M 28.00 0.00 L 27.00 2.00 L 21.00 5.00 L 12.00 6.00 L 10.00 8.00 L 8.00 19.00 L 4.00 31.00 L 4.00 38.00 L 1.00 43.00 L 0.00 56.00 L 20.00 76.00 L 38.00 78.00 L 39.00 59.00 L 58.00 47.00 L 59.00 37.00 L 45.00 16.00 L 48.00 7.00 L 48.00 3.00 L 45.00 0.00 Z",
      "province": "M026_b",
      "rootTerritory": "M026_b",
      "viewBox": "0 0 59 78",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        "nc": {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        "sc": {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M026": {
    "territory": "M026",
    "unitSlotName": "main",
    "province": "M026",
    "provinceMapData": {
      "abbr": "ECA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 126,
          "y": 106,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 268,
      "height": 176,
      "x": 627,
      "y": 826,
      "playable": true,
      "path": "M 268.000 52.000 L 266.000 50.000 L 244.000 51.000 L 240.000 45.000 L 239.000 26.000 L 205.000 26.000 L 203.000 23.000 L 203.000 21.000 L 204.000 20.000 L 204.000 11.000 L 205.000 10.000 L 205.205 0.964 L 205.205 0.964 L 205.205 0.964 L 192.032 2.342 L 190.947 2.456 L 186.245 2.948 L 187.000 11.000 L 186.000 12.000 L 186.000 15.000 L 188.000 17.000 L 186.000 19.000 L 180.000 20.000 L 173.000 28.000 L 156.000 26.000 L 145.000 33.000 L 134.000 34.000 L 125.000 42.000 L 122.000 49.000 L 120.000 51.000 L 38.000 51.000 L 36.000 53.000 L 37.000 84.000 L 35.000 86.000 L 0.000 85.002 L 0.648 115.162 L 0.648 115.162 L 0.648 115.162 L 18.988 116.222 L 20.038 116.277 L 33.999 117.010 L 35.049 117.065 L 55.493 118.139 L 61.000 115.000 L 156.000 116.000 L 157.000 117.000 L 158.000 122.000 L 160.000 123.000 L 160.000 168.000 L 184.000 167.000 L 198.000 176.000 L 204.000 176.000 L 213.000 166.000 L 237.000 164.000 L 240.000 168.000 L 241.000 173.000 L 247.000 176.000 L 253.000 176.000 L 253.000 72.000 L 262.000 64.000 L 262.000 58.000 L 268.000 54.000 Z",
      "province": "M026",
      "rootTerritory": "M026",
      "viewBox": "0 0 268 176",
      "unitSlots": [
        {
          "name": "main",
          "x": 126,
          "y": 106,
          "territory": "M026",
          "arrowReceiver": {
            "x": 126,
            "y": 136
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 126,
          "y": 106,
          "territory": "M026",
          "arrowReceiver": {
            "x": 126,
            "y": 136
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "东加勒比海": {
    "territory": "M026",
    "unitSlotName": "main",
    "province": "M026",
    "provinceMapData": {
      "abbr": "ECA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 126,
          "y": 106,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 268,
      "height": 176,
      "x": 627,
      "y": 826,
      "playable": true,
      "path": "M 268.000 52.000 L 266.000 50.000 L 244.000 51.000 L 240.000 45.000 L 239.000 26.000 L 205.000 26.000 L 203.000 23.000 L 203.000 21.000 L 204.000 20.000 L 204.000 11.000 L 205.000 10.000 L 205.205 0.964 L 205.205 0.964 L 205.205 0.964 L 192.032 2.342 L 190.947 2.456 L 186.245 2.948 L 187.000 11.000 L 186.000 12.000 L 186.000 15.000 L 188.000 17.000 L 186.000 19.000 L 180.000 20.000 L 173.000 28.000 L 156.000 26.000 L 145.000 33.000 L 134.000 34.000 L 125.000 42.000 L 122.000 49.000 L 120.000 51.000 L 38.000 51.000 L 36.000 53.000 L 37.000 84.000 L 35.000 86.000 L 0.000 85.002 L 0.648 115.162 L 0.648 115.162 L 0.648 115.162 L 18.988 116.222 L 20.038 116.277 L 33.999 117.010 L 35.049 117.065 L 55.493 118.139 L 61.000 115.000 L 156.000 116.000 L 157.000 117.000 L 158.000 122.000 L 160.000 123.000 L 160.000 168.000 L 184.000 167.000 L 198.000 176.000 L 204.000 176.000 L 213.000 166.000 L 237.000 164.000 L 240.000 168.000 L 241.000 173.000 L 247.000 176.000 L 253.000 176.000 L 253.000 72.000 L 262.000 64.000 L 262.000 58.000 L 268.000 54.000 Z",
      "province": "M026",
      "rootTerritory": "M026",
      "viewBox": "0 0 268 176",
      "unitSlots": [
        {
          "name": "main",
          "x": 126,
          "y": 106,
          "territory": "M026",
          "arrowReceiver": {
            "x": 126,
            "y": 136
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 126,
          "y": 106,
          "territory": "M026",
          "arrowReceiver": {
            "x": 126,
            "y": 136
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M027": {
    "territory": "M027",
    "unitSlotName": "main",
    "province": "M027",
    "provinceMapData": {
      "abbr": "SAR",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 106,
          "y": 99,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 214,
      "height": 205,
      "x": 724,
      "y": 624,
      "playable": true,
      "path": "M 153.778 0.328 L 144.013 0.561 L 142.990 0.585 L 63.011 2.479 L 61.988 2.503 L 41.999 2.977 L 40.976 3.001 L 14.954 3.348 L 0.000 17.000 L 8.000 22.000 L 8.000 100.000 L 11.000 103.000 L 35.000 102.000 L 44.000 111.000 L 46.000 139.000 L 49.000 142.000 L 49.000 149.000 L 50.000 150.000 L 50.000 164.000 L 51.000 165.000 L 51.000 179.000 L 52.000 180.000 L 52.000 187.000 L 61.000 188.000 L 72.000 200.000 L 82.000 201.000 L 89.245 204.948 L 108.205 202.964 L 108.205 202.964 L 109.000 198.000 L 109.000 182.000 L 110.000 181.000 L 110.000 178.000 L 112.000 175.000 L 158.000 176.000 L 160.000 178.000 L 162.000 183.000 L 213.761 182.713 L 212.040 164.128 L 211.891 163.015 L 210.972 156.138 L 210.823 155.024 L 210.297 151.094 L 210.148 149.980 L 209.622 146.050 L 209.473 144.937 L 208.422 137.077 L 208.273 135.963 L 207.222 128.104 L 207.073 126.990 L 206.022 119.131 L 205.873 118.017 L 205.085 112.122 L 204.936 111.009 L 202.947 96.141 L 202.798 95.027 L 202.141 90.115 L 201.449 84.940 L 200.529 78.063 L 200.380 76.949 L 198.205 66.968 L 198.205 66.968 L 198.205 66.968 L 188.676 53.557 L 185.782 49.143 L 171.186 26.878 L 169.510 24.321 L 164.497 16.674 L 161.603 12.260 L 156.590 4.613 Z",
      "province": "M027",
      "rootTerritory": "M027",
      "viewBox": "0 0 214 205",
      "unitSlots": [
        {
          "name": "main",
          "x": 106,
          "y": 99,
          "territory": "M027",
          "arrowReceiver": {
            "x": 106,
            "y": 129
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 106,
          "y": 99,
          "territory": "M027",
          "arrowReceiver": {
            "x": 106,
            "y": 129
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "马尾藻海": {
    "territory": "M027",
    "unitSlotName": "main",
    "province": "M027",
    "provinceMapData": {
      "abbr": "SAR",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 106,
          "y": 99,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 214,
      "height": 205,
      "x": 724,
      "y": 624,
      "playable": true,
      "path": "M 153.778 0.328 L 144.013 0.561 L 142.990 0.585 L 63.011 2.479 L 61.988 2.503 L 41.999 2.977 L 40.976 3.001 L 14.954 3.348 L 0.000 17.000 L 8.000 22.000 L 8.000 100.000 L 11.000 103.000 L 35.000 102.000 L 44.000 111.000 L 46.000 139.000 L 49.000 142.000 L 49.000 149.000 L 50.000 150.000 L 50.000 164.000 L 51.000 165.000 L 51.000 179.000 L 52.000 180.000 L 52.000 187.000 L 61.000 188.000 L 72.000 200.000 L 82.000 201.000 L 89.245 204.948 L 108.205 202.964 L 108.205 202.964 L 109.000 198.000 L 109.000 182.000 L 110.000 181.000 L 110.000 178.000 L 112.000 175.000 L 158.000 176.000 L 160.000 178.000 L 162.000 183.000 L 213.761 182.713 L 212.040 164.128 L 211.891 163.015 L 210.972 156.138 L 210.823 155.024 L 210.297 151.094 L 210.148 149.980 L 209.622 146.050 L 209.473 144.937 L 208.422 137.077 L 208.273 135.963 L 207.222 128.104 L 207.073 126.990 L 206.022 119.131 L 205.873 118.017 L 205.085 112.122 L 204.936 111.009 L 202.947 96.141 L 202.798 95.027 L 202.141 90.115 L 201.449 84.940 L 200.529 78.063 L 200.380 76.949 L 198.205 66.968 L 198.205 66.968 L 198.205 66.968 L 188.676 53.557 L 185.782 49.143 L 171.186 26.878 L 169.510 24.321 L 164.497 16.674 L 161.603 12.260 L 156.590 4.613 Z",
      "province": "M027",
      "rootTerritory": "M027",
      "viewBox": "0 0 214 205",
      "unitSlots": [
        {
          "name": "main",
          "x": 106,
          "y": 99,
          "territory": "M027",
          "arrowReceiver": {
            "x": 106,
            "y": 129
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 106,
          "y": 99,
          "territory": "M027",
          "arrowReceiver": {
            "x": 106,
            "y": 129
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_194_a": {
    "territory": "REGION_194_a",
    "unitSlotName": "main",
    "province": "REGION_194_a",
    "provinceMapData": {
      "abbr": "BQI",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 46,
          "y": 34,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 92,
      "height": 72,
      "x": 710,
      "y": 1009,
      "playable": true,
      "path": "M 35.00 0.00 L 35.00 1.00 L 25.00 11.00 L 17.00 13.00 L 9.00 21.00 L 6.00 30.00 L 3.00 33.00 L 0.00 34.00 L 0.00 37.00 L 16.00 56.00 L 19.00 57.00 L 21.00 59.00 L 25.00 59.00 L 36.00 71.00 L 64.00 72.00 L 68.00 63.00 L 71.00 60.00 L 80.00 41.00 L 85.00 36.00 L 92.00 36.00 L 92.00 34.00 L 84.00 32.00 L 76.00 28.00 L 54.00 0.00 Z",
      "province": "REGION_194_a",
      "rootTerritory": "REGION_194_a",
      "viewBox": "0 0 92 72",
      "unitSlots": [
        {
          "name": "main",
          "x": 46,
          "y": 34,
          "territory": "REGION_194_a",
          "arrowReceiver": {
            "x": 46,
            "y": 64
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 46,
          "y": 34,
          "territory": "REGION_194_a",
          "arrowReceiver": {
            "x": 46,
            "y": 64
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "巴基西梅托": {
    "territory": "REGION_194_a",
    "unitSlotName": "main",
    "province": "REGION_194_a",
    "provinceMapData": {
      "abbr": "BQI",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 46,
          "y": 34,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 92,
      "height": 72,
      "x": 710,
      "y": 1009,
      "playable": true,
      "path": "M 35.00 0.00 L 35.00 1.00 L 25.00 11.00 L 17.00 13.00 L 9.00 21.00 L 6.00 30.00 L 3.00 33.00 L 0.00 34.00 L 0.00 37.00 L 16.00 56.00 L 19.00 57.00 L 21.00 59.00 L 25.00 59.00 L 36.00 71.00 L 64.00 72.00 L 68.00 63.00 L 71.00 60.00 L 80.00 41.00 L 85.00 36.00 L 92.00 36.00 L 92.00 34.00 L 84.00 32.00 L 76.00 28.00 L 54.00 0.00 Z",
      "province": "REGION_194_a",
      "rootTerritory": "REGION_194_a",
      "viewBox": "0 0 92 72",
      "unitSlots": [
        {
          "name": "main",
          "x": 46,
          "y": 34,
          "territory": "REGION_194_a",
          "arrowReceiver": {
            "x": 46,
            "y": 64
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 46,
          "y": 34,
          "territory": "REGION_194_a",
          "arrowReceiver": {
            "x": 46,
            "y": 64
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_191_a": {
    "territory": "REGION_191_a",
    "unitSlotName": "main",
    "province": "REGION_191_a",
    "provinceMapData": {
      "abbr": "MCB",
      "type": "Coast",
      "centerPos": {
        "x": 9,
        "y": 2
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 52,
          "y": 19,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 95,
      "height": 70,
      "x": 685,
      "y": 973,
      "playable": true,
      "path": "M 95.00 18.00 L 87.00 9.00 L 79.00 9.00 L 70.00 1.00 L 49.00 0.00 L 49.00 1.00 L 43.00 7.00 L 26.00 5.00 L 20.00 16.00 L 10.00 19.00 L 9.00 30.00 L 1.00 38.00 L 0.00 55.00 L 3.00 58.00 L 3.00 61.00 L 5.00 64.00 L 12.00 65.00 L 18.00 68.00 L 22.00 68.00 L 24.00 70.00 L 27.00 68.00 L 31.00 69.00 L 35.00 59.00 L 44.00 50.00 L 52.00 48.00 L 62.00 37.00 L 70.00 36.00 L 77.00 23.00 L 95.00 21.00 Z",
      "province": "REGION_191_a",
      "rootTerritory": "REGION_191_a",
      "viewBox": "0 0 95 70",
      "unitSlots": [
        {
          "name": "main",
          "x": 52,
          "y": 19,
          "territory": "REGION_191_a",
          "arrowReceiver": {
            "x": 52,
            "y": 49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 52,
          "y": 19,
          "territory": "REGION_191_a",
          "arrowReceiver": {
            "x": 52,
            "y": 49
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "马拉开波": {
    "territory": "REGION_191_a",
    "unitSlotName": "main",
    "province": "REGION_191_a",
    "provinceMapData": {
      "abbr": "MCB",
      "type": "Coast",
      "centerPos": {
        "x": 9,
        "y": 2
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 52,
          "y": 19,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 95,
      "height": 70,
      "x": 685,
      "y": 973,
      "playable": true,
      "path": "M 95.00 18.00 L 87.00 9.00 L 79.00 9.00 L 70.00 1.00 L 49.00 0.00 L 49.00 1.00 L 43.00 7.00 L 26.00 5.00 L 20.00 16.00 L 10.00 19.00 L 9.00 30.00 L 1.00 38.00 L 0.00 55.00 L 3.00 58.00 L 3.00 61.00 L 5.00 64.00 L 12.00 65.00 L 18.00 68.00 L 22.00 68.00 L 24.00 70.00 L 27.00 68.00 L 31.00 69.00 L 35.00 59.00 L 44.00 50.00 L 52.00 48.00 L 62.00 37.00 L 70.00 36.00 L 77.00 23.00 L 95.00 21.00 Z",
      "province": "REGION_191_a",
      "rootTerritory": "REGION_191_a",
      "viewBox": "0 0 95 70",
      "unitSlots": [
        {
          "name": "main",
          "x": 52,
          "y": 19,
          "territory": "REGION_191_a",
          "arrowReceiver": {
            "x": 52,
            "y": 49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 52,
          "y": 19,
          "territory": "REGION_191_a",
          "arrowReceiver": {
            "x": 52,
            "y": 49
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M028": {
    "territory": "M028",
    "unitSlotName": "main",
    "province": "M028",
    "provinceMapData": {
      "abbr": "ORI",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 57,
          "y": 88,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 118,
      "height": 145,
      "x": 689,
      "y": 1038,
      "playable": true,
      "path": "M 1.00 0.00 L 0.00 1.00 L 0.00 10.00 L 2.00 13.00 L 2.00 15.00 L 4.00 19.00 L 10.00 23.00 L 13.00 23.00 L 14.00 24.00 L 14.00 28.00 L 17.00 28.00 L 20.00 30.00 L 20.00 45.00 L 8.00 60.00 L 8.00 65.00 L 11.00 68.00 L 11.00 82.00 L 7.00 85.00 L 7.00 89.00 L 11.00 92.00 L 10.00 110.00 L 33.00 123.00 L 37.00 123.00 L 40.00 119.00 L 52.00 119.00 L 57.00 123.00 L 66.00 122.00 L 82.00 138.00 L 100.00 137.00 L 110.00 144.00 L 117.00 145.00 L 118.00 136.00 L 112.00 131.00 L 107.00 130.00 L 103.00 125.00 L 103.00 117.00 L 102.00 116.00 L 102.00 108.00 L 110.00 101.00 L 112.00 92.00 L 103.00 84.00 L 92.00 80.00 L 83.00 68.00 L 84.00 42.00 L 59.00 41.00 L 48.00 29.00 L 39.00 29.00 L 37.00 28.00 L 29.00 19.00 L 29.00 18.00 L 22.00 11.00 L 19.00 4.00 L 16.00 4.00 L 15.00 3.00 L 12.00 3.00 L 11.00 2.00 Z",
      "province": "M028",
      "rootTerritory": "M028",
      "viewBox": "0 0 118 145",
      "unitSlots": [
        {
          "name": "main",
          "x": 57,
          "y": 88,
          "territory": "M028",
          "arrowReceiver": {
            "x": 57,
            "y": 118
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57,
          "y": 88,
          "territory": "M028",
          "arrowReceiver": {
            "x": 57,
            "y": 118
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "奥里诺科": {
    "territory": "M028",
    "unitSlotName": "main",
    "province": "M028",
    "provinceMapData": {
      "abbr": "ORI",
      "type": "Land",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 57,
          "y": 88,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 118,
      "height": 145,
      "x": 689,
      "y": 1038,
      "playable": true,
      "path": "M 1.00 0.00 L 0.00 1.00 L 0.00 10.00 L 2.00 13.00 L 2.00 15.00 L 4.00 19.00 L 10.00 23.00 L 13.00 23.00 L 14.00 24.00 L 14.00 28.00 L 17.00 28.00 L 20.00 30.00 L 20.00 45.00 L 8.00 60.00 L 8.00 65.00 L 11.00 68.00 L 11.00 82.00 L 7.00 85.00 L 7.00 89.00 L 11.00 92.00 L 10.00 110.00 L 33.00 123.00 L 37.00 123.00 L 40.00 119.00 L 52.00 119.00 L 57.00 123.00 L 66.00 122.00 L 82.00 138.00 L 100.00 137.00 L 110.00 144.00 L 117.00 145.00 L 118.00 136.00 L 112.00 131.00 L 107.00 130.00 L 103.00 125.00 L 103.00 117.00 L 102.00 116.00 L 102.00 108.00 L 110.00 101.00 L 112.00 92.00 L 103.00 84.00 L 92.00 80.00 L 83.00 68.00 L 84.00 42.00 L 59.00 41.00 L 48.00 29.00 L 39.00 29.00 L 37.00 28.00 L 29.00 19.00 L 29.00 18.00 L 22.00 11.00 L 19.00 4.00 L 16.00 4.00 L 15.00 3.00 L 12.00 3.00 L 11.00 2.00 Z",
      "province": "M028",
      "rootTerritory": "M028",
      "viewBox": "0 0 118 145",
      "unitSlots": [
        {
          "name": "main",
          "x": 57,
          "y": 88,
          "territory": "M028",
          "arrowReceiver": {
            "x": 57,
            "y": 118
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 57,
          "y": 88,
          "territory": "M028",
          "arrowReceiver": {
            "x": 57,
            "y": 118
          }
        }
      },
      "texture": {
        "texture": "#FDDEAC",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_9_a": {
    "territory": "REGION_9_a",
    "unitSlotName": "main",
    "province": "REGION_9_a",
    "provinceMapData": {
      "abbr": "HOR",
      "type": "Land",
      "centerPos": {
        "x": 70,
        "y": 199
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 87,
          "y": 192,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 175,
      "height": 266,
      "x": 974,
      "y": 1225,
      "playable": true,
      "path": "M 103.00 0.00 L 95.00 1.00 L 86.00 10.00 L 87.00 25.00 L 72.00 39.00 L 71.00 58.00 L 47.00 89.00 L 44.00 142.00 L 35.00 160.00 L 0.00 200.00 L 0.00 206.00 L 2.00 210.00 L 11.00 215.00 L 13.00 215.00 L 21.00 219.00 L 28.00 226.00 L 31.00 233.00 L 42.00 233.00 L 47.00 237.00 L 51.00 237.00 L 56.00 233.00 L 72.00 232.00 L 76.00 236.00 L 75.00 246.00 L 82.00 252.00 L 82.00 258.00 L 83.00 259.00 L 83.00 265.00 L 84.00 266.00 L 88.00 266.00 L 91.00 263.00 L 101.00 263.00 L 106.00 255.00 L 127.00 246.00 L 137.00 237.00 L 138.00 237.00 L 147.00 228.00 L 148.00 212.00 L 167.00 193.00 L 169.00 174.00 L 171.00 169.00 L 173.00 167.00 L 173.00 159.00 L 174.00 158.00 L 174.00 143.00 L 175.00 142.00 L 175.00 139.00 L 173.00 136.00 L 173.00 132.00 L 166.00 128.00 L 151.00 129.00 L 148.00 126.00 L 131.00 126.00 L 127.00 130.00 L 124.00 129.00 L 122.00 127.00 L 127.00 70.00 L 115.00 60.00 L 119.00 52.00 L 119.00 40.00 L 105.00 32.00 L 108.00 27.00 L 108.00 5.00 Z",
      "province": "REGION_9_a",
      "rootTerritory": "REGION_9_a",
      "viewBox": "0 0 175 266",
      "unitSlots": [
        {
          "name": "main",
          "x": 87,
          "y": 192,
          "territory": "REGION_9_a",
          "arrowReceiver": {
            "x": 87,
            "y": 222
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 87,
          "y": 192,
          "territory": "REGION_9_a",
          "arrowReceiver": {
            "x": 87,
            "y": 222
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "贝洛奥里藏特": {
    "territory": "REGION_9_a",
    "unitSlotName": "main",
    "province": "REGION_9_a",
    "provinceMapData": {
      "abbr": "HOR",
      "type": "Land",
      "centerPos": {
        "x": 70,
        "y": 199
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 87,
          "y": 192,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 175,
      "height": 266,
      "x": 974,
      "y": 1225,
      "playable": true,
      "path": "M 103.00 0.00 L 95.00 1.00 L 86.00 10.00 L 87.00 25.00 L 72.00 39.00 L 71.00 58.00 L 47.00 89.00 L 44.00 142.00 L 35.00 160.00 L 0.00 200.00 L 0.00 206.00 L 2.00 210.00 L 11.00 215.00 L 13.00 215.00 L 21.00 219.00 L 28.00 226.00 L 31.00 233.00 L 42.00 233.00 L 47.00 237.00 L 51.00 237.00 L 56.00 233.00 L 72.00 232.00 L 76.00 236.00 L 75.00 246.00 L 82.00 252.00 L 82.00 258.00 L 83.00 259.00 L 83.00 265.00 L 84.00 266.00 L 88.00 266.00 L 91.00 263.00 L 101.00 263.00 L 106.00 255.00 L 127.00 246.00 L 137.00 237.00 L 138.00 237.00 L 147.00 228.00 L 148.00 212.00 L 167.00 193.00 L 169.00 174.00 L 171.00 169.00 L 173.00 167.00 L 173.00 159.00 L 174.00 158.00 L 174.00 143.00 L 175.00 142.00 L 175.00 139.00 L 173.00 136.00 L 173.00 132.00 L 166.00 128.00 L 151.00 129.00 L 148.00 126.00 L 131.00 126.00 L 127.00 130.00 L 124.00 129.00 L 122.00 127.00 L 127.00 70.00 L 115.00 60.00 L 119.00 52.00 L 119.00 40.00 L 105.00 32.00 L 108.00 27.00 L 108.00 5.00 Z",
      "province": "REGION_9_a",
      "rootTerritory": "REGION_9_a",
      "viewBox": "0 0 175 266",
      "unitSlots": [
        {
          "name": "main",
          "x": 87,
          "y": 192,
          "territory": "REGION_9_a",
          "arrowReceiver": {
            "x": 87,
            "y": 222
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 87,
          "y": 192,
          "territory": "REGION_9_a",
          "arrowReceiver": {
            "x": 87,
            "y": 222
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M029": {
    "territory": "M029",
    "unitSlotName": "main",
    "province": "M029",
    "provinceMapData": {
      "abbr": "RDJ",
      "type": "Coast",
      "centerPos": {
        "x": 10,
        "y": 112
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 27,
          "y": 119,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 98,
      "height": 134,
      "x": 1075,
      "y": 1360,
      "playable": true,
      "path": "M 98.00 6.00 L 82.00 4.00 L 76.00 0.00 L 75.00 7.00 L 74.00 8.00 L 74.00 23.00 L 73.00 24.00 L 73.00 32.00 L 71.00 34.00 L 68.00 35.00 L 65.00 56.00 L 46.00 75.00 L 45.00 91.00 L 24.00 110.00 L 3.00 119.00 L 0.00 122.00 L 0.00 127.00 L 8.00 127.00 L 12.00 134.00 L 22.00 134.00 L 33.00 125.00 L 43.00 125.00 L 51.00 120.00 L 50.00 108.00 L 56.00 103.00 L 61.00 89.00 L 80.00 71.00 L 92.00 47.00 L 93.00 28.00 L 96.00 26.00 L 98.00 21.00 Z",
      "province": "M029",
      "rootTerritory": "M029",
      "viewBox": "0 0 98 134",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 119,
          "territory": "M029",
          "arrowReceiver": {
            "x": 27,
            "y": 149
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 119,
          "territory": "M029",
          "arrowReceiver": {
            "x": 27,
            "y": 149
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "里约热内卢": {
    "territory": "M029",
    "unitSlotName": "main",
    "province": "M029",
    "provinceMapData": {
      "abbr": "RDJ",
      "type": "Coast",
      "centerPos": {
        "x": 10,
        "y": 112
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 27,
          "y": 119,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 98,
      "height": 134,
      "x": 1075,
      "y": 1360,
      "playable": true,
      "path": "M 98.00 6.00 L 82.00 4.00 L 76.00 0.00 L 75.00 7.00 L 74.00 8.00 L 74.00 23.00 L 73.00 24.00 L 73.00 32.00 L 71.00 34.00 L 68.00 35.00 L 65.00 56.00 L 46.00 75.00 L 45.00 91.00 L 24.00 110.00 L 3.00 119.00 L 0.00 122.00 L 0.00 127.00 L 8.00 127.00 L 12.00 134.00 L 22.00 134.00 L 33.00 125.00 L 43.00 125.00 L 51.00 120.00 L 50.00 108.00 L 56.00 103.00 L 61.00 89.00 L 80.00 71.00 L 92.00 47.00 L 93.00 28.00 L 96.00 26.00 L 98.00 21.00 Z",
      "province": "M029",
      "rootTerritory": "M029",
      "viewBox": "0 0 98 134",
      "unitSlots": [
        {
          "name": "main",
          "x": 27,
          "y": 119,
          "territory": "M029",
          "arrowReceiver": {
            "x": 27,
            "y": 149
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 27,
          "y": 119,
          "territory": "M029",
          "arrowReceiver": {
            "x": 27,
            "y": 149
          }
        }
      },
      "texture": {
        "texture": "#B0CEB1",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_49_b_a_a": {
    "territory": "REGION_49_b_a_a",
    "unitSlotName": "main",
    "province": "REGION_49_b_a_a",
    "provinceMapData": {
      "abbr": "NCA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 102,
          "y": 48,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 209,
      "height": 61,
      "x": 525,
      "y": 818,
      "playable": true,
      "path": "M 1.000 13.000 L 0.000 40.000 L 1.000 41.000 L 1.000 48.000 L 2.000 49.000 L 3.000 59.000 L 80.000 61.000 L 87.000 52.000 L 126.000 52.000 L 131.000 61.000 L 197.000 58.000 L 203.000 52.000 L 202.000 33.000 L 208.664 21.584 L 208.664 21.584 L 173.068 15.608 L 163.000 23.000 L 149.000 22.000 L 147.000 25.000 L 149.000 28.000 L 148.000 30.000 L 144.000 28.000 L 138.000 29.000 L 137.000 30.000 L 135.000 30.000 L 131.000 36.000 L 127.000 36.000 L 126.000 35.000 L 122.000 35.000 L 118.000 32.000 L 118.000 27.000 L 113.000 23.000 L 113.000 18.000 L 112.000 18.000 L 111.000 16.000 L 109.000 16.000 L 108.000 15.000 L 106.000 15.000 L 105.000 14.000 L 103.000 14.000 L 102.000 13.000 L 100.000 13.000 L 99.000 12.000 L 97.000 12.000 L 96.000 11.000 L 94.000 11.000 L 93.000 10.000 L 91.000 10.000 L 69.000 2.000 L 59.000 2.000 L 58.000 1.000 L 44.000 1.000 L 43.000 0.000 L 36.000 0.000 L 35.000 2.000 L 13.000 13.000 Z",
      "province": "REGION_49_b_a_a",
      "rootTerritory": "REGION_49_b_a_a",
      "viewBox": "0 0 209 61",
      "unitSlots": [
        {
          "name": "main",
          "x": 102,
          "y": 48,
          "territory": "REGION_49_b_a_a",
          "arrowReceiver": {
            "x": 102,
            "y": 78
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 102,
          "y": 48,
          "territory": "REGION_49_b_a_a",
          "arrowReceiver": {
            "x": 102,
            "y": 78
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "北加勒比海": {
    "territory": "REGION_49_b_a_a",
    "unitSlotName": "main",
    "province": "REGION_49_b_a_a",
    "provinceMapData": {
      "abbr": "NCA",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 102,
          "y": 48,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 209,
      "height": 61,
      "x": 525,
      "y": 818,
      "playable": true,
      "path": "M 1.000 13.000 L 0.000 40.000 L 1.000 41.000 L 1.000 48.000 L 2.000 49.000 L 3.000 59.000 L 80.000 61.000 L 87.000 52.000 L 126.000 52.000 L 131.000 61.000 L 197.000 58.000 L 203.000 52.000 L 202.000 33.000 L 208.664 21.584 L 208.664 21.584 L 173.068 15.608 L 163.000 23.000 L 149.000 22.000 L 147.000 25.000 L 149.000 28.000 L 148.000 30.000 L 144.000 28.000 L 138.000 29.000 L 137.000 30.000 L 135.000 30.000 L 131.000 36.000 L 127.000 36.000 L 126.000 35.000 L 122.000 35.000 L 118.000 32.000 L 118.000 27.000 L 113.000 23.000 L 113.000 18.000 L 112.000 18.000 L 111.000 16.000 L 109.000 16.000 L 108.000 15.000 L 106.000 15.000 L 105.000 14.000 L 103.000 14.000 L 102.000 13.000 L 100.000 13.000 L 99.000 12.000 L 97.000 12.000 L 96.000 11.000 L 94.000 11.000 L 93.000 10.000 L 91.000 10.000 L 69.000 2.000 L 59.000 2.000 L 58.000 1.000 L 44.000 1.000 L 43.000 0.000 L 36.000 0.000 L 35.000 2.000 L 13.000 13.000 Z",
      "province": "REGION_49_b_a_a",
      "rootTerritory": "REGION_49_b_a_a",
      "viewBox": "0 0 209 61",
      "unitSlots": [
        {
          "name": "main",
          "x": 102,
          "y": 48,
          "territory": "REGION_49_b_a_a",
          "arrowReceiver": {
            "x": 102,
            "y": 78
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 102,
          "y": 48,
          "territory": "REGION_49_b_a_a",
          "arrowReceiver": {
            "x": 102,
            "y": 78
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M030": {
    "territory": "M030",
    "unitSlotName": "main",
    "province": "M030",
    "provinceMapData": {
      "abbr": "KMG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 47,
      "height": 29,
      "x": 591,
      "y": 804,
      "playable": true,
      "path": "M 0.00 1.00 L 2.00 15.00 L 18.00 20.00 L 24.00 23.00 L 27.00 23.00 L 30.00 25.00 L 33.00 25.00 L 34.00 26.00 L 42.00 28.00 L 43.00 29.00 L 47.00 28.00 L 47.00 18.00 L 36.00 17.00 L 35.00 15.00 L 31.00 12.00 L 28.00 12.00 L 23.00 9.00 L 17.00 9.00 L 16.00 8.00 L 14.00 8.00 L 12.00 7.00 L 6.00 0.00 Z",
      "province": "M030",
      "rootTerritory": "M030",
      "viewBox": "0 0 47 29",
      "unitSlots": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        "nc": {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        "sc": {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡马圭": {
    "territory": "M030",
    "unitSlotName": "main",
    "province": "M030",
    "provinceMapData": {
      "abbr": "KMG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 47,
      "height": 29,
      "x": 591,
      "y": 804,
      "playable": true,
      "path": "M 0.00 1.00 L 2.00 15.00 L 18.00 20.00 L 24.00 23.00 L 27.00 23.00 L 30.00 25.00 L 33.00 25.00 L 34.00 26.00 L 42.00 28.00 L 43.00 29.00 L 47.00 28.00 L 47.00 18.00 L 36.00 17.00 L 35.00 15.00 L 31.00 12.00 L 28.00 12.00 L 23.00 9.00 L 17.00 9.00 L 16.00 8.00 L 14.00 8.00 L 12.00 7.00 L 6.00 0.00 Z",
      "province": "M030",
      "rootTerritory": "M030",
      "viewBox": "0 0 47 29",
      "unitSlots": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        "nc": {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        "sc": {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_73_a_a": {
    "territory": "REGION_73_a_a",
    "unitSlotName": "main",
    "province": "REGION_73_a_a",
    "provinceMapData": {
      "abbr": "GOC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 232,
          "y": 44,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 463,
      "height": 201,
      "x": 172,
      "y": 1666,
      "playable": true,
      "path": "M 0.00 48.00 L 0.00 58.00 L 1.00 59.00 L 1.00 63.00 L 2.00 64.00 L 3.00 72.00 L 4.00 73.00 L 4.00 78.00 L 5.00 79.00 L 6.00 89.00 L 7.00 90.00 L 7.00 94.00 L 8.00 95.00 L 8.00 100.00 L 9.00 101.00 L 10.00 112.00 L 11.00 113.00 L 11.00 117.00 L 12.00 118.00 L 12.00 123.00 L 14.00 127.00 L 14.00 132.00 L 16.00 136.00 L 17.00 147.00 L 18.00 148.00 L 19.00 158.00 L 20.00 159.00 L 20.00 175.00 L 22.00 176.00 L 25.00 176.00 L 28.00 178.00 L 74.00 179.00 L 75.00 180.00 L 85.00 180.00 L 86.00 181.00 L 107.00 182.00 L 108.00 183.00 L 117.00 183.00 L 118.00 184.00 L 157.00 185.00 L 158.00 186.00 L 180.00 186.00 L 181.00 187.00 L 203.00 187.00 L 204.00 188.00 L 218.00 188.00 L 219.00 189.00 L 226.00 189.00 L 227.00 190.00 L 233.00 190.00 L 234.00 191.00 L 245.00 191.00 L 246.00 192.00 L 262.00 192.00 L 263.00 193.00 L 279.00 193.00 L 280.00 194.00 L 295.00 194.00 L 296.00 195.00 L 312.00 195.00 L 313.00 196.00 L 329.00 196.00 L 330.00 197.00 L 346.00 197.00 L 347.00 198.00 L 363.00 198.00 L 364.00 199.00 L 380.00 199.00 L 381.00 200.00 L 396.00 200.00 L 397.00 201.00 L 405.00 201.00 L 405.00 197.00 L 401.00 194.00 L 402.00 184.00 L 414.00 170.00 L 417.00 164.00 L 423.00 158.00 L 425.00 154.00 L 425.00 152.00 L 428.00 147.00 L 428.00 143.00 L 430.00 139.00 L 432.00 137.00 L 434.00 137.00 L 436.00 130.00 L 438.00 127.00 L 440.00 120.00 L 443.00 115.00 L 443.00 112.00 L 449.00 100.00 L 450.00 94.00 L 454.00 86.00 L 454.00 77.00 L 457.00 75.00 L 461.00 65.00 L 461.00 56.00 L 463.00 53.00 L 463.00 41.00 L 462.00 40.00 L 462.00 36.00 L 302.00 34.00 L 295.00 29.00 L 284.00 29.00 L 283.00 30.00 L 261.00 30.00 L 260.00 31.00 L 239.00 31.00 L 238.00 30.00 L 219.00 30.00 L 218.00 29.00 L 199.00 29.00 L 198.00 28.00 L 188.00 28.00 L 179.00 23.00 L 121.00 24.00 L 112.00 18.00 L 51.00 14.00 L 37.00 0.00 L 23.00 0.00 L 22.00 19.00 L 37.00 35.00 L 34.00 39.00 L 1.00 40.00 L 1.00 47.00 Z",
      "province": "REGION_73_a_a",
      "rootTerritory": "REGION_73_a_a",
      "viewBox": "0 0 463 201",
      "unitSlots": [
        {
          "name": "main",
          "x": 232,
          "y": 44,
          "territory": "REGION_73_a_a",
          "arrowReceiver": {
            "x": 232,
            "y": 74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 232,
          "y": 44,
          "territory": "REGION_73_a_a",
          "arrowReceiver": {
            "x": 232,
            "y": 74
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "科尔科瓦多湾": {
    "territory": "REGION_73_a_a",
    "unitSlotName": "main",
    "province": "REGION_73_a_a",
    "provinceMapData": {
      "abbr": "GOC",
      "type": "Sea",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 232,
          "y": 44,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 463,
      "height": 201,
      "x": 172,
      "y": 1666,
      "playable": true,
      "path": "M 0.00 48.00 L 0.00 58.00 L 1.00 59.00 L 1.00 63.00 L 2.00 64.00 L 3.00 72.00 L 4.00 73.00 L 4.00 78.00 L 5.00 79.00 L 6.00 89.00 L 7.00 90.00 L 7.00 94.00 L 8.00 95.00 L 8.00 100.00 L 9.00 101.00 L 10.00 112.00 L 11.00 113.00 L 11.00 117.00 L 12.00 118.00 L 12.00 123.00 L 14.00 127.00 L 14.00 132.00 L 16.00 136.00 L 17.00 147.00 L 18.00 148.00 L 19.00 158.00 L 20.00 159.00 L 20.00 175.00 L 22.00 176.00 L 25.00 176.00 L 28.00 178.00 L 74.00 179.00 L 75.00 180.00 L 85.00 180.00 L 86.00 181.00 L 107.00 182.00 L 108.00 183.00 L 117.00 183.00 L 118.00 184.00 L 157.00 185.00 L 158.00 186.00 L 180.00 186.00 L 181.00 187.00 L 203.00 187.00 L 204.00 188.00 L 218.00 188.00 L 219.00 189.00 L 226.00 189.00 L 227.00 190.00 L 233.00 190.00 L 234.00 191.00 L 245.00 191.00 L 246.00 192.00 L 262.00 192.00 L 263.00 193.00 L 279.00 193.00 L 280.00 194.00 L 295.00 194.00 L 296.00 195.00 L 312.00 195.00 L 313.00 196.00 L 329.00 196.00 L 330.00 197.00 L 346.00 197.00 L 347.00 198.00 L 363.00 198.00 L 364.00 199.00 L 380.00 199.00 L 381.00 200.00 L 396.00 200.00 L 397.00 201.00 L 405.00 201.00 L 405.00 197.00 L 401.00 194.00 L 402.00 184.00 L 414.00 170.00 L 417.00 164.00 L 423.00 158.00 L 425.00 154.00 L 425.00 152.00 L 428.00 147.00 L 428.00 143.00 L 430.00 139.00 L 432.00 137.00 L 434.00 137.00 L 436.00 130.00 L 438.00 127.00 L 440.00 120.00 L 443.00 115.00 L 443.00 112.00 L 449.00 100.00 L 450.00 94.00 L 454.00 86.00 L 454.00 77.00 L 457.00 75.00 L 461.00 65.00 L 461.00 56.00 L 463.00 53.00 L 463.00 41.00 L 462.00 40.00 L 462.00 36.00 L 302.00 34.00 L 295.00 29.00 L 284.00 29.00 L 283.00 30.00 L 261.00 30.00 L 260.00 31.00 L 239.00 31.00 L 238.00 30.00 L 219.00 30.00 L 218.00 29.00 L 199.00 29.00 L 198.00 28.00 L 188.00 28.00 L 179.00 23.00 L 121.00 24.00 L 112.00 18.00 L 51.00 14.00 L 37.00 0.00 L 23.00 0.00 L 22.00 19.00 L 37.00 35.00 L 34.00 39.00 L 1.00 40.00 L 1.00 47.00 Z",
      "province": "REGION_73_a_a",
      "rootTerritory": "REGION_73_a_a",
      "viewBox": "0 0 463 201",
      "unitSlots": [
        {
          "name": "main",
          "x": 232,
          "y": 44,
          "territory": "REGION_73_a_a",
          "arrowReceiver": {
            "x": 232,
            "y": 74
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 232,
          "y": 44,
          "territory": "REGION_73_a_a",
          "arrowReceiver": {
            "x": 232,
            "y": 74
          }
        }
      },
      "texture": {
        "texture": "#8FB3D9",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M031": {
    "territory": "M031",
    "unitSlotName": "main",
    "province": "M031",
    "provinceMapData": {
      "abbr": "AYS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 41,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 58,
      "height": 77,
      "x": 606,
      "y": 1729,
      "playable": true,
      "path": "M 28.00 0.00 L 42.00 7.00 L 57.00 7.00 L 58.00 9.00 L 58.00 11.00 L 43.00 11.00 L 38.00 25.00 L 31.00 32.00 L 32.00 48.00 L 13.00 67.00 L 12.00 74.00 L 9.00 77.00 L 0.00 76.00 L 21.00 22.00 L 21.00 14.00 L 24.00 12.00 L 28.00 1.00 Z",
      "province": "M031",
      "rootTerritory": "M031",
      "viewBox": "0 0 58 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 9,
          "territory": "M031",
          "arrowReceiver": {
            "x": 41,
            "y": 39
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 9,
          "territory": "M031",
          "arrowReceiver": {
            "x": 41,
            "y": 39
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "艾森": {
    "territory": "M031",
    "unitSlotName": "main",
    "province": "M031",
    "provinceMapData": {
      "abbr": "AYS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 41,
          "y": 9,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 58,
      "height": 77,
      "x": 606,
      "y": 1729,
      "playable": true,
      "path": "M 28.00 0.00 L 42.00 7.00 L 57.00 7.00 L 58.00 9.00 L 58.00 11.00 L 43.00 11.00 L 38.00 25.00 L 31.00 32.00 L 32.00 48.00 L 13.00 67.00 L 12.00 74.00 L 9.00 77.00 L 0.00 76.00 L 21.00 22.00 L 21.00 14.00 L 24.00 12.00 L 28.00 1.00 Z",
      "province": "M031",
      "rootTerritory": "M031",
      "viewBox": "0 0 58 77",
      "unitSlots": [
        {
          "name": "main",
          "x": 41,
          "y": 9,
          "territory": "M031",
          "arrowReceiver": {
            "x": 41,
            "y": 39
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 41,
          "y": 9,
          "territory": "M031",
          "arrowReceiver": {
            "x": 41,
            "y": 39
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_107_NORTH_COAST": {
    "territory": "REGION_107_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "REGION_107",
    "provinceMapData": {
      "abbr": "WDC",
      "type": "Coast",
      "centerPos": {
        "x": 11,
        "y": 5
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 63,
      "x": 590,
      "y": 496,
      "playable": true,
      "path": "M 0.00 7.00 L 0.00 24.00 L 3.00 28.00 L 11.00 28.00 L 15.00 32.00 L 25.00 31.00 L 31.00 29.00 L 47.00 42.00 L 50.00 49.00 L 56.00 49.00 L 61.00 54.00 L 61.00 63.00 L 63.00 63.00 L 71.00 58.00 L 74.00 52.00 L 74.00 37.00 L 72.00 35.00 L 72.00 33.00 L 74.00 31.00 L 74.00 17.00 L 71.00 12.00 L 72.00 0.00 L 53.00 1.00 L 52.00 2.00 L 11.00 0.00 L 3.00 4.00 Z",
      "province": "REGION_107",
      "rootTerritory": "REGION_107",
      "viewBox": "0 0 74 63",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        "nc": {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        "sc": {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "华盛顿特区 (North Coast)": {
    "territory": "REGION_107_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "REGION_107",
    "provinceMapData": {
      "abbr": "WDC",
      "type": "Coast",
      "centerPos": {
        "x": 11,
        "y": 5
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 63,
      "x": 590,
      "y": 496,
      "playable": true,
      "path": "M 0.00 7.00 L 0.00 24.00 L 3.00 28.00 L 11.00 28.00 L 15.00 32.00 L 25.00 31.00 L 31.00 29.00 L 47.00 42.00 L 50.00 49.00 L 56.00 49.00 L 61.00 54.00 L 61.00 63.00 L 63.00 63.00 L 71.00 58.00 L 74.00 52.00 L 74.00 37.00 L 72.00 35.00 L 72.00 33.00 L 74.00 31.00 L 74.00 17.00 L 71.00 12.00 L 72.00 0.00 L 53.00 1.00 L 52.00 2.00 L 11.00 0.00 L 3.00 4.00 Z",
      "province": "REGION_107",
      "rootTerritory": "REGION_107",
      "viewBox": "0 0 74 63",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        "nc": {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        "sc": {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_107_SOUTH_COAST": {
    "territory": "REGION_107_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "REGION_107",
    "provinceMapData": {
      "abbr": "WDC",
      "type": "Coast",
      "centerPos": {
        "x": 11,
        "y": 5
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 63,
      "x": 590,
      "y": 496,
      "playable": true,
      "path": "M 0.00 7.00 L 0.00 24.00 L 3.00 28.00 L 11.00 28.00 L 15.00 32.00 L 25.00 31.00 L 31.00 29.00 L 47.00 42.00 L 50.00 49.00 L 56.00 49.00 L 61.00 54.00 L 61.00 63.00 L 63.00 63.00 L 71.00 58.00 L 74.00 52.00 L 74.00 37.00 L 72.00 35.00 L 72.00 33.00 L 74.00 31.00 L 74.00 17.00 L 71.00 12.00 L 72.00 0.00 L 53.00 1.00 L 52.00 2.00 L 11.00 0.00 L 3.00 4.00 Z",
      "province": "REGION_107",
      "rootTerritory": "REGION_107",
      "viewBox": "0 0 74 63",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        "nc": {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        "sc": {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "华盛顿特区 (South Coast)": {
    "territory": "REGION_107_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "REGION_107",
    "provinceMapData": {
      "abbr": "WDC",
      "type": "Coast",
      "centerPos": {
        "x": 11,
        "y": 5
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 54,
          "y": 22,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 63,
      "x": 590,
      "y": 496,
      "playable": true,
      "path": "M 0.00 7.00 L 0.00 24.00 L 3.00 28.00 L 11.00 28.00 L 15.00 32.00 L 25.00 31.00 L 31.00 29.00 L 47.00 42.00 L 50.00 49.00 L 56.00 49.00 L 61.00 54.00 L 61.00 63.00 L 63.00 63.00 L 71.00 58.00 L 74.00 52.00 L 74.00 37.00 L 72.00 35.00 L 72.00 33.00 L 74.00 31.00 L 74.00 17.00 L 71.00 12.00 L 72.00 0.00 L 53.00 1.00 L 52.00 2.00 L 11.00 0.00 L 3.00 4.00 Z",
      "province": "REGION_107",
      "rootTerritory": "REGION_107",
      "viewBox": "0 0 74 63",
      "unitSlots": [
        {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 37,
          "y": 25,
          "territory": "REGION_107",
          "arrowReceiver": {
            "x": 37,
            "y": 55
          }
        },
        "nc": {
          "name": "nc",
          "x": 8.27,
          "y": 13.46,
          "territory": "REGION_107_NORTH_COAST",
          "arrowReceiver": {
            "x": 8.27,
            "y": 43.46
          }
        },
        "sc": {
          "name": "sc",
          "x": 64.15,
          "y": 45.98,
          "territory": "REGION_107_SOUTH_COAST",
          "arrowReceiver": {
            "x": 64.15,
            "y": 75.98
          }
        }
      },
      "texture": {
        "texture": "#A6C4E7",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_123_NORTH_COAST": {
    "territory": "REGION_123_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "REGION_123",
    "provinceMapData": {
      "abbr": "ONT",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 74,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 182,
      "height": 112,
      "x": 423,
      "y": 289,
      "playable": true,
      "path": "M 5.00 61.00 L 0.00 94.00 L 12.00 94.00 L 21.00 101.00 L 35.00 102.00 L 44.00 97.00 L 61.00 96.00 L 65.00 99.00 L 65.00 103.00 L 68.00 103.00 L 75.00 96.00 L 78.00 96.00 L 79.00 97.00 L 105.00 99.00 L 112.00 110.00 L 115.00 111.00 L 122.00 111.00 L 133.00 105.00 L 141.00 105.00 L 151.00 112.00 L 172.00 110.00 L 173.00 109.00 L 175.00 111.00 L 177.00 111.00 L 177.00 108.00 L 179.00 105.00 L 182.00 80.00 L 172.00 80.00 L 168.00 78.00 L 161.00 70.00 L 159.00 62.00 L 149.00 54.00 L 149.00 32.00 L 147.00 29.00 L 124.00 28.00 L 78.00 2.00 L 67.00 2.00 L 64.00 0.00 L 60.00 0.00 Z",
      "province": "REGION_123",
      "rootTerritory": "REGION_123",
      "viewBox": "0 0 182 112",
      "unitSlots": [
        {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        "nc": {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        "sc": {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "安大略 (North Coast)": {
    "territory": "REGION_123_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "REGION_123",
    "provinceMapData": {
      "abbr": "ONT",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 74,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 182,
      "height": 112,
      "x": 423,
      "y": 289,
      "playable": true,
      "path": "M 5.00 61.00 L 0.00 94.00 L 12.00 94.00 L 21.00 101.00 L 35.00 102.00 L 44.00 97.00 L 61.00 96.00 L 65.00 99.00 L 65.00 103.00 L 68.00 103.00 L 75.00 96.00 L 78.00 96.00 L 79.00 97.00 L 105.00 99.00 L 112.00 110.00 L 115.00 111.00 L 122.00 111.00 L 133.00 105.00 L 141.00 105.00 L 151.00 112.00 L 172.00 110.00 L 173.00 109.00 L 175.00 111.00 L 177.00 111.00 L 177.00 108.00 L 179.00 105.00 L 182.00 80.00 L 172.00 80.00 L 168.00 78.00 L 161.00 70.00 L 159.00 62.00 L 149.00 54.00 L 149.00 32.00 L 147.00 29.00 L 124.00 28.00 L 78.00 2.00 L 67.00 2.00 L 64.00 0.00 L 60.00 0.00 Z",
      "province": "REGION_123",
      "rootTerritory": "REGION_123",
      "viewBox": "0 0 182 112",
      "unitSlots": [
        {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        "nc": {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        "sc": {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_123_SOUTH_COAST": {
    "territory": "REGION_123_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "REGION_123",
    "provinceMapData": {
      "abbr": "ONT",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 74,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 182,
      "height": 112,
      "x": 423,
      "y": 289,
      "playable": true,
      "path": "M 5.00 61.00 L 0.00 94.00 L 12.00 94.00 L 21.00 101.00 L 35.00 102.00 L 44.00 97.00 L 61.00 96.00 L 65.00 99.00 L 65.00 103.00 L 68.00 103.00 L 75.00 96.00 L 78.00 96.00 L 79.00 97.00 L 105.00 99.00 L 112.00 110.00 L 115.00 111.00 L 122.00 111.00 L 133.00 105.00 L 141.00 105.00 L 151.00 112.00 L 172.00 110.00 L 173.00 109.00 L 175.00 111.00 L 177.00 111.00 L 177.00 108.00 L 179.00 105.00 L 182.00 80.00 L 172.00 80.00 L 168.00 78.00 L 161.00 70.00 L 159.00 62.00 L 149.00 54.00 L 149.00 32.00 L 147.00 29.00 L 124.00 28.00 L 78.00 2.00 L 67.00 2.00 L 64.00 0.00 L 60.00 0.00 Z",
      "province": "REGION_123",
      "rootTerritory": "REGION_123",
      "viewBox": "0 0 182 112",
      "unitSlots": [
        {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        "nc": {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        "sc": {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "安大略 (South Coast)": {
    "territory": "REGION_123_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "REGION_123",
    "provinceMapData": {
      "abbr": "ONT",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 74,
          "y": 52,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 182,
      "height": 112,
      "x": 423,
      "y": 289,
      "playable": true,
      "path": "M 5.00 61.00 L 0.00 94.00 L 12.00 94.00 L 21.00 101.00 L 35.00 102.00 L 44.00 97.00 L 61.00 96.00 L 65.00 99.00 L 65.00 103.00 L 68.00 103.00 L 75.00 96.00 L 78.00 96.00 L 79.00 97.00 L 105.00 99.00 L 112.00 110.00 L 115.00 111.00 L 122.00 111.00 L 133.00 105.00 L 141.00 105.00 L 151.00 112.00 L 172.00 110.00 L 173.00 109.00 L 175.00 111.00 L 177.00 111.00 L 177.00 108.00 L 179.00 105.00 L 182.00 80.00 L 172.00 80.00 L 168.00 78.00 L 161.00 70.00 L 159.00 62.00 L 149.00 54.00 L 149.00 32.00 L 147.00 29.00 L 124.00 28.00 L 78.00 2.00 L 67.00 2.00 L 64.00 0.00 L 60.00 0.00 Z",
      "province": "REGION_123",
      "rootTerritory": "REGION_123",
      "viewBox": "0 0 182 112",
      "unitSlots": [
        {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 86,
          "y": 85,
          "territory": "REGION_123",
          "arrowReceiver": {
            "x": 86,
            "y": 115
          }
        },
        "nc": {
          "name": "nc",
          "x": 163.31,
          "y": 76.61,
          "territory": "REGION_123_NORTH_COAST",
          "arrowReceiver": {
            "x": 163.31,
            "y": 106.61
          }
        },
        "sc": {
          "name": "sc",
          "x": 118.81,
          "y": 100.16,
          "territory": "REGION_123_SOUTH_COAST",
          "arrowReceiver": {
            "x": 118.81,
            "y": 130.16
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_144_NORTH_COAST": {
    "territory": "REGION_144_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "REGION_144",
    "provinceMapData": {
      "abbr": "HON",
      "type": "Coast",
      "centerPos": {
        "x": -10,
        "y": 24
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 67,
      "x": 461,
      "y": 923,
      "playable": true,
      "path": "M 68.00 0.00 L 65.00 0.00 L 64.00 8.00 L 61.00 11.00 L 52.00 12.00 L 45.00 10.00 L 38.00 10.00 L 28.00 22.00 L 14.00 23.00 L 11.00 28.00 L 5.00 33.00 L 5.00 35.00 L 0.00 40.00 L 1.00 44.00 L 12.00 55.00 L 24.00 60.00 L 28.00 60.00 L 41.00 67.00 L 44.00 67.00 L 44.00 53.00 L 51.00 46.00 L 50.00 31.00 L 56.00 24.00 L 60.00 17.00 L 69.00 17.00 L 69.00 2.00 Z",
      "province": "REGION_144",
      "rootTerritory": "REGION_144",
      "viewBox": "0 0 69 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        "nc": {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        "sc": {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "尼加拉瓜 (North Coast)": {
    "territory": "REGION_144_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "REGION_144",
    "provinceMapData": {
      "abbr": "HON",
      "type": "Coast",
      "centerPos": {
        "x": -10,
        "y": 24
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 67,
      "x": 461,
      "y": 923,
      "playable": true,
      "path": "M 68.00 0.00 L 65.00 0.00 L 64.00 8.00 L 61.00 11.00 L 52.00 12.00 L 45.00 10.00 L 38.00 10.00 L 28.00 22.00 L 14.00 23.00 L 11.00 28.00 L 5.00 33.00 L 5.00 35.00 L 0.00 40.00 L 1.00 44.00 L 12.00 55.00 L 24.00 60.00 L 28.00 60.00 L 41.00 67.00 L 44.00 67.00 L 44.00 53.00 L 51.00 46.00 L 50.00 31.00 L 56.00 24.00 L 60.00 17.00 L 69.00 17.00 L 69.00 2.00 Z",
      "province": "REGION_144",
      "rootTerritory": "REGION_144",
      "viewBox": "0 0 69 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        "nc": {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        "sc": {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_144_SOUTH_COAST": {
    "territory": "REGION_144_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "REGION_144",
    "provinceMapData": {
      "abbr": "HON",
      "type": "Coast",
      "centerPos": {
        "x": -10,
        "y": 24
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 67,
      "x": 461,
      "y": 923,
      "playable": true,
      "path": "M 68.00 0.00 L 65.00 0.00 L 64.00 8.00 L 61.00 11.00 L 52.00 12.00 L 45.00 10.00 L 38.00 10.00 L 28.00 22.00 L 14.00 23.00 L 11.00 28.00 L 5.00 33.00 L 5.00 35.00 L 0.00 40.00 L 1.00 44.00 L 12.00 55.00 L 24.00 60.00 L 28.00 60.00 L 41.00 67.00 L 44.00 67.00 L 44.00 53.00 L 51.00 46.00 L 50.00 31.00 L 56.00 24.00 L 60.00 17.00 L 69.00 17.00 L 69.00 2.00 Z",
      "province": "REGION_144",
      "rootTerritory": "REGION_144",
      "viewBox": "0 0 69 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        "nc": {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        "sc": {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "尼加拉瓜 (South Coast)": {
    "territory": "REGION_144_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "REGION_144",
    "provinceMapData": {
      "abbr": "HON",
      "type": "Coast",
      "centerPos": {
        "x": -10,
        "y": 24
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 29,
          "y": 41,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 69,
      "height": 67,
      "x": 461,
      "y": 923,
      "playable": true,
      "path": "M 68.00 0.00 L 65.00 0.00 L 64.00 8.00 L 61.00 11.00 L 52.00 12.00 L 45.00 10.00 L 38.00 10.00 L 28.00 22.00 L 14.00 23.00 L 11.00 28.00 L 5.00 33.00 L 5.00 35.00 L 0.00 40.00 L 1.00 44.00 L 12.00 55.00 L 24.00 60.00 L 28.00 60.00 L 41.00 67.00 L 44.00 67.00 L 44.00 53.00 L 51.00 46.00 L 50.00 31.00 L 56.00 24.00 L 60.00 17.00 L 69.00 17.00 L 69.00 2.00 Z",
      "province": "REGION_144",
      "rootTerritory": "REGION_144",
      "viewBox": "0 0 69 67",
      "unitSlots": [
        {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 30,
          "y": 32,
          "territory": "REGION_144",
          "arrowReceiver": {
            "x": 30,
            "y": 62
          }
        },
        "nc": {
          "name": "nc",
          "x": 54.78,
          "y": 13.65,
          "territory": "REGION_144_NORTH_COAST",
          "arrowReceiver": {
            "x": 54.78,
            "y": 43.65
          }
        },
        "sc": {
          "name": "sc",
          "x": 18.83,
          "y": 56.68,
          "territory": "REGION_144_SOUTH_COAST",
          "arrowReceiver": {
            "x": 18.83,
            "y": 86.68
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_183_NORTH_COAST": {
    "territory": "REGION_183_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "REGION_183",
    "provinceMapData": {
      "abbr": "COS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 13,
          "y": 15,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 52,
      "x": 482,
      "y": 982,
      "playable": true,
      "path": "M 3.00 0.00 L 3.00 10.00 L 0.00 13.00 L 0.00 19.00 L 2.00 23.00 L 9.00 28.00 L 13.00 28.00 L 16.00 30.00 L 20.00 31.00 L 41.00 52.00 L 45.00 52.00 L 44.00 39.00 L 36.00 23.00 L 23.00 10.00 L 23.00 7.00 L 10.00 0.00 Z",
      "province": "REGION_183",
      "rootTerritory": "REGION_183",
      "viewBox": "0 0 45 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        "nc": {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        "sc": {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "哥斯达黎加 (North Coast)": {
    "territory": "REGION_183_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "REGION_183",
    "provinceMapData": {
      "abbr": "COS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 13,
          "y": 15,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 52,
      "x": 482,
      "y": 982,
      "playable": true,
      "path": "M 3.00 0.00 L 3.00 10.00 L 0.00 13.00 L 0.00 19.00 L 2.00 23.00 L 9.00 28.00 L 13.00 28.00 L 16.00 30.00 L 20.00 31.00 L 41.00 52.00 L 45.00 52.00 L 44.00 39.00 L 36.00 23.00 L 23.00 10.00 L 23.00 7.00 L 10.00 0.00 Z",
      "province": "REGION_183",
      "rootTerritory": "REGION_183",
      "viewBox": "0 0 45 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        "nc": {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        "sc": {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_183_SOUTH_COAST": {
    "territory": "REGION_183_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "REGION_183",
    "provinceMapData": {
      "abbr": "COS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 13,
          "y": 15,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 52,
      "x": 482,
      "y": 982,
      "playable": true,
      "path": "M 3.00 0.00 L 3.00 10.00 L 0.00 13.00 L 0.00 19.00 L 2.00 23.00 L 9.00 28.00 L 13.00 28.00 L 16.00 30.00 L 20.00 31.00 L 41.00 52.00 L 45.00 52.00 L 44.00 39.00 L 36.00 23.00 L 23.00 10.00 L 23.00 7.00 L 10.00 0.00 Z",
      "province": "REGION_183",
      "rootTerritory": "REGION_183",
      "viewBox": "0 0 45 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        "nc": {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        "sc": {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "哥斯达黎加 (South Coast)": {
    "territory": "REGION_183_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "REGION_183",
    "provinceMapData": {
      "abbr": "COS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 13,
          "y": 15,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 45,
      "height": 52,
      "x": 482,
      "y": 982,
      "playable": true,
      "path": "M 3.00 0.00 L 3.00 10.00 L 0.00 13.00 L 0.00 19.00 L 2.00 23.00 L 9.00 28.00 L 13.00 28.00 L 16.00 30.00 L 20.00 31.00 L 41.00 52.00 L 45.00 52.00 L 44.00 39.00 L 36.00 23.00 L 23.00 10.00 L 23.00 7.00 L 10.00 0.00 Z",
      "province": "REGION_183",
      "rootTerritory": "REGION_183",
      "viewBox": "0 0 45 52",
      "unitSlots": [
        {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 24,
          "y": 16,
          "territory": "REGION_183",
          "arrowReceiver": {
            "x": 24,
            "y": 46
          }
        },
        "nc": {
          "name": "nc",
          "x": 31.47,
          "y": 45.02,
          "territory": "REGION_183_NORTH_COAST",
          "arrowReceiver": {
            "x": 31.47,
            "y": 75.02
          }
        },
        "sc": {
          "name": "sc",
          "x": 14.72,
          "y": 43.65,
          "territory": "REGION_183_SOUTH_COAST",
          "arrowReceiver": {
            "x": 14.72,
            "y": 73.65
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_20_a_b_NORTH_COAST": {
    "territory": "REGION_20_a_b_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M026_b",
    "provinceMapData": {
      "abbr": "CPZ",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 36,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 59,
      "height": 78,
      "x": 341,
      "y": 853,
      "playable": true,
      "path": "M 28.00 0.00 L 27.00 2.00 L 21.00 5.00 L 12.00 6.00 L 10.00 8.00 L 8.00 19.00 L 4.00 31.00 L 4.00 38.00 L 1.00 43.00 L 0.00 56.00 L 20.00 76.00 L 38.00 78.00 L 39.00 59.00 L 58.00 47.00 L 59.00 37.00 L 45.00 16.00 L 48.00 7.00 L 48.00 3.00 L 45.00 0.00 Z",
      "province": "M026_b",
      "rootTerritory": "M026_b",
      "viewBox": "0 0 59 78",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        "nc": {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        "sc": {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "恰帕斯 (North Coast)": {
    "territory": "REGION_20_a_b_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M026_b",
    "provinceMapData": {
      "abbr": "CPZ",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 36,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 59,
      "height": 78,
      "x": 341,
      "y": 853,
      "playable": true,
      "path": "M 28.00 0.00 L 27.00 2.00 L 21.00 5.00 L 12.00 6.00 L 10.00 8.00 L 8.00 19.00 L 4.00 31.00 L 4.00 38.00 L 1.00 43.00 L 0.00 56.00 L 20.00 76.00 L 38.00 78.00 L 39.00 59.00 L 58.00 47.00 L 59.00 37.00 L 45.00 16.00 L 48.00 7.00 L 48.00 3.00 L 45.00 0.00 Z",
      "province": "M026_b",
      "rootTerritory": "M026_b",
      "viewBox": "0 0 59 78",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        "nc": {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        "sc": {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_20_a_b_SOUTH_COAST": {
    "territory": "REGION_20_a_b_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M026_b",
    "provinceMapData": {
      "abbr": "CPZ",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 36,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 59,
      "height": 78,
      "x": 341,
      "y": 853,
      "playable": true,
      "path": "M 28.00 0.00 L 27.00 2.00 L 21.00 5.00 L 12.00 6.00 L 10.00 8.00 L 8.00 19.00 L 4.00 31.00 L 4.00 38.00 L 1.00 43.00 L 0.00 56.00 L 20.00 76.00 L 38.00 78.00 L 39.00 59.00 L 58.00 47.00 L 59.00 37.00 L 45.00 16.00 L 48.00 7.00 L 48.00 3.00 L 45.00 0.00 Z",
      "province": "M026_b",
      "rootTerritory": "M026_b",
      "viewBox": "0 0 59 78",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        "nc": {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        "sc": {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "恰帕斯 (South Coast)": {
    "territory": "REGION_20_a_b_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M026_b",
    "provinceMapData": {
      "abbr": "CPZ",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 28,
          "y": 36,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 59,
      "height": 78,
      "x": 341,
      "y": 853,
      "playable": true,
      "path": "M 28.00 0.00 L 27.00 2.00 L 21.00 5.00 L 12.00 6.00 L 10.00 8.00 L 8.00 19.00 L 4.00 31.00 L 4.00 38.00 L 1.00 43.00 L 0.00 56.00 L 20.00 76.00 L 38.00 78.00 L 39.00 59.00 L 58.00 47.00 L 59.00 37.00 L 45.00 16.00 L 48.00 7.00 L 48.00 3.00 L 45.00 0.00 Z",
      "province": "M026_b",
      "rootTerritory": "M026_b",
      "viewBox": "0 0 59 78",
      "unitSlots": [
        {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 29,
          "y": 42,
          "territory": "M026_b",
          "arrowReceiver": {
            "x": 29,
            "y": 72
          }
        },
        "nc": {
          "name": "nc",
          "x": 37.21,
          "y": 17.33,
          "territory": "REGION_20_a_b_NORTH_COAST",
          "arrowReceiver": {
            "x": 37.21,
            "y": 47.33
          }
        },
        "sc": {
          "name": "sc",
          "x": 32.32,
          "y": 68.96,
          "territory": "REGION_20_a_b_SOUTH_COAST",
          "arrowReceiver": {
            "x": 32.32,
            "y": 98.96
          }
        }
      },
      "texture": {
        "texture": "#BED3B0",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M020_NORTH_COAST": {
    "territory": "M020_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M020",
    "provinceMapData": {
      "abbr": "WDM",
      "type": "Coast",
      "centerPos": {
        "x": 30,
        "y": 39
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 93,
      "x": 374,
      "y": 859,
      "playable": true,
      "path": "M 79.00 0.00 L 61.00 0.00 L 52.00 10.00 L 39.00 10.00 L 33.00 7.00 L 28.00 1.00 L 13.00 0.00 L 11.00 12.00 L 25.00 34.00 L 24.00 39.00 L 22.00 41.00 L 5.00 51.00 L 4.00 70.00 L 0.00 71.00 L 0.00 77.00 L 12.00 89.00 L 19.00 90.00 L 24.00 93.00 L 30.00 93.00 L 30.00 88.00 L 31.00 87.00 L 35.00 87.00 L 37.00 84.00 L 49.00 82.00 L 49.00 70.00 L 51.00 68.00 L 51.00 60.00 L 53.00 56.00 L 56.00 53.00 L 63.00 51.00 L 66.00 46.00 L 70.00 46.00 L 71.00 39.00 L 77.00 34.00 L 78.00 21.00 L 81.00 16.00 L 81.00 2.00 Z",
      "province": "M020",
      "rootTerritory": "M020",
      "viewBox": "0 0 81 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        "nc": {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        "sc": {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "危地马拉 (North Coast)": {
    "territory": "M020_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M020",
    "provinceMapData": {
      "abbr": "WDM",
      "type": "Coast",
      "centerPos": {
        "x": 30,
        "y": 39
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 93,
      "x": 374,
      "y": 859,
      "playable": true,
      "path": "M 79.00 0.00 L 61.00 0.00 L 52.00 10.00 L 39.00 10.00 L 33.00 7.00 L 28.00 1.00 L 13.00 0.00 L 11.00 12.00 L 25.00 34.00 L 24.00 39.00 L 22.00 41.00 L 5.00 51.00 L 4.00 70.00 L 0.00 71.00 L 0.00 77.00 L 12.00 89.00 L 19.00 90.00 L 24.00 93.00 L 30.00 93.00 L 30.00 88.00 L 31.00 87.00 L 35.00 87.00 L 37.00 84.00 L 49.00 82.00 L 49.00 70.00 L 51.00 68.00 L 51.00 60.00 L 53.00 56.00 L 56.00 53.00 L 63.00 51.00 L 66.00 46.00 L 70.00 46.00 L 71.00 39.00 L 77.00 34.00 L 78.00 21.00 L 81.00 16.00 L 81.00 2.00 Z",
      "province": "M020",
      "rootTerritory": "M020",
      "viewBox": "0 0 81 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        "nc": {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        "sc": {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M020_SOUTH_COAST": {
    "territory": "M020_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M020",
    "provinceMapData": {
      "abbr": "WDM",
      "type": "Coast",
      "centerPos": {
        "x": 30,
        "y": 39
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 93,
      "x": 374,
      "y": 859,
      "playable": true,
      "path": "M 79.00 0.00 L 61.00 0.00 L 52.00 10.00 L 39.00 10.00 L 33.00 7.00 L 28.00 1.00 L 13.00 0.00 L 11.00 12.00 L 25.00 34.00 L 24.00 39.00 L 22.00 41.00 L 5.00 51.00 L 4.00 70.00 L 0.00 71.00 L 0.00 77.00 L 12.00 89.00 L 19.00 90.00 L 24.00 93.00 L 30.00 93.00 L 30.00 88.00 L 31.00 87.00 L 35.00 87.00 L 37.00 84.00 L 49.00 82.00 L 49.00 70.00 L 51.00 68.00 L 51.00 60.00 L 53.00 56.00 L 56.00 53.00 L 63.00 51.00 L 66.00 46.00 L 70.00 46.00 L 71.00 39.00 L 77.00 34.00 L 78.00 21.00 L 81.00 16.00 L 81.00 2.00 Z",
      "province": "M020",
      "rootTerritory": "M020",
      "viewBox": "0 0 81 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        "nc": {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        "sc": {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "危地马拉 (South Coast)": {
    "territory": "M020_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M020",
    "provinceMapData": {
      "abbr": "WDM",
      "type": "Coast",
      "centerPos": {
        "x": 30,
        "y": 39
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 47,
          "y": 32,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 81,
      "height": 93,
      "x": 374,
      "y": 859,
      "playable": true,
      "path": "M 79.00 0.00 L 61.00 0.00 L 52.00 10.00 L 39.00 10.00 L 33.00 7.00 L 28.00 1.00 L 13.00 0.00 L 11.00 12.00 L 25.00 34.00 L 24.00 39.00 L 22.00 41.00 L 5.00 51.00 L 4.00 70.00 L 0.00 71.00 L 0.00 77.00 L 12.00 89.00 L 19.00 90.00 L 24.00 93.00 L 30.00 93.00 L 30.00 88.00 L 31.00 87.00 L 35.00 87.00 L 37.00 84.00 L 49.00 82.00 L 49.00 70.00 L 51.00 68.00 L 51.00 60.00 L 53.00 56.00 L 56.00 53.00 L 63.00 51.00 L 66.00 46.00 L 70.00 46.00 L 71.00 39.00 L 77.00 34.00 L 78.00 21.00 L 81.00 16.00 L 81.00 2.00 Z",
      "province": "M020",
      "rootTerritory": "M020",
      "viewBox": "0 0 81 93",
      "unitSlots": [
        {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 39,
          "y": 10,
          "territory": "M020",
          "arrowReceiver": {
            "x": 39,
            "y": 40
          }
        },
        "nc": {
          "name": "nc",
          "x": 65.91,
          "y": 21.55,
          "territory": "M020_NORTH_COAST",
          "arrowReceiver": {
            "x": 65.91,
            "y": 51.55
          }
        },
        "sc": {
          "name": "sc",
          "x": 21.49,
          "y": 72.54,
          "territory": "M020_SOUTH_COAST",
          "arrowReceiver": {
            "x": 21.49,
            "y": 102.54
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_187_NORTH_COAST": {
    "territory": "REGION_187_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M018",
    "provinceMapData": {
      "abbr": "CLI",
      "type": "Coast",
      "centerPos": {
        "x": 32,
        "y": 69
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 62,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 143,
      "x": 583,
      "y": 1034,
      "playable": true,
      "path": "M 46.00 0.00 L 19.00 2.00 L 17.00 5.00 L 19.00 34.00 L 28.00 42.00 L 26.00 67.00 L 25.00 68.00 L 25.00 84.00 L 0.00 109.00 L 0.00 129.00 L 24.00 143.00 L 38.00 143.00 L 43.00 138.00 L 44.00 118.00 L 40.00 113.00 L 46.00 104.00 L 59.00 98.00 L 61.00 89.00 L 74.00 66.00 L 74.00 54.00 L 69.00 51.00 L 65.00 25.00 L 55.00 16.00 L 53.00 3.00 Z",
      "province": "M018",
      "rootTerritory": "M018",
      "viewBox": "0 0 74 143",
      "unitSlots": [
        {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        "nc": {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        "sc": {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡利 (North Coast)": {
    "territory": "REGION_187_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M018",
    "provinceMapData": {
      "abbr": "CLI",
      "type": "Coast",
      "centerPos": {
        "x": 32,
        "y": 69
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 62,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 143,
      "x": 583,
      "y": 1034,
      "playable": true,
      "path": "M 46.00 0.00 L 19.00 2.00 L 17.00 5.00 L 19.00 34.00 L 28.00 42.00 L 26.00 67.00 L 25.00 68.00 L 25.00 84.00 L 0.00 109.00 L 0.00 129.00 L 24.00 143.00 L 38.00 143.00 L 43.00 138.00 L 44.00 118.00 L 40.00 113.00 L 46.00 104.00 L 59.00 98.00 L 61.00 89.00 L 74.00 66.00 L 74.00 54.00 L 69.00 51.00 L 65.00 25.00 L 55.00 16.00 L 53.00 3.00 Z",
      "province": "M018",
      "rootTerritory": "M018",
      "viewBox": "0 0 74 143",
      "unitSlots": [
        {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        "nc": {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        "sc": {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "REGION_187_SOUTH_COAST": {
    "territory": "REGION_187_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M018",
    "provinceMapData": {
      "abbr": "CLI",
      "type": "Coast",
      "centerPos": {
        "x": 32,
        "y": 69
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 62,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 143,
      "x": 583,
      "y": 1034,
      "playable": true,
      "path": "M 46.00 0.00 L 19.00 2.00 L 17.00 5.00 L 19.00 34.00 L 28.00 42.00 L 26.00 67.00 L 25.00 68.00 L 25.00 84.00 L 0.00 109.00 L 0.00 129.00 L 24.00 143.00 L 38.00 143.00 L 43.00 138.00 L 44.00 118.00 L 40.00 113.00 L 46.00 104.00 L 59.00 98.00 L 61.00 89.00 L 74.00 66.00 L 74.00 54.00 L 69.00 51.00 L 65.00 25.00 L 55.00 16.00 L 53.00 3.00 Z",
      "province": "M018",
      "rootTerritory": "M018",
      "viewBox": "0 0 74 143",
      "unitSlots": [
        {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        "nc": {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        "sc": {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡利 (South Coast)": {
    "territory": "REGION_187_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M018",
    "provinceMapData": {
      "abbr": "CLI",
      "type": "Coast",
      "centerPos": {
        "x": 32,
        "y": 69
      },
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 49,
          "y": 62,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 74,
      "height": 143,
      "x": 583,
      "y": 1034,
      "playable": true,
      "path": "M 46.00 0.00 L 19.00 2.00 L 17.00 5.00 L 19.00 34.00 L 28.00 42.00 L 26.00 67.00 L 25.00 68.00 L 25.00 84.00 L 0.00 109.00 L 0.00 129.00 L 24.00 143.00 L 38.00 143.00 L 43.00 138.00 L 44.00 118.00 L 40.00 113.00 L 46.00 104.00 L 59.00 98.00 L 61.00 89.00 L 74.00 66.00 L 74.00 54.00 L 69.00 51.00 L 65.00 25.00 L 55.00 16.00 L 53.00 3.00 Z",
      "province": "M018",
      "rootTerritory": "M018",
      "viewBox": "0 0 74 143",
      "unitSlots": [
        {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 45,
          "y": 54,
          "territory": "M018",
          "arrowReceiver": {
            "x": 45,
            "y": 84
          }
        },
        "nc": {
          "name": "nc",
          "x": 39.43,
          "y": 18.99,
          "territory": "REGION_187_NORTH_COAST",
          "arrowReceiver": {
            "x": 39.43,
            "y": 48.99
          }
        },
        "sc": {
          "name": "sc",
          "x": 11.05,
          "y": 113.88,
          "territory": "REGION_187_SOUTH_COAST",
          "arrowReceiver": {
            "x": 11.05,
            "y": 143.88
          }
        }
      },
      "texture": {
        "texture": "#E9D99E",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M012_NORTH_COAST": {
    "territory": "M012_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M012",
    "provinceMapData": {
      "abbr": "HDS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 103,
      "height": 65,
      "x": 424,
      "y": 902,
      "playable": true,
      "path": "M 103.00 16.00 L 93.00 4.00 L 85.00 0.00 L 14.00 2.00 L 11.00 7.00 L 6.00 8.00 L 2.00 11.00 L 0.00 15.00 L 0.00 29.00 L 18.00 40.00 L 21.00 43.00 L 16.00 52.00 L 16.00 61.00 L 20.00 65.00 L 36.00 65.00 L 43.00 58.00 L 43.00 56.00 L 49.00 51.00 L 53.00 45.00 L 67.00 44.00 L 77.00 32.00 L 87.00 34.00 L 100.00 33.00 L 102.00 31.00 Z",
      "province": "M012",
      "rootTerritory": "M012",
      "viewBox": "0 0 103 65",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        "nc": {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        "sc": {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "洪都拉斯 (North Coast)": {
    "territory": "M012_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M012",
    "provinceMapData": {
      "abbr": "HDS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 103,
      "height": 65,
      "x": 424,
      "y": 902,
      "playable": true,
      "path": "M 103.00 16.00 L 93.00 4.00 L 85.00 0.00 L 14.00 2.00 L 11.00 7.00 L 6.00 8.00 L 2.00 11.00 L 0.00 15.00 L 0.00 29.00 L 18.00 40.00 L 21.00 43.00 L 16.00 52.00 L 16.00 61.00 L 20.00 65.00 L 36.00 65.00 L 43.00 58.00 L 43.00 56.00 L 49.00 51.00 L 53.00 45.00 L 67.00 44.00 L 77.00 32.00 L 87.00 34.00 L 100.00 33.00 L 102.00 31.00 Z",
      "province": "M012",
      "rootTerritory": "M012",
      "viewBox": "0 0 103 65",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        "nc": {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        "sc": {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M012_SOUTH_COAST": {
    "territory": "M012_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M012",
    "provinceMapData": {
      "abbr": "HDS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 103,
      "height": 65,
      "x": 424,
      "y": 902,
      "playable": true,
      "path": "M 103.00 16.00 L 93.00 4.00 L 85.00 0.00 L 14.00 2.00 L 11.00 7.00 L 6.00 8.00 L 2.00 11.00 L 0.00 15.00 L 0.00 29.00 L 18.00 40.00 L 21.00 43.00 L 16.00 52.00 L 16.00 61.00 L 20.00 65.00 L 36.00 65.00 L 43.00 58.00 L 43.00 56.00 L 49.00 51.00 L 53.00 45.00 L 67.00 44.00 L 77.00 32.00 L 87.00 34.00 L 100.00 33.00 L 102.00 31.00 Z",
      "province": "M012",
      "rootTerritory": "M012",
      "viewBox": "0 0 103 65",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        "nc": {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        "sc": {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "洪都拉斯 (South Coast)": {
    "territory": "M012_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M012",
    "provinceMapData": {
      "abbr": "HDS",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 38,
          "y": 25,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 103,
      "height": 65,
      "x": 424,
      "y": 902,
      "playable": true,
      "path": "M 103.00 16.00 L 93.00 4.00 L 85.00 0.00 L 14.00 2.00 L 11.00 7.00 L 6.00 8.00 L 2.00 11.00 L 0.00 15.00 L 0.00 29.00 L 18.00 40.00 L 21.00 43.00 L 16.00 52.00 L 16.00 61.00 L 20.00 65.00 L 36.00 65.00 L 43.00 58.00 L 43.00 56.00 L 49.00 51.00 L 53.00 45.00 L 67.00 44.00 L 77.00 32.00 L 87.00 34.00 L 100.00 33.00 L 102.00 31.00 Z",
      "province": "M012",
      "rootTerritory": "M012",
      "viewBox": "0 0 103 65",
      "unitSlots": [
        {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 48,
          "y": 17,
          "territory": "M012",
          "arrowReceiver": {
            "x": 48,
            "y": 47
          }
        },
        "nc": {
          "name": "nc",
          "x": 87.82,
          "y": 23.72,
          "territory": "M012_NORTH_COAST",
          "arrowReceiver": {
            "x": 87.82,
            "y": 53.72
          }
        },
        "sc": {
          "name": "sc",
          "x": 30.98,
          "y": 49.49,
          "territory": "M012_SOUTH_COAST",
          "arrowReceiver": {
            "x": 30.98,
            "y": 79.49
          }
        }
      },
      "texture": {
        "texture": "#C9C3B5",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M030_NORTH_COAST": {
    "territory": "M030_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M030",
    "provinceMapData": {
      "abbr": "KMG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 47,
      "height": 29,
      "x": 591,
      "y": 804,
      "playable": true,
      "path": "M 0.00 1.00 L 2.00 15.00 L 18.00 20.00 L 24.00 23.00 L 27.00 23.00 L 30.00 25.00 L 33.00 25.00 L 34.00 26.00 L 42.00 28.00 L 43.00 29.00 L 47.00 28.00 L 47.00 18.00 L 36.00 17.00 L 35.00 15.00 L 31.00 12.00 L 28.00 12.00 L 23.00 9.00 L 17.00 9.00 L 16.00 8.00 L 14.00 8.00 L 12.00 7.00 L 6.00 0.00 Z",
      "province": "M030",
      "rootTerritory": "M030",
      "viewBox": "0 0 47 29",
      "unitSlots": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        "nc": {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        "sc": {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡马圭 (North Coast)": {
    "territory": "M030_NORTH_COAST",
    "unitSlotName": "nc",
    "province": "M030",
    "provinceMapData": {
      "abbr": "KMG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 47,
      "height": 29,
      "x": 591,
      "y": 804,
      "playable": true,
      "path": "M 0.00 1.00 L 2.00 15.00 L 18.00 20.00 L 24.00 23.00 L 27.00 23.00 L 30.00 25.00 L 33.00 25.00 L 34.00 26.00 L 42.00 28.00 L 43.00 29.00 L 47.00 28.00 L 47.00 18.00 L 36.00 17.00 L 35.00 15.00 L 31.00 12.00 L 28.00 12.00 L 23.00 9.00 L 17.00 9.00 L 16.00 8.00 L 14.00 8.00 L 12.00 7.00 L 6.00 0.00 Z",
      "province": "M030",
      "rootTerritory": "M030",
      "viewBox": "0 0 47 29",
      "unitSlots": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        "nc": {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        "sc": {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "M030_SOUTH_COAST": {
    "territory": "M030_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M030",
    "provinceMapData": {
      "abbr": "KMG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 47,
      "height": 29,
      "x": 591,
      "y": 804,
      "playable": true,
      "path": "M 0.00 1.00 L 2.00 15.00 L 18.00 20.00 L 24.00 23.00 L 27.00 23.00 L 30.00 25.00 L 33.00 25.00 L 34.00 26.00 L 42.00 28.00 L 43.00 29.00 L 47.00 28.00 L 47.00 18.00 L 36.00 17.00 L 35.00 15.00 L 31.00 12.00 L 28.00 12.00 L 23.00 9.00 L 17.00 9.00 L 16.00 8.00 L 14.00 8.00 L 12.00 7.00 L 6.00 0.00 Z",
      "province": "M030",
      "rootTerritory": "M030",
      "viewBox": "0 0 47 29",
      "unitSlots": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        "nc": {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        "sc": {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  },
  "卡马圭 (South Coast)": {
    "territory": "M030_SOUTH_COAST",
    "unitSlotName": "sc",
    "province": "M030",
    "provinceMapData": {
      "abbr": "KMG",
      "type": "Coast",
      "fill": "none",
      "labels": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "style": {
            "fontSize": 10,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "text": "nc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "text": "sc",
          "style": {
            "fontSize": 8,
            "textAnchor": "middle",
            "dominantBaseline": "central"
          }
        }
      ],
      "width": 47,
      "height": 29,
      "x": 591,
      "y": 804,
      "playable": true,
      "path": "M 0.00 1.00 L 2.00 15.00 L 18.00 20.00 L 24.00 23.00 L 27.00 23.00 L 30.00 25.00 L 33.00 25.00 L 34.00 26.00 L 42.00 28.00 L 43.00 29.00 L 47.00 28.00 L 47.00 18.00 L 36.00 17.00 L 35.00 15.00 L 31.00 12.00 L 28.00 12.00 L 23.00 9.00 L 17.00 9.00 L 16.00 8.00 L 14.00 8.00 L 12.00 7.00 L 6.00 0.00 Z",
      "province": "M030",
      "rootTerritory": "M030",
      "viewBox": "0 0 47 29",
      "unitSlots": [
        {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      ],
      "unitSlotsBySlotName": {
        "main": {
          "name": "main",
          "x": 17,
          "y": 13,
          "territory": "M030",
          "arrowReceiver": {
            "x": 17,
            "y": 43
          }
        },
        "nc": {
          "name": "nc",
          "x": 41,
          "y": 10.06,
          "territory": "M030_NORTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 40.06
          }
        },
        "sc": {
          "name": "sc",
          "x": 41,
          "y": 23,
          "territory": "M030_SOUTH_COAST",
          "arrowReceiver": {
            "x": 41,
            "y": 53
          }
        }
      },
      "texture": {
        "texture": "#E19EAA",
        "strokeOpacity": 0.5,
        "strokeWidth": 7
      }
    }
  }
} as unknown as MapVariant["territoryMap"];

const webdipNameToTerritory: MapVariant["webdipNameToTerritory"] = {
  "魁北克": "REGION_1",
  "纽芬兰": "REGION_2",
  "蒙特利尔": "REGION_3",
  "哈利法克斯": "REGION_4",
  "圣萨尔瓦多": "REGION_8",
  "马托格罗索": "REGION_10",
  "圣保罗": "REGION_12",
  "南里奥格兰德": "REGION_13",
  "北冰洋": "REGION_15",
  "索诺拉": "REGION_16",
  "奇瓦瓦": "REGION_17",
  "中大西洋": "REGION_18",
  "瓜达拉哈拉": "REGION_19",
  "米却背": "REGION_21",
  "瓦哈卡": "REGION_22",
  "南大西洋": "REGION_23",
  "图库曼": "REGION_24",
  "南查科": "REGION_25",
  "拉里奥哈": "REGION_26",
  "科连特斯": "REGION_27",
  "卡塔马卡": "REGION_28",
  "科尔多瓦": "REGION_29",
  "布宜诺斯艾利斯": "REGION_30",
  "马萨诸塞湾": "REGION_40",
  "墨西哥湾流": "REGION_42",
  "安的列斯洋流": "REGION_44",
  "阿帕拉齐湾": "REGION_47",
  "墨西哥湾": "REGION_48",
  "波多黎各": "REGION_51",
  "阿内加达海峡": "REGION_52",
  "尤卡坦海峡": "REGION_53",
  "西加勒比海": "REGION_55",
  "特立尼达海域": "REGION_59",
  "委内瑞拉湾": "REGION_61",
  "南太平洋": "REGION_68",
  "瓜亚基尔湾": "REGION_69",
  "梅希约内斯湾": "REGION_70",
  "洪堡洋流": "REGION_71",
  "拉普拉塔河": "REGION_72",
  "布兰卡湾": "REGION_75",
  "德雷克海峡": "REGION_77",
  "白令海": "REGION_80",
  "波弗特海": "REGION_81",
  "北大西洋": "REGION_82",
  "拉布拉多海": "REGION_83",
  "阿拉斯加湾": "REGION_84",
  "北太平洋": "REGION_85",
  "圣劳伦斯湾": "REGION_86",
  "百慕大三角": "REGION_88",
  "阿卡普尔科湾": "REGION_90",
  "坎佩切湾": "REGION_91",
  "牙买加": "REGION_92",
  "洪都拉斯湾": "REGION_93",
  "特万特佩克湾": "REGION_95",
  "特立尼达": "REGION_98",
  "马拉若湾": "REGION_99",
  "万圣湾": "REGION_100",
  "帕拉卡斯湾": "REGION_101",
  "瓜纳巴拉湾": "REGION_102",
  "巴拉那瓜湾": "REGION_103",
  "新英格兰": "REGION_104",
  "纽约": "REGION_106",
  "华盛顿特区": "REGION_107",
  "弗吉尼亚": "REGION_109",
  "查尔斯顿": "REGION_111",
  "佛罗里达": "REGION_113",
  "鲁珀特地": "REGION_120",
  "哥伦比亚省": "REGION_122",
  "安大略": "REGION_123",
  "俄勒冈乡域": "REGION_124",
  "达科他": "REGION_125",
  "爱荷华领地": "REGION_126",
  "多伦多": "REGION_127",
  "上加利福尼亚": "REGION_129",
  "大盆地沙漠": "REGION_130",
  "密歇根": "REGION_131",
  "密苏里": "REGION_132",
  "阿帕奇里亚": "REGION_134",
  "德克萨斯": "REGION_135",
  "尤卡坦": "REGION_139",
  "圣多明各": "REGION_140",
  "尼加拉瓜": "REGION_144",
  "乔治敦": "REGION_145",
  "苏里南": "REGION_147",
  "卡宴": "REGION_148",
  "厄瓜多尔": "REGION_151",
  "阿克里": "REGION_154",
  "贝尼": "REGION_155",
  "圣克鲁斯": "REGION_156",
  "拉巴斯": "REGION_157",
  "波多西": "REGION_158",
  "北查科": "REGION_159",
  "安托法加斯塔": "REGION_160",
  "亚松森": "REGION_161",
  "乌拉圭": "REGION_162",
  "门多萨": "REGION_163",
  "潘帕斯": "REGION_164",
  "洛雷托": "REGION_169",
  "卡哈马卡": "REGION_170",
  "利马": "REGION_171",
  "库斯科": "REGION_172",
  "阿塔卡马": "REGION_174",
  "哥斯达黎加": "REGION_183",
  "圣玛尔塔": "REGION_184",
  "卡塔赫纳": "REGION_185",
  "波哥大": "REGION_188",
  "卡克塔": "REGION_190",
  "库马纳": "REGION_192",
  "加拉加斯": "REGION_193",
  "安戈斯图拉": "REGION_195",
  "西北领地": "M001",
  "格陵兰": "M002",
  "巴哈马": "M003",
  "海地": "M004",
  "西印度群岛": "M005",
  "佛罗里达海峡": "REGION_50_a",
  "巴哈马海峡": "REGION_49_a",
  "古巴圣地亚哥": "M006",
  "哈瓦那": "M007",
  "奇里基湾": "REGION_62_a",
  "阿尔米兰特湾": "REGION_62_b_a",
  "巴拿马湾": "REGION_65_a",
  "乌拉巴湾": "REGION_97_a",
  "巴拿马": "M008",
  "福克兰洋流": "REGION_76_a",
  "巴塔哥尼亚": "REGION_167_a",
  "塔尔卡瓦诺": "REGION_175_b",
  "瓦尔帕莱索": "REGION_175_a_a",
  "圣地亚哥": "REGION_175_a_b",
  "阿雷基帕": "REGION_173_a",
  "塔拉帕卡": "REGION_173_b",
  "丰塞卡湾": "REGION_60_a",
  "亚马逊": "M013",
  "马瑙斯": "M014",
  "帕拉": "M016",
  "马尔维纳斯": "M015",
  "中太平洋": "REGION_64_a_a",
  "加拉帕戈斯": "REGION_64_a_b",
  "圣卡塔利娜湾": "REGION_43_a",
  "阿拉斯加": "M019",
  "危地马拉": "M020",
  "复活节岛": "M009",
  "火地岛": "M010_a",
  "麦哲伦": "M010",
  "哈德逊湾": "M023",
  "东五大湖": "M024_a",
  "伊利运河": "M024",
  "科尔特斯海": "M017_a",
  "下加利福尼亚": "M017",
  "卡利": "M018",
  "芝加哥": "M025",
  "西五大湖": "M022",
  "凯阿拉凯夸湾": "M021_a",
  "夏威夷": "M021_b",
  "田纳西河谷": "REGION_110_a",
  "新奥尔良": "M021",
  "萨尔瓦多": "M012_a",
  "洪都拉斯": "M012",
  "墨西哥城": "REGION_20_a_a_a",
  "韦拉克鲁斯": "M026_a",
  "恰帕斯": "M026_b",
  "东加勒比海": "M026",
  "马尾藻海": "M027",
  "巴基西梅托": "REGION_194_a",
  "马拉开波": "REGION_191_a",
  "奥里诺科": "M028",
  "贝洛奥里藏特": "REGION_9_a",
  "里约热内卢": "M029",
  "北加勒比海": "REGION_49_b_a_a",
  "卡马圭": "M030",
  "科尔科瓦多湾": "REGION_73_a_a",
  "艾森": "M031",
  "华盛顿特区 (North Coast)": "REGION_107_NORTH_COAST",
  "华盛顿特区 (South Coast)": "REGION_107_SOUTH_COAST",
  "安大略 (North Coast)": "REGION_123_NORTH_COAST",
  "安大略 (South Coast)": "REGION_123_SOUTH_COAST",
  "尼加拉瓜 (North Coast)": "REGION_144_NORTH_COAST",
  "尼加拉瓜 (South Coast)": "REGION_144_SOUTH_COAST",
  "哥斯达黎加 (North Coast)": "REGION_183_NORTH_COAST",
  "哥斯达黎加 (South Coast)": "REGION_183_SOUTH_COAST",
  "恰帕斯 (North Coast)": "REGION_20_a_b_NORTH_COAST",
  "恰帕斯 (South Coast)": "REGION_20_a_b_SOUTH_COAST",
  "危地马拉 (North Coast)": "M020_NORTH_COAST",
  "危地马拉 (South Coast)": "M020_SOUTH_COAST",
  "卡利 (North Coast)": "REGION_187_NORTH_COAST",
  "卡利 (South Coast)": "REGION_187_SOUTH_COAST",
  "洪都拉斯 (North Coast)": "M012_NORTH_COAST",
  "洪都拉斯 (South Coast)": "M012_SOUTH_COAST",
  "卡马圭 (North Coast)": "M030_NORTH_COAST",
  "卡马圭 (South Coast)": "M030_SOUTH_COAST"
};

const territoryToWebdipName: MapVariant["territoryToWebdipName"] = {
  "REGION_1": "魁北克",
  "REGION_2": "纽芬兰",
  "REGION_3": "蒙特利尔",
  "REGION_4": "哈利法克斯",
  "REGION_8": "圣萨尔瓦多",
  "REGION_10": "马托格罗索",
  "REGION_12": "圣保罗",
  "REGION_13": "南里奥格兰德",
  "REGION_15": "北冰洋",
  "REGION_16": "索诺拉",
  "REGION_17": "奇瓦瓦",
  "REGION_18": "中大西洋",
  "REGION_19": "瓜达拉哈拉",
  "REGION_21": "米却背",
  "REGION_22": "瓦哈卡",
  "REGION_23": "南大西洋",
  "REGION_24": "图库曼",
  "REGION_25": "南查科",
  "REGION_26": "拉里奥哈",
  "REGION_27": "科连特斯",
  "REGION_28": "卡塔马卡",
  "REGION_29": "科尔多瓦",
  "REGION_30": "布宜诺斯艾利斯",
  "REGION_40": "马萨诸塞湾",
  "REGION_42": "墨西哥湾流",
  "REGION_44": "安的列斯洋流",
  "REGION_47": "阿帕拉齐湾",
  "REGION_48": "墨西哥湾",
  "REGION_51": "波多黎各",
  "REGION_52": "阿内加达海峡",
  "REGION_53": "尤卡坦海峡",
  "REGION_55": "西加勒比海",
  "REGION_59": "特立尼达海域",
  "REGION_61": "委内瑞拉湾",
  "REGION_68": "南太平洋",
  "REGION_69": "瓜亚基尔湾",
  "REGION_70": "梅希约内斯湾",
  "REGION_71": "洪堡洋流",
  "REGION_72": "拉普拉塔河",
  "REGION_75": "布兰卡湾",
  "REGION_77": "德雷克海峡",
  "REGION_80": "白令海",
  "REGION_81": "波弗特海",
  "REGION_82": "北大西洋",
  "REGION_83": "拉布拉多海",
  "REGION_84": "阿拉斯加湾",
  "REGION_85": "北太平洋",
  "REGION_86": "圣劳伦斯湾",
  "REGION_88": "百慕大三角",
  "REGION_90": "阿卡普尔科湾",
  "REGION_91": "坎佩切湾",
  "REGION_92": "牙买加",
  "REGION_93": "洪都拉斯湾",
  "REGION_95": "特万特佩克湾",
  "REGION_98": "特立尼达",
  "REGION_99": "马拉若湾",
  "REGION_100": "万圣湾",
  "REGION_101": "帕拉卡斯湾",
  "REGION_102": "瓜纳巴拉湾",
  "REGION_103": "巴拉那瓜湾",
  "REGION_104": "新英格兰",
  "REGION_106": "纽约",
  "REGION_107": "华盛顿特区",
  "REGION_109": "弗吉尼亚",
  "REGION_111": "查尔斯顿",
  "REGION_113": "佛罗里达",
  "REGION_120": "鲁珀特地",
  "REGION_122": "哥伦比亚省",
  "REGION_123": "安大略",
  "REGION_124": "俄勒冈乡域",
  "REGION_125": "达科他",
  "REGION_126": "爱荷华领地",
  "REGION_127": "多伦多",
  "REGION_129": "上加利福尼亚",
  "REGION_130": "大盆地沙漠",
  "REGION_131": "密歇根",
  "REGION_132": "密苏里",
  "REGION_134": "阿帕奇里亚",
  "REGION_135": "德克萨斯",
  "REGION_139": "尤卡坦",
  "REGION_140": "圣多明各",
  "REGION_144": "尼加拉瓜",
  "REGION_145": "乔治敦",
  "REGION_147": "苏里南",
  "REGION_148": "卡宴",
  "REGION_151": "厄瓜多尔",
  "REGION_154": "阿克里",
  "REGION_155": "贝尼",
  "REGION_156": "圣克鲁斯",
  "REGION_157": "拉巴斯",
  "REGION_158": "波多西",
  "REGION_159": "北查科",
  "REGION_160": "安托法加斯塔",
  "REGION_161": "亚松森",
  "REGION_162": "乌拉圭",
  "REGION_163": "门多萨",
  "REGION_164": "潘帕斯",
  "REGION_169": "洛雷托",
  "REGION_170": "卡哈马卡",
  "REGION_171": "利马",
  "REGION_172": "库斯科",
  "REGION_174": "阿塔卡马",
  "REGION_183": "哥斯达黎加",
  "REGION_184": "圣玛尔塔",
  "REGION_185": "卡塔赫纳",
  "REGION_188": "波哥大",
  "REGION_190": "卡克塔",
  "REGION_192": "库马纳",
  "REGION_193": "加拉加斯",
  "REGION_195": "安戈斯图拉",
  "M001": "西北领地",
  "M002": "格陵兰",
  "M003": "巴哈马",
  "M004": "海地",
  "M005": "西印度群岛",
  "REGION_50_a": "佛罗里达海峡",
  "REGION_49_a": "巴哈马海峡",
  "M006": "古巴圣地亚哥",
  "M007": "哈瓦那",
  "REGION_62_a": "奇里基湾",
  "REGION_62_b_a": "阿尔米兰特湾",
  "REGION_65_a": "巴拿马湾",
  "REGION_97_a": "乌拉巴湾",
  "M008": "巴拿马",
  "REGION_76_a": "福克兰洋流",
  "REGION_167_a": "巴塔哥尼亚",
  "REGION_175_b": "塔尔卡瓦诺",
  "REGION_175_a_a": "瓦尔帕莱索",
  "REGION_175_a_b": "圣地亚哥",
  "REGION_173_a": "阿雷基帕",
  "REGION_173_b": "塔拉帕卡",
  "REGION_60_a": "丰塞卡湾",
  "M013": "亚马逊",
  "M014": "马瑙斯",
  "M016": "帕拉",
  "M015": "马尔维纳斯",
  "REGION_64_a_a": "中太平洋",
  "REGION_64_a_b": "加拉帕戈斯",
  "REGION_43_a": "圣卡塔利娜湾",
  "M019": "阿拉斯加",
  "M020": "危地马拉",
  "M009": "复活节岛",
  "M010_a": "火地岛",
  "M010": "麦哲伦",
  "M023": "哈德逊湾",
  "M024_a": "东五大湖",
  "M024": "伊利运河",
  "M017_a": "科尔特斯海",
  "M017": "下加利福尼亚",
  "M018": "卡利",
  "M025": "芝加哥",
  "M022": "西五大湖",
  "M021_a": "凯阿拉凯夸湾",
  "M021_b": "夏威夷",
  "REGION_110_a": "田纳西河谷",
  "M021": "新奥尔良",
  "M012_a": "萨尔瓦多",
  "M012": "洪都拉斯",
  "REGION_20_a_a_a": "墨西哥城",
  "M026_a": "韦拉克鲁斯",
  "M026_b": "恰帕斯",
  "M026": "东加勒比海",
  "M027": "马尾藻海",
  "REGION_194_a": "巴基西梅托",
  "REGION_191_a": "马拉开波",
  "M028": "奥里诺科",
  "REGION_9_a": "贝洛奥里藏特",
  "M029": "里约热内卢",
  "REGION_49_b_a_a": "北加勒比海",
  "M030": "卡马圭",
  "REGION_73_a_a": "科尔科瓦多湾",
  "M031": "艾森",
  "REGION_107_NORTH_COAST": "华盛顿特区 (North Coast)",
  "REGION_107_SOUTH_COAST": "华盛顿特区 (South Coast)",
  "REGION_123_NORTH_COAST": "安大略 (North Coast)",
  "REGION_123_SOUTH_COAST": "安大略 (South Coast)",
  "REGION_144_NORTH_COAST": "尼加拉瓜 (North Coast)",
  "REGION_144_SOUTH_COAST": "尼加拉瓜 (South Coast)",
  "REGION_183_NORTH_COAST": "哥斯达黎加 (North Coast)",
  "REGION_183_SOUTH_COAST": "哥斯达黎加 (South Coast)",
  "REGION_20_a_b_NORTH_COAST": "恰帕斯 (North Coast)",
  "REGION_20_a_b_SOUTH_COAST": "恰帕斯 (South Coast)",
  "M020_NORTH_COAST": "危地马拉 (North Coast)",
  "M020_SOUTH_COAST": "危地马拉 (South Coast)",
  "REGION_187_NORTH_COAST": "卡利 (North Coast)",
  "REGION_187_SOUTH_COAST": "卡利 (South Coast)",
  "M012_NORTH_COAST": "洪都拉斯 (North Coast)",
  "M012_SOUTH_COAST": "洪都拉斯 (South Coast)",
  "M030_NORTH_COAST": "卡马圭 (North Coast)",
  "M030_SOUTH_COAST": "卡马圭 (South Coast)"
};

const coastData: MapVariant["coastData"] = {
  "REGION_107_NORTH_COAST": {
    "parent": "REGION_107",
    "unitSlotName": "nc"
  },
  "REGION_107_SOUTH_COAST": {
    "parent": "REGION_107",
    "unitSlotName": "sc"
  },
  "REGION_123_NORTH_COAST": {
    "parent": "REGION_123",
    "unitSlotName": "nc"
  },
  "REGION_123_SOUTH_COAST": {
    "parent": "REGION_123",
    "unitSlotName": "sc"
  },
  "REGION_144_NORTH_COAST": {
    "parent": "REGION_144",
    "unitSlotName": "nc"
  },
  "REGION_144_SOUTH_COAST": {
    "parent": "REGION_144",
    "unitSlotName": "sc"
  },
  "REGION_183_NORTH_COAST": {
    "parent": "REGION_183",
    "unitSlotName": "nc"
  },
  "REGION_183_SOUTH_COAST": {
    "parent": "REGION_183",
    "unitSlotName": "sc"
  },
  "REGION_20_a_b_NORTH_COAST": {
    "parent": "M026_b",
    "unitSlotName": "nc"
  },
  "REGION_20_a_b_SOUTH_COAST": {
    "parent": "M026_b",
    "unitSlotName": "sc"
  },
  "M020_NORTH_COAST": {
    "parent": "M020",
    "unitSlotName": "nc"
  },
  "M020_SOUTH_COAST": {
    "parent": "M020",
    "unitSlotName": "sc"
  },
  "REGION_187_NORTH_COAST": {
    "parent": "M018",
    "unitSlotName": "nc"
  },
  "REGION_187_SOUTH_COAST": {
    "parent": "M018",
    "unitSlotName": "sc"
  },
  "M012_NORTH_COAST": {
    "parent": "M012",
    "unitSlotName": "nc"
  },
  "M012_SOUTH_COAST": {
    "parent": "M012",
    "unitSlotName": "sc"
  },
  "M030_NORTH_COAST": {
    "parent": "M030",
    "unitSlotName": "nc"
  },
  "M030_SOUTH_COAST": {
    "parent": "M030",
    "unitSlotName": "sc"
  }
};

const countryMap: MapVariant["countryMap"] = {
  "Brazil": "Brazil" as Country,
  "Argentina": "Argentina" as Country,
  "Chile": "Chile" as Country,
  "United Kingdom": "United Kingdom" as Country,
  "Mexico": "Mexico" as Country,
  "New Granada": "New Granada" as Country,
  "Peru": "Peru" as Country,
  "Spain": Country.SPAIN,
  "United States": "United States" as Country,
  "Venezuela": "Venezuela" as Country,
};

const countryIDMap: MapVariant["countryIDMap"] = {
  1: "Brazil" as Country,
  2: "Argentina" as Country,
  3: "Chile" as Country,
  4: "United Kingdom" as Country,
  5: "Mexico" as Country,
  6: "New Granada" as Country,
  7: "Peru" as Country,
  8: Country.SPAIN,
  9: "United States" as Country,
  10: "Venezuela" as Country,
};

const americas1840MapVariant: MapVariant = {
  key: "americas1840",
  name: "Americas1840",
  mapID: 25,
  variantIDs: [25],
  width: 1295,
  height: 1920,
  initialScale: 1,
  unitSize: 40,
  supplyCenterDot: true,
  flatCountryColors: true,
  provincesMapData,
  territoryMap,
  webdipNameToTerritory,
  territoryToWebdipName,
  coastData,
  countryMap,
  countryIDMap,
  textures: {
    capturableLand: {
      href: capturableLandTexture,
      width: 1546,
      height: 1384,
      patternWidth: 1546,
      patternHeight: 1384,
    },
    sea: {
      href: seaTexture,
      width: 1966,
      height: 1615,
      patternWidth: 1546,
      patternHeight: 1384,
    },
  },
  provincesToRenderLast: [],
  boardMap: WDBoardMap,
};

export default americas1840MapVariant;
